const _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"],
  _excluded2 = ["tag", "children", "className", "swiper", "zoom", "lazy", "virtualIndex", "swiperSlideIndex"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import * as e from "react";
import t, { useRef as n, useState as c, useEffect as i, useLayoutEffect as r, useCallback as a, createElement as o, useMemo as s, useImperativeHandle as l, forwardRef as f, useDebugValue as u, createContext as d } from "react";
import p from "prop-types";
import { NavLink as m } from "react-router-dom";
import { createPortal as h } from "react-dom";
import { DateRangePicker as v } from "react-dates";
function g(e) {
  var t = function (e, t) {
    if ("object" != typeof e || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (void 0 !== n) {
      var c = n.call(e, t || "default");
      if ("object" != typeof c) return c;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" == typeof t ? t : String(t);
}
function b(e, t, n) {
  return (t = g(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function H() {
  return H = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, H.apply(this, arguments);
}
function z(e, t) {
  if (null == e) return {};
  var n,
    c,
    i = function (e, t) {
      if (null == e) return {};
      var n,
        c,
        i = {},
        r = Object.keys(e);
      for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function y(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var c,
        i,
        r,
        a,
        o = [],
        s = !0,
        l = !1;
      try {
        if (r = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          s = !1;
        } else for (; !(s = (c = r.call(n)).done) && (o.push(c.value), o.length !== t); s = !0);
      } catch (e) {
        l = !0, i = e;
      } finally {
        try {
          if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
        } finally {
          if (l) throw i;
        }
      }
      return o;
    }
  }(e, t) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return V(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return V(e, t);
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function V(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, c = new Array(t); n < t; n++) c[n] = e[n];
  return c;
}
var x = {
  hero: "hero-module_hero__C-Zof",
  partialHeight: "hero-module_partialHeight__V5UEP",
  hero__container: "hero-module_hero__container__PSi1h",
  hero__content: "hero-module_hero__content__LaDO9",
  "layout-fullscreen_all_centered": "hero-module_layout-fullscreen_all_centered__-xLb-",
  "layout-fullscreen_text_top_search_bottom": "hero-module_layout-fullscreen_text_top_search_bottom__7w1OP",
  "layout-fullscreen_all_bottom": "hero-module_layout-fullscreen_all_bottom__jJ4Xo",
  "layout-partial_screen_all_bottom": "hero-module_layout-partial_screen_all_bottom__TNiXc",
  isNotHome: "hero-module_isNotHome__vsV-E",
  hero__headlineShadow: "hero-module_hero__headlineShadow__IYI0Y",
  hero__description: "hero-module_hero__description__WGlj-",
  hero__singleImageBg: "hero-module_hero__singleImageBg__-EOQR",
  hero__swiperSlide: "hero-module_hero__swiperSlide__yUNrI",
  swiperControl: "hero-module_swiperControl__K5FIB",
  prev: "hero-module_prev__8OZ8A",
  next: "hero-module_next__SBSA5",
  adjustForPartialHeight: "hero-module_adjustForPartialHeight__x82V3",
  swiperNav: "hero-module_swiperNav__NwyuH",
  swiperNav__dot: "hero-module_swiperNav__dot__uPoL5",
  active: "hero-module_active__z8ydP",
  swiperNav__scrim: "hero-module_swiperNav__scrim__-bbdw",
  adjustPhotoGallery: "hero-module_adjustPhotoGallery__Vhokr"
};
function M(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    t && (c = c.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, c);
  }
  return n;
}
function _(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? M(Object(n), !0).forEach(function (t) {
      w(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function w(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function E() {
  return E = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, E.apply(this, arguments);
}
function C(e, t) {
  if (null == e) return {};
  var n,
    c,
    i = function (e, t) {
      if (null == e) return {};
      var n,
        c,
        i = {},
        r = Object.keys(e);
      for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function L(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var c,
        i,
        r = [],
        a = !0,
        o = !1;
      try {
        for (n = n.call(e); !(a = (c = n.next()).done) && (r.push(c.value), !t || r.length !== t); a = !0);
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          a || null == n.return || n.return();
        } finally {
          if (o) throw i;
        }
      }
      return r;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return N(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? N(e, t) : void 0;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function N(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, c = new Array(t); n < t; n++) c[n] = e[n];
  return c;
}
function S(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    t && (c = c.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, c);
  }
  return n;
}
function k(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? S(Object(n), !0).forEach(function (t) {
      T(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function P(e) {
  return P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, P(e);
}
function T(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function O(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var c,
        i,
        r = [],
        a = !0,
        o = !1;
      try {
        for (n = n.call(e); !(a = (c = n.next()).done) && (r.push(c.value), !t || r.length !== t); a = !0);
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          a || null == n.return || n.return();
        } finally {
          if (o) throw i;
        }
      }
      return r;
    }
  }(e, t) || D(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function A(e) {
  return function (e) {
    if (Array.isArray(e)) return I(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || D(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function D(e, t) {
  if (e) {
    if ("string" == typeof e) return I(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? I(e, t) : void 0;
  }
}
function I(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, c = new Array(t); n < t; n++) c[n] = e[n];
  return c;
}
var j = function () {},
  F = {},
  R = {},
  B = null,
  G = {
    mark: j,
    measure: j
  };
try {
  "undefined" != typeof window && (F = window), "undefined" != typeof document && (R = document), "undefined" != typeof MutationObserver && (B = MutationObserver), "undefined" != typeof performance && (G = performance);
} catch (Vn) {}
var Y = (F.navigator || {}).userAgent,
  W = void 0 === Y ? "" : Y,
  q = F,
  U = R,
  $ = B,
  X = G;
q.document;
var Z,
  K,
  Q,
  J,
  ee,
  te = !!U.documentElement && !!U.head && "function" == typeof U.addEventListener && "function" == typeof U.createElement,
  ne = ~W.indexOf("MSIE") || ~W.indexOf("Trident/"),
  ce = ["HTML", "HEAD", "STYLE", "SCRIPT"],
  ie = function () {
    try {
      return "production" === process.env.NODE_ENV;
    } catch (e) {
      return !1;
    }
  }(),
  re = ["classic", "sharp"];
function ae(e) {
  return new Proxy(e, {
    get: function (e, t) {
      return t in e ? e[t] : e.classic;
    }
  });
}
var oe = ae((T(Z = {}, "classic", {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fad: "duotone",
    "fa-duotone": "duotone",
    fab: "brands",
    "fa-brands": "brands",
    fak: "kit",
    "fa-kit": "kit"
  }), T(Z, "sharp", {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light"
  }), Z)),
  se = ae((T(K = {}, "classic", {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
  }), T(K, "sharp", {
    solid: "fass",
    regular: "fasr",
    light: "fasl"
  }), K)),
  le = ae((T(Q = {}, "classic", {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  }), T(Q, "sharp", {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light"
  }), Q)),
  fe = ae((T(J = {}, "classic", {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  }), T(J, "sharp", {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl"
  }), J)),
  ue = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/,
  de = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i,
  pe = ae((T(ee = {}, "classic", {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  }), T(ee, "sharp", {
    900: "fass",
    400: "fasr",
    300: "fasl"
  }), ee)),
  me = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  he = me.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
  ve = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"],
  ge = "duotone-group",
  be = "primary",
  He = "secondary",
  ze = new Set();
Object.keys(se.classic).map(ze.add.bind(ze)), Object.keys(se.sharp).map(ze.add.bind(ze));
var ye = [].concat(re, A(ze), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", ge, "swap-opacity", be, He]).concat(me.map(function (e) {
    return "".concat(e, "x");
  })).concat(he.map(function (e) {
    return "w-".concat(e);
  })),
  Ve = q.FontAwesomeConfig || {};
U && "function" == typeof U.querySelector && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (e) {
  var t = O(e, 2),
    n = t[0],
    c = t[1],
    i = function (e) {
      return "" === e || "false" !== e && ("true" === e || e);
    }(function (e) {
      var t = U.querySelector("script[" + e + "]");
      if (t) return t.getAttribute(e);
    }(n));
  null != i && (Ve[c] = i);
});
var xe = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: "fa",
  replacementClass: "svg-inline--fa",
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Ve.familyPrefix && (Ve.cssPrefix = Ve.familyPrefix);
var Me = k(k({}, xe), Ve);
Me.autoReplaceSvg || (Me.observeMutations = !1);
var _e = {};
Object.keys(xe).forEach(function (e) {
  Object.defineProperty(_e, e, {
    enumerable: !0,
    set: function (t) {
      Me[e] = t, we.forEach(function (e) {
        return e(_e);
      });
    },
    get: function () {
      return Me[e];
    }
  });
}), Object.defineProperty(_e, "familyPrefix", {
  enumerable: !0,
  set: function (e) {
    Me.cssPrefix = e, we.forEach(function (e) {
      return e(_e);
    });
  },
  get: function () {
    return Me.cssPrefix;
  }
}), q.FontAwesomeConfig = _e;
var we = [],
  Ee = 16,
  Ce = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: !1,
    flipY: !1
  };
function Le() {
  for (var e = 12, t = ""; e-- > 0;) t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
  return t;
}
function Ne(e) {
  for (var t = [], n = (e || []).length >>> 0; n--;) t[n] = e[n];
  return t;
}
function Se(e) {
  return e.classList ? Ne(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function (e) {
    return e;
  });
}
function ke(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Pe(e) {
  return Object.keys(e || {}).reduce(function (t, n) {
    return t + "".concat(n, ": ").concat(e[n].trim(), ";");
  }, "");
}
function Te(e) {
  return e.size !== Ce.size || e.x !== Ce.x || e.y !== Ce.y || e.rotate !== Ce.rotate || e.flipX || e.flipY;
}
function Oe() {
  var e = "fa",
    t = "svg-inline--fa",
    n = _e.cssPrefix,
    c = _e.replacementClass,
    i = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
  if (n !== e || c !== t) {
    var r = new RegExp("\\.".concat(e, "\\-"), "g"),
      a = new RegExp("\\--".concat(e, "\\-"), "g"),
      o = new RegExp("\\.".concat(t), "g");
    i = i.replace(r, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(o, ".".concat(c));
  }
  return i;
}
var Ae = !1;
function De() {
  _e.autoAddCss && !Ae && (function (e) {
    if (e && te) {
      var t = U.createElement("style");
      t.setAttribute("type", "text/css"), t.innerHTML = e;
      for (var n = U.head.childNodes, c = null, i = n.length - 1; i > -1; i--) {
        var r = n[i],
          a = (r.tagName || "").toUpperCase();
        ["STYLE", "LINK"].indexOf(a) > -1 && (c = r);
      }
      U.head.insertBefore(t, c);
    }
  }(Oe()), Ae = !0);
}
var Ie = {
    mixout: function () {
      return {
        dom: {
          css: Oe,
          insertCss: De
        }
      };
    },
    hooks: function () {
      return {
        beforeDOMElementCreation: function () {
          De();
        },
        beforeI2svg: function () {
          De();
        }
      };
    }
  },
  je = q || {};
je.___FONT_AWESOME___ || (je.___FONT_AWESOME___ = {}), je.___FONT_AWESOME___.styles || (je.___FONT_AWESOME___.styles = {}), je.___FONT_AWESOME___.hooks || (je.___FONT_AWESOME___.hooks = {}), je.___FONT_AWESOME___.shims || (je.___FONT_AWESOME___.shims = []);
var Fe = je.___FONT_AWESOME___,
  Re = [],
  Be = !1;
function Ge(e) {
  var t = e.tag,
    n = e.attributes,
    c = void 0 === n ? {} : n,
    i = e.children,
    r = void 0 === i ? [] : i;
  return "string" == typeof e ? ke(e) : "<".concat(t, " ").concat(function (e) {
    return Object.keys(e || {}).reduce(function (t, n) {
      return t + "".concat(n, '="').concat(ke(e[n]), '" ');
    }, "").trim();
  }(c), ">").concat(r.map(Ge).join(""), "</").concat(t, ">");
}
function Ye(e, t, n) {
  if (e && e[t] && e[t][n]) return {
    prefix: t,
    iconName: n,
    icon: e[t][n]
  };
}
te && ((Be = (U.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(U.readyState)) || U.addEventListener("DOMContentLoaded", function e() {
  U.removeEventListener("DOMContentLoaded", e), Be = 1, Re.map(function (e) {
    return e();
  });
}));
var We,
  qe,
  Ue,
  $e = function (e, t, n, c) {
    var i,
      r,
      a,
      o = Object.keys(e),
      s = o.length,
      l = void 0 !== c ? function (e, t) {
        return function (n, c, i, r) {
          return e.call(t, n, c, i, r);
        };
      }(t, c) : t;
    for (void 0 === n ? (i = 1, a = e[o[0]]) : (i = 0, a = n); i < s; i++) a = l(a, e[r = o[i]], r, e);
    return a;
  };
function Xe(e) {
  var t = function (e) {
    for (var t = [], n = 0, c = e.length; n < c;) {
      var i = e.charCodeAt(n++);
      if (i >= 55296 && i <= 56319 && n < c) {
        var r = e.charCodeAt(n++);
        56320 == (64512 & r) ? t.push(((1023 & i) << 10) + (1023 & r) + 65536) : (t.push(i), n--);
      } else t.push(i);
    }
    return t;
  }(e);
  return 1 === t.length ? t[0].toString(16) : null;
}
function Ze(e) {
  return Object.keys(e).reduce(function (t, n) {
    var c = e[n];
    return c.icon ? t[c.iconName] = c.icon : t[n] = c, t;
  }, {});
}
function Ke(e, t) {
  var n = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).skipHooks,
    c = void 0 !== n && n,
    i = Ze(t);
  "function" != typeof Fe.hooks.addPack || c ? Fe.styles[e] = k(k({}, Fe.styles[e] || {}), i) : Fe.hooks.addPack(e, Ze(t)), "fas" === e && Ke("fa", t);
}
var Qe = Fe.styles,
  Je = Fe.shims,
  et = (T(We = {}, "classic", Object.values(le.classic)), T(We, "sharp", Object.values(le.sharp)), We),
  tt = null,
  nt = {},
  ct = {},
  it = {},
  rt = {},
  at = {},
  ot = (T(qe = {}, "classic", Object.keys(oe.classic)), T(qe, "sharp", Object.keys(oe.sharp)), qe);
var st,
  lt = function () {
    var e = function (e) {
      return $e(Qe, function (t, n, c) {
        return t[c] = $e(n, e, {}), t;
      }, {});
    };
    nt = e(function (e, t, n) {
      return t[3] && (e[t[3]] = n), t[2] && t[2].filter(function (e) {
        return "number" == typeof e;
      }).forEach(function (t) {
        e[t.toString(16)] = n;
      }), e;
    }), ct = e(function (e, t, n) {
      return e[n] = n, t[2] && t[2].filter(function (e) {
        return "string" == typeof e;
      }).forEach(function (t) {
        e[t] = n;
      }), e;
    }), at = e(function (e, t, n) {
      var c = t[2];
      return e[n] = n, c.forEach(function (t) {
        e[t] = n;
      }), e;
    });
    var t = "far" in Qe || _e.autoFetchSvg,
      n = $e(Je, function (e, n) {
        var c = n[0],
          i = n[1],
          r = n[2];
        return "far" !== i || t || (i = "fas"), "string" == typeof c && (e.names[c] = {
          prefix: i,
          iconName: r
        }), "number" == typeof c && (e.unicodes[c.toString(16)] = {
          prefix: i,
          iconName: r
        }), e;
      }, {
        names: {},
        unicodes: {}
      });
    it = n.names, rt = n.unicodes, tt = mt(_e.styleDefault, {
      family: _e.familyDefault
    });
  };
function ft(e, t) {
  return (nt[e] || {})[t];
}
function ut(e, t) {
  return (at[e] || {})[t];
}
function dt(e) {
  return it[e] || {
    prefix: null,
    iconName: null
  };
}
function pt() {
  return tt;
}
function mt(e) {
  var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).family,
    n = void 0 === t ? "classic" : t,
    c = oe[n][e],
    i = se[n][e] || se[n][c],
    r = e in Fe.styles ? e : null;
  return i || r || null;
}
st = function (e) {
  tt = mt(e.styleDefault, {
    family: _e.familyDefault
  });
}, we.push(st), lt();
var ht = (T(Ue = {}, "classic", Object.keys(le.classic)), T(Ue, "sharp", Object.keys(le.sharp)), Ue);
function vt(e) {
  var t,
    n = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).skipLookups,
    c = void 0 !== n && n,
    i = (T(t = {}, "classic", "".concat(_e.cssPrefix, "-").concat("classic")), T(t, "sharp", "".concat(_e.cssPrefix, "-").concat("sharp")), t),
    r = null,
    a = "classic";
  (e.includes(i.classic) || e.some(function (e) {
    return ht.classic.includes(e);
  })) && (a = "classic"), (e.includes(i.sharp) || e.some(function (e) {
    return ht.sharp.includes(e);
  })) && (a = "sharp");
  var o = e.reduce(function (e, t) {
    var n = function (e, t) {
      var n,
        c = t.split("-"),
        i = c[0],
        r = c.slice(1).join("-");
      return i !== e || "" === r || (n = r, ~ye.indexOf(n)) ? null : r;
    }(_e.cssPrefix, t);
    if (Qe[t] ? (t = et[a].includes(t) ? fe[a][t] : t, r = t, e.prefix = t) : ot[a].indexOf(t) > -1 ? (r = t, e.prefix = mt(t, {
      family: a
    })) : n ? e.iconName = n : t !== _e.replacementClass && t !== i.classic && t !== i.sharp && e.rest.push(t), !c && e.prefix && e.iconName) {
      var o = "fa" === r ? dt(e.iconName) : {},
        s = ut(e.prefix, e.iconName);
      o.prefix && (r = null), e.iconName = o.iconName || s || e.iconName, e.prefix = o.prefix || e.prefix, "far" !== e.prefix || Qe.far || !Qe.fas || _e.autoFetchSvg || (e.prefix = "fas");
    }
    return e;
  }, {
    prefix: null,
    iconName: null,
    rest: []
  });
  return (e.includes("fa-brands") || e.includes("fab")) && (o.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (o.prefix = "fad"), o.prefix || "sharp" !== a || !Qe.fass && !_e.autoFetchSvg || (o.prefix = "fass", o.iconName = ut(o.prefix, o.iconName) || o.iconName), "fa" !== o.prefix && "fa" !== r || (o.prefix = pt() || "fas"), o;
}
var gt = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.definitions = {};
    }
    var t, n;
    return t = e, n = [{
      key: "add",
      value: function () {
        for (var e = this, t = arguments.length, n = new Array(t), c = 0; c < t; c++) n[c] = arguments[c];
        var i = n.reduce(this._pullDefinitions, {});
        Object.keys(i).forEach(function (t) {
          e.definitions[t] = k(k({}, e.definitions[t] || {}), i[t]), Ke(t, i[t]);
          var n = le.classic[t];
          n && Ke(n, i[t]), lt();
        });
      }
    }, {
      key: "reset",
      value: function () {
        this.definitions = {};
      }
    }, {
      key: "_pullDefinitions",
      value: function (e, t) {
        var n = t.prefix && t.iconName && t.icon ? {
          0: t
        } : t;
        return Object.keys(n).map(function (t) {
          var c = n[t],
            i = c.prefix,
            r = c.iconName,
            a = c.icon,
            o = a[2];
          e[i] || (e[i] = {}), o.length > 0 && o.forEach(function (t) {
            "string" == typeof t && (e[i][t] = a);
          }), e[i][r] = a;
        }), e;
      }
    }], n && function (e, t) {
      for (var n = 0; n < t.length; n++) {
        var c = t[n];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(e, c.key, c);
      }
    }(t.prototype, n), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e;
  }(),
  bt = [],
  Ht = {},
  zt = {},
  yt = Object.keys(zt);
function Vt(e, t) {
  for (var n = arguments.length, c = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++) c[i - 2] = arguments[i];
  return (Ht[e] || []).forEach(function (e) {
    t = e.apply(null, [t].concat(c));
  }), t;
}
function xt(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++) n[c - 1] = arguments[c];
  (Ht[e] || []).forEach(function (e) {
    e.apply(null, n);
  });
}
function Mt() {
  var e = arguments[0],
    t = Array.prototype.slice.call(arguments, 1);
  return zt[e] ? zt[e].apply(null, t) : void 0;
}
function _t(e) {
  "fa" === e.prefix && (e.prefix = "fas");
  var t = e.iconName,
    n = e.prefix || pt();
  if (t) return t = ut(n, t) || t, Ye(wt.definitions, n, t) || Ye(Fe.styles, n, t);
}
var wt = new gt(),
  Et = {
    i2svg: function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return te ? (xt("beforeI2svg", e), Mt("pseudoElements2svg", e), Mt("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.autoReplaceSvgRoot;
      !1 === _e.autoReplaceSvg && (_e.autoReplaceSvg = !0), _e.observeMutations = !0, function (e) {
        te && (Be ? setTimeout(e, 0) : Re.push(e));
      }(function () {
        Lt({
          autoReplaceSvgRoot: t
        }), xt("watch", e);
      });
    }
  },
  Ct = {
    noAuto: function () {
      _e.autoReplaceSvg = !1, _e.observeMutations = !1, xt("noAuto");
    },
    config: _e,
    dom: Et,
    parse: {
      icon: function (e) {
        if (null === e) return null;
        if ("object" === P(e) && e.prefix && e.iconName) return {
          prefix: e.prefix,
          iconName: ut(e.prefix, e.iconName) || e.iconName
        };
        if (Array.isArray(e) && 2 === e.length) {
          var t = 0 === e[1].indexOf("fa-") ? e[1].slice(3) : e[1],
            n = mt(e[0]);
          return {
            prefix: n,
            iconName: ut(n, t) || t
          };
        }
        if ("string" == typeof e && (e.indexOf("".concat(_e.cssPrefix, "-")) > -1 || e.match(ue))) {
          var c = vt(e.split(" "), {
            skipLookups: !0
          });
          return {
            prefix: c.prefix || pt(),
            iconName: ut(c.prefix, c.iconName) || c.iconName
          };
        }
        if ("string" == typeof e) {
          var i = pt();
          return {
            prefix: i,
            iconName: ut(i, e) || e
          };
        }
      }
    },
    library: wt,
    findIconDefinition: _t,
    toHtml: Ge
  },
  Lt = function () {
    var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).autoReplaceSvgRoot,
      t = void 0 === e ? U : e;
    (Object.keys(Fe.styles).length > 0 || _e.autoFetchSvg) && te && _e.autoReplaceSvg && Ct.dom.i2svg({
      node: t
    });
  };
function Nt(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function () {
      return e.abstract.map(function (e) {
        return Ge(e);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function () {
      if (te) {
        var t = U.createElement("div");
        return t.innerHTML = e.html, t.children;
      }
    }
  }), e;
}
function St(e) {
  var t = e.icons,
    n = t.main,
    c = t.mask,
    i = e.prefix,
    r = e.iconName,
    a = e.transform,
    o = e.symbol,
    s = e.title,
    l = e.maskId,
    f = e.titleId,
    u = e.extra,
    d = e.watchable,
    p = void 0 !== d && d,
    m = c.found ? c : n,
    h = m.width,
    v = m.height,
    g = "fak" === i,
    b = [_e.replacementClass, r ? "".concat(_e.cssPrefix, "-").concat(r) : ""].filter(function (e) {
      return -1 === u.classes.indexOf(e);
    }).filter(function (e) {
      return "" !== e || !!e;
    }).concat(u.classes).join(" "),
    H = {
      children: [],
      attributes: k(k({}, u.attributes), {}, {
        "data-prefix": i,
        "data-icon": r,
        class: b,
        role: u.attributes.role || "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 ".concat(h, " ").concat(v)
      })
    },
    z = g && !~u.classes.indexOf("fa-fw") ? {
      width: "".concat(h / v * 16 * .0625, "em")
    } : {};
  p && (H.attributes["data-fa-i2svg"] = ""), s && (H.children.push({
    tag: "title",
    attributes: {
      id: H.attributes["aria-labelledby"] || "title-".concat(f || Le())
    },
    children: [s]
  }), delete H.attributes.title);
  var y = k(k({}, H), {}, {
      prefix: i,
      iconName: r,
      main: n,
      mask: c,
      maskId: l,
      transform: a,
      symbol: o,
      styles: k(k({}, z), u.styles)
    }),
    V = c.found && n.found ? Mt("generateAbstractMask", y) || {
      children: [],
      attributes: {}
    } : Mt("generateAbstractIcon", y) || {
      children: [],
      attributes: {}
    },
    x = V.children,
    M = V.attributes;
  return y.children = x, y.attributes = M, o ? function (e) {
    var t = e.prefix,
      n = e.iconName,
      c = e.children,
      i = e.attributes,
      r = e.symbol,
      a = !0 === r ? "".concat(t, "-").concat(_e.cssPrefix, "-").concat(n) : r;
    return [{
      tag: "svg",
      attributes: {
        style: "display: none;"
      },
      children: [{
        tag: "symbol",
        attributes: k(k({}, i), {}, {
          id: a
        }),
        children: c
      }]
    }];
  }(y) : function (e) {
    var t = e.children,
      n = e.main,
      c = e.mask,
      i = e.attributes,
      r = e.styles,
      a = e.transform;
    if (Te(a) && n.found && !c.found) {
      var o = {
        x: n.width / n.height / 2,
        y: .5
      };
      i.style = Pe(k(k({}, r), {}, {
        "transform-origin": "".concat(o.x + a.x / 16, "em ").concat(o.y + a.y / 16, "em")
      }));
    }
    return [{
      tag: "svg",
      attributes: i,
      children: t
    }];
  }(y);
}
function kt(e) {
  var t = e.content,
    n = e.width,
    c = e.height,
    i = e.transform,
    r = e.title,
    a = e.extra,
    o = e.watchable,
    s = void 0 !== o && o,
    l = k(k(k({}, a.attributes), r ? {
      title: r
    } : {}), {}, {
      class: a.classes.join(" ")
    });
  s && (l["data-fa-i2svg"] = "");
  var f = k({}, a.styles);
  Te(i) && (f.transform = function (e) {
    var t = e.transform,
      n = e.width,
      c = void 0 === n ? 16 : n,
      i = e.height,
      r = void 0 === i ? 16 : i,
      a = e.startCentered,
      o = void 0 !== a && a,
      s = "";
    return s += o && ne ? "translate(".concat(t.x / Ee - c / 2, "em, ").concat(t.y / Ee - r / 2, "em) ") : o ? "translate(calc(-50% + ".concat(t.x / Ee, "em), calc(-50% + ").concat(t.y / Ee, "em)) ") : "translate(".concat(t.x / Ee, "em, ").concat(t.y / Ee, "em) "), (s += "scale(".concat(t.size / Ee * (t.flipX ? -1 : 1), ", ").concat(t.size / Ee * (t.flipY ? -1 : 1), ") ")) + "rotate(".concat(t.rotate, "deg) ");
  }({
    transform: i,
    startCentered: !0,
    width: n,
    height: c
  }), f["-webkit-transform"] = f.transform);
  var u = Pe(f);
  u.length > 0 && (l.style = u);
  var d = [];
  return d.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), r && d.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), d;
}
var Pt = Fe.styles;
function Tt(e) {
  var t = e[0],
    n = e[1],
    c = O(e.slice(4), 1)[0];
  return {
    found: !0,
    width: t,
    height: n,
    icon: Array.isArray(c) ? {
      tag: "g",
      attributes: {
        class: "".concat(_e.cssPrefix, "-").concat(ge)
      },
      children: [{
        tag: "path",
        attributes: {
          class: "".concat(_e.cssPrefix, "-").concat(He),
          fill: "currentColor",
          d: c[0]
        }
      }, {
        tag: "path",
        attributes: {
          class: "".concat(_e.cssPrefix, "-").concat(be),
          fill: "currentColor",
          d: c[1]
        }
      }]
    } : {
      tag: "path",
      attributes: {
        fill: "currentColor",
        d: c
      }
    }
  };
}
var Ot = {
  found: !1,
  width: 512,
  height: 512
};
function At(e, t) {
  var n = t;
  return "fa" === t && null !== _e.styleDefault && (t = pt()), new Promise(function (c, i) {
    if (Mt("missingIconAbstract"), "fa" === n) {
      var r = dt(e) || {};
      e = r.iconName || e, t = r.prefix || t;
    }
    if (e && t && Pt[t] && Pt[t][e]) return c(Tt(Pt[t][e]));
    !function (e, t) {
      ie || _e.showMissingIcons || !e || console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
    }(e, t), c(k(k({}, Ot), {}, {
      icon: _e.showMissingIcons && e && Mt("missingIconAbstract") || {}
    }));
  });
}
var Dt = function () {},
  It = _e.measurePerformance && X && X.mark && X.measure ? X : {
    mark: Dt,
    measure: Dt
  },
  jt = function (e) {
    return It.mark("".concat('FA "6.4.2"', " ").concat(e, " begins")), function () {
      return function (e) {
        It.mark("".concat('FA "6.4.2"', " ").concat(e, " ends")), It.measure("".concat('FA "6.4.2"', " ").concat(e), "".concat('FA "6.4.2"', " ").concat(e, " begins"), "".concat('FA "6.4.2"', " ").concat(e, " ends"));
      }(e);
    };
  },
  Ft = function () {};
function Rt(e) {
  return "string" == typeof (e.getAttribute ? e.getAttribute("data-fa-i2svg") : null);
}
function Bt(e) {
  return U.createElementNS("http://www.w3.org/2000/svg", e);
}
function Gt(e) {
  return U.createElement(e);
}
function Yt(e) {
  var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).ceFn,
    n = void 0 === t ? "svg" === e.tag ? Bt : Gt : t;
  if ("string" == typeof e) return U.createTextNode(e);
  var c = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function (t) {
    c.setAttribute(t, e.attributes[t]);
  }), (e.children || []).forEach(function (e) {
    c.appendChild(Yt(e, {
      ceFn: n
    }));
  }), c;
}
var Wt = {
  replace: function (e) {
    var t = e[0];
    if (t.parentNode) if (e[1].forEach(function (e) {
      t.parentNode.insertBefore(Yt(e), t);
    }), null === t.getAttribute("data-fa-i2svg") && _e.keepOriginalSource) {
      var n = U.createComment(function (e) {
        var t = " ".concat(e.outerHTML, " ");
        return "".concat(t, "Font Awesome fontawesome.com ");
      }(t));
      t.parentNode.replaceChild(n, t);
    } else t.remove();
  },
  nest: function (e) {
    var t = e[0],
      n = e[1];
    if (~Se(t).indexOf(_e.replacementClass)) return Wt.replace(e);
    var c = new RegExp("".concat(_e.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      var i = n[0].attributes.class.split(" ").reduce(function (e, t) {
        return t === _e.replacementClass || t.match(c) ? e.toSvg.push(t) : e.toNode.push(t), e;
      }, {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = i.toSvg.join(" "), 0 === i.toNode.length ? t.removeAttribute("class") : t.setAttribute("class", i.toNode.join(" "));
    }
    var r = n.map(function (e) {
      return Ge(e);
    }).join("\n");
    t.setAttribute("data-fa-i2svg", ""), t.innerHTML = r;
  }
};
function qt(e) {
  e();
}
function Ut(e, t) {
  var n = "function" == typeof t ? t : Ft;
  if (0 === e.length) n();else {
    var c = qt;
    "async" === _e.mutateApproach && (c = q.requestAnimationFrame || qt), c(function () {
      var t = !0 === _e.autoReplaceSvg ? Wt.replace : Wt[_e.autoReplaceSvg] || Wt.replace,
        c = jt("mutate");
      e.map(t), c(), n();
    });
  }
}
var $t = !1;
function Xt() {
  $t = !0;
}
function Zt() {
  $t = !1;
}
var Kt = null;
function Qt(e) {
  if ($ && _e.observeMutations) {
    var t = e.treeCallback,
      n = void 0 === t ? Ft : t,
      c = e.nodeCallback,
      i = void 0 === c ? Ft : c,
      r = e.pseudoElementsCallback,
      a = void 0 === r ? Ft : r,
      o = e.observeMutationsRoot,
      s = void 0 === o ? U : o;
    Kt = new $(function (e) {
      if (!$t) {
        var t = pt();
        Ne(e).forEach(function (e) {
          if ("childList" === e.type && e.addedNodes.length > 0 && !Rt(e.addedNodes[0]) && (_e.searchPseudoElements && a(e.target), n(e.target)), "attributes" === e.type && e.target.parentNode && _e.searchPseudoElements && a(e.target.parentNode), "attributes" === e.type && Rt(e.target) && ~ve.indexOf(e.attributeName)) if ("class" === e.attributeName && function (e) {
            var t = e.getAttribute ? e.getAttribute("data-prefix") : null,
              n = e.getAttribute ? e.getAttribute("data-icon") : null;
            return t && n;
          }(e.target)) {
            var c = vt(Se(e.target)),
              r = c.prefix,
              o = c.iconName;
            e.target.setAttribute("data-prefix", r || t), o && e.target.setAttribute("data-icon", o);
          } else (s = e.target) && s.classList && s.classList.contains && s.classList.contains(_e.replacementClass) && i(e.target);
          var s;
        });
      }
    }), te && Kt.observe(s, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function Jt(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
      styleParser: !0
    },
    n = function (e) {
      var t,
        n,
        c = e.getAttribute("data-prefix"),
        i = e.getAttribute("data-icon"),
        r = void 0 !== e.innerText ? e.innerText.trim() : "",
        a = vt(Se(e));
      return a.prefix || (a.prefix = pt()), c && i && (a.prefix = c, a.iconName = i), a.iconName && a.prefix || (a.prefix && r.length > 0 && (a.iconName = (t = a.prefix, n = e.innerText, (ct[t] || {})[n] || ft(a.prefix, Xe(e.innerText)))), !a.iconName && _e.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
    }(e),
    c = n.iconName,
    i = n.prefix,
    r = n.rest,
    a = function (e) {
      var t = Ne(e.attributes).reduce(function (e, t) {
          return "class" !== e.name && "style" !== e.name && (e[t.name] = t.value), e;
        }, {}),
        n = e.getAttribute("title"),
        c = e.getAttribute("data-fa-title-id");
      return _e.autoA11y && (n ? t["aria-labelledby"] = "".concat(_e.replacementClass, "-title-").concat(c || Le()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
    }(e),
    o = Vt("parseNodeAttributes", {}, e),
    s = t.styleParser ? function (e) {
      var t = e.getAttribute("style"),
        n = [];
      return t && (n = t.split(";").reduce(function (e, t) {
        var n = t.split(":"),
          c = n[0],
          i = n.slice(1);
        return c && i.length > 0 && (e[c] = i.join(":").trim()), e;
      }, {})), n;
    }(e) : [];
  return k({
    iconName: c,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: i,
    transform: Ce,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: r,
      styles: s,
      attributes: a
    }
  }, o);
}
var en = Fe.styles;
function tn(e) {
  var t = "nest" === _e.autoReplaceSvg ? Jt(e, {
    styleParser: !1
  }) : Jt(e);
  return ~t.extra.classes.indexOf("fa-layers-text") ? Mt("generateLayersText", e, t) : Mt("generateSvgReplacementMutation", e, t);
}
var nn = new Set();
function cn(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
  if (!te) return Promise.resolve();
  var n = U.documentElement.classList,
    c = function (e) {
      return n.add("".concat("fontawesome-i2svg", "-").concat(e));
    },
    i = function (e) {
      return n.remove("".concat("fontawesome-i2svg", "-").concat(e));
    },
    r = _e.autoFetchSvg ? nn : re.map(function (e) {
      return "fa-".concat(e);
    }).concat(Object.keys(en));
  r.includes("fa") || r.push("fa");
  var a = [".".concat("fa-layers-text", ":not([").concat("data-fa-i2svg", "])")].concat(r.map(function (e) {
    return ".".concat(e, ":not([").concat("data-fa-i2svg", "])");
  })).join(", ");
  if (0 === a.length) return Promise.resolve();
  var o = [];
  try {
    o = Ne(e.querySelectorAll(a));
  } catch (e) {}
  if (!(o.length > 0)) return Promise.resolve();
  c("pending"), i("complete");
  var s = jt("onTree"),
    l = o.reduce(function (e, t) {
      try {
        var n = tn(t);
        n && e.push(n);
      } catch (e) {
        ie || "MissingIcon" === e.name && console.error(e);
      }
      return e;
    }, []);
  return new Promise(function (e, n) {
    Promise.all(l).then(function (n) {
      Ut(n, function () {
        c("active"), c("complete"), i("pending"), "function" == typeof t && t(), s(), e();
      });
    }).catch(function (e) {
      s(), n(e);
    });
  });
}
function rn(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
  tn(e).then(function (e) {
    e && Ut([e], t);
  });
}
re.map(function (e) {
  nn.add("fa-".concat(e));
}), Object.keys(oe.classic).map(nn.add.bind(nn)), Object.keys(oe.sharp).map(nn.add.bind(nn)), nn = A(nn);
var an = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = t.transform,
      c = void 0 === n ? Ce : n,
      i = t.symbol,
      r = void 0 !== i && i,
      a = t.mask,
      o = void 0 === a ? null : a,
      s = t.maskId,
      l = void 0 === s ? null : s,
      f = t.title,
      u = void 0 === f ? null : f,
      d = t.titleId,
      p = void 0 === d ? null : d,
      m = t.classes,
      h = void 0 === m ? [] : m,
      v = t.attributes,
      g = void 0 === v ? {} : v,
      b = t.styles,
      H = void 0 === b ? {} : b;
    if (e) {
      var z = e.prefix,
        y = e.iconName,
        V = e.icon;
      return Nt(k({
        type: "icon"
      }, e), function () {
        return xt("beforeDOMElementCreation", {
          iconDefinition: e,
          params: t
        }), _e.autoA11y && (u ? g["aria-labelledby"] = "".concat(_e.replacementClass, "-title-").concat(p || Le()) : (g["aria-hidden"] = "true", g.focusable = "false")), St({
          icons: {
            main: Tt(V),
            mask: o ? Tt(o.icon) : {
              found: !1,
              width: null,
              height: null,
              icon: {}
            }
          },
          prefix: z,
          iconName: y,
          transform: k(k({}, Ce), c),
          symbol: r,
          title: u,
          maskId: l,
          titleId: p,
          extra: {
            attributes: g,
            styles: H,
            classes: h
          }
        });
      });
    }
  },
  on = {
    mixout: function () {
      return {
        icon: (e = an, function (t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            c = (t || {}).icon ? t : _t(t || {}),
            i = n.mask;
          return i && (i = (i || {}).icon ? i : _t(i || {})), e(c, k(k({}, n), {}, {
            mask: i
          }));
        })
      };
      var e;
    },
    hooks: function () {
      return {
        mutationObserverCallbacks: function (e) {
          return e.treeCallback = cn, e.nodeCallback = rn, e;
        }
      };
    },
    provides: function (e) {
      e.i2svg = function (e) {
        var t = e.node,
          n = void 0 === t ? U : t,
          c = e.callback;
        return cn(n, void 0 === c ? function () {} : c);
      }, e.generateSvgReplacementMutation = function (e, t) {
        var n = t.iconName,
          c = t.title,
          i = t.titleId,
          r = t.prefix,
          a = t.transform,
          o = t.symbol,
          s = t.mask,
          l = t.maskId,
          f = t.extra;
        return new Promise(function (t, u) {
          Promise.all([At(n, r), s.iconName ? At(s.iconName, s.prefix) : Promise.resolve({
            found: !1,
            width: 512,
            height: 512,
            icon: {}
          })]).then(function (s) {
            var u = O(s, 2),
              d = u[0],
              p = u[1];
            t([e, St({
              icons: {
                main: d,
                mask: p
              },
              prefix: r,
              iconName: n,
              transform: a,
              symbol: o,
              maskId: l,
              title: c,
              titleId: i,
              extra: f,
              watchable: !0
            })]);
          }).catch(u);
        });
      }, e.generateAbstractIcon = function (e) {
        var t,
          n = e.children,
          c = e.attributes,
          i = e.main,
          r = e.transform,
          a = Pe(e.styles);
        return a.length > 0 && (c.style = a), Te(r) && (t = Mt("generateAbstractTransformGrouping", {
          main: i,
          transform: r,
          containerWidth: i.width,
          iconWidth: i.width
        })), n.push(t || i.icon), {
          children: n,
          attributes: c
        };
      };
    }
  },
  sn = {
    mixout: function () {
      return {
        layer: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.classes,
            c = void 0 === n ? [] : n;
          return Nt({
            type: "layer"
          }, function () {
            xt("beforeDOMElementCreation", {
              assembler: e,
              params: t
            });
            var n = [];
            return e(function (e) {
              Array.isArray(e) ? e.map(function (e) {
                n = n.concat(e.abstract);
              }) : n = n.concat(e.abstract);
            }), [{
              tag: "span",
              attributes: {
                class: ["".concat(_e.cssPrefix, "-layers")].concat(A(c)).join(" ")
              },
              children: n
            }];
          });
        }
      };
    }
  },
  ln = {
    mixout: function () {
      return {
        counter: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.title,
            c = void 0 === n ? null : n,
            i = t.classes,
            r = void 0 === i ? [] : i,
            a = t.attributes,
            o = void 0 === a ? {} : a,
            s = t.styles,
            l = void 0 === s ? {} : s;
          return Nt({
            type: "counter",
            content: e
          }, function () {
            return xt("beforeDOMElementCreation", {
              content: e,
              params: t
            }), function (e) {
              var t = e.content,
                n = e.title,
                c = e.extra,
                i = k(k(k({}, c.attributes), n ? {
                  title: n
                } : {}), {}, {
                  class: c.classes.join(" ")
                }),
                r = Pe(c.styles);
              r.length > 0 && (i.style = r);
              var a = [];
              return a.push({
                tag: "span",
                attributes: i,
                children: [t]
              }), n && a.push({
                tag: "span",
                attributes: {
                  class: "sr-only"
                },
                children: [n]
              }), a;
            }({
              content: e.toString(),
              title: c,
              extra: {
                attributes: o,
                styles: l,
                classes: ["".concat(_e.cssPrefix, "-layers-counter")].concat(A(r))
              }
            });
          });
        }
      };
    }
  },
  fn = {
    mixout: function () {
      return {
        text: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.transform,
            c = void 0 === n ? Ce : n,
            i = t.title,
            r = void 0 === i ? null : i,
            a = t.classes,
            o = void 0 === a ? [] : a,
            s = t.attributes,
            l = void 0 === s ? {} : s,
            f = t.styles,
            u = void 0 === f ? {} : f;
          return Nt({
            type: "text",
            content: e
          }, function () {
            return xt("beforeDOMElementCreation", {
              content: e,
              params: t
            }), kt({
              content: e,
              transform: k(k({}, Ce), c),
              title: r,
              extra: {
                attributes: l,
                styles: u,
                classes: ["".concat(_e.cssPrefix, "-layers-text")].concat(A(o))
              }
            });
          });
        }
      };
    },
    provides: function (e) {
      e.generateLayersText = function (e, t) {
        var n = t.title,
          c = t.transform,
          i = t.extra,
          r = null,
          a = null;
        if (ne) {
          var o = parseInt(getComputedStyle(e).fontSize, 10),
            s = e.getBoundingClientRect();
          r = s.width / o, a = s.height / o;
        }
        return _e.autoA11y && !n && (i.attributes["aria-hidden"] = "true"), Promise.resolve([e, kt({
          content: e.innerHTML,
          width: r,
          height: a,
          transform: c,
          title: n,
          extra: i,
          watchable: !0
        })]);
      };
    }
  },
  un = new RegExp('"', "ug"),
  dn = [1105920, 1112319];
function pn(e, t) {
  var n = "".concat("data-fa-pseudo-element-pending").concat(t.replace(":", "-"));
  return new Promise(function (c, i) {
    if (null !== e.getAttribute(n)) return c();
    var r,
      a,
      o,
      s = Ne(e.children).filter(function (e) {
        return e.getAttribute("data-fa-pseudo-element") === t;
      })[0],
      l = q.getComputedStyle(e, t),
      f = l.getPropertyValue("font-family").match(de),
      u = l.getPropertyValue("font-weight"),
      d = l.getPropertyValue("content");
    if (s && !f) return e.removeChild(s), c();
    if (f && "none" !== d && "" !== d) {
      var p = l.getPropertyValue("content"),
        m = ~["Sharp"].indexOf(f[2]) ? "sharp" : "classic",
        h = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(f[2]) ? se[m][f[2].toLowerCase()] : pe[m][u],
        v = function (e) {
          var t,
            n,
            c,
            i,
            r = e.replace(un, ""),
            a = (0, c = (t = r).length, (i = t.charCodeAt(0)) >= 55296 && i <= 56319 && c > 1 && (n = t.charCodeAt(1)) >= 56320 && n <= 57343 ? 1024 * (i - 55296) + n - 56320 + 65536 : i),
            o = a >= dn[0] && a <= dn[1],
            s = 2 === r.length && r[0] === r[1];
          return {
            value: Xe(s ? r[0] : r),
            isSecondary: o || s
          };
        }(p),
        g = v.value,
        b = v.isSecondary,
        H = f[0].startsWith("FontAwesome"),
        z = ft(h, g),
        y = z;
      if (H) {
        var V = (a = rt[r = g], o = ft("fas", r), a || (o ? {
          prefix: "fas",
          iconName: o
        } : null) || {
          prefix: null,
          iconName: null
        });
        V.iconName && V.prefix && (z = V.iconName, h = V.prefix);
      }
      if (!z || b || s && s.getAttribute("data-prefix") === h && s.getAttribute("data-icon") === y) c();else {
        e.setAttribute(n, y), s && e.removeChild(s);
        var x = {
            iconName: null,
            title: null,
            titleId: null,
            prefix: null,
            transform: Ce,
            symbol: !1,
            mask: {
              iconName: null,
              prefix: null,
              rest: []
            },
            maskId: null,
            extra: {
              classes: [],
              styles: {},
              attributes: {}
            }
          },
          M = x.extra;
        M.attributes["data-fa-pseudo-element"] = t, At(z, h).then(function (i) {
          var r = St(k(k({}, x), {}, {
              icons: {
                main: i,
                mask: {
                  prefix: null,
                  iconName: null,
                  rest: []
                }
              },
              prefix: h,
              iconName: y,
              extra: M,
              watchable: !0
            })),
            a = U.createElementNS("http://www.w3.org/2000/svg", "svg");
          "::before" === t ? e.insertBefore(a, e.firstChild) : e.appendChild(a), a.outerHTML = r.map(function (e) {
            return Ge(e);
          }).join("\n"), e.removeAttribute(n), c();
        }).catch(i);
      }
    } else c();
  });
}
function mn(e) {
  return Promise.all([pn(e, "::before"), pn(e, "::after")]);
}
function hn(e) {
  return !(e.parentNode === document.head || ~ce.indexOf(e.tagName.toUpperCase()) || e.getAttribute("data-fa-pseudo-element") || e.parentNode && "svg" === e.parentNode.tagName);
}
function vn(e) {
  if (te) return new Promise(function (t, n) {
    var c = Ne(e.querySelectorAll("*")).filter(hn).map(mn),
      i = jt("searchPseudoElements");
    Xt(), Promise.all(c).then(function () {
      i(), Zt(), t();
    }).catch(function () {
      i(), Zt(), n();
    });
  });
}
var gn = !1,
  bn = function (e) {
    return e.toLowerCase().split(" ").reduce(function (e, t) {
      var n = t.toLowerCase().split("-"),
        c = n[0],
        i = n.slice(1).join("-");
      if (c && "h" === i) return e.flipX = !0, e;
      if (c && "v" === i) return e.flipY = !0, e;
      if (i = parseFloat(i), isNaN(i)) return e;
      switch (c) {
        case "grow":
          e.size = e.size + i;
          break;
        case "shrink":
          e.size = e.size - i;
          break;
        case "left":
          e.x = e.x - i;
          break;
        case "right":
          e.x = e.x + i;
          break;
        case "up":
          e.y = e.y - i;
          break;
        case "down":
          e.y = e.y + i;
          break;
        case "rotate":
          e.rotate = e.rotate + i;
      }
      return e;
    }, {
      size: 16,
      x: 0,
      y: 0,
      flipX: !1,
      flipY: !1,
      rotate: 0
    });
  },
  Hn = {
    mixout: function () {
      return {
        parse: {
          transform: function (e) {
            return bn(e);
          }
        }
      };
    },
    hooks: function () {
      return {
        parseNodeAttributes: function (e, t) {
          var n = t.getAttribute("data-fa-transform");
          return n && (e.transform = bn(n)), e;
        }
      };
    },
    provides: function (e) {
      e.generateAbstractTransformGrouping = function (e) {
        var t = e.main,
          n = e.transform,
          c = e.containerWidth,
          i = e.iconWidth,
          r = {
            transform: "translate(".concat(c / 2, " 256)")
          },
          a = "translate(".concat(32 * n.x, ", ").concat(32 * n.y, ") "),
          o = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "),
          s = "rotate(".concat(n.rotate, " 0 0)"),
          l = {
            outer: r,
            inner: {
              transform: "".concat(a, " ").concat(o, " ").concat(s)
            },
            path: {
              transform: "translate(".concat(i / 2 * -1, " -256)")
            }
          };
        return {
          tag: "g",
          attributes: k({}, l.outer),
          children: [{
            tag: "g",
            attributes: k({}, l.inner),
            children: [{
              tag: t.icon.tag,
              children: t.icon.children,
              attributes: k(k({}, t.icon.attributes), l.path)
            }]
          }]
        };
      };
    }
  },
  zn = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  };
function yn(e) {
  var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
var Vn,
  xn,
  Mn = {
    hooks: function () {
      return {
        parseNodeAttributes: function (e, t) {
          var n = t.getAttribute("data-fa-mask"),
            c = n ? vt(n.split(" ").map(function (e) {
              return e.trim();
            })) : {
              prefix: null,
              iconName: null,
              rest: []
            };
          return c.prefix || (c.prefix = pt()), e.mask = c, e.maskId = t.getAttribute("data-fa-mask-id"), e;
        }
      };
    },
    provides: function (e) {
      e.generateAbstractMask = function (e) {
        var t,
          n = e.children,
          c = e.attributes,
          i = e.main,
          r = e.mask,
          a = e.maskId,
          o = e.transform,
          s = i.width,
          l = i.icon,
          f = r.width,
          u = r.icon,
          d = function (e) {
            var t = e.transform,
              n = e.iconWidth,
              c = {
                transform: "translate(".concat(e.containerWidth / 2, " 256)")
              },
              i = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "),
              r = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
              a = "rotate(".concat(t.rotate, " 0 0)");
            return {
              outer: c,
              inner: {
                transform: "".concat(i, " ").concat(r, " ").concat(a)
              },
              path: {
                transform: "translate(".concat(n / 2 * -1, " -256)")
              }
            };
          }({
            transform: o,
            containerWidth: f,
            iconWidth: s
          }),
          p = {
            tag: "rect",
            attributes: k(k({}, zn), {}, {
              fill: "white"
            })
          },
          m = l.children ? {
            children: l.children.map(yn)
          } : {},
          h = {
            tag: "g",
            attributes: k({}, d.inner),
            children: [yn(k({
              tag: l.tag,
              attributes: k(k({}, l.attributes), d.path)
            }, m))]
          },
          v = {
            tag: "g",
            attributes: k({}, d.outer),
            children: [h]
          },
          g = "mask-".concat(a || Le()),
          b = "clip-".concat(a || Le()),
          H = {
            tag: "mask",
            attributes: k(k({}, zn), {}, {
              id: g,
              maskUnits: "userSpaceOnUse",
              maskContentUnits: "userSpaceOnUse"
            }),
            children: [p, v]
          },
          z = {
            tag: "defs",
            children: [{
              tag: "clipPath",
              attributes: {
                id: b
              },
              children: (t = u, "g" === t.tag ? t.children : [t])
            }, H]
          };
        return n.push(z, {
          tag: "rect",
          attributes: k({
            fill: "currentColor",
            "clip-path": "url(#".concat(b, ")"),
            mask: "url(#".concat(g, ")")
          }, zn)
        }), {
          children: n,
          attributes: c
        };
      };
    }
  },
  _n = {
    provides: function (e) {
      var t = !1;
      q.matchMedia && (t = q.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function () {
        var e = [],
          n = {
            fill: "currentColor"
          },
          c = {
            attributeType: "XML",
            repeatCount: "indefinite",
            dur: "2s"
          };
        e.push({
          tag: "path",
          attributes: k(k({}, n), {}, {
            d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
          })
        });
        var i = k(k({}, c), {}, {
            attributeName: "opacity"
          }),
          r = {
            tag: "circle",
            attributes: k(k({}, n), {}, {
              cx: "256",
              cy: "364",
              r: "28"
            }),
            children: []
          };
        return t || r.children.push({
          tag: "animate",
          attributes: k(k({}, c), {}, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: k(k({}, i), {}, {
            values: "1;0;1;1;0;1;"
          })
        }), e.push(r), e.push({
          tag: "path",
          attributes: k(k({}, n), {}, {
            opacity: "1",
            d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
          }),
          children: t ? [] : [{
            tag: "animate",
            attributes: k(k({}, i), {}, {
              values: "1;0;0;0;0;1;"
            })
          }]
        }), t || e.push({
          tag: "path",
          attributes: k(k({}, n), {}, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: k(k({}, i), {}, {
              values: "0;0;1;1;0;0;"
            })
          }]
        }), {
          tag: "g",
          attributes: {
            class: "missing"
          },
          children: e
        };
      };
    }
  };
Vn = [Ie, on, sn, ln, fn, {
  hooks: function () {
    return {
      mutationObserverCallbacks: function (e) {
        return e.pseudoElementsCallback = vn, e;
      }
    };
  },
  provides: function (e) {
    e.pseudoElements2svg = function (e) {
      var t = e.node,
        n = void 0 === t ? U : t;
      _e.searchPseudoElements && vn(n);
    };
  }
}, {
  mixout: function () {
    return {
      dom: {
        unwatch: function () {
          Xt(), gn = !0;
        }
      }
    };
  },
  hooks: function () {
    return {
      bootstrap: function () {
        Qt(Vt("mutationObserverCallbacks", {}));
      },
      noAuto: function () {
        Kt && Kt.disconnect();
      },
      watch: function (e) {
        var t = e.observeMutationsRoot;
        gn ? Zt() : Qt(Vt("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
}, Hn, Mn, _n, {
  hooks: function () {
    return {
      parseNodeAttributes: function (e, t) {
        var n = t.getAttribute("data-fa-symbol"),
          c = null !== n && ("" === n || n);
        return e.symbol = c, e;
      }
    };
  }
}], xn = Ct, bt = Vn, Ht = {}, Object.keys(zt).forEach(function (e) {
  -1 === yt.indexOf(e) && delete zt[e];
}), bt.forEach(function (e) {
  var t = e.mixout ? e.mixout() : {};
  if (Object.keys(t).forEach(function (e) {
    "function" == typeof t[e] && (xn[e] = t[e]), "object" === P(t[e]) && Object.keys(t[e]).forEach(function (n) {
      xn[e] || (xn[e] = {}), xn[e][n] = t[e][n];
    });
  }), e.hooks) {
    var n = e.hooks();
    Object.keys(n).forEach(function (e) {
      Ht[e] || (Ht[e] = []), Ht[e].push(n[e]);
    });
  }
  e.provides && e.provides(zt);
});
var wn = Ct.parse,
  En = Ct.icon;
function Cn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    t && (c = c.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, c);
  }
  return n;
}
function Ln(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Cn(Object(n), !0).forEach(function (t) {
      Sn(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function Nn(e) {
  return Nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Nn(e);
}
function Sn(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function kn(e) {
  return function (e) {
    if (Array.isArray(e)) return Pn(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return Pn(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Pn(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Pn(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, c = new Array(t); n < t; n++) c[n] = e[n];
  return c;
}
function Tn(e) {
  return t = e, (t -= 0) == t ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, t) {
    return t ? t.toUpperCase() : "";
  })).substr(0, 1).toLowerCase() + e.substr(1);
  var t;
}
var On = ["style"];
var An = !1;
try {
  An = "production" === process.env.NODE_ENV;
} catch (Vn) {}
function Dn(e) {
  return e && "object" === Nn(e) && e.prefix && e.iconName && e.icon ? e : wn.icon ? wn.icon(e) : null === e ? null : e && "object" === Nn(e) && e.prefix && e.iconName ? e : Array.isArray(e) && 2 === e.length ? {
    prefix: e[0],
    iconName: e[1]
  } : "string" == typeof e ? {
    prefix: "fas",
    iconName: e
  } : void 0;
}
function In(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? Sn({}, e, t) : {};
}
var jn = /*#__PURE__*/t.forwardRef(function (e, t) {
  var n = e.icon,
    c = e.mask,
    i = e.symbol,
    r = e.className,
    a = e.title,
    o = e.titleId,
    s = e.maskId,
    l = Dn(n),
    f = In("classes", [].concat(kn(function (e) {
      var t,
        n = e.beat,
        c = e.fade,
        i = e.beatFade,
        r = e.bounce,
        a = e.shake,
        o = e.flash,
        s = e.spin,
        l = e.spinPulse,
        f = e.spinReverse,
        u = e.pulse,
        d = e.fixedWidth,
        p = e.inverse,
        m = e.border,
        h = e.listItem,
        v = e.flip,
        g = e.size,
        b = e.rotation,
        H = e.pull,
        z = (Sn(t = {
          "fa-beat": n,
          "fa-fade": c,
          "fa-beat-fade": i,
          "fa-bounce": r,
          "fa-shake": a,
          "fa-flash": o,
          "fa-spin": s,
          "fa-spin-reverse": f,
          "fa-spin-pulse": l,
          "fa-pulse": u,
          "fa-fw": d,
          "fa-inverse": p,
          "fa-border": m,
          "fa-li": h,
          "fa-flip": !0 === v,
          "fa-flip-horizontal": "horizontal" === v || "both" === v,
          "fa-flip-vertical": "vertical" === v || "both" === v
        }, "fa-".concat(g), null != g), Sn(t, "fa-rotate-".concat(b), null != b && 0 !== b), Sn(t, "fa-pull-".concat(H), null != H), Sn(t, "fa-swap-opacity", e.swapOpacity), t);
      return Object.keys(z).map(function (e) {
        return z[e] ? e : null;
      }).filter(function (e) {
        return e;
      });
    }(e)), kn(r.split(" ")))),
    u = In("transform", "string" == typeof e.transform ? wn.transform(e.transform) : e.transform),
    d = In("mask", Dn(c)),
    p = En(l, Ln(Ln(Ln(Ln({}, f), u), d), {}, {
      symbol: i,
      title: a,
      titleId: o,
      maskId: s
    }));
  if (!p) return function () {
    var e;
    !An && console && "function" == typeof console.error && (e = console).error.apply(e, arguments);
  }("Could not find icon", l), null;
  var m = p.abstract,
    h = {
      ref: t
    };
  return Object.keys(e).forEach(function (t) {
    jn.defaultProps.hasOwnProperty(t) || (h[t] = e[t]);
  }), Fn(m[0], h);
});
jn.displayName = "FontAwesomeIcon", jn.propTypes = {
  beat: p.bool,
  border: p.bool,
  beatFade: p.bool,
  bounce: p.bool,
  className: p.string,
  fade: p.bool,
  flash: p.bool,
  mask: p.oneOfType([p.object, p.array, p.string]),
  maskId: p.string,
  fixedWidth: p.bool,
  inverse: p.bool,
  flip: p.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: p.oneOfType([p.object, p.array, p.string]),
  listItem: p.bool,
  pull: p.oneOf(["right", "left"]),
  pulse: p.bool,
  rotation: p.oneOf([0, 90, 180, 270]),
  shake: p.bool,
  size: p.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: p.bool,
  spinPulse: p.bool,
  spinReverse: p.bool,
  symbol: p.oneOfType([p.bool, p.string]),
  title: p.string,
  titleId: p.string,
  transform: p.oneOfType([p.string, p.object]),
  swapOpacity: p.bool
}, jn.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var Fn = function e(t, n) {
    var c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    if ("string" == typeof n) return n;
    var i = (n.children || []).map(function (n) {
        return e(t, n);
      }),
      r = Object.keys(n.attributes || {}).reduce(function (e, t) {
        var c = n.attributes[t];
        switch (t) {
          case "class":
            e.attrs.className = c, delete n.attributes.class;
            break;
          case "style":
            e.attrs.style = function (e) {
              return e.split(";").map(function (e) {
                return e.trim();
              }).filter(function (e) {
                return e;
              }).reduce(function (e, t) {
                var n,
                  c = t.indexOf(":"),
                  i = Tn(t.slice(0, c)),
                  r = t.slice(c + 1).trim();
                return i.startsWith("webkit") ? e[(n = i, n.charAt(0).toUpperCase() + n.slice(1))] = r : e[i] = r, e;
              }, {});
            }(c);
            break;
          default:
            0 === t.indexOf("aria-") || 0 === t.indexOf("data-") ? e.attrs[t.toLowerCase()] = c : e.attrs[Tn(t)] = c;
        }
        return e;
      }, {
        attrs: {}
      }),
      a = c.style,
      o = void 0 === a ? {} : a,
      s = function (e, t) {
        if (null == e) return {};
        var n,
          c,
          i = function (e, t) {
            if (null == e) return {};
            var n,
              c,
              i = {},
              r = Object.keys(e);
            for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || (i[n] = e[n]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }(c, On);
    return r.attrs.style = Ln(Ln({}, r.attrs.style), o), t.apply(void 0, [n.tag, Ln(Ln({}, r.attrs), s)].concat(kn(i)));
  }.bind(null, t.createElement),
  Rn = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
  },
  Bn = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
  },
  Gn = {
    prefix: "fas",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8V384H416c-17.7 0-32 14.3-32 32s14.3 32 32 32h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V96z"]
  },
  Yn = {
    prefix: "fas",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"]
  },
  Wn = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
  },
  qn = {
    prefix: "fas",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]
  },
  Un = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"]
  },
  $n = {
    prefix: "fas",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
  },
  Xn = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
  },
  Zn = {
    prefix: "fas",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
  },
  Kn = {
    prefix: "fas",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  Qn = {
    prefix: "fas",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"]
  },
  Jn = {
    prefix: "fas",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  ec = {
    prefix: "fas",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"]
  },
  tc = {
    prefix: "fas",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M435.4 121.9l67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1zm-91.2 .7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5zm-176.5 267L389.5 167.8C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z"]
  },
  nc = {
    prefix: "fas",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
  },
  cc = {
    prefix: "fas",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"]
  },
  ic = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  rc = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"]
  },
  ac = {
    prefix: "fas",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  oc = {
    prefix: "fas",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  sc = {
    prefix: "fas",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
  },
  lc = {
    prefix: "fas",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"]
  },
  fc = {
    prefix: "fas",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"]
  },
  uc = {
    prefix: "fas",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M0 128V352c0 70.7 57.3 128 128 128H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H368c44.2 0 80-35.8 80-80V128c0-53-43-96-96-96H96C43 32 0 75 0 128z"]
  },
  dc = {
    prefix: "fas",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"]
  },
  pc = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
  },
  mc = {
    prefix: "fas",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96 43-96 96s43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96-43 96-96s-43-96-96-96H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160zM192 224H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  hc = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
  },
  vc = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]
  },
  gc = {
    prefix: "fas",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"]
  },
  bc = {
    prefix: "fas",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 0h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H232v64zm48 64H232v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"]
  },
  Hc = {
    prefix: "fas",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM400 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H514.7l-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h72c30.9 0 56 25.1 56 56s-25.1 56-56 56H455.4c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5H520c66.3 0 120-53.7 120-120c0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H400z"]
  },
  zc = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"]
  },
  yc = {
    prefix: "fas",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  Vc = {
    prefix: "fas",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"]
  },
  xc = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"]
  },
  Mc = {
    prefix: "fas",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94zm215.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
  },
  _c = {
    prefix: "fas",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M479 103.8L441 256H576V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320H400c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
  },
  wc = {
    prefix: "fas",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
  },
  Ec = {
    prefix: "fas",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"]
  },
  Cc = {
    prefix: "fas",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  Lc = {
    prefix: "fas",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"]
  },
  Nc = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  Sc = {
    prefix: "fas",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
  },
  kc = {
    prefix: "fas",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
  },
  Pc = {
    prefix: "fas",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"]
  },
  Tc = {
    prefix: "fas",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H399.7l-81.7-64H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H236.4L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM324.9 352l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H324.9zM162.5 224l-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7c0 17.7 14.3 32 32 32h34.5zM487.4 480l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H487.4z"]
  },
  Oc = {
    prefix: "fas",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
  },
  Ac = Oc,
  Dc = {
    prefix: "fas",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"]
  },
  Ic = {
    prefix: "fas",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"]
  },
  jc = {
    prefix: "fas",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"]
  },
  Fc = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"]
  },
  Rc = {
    prefix: "fas",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"]
  },
  Bc = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"]
  },
  Gc = {
    prefix: "fas",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"]
  },
  Yc = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  Wc = {
    prefix: "fas",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64-96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  qc = {
    prefix: "fas",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"]
  },
  Uc = {
    prefix: "fas",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"]
  },
  $c = {
    prefix: "fas",
    iconName: "code",
    icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
  },
  Xc = {
    prefix: "fas",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H256 512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448 416 288 256 192 160 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32v96H64V32zM512 256H256c-17.7 0-32 14.3-32 32v96H64V192H256 512v64zM192 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
  },
  Zc = {
    prefix: "fas",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"]
  },
  Kc = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"]
  },
  Qc = {
    prefix: "fas",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  Jc = {
    prefix: "fas",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  ei = {
    prefix: "fas",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  ti = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"]
  },
  ni = {
    prefix: "fas",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
  },
  ci = {
    prefix: "fas",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M177.5 446c-8.8 3.8-19 2-26-4.6l-144-136C2.7 300.9 0 294.6 0 288s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 88 192 0c17.7 0 32-14.3 32-32l0-144c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 144c0 70.7-57.3 128-128 128l-192 0 0 88c0 9.6-5.7 18.2-14.5 22z"]
  },
  ii = {
    prefix: "fas",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  ri = {
    prefix: "fas",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
  },
  ai = {
    prefix: "fas",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
  },
  oi = {
    prefix: "fas",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32zM32 96c17.7 0 32 14.3 32 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96L44.8 294.4C15.7 255.6 0 208.5 0 160V128c0-17.7 14.3-32 32-32zm320 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160V128c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  si = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  li = {
    prefix: "fas",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"]
  },
  fi = {
    prefix: "fas",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M64 128c0-17.7 14.3-32 32-32h12.8l34 84.9C95 215.9 64 272.3 64 336v8c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8H418c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344v-8c0-63.7-31-120.1-78.8-155.1L478.1 68.8c1.3-3.2 1.9-6.6 1.9-10C480 44 468 32 453.2 32H192 122.8 96C43 32 0 75 0 128v64c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm65 192c5.2-41.4 30.1-76.6 65-96H382c34.9 19.4 59.8 54.6 65 96H129z"]
  },
  ui = {
    prefix: "fas",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
  },
  di = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
  },
  pi = {
    prefix: "fas",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
  },
  mi = {
    prefix: "fas",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
  },
  hi = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
  },
  vi = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
  },
  gi = {
    prefix: "fas",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384H424l3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2v-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  bi = {
    prefix: "fas",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M224 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16V32H512c53 0 96 43 96 96c0 17.7-14.3 32-32 32H384V416H254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H96L18.7 338.7C6.7 326.7 0 310.5 0 293.5V96C0 60.7 28.7 32 64 32H224V16zM112 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112zm96 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80-48V400 320 288 216 192h24 76.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V320v64c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80V416zM578.1 288l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48H578.1z"]
  },
  Hi = {
    prefix: "fas",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 328c-61.9 0-112-50.1-112-112c0-16.5 3.6-32.2 10-46.3c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416z"]
  },
  zi = {
    prefix: "fas",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"]
  },
  yi = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"]
  },
  Vi = {
    prefix: "fas",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M537 116l-35.3 44.1C578.6 163.1 640 226.4 640 304c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45zM416 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
  },
  xi = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
  },
  Mi = {
    prefix: "fas",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  _i = {
    prefix: "fas",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"]
  },
  wi = {
    prefix: "fas",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
  },
  Ei = {
    prefix: "fas",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 448c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM384 64H64V384H384V64z"]
  },
  Ci = {
    prefix: "fas",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"]
  },
  Li = {
    prefix: "fas",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
  },
  Ni = {
    prefix: "fas",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"]
  },
  Si = {
    prefix: "fas",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"]
  },
  ki = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"]
  },
  Pi = {
    prefix: "fas",
    iconName: "download",
    icon: [512, 512, [], "f019", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  Ti = {
    prefix: "fas",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M0 96v64H448V96c0-53-43-96-96-96H96C43 0 0 43 0 96zM56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zM176 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 200V448H64l0-192H384zM64 192H0v64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256 192H384 64zm48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
  },
  Oi = {
    prefix: "fas",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"]
  },
  Ai = {
    prefix: "fas",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
  },
  Di = {
    prefix: "fas",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"]
  },
  Ii = {
    prefix: "fas",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"]
  },
  ji = {
    prefix: "fas",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zM128 416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"]
  },
  Fi = {
    prefix: "fas",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  Ri = {
    prefix: "fas",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"]
  },
  Bi = {
    prefix: "fas",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Gi = {
    prefix: "fas",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 256H192V416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7c15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7C83.4 349.4 64 380.4 64 416c0 53 43 96 96 96s96-43 96-96V256zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32V256H320V384z"]
  },
  Yi = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"]
  },
  Wi = {
    prefix: "fas",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
  },
  qi = {
    prefix: "fas",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
  },
  Ui = {
    prefix: "fas",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 256h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
  },
  $i = {
    prefix: "fas",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"]
  },
  Xi = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
  },
  Zi = {
    prefix: "fas",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  Ki = {
    prefix: "fas",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
  },
  Qi = {
    prefix: "fas",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]
  },
  Ji = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  er = {
    prefix: "fas",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"]
  },
  tr = {
    prefix: "fas",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
  },
  nr = {
    prefix: "fas",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]
  },
  cr = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  ir = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
  },
  rr = {
    prefix: "fas",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M120 0c13.3 0 24 10.7 24 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V24c0-13.3 10.7-24 24-24zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424H306.5l-18.3-42.7C277.7 383.1 267 384 256 384H192c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  ar = {
    prefix: "fas",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"]
  },
  or = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
  },
  sr = {
    prefix: "fas",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
  },
  lr = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
  },
  fr = {
    prefix: "fas",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  ur = {
    prefix: "fas",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
  },
  dr = {
    prefix: "fas",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
  },
  pr = {
    prefix: "fas",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM288 416c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32z"]
  },
  mr = {
    prefix: "fas",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
  },
  hr = {
    prefix: "fas",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
  },
  vr = {
    prefix: "fas",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4H496c35.3 0 64 28.7 64 64v5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H482.3l100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4V192c0-70.7-57.3-128-128-128h-4.5c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z"]
  },
  gr = {
    prefix: "fas",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"]
  },
  br = {
    prefix: "fas",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  Hr = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
  },
  zr = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
  },
  yr = {
    prefix: "fas",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
  },
  Vr = {
    prefix: "fas",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"]
  },
  xr = {
    prefix: "fas",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"]
  },
  Mr = {
    prefix: "fas",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
  },
  _r = {
    prefix: "fas",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M0 32V64C0 81.7 14.3 96 32 96H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm608 96H32V480c0 17.7 14.3 32 32 32h96V352c0-88.4 71.6-160 160-160s160 71.6 160 160V512h96c17.7 0 32-14.3 32-32V128zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z"]
  },
  wr = {
    prefix: "fas",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
  },
  Er = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"]
  },
  Cr = {
    prefix: "fas",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  Lr = {
    prefix: "fas",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"]
  },
  Nr = {
    prefix: "fas",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
  },
  Sr = {
    prefix: "fas",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  kr = {
    prefix: "fas",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"]
  },
  Pr = {
    prefix: "fas",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM432 64c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4 .4 19.3 6.5 26.8s15.2 11.8 24.8 11.8H524c28.7 0 52 23.3 52 52s-23.3 52-52 52H456.4c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2H524c64.1 0 116-51.9 116-116s-51.9-116-116-116H439.4L458 128H576c17.7 0 32-14.3 32-32s-14.3-32-32-32H432z"]
  },
  Tr = {
    prefix: "fas",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
  },
  Or = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  Ar = {
    prefix: "fas",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]
  },
  Dr = {
    prefix: "fas",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M512 256c0 141.4-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13c23.9-8.7 38.3-32 36.8-56.1c-1.3-24.4-16.5-46.1-39.2-55.6L166.2 257.3c-8.1-3.4-17.5 .4-21 8.5s.4 17.5 8.5 21l82.4 34.7L144 355v-3c0-30.9-25.1-56-56-56s-56 25.1-56 56v28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM112 352v48.6l151.8-55.2c12.5-4.5 26.2 1.9 30.8 14.4s-1.9 26.2-14.4 30.8l-49.8 18.1-26.1 71.7c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  Ir = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"]
  },
  jr = {
    prefix: "fas",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
  },
  Fr = {
    prefix: "fas",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
  },
  Rr = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
  },
  Br = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Gr = {
    prefix: "fas",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  Yr = {
    prefix: "fas",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
  },
  Wr = {
    prefix: "fas",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  qr = {
    prefix: "fas",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"]
  },
  Ur = {
    prefix: "far",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  $r = {
    prefix: "far",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"]
  },
  Xr = {
    prefix: "far",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zm456 0c0-8.5-4.5-16.4-11.8-20.7s-16.4-4.4-23.8-.3l-72 40c-11.6 6.4-15.8 21-9.3 32.6s21 15.8 32.6 9.3L456 128.8V400H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H504V88z"]
  },
  Zr = {
    prefix: "far",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M512 80H128c-8.8 0-16 7.2-16 16V320H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320H528V96c0-8.8-7.2-16-16-16zM96 432H544c20.9 0 38.7-13.4 45.3-32H50.7c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32c0 53-43 96-96 96H96c-53 0-96-43-96-96z"]
  },
  Kr = {
    prefix: "far",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
  },
  Qr = {
    prefix: "far",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M88 72v48H40V72H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 232v48H40V232H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 200H88v48H40V392zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 72v48H200V72h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 200h48v48H200V232zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 160v48H200V392h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 72h48v48H360V72zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 160v48H360V232h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 200h48v48H360V392zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
  },
  Jr = {
    prefix: "far",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8c12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6l0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4c-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7H351.6c5.7 5.3 9.7 11 12.3 17.1z"]
  },
  ea = {
    prefix: "far",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
  },
  ta = {
    prefix: "far",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  na = {
    prefix: "far",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M48 80v48H464V80H48zM32 32H480c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM32 416V208H80V416c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V208h48V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64z"]
  },
  ca = {
    prefix: "far",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM169.8 117.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  ia = {
    prefix: "far",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M512 80c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM432 136V344c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-312-8c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120z"]
  },
  ra = {
    prefix: "far",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H80c0-97.2 78.8-176 176-176s176 78.8 176 176h48c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  aa = {
    prefix: "far",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M224 240h96c66.2 0 122 44.7 138.8 105.5c3.3-12.4 5.2-26.2 5.2-41.5c0-70.7-57.3-128-128-128H224 200c-13.3 0-24-10.7-24-24V128 99.9L55.9 208 176 316.1V288 264c0-13.3 10.7-24 24-24h24zm0 48v48 16c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2V80v48h48 64c97.2 0 176 78.8 176 176c0 78-38.6 126.2-68.7 152.1c-4.1 3.5-8.1 6.6-11.7 9.3c-3.2 2.4-6.2 4.4-8.9 6.2c-4.5 3-8.3 5.1-10.8 6.5c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-6.8 3.6-13.2 8.3-18.1c.5-.5 .9-.9 1.4-1.4c2.4-2.3 5.1-5.1 7.7-8.6c1.7-2.3 3.4-5 5-7.9c5.3-9.7 9.5-22.9 9.5-40.2c0-53-43-96-96-96H272 224z"]
  },
  oa = {
    prefix: "far",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L396.5 81.5C358.1 50.6 309.2 32 256 32C132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.5-74.5c38.4 31 87.3 49.5 140.5 49.5c123.7 0 224-100.3 224-224c0-53.2-18.6-102.1-49.5-140.5L505 41zM362.3 115.7L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3L396.3 149.7C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176c-39.9 0-76.8-13.3-106.3-35.7z"]
  },
  sa = {
    prefix: "far",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"]
  },
  la = {
    prefix: "far",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32C50.1 160 0 210.1 0 272c0 44.7 26.2 83.2 64 101.2V416c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H112l0-16V336l0-128h32c12.6 0 24.3 3.6 34.2 9.9c7.9-14.2 18.1-26.9 30.2-37.6C190.2 167.5 168 160 144 160H112zM64 229.7v84.7C54 303.1 48 288.2 48 272s6-31.1 16-42.3zM496 208h32V336v48 16H496V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V373.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H496c-24 0-46.2 7.5-64.4 20.3c12 10.7 22.3 23.4 30.2 37.6c9.9-6.3 21.6-9.9 34.2-9.9zm96 64c0 16.2-6 31.1-16 42.3V229.7c10 11.3 16 26.1 16 42.3zM560 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 32c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V389.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H304zm0 224V352 224h32l0 128v48 32H304V400zm-48-69.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3v84.7zm128 0V245.7c10 11.3 16 26.1 16 42.3s-6 31.1-16 42.3z"]
  },
  fa = {
    prefix: "far",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  ua = {
    prefix: "far",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M320 80v64H256V80h64zM256 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h8v40H112c-30.9 0-56 25.1-56 56v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V288c0-4.4 3.6-8 8-8H264v40h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V280H464c4.4 0 8 3.6 8 8v32h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V288c0-30.9-25.1-56-56-56H312V192h8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256zM48 368h64v64H48V368zm208 0h64v64H256V368zm208 0h64v64H464V368z"]
  },
  da = {
    prefix: "far",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H80v80H560V304H536c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V280zM48 464H164.3c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H48v32zm171.7 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H219.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zm128 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H347.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zM592 464V432H475.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16H592z"]
  },
  pa = {
    prefix: "far",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
  },
  ma = {
    prefix: "far",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
  },
  ha = {
    prefix: "far",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M144 128v64H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zM48 256V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16z"]
  },
  va = {
    prefix: "far",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0zM48 336V448c0 8.8 7.2 16 16 16h48V304H48v16 16zM160 464h72V304H160V464zm120 0h72V304l-72 0V464zm-2.7-208H376l24 0 48 0c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V336 320 280 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8zM48 256l88 0h40l-51.2-38.4c-8.3-6.2-18.4-9.6-28.8-9.6c-26.5 0-48 21.5-48 48zm352 48V464h48c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H400zM272 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  ga = {
    prefix: "far",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M48 144V276.1C66.1 263.4 88.2 256 112 256H380c7 0 13.7 1 20 3V144c0-35.3-28.7-64-64-64H112c-35.3 0-64 28.7-64 64zM0 368V144C0 82.1 50.1 32 112 32H336c61.9 0 112 50.1 112 112V320h-.1c.1 1.3 .1 2.7 .1 4c0 37.6-30.4 68-68 68H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H380c11 0 20-9 20-20s-9-20-20-20H112c-35.3 0-64 28.7-64 64s28.7 64 64 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H112C50.1 480 0 429.9 0 368z"]
  },
  ba = {
    prefix: "far",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM405.3 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80H378.7c39.8 0 73.2 27.2 82.6 64H178.7c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z"]
  },
  Ha = {
    prefix: "far",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
  },
  za = {
    prefix: "far",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C98.1 144 48 194.1 48 256s50.1 112 112 112h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c61.9 0 112-50.1 112-112s-50.1-112-112-112H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c88.4 0 160 71.6 160 160zM184 232H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  ya = {
    prefix: "far",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
  },
  Va = {
    prefix: "far",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  xa = {
    prefix: "far",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M240 80V432H208V80h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 272V432H48V272H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-80h32V432H368V144zm-48 0V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
  },
  Ma = {
    prefix: "far",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216 16h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H216v96zm64 48H216v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V296 160c0-17.7 14.3-32 32-32h80c53 0 96 43 96 96s-43 96-96 96z"]
  },
  _a = {
    prefix: "far",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM400 64c-13.3 0-24 10.7-24 24s10.7 24 24 24H542.1L423 231c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8h88c35.3 0 64 28.7 64 64s-28.7 64-64 64H455.4c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2c6.4 38.6 39.8 66.8 78.9 66.8H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H497.9L617 105c6.9-6.9 8.9-17.2 5.2-26.2S609.7 64 600 64H400z"]
  },
  wa = {
    prefix: "far",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4l0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5l0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192V368c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5V113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
  },
  Ea = {
    prefix: "far",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  Ca = {
    prefix: "far",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"]
  },
  La = {
    prefix: "far",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M336 448V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 215.6c11 0 20 9 20 20v10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8v10.1c0 11-9 20-20 20s-20-9-20-20V409.7c-10-1.9-19.3-4.8-27.5-7.3l0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2l0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3V235.6c0-11 9-20 20-20zM96 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Na = {
    prefix: "far",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zM115.7 346.2L75.5 307l55.5-8.1c15.6-2.3 29.2-12.1 36.1-26.3l24.8-50.3 24.8 50.3c7 14.2 20.5 24 36.1 26.3l55.5 8.1-40.2 39.2c-11.3 11-16.4 26.9-13.8 42.4l9.5 55.4-49.5-26.1c-14-7.4-30.7-7.4-44.7 0L120 444l9.5-55.4c2.7-15.6-2.5-31.4-13.8-42.4zm54.7-188.8l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94c-8.8-17.9-34.3-17.9-43.1 0zm258.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
  },
  Sa = {
    prefix: "far",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M455.5 92.9L421.5 256H592V88c0-13.3 10.7-24 24-24s24 10.7 24 24V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V304H392c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24V224H272V88c0-13.3 10.7-24 24-24s24 10.7 24 24V248 424c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H48V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V248 88C0 74.7 10.7 64 24 64z"]
  },
  ka = {
    prefix: "far",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M39.9 185.7C114.6 119.9 212.6 80 320 80s205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32S91.3 76.4 8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2zM320 256c64.6 0 123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5C196.5 280.7 255.4 256 320 256zm56 168a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
  },
  Pa = {
    prefix: "far",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M101.3 48C89.5 48 80 57.5 80 69.3V256H432h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H432 80 32 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V69.3C32 31 63 0 101.3 0c18.4 0 36 7.3 49 20.3l4.8 4.8c11.1-5.8 23.7-9.1 37-9.1c23.9 0 45.4 10.5 60.1 27.2c9.2-5.3 21.1-4 28.9 3.9c9.4 9.4 9.4 24.6 0 33.9L177 185c-9.4 9.4-24.6 9.4-33.9 0c-7.8-7.8-9.1-19.7-3.9-28.9C122.5 141.4 112 119.9 112 96c0-13.4 3.3-25.9 9.1-37l-4.8-4.8c-4-4-9.4-6.2-15-6.2zM32 336H80v32c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V336h48v32c0 28.4-12.4 54-32 71.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V462.7c-5.2 .9-10.5 1.3-16 1.3H128c-5.5 0-10.8-.5-16-1.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V439.6C44.4 422 32 396.4 32 368V336zM192 64c-17.7 0-32 14.3-32 32c0 10.4 4.9 19.6 12.6 25.5l44.8-44.8C211.6 68.9 202.4 64 192 64z"]
  },
  Ta = {
    prefix: "far",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
  },
  Oa = {
    prefix: "far",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 56C0 42.7 10.7 32 24 32H72 88 212c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124H88 72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48V256 80H24C10.7 80 0 69.3 0 56zM212 232c42 0 76-34 76-76s-34-76-76-76H96V232H212zM96 280V432H244c42 0 76-34 76-76s-34-76-76-76H212 96z"]
  },
  Aa = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  Da = {
    prefix: "far",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
  },
  Ia = {
    prefix: "far",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
  },
  ja = {
    prefix: "far",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M140.8 122.9C171.7 96.2 212 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2c-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.3 0-109.6 21.5-149.2 56.9L76.3 58.3C69.7 51.7 60.7 48 51.3 48C31.8 48 16 63.8 16 83.3V200c0 13.3 10.7 24 24 24H156.7c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25l-40.8-40.8zm-76.8-9L126.1 176H64V113.9z"]
  },
  Fa = {
    prefix: "far",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L471.2 344H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H409.9L307.9 216H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H246.6L144.6 88H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-9 0-16.9 5-21 12.3L38.8 5.1zM152.3 216l-50.4-39.7C98.2 180.5 96 186 96 192c0 13.3 10.7 24 24 24h32.3zM314.8 344l-60.9-48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H314.8zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H477.2l-60.9-48H120z"]
  },
  Ra = {
    prefix: "far",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
  },
  Ba = Ra,
  Ga = {
    prefix: "far",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M178.7 122.2c11.2-6.5 19.3-17.2 22.5-29.8l5.3-20.9 15 15.5c9 9.3 21.4 14.5 34.4 14.5s25.4-5.2 34.4-14.5l15-15.5 5.3 20.9c3.2 12.6 11.3 23.3 22.5 29.8s24.6 8.1 37 4.6l20.8-5.9-5.9 20.8c-3.5 12.5-1.9 25.8 4.6 37s17.2 19.3 29.8 22.5l20.9 5.3-15.5 15c-9.3 9-14.5 21.4-14.5 34.4s5.2 25.4 14.5 34.4l15.5 15-20.9 5.3c-12.6 3.2-23.3 11.3-29.8 22.5s-8.1 24.6-4.6 37l5.9 20.8-20.8-5.9c-12.5-3.5-25.8-1.9-37 4.6s-19.3 17.2-22.5 29.8l-5.3 20.9-15-15.5c-9-9.3-21.4-14.5-34.4-14.5s-25.4 5.2-34.4 14.5l-15 15.5-5.3-20.9c-3.2-12.6-11.3-23.3-22.5-29.8s-24.6-8.1-37-4.6l-20.8 5.9 5.9-20.8c3.5-12.5 1.9-25.8-4.6-37s-17.2-19.3-29.8-22.5l-20.9-5.3 15.5-15c9.3-9 14.5-21.4 14.5-34.4s-5.2-25.4-14.5-34.4l-15.5-15 20.9-5.3c12.6-3.2 23.3-11.3 29.8-22.5s8.1-24.6 4.6-37l-5.9-20.8 20.8 5.9c12.5 3.5 25.8 1.9 37.1-4.6zM222.5 19.1L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-4 15.9L154.7 80.6 108.5 67.5 92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l4.5 15.8 13.1 46.2L34.1 166.5l-15.9 4c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l11.8 11.5L53.5 256 19.1 289.5 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l15.9 4 46.5 11.8L67.5 403.5l-4.5 15.8c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l15.8-4.5 46.2-13.1 11.8 46.5 4 15.9c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L222.5 493 256 458.5 289.5 493 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l4-15.9 11.8-46.5 46.2 13.1 15.8 4.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-4.5-15.8-13.1-46.2 46.5-11.8 15.9-4c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L493 289.5 458.5 256 493 222.5 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-15.9-4-46.5-11.8 13.1-46.2 4.5-15.8c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-15.8 4.5L357.3 80.6 345.5 34.1l-4-15.9c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L289.5 19.1 256 53.5 222.5 19.1z"]
  },
  Ya = {
    prefix: "far",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-281.9-221L396.4 80H521.3l-8.5 34.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.5l11-44.1C576.6 56.5 557.5 32 531.5 32h-335c-18.4 0-34.4 12.5-38.8 30.3l-7.5 30.1L38.8 5.1zM191.5 124.8L202.7 80H346.5L308.1 216.2 191.5 124.8zm57.4 300.7l-1.8 6.5H192c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H296.9l23.6-83.5-40.8-32.1L248.9 425.5z"]
  },
  Wa = {
    prefix: "far",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"]
  },
  qa = {
    prefix: "far",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"]
  },
  Ua = {
    prefix: "far",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 56c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H291.3L144.7 432H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H92.7L239.3 80H152c-13.3 0-24-10.7-24-24z"]
  },
  $a = {
    prefix: "far",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  Xa = {
    prefix: "far",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M70.6 176H249.4L160 86.6 70.6 176zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336L160 425.4 249.4 336H70.6zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
  },
  Za = {
    prefix: "far",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM216 72H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  Ka = {
    prefix: "far",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm120-72v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm72-88c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM480 88V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  Qa = {
    prefix: "far",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M256 55.8L289.5 96h-67L256 55.8zM229.8 12.3L168.2 86.2c-5.3 6.3-8.2 14.3-8.2 22.6c0 19.5 15.8 35.2 35.2 35.2H232v88H144V195.2c0-19.5-15.8-35.2-35.2-35.2c-8.2 0-16.2 2.9-22.6 8.2L12.3 229.8C4.5 236.2 0 245.9 0 256s4.5 19.8 12.3 26.2l73.9 61.6c6.3 5.3 14.3 8.2 22.6 8.2c19.5 0 35.2-15.8 35.2-35.2V280h88v88H195.2c-19.5 0-35.2 15.8-35.2 35.2c0 8.2 2.9 16.2 8.2 22.6l61.6 73.9c6.5 7.8 16.1 12.3 26.2 12.3s19.8-4.5 26.2-12.3l61.6-73.9c5.3-6.3 8.2-14.3 8.2-22.6c0-19.5-15.8-35.2-35.2-35.2H280V280h88v36.8c0 19.5 15.8 35.2 35.2 35.2c8.2 0 16.2-2.9 22.6-8.2l73.9-61.6c7.8-6.5 12.3-16.1 12.3-26.2s-4.5-19.8-12.3-26.2l-73.9-61.6c-6.3-5.3-14.3-8.2-22.6-8.2c-19.5 0-35.2 15.8-35.2 35.2V232H280V144h36.8c19.5 0 35.2-15.8 35.2-35.2c0-8.2-2.9-16.2-8.2-22.6L282.2 12.3C275.8 4.5 266.1 0 256 0s-19.8 4.5-26.2 12.3zM256 456.2L222.5 416h67L256 456.2zM456.2 256L416 289.5v-67L456.2 256zM96 289.5L55.8 256 96 222.5v67z"]
  },
  Ja = {
    prefix: "far",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M341.5 13.5C337.5 5.2 329.1 0 319.9 0s-17.6 5.2-21.6 13.5L229.7 154.8 76.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L174.2 328.4 148 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L465.6 328.4 576.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L410.1 154.8 341.5 13.5zM320 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L423 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L331.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"]
  },
  eo = {
    prefix: "far",
    iconName: "code",
    icon: [640, 512, [], "f121", "M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256 168.4 153.5c9.7-9.1 10.2-24.3 1.1-33.9z"]
  },
  to = {
    prefix: "far",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M24 0C37.3 0 48 10.7 48 24V160H256V40c0-22.1 17.9-40 40-40H456c66.3 0 120 53.7 120 120v64 96V439.7 488c0 13.3-10.7 24-24 24s-24-10.7-24-24V463.7H280 48V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V439.7 184 24C0 10.7 10.7 0 24 0zM256 415.7V296c0-22.1 17.9-40 40-40H528V208H280 48V415.7H256zM528 160V120c0-39.8-32.2-72-72-72H304V160H528zm0 144H304V415.7H528V304zM96 328a56 56 0 1 1 112 0A56 56 0 1 1 96 328zM152 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
  },
  no = {
    prefix: "far",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M77 48L51.4 240H208c7.4 0 14.4 3.4 18.9 9.2s6.2 13.4 4.4 20.6l-23 91.8L322.8 192H176c-7.9 0-15.3-3.9-19.8-10.4s-5.4-14.9-2.6-22.2L196.9 48H77zM30.4 34.7C33 14.8 50 0 70 0H208.6c28.1 0 47.5 28.3 37.3 54.5L211.1 144H337.9c32.1 0 51.1 35.8 33.2 62.4l-199.2 295c-6.5 9.7-19 13.2-29.7 8.5s-16.3-16.4-13.5-27.7L177.3 288H42.3C18.1 288-.6 266.7 2.6 242.7l27.7-208z"]
  },
  co = {
    prefix: "far",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"]
  },
  io = {
    prefix: "far",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  ro = {
    prefix: "far",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120h66.7c3.8-22.7 23.6-40 47.3-40h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H400c-23.8 0-43.5-17.3-47.3-40H286zM80 144a64 64 0 1 1 128 0A64 64 0 1 1 80 144zM376 264c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40 56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V320h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h56 40v-8zm-40 56V464H464V320H336zM32 336c0-8.8 7.2-16 16-16h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm128 48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32zM0 488c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM400 128v32h96V128H400z"]
  },
  ao = {
    prefix: "far",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 48c44.2 0 80 35.8 80 80v64H144V128c0-44.2 35.8-80 80-80zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 240H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm184 80c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V320z"]
  },
  oo = {
    prefix: "far",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80v72c0 13.3 10.7 24 24 24s24-10.7 24-24V128C560 57.3 502.7 0 432 0S304 57.3 304 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128zM64 240H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16z"]
  },
  so = {
    prefix: "far",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  lo = {
    prefix: "far",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M6.5 271.6c-8.7 9.2-8.7 23.7 0 32.9l121.4 129c8.8 9.3 21 14.6 33.7 14.6c25.6 0 46.3-20.7 46.3-46.3l0-41.7 144 0c88.4 0 160-71.6 160-160l0-112c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 120c0 4.4-3.6 8-8 8l-152 0 0-41.7c0-25.6-20.7-46.3-46.3-46.3c-12.8 0-25 5.3-33.7 14.6L6.5 271.6zm153.5-93l0 61.5c0 13.3 10.7 24 24 24l176 0c30.9 0 56-25.1 56-56l0-120c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 112c0 61.9-50.1 112-112 112l-168 0c-13.3 0-24 10.7-24 24l0 61.5L57 288 160 178.5z"]
  },
  fo = {
    prefix: "far",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  uo = {
    prefix: "far",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
  },
  po = {
    prefix: "far",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
  },
  mo = {
    prefix: "far",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c13.3 0 24 10.7 24 24v88c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6C167.2 236.2 152 190.7 152 144V56c0-13.3 10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V418.1c0-33.2-9.8-65.6-28.2-93.2L36.3 277.7C12.6 242.2 0 200.5 0 157.9V120c0-13.3 10.7-24 24-24zm328 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V418.1c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3C316.6 242.2 304 200.5 304 157.9V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  ho = {
    prefix: "far",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
  },
  vo = {
    prefix: "far",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0s0 0 0 0"]
  },
  go = {
    prefix: "far",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M88 80c-22.1 0-40 17.9-40 40v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V120C0 71.4 39.4 32 88 32h34.4H192 453.6C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80H88zm296.8 80l35.6-80H192 155.6l35.6 80H384.8zm1.2 48H190c-41.8 21.6-71.7 63.1-77.1 112H463.1c-5.4-48.9-35.3-90.4-77.1-112zm32.2 224H157.7c.1 0 .1 0 .2 0H418c.1 0 .1 0 .2 0z"]
  },
  bo = {
    prefix: "far",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"]
  },
  Ho = {
    prefix: "far",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"]
  },
  zo = {
    prefix: "far",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  yo = {
    prefix: "far",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"]
  },
  Vo = {
    prefix: "far",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
  },
  xo = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
  },
  Mo = {
    prefix: "far",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 336H424c22 0 41.2 15 46.6 36.4l3.6 14.3c6.7 26.6 30.6 45.3 58 45.3c33 0 59.8-26.8 59.8-59.8v-2.8c0-3.5-.3-7.1-.9-10.6L558.4 168c-6.2-36-27.8-60.4-54.6-67.1C461.4 90.3 399.7 80 320 80s-141.5 10.3-183.7 20.9C109.4 107.6 87.8 132 81.6 168L48.9 358.8c-.6 3.5-.9 7-.9 10.6v2.8c0 33 26.8 59.8 59.8 59.8c27.4 0 51.4-18.7 58-45.3l3.6-14.3C174.8 351 194 336 216 336zm211.6 62.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM232 168v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H232v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  _o = {
    prefix: "far",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H520c48.6 0 88 39.4 88 88v40c0 22.5-15.5 41.4-36.4 46.6l53.1 41.7c9.7 7.6 15.3 19.2 15.3 31.5V376c0 22.1-17.9 40-40 40H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H408 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7 .9-13.7 2.6-20.1c-1.3-.8-2.4-1.8-3.5-2.9L21.1 335C7.6 321.5 0 303.2 0 284.1V104C0 64.2 32.2 32 72 32H224V24zM72 80c-13.3 0-24 10.7-24 24V284.1c0 6.4 2.5 12.5 7 17L121.9 368H128c13.4-10 30-16 48-16s34.6 6 48 16H384V256 184c0-13.3 10.7-24 24-24h16 80 56V120c0-22.1-17.9-40-40-40H72zM556.8 256l-61.1-48H432v48H556.8zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM120 128H264c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"]
  },
  wo = {
    prefix: "far",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM314.6 319.7c-3.5 .2-7 .3-10.6 .3c-32 0-56-16-80-32s-48-32-80-32c-3.5 0-7.1 .2-10.7 .4C146.4 218.9 182 192 224 192c53 0 96 43 96 96c0 11.1-1.9 21.8-5.4 31.7zM368 288A144 144 0 1 0 80 288a144 144 0 1 0 288 0z"]
  },
  Eo = {
    prefix: "far",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
  },
  Co = {
    prefix: "far",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.2-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"]
  },
  Lo = {
    prefix: "far",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM519 69.3c-10.3-8.3-25.5-6.6-33.7 3.7l-98 122.5C364.4 224 352 259.5 352 296h.2c-.1 2.6-.2 5.3-.2 8c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-6.8 0-13.4 .5-20 1.4L522.7 103c8.3-10.4 6.6-25.5-3.8-33.7zM496 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
  },
  No = {
    prefix: "far",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  So = {
    prefix: "far",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm88 72H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  ko = {
    prefix: "far",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"]
  },
  Po = {
    prefix: "far",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
  },
  To = {
    prefix: "far",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M48 448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V368H48v80zm0-128H400V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V320zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Oo = {
    prefix: "far",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c48.6 0 88-39.4 88-88l0-342.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L168 424c0 22.1-17.9 40-40 40L24 464z"]
  },
  Ao = {
    prefix: "far",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
  },
  Do = {
    prefix: "far",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M64 448c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V368H64v80zm0-128H320V64c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16V320zM16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM160 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Io = {
    prefix: "far",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"]
  },
  jo = {
    prefix: "far",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"]
  },
  Fo = {
    prefix: "far",
    iconName: "download",
    icon: [512, 512, [], "f019", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V294.1l-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95V24zM128.8 304H64c-35.3 0-64 28.7-64 64v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V368c0-35.3-28.7-64-64-64H383.2l-48 48H448c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16H176.8l-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  Ro = {
    prefix: "far",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M352 48c26.5 0 48 21.5 48 48v64H48V96c0-26.5 21.5-48 48-48H352zm48 160V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208H400zM96 0C43 0 0 43 0 96V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96zm32 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 240c-17.7 0-32 14.3-32 32V400c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H112zm32 48H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Bo = {
    prefix: "far",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M120 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM96 320c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  Go = {
    prefix: "far",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H384V312c0-22.1-17.9-40-40-40H232c-22.1 0-40 17.9-40 40V464H144c-17.7 0-32-14.3-32-32zm128 32V320h96V464H240z"]
  },
  Yo = {
    prefix: "far",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3V200c0 13.3-10.7 24-24 24H355.3c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176H448V113.9z"]
  },
  Wo = {
    prefix: "far",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M71.9 26.7c1.5-13.2-8-25-21.2-26.5s-25 8-26.5 21.2l-16 144L8 166.7V168v16c0 48.6 39.4 88 88 88h8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V272h8c48.6 0 88-39.4 88-88V168v-1.3l-.1-1.3-16-144C230.4 8.2 218.5-1.3 205.3 .1s-22.7 13.3-21.2 26.5L200 169.3V184c0 22.1-17.9 40-40 40H128 96c-22.1 0-40-17.9-40-40V169.3L71.9 26.7zM152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM336 176c0-57.7 21.7-88.6 41.4-105.7c7.7-6.6 15.5-11.6 22.6-15.2V248v56H352c-8.8 0-16-7.2-16-16V176zm64 176V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352 304 248 32c0-17.7-14.3-32-32-32C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h48z"]
  },
  qo = {
    prefix: "far",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M24 72C10.7 72 0 82.7 0 96s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM152 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM128 416c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zM0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24V424z"]
  },
  Uo = {
    prefix: "far",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95V360zm32-8V304H448c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V368c0-35.3 28.7-64 64-64H200v48H64c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H312zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  $o = {
    prefix: "far",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M321.7 0c19.1 0 32.9 18.3 27.6 36.6L295.8 224h85.2c19.3 0 34.9 15.6 34.9 34.9c0 10.3-4.5 20-12.3 26.6L144.9 505.2c-5.2 4.4-11.8 6.8-18.6 6.8c-19.1 0-32.9-18.3-27.6-36.6L152.2 288H65.7C47.1 288 32 272.9 32 254.3c0-9.9 4.3-19.2 11.8-25.6L303.1 6.9C308.3 2.4 314.9 0 321.7 0zM285.6 85L104.4 240H184c7.5 0 14.6 3.5 19.2 9.5s6 13.8 3.9 21L162.3 427.5 345.5 272H264c-7.5 0-14.6-3.5-19.2-9.5s-6-13.8-3.9-21L285.6 85z"]
  },
  Xo = {
    prefix: "far",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M0 24C0 37.3 10.7 48 24 48H56 392h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H392 56 24C10.7 0 0 10.7 0 24zM81.6 182.9l-1.6 .5V80H32V207.1l-.4 .4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3c1.7 1.1 3.5 2.1 5.2 3.2L69.3 448.2c-3.5 6.3-5.3 13.5-5.3 20.7c0 23.8 19.3 43.1 43.1 43.1H340.9c23.8 0 43.1-19.3 43.1-43.1c0-7.2-1.8-14.4-5.3-20.7l-22.3-40.7c1.8-1 3.5-2.1 5.2-3.2c45-28.1 78.4-75.6 78.4-148.3c0-20.3-9.5-36.6-23.6-48.5l-.4-.4V80H368V183.4l-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9zM373.8 326.8c-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3c-14.7-9.2-27.8-21.2-37.6-36.9c2.4 .8 4.9 1.5 7.4 2.3C119.6 340 170.3 344 224 344s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3zM56 256c0-3.7 1.2-7.4 6.6-12c6.1-5.1 16.5-10.4 32.3-15C126.3 220 171.6 216 224 216s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15c5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12c-6.1 5.1-16.5 10.4-32.2 15C321.7 292 276.4 296 224 296s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15c-5.4-4.6-6.6-8.2-6.6-12zM312.3 426.8L332.6 464H115.4l20.4-37.2c30.5 9.7 61.8 13.2 88.3 13.2s57.7-3.5 88.3-13.2zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
  },
  Zo = {
    prefix: "far",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 48c-8.8 0-16 7.2-16 16V192c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm120 64H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM368 288V392c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7c-11.5-6.6-15.4-21.3-8.7-32.8s21.3-15.4 32.8-8.7C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88V288h48zM208 424V288h48V424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2c11.5-6.6 26.2-2.7 32.8 8.7s2.7 26.2-8.7 32.8c-12 7-20 19.9-20 34.7c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
  },
  Ko = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"]
  },
  Qo = {
    prefix: "far",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M505 273c9.4-9.4 9.4-24.6 0-33.9L369 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l95 95L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l406.1 0-95 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z"]
  },
  Jo = {
    prefix: "far",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
  },
  es = {
    prefix: "far",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M176 80H80v96h96V80zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 304H80v96h96V336zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 80v96h96V80H336zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
  },
  ts = {
    prefix: "far",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM39 103c9.4-9.4 24.6-9.4 33.9 0l72.4 72.4C161.3 165.7 180 160 200 160H312c20 0 38.7 5.7 54.6 15.5L439 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C410.3 225.3 416 244 416 264h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H416v8c0 27.2-6.8 52.8-18.8 75.3L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-70.9-70.9C339.3 462.5 299.7 480 256 480s-83.3-17.5-112.2-45.9L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8C102.8 372.8 96 347.2 96 320v-8H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96c0-20 5.7-38.7 15.5-54.6L39 137c-9.4-9.4-9.4-24.6 0-33.9zM144 264v56c0 53.6 37.7 98.4 88 109.4V280c0-13.3 10.7-24 24-24s24 10.7 24 24V429.4c50.3-11 88-55.8 88-109.4V264c0-30.9-25.1-56-56-56H200c-30.9 0-56 25.1-56 56z"]
  },
  ns = {
    prefix: "far",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
  },
  cs = {
    prefix: "far",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  is = {
    prefix: "far",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V360v96c0 13.3 10.7 24 24 24s24-10.7 24-24V384H312 592v80c0 13.3 10.7 24 24 24s24-10.7 24-24V360 248c0-66.3-53.7-120-120-120H344c-30.9 0-56 25.1-56 56V336H48V56zM592 248v88H336V184c0-4.4 3.6-8 8-8H520c39.8 0 72 32.2 72 72zM128 216a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm128 0A88 88 0 1 0 80 216a88 88 0 1 0 176 0z"]
  },
  rs = {
    prefix: "far",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
  },
  as = {
    prefix: "far",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
  },
  os = {
    prefix: "far",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
  },
  ss = {
    prefix: "far",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M32 160a64 64 0 1 0 128 0A64 64 0 1 0 32 160zM80 334.1C62.8 349 41 360.8 18.8 365.8C5.9 368.7-2.3 381.5 .6 394.5s15.7 21.1 28.7 18.2C58 406.2 81.6 392.2 96 382.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM256.5 193.9L403 318.1c13.8-3.2 27.9-9.6 40.2-18c2.4-1.7 4.9-3.2 7.5-4.5L295.9 164.3C319.7 151.4 347 144 376 144h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376c-119.3 0-216 96.7-216 216v2.2c10.8 4 21.9 6.2 32 6.2c5.4 0 10.7-.5 16-1.6V312c0-46.1 18.5-87.8 48.5-118.1z"]
  },
  ls = {
    prefix: "far",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M48 336h81.2l20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1H326.1c15.1 0 29-8.6 35.8-22.1L382.8 336H464v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V336zm406.5-48H377.9c-15.1 0-29 8.6-35.8 22.1L321.2 352H190.8l-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1H57.5l49-195.9C108.2 85 114.6 80 122 80H390c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
  },
  fs = {
    prefix: "far",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M392 48H120c-4.4 0-8 3.6-8 8V225.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V186.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2V56c0-4.4-3.6-8-8-8zM160 120c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zm0 80c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM48 276.2V456c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8V276.2L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V237.9z"]
  },
  us = {
    prefix: "far",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160h64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H384l0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-376H288V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H192c-88.4 0-160-71.6-160-160zM240 304V80H192C130.1 80 80 130.1 80 192s50.1 112 112 112h48z"]
  },
  ds = {
    prefix: "far",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M120 0C106.7 0 96 10.7 96 24v2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24c0-13.3-10.7-24-24-24zM48.9 208H399.1c-8 72-69 128-143.1 128H192c-74.1 0-135.2-56-143.1-128zM32 160c-17.7 0-32 14.3-32 32c0 78.1 46.6 145.3 113.6 175.3l-7.5 17.5c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H327l10.9 25.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L334.4 367.3c67-30 113.6-97.2 113.6-175.3c0-17.7-14.3-32-32-32H32zM147.5 410l12.3-28.7c10.5 1.8 21.2 2.7 32.2 2.7h64c11 0 21.7-.9 32.2-2.7L306.5 424H155.3c-2-5-4.7-9.7-7.8-14zM72 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24z"]
  },
  ps = {
    prefix: "far",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"]
  },
  ms = {
    prefix: "far",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
  },
  hs = {
    prefix: "far",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M39.6 5.8C32.5-.3 22.5-1.7 14 2.2S0 14.6 0 24V488c0 9.4 5.5 17.9 14 21.8s18.5 2.5 25.6-3.6L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c7.1 6.1 17.1 7.5 25.6 3.6s14-12.4 14-21.8V24c0-9.4-5.5-17.9-14-21.8s-18.5-2.5-25.6 3.6L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8zm8.4 430V76.2l16.4 14c9 7.7 22.3 7.7 31.2 0L136 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L248 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l16.4-14V435.8l-16.4-14c-9-7.7-22.3-7.7-31.2 0L248 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0L136 456.4 95.6 421.8c-9-7.7-22.3-7.7-31.2 0L48 435.8zM120 144c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 256c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
  },
  vs = {
    prefix: "far",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
  },
  gs = {
    prefix: "far",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM120 464H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  bs = {
    prefix: "far",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24zM192 256c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  Hs = {
    prefix: "far",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"]
  },
  zs = {
    prefix: "far",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zM288 408c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24z"]
  },
  ys = {
    prefix: "far",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"]
  },
  Vs = {
    prefix: "far",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
  },
  xs = {
    prefix: "far",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zm397.3 40.8C457.9 118 474 112 490.7 112h9.2c42.1 0 76.2 34.1 76.2 76.2c0 21.3-8.9 41.5-24.5 56L375.7 406.4c-7.3 6.7-9.7 17.2-6.1 26.4s12.5 15.3 22.4 15.3H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H453.4L584.1 279.4c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64h-9.2c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l29.7-25.4z"]
  },
  Ms = {
    prefix: "far",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"]
  },
  _s = {
    prefix: "far",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  ws = {
    prefix: "far",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"]
  },
  Es = {
    prefix: "far",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
  },
  Cs = {
    prefix: "far",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M369 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L369 113zM112 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
  },
  Ls = {
    prefix: "far",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l4.1 4.1-35.7 35.7c-6.6 6.6-10.3 15.6-10.3 25c0 19.5 15.8 35.3 35.3 35.3H472c13.3 0 24-10.7 24-24V83.3C496 63.8 480.2 48 460.7 48c-9.4 0-18.3 3.7-25 10.3L400 94.1l-4.1-4.1C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9l-4.1-4.1 35.7-35.7c6.6-6.6 10.3-15.6 10.3-25c0-19.5-15.8-35.3-35.3-35.3H40c-13.3 0-24 10.7-24 24V428.7C16 448.2 31.8 464 51.3 464c9.4 0 18.3-3.7 25-10.3L112 417.9l4.1 4.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9zM448 176H385.9L448 113.9V176zM64 336h62.1L64 398.1V336z"]
  },
  Ns = {
    prefix: "far",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M288 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM448 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM75 437a32 32 0 1 0 45.3-45.3A32 32 0 1 0 75 437zm316.8 0A32 32 0 1 0 437 391.8 32 32 0 1 0 391.8 437zM75 75a32 32 0 1 0 45.3 45.3A32 32 0 1 0 75 75z"]
  },
  Ss = {
    prefix: "far",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM399 79L239 239c-9.4 9.4-9.4 24.6 0 33.9L399 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-143-143L433 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
  },
  ks = {
    prefix: "far",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M48 48H592V80H48V48zM32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32l0 360c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V368c0-88.4 71.6-160 160-160s160 71.6 160 160V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM80 464V128H560V464H528V368c0-114.9-93.1-208-208-208s-208 93.1-208 208v96H80zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z"]
  },
  Ps = {
    prefix: "far",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M48 106.7V56c0-13.3-10.7-24-24-24S0 42.7 0 56V168c0 13.3 10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H80.7c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
  },
  Ts = {
    prefix: "far",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136h111l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H342.9L314.1 328H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H304.5l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376h-111l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h81.1l28.8-144H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h87.5l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328h111l28.8-144h-111z"]
  },
  Os = {
    prefix: "far",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm120-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm72 40c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM480 88V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  As = {
    prefix: "far",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M111.7 6.4c9.2-8.5 23.4-8.5 32.6 0l96.8 89.4c9.5 8.8 14.9 21.1 14.9 34c0 25.5-20.7 46.3-46.3 46.3H200V336h9.7c25.5 0 46.3 20.7 46.3 46.3c0 12.9-5.4 25.2-14.9 34l-96.8 89.4c-9.2 8.5-23.4 8.5-32.6 0L14.9 416.2C5.4 407.5 0 395.2 0 382.3C0 356.7 20.7 336 46.3 336H56V176H46.3C20.7 176 0 155.3 0 129.7c0-12.9 5.4-25.2 14.9-34L111.7 6.4zM50.7 128H80c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H50.7L128 455.3 205.3 384H176c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24h29.3L128 56.7 50.7 128zM47.4 381s0 0 0 0l-1.2 1.3 1.2-1.3 0 0z"]
  },
  Ds = {
    prefix: "far",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
  },
  Is = {
    prefix: "far",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M48 123.9C48 99.6 67.6 80 91.9 80c11.6 0 22.8 4.6 31 12.9l6.7 6.7c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8 .8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-.8 .8L303.4 81l-.2-.2c-37.9-37.9-96.2-43-139.6-15.1l-6.7-6.7C139.6 41.7 116.3 32 91.9 32C41.1 32 0 73.1 0 123.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V123.9zM269.5 115l6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2 .2 0 0zM416 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  js = {
    prefix: "far",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16zm64 208v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48z"]
  },
  Fs = {
    prefix: "far",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM440 64c-11.4 0-21.3 8.1-23.5 19.3l-32 160c-1.4 7.1 .4 14.4 5 19.9s11.4 8.8 18.6 8.8H528c35.3 0 64 28.7 64 64s-28.7 64-64 64H464.4c-13.8 0-26-8.8-30.4-21.9l-3.2-9.7c-4.2-12.6-17.8-19.4-30.4-15.2s-19.4 17.8-15.2 30.4l3.2 9.7C399.4 426 429.9 448 464.4 448H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H437.3l22.4-112H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H440z"]
  },
  Rs = {
    prefix: "far",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
  },
  Bs = {
    prefix: "far",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
  },
  Gs = {
    prefix: "far",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M288 240H192c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128H288h24c13.3 0 24-10.7 24-24V128 99.9L456.1 208 336 316.1V288 264c0-13.3-10.7-24-24-24H288zm0 48v48 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V80v48H240 176C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96h48 48z"]
  },
  Ys = {
    prefix: "far",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 17.7 2.2 34.8 6.4 51.2C40.8 317.4 32 333.7 32 352v28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l10.1-27.7c3.8 .2 7.7 .3 11.6 .3zm43-158.9c-9.9-2-20.5-1.3-30.7 2.5L237.9 319l-65.5-15.4c-8.6-2-13.9-10.6-11.9-19.2s10.6-13.9 19.2-11.9l97.1 22.8c8.2 1.9 15.7 5.3 22.3 9.8zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-120-31.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3zM112 352v48.4l167.6-62.8c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9L230.9 407c-.1 .4-.3 .8-.4 1.2l-26.3 72.2c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  Ws = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"]
  },
  qs = {
    prefix: "far",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M424 40c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H424zm0 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424zm24 152c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24zM424 424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424z"]
  },
  Us = {
    prefix: "far",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
  },
  $s = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.1s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"]
  },
  Xs = {
    prefix: "far",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM192 400c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zM112 224H272c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32z"]
  },
  Zs = {
    prefix: "far",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M112 160V64c0-8.8 7.2-16 16-16H357.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64v96h48zm16 208H384v96H128V368zm-16-48c-17.7 0-32 14.3-32 32H48V256c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16v96H432c0-17.7-14.3-32-32-32H112zm320 80h48c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64V368c0 17.7 14.3 32 32 32H80v80c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V400z"]
  },
  Ks = {
    prefix: "far",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192H477.9c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144H88.2L256 51.4 423.8 144H283.7c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224V384c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V224H400V384H336V224H288V384H224V224H176V384H112V224H64zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H32z"]
  },
  Qs = {
    prefix: "far",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
  },
  Js = {
    prefix: "far",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M175.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3H264V352c0 88.4-71.6 160-160 160H56c-30.9 0-56-25.1-56-56V424c0-30.9 25.1-56 56-56h56c4.4 0 8-3.6 8-8V208H78.3C52.7 208 32 187.3 32 161.7c0-12.8 5.3-25 14.6-33.7L175.6 6.5zM82.5 160H144c13.3 0 24 10.7 24 24V360c0 30.9-25.1 56-56 56H56c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h48c61.9 0 112-50.1 112-112V184c0-13.3 10.7-24 24-24h61.5L192 57 82.5 160z"]
  },
  el = {
    prefix: "fal",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm80 80V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  tl = {
    prefix: "fal",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H312v72H416V192zm0 104H312v80H416V296zm0 112H312v72h72c17.7 0 32-14.3 32-32V408zM280 376V296H168v80H280zM168 408v72H280V408H168zm-32-32V296H32v80H136zM32 408v40c0 17.7 14.3 32 32 32h72V408H32zm0-144H136V192H32v72zm136 0H280V192H168v72zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"]
  },
  nl = {
    prefix: "fal",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M496 80c0-5.7-3-10.9-7.9-13.8s-10.9-2.9-15.9-.2l-72 40c-7.7 4.3-10.5 14-6.2 21.8s14 10.5 21.8 6.2L464 107.2V416H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V80zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80z"]
  },
  cl = {
    prefix: "fal",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M512 64H128c-17.7 0-32 14.3-32 32V352H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H544V96c0-17.7-14.3-32-32-32zM76.8 448H563.2c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z"]
  },
  il = {
    prefix: "fal",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
  },
  rl = {
    prefix: "fal",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 224c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 192H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 64h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
  },
  al = {
    prefix: "fal",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M129.7 132c4.8-25.9 22-44.8 49.7-56.2c28.3-11.7 67-15 111-8.4c13.8 2.1 56.1 10 69.7 13.5c8.6 2.2 17.3-3 19.5-11.5s-3-17.3-11.5-19.5c-15.1-3.9-58.6-12-72.9-14.1c-47.7-7.2-92.7-4.1-127.9 10.5c-35.7 14.7-62.1 41.6-69.1 80.6c-.1 .3-.1 .6-.1 .9c-2.8 22.9 .6 42.7 9.5 59.7c8.8 16.8 22.4 29.6 37.9 39.8c18.7 12.2 41.6 21.2 65.2 28.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H319.4c-18.1-6.6-37-12.1-55.3-17.3l-1.2-.3c-39-11.2-74.8-21.6-100.2-38.1c-12.5-8.1-21.5-17.2-27.1-27.8c-5.4-10.4-8.1-23.3-6.1-40.5zM379 336.8c4.7 10.8 6.6 24.5 3.4 42.7c-4.7 26.1-21.9 45.2-49.8 56.6c-28.3 11.7-66.9 15-110.9 8.4c-22.1-3.5-59.5-15.7-88-25.1l0 0 0 0c-6.1-2-11.8-3.9-16.8-5.5c-8.4-2.7-17.4 1.9-20.1 10.4s1.9 17.4 10.4 20.1c4.4 1.4 9.6 3.1 15.3 5c28.3 9.3 69.3 22.8 94.4 26.7l.1 0c47.7 7.2 92.7 4.1 127.9-10.5c35.7-14.7 62.1-41.6 69.1-80.6c4.2-23.3 2.2-43.7-5.6-61.3c-.6-1.3-1.2-2.7-1.9-4H367.7c4.9 5.2 8.6 10.8 11.3 16.8z"]
  },
  ol = {
    prefix: "fal",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6l-219 219V400c0-8.8-7.2-16-16-16H128V352c0-8.8-7.2-16-16-16H99.4l219-219zM66.9 379.5c1.2-4 2.7-7.9 4.7-11.5H96v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7L39.6 472.4l27.3-92.8zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17zM331.3 202.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"]
  },
  sl = {
    prefix: "fal",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  ll = {
    prefix: "fal",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M480 64H32v64H64 448h32V64zm0 96H448 64 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zM160 240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm288-48h32V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192H64V416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192z"]
  },
  fl = {
    prefix: "fal",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168.7 121.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V240c0 8.8 7.2 16 16 16s16-7.2 16-16V220.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2C344 109 315.5 80 280 80H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  ul = {
    prefix: "fal",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M512 64c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H496 80 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM480 448v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480zM464 128V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zM128 320V160H384V320H128zM96 152V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
  },
  dl = {
    prefix: "fal",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48.6C123.8 152.8 32 249.7 32 368v16H64V368c0-106 86-192 192-192s192 86 192 192v16h32V368c0-118.3-91.8-215.2-208-223.4V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 208zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  pl = {
    prefix: "fal",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M216 160c-13.3 0-24-10.7-24-24v-8V112 64L32 208 192 352l0-48V288v-8c0-13.3 10.7-24 24-24h8 96c70.7 0 128 57.3 128 128c0 8.3-.7 16.1-2 23.2c18.2-23.4 34-57.1 34-103.2c0-79.5-64.5-144-144-144H224h-8zm8 144v16 32c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2V96v16 16h32 80c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H256 224v16z"]
  },
  ml = {
    prefix: "fal",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M491.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66 66C363.4 52.6 312.1 32 256 32C132.3 32 32 132.3 32 256c0 56.1 20.6 107.4 54.7 146.7l-66 66c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l66-66C148.6 459.4 199.9 480 256 480c123.7 0 224-100.3 224-224c0-56.1-20.6-107.4-54.7-146.7l66-66zM380 109.4L109.4 380C81.1 346.5 64 303.3 64 256C64 150 150 64 256 64c47.3 0 90.5 17.1 124 45.4zM132 402.6L402.6 132c28.3 33.5 45.4 76.7 45.4 124c0 106-86 192-192 192c-47.3 0-90.5-17.1-124-45.4z"]
  },
  hl = {
    prefix: "fal",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z"]
  },
  vl = {
    prefix: "fal",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M128 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM0 280c0 43.3 26.4 80.4 64 96v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H96V208.4c2.6-.3 5.3-.4 8-.4h48c9.3 0 18.1 1.7 26.2 4.9c8.2 3.2 17.5-.9 20.7-9.1s-.9-17.5-9.1-20.7c-11.7-4.6-24.5-7.1-37.8-7.1H104C46.6 176 0 222.6 0 280zm64 59.9C44.7 327 32 304.9 32 280c0-25 12.7-47 32-59.9V339.9zM512 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM640 280c0-57.4-46.6-104-104-104H488c-13.3 0-26.1 2.5-37.8 7.1c-8.2 3.2-12.3 12.5-9.1 20.7s12.5 12.3 20.7 9.1c8.1-3.2 16.9-4.9 26.2-4.9h48c2.7 0 5.4 .1 8 .4V416H480V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V376c37.6-15.7 64-52.7 64-96zm-64 59.9V220.1C595.3 233 608 255 608 280c0 24.9-12.7 47-32 59.9zM288 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zm-80 96c-57.4 0-104 46.6-104 104c0 40.1 22.7 74.9 56 92.3V456c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V388.3c33.3-17.3 56-52.1 56-92.3c0-57.4-46.6-104-104-104H304zm-48 50.3V349.7c-14.7-13.2-24-32.4-24-53.7c0-21.3 9.3-40.5 24-53.7zM288 448V225.8c5.1-1.2 10.5-1.8 16-1.8h32c5.5 0 10.9 .6 16 1.8V448H288zm96-98.3V242.3c14.7 13.2 24 32.3 24 53.7c0 21.3-9.3 40.5-24 53.7z"]
  },
  gl = {
    prefix: "fal",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  bl = {
    prefix: "fal",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M320 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304 272 256c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64zM256 192h16v48H112c-26.5 0-48 21.5-48 48v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H96V288c0-8.8 7.2-16 16-16H272v48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H304V272H464c8.8 0 16 7.2 16 16v32H464c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288c0-26.5-21.5-48-48-48H304V192h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48zM48 352h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z"]
  },
  Hl = {
    prefix: "fal",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M349.4 93.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C192 262.5 248.2 320 320 320c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zM327.5 37.1c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM285.1 96c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 0 0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C361.3 282 342.3 288 321 288c-25.9 0-50.2-8.4-68.2-24.8C234.7 246.6 224 222.7 224 194c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L347 191l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C285.7 249.9 301.9 256 321 256c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5zM32 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v96H576V288H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16V386.7c18.6 6.6 32 24.4 32 45.3v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V432c0-20.9 13.4-38.7 32-45.3V272zm0 160v32c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm160-8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  zl = {
    prefix: "fal",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM144 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
  },
  yl = {
    prefix: "fal",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M48 112V80H80v32H48zM16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40C26.7 48 16 58.7 16 72zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM48 240H80v32H48V240zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40zm8 224V400H80v32H48zM16 392v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24z"]
  },
  Vl = {
    prefix: "fal",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96zM32 272V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48z"]
  },
  xl = {
    prefix: "fal",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M240 0c-8.8 0-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C307.7 128.4 320 151.4 320 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L288.8 77.3C268.3 63.6 256 40.6 256 16c0-8.8-7.2-16-16-16zM32 336V320 288H272c.5 0 1 0 1.6-.1c1.3 0 2.5 .1 3.8 .1H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm170.7-80H32c0-35.3 28.7-64 64-64c13.8 0 27.3 4.5 38.4 12.8L202.7 256zM0 272v48 16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v16zM384 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C435.7 128.4 448 151.4 448 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L416.8 77.3C396.3 63.6 384 40.6 384 16zM112 336c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zM32 64a32 32 0 1 1 64 0A32 32 0 1 1 32 64zm96 0A64 64 0 1 0 0 64a64 64 0 1 0 128 0z"]
  },
  Ml = {
    prefix: "fal",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M32 128V312.4C49 297.2 71.4 288 96 288H392c8.6 0 16.7 1.9 24 5.4V128c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zM0 384V128C0 75 43 32 96 32H352c53 0 96 43 96 96V344c0 30.9-25.1 56-56 56H96c-8.8 0-16-7.2-16-16s7.2-16 16-16H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H96c-35.3 0-64 28.7-64 64s28.7 64 64 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-53 0-96-43-96-96z"]
  },
  _l = {
    prefix: "fal",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"]
  },
  wl = {
    prefix: "fal",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"]
  },
  El = {
    prefix: "fal",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C89.3 128 32 185.3 32 256s57.3 128 128 128h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c70.7 0 128-57.3 128-128s-57.3-128-128-128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c88.4 0 160 71.6 160 160zM152 240H424c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Cl = {
    prefix: "fal",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M480 96c0 35.3 28.7 64 64 64V128c0-17.7-14.3-32-32-32H480zm-32 0H128c0 53-43 96-96 96V320c53 0 96 43 96 96H448c0-53 43-96 96-96V192c-53 0-96-43-96-96zM32 384c0 17.7 14.3 32 32 32H96c0-35.3-28.7-64-64-64v32zm512-32c-35.3 0-64 28.7-64 64h32c17.7 0 32-14.3 32-32V352zM64 96c-17.7 0-32 14.3-32 32v32c35.3 0 64-28.7 64-64H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
  },
  Ll = {
    prefix: "fal",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 192c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  Nl = {
    prefix: "fal",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M240 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 256c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-96h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-48 16V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
  },
  Sl = {
    prefix: "fal",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 32h80c35.3 0 64-28.7 64-64s-28.7-64-64-64H208V288zm80 32H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"]
  },
  kl = {
    prefix: "fal",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM400 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H560L421 228.4c-4.7 4.5-6.3 11.5-3.8 17.5s8.3 10.1 14.9 10.1h96c44.2 0 80 35.8 80 80s-35.8 80-80 80H455.4c-19.6 0-36.2-14.1-39.5-33.4l-.2-1.2c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l.2 1.2c5.8 34.7 35.8 60.2 71 60.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H472L611 91.6c4.7-4.5 6.3-11.5 3.8-17.5S606.5 64 600 64H400z"]
  },
  Pl = {
    prefix: "fal",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M32 184c35.3 0 64-28.7 64-64v-.5c-18.5-1.4-37.1-4.4-55.8-9.5c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2l0 0 0 0 0 0s0 0 0 0l0 .1V184zm0 192v46.3c0 6.8 3.7 10.4 6.2 11.3C57.3 440.8 76.5 445 96 446.8V440c0-35.3-28.7-64-64-64zm0-32c53 0 96 43 96 96v8c44.7-1 91.1-11.7 141.3-24.5c4.3-1.1 8.6-2.2 13-3.3c51.8-13.3 108-27.6 165.7-28.6c.2-52.8 43.1-95.6 96-95.6V168c-53 0-96-43-96-96V64c-44.7 1-91.1 11.7-141.3 24.5c-4.3 1.1-8.6 2.2-13 3.3c-51.8 13.3-108 27.6-165.7 28.6c-.2 52.8-43.1 95.6-96 95.6V344zm503.8 58c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0s0 0 0-.1V328c-35.3 0-64 28.7-64 64v.5c18.5 1.4 37.1 4.4 55.8 9.5zM480 72c0 35.3 28.7 64 64 64V89.7c0-6.8-3.7-10.4-6.2-11.3C518.7 71.2 499.5 67 480 65.2V72zM0 422.3V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z"]
  },
  Tl = {
    prefix: "fal",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M402.7 425.3l-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224c56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256C480 132.3 379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  Ol = {
    prefix: "fal",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M226.5 168.8L287.9 42.3l61.4 126.5c4.6 9.5 13.6 16.1 24.1 17.7l137.4 20.3-99.8 98.8c-7.4 7.3-10.8 17.8-9 28.1l23.5 139.5L303 407.7c-9.4-5-20.7-5-30.2 0L150.2 473.2l23.5-139.5c1.7-10.3-1.6-20.7-9-28.1L65 206.8l137.4-20.3c10.5-1.5 19.5-8.2 24.1-17.7zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"]
  },
  Al = {
    prefix: "fal",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm144 99.6v13.6c8.3 1.1 16.3 2.7 23.7 4.5c8.6 2 13.9 10.7 11.9 19.3s-10.7 13.9-19.3 11.9c-11.2-2.6-22.2-4.6-32.5-4.8c-8.7-.1-17.9 1.7-24.3 5.1c-6.1 3.2-7.4 6.3-7.4 9.4c0 1.5 .2 3.6 6.6 7c7 3.7 16.8 6.4 29.4 9.8l.5 .1c11.3 3 25.2 6.8 36.1 12.9c11.8 6.6 23.1 17.7 23.4 35.9c.3 18.9-10.6 31.7-23.6 38.9c-7.5 4.1-15.9 6.6-24.4 7.9v13.5c0 8.8-7.2 16-16 16s-16-7.2-16-16V414.4c-10.9-1.9-21.2-5-30.3-7.8l0 0 0 0c-2.1-.7-4.2-1.3-6.2-1.9c-8.5-2.5-13.3-11.4-10.8-19.9s11.4-13.3 19.9-10.8c2.4 .7 4.8 1.4 7.1 2.1c13.6 4.1 24.8 7.5 36.8 7.9c9.4 .3 18.5-1.6 24.4-4.9c5.4-3 7.2-6.2 7.1-10.4c0-2.4-.8-4.9-7-8.4c-6.9-3.9-16.8-6.7-29.2-10l-1.6-.4c-11-3-24.2-6.5-34.6-12.1c-11.5-6.2-23.3-16.9-23.4-35.1c-.1-19 11.9-31.3 24.5-37.9c7.3-3.8 15.4-6.2 23.4-7.5V243.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  Dl = {
    prefix: "fal",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M352 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5L41.2 295.8l63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3L177 432.1c9.3-4.9 20.5-4.9 29.8 0L285 473.3l-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM448 160c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176c0-8.8 7.2-16 16-16z"]
  },
  Il = {
    prefix: "fal",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M447.7 83L411.4 272H608V80c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H392c-4.8 0-9.3-2.1-12.3-5.8s-4.3-8.5-3.4-13.2l40-208c1.7-8.7 10.1-14.4 18.7-12.7s14.4 10.1 12.7 18.7zM16 64c8.8 0 16 7.2 16 16V240H288V80c0-8.8 7.2-16 16-16s16 7.2 16 16V256 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H32V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V256 80c0-8.8 7.2-16 16-16z"]
  },
  jl = {
    prefix: "fal",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M27.3 184.4C102.4 110 205.8 64 320 64s217.6 46 292.7 120.4c6.3 6.2 16.4 6.2 22.6-.1s6.2-16.4-.1-22.6C554.3 81.5 442.9 32 320 32S85.7 81.5 4.7 161.7c-6.3 6.2-6.3 16.3-.1 22.6s16.3 6.3 22.6 .1zM320 224c70.5 0 134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0C185.6 252.5 249.5 224 320 224zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  Fl = {
    prefix: "fal",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M93.3 32C77.1 32 64 45.1 64 61.3V256H448h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 64 32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V61.3C32 27.4 59.4 0 93.3 0c16.2 0 31.8 6.5 43.3 17.9L161.7 43c11.1-7 24.2-11 38.3-11c20.2 0 38.5 8.3 51.6 21.8l1.1-1.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-104 104c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3L113.9 40.6C108.5 35.1 101 32 93.3 32zM32 320H64v48c0 26.2 12.6 49.4 32 64h0v0c13.4 10 30 16 48 16H368c18 0 34.6-6 48-16v0h0c19.4-14.6 32-37.8 32-64V320h32v48c0 30.5-12.2 58.2-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V446.4C44.2 426.2 32 398.5 32 368V320zM200 64c-22.1 0-40 17.9-40 40c0 11.4 4.8 21.7 12.4 29L229 76.4C221.7 68.8 211.4 64 200 64z"]
  },
  Rl = {
    prefix: "fal",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M0 48c0-8.8 7.2-16 16-16H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H96V224c0 70.7 57.3 128 128 128s128-57.3 128-128V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V64H16C7.2 64 0 56.8 0 48zM0 464c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
  },
  Bl = {
    prefix: "fal",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 48c0-8.8 7.2-16 16-16H48 80 232c66.3 0 120 53.7 120 120c0 38.8-18.4 73.3-46.9 95.2C351.1 264 384 308.1 384 360c0 66.3-53.7 120-120 120H80 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V256 64H16C7.2 64 0 56.8 0 48zM64 448H80 264c48.6 0 88-39.4 88-88s-39.4-88-88-88H232 64V448zm0-208H232c48.6 0 88-39.4 88-88s-39.4-88-88-88H80 64V240z"]
  },
  Gl = {
    prefix: "fal",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Yl = {
    prefix: "fal",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
  },
  Wl = {
    prefix: "fal",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M64 64C46.3 64 32 78.3 32 96V329.4l67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4V96c0-17.7-14.3-32-32-32H64zM32 374.6V416c0 17.7 14.3 32 32 32h41.4l96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448H448c17.7 0 32-14.3 32-32V310.6l-90.3-90.3zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
  },
  ql = {
    prefix: "fal",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M94.7 360.2c-3.2-5-8.7-8.2-14.7-8.2c-12.3 0-20.3 12.8-13.7 23.2C106 438.2 176.1 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7L78.6 56c-5.1-5.1-12.1-8-19.3-8C44.2 48 32 60.2 32 75.3V176c0 8.8 7.2 16 16 16H148.7c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-36-36C165.5 81.1 208.7 64 256 64c106 0 192 86 192 192s-86 192-192 192c-67.6 0-127.1-35-161.3-87.8zM64 86.6L137.4 160H64V86.6z"]
  },
  Ul = {
    prefix: "fal",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM528 336c8.8 0 16-7.2 16-16s-7.2-16-16-16H484.1l40.5 32H528zm0-128c8.8 0 16-7.2 16-16s-7.2-16-16-16H322l40.5 32H528zm-372.1 0l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h43.9zM528 48H159.8l40.5 32H528c8.8 0 16-7.2 16-16s-7.2-16-16-16zM318 336l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H318zm121.6 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H480.2l-40.5-32z"]
  },
  $l = {
    prefix: "fal",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
  },
  Xl = $l,
  Zl = {
    prefix: "fal",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M170.7 108.3c7.5-4.3 12.9-11.5 15-19.8l12.3-48.6 35 36c6 6.2 14.3 9.7 22.9 9.7s16.9-3.5 22.9-9.7l35-36 12.3 48.6c2.1 8.4 7.5 15.5 15 19.8s16.4 5.4 24.7 3.1l48.3-13.6L400.6 146c-2.3 8.3-1.2 17.2 3.1 24.7s11.5 12.9 19.8 15l48.6 12.3-36 35c-6.2 6-9.7 14.3-9.7 22.9s3.5 16.9 9.7 22.9l36 35-48.6 12.3c-8.4 2.1-15.5 7.5-19.8 15s-5.4 16.4-3.1 24.7l13.6 48.3L366 400.6c-8.3-2.3-17.2-1.2-24.7 3.1s-12.9 11.5-15 19.8l-12.3 48.6-35-36c-6-6.2-14.3-9.7-22.9-9.7s-16.9 3.5-22.9 9.7l-35 36-12.3-48.6c-2.1-8.4-7.5-15.5-15-19.8s-16.4-5.4-24.7-3.1L97.8 414.2 111.4 366c2.3-8.3 1.2-17.2-3.1-24.7s-11.5-12.9-19.8-15L39.8 313.9l36-35c6.2-6 9.7-14.3 9.7-22.9s-3.5-16.9-9.7-22.9l-36-35 48.6-12.3c8.4-2.1 15.5-7.5 19.8-15s5.4-16.4 3.1-24.7L97.8 97.8 146 111.4c8.3 2.3 17.2 1.2 24.7-3.1zM49.6 162.6l-31.5 8c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l23.3 22.6L53.5 256 30.5 278.3 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l31.5 8 31 7.9-8.7 30.8-8.8 31.2c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l31.2-8.8 30.8-8.7 7.9 31 8 31.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l22.6-23.3L256 458.5l22.3 22.9L301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l8-31.5 7.9-31 30.8 8.7 31.2 8.8c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-8.8-31.2-8.7-30.8 31-7.9 31.5-8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-23.3-22.6L458.5 256l22.9-22.3L504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-31.5-8-31-7.9 8.7-30.8 8.8-31.2c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-31.2 8.8-30.8 8.7-7.9-31-8-31.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L278.3 30.5 256 53.5 233.7 30.5 211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-8 31.5-7.9 31-30.8-8.7L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l8.8 31.2 8.7 30.8-31 7.9z"]
  },
  Kl = {
    prefix: "fal",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM390.4 64l149.1 0-11 44.1c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l11-44.1c5-20.2-10.2-39.8-31-39.8h-383c-4.7 0-9.2 1-13.3 2.9L180.1 64l177.1 0L325.1 178.5 352.3 200 390.4 64zM287.7 312L249.6 448H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H282.9l32.1-114.5L287.7 312z"]
  },
  Ql = {
    prefix: "fal",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm39.2 235.1c-2.7-8.4-11.7-13.1-20.1-10.4s-13.1 11.7-10.4 20.1l56 176c2.2 6.8 8.5 11.3 15.6 11.1s13.2-4.9 15.1-11.8L192 300.8l32.6 119.4c1.9 6.8 8 11.6 15.1 11.8s13.4-4.4 15.6-11.1l56-176c2.7-8.4-2-17.4-10.4-20.1s-17.4 2-20.1 10.4L241.2 359.5 207.4 235.8c-1.9-7-8.2-11.8-15.4-11.8s-13.5 4.8-15.4 11.8L142.8 359.5 103.2 235.1z"]
  },
  Jl = {
    prefix: "fal",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"]
  },
  ef = {
    prefix: "fal",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 48c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H283L135.3 448H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85L248.7 64H144c-8.8 0-16-7.2-16-16z"]
  },
  tf = {
    prefix: "fal",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  nf = {
    prefix: "fal",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M34.2 179.7L154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1H280.9c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3L132.4 469.1c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9L307.7 355.6c7.8-7.4 12.3-17.7 12.3-28.5c0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"]
  },
  cf = {
    prefix: "fal",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M32 48c0 8.8 7.2 16 16 16H64V192H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM58.7 323.9c11.1-11.1 29.2-10.5 39.6 1.3c9.2 10.5 8.9 26.2-.6 36.3L12.3 453.1c-4.3 4.7-5.5 11.5-3 17.3s8.3 9.6 14.7 9.6H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.8l60.3-64.6c20.7-22.2 21.2-56.4 1.3-79.3c-22.5-25.7-62.1-27.1-86.3-2.9L20.7 316.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l15.4-15.4z"]
  },
  rf = {
    prefix: "fal",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 224c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm112-80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-80c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM448 80V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  af = {
    prefix: "fal",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M252.9 33.4L196 96H316L259.1 33.4c-.8-.9-1.9-1.4-3.1-1.4s-2.3 .5-3.1 1.4zm29.8-21.5l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8H272V240H384v32H272V384h51.2c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8H240V272H128l0 51.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 51.2H240V128l-51.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM316 416H196l56.9 62.6c.8 .9 1.9 1.4 3.1 1.4s2.3-.5 3.1-1.4L316 416zM478.6 259.1c.9-.8 1.4-1.9 1.4-3.1s-.5-2.3-1.4-3.1L416 196V316l62.6-56.9zm-46.4 85.4c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM33.4 252.9c-.9 .8-1.4 1.9-1.4 3.1s.5 2.3 1.4 3.1L96 316 96 196 33.4 252.9z"]
  },
  of = {
    prefix: "fal",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M234.4 186.5L97 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L182.2 473.2 304 408.1V75.1l-45.5 93.7c-4.6 9.5-13.6 16.1-24.1 17.7zM336 408.2l121.6 65L434.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L405.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L336 75.4V408.2zm146.2 99.2c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L298.3 13.5C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z"]
  },
  sf = {
    prefix: "fal",
    iconName: "code",
    icon: [640, 512, [], "f121", "M405.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1l-160 480c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l160-480c2.8-8.4-1.7-17.4-10.1-20.2zM172 117.4c-5.9-6.6-16-7.2-22.6-1.3l-144 128C2 247.1 0 251.4 0 256s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L40.1 256 170.6 140c6.6-5.9 7.2-16 1.3-22.6zm296.1 0c-5.9 6.6-5.3 16.7 1.3 22.6L599.9 256 469.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128c-6.6-5.9-16.7-5.3-22.6 1.3z"]
  },
  lf = {
    prefix: "fal",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V176 431.7 496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.7H240 544V496c0 8.8 7.2 16 16 16s16-7.2 16-16V431.7 272 176 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32V160H32V16zM224 288V415.7H32V192H240 544v64H256c-17.7 0-32 14.3-32 32zM544 112v48H256V32H464c44.2 0 80 35.8 80 80zM256 288l288 0V415.7H256V288zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  ff = {
    prefix: "fal",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M32 30.9C32 13.8 45.9 0 62.9 0H226.2C242.7 0 256 13.3 256 29.8c0 3.2-.5 6.4-1.5 9.4L214.2 160H355.8c15.6 0 28.2 12.6 28.2 28.2c0 5.7-1.7 11.2-4.9 15.9l-203.2 297c-4.6 6.8-12.3 10.8-20.5 10.8c-16.2 0-28-15.2-24.1-30.9L179.5 288H30.9C13.9 288 0 274.1 0 257.1c0-1.5 .1-2.9 .3-4.4L32 30.9zM64 32c0 1.1-.1 2.2-.3 3.3L32.2 256H200c4.9 0 9.6 2.3 12.6 6.2s4.1 8.9 2.9 13.7L171.9 450.2 348.6 192H192c-5.1 0-10-2.5-13-6.6s-3.8-9.5-2.2-14.4L223.1 32H64z"]
  },
  uf = {
    prefix: "fal",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm85.1 246.8c-5.1-7.2-15-9-22.3-3.9s-9 15-3.9 22.3L172.5 336l-49.6 70.8c-5.1 7.2-3.3 17.2 3.9 22.3s17.2 3.3 22.3-3.9L192 363.9l42.9 61.3c5.1 7.2 15 9 22.3 3.9s9-15 3.9-22.3L211.5 336l49.6-70.8c5.1-7.2 3.3-17.2-3.9-22.3s-17.2-3.3-22.3 3.9L192 308.1l-42.9-61.3z"]
  },
  df = {
    prefix: "fal",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
  },
  pf = {
    prefix: "fal",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm143.1-96c-8 72-69 128-143.1 128C64.5 288 0 223.5 0 144S64.5 0 144 0c74.1 0 135.2 56 143.1 128h67.6c6.6-18.6 24.4-32 45.3-32h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H400c-20.9 0-38.7-13.4-45.3-32H287.1zM272 320h16 32V288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V352H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 0h96V288H352v32zm-32 32V464c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V352H320zM496 128H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zM192 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 144a80 80 0 1 1 160 0A80 80 0 1 1 64 144zM0 496c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM160 352v32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm0-32h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16h80 16 16zm-32 64V352H64v64h64V384z"]
  },
  mf = {
    prefix: "fal",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm160 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V312z"]
  },
  hf = {
    prefix: "fal",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M352 128c0-53 43-96 96-96s96 43 96 96v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128zm-16 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48H336z"]
  },
  vf = {
    prefix: "fal",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
  },
  gf = {
    prefix: "fal",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M160 208l0-57.3c0-3.7-3-6.7-6.7-6.7c-1.9 0-3.7 .8-5 2.2L35.8 272 148.3 397.8c1.3 1.4 3.1 2.2 5 2.2c3.7 0 6.7-3 6.7-6.7l0-57.3c0-17.7 14.3-32 32-32l176 0c61.9 0 112-50.1 112-112l0-112c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 112c0 26.5-21.5 48-48 48l-176 0c-17.7 0-32-14.3-32-32zM5.3 286C1.9 282.1 0 277.2 0 272s1.9-10.1 5.3-14L124.5 124.9c7.3-8.2 17.8-12.9 28.8-12.9c21.4 0 38.7 17.3 38.7 38.7l0 25.3 0 32 32 0 144 0c8.8 0 16-7.2 16-16l0-112c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 112c0 79.5-64.5 144-144 144l-144 0-32 0 0 32 0 25.3c0 21.4-17.3 38.7-38.7 38.7c-11 0-21.5-4.7-28.8-12.9L5.3 286z"]
  },
  bf = {
    prefix: "fal",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8H280c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H222.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  Hf = {
    prefix: "fal",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
  },
  zf = {
    prefix: "fal",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
  },
  yf = {
    prefix: "fal",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c8.8 0 16 7.2 16 16v96c0 38.1 12.4 75.1 35.2 105.6l19.2 25.6c27 36 41.6 79.8 41.6 124.8v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-38.1-12.4-75.1-35.2-105.6l-19.2-25.6C174.6 232.8 160 189 160 144V48c0-8.8 7.2-16 16-16zM16 96c8.8 0 16 7.2 16 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6L34.9 273.2C12.2 239.1 0 198.9 0 157.9V112c0-8.8 7.2-16 16-16zm336 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3C332.2 239.1 320 198.9 320 157.9V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  Vf = {
    prefix: "fal",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V65.8c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM96 64H288v96H96V64zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
  },
  xf = {
    prefix: "fal",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z"]
  },
  Mf = {
    prefix: "fal",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M80 64c-26.5 0-48 21.5-48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V112C0 67.8 35.8 32 80 32h42.4H128 453.6C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L98.3 69.1c-.7-1.6-1.3-3.4-1.7-5.1H80zm365 0H131l49.8 112H395.2L445 64zM416 208H160l0 0c-26.4 19.9-46.5 47.7-56.7 80H472.7c-10.1-32.3-30.2-60.1-56.7-80l0 0zm63.2 112H96.8c-.5 5.3-.8 10.6-.8 16v8c0 42.6 27.2 78.8 46.8 98.8c2.7 2.8 7.7 5.2 15.2 5.2H418c7.5 0 12.5-2.4 15.2-5.2c19.6-20 46.8-56.2 46.8-98.8v-8c0-5.4-.3-10.7-.8-16z"]
  },
  _f = {
    prefix: "fal",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6z"]
  },
  wf = {
    prefix: "fal",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z"]
  },
  Ef = {
    prefix: "fal",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  Cf = {
    prefix: "fal",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 288v24 48 24H96V288H208zm32 96v-.4l58.1 23.2c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V280c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L240 288.4V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H208c17.7 0 32-14.3 32-32zm48-15.6l-48-19.2V322.8l48-19.2v64.7z"]
  },
  Lf = {
    prefix: "fal",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M320 33c0-18.2 14.8-33 33-33H480c17.7 0 32 14.3 32 32V159c0 18.2-14.8 33-33 33c-8.7 0-17.1-3.5-23.3-9.7L404 130.6 235.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L381.4 108 329.7 56.3C323.5 50.1 320 41.7 320 33zm33-1c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L478.3 159.7c.2 .2 .4 .3 .7 .3c.5 0 1-.4 1-1V32H353zM0 96C0 60.7 28.7 32 64 32H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64C46.3 64 32 78.3 32 96V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V304c0-8.8 7.2-16 16-16s16 7.2 16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
  },
  Nf = {
    prefix: "fal",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
  },
  Sf = {
    prefix: "fal",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 352H424c14.7 0 27.5 10 31 24.2l3.6 14.3c8.4 33.8 38.8 57.4 73.6 57.4c41.9 0 75.8-33.9 75.8-75.8v-2.8c0-4.5-.4-8.9-1.1-13.3L574.1 165.3c-7-40.7-32.2-71.3-66.5-79.9C464.1 74.5 401.1 64 320 64s-144.1 10.5-187.6 21.4C98 93.9 72.8 124.5 65.9 165.3L33.1 356.1c-.8 4.4-1.1 8.8-1.1 13.3v2.8c0 41.9 33.9 75.8 75.8 75.8c34.8 0 65.1-23.7 73.6-57.4l3.6-14.3c3.6-14.2 16.4-24.2 31-24.2zm211.6 46.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM208 160v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  kf = {
    prefix: "fal",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H496c61.9 0 112 50.1 112 112v8c0 22.1-17.9 40-40 40H549.6L628 254.7c7.6 6.1 12 15.3 12 25V384c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H400 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2L18.7 329.4C6.7 317.4 0 301.1 0 284.1V96C0 60.7 28.7 32 64 32H224V24zM64 64C46.3 64 32 78.3 32 96V284.1c0 8.5 3.4 16.6 9.4 22.6l73.6 73.6C129.6 363 151.5 352 176 352c26.2 0 49.4 12.6 64 32H384V176c0-8.8 7.2-16 16-16H568c4.4 0 8-3.6 8-8v-8c0-44.2-35.8-80-80-80H384 352V32H256V64H224 64zM176 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-64 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h48V288H416v96h16zM416 192v64H578.4l-80-64H416zM128 224H288V160H128v64zM96 152c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V152z"]
  },
  Pf = {
    prefix: "fal",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM325.7 351c-7 .7-14.3 1-21.7 1c-41.8 0-72.9-20.8-95.7-36l-2.1-1.4c-25-16.7-41.3-26.6-62.2-26.6c-9.8 0-20.6 1.6-31.4 4c-.4 3.9-.6 7.9-.6 12c0 61.9 50.1 112 112 112c45.1 0 84-26.6 101.7-65zm9.5-33.4c.5-4.4 .8-8.9 .8-13.5c0-61.9-50.1-112-112-112c-45.3 0-84.4 27-102 65.7c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304z"]
  },
  Tf = {
    prefix: "fal",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 96c-17.7 0-32 14.3-32 32v39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
  },
  Of = {
    prefix: "fal",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M380.7 67.3c-29.1-29.1-76.3-29.1-105.4 0l-192 192c-46.8 46.8-46.8 122.6 0 169.4s122.6 46.8 169.4 0l152-152c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-152 152c-59.3 59.3-155.4 59.3-214.6 0S1.4 296 60.7 236.7l192-192c41.6-41.6 109-41.6 150.6 0s41.6 109 0 150.6L219.5 379.1c-28.2 28.2-74.6 25.6-99.6-5.5c-21.3-26.6-19.2-65 4.9-89.1L276.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L147.5 307.1c-12.6 12.6-13.7 32.6-2.6 46.5c13 16.2 37.2 17.6 51.9 2.9L380.7 172.7c29.1-29.1 29.1-76.3 0-105.4z"]
  },
  Af = {
    prefix: "fal",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM505.4 67.1c-7.1-5.2-17.2-3.6-22.4 3.5L383.3 207.8C363 235.7 352 269.4 352 304c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-15 0-29.6 2.3-43.2 6.6l56.1-77.2c5.2-7.1 3.6-17.2-3.5-22.4zM496 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
  },
  Df = {
    prefix: "fal",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  If = {
    prefix: "fal",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm80 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  jf = {
    prefix: "fal",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"]
  },
  Ff = {
    prefix: "fal",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.1-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]
  },
  Rf = {
    prefix: "fal",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M384 32c17.7 0 32 14.3 32 32V320H32V64c0-17.7 14.3-32 32-32H384zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352H416zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
  },
  Bf = {
    prefix: "fal",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c44.2 0 80-35.8 80-80l0-377.4L308.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6 176 432c0 26.5-21.5 48-48 48L16 480z"]
  },
  Gf = {
    prefix: "fal",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
  },
  Yf = {
    prefix: "fal",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M288 32c17.7 0 32 14.3 32 32V320H64V64c0-17.7 14.3-32 32-32H288zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352H320zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm48 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16z"]
  },
  Wf = {
    prefix: "fal",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"]
  },
  qf = {
    prefix: "fal",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"]
  },
  Uf = {
    prefix: "fal",
    iconName: "download",
    icon: [512, 512, [], "f019", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V16zM140.1 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H371.9l-32 32H448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H172.1l-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  $f = {
    prefix: "fal",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M96 32C60.7 32 32 60.7 32 96v64H416V96c0-35.3-28.7-64-64-64H96zM32 192V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192H32zM0 96C0 43 43 0 96 0H352c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM264 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 256V416H352V256H96zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 48c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z"]
  },
  Xf = {
    prefix: "fal",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM96 320c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  Zf = {
    prefix: "fal",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48zm144 48V320h96V480H240z"]
  },
  Kf = {
    prefix: "fal",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3V176c0 8.8-7.2 16-16 16H363.3c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160H448V86.6z"]
  },
  Qf = {
    prefix: "fal",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M42.6 .2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9V176c0 26.5 21.5 48 48 48h32 32c26.5 0 48-21.5 48-48V165.3c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2V176c0 44.2-35.8 80-80 80H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H80c-44.2 0-80-35.8-80-80V165.3c0-4.4 .4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6 .2zM88.8 0c8.8 .4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0C144-.4 151.5 6.4 152 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4 .5 135.2 0zM320 176V288c0 17.7 14.3 32 32 32h64V32.2l-.2 .1c-1.7 .4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32V320v16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H352c-35.3 0-64-28.7-64-64V176C288 32 400 0 416 0z"]
  },
  Jf = {
    prefix: "fal",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M16 80C7.2 80 0 87.2 0 96s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM128 416c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16V432z"]
  },
  eu = {
    prefix: "fal",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M272 54.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H304V320H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H208v32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  tu = {
    prefix: "fal",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"]
  },
  nu = {
    prefix: "fal",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M0 16C0 7.2 7.2 0 16 0H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM64 196.8c5-1.6 10.2-3.2 15.4-4.6C121 181.2 174.5 176 224 176s103 5.2 144.6 16.3c5.3 1.4 10.4 2.9 15.4 4.6V64h32V210.6c2.1 1.2 4.2 2.5 6.1 3.8c13.9 9.4 25.9 23 25.9 41.6c0 69.8-35.8 118.1-81 148.5l15.2 51c1.2 4.1 1.8 8.3 1.8 12.5c0 24.3-19.7 43.9-43.9 43.9H107.9C83.7 512 64 492.3 64 468.1c0-4.2 .6-8.5 1.8-12.5l15.2-51C35.8 374.1 0 325.8 0 256c0-18.5 12-32.2 25.9-41.6c1.9-1.3 4-2.6 6.1-3.8V64H64V196.8zM40.3 305.7c11.3 31.6 33.2 55.4 59.7 72.9C139.4 404.7 188.2 416 224 416s84.6-11.3 124.1-37.3c26.5-17.5 48.4-41.3 59.7-72.9c-11.5 5.6-24.9 10.2-39.2 14C327 330.8 273.5 336 224 336s-103-5.2-144.6-16.3c-14.3-3.8-27.6-8.4-39.2-14zM416 256c0-3.1-1.8-8.3-11.8-15c-9.8-6.6-24.7-12.7-43.9-17.8C322.2 213.1 271.7 208 224 208s-98.2 5.1-136.3 15.2c-19.2 5.1-34.1 11.2-43.9 17.8C33.8 247.7 32 252.9 32 256s1.8 8.3 11.8 15c9.8 6.6 24.7 12.7 43.9 17.8C125.8 298.9 176.3 304 224 304s98.2-5.1 136.3-15.2c19.2-5.1 34.1-11.2 43.9-17.8c9.9-6.7 11.8-11.9 11.8-15zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM351.5 464.7l-13.1-43.8C299.6 439.7 257.3 448 224 448s-75.6-8.3-114.4-27.2L96.5 464.7c-.3 1.1-.5 2.3-.5 3.4c0 6.6 5.3 11.9 11.9 11.9H340.1c6.6 0 11.9-5.3 11.9-11.9c0-1.2-.2-2.3-.5-3.4z"]
  },
  cu = {
    prefix: "fal",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 32C46.3 32 32 46.3 32 64V192c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 64H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 288V432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-29.6 16.1-55.5 40-69.3c7.6-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48V288h32zm64 112V288h32V400c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.7-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8c23.9 13.8 40 39.7 40 69.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
  },
  iu = {
    prefix: "fal",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M288.8 430.3c3.5 12.8 16.7 20.3 29.5 16.8s20.3-16.7 16.8-29.5l-4.5-16.4c-5.5-20.2-13.9-39.3-24.7-56.9c-3.1-4.9-3.2-11.1-.4-16.2s8.2-8.2 14-8.2H448c17.7 0 32-14.3 32-32c0-11.3-5.9-21.3-14.8-27c-7.2-4.6-9.5-13.9-5.3-21.3c2.6-4.6 4.1-10 4.1-15.7c0-12.4-7-23.1-17.3-28.5c-4.2-2.2-7.3-6.1-8.3-10.8s.1-9.5 3-13.2c4.2-5.4 6.7-12.2 6.7-19.5c0-14.2-9.2-26.3-22.1-30.4c-7.8-2.5-12.4-10.6-10.7-18.6c.5-2.2 .7-4.5 .7-6.9c0-17.7-14.3-32-32-32H294.5c-15.8 0-31.2 4.7-44.4 13.4l-38.5 25.7c-9 6-16.6 13.7-22.4 22.6c-4.9 7.4-14.8 9.4-22.2 4.6s-9.4-14.8-4.6-22.2c8.1-12.3 18.7-23.1 31.4-31.6l38.5-25.7c18.4-12.3 40-18.8 62.1-18.8H384c35.3 0 64 28.7 64 64l0 .6c19.1 11.1 32 31.7 32 55.4c0 8.7-1.8 17.1-4.9 24.7C487.9 188.4 496 205.2 496 224c0 6.5-1 12.8-2.8 18.7C504.8 254.3 512 270.3 512 288c0 35.3-28.7 64-64 64H346.4c6.2 13.1 11.3 26.7 15.1 40.9l4.5 16.4c8.1 29.8-9.5 60.6-39.3 68.8s-60.6-9.5-68.8-39.3l-4.5-16.4c-8.9-32.6-29.6-60.8-58.2-79l-3.1-2 8.2-12.9-8.2 12.9c-11.8-7.5-21.7-17.1-29.5-28.2c-5.1-7.2-3.3-17.2 4-22.3s17.2-3.3 22.3 4c5.4 7.7 12.2 14.4 20.4 19.5l3.1 2c35.3 22.4 60.9 57.2 71.9 97.5l4.5 16.4zM32 352H96V128H32V352zM0 352V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  ru = {
    prefix: "fal",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-144-144c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l441.4 0L340.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l144-144z"]
  },
  au = {
    prefix: "fal",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
  },
  ou = {
    prefix: "fal",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M176 64H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 288H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H336zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V288c0-8.8 7.2-16 16-16z"]
  },
  su = {
    prefix: "fal",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M256 32c-35.3 0-64 28.7-64 64H320c0-35.3-28.7-64-64-64zM160 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zM36.7 100.7c6.2-6.2 16.4-6.2 22.6 0L138.6 180c17.2-12.6 38.4-20 61.4-20H312c22.9 0 44.2 7.4 61.4 20l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L396 202.6c12.6 17.2 20 38.4 20 61.4v8h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v16c0 30.2-8.4 58.4-22.9 82.5l82.2 82.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79-79C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-79 79c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l82.2-82.2C104.4 378.4 96 350.2 96 320V304H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96v-8c0-22.9 7.4-44.2 20-61.4L36.7 123.3c-6.2-6.2-6.2-16.4 0-22.6zM128 320c0 65.3 48.9 119.1 112 127V256c0-8.8 7.2-16 16-16s16 7.2 16 16V447c63.1-7.9 112-61.7 112-127V288 264c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v24 32z"]
  },
  lu = {
    prefix: "fal",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 64C46.3 64 32 78.3 32 96v32H544V96c0-17.7-14.3-32-32-32H64zM32 160v64H544V160H32zm0 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V256H32zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
  },
  fu = {
    prefix: "fal",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  uu = {
    prefix: "fal",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V336v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V416H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 336 240c0-61.9-50.1-112-112-112H304c-26.5 0-48 21.5-48 48V320H32V48zM608 384H32V352H272 608v32zm0-144v80H288V176c0-8.8 7.2-16 16-16H528c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z"]
  },
  du = {
    prefix: "fal",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"]
  },
  pu = {
    prefix: "fal",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
  },
  mu = {
    prefix: "fal",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
  },
  hu = {
    prefix: "fal",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M104 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm29.8 122.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 384.1 0 390.4 0 398.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 401.9 161.7 416 192 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 401.9 353.7 416 384 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 374 404.9 384 384 384s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 374 212.9 384 192 384s-41.7-9.9-58.2-21.2zM258.4 185L412.3 315.5c10.7-3.5 21.4-8.8 30.9-15.4l.2-.2-163-138.3C309.5 140.5 345.3 128 384 128h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-114.9 0-208 93.1-208 208v14.8c5.5 1.1 10.9 1.7 16 1.7c5.4 0 10.7-.5 16-1.6V304c0-46.8 18.3-89.4 48.1-121l2.3 2z"]
  },
  vu = {
    prefix: "fal",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M32 416V327.9c0-2.6 .3-5.2 1-7.8l0-.1H134.1l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7H326.1c12.1 0 23.2-6.8 28.6-17.7L377.9 320H479l0 .1c.6 2.5 1 5.1 1 7.8V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM471 288H377.9c-12.1 0-23.2 6.8-28.6 17.7L326.1 352H185.9l-23.2-46.3c-5.4-10.8-16.5-17.7-28.6-17.7H41L90.9 88.2C94.5 74 107.3 64 122 64H390c14.7 0 27.5 10 31 24.2L471 288zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
  },
  gu = {
    prefix: "fal",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M392 32H120c-13.3 0-24 10.7-24 24V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zM176 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  bu = {
    prefix: "fal",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160h64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384l0 400c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-400H288V464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112H192c-88.4 0-160-71.6-160-160zM256 320V64H192C121.3 64 64 121.3 64 192s57.3 128 128 128h64z"]
  },
  Hu = {
    prefix: "fal",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M112 0c-8.8 0-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16c0-8.8-7.2-16-16-16zM256 352H192c-88.4 0-160-71.6-160-160H416c0 88.4-71.6 160-160 160zM32 160c-17.7 0-32 14.3-32 32c0 80.5 49.5 149.4 119.7 177.9l-7.4 16.2c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48H335.9l17.6 38.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L328.3 369.9C398.5 341.4 448 272.5 448 192c0-17.7-14.3-32-32-32H32zM140.4 401.9l10.2-22.4c13.4 2.9 27.2 4.5 41.5 4.5h64c14.2 0 28.1-1.5 41.5-4.5L321.3 432H158c-3-11.7-9.2-22-17.6-30.1zM64 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16z"]
  },
  zu = {
    prefix: "fal",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"]
  },
  yu = {
    prefix: "fal",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"]
  },
  Vu = {
    prefix: "fal",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M26.5 4C21.8-.2 15.1-1.2 9.4 1.4S0 9.7 0 16V496c0 6.3 3.7 12 9.4 14.6s12.4 1.6 17.1-2.5l52.7-46.1 45.4 45.4c6.2 6.2 16.4 6.2 22.6 0L192 462.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0l45.4-45.4L357.5 508c4.7 4.1 11.4 5.1 17.1 2.5s9.4-8.3 9.4-14.6V16c0-6.3-3.7-12-9.4-14.6S362.2-.2 357.5 4L304.7 50.1 259.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L192 49.4 147.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L79.3 50.1 26.5 4zM32 460.7V51.3L69.5 84c6.3 5.5 15.9 5.2 21.8-.7L136 38.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0L248 38.6l44.7 44.7c6 6 15.5 6.3 21.8 .7L352 51.3V460.7L314.5 428c-6.3-5.5-15.9-5.2-21.8 .7L248 473.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0L136 473.4 91.3 428.7c-6-6-15.5-6.3-21.8-.7L32 460.7zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
  },
  xu = {
    prefix: "fal",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"]
  },
  Mu = {
    prefix: "fal",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 32C46.3 32 32 46.3 32 64V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  _u = {
    prefix: "fal",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  wu = {
    prefix: "fal",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
  },
  Eu = {
    prefix: "fal",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM288 400c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16z"]
  },
  Cu = {
    prefix: "fal",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H208V448c0 8.8 7.2 16 16 16s16-7.2 16-16V272H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64z"]
  },
  Lu = {
    prefix: "fal",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"]
  },
  Nu = {
    prefix: "fal",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zm400.1 41.5c19.2-16.5 43.7-25.5 69-25.5H507c47 0 85 38.1 85 85c0 23.1-9.4 45.2-26.1 61.2l-185 178.2c-4.7 4.5-6.2 11.5-3.7 17.5s8.3 10 14.8 10H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H431.7L588.1 265.3C611.1 243.3 624 212.8 624 181c0-64.6-52.4-117-117-117h-5.8c-33 0-64.8 11.8-89.9 33.2l-21.7 18.6c-6.7 5.8-7.5 15.9-1.7 22.6s15.8 7.5 22.6 1.7l21.7-18.6z"]
  },
  Su = {
    prefix: "fal",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8V440.4l128-51.2V71.6L32 122.8zm352 320V124.1L192 69.2V387.9l192 54.9zm32-2.4l128-51.2V71.6L416 122.8V440.4z"]
  },
  ku = {
    prefix: "fal",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  Pu = {
    prefix: "fal",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"]
  },
  Tu = {
    prefix: "fal",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"]
  },
  Ou = {
    prefix: "fal",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z"]
  },
  Au = {
    prefix: "fal",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M426.1 301.2C406.2 376.5 337.6 432 256 432c-51 0-96.9-21.7-129-56.3l41-41c5.1-5.1 8-12.1 8-19.3c0-15.1-12.2-27.3-27.3-27.3H48c-8.8 0-16 7.2-16 16V404.7C32 419.8 44.2 432 59.3 432c7.2 0 14.2-2.9 19.3-8l25.7-25.7C142.3 438.7 196.2 464 256 464c97.4 0 179.2-67 201.8-157.4c2.4-9.7-5.2-18.6-15.2-18.6c-7.8 0-14.5 5.6-16.5 13.2zM385 136.3l-41 41c-5.1 5.1-8 12.1-8 19.3c0 15.1 12.2 27.3 27.3 27.3H464c8.8 0 16-7.2 16-16V107.3C480 92.2 467.8 80 452.7 80c-7.2 0-14.2 2.9-19.3 8l-25.7 25.7C369.7 73.3 315.8 48 256 48C158.6 48 76.8 115 54.2 205.4c-2.4 9.7 5.2 18.6 15.2 18.6c7.8 0 14.5-5.6 16.5-13.2C105.8 135.5 174.4 80 256 80c51 0 96.9 21.7 129.1 56.3zM448 192H374.6L448 118.6V192zM64 320h73.4L64 393.4V320z"]
  },
  Du = {
    prefix: "fal",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"]
  },
  Iu = {
    prefix: "fal",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 235.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160zm352-160l-160 160c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 427.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
  },
  ju = {
    prefix: "fal",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352c0-88.4 71.6-160 160-160s160 71.6 160 160V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM576 128V480H512V352c0-106-86-192-192-192s-192 86-192 192V480H64V128H576zM32 32H608V96H32V32zM341.4 332.7c9.6-.1 18.7-4.5 24.7-12.1l1.7-2.1c8.7 10.6 16.4 22.6 22.5 34.5c9.6 18.5 14 35.5 14 42.7c0 46.3-37.6 84.3-84.4 84.3c-47.3 0-84.4-37.9-84.4-84.3c0-10.7 5.9-29.6 18.8-50.6c9.9-16.1 23.3-33.1 39.1-49.2c8 8 15.6 16.4 22.9 25.2c6.2 7.4 15.3 11.6 25 11.5zm77.3 5.6c-10.7-20.7-25.9-42.5-43.9-59c-3.2-2.9-7.8-3.6-11.6-1.9c-1.1 .5-2.1 1.1-2.9 1.9c-7 6.4-13.5 14.3-19.2 21.5c-7-8.4-14.2-16.4-21.7-24.1c-6-6.2-12.3-12.1-18.6-17.9c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4zM307 353.4c-3.1-3.9-7.8-6.2-12.7-6.1s-9.6 2.4-12.6 6.3c-4.7 6.2-8.6 11.8-11.8 17.2c-5.5 9.4-8.2 17.5-8.2 26.3c0 8.8 7.2 16 16 16s16-7.2 16-16c0-1 .1-2.8 1.8-6.4l18.8 24 0 0c5.9 7.5 14.9 12 24.5 12.2s18.8-3.9 25-11.2l9.6-11.2c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7l-9.6 11.2 0 0-21.5-27.4 0 0L307 353.4z"]
  },
  Fu = {
    prefix: "fal",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M32 132V48c0-8.8-7.2-16-16-16S0 39.2 0 48V176c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H53.6C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16V256c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4V144c0-8.8-7.2-16-16-16z"]
  },
  Ru = {
    prefix: "fal",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M207.6 51.6c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h98L109.1 336H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.7L80.4 460.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H261.7l-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H302l36.9-160H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.3l21.3-92.4c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H186.3l21.3-92.4zM178.9 176H306L269.1 336H142l36.9-160z"]
  },
  Bu = {
    prefix: "fal",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 256c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16zM256 144V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 48c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112-80V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  Gu = {
    prefix: "fal",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M103.3 9.7C110 3.5 118.8 0 128 0s18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3H192V352h25.7c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7s-18-3.5-24.7-9.7l-91-84C4.5 411.1 0 400.9 0 390.3C0 369.1 17.1 352 38.3 352H64V160H38.3C17.1 160 0 142.9 0 121.7c0-10.7 4.5-20.9 12.3-28.1l91-84zM128 32c-1.1 0-2.2 .4-3 1.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3H80c8.8 0 16 7.2 16 16V368v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 8.8-7.2 16-16 16H38.3c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.8 2-4.6c0-3.5-2.8-6.3-6.3-6.3H176c-8.8 0-16-7.2-16-16v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0V144c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2z"]
  },
  Yu = {
    prefix: "fal",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
  },
  Wu = {
    prefix: "fal",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M32 115.9C32 87.2 55.2 64 83.9 64c13.8 0 27 5.5 36.7 15.2l28.1 28.1c.5 .5 1.1 1 1.7 1.5c-33 43.9-29.5 106.5 10.4 146.4l4.7 4.7-16.8 16.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16.8 16.8-4.7-4.7C279.3 56.9 216.7 53.4 172.8 86.4c-.4-.6-.9-1.2-1.5-1.7L143.2 56.6C127.5 40.8 106.1 32 83.9 32C37.6 32 0 69.6 0 115.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V115.9zm151.4 3.5c31.2-31.2 81.9-31.2 113.1 0l4.7 4.7L188.1 237.3l-4.7-4.7c-31.2-31.2-31.2-81.9 0-113.1zM416 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM424 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  qu = {
    prefix: "fal",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 32H64C46.3 32 32 46.3 32 64V256H544V64c0-17.7-14.3-32-32-32zm64 224v32 64c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V288 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM32 288v64c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64z"]
  },
  Uu = {
    prefix: "fal",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM432 64c-7.6 0-14.2 5.4-15.7 12.9l-32 160c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9H528c44.2 0 80 35.8 80 80s-35.8 80-80 80H456.4c-17.2 0-32.5-11-37.9-27.4l-3.2-9.7c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l3.2 9.7c9.8 29.4 37.3 49.2 68.3 49.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H419.5L445.1 96H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
  },
  $u = {
    prefix: "fal",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"]
  },
  Xu = {
    prefix: "fal",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M34.5 420.4c-1.6 2.8-2.5 6-2.5 9.3c0 10.2 8.2 18.4 18.4 18.4H461.6c10.2 0 18.4-8.2 18.4-18.4c0-3.3-.9-6.4-2.5-9.3L276.5 75.8C272.2 68.5 264.4 64 256 64s-16.2 4.5-20.5 11.8L34.5 420.4zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  Zu = {
    prefix: "fal",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M296 160c13.3 0 24-10.7 24-24v-8V112 64L480 208 320 352l0-48V288v-8c0-13.3-10.7-24-24-24h-8H192c-70.7 0-128 57.3-128 128c0 8.3 .7 16.1 2 23.2C47.9 383.7 32 350.1 32 304c0-79.5 64.5-144 144-144H288h8zm-8 144v16 32c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V96v16 16H256 176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h64 32v16z"]
  },
  Ku = {
    prefix: "fal",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 108.4-76.9 198.8-179.2 219.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5C424 483.2 512 379.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 23.6 3.2 46.5 9.2 68.3c2.4 8.5 11.2 13.5 19.7 11.2s13.5-11.2 11.2-19.7c-5.2-19-8.1-39-8.1-59.7zm165.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l70.5 23.5L160 348.8V320c0-26.5-21.5-48-48-48s-48 21.5-48 48V440c0 39.8 32.2 72 72 72h47.8c29.4 0 55.9-17.9 66.9-45.3l23.9-59.6 47-18.4c20.9-8.2 32.8-29.4 30.1-50.7c-2.3-18.7-15.1-34.7-33.3-40.8L197.1 256.8zM320 342.7c0 .4 0 .9 0 1.3h0c0 6.4-3.9 12.4-10.2 14.9l-53.5 20.9c-4.3 1.7-7.7 5.2-9.2 9.5c-.1 .2-.1 .4-.2 .6l-26 64.9C214.8 470 200.1 480 183.8 480H136c-22.1 0-40-17.9-40-40V320c0-8.8 7.2-16 16-16s16 7.2 16 16v52.2c0 5.3 2.6 10.2 7 13.2s9.9 3.6 14.9 1.7l148.3-58c8.2-3.2 17.5 .8 20.7 9.1c.6 1.5 .9 3 1.1 4.5zM200.4 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-120-87.2l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 94.1 162.3 90 127.1 110.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4c23.5-13.4 52.9-10.6 73.4 7z"]
  },
  Qu = {
    prefix: "fal",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8 .1 290s8.4 22.9 19.6 27.6L160 376v93c0 23.8 19.3 43 43 43c13.1 0 25.4-5.9 33.6-16.1l52.8-66 .1 0 114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2l-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1c-6.1 0-11-4.9-11-11V389.3l66.6 27.8zm43.1-16.7l-96.6-40.3L474.1 70.5 416 448 301.8 400.4zM450.5 48.8L173.6 347 32 288 450.5 48.8z"]
  },
  Ju = {
    prefix: "fal",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm16 144c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432z"]
  },
  ed = {
    prefix: "fal",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
  },
  td = {
    prefix: "fal",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M288.8 81.7c3.5-12.8 16.7-20.3 29.5-16.8s20.3 16.7 16.8 29.5l-4.5 16.4c-5.5 20.2-13.9 39.3-24.7 56.9c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2H448c17.7 0 32 14.3 32 32c0 11.3-5.9 21.3-14.8 27c-7.2 4.6-9.5 13.9-5.3 21.3c2.6 4.6 4.1 10 4.1 15.7c0 12.4-7 23.1-17.3 28.5c-4.2 2.2-7.3 6.1-8.3 10.8s.1 9.5 3 13.2c4.2 5.4 6.7 12.2 6.7 19.5c0 14.2-9.2 26.3-22.1 30.4c-7.8 2.6-12.4 10.6-10.7 18.6c.5 2.2 .7 4.5 .7 6.9c0 17.7-14.3 32-32 32H294.5c-15.8 0-31.2-4.7-44.4-13.4l-38.5-25.7c-9-6-16.6-13.7-22.4-22.6c-4.9-7.4-14.8-9.4-22.2-4.6s-9.4 14.8-4.6 22.2c8.1 12.3 18.7 23.1 31.4 31.6l38.5 25.7c18.4 12.3 40 18.8 62.1 18.8H384c35.3 0 64-28.7 64-64l0-.6c19.1-11.1 32-31.7 32-55.4c0-8.7-1.8-17.1-4.9-24.7C487.9 323.6 496 306.8 496 288c0-6.5-1-12.8-2.8-18.7C504.8 257.7 512 241.7 512 224c0-35.3-28.7-64-64-64H346.4c6.2-13.1 11.3-26.7 15.1-40.9l4.5-16.4c8.1-29.8-9.5-60.6-39.3-68.8s-60.6 9.5-68.8 39.3l-4.5 16.4c-8.9 32.6-29.6 60.8-58.2 79l-3.1 2c-11.8 7.5-21.7 17.1-29.5 28.2c-5.1 7.2-3.3 17.2 4 22.3s17.2 3.3 22.3-4c5.4-7.7 12.2-14.4 20.4-19.5l3.1-2c35.3-22.4 60.9-57.2 71.9-97.5l4.5-16.4zM32 224H96V448H32V224zM0 224V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
  },
  nd = {
    prefix: "fal",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM224 432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm64-96H96V272H288v64zM96 240c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H96z"]
  },
  cd = {
    prefix: "fal",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M96 160H64V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H416V90.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32v96zm352 64H64c-17.7 0-32 14.3-32 32V384H64V352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32h32V256c0-17.7-14.3-32-32-32zm0 192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 17.7-14.3 32-32 32H448zM96 352l0 128H416V352H96zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  id = {
    prefix: "fal",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192H256 480.8c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24H34.3L256 34.4 477.7 160H306.6zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM40 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H472c8.8 0 16-7.2 16-16s-7.2-16-16-16H40zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  rd = {
    prefix: "fal",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
  },
  ad = {
    prefix: "fal",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M128 160H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L192 35.8 317.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7H256c-17.7 0-32 14.3-32 32V368c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48V192c0-17.7-14.3-32-32-32zM206 5.3C202.1 1.9 197.2 0 192 0s-10.1 1.9-14 5.3L44.9 124.5C36.7 131.8 32 142.3 32 153.3C32 174.7 49.3 192 70.7 192H96h32v32V368c0 8.8-7.2 16-16 16l-64 0c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h64c79.5 0 144-64.5 144-144V224 192h32 25.3c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L206 5.3z"]
  },
  od = {
    prefix: "fat",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zm96 48V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  sd = {
    prefix: "fat",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16 96 16 96 16 32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V416 400 304 288 192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM432 288H304V192H432v96zM288 192v96H160V192H288zm-144 0v96H16V192H144zM16 304H144v96H16V304zm0 112H144v80H64c-26.5 0-48-21.5-48-48V416zm144 80V416H288v80H160zm144 0V416H432v32c0 26.5-21.5 48-48 48H304zm128-96H304V304H432v96zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM288 400H160V304H288v96z"]
  },
  ld = {
    prefix: "fat",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M496 72c0-2.9-1.6-5.6-4.1-7s-5.7-1.3-8.1 .2l-64 40c-3.7 2.3-4.9 7.3-2.5 11s7.3 4.9 11 2.5L480 86.4V432H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64 64c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V72zM16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72z"]
  },
  fd = {
    prefix: "fat",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M512 48H128c-26.5 0-48 21.5-48 48V352H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H560V96c0-26.5-21.5-48-48-48zM19.2 400c-1.8 0-3.2 1.4-3.2 3.2C16 436.8 43.2 464 76.8 464H563.2c33.6 0 60.8-27.2 60.8-60.8c0-1.8-1.4-3.2-3.2-3.2H19.2zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z"]
  },
  ud = {
    prefix: "fat",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM200 368h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H200c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 17.7-14.3 32-32 32H200c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm133.1 0H368c4.4 0 8 3.6 8 8s-3.6 8-8 8H333.1c-11.7 0-21.1 9.4-21.1 21.1c0 8.3 4.9 15.9 12.5 19.3L362 441c13.4 6 22 19.2 22 33.9c0 20.5-16.6 37.1-37.1 37.1H304c-4.4 0-8-3.6-8-8s3.6-8 8-8h42.9c11.7 0 21.1-9.4 21.1-21.1c0-8.3-4.9-15.9-12.5-19.3L318 439c-13.4-6-22-19.2-22-33.9c0-20.5 16.6-37.1 37.1-37.1zm98.9 0c4.4 0 8 3.6 8 8v31.6c0 29.1 8.3 57.5 24 82c15.7-24.5 24-52.9 24-82V376c0-4.4 3.6-8 8-8s8 3.6 8 8v31.6c0 33.2-9.8 65.6-28.2 93.2l-5.1 7.7c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-5.1-7.7c-18.4-27.6-28.2-60-28.2-93.2V376c0-4.4 3.6-8 8-8z"]
  },
  dd = {
    prefix: "fat",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M88 48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 208c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 176H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 176h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24zm-40 24v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24h48zm-48-16c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 48h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24zM320 72v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24h48zm-48-16c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 176h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24zm-40 24v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
  },
  pd = {
    prefix: "fat",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M113.9 125.9c5.6-30.4 26.3-52.3 57.8-65c31.8-12.9 74.4-16.3 121.9-9.3C308.2 53.8 353.2 62 368 65.8c4.3 1.1 8.6-1.5 9.7-5.8s-1.5-8.6-5.8-9.7c-15.5-3.9-61.1-12.3-76-14.5c-49.3-7.3-95-4-130.3 10.3c-35.5 14.4-60.8 40.2-67.6 77.2l0 0-.1 .4c-2.8 22.3 .6 41.1 9.1 57c8.4 15.8 21.5 28.1 37.1 38.1c25.8 16.5 59.7 27.4 93.8 37.2H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H295.4c-11-3.4-22.2-6.6-33.3-9.7l-2.2-.6c-40.4-11.5-79.3-22.5-107.2-40.4c-14-9-24.8-19.4-31.6-32.1c-6.7-12.5-9.7-27.9-7.3-47.2zM394 336.5c5.8 13 7.8 29 4.1 49.3c-5.6 30.5-26.2 52.4-57.9 65.3c-31.8 12.9-74.4 16.3-121.9 9.3c-24.2-3.7-64.7-16.8-94.7-26.5l0 0 0 0c-6.3-2-12.2-3.9-17.3-5.5c-4.2-1.3-8.7 1-10 5.2s1 8.7 5.2 10c4.8 1.5 10.4 3.3 16.6 5.3l0 0c29.9 9.7 72.2 23.3 97.8 27.3l0 0c49.3 7.3 95 4 130.3-10.3c35.5-14.4 60.8-40.2 67.6-77.2c4.2-22.9 2.1-42.2-5.3-58.7c-1.6-3.5-3.3-6.8-5.3-10H383.5c4.3 5.1 7.8 10.6 10.5 16.5z"]
  },
  md = {
    prefix: "fat",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M395 25.9c12.5-12.5 32.8-12.5 45.3 0l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L328.1 92.8 395 25.9zm-78.2 78.2l91.1 91.1L164.7 438.4c-1.5 1.5-3.1 3-4.7 4.4V408c0-4.4-3.6-8-8-8H112V360c0-4.4-3.6-8-8-8H69.2c1.4-1.6 2.9-3.2 4.4-4.7L316.8 104.1zM51.4 384.7c1.7-5.8 4-11.4 6.8-16.7H96v40c0 4.4 3.6 8 8 8h40v37.7c-5.3 2.8-10.9 5.1-16.7 6.8L19.8 492.2 51.4 384.7zm400.1-370c-18.7-18.7-49.1-18.7-67.9 0L62.3 336C50 348.3 41 363.5 36.1 380.2L.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2L497.4 128.3c18.7-18.7 18.7-49.1 0-67.9L451.5 14.6zM317.7 173.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-144 144c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l144-144z"]
  },
  hd = {
    prefix: "fat",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M120.4 64c4-36 34.5-64 71.6-64s67.6 28 71.6 64H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h2.7C73.3 77.4 91.1 64 112 64h8.4zM64 112c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48v16c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V112zM192 16c-30.9 0-56 25.1-56 56c0 4.4-3.6 8-8 8H112c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V112c0-17.7-14.3-32-32-32H256c-4.4 0-8-3.6-8-8c0-30.9-25.1-56-56-56zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM160 224c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm0 96c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm0 96c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zM96 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
  },
  vd = {
    prefix: "fat",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M480 48H32c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16H48 464h16c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm0 96H464 48 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32zM160 232c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm304-56h16V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V176H48V416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48V176z"]
  },
  gd = {
    prefix: "fat",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 136l0 6.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-6.5c0-22.1 17.9-40 40-40h56.2c26.4 0 47.8 21.4 47.8 47.8c0 16.1-8.1 31.1-21.5 39.9l-54.9 36.2c-2.2 1.5-3.6 4-3.6 6.7V256c0 4.4 3.6 8 8 8s8-3.6 8-8V230.9L315.3 197c17.9-11.8 28.7-31.8 28.7-53.3c0-35.2-28.6-63.8-63.8-63.8H224c-30.9 0-56 25.1-56 56zM272 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  bd = {
    prefix: "fat",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M512 48c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 24c0 4.4 3.6 8 8 8s8-3.6 8-8V448H496v24c0 4.4 3.6 8 8 8s8-3.6 8-8V448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm432 72V376c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8s-8 3.6-8 8zM104 128H408c4.4 0 8 3.6 8 8V344c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8zm-24 8V344c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24V136c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24z"]
  },
  Hd = {
    prefix: "fat",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M200 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v64.1C128 148.4 32 247 32 368v32H48V368c0-114.9 93.1-208 208-208s208 93.1 208 208v32h16V368c0-121-96-219.6-216-223.9V80h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H256 200zM8 432c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  zd = {
    prefix: "fat",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M224 144c-8.8 0-16-7.2-16-16V64c0-6.3-3.7-12-9.5-14.6s-12.5-1.5-17.2 2.7l-160 144c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l160 144c4.7 4.2 11.4 5.3 17.2 2.7s9.5-8.3 9.5-14.6V288c0-8.8 7.2-16 16-16h96c61.9 0 112 50.1 112 112c0 35.5-15.2 57.1-27.3 68.4c-3.7 3.5-4.7 6.5-4.7 7.8c0 2.1 1.7 3.7 3.7 3.7c.3 0 .5 0 .6 0c17.1-9.3 91.8-55.7 91.8-160c0-88.4-71.6-160-160-160H224zm0 160v48c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v48 16h16 96c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H240 224v16z"]
  },
  yd = {
    prefix: "fat",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M485.7 37.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L408.6 92.1C368.6 54.8 315 32 256 32C132.3 32 32 132.3 32 256c0 59 22.8 112.6 60.1 152.6L26.3 474.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l65.7-65.7C143.4 457.2 197 480 256 480c123.7 0 224-100.3 224-224c0-59-22.8-112.6-60.1-152.6l65.7-65.7zm-88.3 65.7L103.4 397.3C69 360.2 48 310.6 48 256C48 141.1 141.1 48 256 48c54.6 0 104.2 21 141.3 55.4zM114.7 408.6L408.6 114.7C443 151.8 464 201.4 464 256c0 114.9-93.1 208-208 208c-54.6 0-104.2-21-141.3-55.4z"]
  },
  Vd = {
    prefix: "fat",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM0 248c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM448 408c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8z"]
  },
  xd = {
    prefix: "fat",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M88 88a40 40 0 1 1 80 0A40 40 0 1 1 88 88zm96 0A56 56 0 1 0 72 88a56 56 0 1 0 112 0zm288 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 456 88a56 56 0 1 0 112 0zM64 256c-4.4 0-8 3.6-8 8v98.2c-24.2-16.9-40-45-40-76.7c0-51.7 41.9-93.5 93.5-93.5h36.9c18.8 0 36.3 5.6 51 15.1c3.7-4 7.6-7.8 11.7-11.4c-17.8-12.4-39.4-19.7-62.7-19.7H109.5C49 176 0 225 0 285.5c0 41.1 22.6 76.8 56 95.6V432c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V403.6c-5.9-6.2-11.3-12.8-16-20V432c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V264c0-4.4-3.6-8-8-8zM440 432c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V381.1c33.4-18.7 56-54.5 56-95.6C640 225 591 176 530.5 176H493.5c-23.3 0-44.9 7.3-62.7 19.7c4.1 3.6 8 7.4 11.7 11.4c14.7-9.6 32.2-15.1 51-15.1h36.9c51.7 0 93.5 41.9 93.5 93.5c0 31.7-15.8 59.8-40 76.7V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V432c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V383.6c-4.7 7.1-10.1 13.8-16 20V432zM272 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 272c-4.4 0-8 3.6-8 8v98.2c-24.2-16.9-40-45-40-76.7c0-51.7 41.9-93.5 93.5-93.5h36.9c51.7 0 93.5 41.9 93.5 93.5c0 31.7-15.8 59.8-40 76.7V280c0-4.4-3.6-8-8-8s-8 3.6-8 8V448c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V280c0-4.4-3.6-8-8-8zm-8 125.1V448c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V397.1c33.4-18.7 56-54.5 56-95.6C448 241 399 192 338.5 192H301.5C241 192 192 241 192 301.5c0 41.1 22.6 76.8 56 95.6z"]
  },
  Md = {
    prefix: "fat",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  _d = {
    prefix: "fat",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M320 48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h64zM256 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h24v56H112c-22.1 0-40 17.9-40 40v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H88V288c0-13.3 10.7-24 24-24H280v56H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H296V264H464c13.3 0 24 10.7 24 24v32H464c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H504V288c0-22.1-17.9-40-40-40H296V192h24c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256zM48 336h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm208 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm208 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H464c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32z"]
  },
  wd = {
    prefix: "fat",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M349.2 77.5c-4.8 .1-9.4-2.1-12.5-5.8c-16.5-19.9-34.2-38.3-53.1-55.3C251.8 44.9 225 77.2 206 107.9c-19 30.8-30 62.1-30 84.2c0 79 63.2 143.8 144 143.8c79.9 0 144-64.8 144-143.8c0-16.5-8.3-44.5-22.4-71.6c-14-26.9-33.5-54.9-56.2-76c-8.3 7.7-16.3 17.4-23.9 26.9c-3 3.8-7.5 6-12.3 6zM338.4 49.1c3.6 4.1 7.1 8.2 10.6 12.4c3.3-4.1 6.7-8.4 10.3-12.6c5.1-5.9 10.5-11.8 16.1-16.9c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c15.8 14.2 30.7 29.3 44.9 45.3zM281.7 96c2.4 0 4.7 1.1 6.2 3c2.2 2.8 19.4 24.6 35.9 45.7l22.5 28.7 4 5.2 33.4-38.9c1.6-1.8 3.9-2.9 6.3-2.8s4.7 1.3 6.1 3.2c3.7 5 6.2 10 8.4 14.3l0 0 0 .1c21.5 39.6 12.2 90.5-24.6 116.2l-.2 .1 0 0c-17.8 11.9-37 17.9-58.5 17.9c-26.5 0-50.9-8.6-68.7-24.9c-17.9-16.4-28.7-40.1-28.7-69.2c0-15.1 4.8-28.9 13.5-43.9c8.6-14.8 21.4-31.3 37.9-51.6c1.5-1.9 3.8-3 6.2-3zm68.4 95.2l-6.3 4.9 0 0 0 0 0 0-.1-.2-.5-.7-2-2.6-7.3-9.3-22.5-28.7c-11.3-14.4-22.7-29-29.6-37.8c-13.4 16.7-23.4 30-30.3 41.8c-7.8 13.4-11.3 24.4-11.3 35.8c0 24.9 9.1 44.3 23.5 57.4c14.5 13.2 34.8 20.7 57.9 20.7c18.2 0 34.3-5 49.5-15.2c29.4-20.6 37.7-62.3 19.6-95.5l-.1-.3 0 0c-.6-1.1-1.1-2.2-1.7-3.3l-32.6 38c-1.6 1.8-3.9 2.8-6.2 2.8s-4.6-1.2-6.1-3.1l6.3-4.9zM32 264c0-4.4 3.6-8 8-8H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H48V384H592V272H552c-4.4 0-8-3.6-8-8s3.6-8 8-8h48c4.4 0 8 3.6 8 8V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V264zm0 136c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H608c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16h-8H40 32zm288 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
  },
  Ed = {
    prefix: "fat",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM136 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H136z"]
  },
  Cd = {
    prefix: "fat",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M40 64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H40zM16 72c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72zM176 88H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zM88 224H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM40 208H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24zm0 176c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H40zm-24 8c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392z"]
  },
  Ld = {
    prefix: "fat",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M112 128v64H336V128c0-61.9-50.1-112-112-112s-112 50.1-112 112zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zm0 16H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H352 336 112 96z"]
  },
  Nd = {
    prefix: "fat",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M248 0c4.4 0 8 3.6 8 8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C336 115.4 352 148.7 352 184c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.6-13.9-59-36.7-75.6L283.2 96.5C256 76.6 240 43.3 240 8c0-4.4 3.6-8 8-8zM16 336V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H277.3c-1.4 0-2.7 0-4-.1c-.4 .1-.8 .1-1.3 .1H16v48 16zm213.3-80L144 192c-13.8-10.4-30.7-16-48-16c-44.2 0-80 35.8-80 80H229.3zM0 336V320 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V336zM384 8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C464 115.4 480 148.7 480 184c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.6-13.9-59-36.7-75.6L411.2 96.5C384 76.6 368 43.3 368 8c0-4.4 3.6-8 8-8s8 3.6 8 8zM112 320c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zM112 64A48 48 0 1 0 16 64a48 48 0 1 0 96 0zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z"]
  },
  Sd = {
    prefix: "fat",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M16 120V341.4C31.9 318.8 58.2 304 88 304H400c12.3 0 23.5 4.6 32 12.2V120c0-39.8-32.2-72-72-72H88c-39.8 0-72 32.2-72 72zM.4 384H0V120C0 71.4 39.4 32 88 32H360c48.6 0 88 39.4 88 88V352c0 26.5-21.5 48-48 48H88c-4.4 0-8-3.6-8-8s3.6-8 8-8H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H88c-39.8 0-72 32.2-72 72s32.2 72 72 72H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-48.6 0-88-39.4-88-88c0-2.7 .1-5.4 .4-8z"]
  },
  kd = {
    prefix: "fat",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M80 80a64 64 0 1 1 128 0A64 64 0 1 1 80 80zm144 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 48H378.7C443.5 368 496 420.5 496 485.3c0 5.9-4.8 10.7-10.7 10.7H154.7c-5.9 0-10.7-4.8-10.7-10.7C144 420.5 196.5 368 261.3 368zm0-16C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 16a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm24 48c48.6 0 88 39.4 88 88c0 4.4 3.6 8 8 8s8-3.6 8-8c0-57.4-46.6-104-104-104H444c1.3 5.2 2.4 10.6 3 16h89zm-343 0c.7-5.4 1.7-10.8 3-16H104C46.6 192 0 238.6 0 296c0 4.4 3.6 8 8 8s8-3.6 8-8c0-48.6 39.4-88 88-88h89z"]
  },
  Pd = {
    prefix: "fat",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M250.3 114.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 131.3 45.7 341.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l216-216z"]
  },
  Td = {
    prefix: "fat",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H160C80.5 112 16 176.5 16 256s64.5 144 144 144h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c79.5 0 144-64.5 144-144s-64.5-144-144-144H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c88.4 0 160 71.6 160 160zm-440-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  Od = {
    prefix: "fat",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm536 56h-8c-39.8 0-72-32.2-72-72v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 30.9 25.1 56 56 56h8c4.4 0 8 3.6 8 8s-3.6 8-8 8zM32 176c0-4.4 3.6-8 8-8h8c30.9 0 56-25.1 56-56v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 39.8-32.2 72-72 72H40c-4.4 0-8-3.6-8-8zM536 328c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8zM32 336c0-4.4 3.6-8 8-8h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56H40c-4.4 0-8-3.6-8-8zm336-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
  },
  Ad = {
    prefix: "fat",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM0 192c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM8 312c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  Dd = {
    prefix: "fat",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M240 48c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 240c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V272c0-17.7 14.3-32 32-32H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zM368 112h32c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zm-48 32V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
  },
  Id = {
    prefix: "fat",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 128h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H192v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 144c0-8.8 7.2-16 16-16zm96 160c39.8 0 72-32.2 72-72s-32.2-72-72-72H192V288h96z"]
  },
  jd = {
    prefix: "fat",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm376-8c-4.4 0-8 3.6-8 8s3.6 8 8 8H580.7L418.3 242.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H447.4c-23.5 0-43.5-17-47.3-40.1l-.2-1.2c-.7-4.4-4.8-7.3-9.2-6.6s-7.3 4.8-6.6 9.2l.2 1.2c5.1 30.9 31.8 53.5 63.1 53.5H520c57.4 0 104-46.6 104-104s-46.6-104-104-104H443.3L605.7 77.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H392z"]
  },
  Fd = {
    prefix: "fat",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M16 422.3c0 12.4 6.9 22.7 16.6 26.3c78.1 29.1 156.8 11.7 240.7-9.6c4-1 8-2 12-3.1c78.7-20.1 162.3-41.4 246.3-18.5c15.2 4.2 28.4-6.9 28.4-17.9V89.7c0-12.4-6.9-22.7-16.6-26.3C465.3 34.2 386.7 51.7 302.8 73c-4 1-8 2-12 3l0 0 0 0 0 0C212 96.2 128.4 117.5 44.4 94.6C29.2 90.4 16 101.5 16 112.5V422.3zm-16 0V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM216 256c0 50 33.5 88 72 88s72-38 72-88s-33.5-88-72-88s-72 38-72 88zm72-104c49.9 0 88 48 88 104s-38.1 104-88 104s-88-48-88-104s38.1-104 88-104zm256 0c0 4.4-3.6 8-8 8h-8c-39.8 0-72-32.2-72-72V80c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 30.9 25.1 56 56 56h8c4.4 0 8 3.6 8 8zM40 216c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c30.9 0 56-25.1 56-56v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 39.8-32.2 72-72 72H40zm504 88c0 4.4-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8c4.4 0 8 3.6 8 8zM40 352h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56H40c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  Rd = {
    prefix: "fat",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M420 431.3L80.7 92C40.6 134.9 16 192.6 16 256c0 132.5 107.5 240 240 240c63.4 0 121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256C496 123.5 388.5 16 256 16C192.6 16 134.9 40.6 92 80.7L431.3 420zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  Bd = {
    prefix: "fat",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M212.1 161.8L280.7 20.5c1.3-2.8 4.1-4.5 7.2-4.5s5.9 1.7 7.2 4.5l68.6 141.3c2.3 4.8 6.8 8.1 12.1 8.8L529 193.3c3 .4 5.5 2.5 6.4 5.4s.2 6-2 8.2L422.4 317c-3.7 3.7-5.4 8.9-4.5 14l26.2 155.6c.5 3-.7 6-3.2 7.8s-5.8 2-8.4 .6l-137-73.2c-4.7-2.5-10.4-2.5-15.1 0L143.4 495c-2.7 1.4-6 1.2-8.4-.6s-3.7-4.8-3.2-7.8L158 331c.9-5.1-.8-10.4-4.5-14L42.4 206.9 31.2 218.1l11.2-11.3c-2.2-2.1-2.9-5.3-2-8.2s3.4-5 6.4-5.4l153.2-22.6c5.2-.8 9.7-4.1 12.1-8.8zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"]
  },
  Gd = {
    prefix: "fat",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 72c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zM192 242.7c-4.4 0-8 3.6-8 8v13.7c-8.3 .6-16 2.3-22.7 5c-12.1 4.9-22.1 13.6-24.5 26.2c-1.5 7.6-.6 14.4 2.6 20.4c3.1 5.8 8 10.1 13.4 13.3c10 6 23.5 9.6 35.7 12.9l1.7 .4c13.4 3.6 25.1 6.9 33 12c3.8 2.4 6.2 5 7.5 7.7c1.3 2.6 1.9 6 .9 11c-1.3 6.6-6 11.8-14.8 15.2c-9 3.4-21.4 4.5-35.8 2.5c-7.2-1-19.4-4.7-28.9-7.6c-2.1-.6-4-1.2-5.7-1.7c-4.2-1.3-8.7 1.2-9.9 5.4s1.2 8.7 5.4 9.9c1.4 .4 3.1 .9 5 1.5c9.4 2.9 23.3 7.1 31.9 8.3l0 0c1.8 .2 3.6 .5 5.3 .6v13.9c0 4.4 3.6 8 8 8s8-3.6 8-8l0-13.5c8.2-.4 15.8-1.9 22.4-4.4c12.4-4.7 22.2-13.6 24.8-27.1c1.5-7.8 .8-14.9-2.3-21.1c-3-6.1-7.8-10.6-13.2-14.1c-10.4-6.7-24.8-10.6-37.5-14l-.3-.1c-13.4-3.6-25-6.7-33-11.5c-3.9-2.3-6.2-4.7-7.5-7.1c-1.2-2.3-1.9-5.3-1-9.8c1-5.4 5.6-10.8 14.8-14.5c9.1-3.7 21.7-5.1 35.9-3.2c4.6 .6 18.6 3.1 23 4.1c4.3 1 8.6-1.6 9.6-5.9s-1.6-8.6-5.9-9.6c-5.1-1.2-19.7-3.7-24.5-4.4c-1.8-.2-3.6-.5-5.3-.6V250.7c0-4.4-3.6-8-8-8z"]
  },
  Yd = {
    prefix: "fat",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M344 0c4.4 0 8 3.6 8 8V72h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H352v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V88H272c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V8c0-4.4 3.6-8 8-8zM138.4 258.5c-2.3 4.7-6.8 8-12 8.8L22.9 282.3c-6.6 1-9.2 9-4.4 13.6l74.9 73.2c3.8 3.7 5.5 9 4.6 14.1L80.3 486.6c-1.1 6.5 5.7 11.5 11.6 8.4l92.6-48.8c4.7-2.5 10.2-2.5 14.9 0L291.9 495c5.9 3.1 12.7-1.9 11.6-8.4L285.9 383.3c-.9-5.2 .8-10.5 4.6-14.1l74.9-73.2c4.7-4.6 2.1-12.7-4.4-13.6L257.4 267.2c-5.2-.8-9.7-4-12-8.8l-46.3-94c-2.9-6-11.4-6-14.4 0l-46.3 94zM7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4zM464 160v48h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H464v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V224H400c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V160c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  Wd = {
    prefix: "fat",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M433.5 64.1c-4.3-.8-8.5 2-9.4 6.3l-40 208c-.5 2.3 .2 4.8 1.7 6.6s3.8 2.9 6.2 2.9H624V440c0 4.4 3.6 8 8 8s8-3.6 8-8V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V272H401.7L439.9 73.5c.8-4.3-2-8.5-6.3-9.4zM16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72z"]
  },
  qd = {
    prefix: "fat",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M13.8 175.3C92 96.6 200.3 48 320 48s228 48.6 306.2 127.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C556.4 82.5 444.1 32 320 32S83.6 82.5 2.5 164c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM320 208c72.2 0 137.8 28.1 186.5 74c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3C465.9 221.8 396.4 192 320 192s-145.9 29.8-197.5 78.4c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3c48.7-45.9 114.3-74 186.5-74zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  Ud = {
    prefix: "fat",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M85.3 16C64.7 16 48 32.7 48 53.3V272H464h16 24c4.4 0 8 3.6 8 8s-3.6 8-8 8H480 464 48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V53.3C32 23.8 55.8 0 85.3 0c14.1 0 27.7 5.6 37.7 15.6l32.1 32.1C167.4 37.9 183 32 200 32c23.1 0 43.7 10.9 56.9 27.8l1.5-1.5c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-104 104c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l1.5-1.5C138.9 147.7 128 127.1 128 104c0-17 5.9-32.6 15.7-44.9L111.6 26.9c-7-7-16.5-10.9-26.3-10.9zM32 320H48v48c0 53 43 96 96 96H368c53 0 96-43 96-96V320h16v48c0 38.1-19 71.7-48 91.9V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V459.9C51 439.7 32 406.1 32 368V320zM200 48c-30.9 0-56 25.1-56 56c0 18.7 9.2 35.3 23.3 45.4l78.2-78.2C235.3 57.2 218.7 48 200 48z"]
  },
  $d = {
    prefix: "fat",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M0 40c0-4.4 3.6-8 8-8H136c4.4 0 8 3.6 8 8s-3.6 8-8 8H80V240c0 79.5 64.5 144 144 144s144-64.5 144-144V48H312c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H384V240c0 88.4-71.6 160-160 160s-160-71.6-160-160V48H8c-4.4 0-8-3.6-8-8zM0 472c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z"]
  },
  Xd = {
    prefix: "fat",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 40c0-4.4 3.6-8 8-8H40 72 224c61.9 0 112 50.1 112 112c0 43.1-24.4 80.5-60.1 99.3C328.7 255.8 368 303.3 368 360c0 66.3-53.7 120-120 120H72 40 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V248 48H8c-4.4 0-8-3.6-8-8zM48 464H72 248c57.4 0 104-46.6 104-104s-46.6-104-104-104H224 48V464zm0-224H224c53 0 96-43 96-96s-43-96-96-96H72 48V240z"]
  },
  Zd = {
    prefix: "fat",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zm96 104c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16zm16-224c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]
  },
  Kd = {
    prefix: "fat",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm72 152c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H136z"]
  },
  Qd = {
    prefix: "fat",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M64 48C37.5 48 16 69.5 16 96V356.7l89.4-89.4c12.5-12.5 32.8-12.5 45.3 0L224 340.7 361.4 203.3c12.5-12.5 32.8-12.5 45.3 0L496 292.7V96c0-26.5-21.5-48-48-48H64zM16 379.3V416c0 26.5 21.5 48 48 48h36.7l112-112-73.4-73.4c-6.2-6.2-16.4-6.2-22.6 0L16 379.3zM395.3 214.6c-6.2-6.2-16.4-6.2-22.6 0L123.3 464H448c26.5 0 48-21.5 48-48V315.3L395.3 214.6zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm168 64a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 72 160z"]
  },
  Jd = {
    prefix: "fat",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M419.9 384.1c-70.7 90.5-201.4 106.6-292 35.8C105 402 86.9 380.2 73.7 356.3c-2.1-3.9-7-5.3-10.9-3.2s-5.3 7-3.2 10.9c14.2 25.8 33.7 49.3 58.4 68.6c97.5 76.2 238.3 58.9 314.4-38.6s58.9-238.3-38.6-314.4C304.1 9.3 177.5 18.5 98.6 96.6l11.3 11.3c73.3-72.5 190.8-81 274.2-15.8c90.5 70.7 106.6 201.4 35.8 292zM32 192c-4.4 0-8-3.6-8-8V64c0-3.2 1.9-6.2 4.9-7.4s6.4-.6 8.7 1.7l120 120c2.3 2.3 3 5.7 1.7 8.7s-4.2 4.9-7.4 4.9H32zm120 16c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2L49 47c-6.9-6.9-17.2-8.9-26.2-5.2S8 54.3 8 64V184c0 13.3 10.7 24 24 24H152z"]
  },
  ep = {
    prefix: "fat",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM274.7 312H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H295l-20.3-16zm252.7 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H507.1l20.3 16zM536 200c4.4 0 8-3.6 8-8s-3.6-8-8-8H345l20.3 16H536zm-403.1 0l-20.3-16H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h28.9zM536 56H182.9l20.3 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8zM457.1 456l-20.3-16H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H457.1z"]
  },
  tp = {
    prefix: "fat",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z"]
  },
  np = tp,
  cp = {
    prefix: "fat",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M162.7 94.5c3.7-2.2 6.4-5.7 7.5-9.9L186.1 22c.7-2.8 2.9-5 5.7-5.8s5.8 .1 7.8 2.1l45 46.2c3 3.1 7.1 4.8 11.5 4.8s8.5-1.7 11.5-4.8l45-46.2c2-2.1 5-2.9 7.8-2.1s5 3 5.7 5.8l15.8 62.5c1.1 4.2 3.8 7.8 7.5 9.9s8.2 2.7 12.3 1.5l62-17.5c2.8-.8 5.8 0 7.8 2s2.8 5 2 7.8l-17.5 62c-1.2 4.2-.6 8.6 1.5 12.3s5.7 6.4 9.9 7.5L490 186.1c2.8 .7 5 2.9 5.8 5.7s-.1 5.8-2.1 7.8l-46.2 45c-3.1 3-4.8 7.1-4.8 11.5s1.7 8.5 4.8 11.5l46.2 45c2.1 2 2.9 5 2.1 7.8s-3 5-5.8 5.7l-62.5 15.8c-4.2 1.1-7.8 3.8-9.9 7.5s-2.7 8.2-1.5 12.3l17.5 62c.8 2.8 0 5.8-2 7.8s-5 2.8-7.8 2l-62-17.5c-4.2-1.2-8.6-.6-12.3 1.5s-6.4 5.7-7.5 9.9L325.9 490c-.7 2.8-2.9 5-5.7 5.8s-5.8-.1-7.8-2.1l-45-46.2c-3-3.1-7.1-4.8-11.5-4.8s-8.5 1.7-11.5 4.8l-45 46.2c-2 2.1-5 2.9-7.8 2.1s-5-3-5.7-5.8l-15.8-62.5c-1.1-4.2-3.8-7.8-7.5-9.9s-8.2-2.7-12.3-1.5l-62 17.5c-2.8 .8-5.8 0-7.8-2s-2.8-5-2-7.8l17.5-62c1.2-4.2 .6-8.6-1.5-12.3s-5.7-6.4-9.9-7.5L22 325.9c-2.8-.7-5-2.9-5.8-5.7s.1-5.8 2.1-7.8l46.2-45c3.1-3 4.8-7.1 4.8-11.5s-1.7-8.5-4.8-11.5l-46.2-45c-2.1-2-2.9-5-2.1-7.8s3-5 5.8-5.7l62.5-15.8c4.2-1.1 7.8-3.8 9.9-7.5s2.7-8.2 1.5-12.3l-17.5-62c-.8-2.8 0-5.8 2-7.8s5-2.8 7.8-2l62 17.5c4.2 1.2 8.6 .6 12.4-1.5zM244.8 42L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-11.9 47-3.9 15.5-15.4-4.4L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l13.2 46.6 4.4 15.4-15.5 3.9-47 11.9c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211L42 244.8 53.5 256 42 267.2 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l47 11.9 15.5 3.9-4.4 15.4L63.1 419.3c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l46.6-13.2 15.4-4.4 3.9 15.5 11.9 47c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L244.8 470 256 458.5 267.2 470 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l11.9-47 3.9-15.5 15.4 4.4 46.6 13.2c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-13.2-46.6-4.4-15.4 15.5-3.9 47-11.9c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L470 267.2 458.5 256 470 244.8 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-47-11.9-15.5-3.9 4.4-15.4 13.2-46.6c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1L372.7 76.2l-15.4 4.4-3.9-15.5-11.9-47c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L267.2 42 256 53.5 244.8 42z"]
  },
  ip = {
    prefix: "fat",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM390 48H547.5c5.2 0 9 4.9 7.8 9.9l-11 44.1c-1.1 4.3 1.5 8.6 5.8 9.7s8.6-1.5 9.7-5.8l11-44.1c3.8-15.1-7.7-29.8-23.3-29.8H384.2h-.4H180.5c-9.8 0-18.5 6-22.2 14.8l13.6 10.7 .9-3.5c.9-3.6 4.1-6.1 7.8-6.1H373.3L332.8 184.6l13.5 10.7L390 48zM293.7 316.7L250 464H168c-4.4 0-8 3.6-8 8s3.6 8 8 8h87.8 .4H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H266.7l40.5-136.6-13.5-10.7z"]
  },
  rp = {
    prefix: "fat",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM87.7 245.8c-1.2-4.2-5.7-6.7-9.9-5.4s-6.7 5.7-5.4 9.9l56 192c1 3.4 4.1 5.8 7.7 5.8s6.7-2.3 7.7-5.8L192 276.6l48.3 165.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.3 7.7-5.8l56-192c1.2-4.2-1.2-8.7-5.4-9.9s-8.7 1.2-9.9 5.4L248 411.4 199.7 245.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.3-7.7 5.8L136 411.4 87.7 245.8z"]
  },
  ap = {
    prefix: "fat",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M288 0c-6.4 0-12.8 1.4-18.6 4.1L43.9 109.4C36.6 112.7 32 120 32 128s4.6 15.3 11.9 18.6L269.4 251.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 146.6C539.4 143.3 544 136 544 128s-4.6-15.3-11.9-18.6L306.6 4.1C300.8 1.4 294.4 0 288 0zM276.1 18.6c3.7-1.7 7.8-2.6 11.9-2.6s8.2 .9 11.9 2.6L525.4 123.9c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 237.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 132.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1L276.1 18.6zM43.9 237.4C36.6 240.7 32 248 32 256s4.6 15.3 11.9 18.6L269.4 379.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 274.6C539.4 271.3 544 264 544 256s-4.6-15.3-11.9-18.6l-59.4-27.7-18.9 8.8 71.5 33.4c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 365.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 260.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1l71.5-33.4-18.9-8.8L43.9 237.4zm0 128C36.6 368.7 32 376 32 384s4.6 15.3 11.9 18.6L269.4 507.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 402.6C539.4 399.3 544 392 544 384s-4.6-15.3-11.9-18.6l-59.4-27.7-18.9 8.8 71.5 33.4c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 493.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 388.1c-1.6-.8-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1l71.5-33.4-18.9-8.8L43.9 365.4z"]
  },
  op = {
    prefix: "fat",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 40c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H285.4L115.9 464H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H98.6L268.1 48H136c-4.4 0-8-3.6-8-8z"]
  },
  sp = {
    prefix: "fat",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M208 16C99.4 16 16 90 16 176c0 36.1 15.1 68.8 38.9 96.5c1.9 2.2 2.4 5.3 1.4 8c-8 21.5-21.4 41.2-40.2 55.4L16 336c28.8 0 57.3-10.1 83.4-23.9c2.3-1.2 5-1.2 7.3-.1c31.7 15.7 65.9 24 101.3 24c108.6 0 192-74 192-160s-83.4-160-192-160zM0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.5 0-71.9-8.4-104.7-23.9C76.8 341.7 47 352 16 352c-6.9 0-13.1-4.5-15.2-11.1c-2.1-6.6 .2-13.7 5.7-17.8c14.7-11.2 25.9-26.6 33.1-43.9C15.7 250.1 0 215.2 0 176zm448 0c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 39.2-15.7 74.1-39.6 103.2c7.2 17.3 18.4 32.7 33.1 43.9c5.5 4.1 7.9 11.3 5.7 17.8c-2.1 6.6-8.3 11.1-15.2 11.1c-31 0-60.8-10.3-87.3-23.9C503.9 503.6 468.5 512 432 512c-95.7 0-176.2-54.6-200.5-129c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c35.3 0 69.6-8.4 101.3-24c2.3-1.1 5-1.1 7.3 .1C566.7 485.9 595.2 496 624 496l-.1-.1c-18.7-14.2-32.2-33.9-40.2-55.4c-1-2.7-.5-5.8 1.4-8C608.9 404.9 624 372.1 624 336c0-81.7-75.3-152.6-176-159.5l0-.5zM215.1 90.7v14.8c1.7 .2 3.3 .4 5 .6c4.3 .7 17.5 3.2 22.1 4.4c3.8 1 6.1 4.9 5.1 8.7s-4.9 6.1-8.7 5.1c-4-1-16.6-3.5-20.7-4.1c-12.7-2-23.9-.5-32 3.1c-8.1 3.6-12.5 9-13.6 15.1c-.8 4.8-.2 8.2 1 10.8c1.3 2.7 3.5 5.1 7 7.4c7.2 4.8 17.6 7.9 29.6 11.5l.2 .1c11.4 3.4 24.4 7.3 33.8 14.1c4.9 3.5 9.1 8 11.7 13.8c2.6 5.9 3.3 12.6 1.9 20.1c-2.2 12.8-10.7 21.6-22.1 26.4c-6.1 2.6-13 4-20.5 4.4v14.3c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1V246.6c-1.7-.2-3.3-.4-5-.6l0 0c-7.7-1.2-20.3-5.5-28.8-8.3l0 0c-1.7-.6-3.2-1.1-4.5-1.5c-3.7-1.2-5.8-5.2-4.5-9s5.2-5.8 9-4.5c1.6 .5 3.3 1.1 5.1 1.7l0 0 0 0 0 0 0 0c8.6 2.9 19.5 6.6 25.9 7.6c12.9 2 24 .9 32-2.4c7.7-3.3 12.3-8.6 13.6-15.8c.9-5.3 .3-9.1-.9-12c-1.3-2.9-3.6-5.6-6.9-8c-7.1-5.1-17.5-8.4-29.6-12l-1.5-.4c-11-3.3-23.3-6.9-32.2-12.9c-4.9-3.3-9.2-7.5-11.9-13.1c-2.7-5.7-3.5-12.2-2.2-19.4c2.1-11.9 10.7-20.7 21.8-25.6c6.1-2.7 13.2-4.4 20.7-5V90.7c0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1z"]
  },
  lp = {
    prefix: "fat",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M19.5 186.7L144.6 54.6c4-4.2 9.6-6.6 15.4-6.6s11.4 2.4 15.4 6.6L300.5 186.7c2.2 2.3 3.5 5.4 3.5 8.7c0 7-5.6 12.6-12.6 12.6H28.6c-7 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7zm-11.6-11C2.8 181 0 188.1 0 195.4C0 211.2 12.8 224 28.6 224H291.4c15.8 0 28.6-12.8 28.6-28.6c0-7.3-2.8-14.4-7.8-19.7L187 43.6C180 36.2 170.2 32 160 32s-20 4.2-27 11.6L7.8 175.7zM19.5 325.3c-2.2-2.3-3.5-5.4-3.5-8.7c0-7 5.6-12.6 12.6-12.6H291.4c7 0 12.6 5.6 12.6 12.6c0 3.2-1.2 6.3-3.5 8.7L175.4 457.4c-4 4.2-9.6 6.6-15.4 6.6s-11.4-2.4-15.4-6.6L19.5 325.3zm-11.6 11L133 468.4c7 7.4 16.8 11.6 27 11.6s20-4.2 27-11.6L312.2 336.3c5-5.3 7.8-12.4 7.8-19.7c0-15.8-12.8-28.6-28.6-28.6H28.6C12.8 288 0 300.8 0 316.6c0 7.3 2.8 14.4 7.8 19.7z"]
  },
  fp = {
    prefix: "fat",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M40 48c0-4.4 3.6-8 8-8H80c4.4 0 8 3.6 8 8V208h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H32c-4.4 0-8-3.6-8-8s3.6-8 8-8H72V56H48c-4.4 0-8-3.6-8-8zm71.2 270.7c-13.3-15.2-36.4-16.9-51.7-3.7L37.2 334.1c-3.4 2.9-8.4 2.5-11.3-.9s-2.5-8.4 .9-11.3l22.3-19.1c22-18.9 55.1-16.5 74.2 5.3c17.9 20.5 17.4 51.1-1.2 71L42.5 464H136c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-3.2 0-6.1-1.9-7.3-4.8s-.7-6.3 1.5-8.7l92.2-98.4c13-13.8 13.3-35.2 .8-49.5zM208 88H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  up = {
    prefix: "fat",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM336 80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm-96 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm-96 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zM432 80c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM336 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-64 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zM464 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"]
  },
  dp = {
    prefix: "fat",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M332.7 90.5L270.9 22.6c-3.8-4.2-9.2-6.6-14.9-6.6s-11.1 2.4-14.9 6.6L179.3 90.5c-2.1 2.4-3.3 5.4-3.3 8.6c0 7.1 5.8 12.8 12.8 12.8l134.3 0c7.1 0 12.8-5.8 12.8-12.8c0-3.2-1.2-6.3-3.3-8.6zM282.8 11.8l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8H264V248H384v16H264V384h59.2c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8H248V264H128l0 59.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 59.2H248V128l-59.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM270.9 489.4l61.7-67.9c2.2-2.4 3.3-5.4 3.3-8.6c0-7.1-5.8-12.8-12.8-12.8H188.8c-7.1 0-12.8 5.8-12.8 12.8c0 3.2 1.2 6.3 3.3 8.6l61.7 67.9c3.8 4.2 9.2 6.6 14.9 6.6s11.1-2.4 14.9-6.6zM489.4 270.9c4.2-3.8 6.6-9.2 6.6-14.9s-2.4-11.1-6.6-14.9l-67.9-61.7c-2.4-2.1-5.4-3.3-8.6-3.3c-7.1 0-12.8 5.8-12.8 12.8V323.2c0 7.1 5.8 12.8 12.8 12.8c3.2 0 6.3-1.2 8.6-3.3l67.9-61.7zm-57.1 73.6c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM90.5 332.7c2.4 2.2 5.4 3.3 8.6 3.3c7.1 0 12.8-5.8 12.8-12.8l0-134.3c0-7.1-5.8-12.8-12.8-12.8c-3.2 0-6.3 1.2-8.6 3.3L22.6 241.1c-4.2 3.8-6.6 9.2-6.6 14.9s2.4 11.1 6.6 14.9l67.9 61.7z"]
  },
  pp = {
    prefix: "fat",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M232.1 170.7L78.8 193.3c-3 .4-5.5 2.5-6.4 5.4s-.2 6 2 8.2L63.2 218.1l11.2-11.3L185.5 317c3.7 3.7 5.4 8.9 4.5 14L163.8 486.6c-.5 3 .7 6 3.2 7.8s5.8 2 8.4 .6L312 422V22L244.1 161.8c-2.3 4.8-6.8 8.1-12.1 8.8zM328 422.1L464.4 495c2.7 1.4 6 1.2 8.4-.6s3.7-4.8 3.2-7.8L449.9 331c-.9-5.1 .8-10.4 4.5-14L565.5 206.9c2.2-2.1 2.9-5.3 2-8.2s-3.4-5-6.4-5.4L407.8 170.7c-5.2-.8-9.7-4.1-12.1-8.8L328 22.3V422.1zm154.2 85.3c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L298.3 13.5C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z"]
  },
  mp = {
    prefix: "fat",
    iconName: "code",
    icon: [640, 512, [], "f121", "M410.7 .5c-4.2-1.5-8.7 .7-10.2 4.9l-176 496c-1.5 4.2 .7 8.7 4.9 10.2s8.7-.7 10.2-4.9l176-496c1.5-4.2-.7-8.7-4.9-10.2zm71.5 122.1c-3 3.2-2.9 8.3 .3 11.3L612.3 256 482.5 378.2c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3l136-128c1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8l-136-128c-3.2-3-8.3-2.9-11.3 .3zm-324.3 0c-3-3.2-8.1-3.4-11.3-.3l-136 128C8.9 251.7 8 253.8 8 256s.9 4.3 2.5 5.8l136 128c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3L27.7 256 157.5 133.8c3.2-3 3.4-8.1 .3-11.3z"]
  },
  hp = {
    prefix: "fat",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V200 439.7 504c0 4.4 3.6 8 8 8s8-3.6 8-8V447.7H216 560V504c0 4.4 3.6 8 8 8s8-3.6 8-8V439.7 280 200 136c0-57.4-46.6-104-104-104H232c-13.3 0-24 10.7-24 24V192H16V8zM208 296V431.7H16V208H216 560v64H232c-13.3 0-24 10.7-24 24zM560 136v56H224V56c0-4.4 3.6-8 8-8H472c48.6 0 88 39.4 88 88zM232 288H560V431.7H224V296c0-4.4 3.6-8 8-8zM112 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  vp = {
    prefix: "fat",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M28.3 34.5C31 14.7 47.9 0 67.9 0h153C240.3 0 256 15.7 256 35.1c0 4.2-.8 8.4-2.2 12.3L211.5 160H357.7c14.5 0 26.3 11.8 26.3 26.3c0 5.3-1.6 10.6-4.7 15L170.4 503c-3.9 5.7-10.4 9-17.2 9c-13.9 0-24-13.3-20.2-26.7L189.4 288H40c-22.1 0-40-17.9-40-40v-8c0-.4 0-.7 .1-1.1L28.3 34.5zM67.9 16c-12 0-22.1 8.8-23.8 20.7L16 240.5V248c0 13.3 10.7 24 24 24H200c2.5 0 4.9 1.2 6.4 3.2s2 4.6 1.3 7L148.4 489.7c-.9 3.2 1.5 6.3 4.8 6.3c1.6 0 3.2-.8 4.1-2.1L366.2 192.1c1.2-1.7 1.8-3.8 1.8-5.9c0-5.7-4.6-10.3-10.3-10.3H200c-2.6 0-5.1-1.3-6.6-3.4s-1.8-4.9-.9-7.4L238.8 41.8c.8-2.1 1.2-4.4 1.2-6.7c0-10.5-8.5-19.1-19.1-19.1H67.9z"]
  },
  gp = {
    prefix: "fat",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm70.7 227.6c-2.5-3.7-7.4-4.7-11.1-2.2s-4.7 7.4-2.2 11.1l61 91.6-61 91.6c-2.5 3.7-1.5 8.6 2.2 11.1s8.6 1.5 11.1-2.2l57.3-86 57.3 86c2.5 3.7 7.4 4.7 11.1 2.2s4.7-7.4 2.2-11.1l-61-91.6 61-91.6c2.5-3.7 1.5-8.6-2.2-11.1s-8.6-1.5-11.1 2.2l-57.3 86-57.3-86z"]
  },
  bp = {
    prefix: "fat",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM200 352a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144z"]
  },
  Hp = {
    prefix: "fat",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M144 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM287.8 152c-4.2 75.8-66.9 136-143.8 136C64.5 288 0 223.5 0 144S64.5 0 144 0c76.8 0 139.6 60.2 143.8 136H353c3.6-13.8 16.1-24 31-24H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-14.9 0-27.4-10.2-31-24H287.8zm96.2 8H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16s7.2 16 16 16zM264 320h8 16 48V296c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v24h48 16 8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8V464c0 26.5-21.5 48-48 48H320c-26.5 0-48-21.5-48-48V336h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm88 0h96V296c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v24zm160 16H288V464c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V336zM224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zM48 144a96 96 0 1 1 192 0A96 96 0 1 1 48 144zM0 504c0-4.4 3.6-8 8-8H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM160 336v64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm16 80H160v16c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16h96 16 16c26.5 0 48 21.5 48 48s-21.5 48-48 48zM48 336v96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V416 400 336H48z"]
  },
  zp = {
    prefix: "fat",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 16c61.9 0 112 50.1 112 112v64H112V128c0-61.9 50.1-112 112-112zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 208H96h16H336h16 32c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48zM240 320v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-8.8 7.2-16 16-16s16 7.2 16 16zm-48 0v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
  },
  yp = {
    prefix: "fat",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M336 128c0-61.9 50.1-112 112-112s112 50.1 112 112v88c0 4.4 3.6 8 8 8s8-3.6 8-8V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H336V128zm-16 80h16 48c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48H320z"]
  },
  Vp = {
    prefix: "fat",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  xp = {
    prefix: "fat",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M176 240l0-89.1c0-3.8-3.1-6.9-6.9-6.9c-1.8 0-3.5 .7-4.7 1.9L16.8 286.1c-.5 .5-.8 1.2-.8 1.9s.3 1.4 .8 1.9L164.4 430.1c1.3 1.2 3 1.9 4.7 1.9c3.8 0 6.9-3.1 6.9-6.9l0-89.1c0-8.8 7.2-16 16-16l208 0c53 0 96-43 96-96l0-152c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24l0 152c0 17.7-14.3 32-32 32l-208 0c-8.8 0-16-7.2-16-16zM5.8 274.5L153.4 134.3c4.3-4 9.9-6.3 15.8-6.3c12.6 0 22.9 10.2 22.9 22.9l0 73.1 0 16 16 0 192 0c8.8 0 16-7.2 16-16l0-152c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 152c0 61.9-50.1 112-112 112l-192 0-16 0 0 16 0 73.1c0 12.6-10.2 22.9-22.9 22.9c-5.9 0-11.5-2.3-15.8-6.3L5.8 301.5C2.1 298 0 293.1 0 288s2.1-10 5.8-13.5z"]
  },
  Mp = {
    prefix: "fat",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-56c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L264 294.9V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V290.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H224c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  _p = {
    prefix: "fat",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM176 368h32c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H176c-4.4 0-8-3.6-8-8V376c0-4.4 3.6-8 8-8zm8 128h24c13.3 0 24-10.7 24-24V408c0-13.3-10.7-24-24-24H184V496zM456 368h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zM296 400c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H328c-17.7 0-32-14.3-32-32V400zm32-16c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H328z"]
  },
  wp = {
    prefix: "fat",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M106.3 124.3C151.4 82.4 212.4 48 288 48s136.6 34.4 181.7 76.3c44.9 41.7 75 91.7 89.1 125.6c1.6 3.9 1.6 8.4 0 12.3C544.7 296 514.6 346 469.7 387.7C424.6 429.6 363.6 464 288 464s-136.6-34.4-181.7-76.3C61.4 346 31.3 296 17.2 262.2c-1.6-3.9-1.6-8.4 0-12.3C31.3 216 61.4 166 106.3 124.3zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm208 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z"]
  },
  Ep = {
    prefix: "fat",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c4.4 0 8 3.6 8 8V144c0 39.8 12.9 78.6 36.8 110.4L240 280c26 34.6 40 76.7 40 120v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V400c0-39.8-12.9-78.6-36.8-110.4L208 264c-26-34.6-40-76.7-40-120V40c0-4.4 3.6-8 8-8zM8 96c4.4 0 8 3.6 8 8v53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C100.3 340 112 378.6 112 418.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V418.1c0-36.3-10.8-71.8-30.9-102.1L33.6 268.8C11.7 236 0 197.4 0 157.9V104c0-4.4 3.6-8 8-8zm344 8v53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C436.3 340 448 378.6 448 418.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V418.1c0-36.3-10.8-71.8-30.9-102.1l-31.5-47.3C347.7 236 336 197.4 336 157.9V104c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  Cp = {
    prefix: "fat",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M16 96c0-26.5 21.5-48 48-48l0 112c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V49.2c8.8 2 17 6.4 23.4 12.9l74.5 74.5c9 9 14.1 21.2 14.1 33.9V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96zM80 48H304V160c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V48zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM296 328a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176z"]
  },
  Lp = {
    prefix: "fat",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M317.1 378.1c-4.7 5.7-12.6 7.5-19.2 4.3c-73.8-34.8-133.5-94.5-168.3-168.3c-3.1-6.6-1.3-14.6 4.3-19.2l49.3-40.4c8.2-6.7 11-18 7-27.8l-40-96c-4.6-11.1-16.8-17.1-28.5-13.9l-88 24C23.2 43.7 16 53.2 16 64c0 238.6 193.4 432 432 432c10.8 0 20.3-7.2 23.2-17.7l24-88c3.2-11.6-2.8-23.8-13.9-28.5l-96-40c-9.8-4.1-21.1-1.3-27.8 7l-40.4 49.3zM304.7 368L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7z"]
  },
  Np = {
    prefix: "fat",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M72 48c-30.9 0-56 25.1-56 56V216c0 4.4-3.6 8-8 8s-8-3.6-8-8V104C0 64.2 32.2 32 72 32h37.2H120 454.1C468.4 32 480 43.6 480 57.9c0 4-.9 8-2.7 11.6L421.5 181c54.3 33.9 90.5 94.2 90.5 163c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344c0-69 36.4-129.5 91-163.3L97.1 50.6c-.4-.8-.6-1.7-.8-2.6H72zm98.4 128H406.1L463 62.3c.7-1.4 1-2.9 1-4.4c0-5.5-4.4-9.9-9.9-9.9H120h-6.5l56.9 128zM416 192H160v0h7.2c-41.1 24.1-71.6 64.3-82.7 112H491.4c-11.1-47.7-41.6-87.9-82.7-112H416v0zm78.4 128H81.6c-1.1 7.8-1.6 15.9-1.6 24c0 49.1 30.9 89.1 51.3 110c6.3 6.5 15.8 10 26.6 10H418c10.9 0 20.3-3.6 26.6-10c20.4-20.9 51.3-60.9 51.3-110c0-8.1-.6-16.2-1.6-24z"]
  },
  Sp = {
    prefix: "fat",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M177.7 16h92.5c8.3 0 16 4.3 20.4 11.3l23 36.7H134.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L115.6 64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H332.4L304.2 18.8C296.9 7.1 284.1 0 270.3 0H177.7c-13.8 0-26.6 7.1-33.9 18.8zM48 119.3c-.4-4.4-4.2-7.7-8.6-7.3s-7.7 4.2-7.3 8.6l28.3 340c2.4 29 26.7 51.4 55.8 51.4H331.8c29.1 0 53.4-22.3 55.8-51.4l28.3-340c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3l-28.3 340C370 480.1 352.6 496 331.8 496H116.2c-20.8 0-38.1-15.9-39.9-36.7L48 119.3z"]
  },
  kp = {
    prefix: "fat",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M2.5 250.2C.9 251.7 0 253.8 0 256s.9 4.3 2.5 5.8l192 184c3.2 3.1 8.3 3 11.3-.2s2.9-8.3-.2-11.3L27.9 264 440 264c4.4 0 8-3.6 8-8s-3.6-8-8-8L27.9 248 205.5 77.8c3.2-3.1 3.3-8.1 .2-11.3s-8.1-3.3-11.3-.2l-192 184z"]
  },
  Pp = {
    prefix: "fat",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM0 320c0 4.4 3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  Tp = {
    prefix: "fat",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM224 272c8.8 0 16 7.2 16 16v24 48 24c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16H224zm32 112V373.8l42.6 24.3c2.2 1.2 4.6 1.9 7.1 1.9c7.9 0 14.3-6.4 14.3-14.3V286.3c0-7.9-6.4-14.3-14.3-14.3c-2.5 0-4.9 .7-7.1 1.9L256 298.2V288c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32zm48-1.2l-48-27.4V316.6l48-27.4v93.6z"]
  },
  Op = {
    prefix: "fat",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M345 16H472c13.3 0 24 10.7 24 24V167c0 13.8-11.2 25-25 25c-6.6 0-13-2.6-17.7-7.3L396 127.3 213.7 309.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L384.7 116 327.3 58.6c-4.7-4.7-7.3-11-7.3-17.7c0-13.8 11.2-25 25-25zm-9 25c0 2.4 .9 4.7 2.6 6.3L464.7 173.4c1.7 1.7 4 2.6 6.3 2.6c5 0 9-4 9-9V40c0-4.4-3.6-8-8-8H345c-5 0-9 4-9 9zM0 88C0 57.1 25.1 32 56 32H200c4.4 0 8 3.6 8 8s-3.6 8-8 8H56C33.9 48 16 65.9 16 88V456c0 22.1 17.9 40 40 40H424c22.1 0 40-17.9 40-40V312c0-4.4 3.6-8 8-8s8 3.6 8 8V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88z"]
  },
  Ap = {
    prefix: "fat",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM176 368h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H184v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H184v64h24zm96-80h32c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H304c-4.4 0-8-3.6-8-8V376c0-4.4 3.6-8 8-8zm8 128h24c13.3 0 24-10.7 24-24V408c0-13.3-10.7-24-24-24H312V496zM424 376c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v48h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V440 376z"]
  },
  Dp = {
    prefix: "fat",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 368H424c7.3 0 13.7 5 15.5 12.1l3.6 14.3C453.3 435.3 490 464 532.2 464c50.7 0 91.8-41.1 91.8-91.8v-2.8c0-5.4-.5-10.7-1.4-16L589.9 162.5c-7.8-45.5-36.6-82.3-78.4-92.7C466.8 58.7 402.5 48 320 48s-146.8 10.7-191.5 21.8c-41.9 10.4-70.6 47.3-78.4 92.7L17.4 353.4c-.9 5.3-1.4 10.6-1.4 16v2.8c0 50.7 41.1 91.8 91.8 91.8c42.1 0 78.9-28.7 89.1-69.5l3.6-14.3c1.8-7.1 8.2-12.1 15.5-12.1zm211.6 30.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM200 160v56h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H200v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V232H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V160c0-4.4 3.6-8 8-8s8 3.6 8 8zM392 272a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  Ip = {
    prefix: "fat",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M248 16c-4.4 0-8 3.6-8 8v8H368V24c0-4.4-3.6-8-8-8H248zM224 32V24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H510.4c53.9 0 97.6 43.7 97.6 97.6c0 16.8-13.6 30.4-30.4 30.4H408c-13.3 0-24 10.7-24 24V392c0 4.4-3.6 8-8 8H284.7c2.2 7.6 3.3 15.7 3.3 24c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-10.5 1.8-20.6 5.2-30L22.9 324.8C8.5 314.3 0 297.5 0 279.7V88C0 57.1 25.1 32 56 32H224zM384 48H368 240 224 56C33.9 48 16 65.9 16 88V279.7c0 12.7 6.1 24.7 16.3 32.3l91.8 67.4C139.5 353.4 167.7 336 200 336c34.2 0 63.8 19.5 78.4 48H368V184c0-22.1 17.9-40 40-40H577.6c8 0 14.4-6.4 14.4-14.4C592 84.5 555.5 48 510.4 48H384zM200 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm288 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0-160a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM272 128H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16zM112 112H272c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zm304 88c0-4.4 3.6-8 8-8h93.1c8.8 0 17.4 2.9 24.4 8.3l82.9 63.8c9.8 7.6 15.6 19.3 15.6 31.7V360c0 22.1-17.9 40-40 40h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c13.3 0 24-10.7 24-24V295.8c0-2.7-.4-5.3-1.3-7.8H424c-4.4 0-8-3.6-8-8s3.6-8 8-8H608.5l-76.7-59c-4.2-3.2-9.3-5-14.6-5H424c-4.4 0-8-3.6-8-8z"]
  },
  jp = {
    prefix: "fat",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M384 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM351.6 314.3c-14.3 3.4-30.4 5.7-47.6 5.7c-32 0-56-16-80-32s-48-32-80-32c-13.4 0-27.4 2.2-40.7 5.4c17.6-49.7 65-85.4 120.7-85.4c70.7 0 128 57.3 128 128c0 3.5-.1 6.9-.4 10.3zm-2.5 16.9C336.6 388.8 285.3 432 224 432c-70.7 0-128-57.3-128-128c0-8.5 .8-16.8 2.4-24.9c15-4.2 30.9-7.1 45.6-7.1c26.5 0 46.6 13 71.1 29.3l1.2 .8C239.6 317.6 267.1 336 304 336c16.2 0 31.3-1.9 45.1-4.8zM224 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
  },
  Fp = {
    prefix: "fat",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 80c-26.5 0-48 21.5-48 48v28.2L220.8 321.4c20.5 16.5 49.8 16.5 70.3 0L496 156.2V128c0-26.5-21.5-48-48-48H64zM16 176.7V384c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V176.7L301.2 333.8c-26.4 21.3-64 21.3-90.4 0L16 176.7zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
  },
  Rp = {
    prefix: "fat",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M386.3 61.7c-32.2-32.2-84.5-32.2-116.7 0l-192 192c-49.9 49.9-49.9 130.8 0 180.7s130.8 49.9 180.7 0l152-152c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-152 152c-56.1 56.1-147.2 56.1-203.3 0s-56.1-147.2 0-203.3l192-192c38.5-38.5 100.8-38.5 139.3 0s38.5 100.8 0 139.3L213.9 373.4c-24.8 24.8-65.7 22.6-87.7-4.9c-18.8-23.4-16.9-57.2 4.3-78.5L282.3 138.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L141.9 301.4c-15.5 15.5-16.8 40.1-3.2 57.2c16 20 45.8 21.6 63.9 3.5L386.3 178.3c32.2-32.2 32.2-84.5 0-116.7z"]
  },
  Bp = {
    prefix: "fat",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm492.9-6.3c-3.5-2.7-8.5-2.1-11.2 1.4L383.3 213.3C363 239.2 352 271.1 352 304v0c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-22 0-42.8 4.9-61.5 13.7l75.8-96.8c2.7-3.5 2.1-8.5-1.4-11.2zM368 304c0-.7 0-1.3 0-2c1.1-69.8 58-126 128-126c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128v0z"]
  },
  Gp = {
    prefix: "fat",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V216c0-4.4-3.6-8-8-8H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h24V352H208zm48-176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
  },
  Yp = {
    prefix: "fat",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM144 144c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm64 96c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zm128 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zM160 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm128 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352z"]
  },
  Wp = {
    prefix: "fat",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M424 256c0 4.4-3.6 8-8 8L32 264c-4.4 0-8-3.6-8-8s3.6-8 8-8l384 0c4.4 0 8 3.6 8 8z"]
  },
  qp = {
    prefix: "fat",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M211.6 28.5c1.6-7.3 8.1-12.5 15.6-12.5h57.6c7.5 0 14 5.2 15.6 12.5l12.9 57.1c.6 2.6 2.5 4.8 5 5.7c17.9 6.8 34.5 16.4 49.1 28.4c2.1 1.7 4.9 2.2 7.4 1.4l56-17.4c7.1-2.2 14.9 .8 18.6 7.3L478.3 161c3.7 6.5 2.5 14.7-3 19.8l-43.1 39.8c-2 1.8-2.9 4.5-2.5 7.2c1.5 9.2 2.3 18.7 2.3 28.4s-.8 19.1-2.3 28.4c-.4 2.6 .5 5.3 2.5 7.2l43.1 39.8c5.5 5.1 6.7 13.3 3 19.8L449.4 401c-3.7 6.5-11.5 9.5-18.6 7.3l-56-17.4c-2.6-.8-5.4-.3-7.4 1.4c-14.6 11.9-31.2 21.6-49.1 28.4c-2.5 1-4.4 3.1-5 5.7l-12.9 57.1c-1.6 7.3-8.1 12.5-15.6 12.5H227.2c-7.5 0-14-5.2-15.6-12.5l-12.9-57.1c-.6-2.6-2.5-4.8-5-5.7c-17.9-6.8-34.5-16.4-49.1-28.4c-2.1-1.7-4.9-2.2-7.4-1.4l-56 17.4c-7.1 2.2-14.9-.8-18.6-7.3L33.7 351c-3.7-6.5-2.5-14.7 3-19.8l43.1-39.8c2-1.8 2.9-4.5 2.5-7.2C80.8 275.1 80 265.7 80 256s.8-19.1 2.3-28.4c.4-2.6-.5-5.3-2.5-7.2L36.7 180.7c-5.5-5.1-6.7-13.3-3-19.8L62.6 111c3.7-6.5 11.5-9.5 18.6-7.3l2.4-7.6-2.4 7.6 56 17.4c2.6 .8 5.4 .3 7.4-1.4c14.6-12 31.2-21.6 49.1-28.4c2.5-1 4.4-3.1 5-5.7l12.9-57.1zM227.2 0c-15 0-27.9 10.4-31.2 25L184 78c-16.7 6.8-32.2 15.8-46.1 26.7L85.9 88.5C71.6 84 56.2 90.1 48.7 103L19.9 153c-7.5 13-5 29.4 6 39.5l39.9 36.9C64.6 238.1 64 247 64 256s.6 17.9 1.8 26.6L25.9 319.5l5.4 5.9-5.4-5.9c-11 10.1-13.5 26.6-6 39.5L48.7 409c7.5 13 22.9 19 37.2 14.6l51.9-16.2c14 10.9 29.5 19.9 46.1 26.7l12 53c3.3 14.6 16.3 25 31.2 25h57.6c15 0 27.9-10.4 31.2-25l12-53c16.7-6.7 32.2-15.8 46.1-26.7l51.9 16.2c14.3 4.4 29.7-1.6 37.2-14.6L492.1 359c7.5-13 5-29.4-6-39.5l-39.9-36.9c1.2-8.7 1.8-17.6 1.8-26.6s-.6-17.9-1.8-26.6l39.9-36.9c11-10.1 13.5-26.6 6-39.5L463.3 103c-7.5-13-22.9-19-37.2-14.6l-51.9 16.2C360.2 93.7 344.7 84.7 328 78L316 25c-3.3-14.6-16.3-25-31.2-25H227.2zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
  },
  Up = {
    prefix: "fat",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M384 16c26.5 0 48 21.5 48 48V384H16V64c0-26.5 21.5-48 48-48H384zm48 384v48c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V400H432zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 448c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H176c-4.4 0-8 3.6-8 8z"]
  },
  $p = {
    prefix: "fat",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l120 0c39.8 0 72-32.2 72-72l0-412.7L338.3 165.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-152-152c-3.1-3.1-8.2-3.1-11.3 0l-152 152c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L184 27.3 184 440c0 30.9-25.1 56-56 56L8 496z"]
  },
  Xp = {
    prefix: "fat",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V256c0 2.7 1.3 5.2 3.6 6.7l96 64c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1L264 251.7V104c0-4.4-3.6-8-8-8s-8 3.6-8 8z"]
  },
  Zp = {
    prefix: "fat",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M288 16c26.5 0 48 21.5 48 48V384H48V64c0-26.5 21.5-48 48-48H288zm48 384v48c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V400H336zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm40 448c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H144c-4.4 0-8 3.6-8 8z"]
  },
  Kp = {
    prefix: "fat",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 4.4 3.6 8 8 8l88.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56L504 424c4.4 0 8-3.6 8-8s-3.6-8-8-8l-280.5 0c-3.9-31.6-30.9-56-63.5-56s-59.6 24.4-63.5 56L8 408c-4.4 0-8 3.6-8 8zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-64c-32.6 0-59.6 24.4-63.5 56L8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l280.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56l88.5 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-88.5 0c-3.9-31.6-30.9-56-63.5-56zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm63.5-56c-3.9-31.6-30.9-56-63.5-56s-59.6 24.4-63.5 56L8 88c-4.4 0-8 3.6-8 8s3.6 8 8 8l120.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56L504 104c4.4 0 8-3.6 8-8s-3.6-8-8-8L255.5 88z"]
  },
  Qp = {
    prefix: "fat",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 400a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM48 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  Jp = {
    prefix: "fat",
    iconName: "download",
    icon: [512, 512, [], "f019", "M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V356.7L133.7 242.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l128 128c3.1 3.1 8.2 3.1 11.3 0l128-128c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 356.7V8zM143.4 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H368.6l-16 16H448c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V384c0-26.5 21.5-48 48-48h95.4l-16-16zM432 432a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
  },
  em = {
    prefix: "fat",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M96 16C51.8 16 16 51.8 16 96v64H432V96c0-44.2-35.8-80-80-80H96zM0 168V96C0 43 43 0 96 0H352c53 0 96 43 96 96v72V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V168zm432 8H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V176zM80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM272 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 240c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 40c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8z"]
  },
  tm = {
    prefix: "fat",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M104 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zM8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM96 320c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  nm = {
    prefix: "fat",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H368V328c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24V496H128c-26.5 0-48-21.5-48-48zm144 48V328c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8V496H224z"]
  },
  cm = {
    prefix: "fat",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M92.1 384.1c70.7 90.5 201.4 106.6 292 35.8c22.9-17.9 41.1-39.7 54.2-63.7c2.1-3.9 7-5.3 10.9-3.2s5.3 7 3.2 10.9c-14.2 25.8-33.7 49.3-58.4 68.6c-97.5 76.2-238.3 58.9-314.4-38.6S20.6 155.7 118.1 79.5c89.8-70.2 216.4-61 295.3 17.1l-11.3 11.3c-73.3-72.5-190.8-81-274.2-15.8c-90.5 70.7-106.6 201.4-35.8 292zM480 192c4.4 0 8-3.6 8-8V64c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7l-120 120c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9H480zM360 208c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2L463 47c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V184c0 13.3-10.7 24-24 24H360z"]
  },
  im = {
    prefix: "fat",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M41.3 .1c4.4 .7 7.3 4.8 6.6 9.2L24.8 148.1c-.5 3-.8 6.1-.8 9.2V168c0 30.9 25.1 56 56 56h64c30.9 0 56-25.1 56-56V157.3c0-3.1-.3-6.2-.8-9.2L176.1 9.3c-.7-4.4 2.2-8.5 6.6-9.2s8.5 2.2 9.2 6.6L215 145.5c.7 3.9 1 7.9 1 11.8V168c0 39.8-32.2 72-72 72H120V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V240H80c-39.8 0-72-32.2-72-72V157.3c0-4 .3-7.9 1-11.8L32.1 6.7C32.8 2.3 37-.6 41.3 .1zM88.4 0c4.4 .2 7.8 4 7.6 8.4l-8 160c-.2 4.4-4 7.8-8.4 7.6s-7.8-4-7.6-8.4l8-160c.2-4.4 4-7.8 8.4-7.6zm47.2 0c4.4-.2 8.2 3.2 8.4 7.6l8 160c.2 4.4-3.2 8.2-7.6 8.4s-8.2-3.2-8.4-7.6l-8-160c-.2-4.4 3.2-8.2 7.6-8.4zM304 176V304c0 17.7 14.3 32 32 32h80V24c0-4.4-3.6-8-8-8l0 0c-.1 0-1.9 .1-5.7 1.1c-3.5 .9-8.1 2.5-13.4 4.8c-10.6 4.6-23.5 12.2-36 23.8C328.2 68.6 304 108.3 304 176zM408 0c13.3 0 24 10.7 24 24V336v8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V352H336c-26.5 0-48-21.5-48-48V176C288 32 392 0 408 0z"]
  },
  rm = {
    prefix: "fat",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M8 88c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM136 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm-8 168c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H136c-4.4 0-8 3.6-8 8zM0 440c0 4.4 3.6 8 8 8s8-3.6 8-8l0-208c0-4.4-3.6-8-8-8s-8 3.6-8 8V440z"]
  },
  am = {
    prefix: "fat",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M264 27.3V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3L133.7 141.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l128-128c3.1-3.1 8.2-3.1 11.3 0l128 128c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L264 27.3zM216 336H64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V384c0-26.5-21.5-48-48-48H296V320H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H216v16zm216 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
  },
  om = {
    prefix: "fat",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M309.9 6.3C314.4 2.2 320.3 0 326.4 0c17.8 0 29.9 18.3 22.9 34.7L268.1 224H391.4c13.6 0 24.6 11 24.6 24.6c0 7-3 13.7-8.3 18.4L138.1 505.7c-4.6 4-10.4 6.3-16.5 6.3c-17.9 0-29.9-18.3-22.9-34.7L179.9 288H55.3C42.5 288 32 277.5 32 264.7c0-6.7 2.8-13 7.8-17.4L309.9 6.3zM326.4 16c-2.2 0-4.3 .8-5.9 2.2L50.5 259.2c-1.6 1.4-2.5 3.4-2.5 5.5c0 4.1 3.3 7.3 7.3 7.3H192c2.7 0 5.2 1.4 6.7 3.6s1.7 5.1 .7 7.6L113.4 483.6c-2.5 5.9 1.8 12.4 8.2 12.4c2.2 0 4.3-.8 5.9-2.2L397.1 255c1.8-1.6 2.9-4 2.9-6.4c0-4.7-3.8-8.6-8.6-8.6H256c-2.7 0-5.2-1.4-6.7-3.6s-1.7-5.1-.7-7.6L334.6 28.4c2.5-5.8-1.8-12.4-8.1-12.4z"]
  },
  sm = {
    prefix: "fat",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M8 0H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8S3.6 0 8 0zM48 202.6c9-3.5 19-6.6 29.5-9.4C120.2 182.1 174.9 176 224 176s103.8 6.1 146.5 17.3c10.6 2.8 20.5 5.9 29.5 9.4V48h16V209.7c2.9 1.5 5.6 3 8.1 4.6c13.3 8.3 23.9 19.4 23.9 33.7c0 67-32.9 117.2-77.2 150.4c-1.7 1.2-3.3 2.5-5 3.7l17 64.3c.8 3 1.2 6.2 1.2 9.3c0 20.1-16.3 36.3-36.3 36.3H100.3C80.3 512 64 495.7 64 475.7c0-3.1 .4-6.3 1.2-9.3l17-64.3c-1.7-1.2-3.4-2.4-5-3.7C32.9 365.2 0 315 0 248c0-14.3 10.6-25.4 23.9-33.7c2.5-1.6 5.3-3.1 8.1-4.6V48H48V202.6zM18.5 278.1c8 46.2 34.3 82 68.3 107.5C128.1 416.5 180.4 432 224 432s95.9-15.5 137.2-46.4c34-25.5 60.3-61.3 68.3-107.5c-1.7 1.2-3.5 2.4-5.3 3.6c-13.6 8.5-32.4 15.5-53.7 21.1C327.8 313.9 273.1 320 224 320s-103.8-6.1-146.5-17.3c-21.3-5.6-40-12.6-53.7-21.1c-1.8-1.1-3.6-2.3-5.3-3.6zM432 248c0-5.7-4.3-12.6-16.3-20.1c-11.7-7.3-28.7-13.8-49.3-19.2C325.4 197.9 272.1 192 224 192s-101.4 5.9-142.4 16.7C61 214.1 44 220.7 32.3 227.9C20.3 235.4 16 242.3 16 248s4.3 12.6 16.3 20.1C44 275.3 61 281.9 81.6 287.3C122.6 298.1 175.9 304 224 304s101.4-5.9 142.4-16.7c20.6-5.4 37.6-11.9 49.3-19.2c12-7.5 16.3-14.4 16.3-20.1zM104 80h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zM367.3 470.5l-15.7-59.2C311.3 435.8 264.4 448 224 448s-87.3-12.2-127.6-36.7L80.7 470.5c-.4 1.7-.7 3.4-.7 5.2c0 11.2 9.1 20.3 20.3 20.3H347.7c11.2 0 20.3-9.1 20.3-20.3c0-1.8-.2-3.5-.7-5.2z"]
  },
  lm = {
    prefix: "fat",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 16C37.5 16 16 37.5 16 64v96c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-28.8 13.9-54.4 35.3-70.4c3.5-2.7 8.5-1.9 11.2 1.6s1.9 8.6-1.6 11.2C107.3 379.5 96 400.4 96 424c0 39.8 32.2 72 72 72s72-32.2 72-72V256h16V424zm64-168h16V392c0 39.8 32.2 72 72 72s72-32.2 72-72c0-23.6-11.3-44.5-28.8-57.6c-3.5-2.7-4.3-7.7-1.6-11.2s7.7-4.3 11.2-1.6c21.4 16 35.2 41.6 35.2 70.4c0 48.6-39.4 88-88 88s-88-39.4-88-88V256zM104 128H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  fm = {
    prefix: "fat",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M281.1 440.4c4.6 17.1 22.2 27.1 39.3 22.5s27.1-22.2 22.5-39.3l-4.5-16.4c-5.7-20.8-22.3-56.7-33.7-75c-1.5-2.5-1.6-5.6-.2-8.1s4.1-4.1 7-4.1H448c22.1 0 40-17.9 40-40c0-14.2-7.3-26.6-18.5-33.7c-3.6-2.3-4.7-7-2.7-10.7c3.3-5.8 5.1-12.5 5.1-19.6c0-15.5-8.8-28.9-21.7-35.6c-2.1-1.1-3.6-3.1-4.1-5.4s0-4.7 1.5-6.6c5.2-6.8 8.3-15.2 8.3-24.4c0-17.8-11.6-32.8-27.6-38c-3.9-1.3-6.2-5.3-5.3-9.3c.6-2.8 .9-5.7 .9-8.6c0-22.1-17.9-40-40-40H286.5c-17.4 0-34.4 5.1-48.8 14.8L199.2 88.5c-10 6.6-18.3 15.1-24.7 24.8c-2.4 3.7-7.4 4.7-11.1 2.3s-4.7-7.4-2.3-11.1C168.7 93 178.6 83 190.3 75.1l38.5-25.7C245.9 38.1 266 32 286.5 32H384c30.9 0 56 25.1 56 56c0 1.8-.1 3.5-.2 5.3c19 8.9 32.2 28.3 32.2 50.7c0 9.7-2.5 18.9-6.9 26.9C479 181 488 197.5 488 216c0 7.4-1.4 14.5-4.1 21c12.3 10.3 20.1 25.7 20.1 43c0 30.9-25.1 56-56 56H325.4c10.9 20.3 23.4 48.5 28.5 67l4.5 16.4c7 25.6-8.1 52-33.7 58.9s-52-8.1-58.9-33.7l-4.5-16.4c-4.7-17.2-14.5-37.4-27.2-55.8c-12.7-18.4-27.7-34.5-42.5-43.8l-3.1-2c-10.9-6.9-20-15.8-27.2-26.1c-2.5-3.6-1.6-8.6 2-11.1s8.6-1.6 11.1 2c6 8.5 13.6 16 22.7 21.7l3.1 2c17.2 10.9 33.7 28.8 47.1 48.3c13.4 19.5 24.1 41.3 29.4 60.6l4.5 16.4zM32 368H96c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H32c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16zM0 352V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  um = {
    prefix: "fat",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M509.7 261.7c3.1-3.1 3.1-8.2 0-11.3l-152-152c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l476.7 0L346.3 402.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l152-152z"]
  },
  dm = {
    prefix: "fat",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M368 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
  },
  pm = {
    prefix: "fat",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M176 48H80C62.3 48 48 62.3 48 80v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 272H80c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H336zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c4.4 0 8 3.6 8 8v96h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H392v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V392H280c-4.4 0-8-3.6-8-8s3.6-8 8-8h96V280c0-4.4 3.6-8 8-8z"]
  },
  mm = {
    prefix: "fat",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M336 96c0-44.2-35.8-80-80-80s-80 35.8-80 80v3.6c0 6.9 5.6 12.4 12.4 12.4H323.6c6.9 0 12.4-5.6 12.4-12.4V96zM160 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zM34.3 98.3c3.1-3.1 8.2-3.1 11.3 0L132.3 185c18.2-15.6 41.8-25 67.7-25H312c25.8 0 49.5 9.4 67.7 25l86.7-86.7c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L391 196.3c15.6 18.2 25 41.8 25 67.7v16h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H416v24c0 33.2-10.1 63.9-27.3 89.5c.4 .3 .7 .5 1 .9l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L379 422.3C349.7 457.6 305.4 480 256 480s-93.7-22.4-123-57.7L45.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88c.3-.3 .7-.6 1-.9C106.1 383.9 96 353.2 96 320V296H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H96V264c0-25.8 9.4-49.5 25-67.7L34.3 109.7c-3.1-3.1-3.1-8.2 0-11.3zM264 232V463.8c75.8-4.2 136-66.9 136-143.8V288 264c0-48.6-39.4-88-88-88H200c-48.6 0-88 39.4-88 88v24 32c0 76.8 60.2 139.6 136 143.8V232c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  hm = {
    prefix: "fat",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 48C37.5 48 16 69.5 16 96v32H560V96c0-26.5-21.5-48-48-48H64zM16 144v96H560V144H16zm0 112V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V256H16zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 360c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8zm128 0c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8z"]
  },
  vm = {
    prefix: "fat",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm144 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
  },
  gm = {
    prefix: "fat",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V328v80 64c0 4.4 3.6 8 8 8s8-3.6 8-8V416H624v56c0 4.4 3.6 8 8 8s8-3.6 8-8V408 328 232c0-57.4-46.6-104-104-104H312c-22.1 0-40 17.9-40 40V320H16V40zM624 400H16V336H280 624v64zm0-168v88H288V168c0-13.3 10.7-24 24-24H536c48.6 0 88 39.4 88 88zM80 208a64 64 0 1 1 128 0A64 64 0 1 1 80 208zm144 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z"]
  },
  bm = {
    prefix: "fat",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M216 8c0-4.4 3.6-8 8-8s8 3.6 8 8V32l0 .2c84.6 4.2 152 74.1 152 159.8v36.6c0 41.8 14.2 82.3 40.3 114.9l16.7 20.9c4.5 5.6 6.9 12.6 6.9 19.8c0 17.5-14.2 31.7-31.7 31.7H31.7C14.2 416 0 401.8 0 384.3c0-7.2 2.4-14.2 6.9-19.8l16.7-20.9C49.8 311 64 270.4 64 228.6V192c0-85.7 67.4-155.6 152-159.8l0-.2V8zm8 40C144.5 48 80 112.5 80 192v36.6c0 45.4-15.5 89.5-43.8 124.9L19.4 374.5c-2.2 2.8-3.4 6.2-3.4 9.8C16 393 23 400 31.7 400H416.3c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C383.5 318.1 368 274.1 368 228.6V192c0-79.5-64.5-144-144-144zM176 448c0 12.7 5.1 24.9 14.1 33.9s21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  Hm = {
    prefix: "fat",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
  },
  zm = {
    prefix: "fat",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 496c26.5 0 48-21.5 48-48V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320zm41.1-336c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM0 64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
  },
  ym = {
    prefix: "fat",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M314.4 203.7L433.8 306c3.2-1.8 6.4-3.8 9.4-5.9c1.6-1.1 3.1-2.1 4.8-3L338.2 203l-13.4-11.4c5.3-2.6 10.8-4.9 16.5-6.9c15.8-5.6 32.9-8.6 50.7-8.6h64c22.1 0 40-17.9 40-40s-17.9-40-40-40H392c-123.6 0-224.5 96.6-231.6 218.4c5.3 1.9 10.6 3.4 15.8 4.5C181 203.8 275.8 112 392 112h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-26.6 0-51.8 6.2-74.2 17.2c-4.8 2.4-8.1 7-8.8 12.4s1.4 10.6 5.5 14.1zM144 160a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128zM294.6 339.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 385.8 214.5 400 192 400s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 382.5 28.3 396.9 7 399.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 385.8 406.5 400 384 400s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z"]
  },
  Vm = {
    prefix: "fat",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M16 416V327.9c0-2.6 .2-5.3 .7-7.9H118.1c3 0 5.8 1.7 7.2 4.4l23.2 46.3c4.1 8.1 12.4 13.3 21.5 13.3H342.1c9.1 0 17.4-5.1 21.5-13.3l23.2-46.3c1.4-2.7 4.1-4.4 7.2-4.4H495.4c.4 2.6 .6 5.2 .6 7.9V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM491.5 304H393.9c-9.1 0-17.4 5.1-21.5 13.3l-23.2 46.3c-1.4 2.7-4.1 4.4-7.2 4.4H169.9c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3H20.5L75.4 84.4C80.7 63 99.9 48 122 48H390c22 0 41.2 15 46.6 36.4L491.5 304zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
  },
  xm = {
    prefix: "fat",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M256 16c-8.6 0-17 2.8-24 7.9L177.9 64H334.1L280 23.9C273 18.8 264.6 16 256 16zM120 64h31l71.5-53C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L361 64h31c30.9 0 56 25.1 56 56v8.5l38.1 28.2c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L64 128.5V120c0-30.9 25.1-56 56-56zM448 214.5l-16 13.1V120c0-22.1-17.9-40-40-40H120c-22.1 0-40 17.9-40 40V227.7L64 214.5V148.4L35.4 169.5C23.2 178.6 16 192.9 16 208.1v8.4l1.6 1.3L232.7 394.5c6.6 5.4 14.8 8.3 23.3 8.3s16.7-2.9 23.3-8.3L494.4 217.8l1.6-1.3v-8.4c0-15.2-7.2-29.5-19.4-38.6L448 148.4v66.1zM16 448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V237.2L289.4 406.9c-9.4 7.7-21.2 12-33.4 12s-24-4.2-33.4-12L16 237.2V448zM168 160H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 80H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  Mm = {
    prefix: "fat",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M32 176C32 96.5 96.5 32 176 32h72 8H432c4.4 0 8 3.6 8 8s-3.6 8-8 8H368l0 424c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-424H272V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V320H176C96.5 320 32 255.5 32 176zM256 304l0-256h-8H176C105.3 48 48 105.3 48 176s57.3 128 128 128h80z"]
  },
  _m = {
    prefix: "fat",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M104 0c4.4 0 8 3.6 8 8v9.4c0 11.2 5.9 21.7 15.5 27.4l41.2 24.7c14.5 8.7 23.3 24.3 23.3 41.2V120c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.4c0-11.2-5.9-21.7-15.5-27.4L119.3 58.5C104.8 49.8 96 34.2 96 17.4V8c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8v9.4c0 11.2 5.9 21.7 15.5 27.4l41.2 24.7c14.5 8.7 23.3 24.3 23.3 41.2V120c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.4c0-11.2-5.9-21.7-15.5-27.4L215.3 58.5C200.8 49.8 192 34.2 192 17.4V8c0-4.4 3.6-8 8-8zM32 176c-8.8 0-16 7.2-16 16c0 97.2 78.8 176 176 176h64c97.2 0 176-78.8 176-176c0-8.8-7.2-16-16-16H32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 81.9-51.3 151.8-123.5 179.4l58.8 129.3c1.8 4 0 8.8-4 10.6s-8.8 0-10.6-4L345.4 456H159.5c-3.9 31.6-30.9 56-63.5 56c-35.3 0-64-28.7-64-64s28.7-64 64-64c7.1 0 13.9 1.2 20.3 3.3l7.2-15.9C51.3 343.8 0 273.9 0 192zM309.3 376.5c-16.9 4.9-34.8 7.5-53.3 7.5H192c-18.5 0-36.4-2.6-53.3-7.5l-8 17.7c15.5 10 26.4 26.6 28.8 45.8H338.1l-28.9-63.5zM144 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
  },
  wm = {
    prefix: "fat",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M580.2 244.7c50-50 50-131 0-181s-131-50-181 0l-17 17c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l17-17c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4L433.1 369.1c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-39.6 39.6c-50 50-50 131 0 181s131 50 181 0L580.2 244.7zM59.8 267.3c-50 50-50 131 0 181s131 50 181 0l17-17c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-17 17c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4L206.9 142.9c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4l-39.6 39.6c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l39.6-39.6c50-50 50-131 0-181s-131-50-181 0L59.8 267.3z"]
  },
  Em = {
    prefix: "fat",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149z"]
  },
  Cm = {
    prefix: "fat",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M13.3 2C10.9-.1 7.6-.6 4.7 .7S0 4.9 0 8V504c0 3.1 1.8 6 4.7 7.3s6.2 .8 8.6-1.3L71.6 459l50.7 50.7c3 3 7.8 3.1 10.9 .4L192 458.6 250.7 510c3.2 2.8 7.9 2.6 10.9-.4L312.4 459 370.7 510c2.4 2.1 5.7 2.6 8.6 1.3s4.7-4.1 4.7-7.3V8c0-3.1-1.8-6-4.7-7.3s-6.2-.8-8.6 1.3L312.4 53.1 261.7 2.3c-3-3-7.8-3.1-10.9-.4L192.4 53.1 141.7 2.3c-3-3-7.8-3.1-10.9-.4L72 53.4 13.3 2zM16 486.4V25.6L66.7 70c3 2.6 7.5 2.6 10.5 0l58.4-51.1 50.7 50.7c3 3 7.8 3.1 10.9 .4l58.4-51.1 50.7 50.7c3 3 7.8 3.1 10.9 .4L368 25.6V486.4L317.3 442c-3.2-2.8-7.9-2.6-10.9 .4L255.6 493 197.3 442c-3-2.6-7.5-2.6-10.5 0L128.4 493 77.7 442.3c-3-3-7.8-3.1-10.9-.4L16 486.4zM96 152c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96zM88 352c0 4.4 3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96c-4.4 0-8 3.6-8 8zm8-104c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96z"]
  },
  Lm = {
    prefix: "fat",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M250.3 397.7c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 380.7 45.7 170.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l216 216z"]
  },
  Nm = {
    prefix: "fat",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M576 16c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H576zM64 0C28.7 0 0 28.7 0 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 504c0 4.4 3.6 8 8 8H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM80 80H560V368H80V80zM64 80V368c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"]
  },
  Sm = {
    prefix: "fat",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M157.7 53.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L63.5 125.2 21.1 89.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l48 40c3.2 2.6 7.9 2.4 10.8-.5l88-88zm0 160c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L63.5 285.2 21.1 249.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l48 40c3.2 2.6 7.9 2.4 10.8-.5l88-88zM200 96c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zm0 160c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zM168 416c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H176c-4.4 0-8 3.6-8 8zm-88 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  km = {
    prefix: "fat",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M256 496c-54 0-103.9-17.9-144-48v0c0-61.9 50.1-112 112-112h64c61.9 0 112 50.1 112 112v0c5.3-4 10.4-8.2 15.4-12.6C409.1 370.6 354.5 320 288 320H224c-66.5 0-121.1 50.6-127.4 115.4C47.2 391.5 16 327.4 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240s-107.5 240-240 240zm0 16A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-304a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  Pm = {
    prefix: "fat",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM64 248c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zM288 408c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H280c4.4 0 8 3.6 8 8z"]
  },
  Tm = {
    prefix: "fat",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M232 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H216V440c0 4.4 3.6 8 8 8s8-3.6 8-8V264H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H232V72z"]
  },
  Om = {
    prefix: "fat",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z"]
  },
  Am = {
    prefix: "fat",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm410.9 35.5c20.7-17.7 47-27.5 74.2-27.5h4.2c52.2 0 94.6 42.4 94.6 94.6c0 24.5-9.5 48-26.5 65.7L386.2 434.4c-2.2 2.3-2.9 5.7-1.6 8.7s4.2 4.9 7.4 4.9H624c4.4 0 8-3.6 8-8s-3.6-8-8-8H410.8L585 251.4c19.9-20.6 31-48.1 31-76.8C616 113.5 566.5 64 505.4 64h-4.2c-31.1 0-61.1 11.1-84.7 31.3l-21.7 18.6c-3.4 2.9-3.7 7.9-.9 11.3s7.9 3.7 11.3 .9l21.7-18.6z"]
  },
  Dm = {
    prefix: "fat",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M181.3 32.5c1.6-.6 3.4-.6 5.1-.1L391.8 95.6 533.1 44.2c20.9-7.6 42.9 7.9 42.9 30.1V391.2c0 13.5-8.4 25.5-21.1 30.1L394.7 479.5c-1.6 .6-3.4 .6-5.1 .1L184.2 416.4 42.9 467.8C22.1 475.4 0 459.9 0 437.7V120.8c0-13.5 8.4-25.5 21.1-30.1L181.3 32.5zM26.5 105.8c-6.3 2.3-10.5 8.3-10.5 15V437.7c0 11.1 11 18.8 21.5 15L176 402.4V51.4L26.5 105.8zM384 461.2V109.9L192 50.8V402.1l192 59.1zm16-.6l149.5-54.4c6.3-2.3 10.5-8.3 10.5-15V74.3c0-11.1-11-18.8-21.5-15L400 109.6v351z"]
  },
  Im = {
    prefix: "fat",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM216 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm96 160a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm160 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm32-128a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM184 320a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z"]
  },
  jm = {
    prefix: "fat",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M18.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L35.3 256 245.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-216 216z"]
  },
  Fm = {
    prefix: "fat",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M301.7 250.3c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L284.7 256 74.3 45.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l216 216z"]
  },
  Rm = {
    prefix: "fat",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M64 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM373.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-352 352c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l352-352z"]
  },
  Bm = {
    prefix: "fat",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M43.6 224c-4.9 0-8.7-4.3-7.8-9.2c9.7-51.8 37.5-100.4 82.3-135.3c88.3-69 212.1-61.3 291.3 13.2L398 104C324.5 35.1 209.8 28.1 127.9 92.1c-41.4 32.3-67.2 77.2-76.3 125.1c-.7 3.9-4.1 6.8-8.1 6.8zm423.7 64c4.9 0 8.7 4.3 7.8 9.2c-9.7 51.8-37.5 100.4-82.3 135.4c-88.1 68.8-211.5 61.3-290.7-12.7L57 465c-6.9 6.9-17.2 8.9-26.2 5.2S16 457.7 16 448V344c0-13.3 10.7-24 24-24H144c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-47.6 47.6c73.5 68.4 187.9 75.1 269.5 11.4c41.4-32.4 67.2-77.3 76.3-125.1c.7-3.9 4.1-6.8 8.1-6.8zM368 176H472c4.4 0 8-3.6 8-8V64c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7l-104 104c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9zm104 16H368c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2L455 47c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V168c0 13.3-10.7 24-24 24zM144 336H40c-4.4 0-8 3.6-8 8V448c0 3.2 1.9 6.2 4.9 7.4s6.4 .6 8.7-1.7l104-104c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9z"]
  },
  Gm = {
    prefix: "fat",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M256 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM131.5 380.5A32 32 0 1 0 86.3 425.7a32 32 0 1 0 45.3-45.3zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM86.3 131.5a32 32 0 1 0 45.3-45.3A32 32 0 1 0 86.3 131.5zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM425.7 425.7a32 32 0 1 0 -45.3-45.3 32 32 0 1 0 45.3 45.3zm-56.6-56.6A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"]
  },
  Ym = {
    prefix: "fat",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M50.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l176 176c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L67.3 256 237.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-176 176zm368-176l-176 176c-3.1 3.1-3.1 8.2 0 11.3l176 176c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L259.3 256 429.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z"]
  },
  Wm = {
    prefix: "fat",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M16 16l0 64H624V16H16zM0 16C0 7.2 7.2 0 16 0H624c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H608V488c0 13.3-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V352c0-88.4-71.6-160-160-160s-160 71.6-160 160V488c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V96H16C7.2 96 0 88.8 0 80V16zM48 96V488c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V352c0-97.2 78.8-176 176-176s176 78.8 176 176V488c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V96H48zM341.2 316.7c-4.8 .1-9.4-2.1-12.5-5.8c-11-13.3-22.8-25.6-35.3-37.1c-21.6 19.8-39.8 42-52.7 63c-13.6 22.1-21.2 44-21.2 59c0 55.1 44.1 100.3 100.4 100.3c55.7 0 100.4-45.2 100.4-100.3c0-11-5.7-30.7-15.8-50.1c-9.3-18.1-22.2-36.7-37-51.2c-4.8 4.8-9.4 10.5-14 16.2c-3 3.8-7.5 6-12.3 6zm-10.8-28.3c3.6 4 7.2 8.1 10.7 12.3c3.2-4.1 6.7-8.4 10.4-12.5c2.8-3.2 5.8-6.2 8.8-9c4.1-3.7 10.5-3.7 14.5 0c18 16.5 33.2 38.3 43.9 59c10.6 20.4 17.6 42.8 17.6 57.4c0 63.9-51.8 116.3-116.4 116.3c-65.2 0-116.4-52.4-116.4-116.3c0-19.2 9.2-44.1 23.6-67.4c14.5-23.5 35-48.1 59.2-69.7c2-1.8 4.7-2.7 7.3-2.7c2.6 0 5.1 .9 7.1 2.7c10.4 9.3 20.3 19.2 29.7 29.7zm-32.1 38.2c1.6 2 14.1 17.9 26.1 33.3l16.3 20.9 1.3 1.7 22.5-26.3c1.6-1.8 3.9-2.9 6.3-2.8s4.7 1.3 6.1 3.2c2.8 3.8 4.7 7.5 6.3 10.7l0 .1c5.1 9.4 7.9 19.6 8.4 29.7c.2 4.4-3.1 8.2-7.5 8.4s-8.2-3.1-8.4-7.5c-.4-7.8-2.5-15.6-6.4-22.8l-21.6 25.2c-1.6 1.8-3.9 2.8-6.2 2.8s-4.6-1.2-6.1-3.1l6.3-4.9c-6.3 4.9-6.3 4.9-6.3 4.9l0 0 0 0 0 0-.1-.1-.4-.5-1.5-1.9-5.3-6.8-16.3-20.8c-7.3-9.3-14.8-18.8-19.8-25.3c-8.9 11.1-15.5 20-20.1 28c-5.6 9.6-7.9 17.2-7.9 25c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-11.5 3.6-21.9 10.1-33c6.4-10.9 15.8-23 27.8-37.8c1.5-1.9 3.8-3 6.2-3s4.7 1.1 6.2 3z"]
  },
  qm = {
    prefix: "fat",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M16 166.7V56c0-4.4-3.6-8-8-8s-8 3.6-8 8V184c0 4.4 3.6 8 8 8H136c4.4 0 8-3.6 8-8s-3.6-8-8-8H29.7C62.6 82.8 151.5 16 256 16c132.5 0 240 107.5 240 240s-107.5 240-240 240c-73.5 0-139.3-33.1-183.4-85.2c-2.9-3.4-7.9-3.8-11.3-.9s-3.8 7.9-.9 11.3C107.3 476.7 177.6 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C146 0 52.2 69.4 16 166.7zM256 128c-4.4 0-8 3.6-8 8V256c0 2.1 .8 4.2 2.3 5.7l88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L264 252.7V136c0-4.4-3.6-8-8-8z"]
  },
  Um = {
    prefix: "fat",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M169.7 32.2c4.3 1 7 5.2 6.1 9.5L153.1 144H328.7L352.2 38.3c1-4.3 5.2-7 9.5-6.1s7 5.2 6.1 9.5L345.1 144H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H341.5L298.9 352H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H295.3L271.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L278.9 368H103.3L79.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L86.9 368H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H90.5l42.7-192H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h96.7L160.2 38.3c1-4.3 5.2-7 9.5-6.1zM149.5 160L106.9 352H282.5l42.7-192H149.5z"]
  },
  $m = {
    prefix: "fat",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zm416 72c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16zM240 176c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16zm-96 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16zm192-32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zM464 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM272 192c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V192zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V288zm160-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"]
  },
  Xm = {
    prefix: "fat",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M108.7 8c5.1-5.1 12.1-8 19.3-8s14.2 2.9 19.3 8L247 107.7c5.7 5.7 9 13.5 9 21.7c0 16.9-13.7 30.6-30.6 30.6H176V352h49.4c16.9 0 30.6 13.7 30.6 30.6c0 8.1-3.2 15.9-9 21.7L147.3 504c-5.1 5.1-12.1 8-19.3 8s-14.2-2.9-19.3-8L9 404.3c-5.7-5.7-9-13.5-9-21.7C0 365.7 13.7 352 30.6 352H80V160H30.6C13.7 160 0 146.3 0 129.4c0-8.1 3.2-15.9 9-21.7L108.7 8zM128 16c-3 0-5.9 1.2-8 3.3L20.3 119c-2.7 2.7-4.3 6.5-4.3 10.3c0 8.1 6.5 14.6 14.6 14.6H88c4.4 0 8 3.6 8 8V360c0 4.4-3.6 8-8 8H30.6c-8.1 0-14.6 6.6-14.6 14.6c0 3.9 1.5 7.6 4.3 10.3L120 492.7l-5.7 5.7 5.7-5.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3l5.7 5.7-5.7-5.7L235.7 393c2.7-2.7 4.3-6.5 4.3-10.3c0-8.1-6.5-14.6-14.6-14.6H168c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h57.4c8.1 0 14.6-6.5 14.6-14.6c0-3.9-1.5-7.6-4.3-10.3L136 19.3c-2.1-2.1-5-3.3-8-3.3z"]
  },
  Zm = {
    prefix: "fat",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-8-160c0 4.4 3.6 8 8 8s8-3.6 8-8V264h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V160c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z"]
  },
  Km = {
    prefix: "fat",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M16 107.9C16 74.8 42.8 48 75.9 48c15.9 0 31.1 6.3 42.3 17.5l36.1 36.1c.3 .3 .7 .6 1.1 .9c-38.3 44-36.5 110.8 5.4 152.6l18.3 18.3-16.8 16.8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l192-192c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-16.8 16.8L319.2 96.8c-41.9-41.9-108.6-43.7-152.6-5.4c-.3-.4-.6-.7-.9-1.1L129.5 54.2C115.3 40 96 32 75.9 32C34 32 0 66 0 107.9V472c0 4.4 3.6 8 8 8s8-3.6 8-8V107.9zm310.2 18.6L190.5 262.2l-18.3-18.3c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0l18.3 18.3zM416 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-64 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  Qm = {
    prefix: "fat",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 16c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H344.2h-.3H232.1h-.3H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H512zM64 416H222.6l-13.3 80H136c-4.4 0-8 3.6-8 8s3.6 8 8 8h80H360h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H366.8l-13.3-80H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm161.4 80l13.3-80h98.4l13.3 80H225.4zM80 80H496V272H80L80 80zM64 80V272c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"]
  },
  Jm = {
    prefix: "fat",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm416-8c-3.7 0-7 2.6-7.8 6.2l-40 176c-.5 2.4 0 4.9 1.5 6.8s3.8 3 6.3 3H536c48.6 0 88 39.4 88 88s-39.4 88-88 88H448.4c-20.7 0-39-13.2-45.5-32.8l-3.2-9.7c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1l3.2 9.7c8.7 26.1 33.2 43.8 60.7 43.8H536c57.4 0 104-46.6 104-104s-46.6-104-104-104H402L438.4 80H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H432z"]
  },
  eh = {
    prefix: "fat",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M437.7 106.3c3.1 3.1 3.1 8.2 0 11.3l-272 272c-3.1 3.1-8.2 3.1-11.3 0l-144-144c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L160 372.7 426.3 106.3c3.1-3.1 8.2-3.1 11.3 0z"]
  },
  th = {
    prefix: "fat",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M20.7 412.3c-3.1 5.3-4.7 11.2-4.7 17.3c0 19 15.4 34.4 34.4 34.4H461.6c19 0 34.4-15.4 34.4-34.4c0-6.1-1.6-12.1-4.7-17.3L290.3 67.7C283.2 55.5 270.1 48 256 48s-27.2 7.5-34.3 19.7L20.7 412.3zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c4.4 0 8 3.6 8 8V328c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8zM240 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  nh = {
    prefix: "fat",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M288 144c8.8 0 16-7.2 16-16V64c0-6.3 3.7-12 9.5-14.6s12.5-1.5 17.2 2.7l160 144c3.4 3 5.3 7.4 5.3 11.9s-1.9 8.9-5.3 11.9l-160 144c-4.7 4.2-11.4 5.3-17.2 2.7s-9.5-8.3-9.5-14.6V288c0-8.8-7.2-16-16-16H192c-61.9 0-112 50.1-112 112c0 35.5 15.2 57.1 27.3 68.4c3.7 3.5 4.7 6.5 4.7 7.8c0 2.1-1.7 3.7-3.7 3.7c-.3 0-.5 0-.6 0C90.6 454.7 16 408.2 16 304c0-88.4 71.6-160 160-160H288zm0 160v48c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2v48 16H272 176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h80 16v16z"]
  },
  ch = {
    prefix: "fat",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M256 16C123.5 16 16 123.5 16 256c0 36.9 8.3 71.9 23.2 103.1c1.9 4 .2 8.8-3.8 10.7s-8.8 .2-10.7-3.8C8.9 332.7 0 295.4 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-4.4 0-8-3.6-8-8s3.6-8 8-8c132.5 0 240-107.5 240-240S388.5 16 256 16zM139 130.9l-7.1 4c-3.8 2.2-8.7 .9-10.9-3s-.9-8.7 3-10.9l7.1-4c32.3-18.5 72.7-14.6 100.9 9.6l13.2 11.3c3.4 2.9 3.7 7.9 .9 11.3s-7.9 3.7-11.3 .9l-13.2-11.3c-23.1-19.8-56.2-22.9-82.6-7.8zM176.4 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm17.6 88.2l81.4 20.4c30.5 7.6 52 34.7 52.6 66c.6 16.9-9.6 33-26.3 39l-42.8 15.6-23.5 64.7c-9.2 25.3-33.2 42.1-60.1 42.1H128c-35.3 0-64-28.7-64-64V328c0-22.1 17.9-40 40-40s40 17.9 40 40v33.8l130.3-47.4c6.7-2.4 13.7-3 20.3-1.9c-6.4-5.9-14.3-10.2-23.1-12.4l-81.4-20.4c-4.3-1.1-6.9-5.4-5.8-9.7s5.4-6.9 9.7-5.8zm118.1 87c-.1-2.5-.5-5-1.4-7.4c-4.5-12.5-18.3-18.9-30.8-14.4L138.7 380.7c-2.5 .9-5.2 .5-7.3-1s-3.4-3.9-3.4-6.6V328c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 26.5 21.5 48 48 48h47.2c20.2 0 38.2-12.6 45.1-31.6l24.8-68.2c.8-2.2 2.6-4 4.8-4.8l46.3-16.8C306 371 312 361.8 312 352h0c0-.3 0-.5 0-.8zM320.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  ih = {
    prefix: "fat",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M403.7 477.5L289.5 429.9l-37.7 65.9c-7.2 12.6-22 18.8-36 15.1s-23.8-16.4-23.8-30.9V389.3L19.7 317.5C8.4 312.8 .8 302.2 .1 290s5.5-23.7 16.1-29.8l7.9 13.9c-5.3 3-8.4 8.8-8 14.9s4.2 11.4 9.8 13.8l168.9 70.4L479.6 16c-2.6 .1-5.2 .8-7.6 2.1l-448 256-7.9-13.9 448-256c8.3-4.7 18-5.5 26.7-2.3c2.5 .9 5 2.2 7.3 3.7c1.3 .9 2.5 1.8 3.6 2.8c.9 .8 1.7 1.6 2.4 2.5c6.1 7 9 16.5 7.5 25.9l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6zm-193.6-98l85.5 35.6c0 0 0 0 .1 0l114.2 47.6c4.5 1.9 9.7 1.6 14-.8s7.2-6.7 8-11.5l64-416c.6-3.7-.2-7.4-2-10.5L210.1 379.5zM208 396v84c0 7.3 4.9 13.6 11.9 15.5s14.4-1.2 18-7.5l36.7-64.2L208 396z"]
  },
  rh = {
    prefix: "fat",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M440 56c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H440zm0 128c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440zm8 136c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8zm-8 120c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440z"]
  },
  ah = {
    prefix: "fat",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM178.3 178.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z"]
  },
  oh = {
    prefix: "fat",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M281.1 71.6c4.6-17.1 22.2-27.1 39.3-22.5s27.1 22.2 22.5 39.3l-4.5 16.4c-5.7 20.8-22.3 56.7-33.7 75c-1.5 2.5-1.6 5.6-.2 8.1s4.1 4.1 7 4.1H448c22.1 0 40 17.9 40 40c0 14.2-7.3 26.6-18.5 33.7c-3.6 2.3-4.7 7-2.7 10.7c3.3 5.8 5.1 12.5 5.1 19.6c0 15.5-8.8 28.9-21.7 35.6c-2.1 1.1-3.6 3.1-4.1 5.4s0 4.7 1.5 6.6c5.2 6.8 8.3 15.2 8.3 24.4c0 17.8-11.6 32.8-27.6 38c-3.9 1.3-6.2 5.3-5.3 9.3c.6 2.8 .9 5.7 .9 8.6c0 22.1-17.9 40-40 40H286.5c-17.4 0-34.4-5.1-48.8-14.8l-38.5-25.7c-10-6.6-18.3-15.1-24.7-24.8c-2.4-3.7-7.4-4.7-11.1-2.3s-4.7 7.4-2.3 11.1c7.6 11.5 17.4 21.5 29.2 29.3l38.5 25.7C245.9 473.9 266 480 286.5 480H384c30.9 0 56-25.1 56-56c0-1.8-.1-3.5-.2-5.3c19-8.9 32.2-28.3 32.2-50.7c0-9.7-2.5-18.9-6.9-26.9C479 331 488 314.5 488 296c0-7.4-1.4-14.5-4.1-21c12.3-10.3 20.1-25.7 20.1-43c0-30.9-25.1-56-56-56H325.4c10.9-20.3 23.4-48.5 28.5-67l4.5-16.4c7-25.6-8.1-52-33.7-58.9s-52 8.1-58.9 33.7l-4.5 16.4c-4.7 17.2-14.5 37.4-27.2 55.8c-12.7 18.4-27.7 34.5-42.5 43.8l-3.1 2c-10.9 6.9-20 15.8-27.2 26.1c-2.5 3.6-1.6 8.6 2 11.1s8.6 1.6 11.1-2c6-8.5 13.6-16 22.7-21.7l3.1-2c17.2-10.9 33.7-28.8 47.1-48.3c13.4-19.5 24.1-41.3 29.4-60.6l4.5-16.4zM32 208H96c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zM0 224V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
  },
  sh = {
    prefix: "fat",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 72c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zM224 440c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H232c-4.4 0-8 3.6-8 8zm64-200c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16H288zM96 224c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"]
  },
  lh = {
    prefix: "fat",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M80 160H64V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H432V90.5c0-12.7-5.1-24.9-14.1-33.9L391.4 30.1c-9-9-21.2-14.1-33.9-14.1H128c-26.5 0-48 21.5-48 48v96zm368 48H64c-26.5 0-48 21.5-48 48V384c0 8.8 7.2 16 16 16H64V352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v48h32c8.8 0 16-7.2 16-16V256c0-26.5-21.5-48-48-48zm0 208v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 17.7-14.3 32-32 32H448zM96 336c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H96zm336-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
  },
  fh = {
    prefix: "fat",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M252.7 .7c2.1-.9 4.5-.9 6.6 0L497.9 108.5c8.6 3.9 14.1 12.4 14.1 21.9V136c0 13.3-10.7 24-24 24H256 24c-13.3 0-24-10.7-24-24v-5.7c0-9.4 5.5-18 14.1-21.9L252.7 .7zM288 144H488c4.4 0 8-3.6 8-8v-5.7c0-3.1-1.8-6-4.7-7.3L256 16.8 20.7 123c-2.9 1.3-4.7 4.1-4.7 7.3V136c0 4.4 3.6 8 8 8H224c-5-6.7-8-15-8-24c0-22.1 17.9-40 40-40s40 17.9 40 40c0 9-3 17.3-8 24zm-32 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM72 192c4.4 0 8 3.6 8 8V368H184V200c0-4.4 3.6-8 8-8s8 3.6 8 8V368H312V200c0-4.4 3.6-8 8-8s8 3.6 8 8V368H432V200c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zM32 440c0-4.4 3.6-8 8-8H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8zM0 504c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z"]
  },
  uh = {
    prefix: "fat",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-4.4 3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z"]
  },
  dh = {
    prefix: "fat",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M144 176H54.9c-3.8 0-6.9-3.1-6.9-6.9c0-1.8 .7-3.5 1.9-4.7L190.1 16.8c.5-.5 1.2-.8 1.9-.8s1.4 .3 1.9 .8L334.1 164.4c1.2 1.3 1.9 3 1.9 4.7c0 3.8-3.1 6.9-6.9 6.9H240c-8.8 0-16 7.2-16 16V400c0 53-43 96-96 96H40c-13.3 0-24-10.7-24-24V456c0-13.3 10.7-24 24-24l88 0c17.7 0 32-14.3 32-32V192c0-8.8-7.2-16-16-16zM178.5 5.8L38.3 153.4c-4 4.3-6.3 9.9-6.3 15.8C32 181.8 42.2 192 54.9 192H128h16v16V400c0 8.8-7.2 16-16 16l-88 0c-22.1 0-40 17.9-40 40v16c0 22.1 17.9 40 40 40h88c61.9 0 112-50.1 112-112V208 192h16 73.1c12.6 0 22.9-10.2 22.9-22.9c0-5.9-2.3-11.5-6.3-15.8L205.5 5.8C202 2.1 197.1 0 192 0s-10 2.1-13.5 5.8z"]
  },
  ph = {
    prefix: "fad",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", ["M416 96H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V96zM144 176V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"]]
  },
  mh = {
    prefix: "fad",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", ["M0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM80 384c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336z", "M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32z"]]
  },
  hh = {
    prefix: "fad",
    iconName: "h1",
    icon: [576, 512, [], "f313", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M496.8 68.8C506.3 74.6 512 84.9 512 96V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480 416c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V147.8l-17.7 8.8c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l64-32c9.9-5 21.7-4.4 31.1 1.4z"]]
  },
  vh = {
    prefix: "fad",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", ["M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z", "M128 96H512V352H128V96z"]]
  },
  gh = {
    prefix: "fad",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM200 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1-17.9-40-40-40H200zm133.1 0c-24.9 0-45.1 20.2-45.1 45.1c0 17.8 10.5 34 26.8 41.2l37.4 16.6c4.7 2.1 7.8 6.8 7.8 12c0 7.2-5.9 13.1-13.1 13.1H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h42.9c24.9 0 45.1-20.2 45.1-45.1c0-17.8-10.5-34-26.8-41.2l-37.4-16.6c-4.7-2.1-7.8-6.8-7.8-12c0-7.2 5.9-13.1 13.1-13.1H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H333.1zm98.9 0c-8.8 0-16 7.2-16 16v31.6c0 34.7 10.3 68.7 29.6 97.6l5.1 7.7c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l5.1-7.7c19.3-28.9 29.6-62.9 29.6-97.6V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v31.6c0 23-5.5 45.6-16 66c-10.5-20.3-16-42.9-16-66V368c0-8.8-7.2-16-16-16z"]]
  },
  bh = {
    prefix: "fad",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", ["M200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zM160 392v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zM360 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360z", "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]]
  },
  Hh = {
    prefix: "fad",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", ["M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z", "M0 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
  },
  zh = {
    prefix: "fad",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", ["M492.7 58.2c25 25 25 65.5 0 90.5l-60 60L302.7 78.7l60-60c25-25 65.5-25 90.5 0l39.4 39.4zM315.3 186.7l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M432.7 208.7L302.7 78.7 58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L432.7 208.7zM89.3 360.5l22.7-9.1v32c0 8.8 7.2 16 16 16h32l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3zm226-196.4c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0z"]]
  },
  yh = {
    prefix: "fad",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
  },
  Vh = {
    prefix: "fad",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", ["M480 128H32V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V128zM192 192H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64z"]]
  },
  xh = {
    prefix: "fad",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M222.6 80c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  Mh = {
    prefix: "fad",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", ["M120 128c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120z", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"]]
  },
  _h = {
    prefix: "fad",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", ["M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3c7.9-.8 15.9-1.3 24-1.3s16.1 .4 24 1.3V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM480 400H32 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8z", "M480 368c0-123.7-100.3-224-224-224S32 244.3 32 368v32H480V368z"]]
  },
  wh = {
    prefix: "fad",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", ["M224 288V128H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224z", "M224 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 190.3 0 198.9 0 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V64z"]]
  },
  Eh = {
    prefix: "fad",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", ["M390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2l45.9-45.9C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5l45.9-45.9zM167.8 389.5l-45.9 45.9c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1l-45.9 45.9C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z", "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-448 448c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l448-448c12.5-12.5 32.8-12.5 45.3 0z"]]
  },
  Ch = {
    prefix: "fad",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", ["M0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]]
  },
  Lh = {
    prefix: "fad",
    iconName: "people-group",
    icon: [640, 512, [], "e533", ["M128 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM48 304c0-16.2 6-31.1 16-42.3v84.7C54 335 48 320.2 48 304zm112 0c0-37.8 14.6-72.2 38.4-97.9c-16.1-9-34.7-14.1-54.4-14.1H112C50.1 192 0 242.1 0 304c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2 394.5c-20-24.7-32-56.2-32-90.5zM448 405.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H496c-19.7 0-38.3 5.1-54.4 14.1C465.4 231.8 480 266.2 480 304c0 34.3-12 65.8-32 90.5v10.7zM512 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm80 144c0 16.2-6 31-16 42.3V261.7c10 11.3 16 26.1 16 42.3z", "M384 96A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 261.7v84.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3zm128 84.7V261.7c10 11.3 16 26.1 16 42.3s-6 31-16 42.3zm0 58.9c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H304c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2z"]]
  },
  Nh = {
    prefix: "fad",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  Sh = {
    prefix: "fad",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", ["M264 280v40h48V280H464c4.4 0 8 3.6 8 8v32h48V288c0-30.9-25.1-56-56-56H312V192H264v40H112c-30.9 0-56 25.1-56 56v32h48V288c0-4.4 3.6-8 8-8H264z", "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V80zM48 320h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm208 0h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm208 0h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]]
  },
  kh = {
    prefix: "fad",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", ["M321 288c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96c-15 10-31 15-49 15zM32 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H80v80H560V304H536c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V280zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M283.7 0c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zM321 288c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
  },
  Ph = {
    prefix: "fad",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 200c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
  },
  Th = {
    prefix: "fad",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", ["M160 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M16 72c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72zm0 160c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232zM40 368H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24z"]]
  },
  Oh = {
    prefix: "fad",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
  },
  Ah = {
    prefix: "fad",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", ["M248 0c13.3 0 24 10.7 24 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2V24c0-13.3 10.7-24 24-24zM0 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2L256 256H0zM384 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z", "M0 256H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm112 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm80-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"]]
  },
  Dh = {
    prefix: "fad",
    iconName: "blanket",
    icon: [448, 512, [], "f498", ["M0 352V128C0 75 43 32 96 32H352c53 0 96 43 96 96V304c0-44.2-35.8-80-80-80H128C57.3 224 0 281.3 0 352z", "M128 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H128C57.3 480 0 422.7 0 352s57.3-128 128-128H368c44.2 0 80 35.8 80 80s-35.8 80-80 80H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]]
  },
  Ih = {
    prefix: "fad",
    iconName: "users",
    icon: [640, 512, [], "f0c0", ["M224 80A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm368 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7zm298 128c.2 0 .4 0 .7 0H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96z", "M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z"]]
  },
  jh = {
    prefix: "fad",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", ["M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z", ""]]
  },
  Fh = {
    prefix: "fad",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", ["M160 256c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32z", "M160 96C71.6 96 0 167.6 0 256s71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-53 0-96-43-96-96s43-96 96-96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm256 0H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96s-43 96-96 96H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c88.4 0 160-71.6 160-160s-71.6-160-160-160z"]]
  },
  Rh = {
    prefix: "fad",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", ["M448 128H128c0 35.3-28.7 64-64 64V320c35.3 0 64 28.7 64 64H448c0-35.3 28.7-64 64-64V192c-35.3 0-64-28.7-64-64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm384 64c0 35.3 28.7 64 64 64V320c-35.3 0-64 28.7-64 64H128c0-35.3-28.7-64-64-64V192c35.3 0 64-28.7 64-64H448z"]]
  },
  Bh = {
    prefix: "fad",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", ["M32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zM32 96C14.3 96 0 81.7 0 64S14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
  },
  Gh = {
    prefix: "fad",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", ["M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80z", "M368 96c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48z"]]
  },
  Yh = {
    prefix: "fad",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", ["M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z", "M240 192h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H240V192zm0 128h48c53 0 96-43 96-96s-43-96-96-96H216c-22.1 0-40 17.9-40 40V288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"]]
  },
  Wh = {
    prefix: "fad",
    iconName: "h3",
    icon: [640, 512, [], "f315", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M368 96c0-17.7 14.3-32 32-32H592c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-89.5 89.5C589 210.8 640 263.4 640 328c0 66.3-53.7 120-120 120H455.4c-43 0-79.7-31.1-86.8-73.5l-.2-1.2c-2.9-17.4 8.9-33.9 26.3-36.8s33.9 8.9 36.8 26.3l.2 1.2c1.9 11.6 11.9 20.1 23.7 20.1H520c30.9 0 56-25.1 56-56s-25.1-56-56-56H448c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L514.7 128H400c-17.7 0-32-14.3-32-32z"]]
  },
  qh = {
    prefix: "fad",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", ["M512 160c-33.9 0-61.6-26.3-63.9-59.7c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6l0 0c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208V352c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.2c4.7-1.2 9.4-2.3 14.2-3.6l0 0c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4V160zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM512 160V304c-31.4 0-57.5 22.6-63 52.4c-62.5 .8-121.8 15.7-172.9 28.6l0 0c-4.8 1.2-9.5 2.4-14.2 3.6c-50.7 12.6-94.1 22.2-134.2 23.2C125.6 378.3 97.9 352 64 352V208c31.4 0 57.5-22.6 63-52.4c62.5-.8 121.8-15.7 172.9-28.6l0 0c4.8-1.2 9.5-2.4 14.2-3.6c50.7-12.6 94.1-22.2 134.2-23.2c2.2 33.3 30 59.7 63.9 59.7z"]]
  },
  Uh = {
    prefix: "fad",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", ["M99.5 144.8L367.2 412.5c17.5-12.5 32.8-27.8 45.3-45.3L144.8 99.5C127.3 112 112 127.3 99.5 144.8z", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]]
  },
  $h = {
    prefix: "fad",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", ["M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z", ""]]
  },
  Xh = {
    prefix: "fad",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 72c-8.8 0-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V440c0 8.8 7.2 16 16 16s16-7.2 16-16V422.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V232c0-8.8-7.2-16-16-16z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM208 232c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16V422.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V232z"]]
  },
  Zh = {
    prefix: "fad",
    iconName: "stars",
    icon: [512, 512, [], "f762", ["M312 104l13.8 48.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104zM428.8 243.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z", "M213.4 157.4c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z"]]
  },
  Kh = {
    prefix: "fad",
    iconName: "h4",
    icon: [640, 512, [], "f86a", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M479 103.8c4.3-17.1-6.1-34.5-23.3-38.8s-34.5 6.1-38.8 23.3l-48 192c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3H576v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H441L479 103.8z"]]
  },
  Qh = {
    prefix: "fad",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", ["", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]]
  },
  Jh = {
    prefix: "fad",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", ["M109.3 64C101.9 64 96 69.9 96 77.3V256H32V77.3C32 34.6 66.6 0 109.3 0c20.5 0 40.1 8.1 54.6 22.6l14.9 14.9C187.8 34 197.7 32 208 32c19.9 0 38 7.2 52 19.2c9.2-5.3 21.1-4 29 3.8c9.4 9.4 9.4 24.6 0 33.9L185 193c-9.4 9.4-24.6 9.4-33.9 0c-7.9-7.9-9.1-19.8-3.8-29c-12-14-19.2-32.1-19.2-52c0-10.3 2-20.2 5.5-29.2L118.6 67.9c-2.5-2.5-5.9-3.9-9.4-3.9z", "M32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm448 96H32v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352z"]]
  },
  ev = {
    prefix: "fad",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", ["M48 32C30.3 32 16 46.3 16 64s14.3 32 32 32H64V224c0 88.4 71.6 160 160 160s160-71.6 160-160V96h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H304c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V224c0 53-43 96-96 96s-96-43-96-96V96h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z", "M0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
  },
  tv = {
    prefix: "fad",
    iconName: "bold",
    icon: [384, 512, [], "f032", ["M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z", ""]]
  },
  nv = {
    prefix: "fad",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 96zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160z"]]
  },
  cv = {
    prefix: "fad",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z", "M128 168c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
  },
  iv = {
    prefix: "fad",
    iconName: "image",
    icon: [512, 512, [], "f03e", ["M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176z"]]
  },
  rv = {
    prefix: "fad",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", ["M98.6 96.6l45.3 45.3c62.6-61.5 163.1-61.2 225.3 1c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c87.5 87.5 229.3 87.5 316.8 0s87.5-229.3 0-316.8c-87.2-87.2-228.3-87.5-315.8-1z", "M168 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"]]
  },
  av = {
    prefix: "fad",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", ["M406.2 416l81.2 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H406.2zM243.7 288l81.2 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H243.7zm-143-112.7L162.5 224H128c-17.7 0-32-14.3-32-32c0-6.1 1.7-11.8 4.7-16.7zM399.7 288H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H481.4l-81.7-64zM236.4 160H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H318.1l-81.7-64zM512 96H154.8L98.4 51.8C103.2 40.2 114.6 32 128 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
  },
  ov = {
    prefix: "fad",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
  },
  sv = ov,
  lv = {
    prefix: "fad",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", ["M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z", ""]]
  },
  fv = {
    prefix: "fad",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", ["M355.7 253.5L400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2 55.1 43.2c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l54.4 42.7zM327.3 353.9L272.9 311 243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
  },
  uv = {
    prefix: "fad",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z"]]
  },
  dv = {
    prefix: "fad",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", ["M324.9 279.8l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z", "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 337.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2z"]]
  },
  pv = {
    prefix: "fad",
    iconName: "italic",
    icon: [384, 512, [], "f033", ["M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z", ""]]
  },
  mv = {
    prefix: "fad",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", ["M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM228 72V85.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V280c0 11-9 20-20 20s-20-9-20-20V265.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V72c0-11 9-20 20-20s20 9 20 20z", "M228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"]]
  },
  hv = {
    prefix: "fad",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", ["M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]]
  },
  vv = {
    prefix: "fad",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", ["M192 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H488c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M48 32C34.7 32 24 42.8 24 56s10.7 24 24 24h8v96H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H104V56c0-13.3-10.7-24-24-24H48zM62.6 342.4c5.7-8.1 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H86.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9L12.5 330.1c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"]]
  },
  gv = {
    prefix: "fad",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M352 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-64 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zM480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"]]
  },
  bv = {
    prefix: "fad",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", ["M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96l64 0V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM288 288l-64 0v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 256 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-256 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64z"]]
  },
  Hv = {
    prefix: "fad",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", ["M320.1 376.3l-.1 .1v63.5l.1-.1 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L470.5 329 574.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L413.2 150.3 348.9 18C343.6 7 332.4 0 320.1 0c-.5 0-1.1 0-1.6 0H320V87.1l.1-.3 42.7 87.9 12.9 26.6 29.3 4.3 96.1 14.2-70.1 69.3-20.7 20.5 4.8 28.7 16.5 97.6-85.2-45.5-26.4-14.1zM178.3 512c-1.1 .1-2.1 .1-3.2 0h3.2z", "M321.7 0H320V87.1 376.4v63.5L191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18c.5 0 1.1 0 1.6 0zM465.2 512c-1.1 .1-2.1 .1-3.2 0h3.2z"]]
  },
  zv = {
    prefix: "fad",
    iconName: "code",
    icon: [640, 512, [], "f121", ["M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6z", "M473.4 121.4c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]]
  },
  yv = {
    prefix: "fad",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", ["M192 48A48 48 0 1 0 96 48a48 48 0 1 0 96 0zm0 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM256 0c-17.7 0-32 14.3-32 32v96H576C576 57.3 518.7 0 448 0H256zM240 256c-8.8 0-16 7.2-16 16V384H512V256H240z", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96 64V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H256 512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448 416 288 192 160 128H544 256 64V32zM512 288v96H256 64V192H256 512v96z"]]
  },
  Vv = {
    prefix: "fad",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", ["", "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"]]
  },
  xv = {
    prefix: "fad",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z"]]
  },
  Mv = {
    prefix: "fad",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  _v = {
    prefix: "fad",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", ["M144 224a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM256 296c0 13.3 10.7 24 24 24H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H280c-13.3 0-24 10.7-24 24z", "M224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zm60.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zm336-64V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V320H512z"]]
  },
  wv = {
    prefix: "fad",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z", "M64 192c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H64zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]]
  },
  Ev = {
    prefix: "fad",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", ["M432 64c-44.2 0-80 35.8-80 80v48H288V144C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V144c0-44.2-35.8-80-80-80z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
  },
  Cv = {
    prefix: "fad",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z", ""]]
  },
  Lv = {
    prefix: "fad",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", ["M192 240v96H400c61.9 0 112-50.1 112-112V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32V224c0 8.8-7.2 16-16 16H192z", "M151.5 441.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-272c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136C2.7 275.1 0 281.4 0 288s2.7 12.9 7.5 17.4l144 136z"]]
  },
  Nv = {
    prefix: "fad",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  Sv = {
    prefix: "fad",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM176 352c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H176zm16 128V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H192zM456 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H456c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1-17.9-40-40-40H456zM288 392v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8z"]]
  },
  kv = {
    prefix: "fad",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", ["M95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288z", "M224 256c35.3 0 64-28.7 64-64c0-7.1-1.2-13.9-3.3-20.3c-1.8-5.5 1.6-11.9 7.4-11.7c40.8 1.7 77.5 29.6 88.6 71.1c13.7 51.2-16.7 103.9-67.9 117.6s-103.9-16.7-117.6-67.9c-1.9-6.9-2.9-13.9-3.2-20.7c-.3-5.8 6.1-9.2 11.7-7.4c6.4 2.1 13.2 3.3 20.3 3.3z"]]
  },
  Pv = {
    prefix: "fad",
    iconName: "heat",
    icon: [448, 512, [], "e00c", ["M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32z", "M64 128c0-17.7-14.3-32-32-32S0 110.3 0 128v32c0 48.5 15.7 95.6 44.8 134.4L64 320c20.8 27.7 32 61.4 32 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-48.5-15.7-95.6-44.8-134.4L96 256c-20.8-27.7-32-61.4-32-96V128zm288 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 48.5 15.7 95.6 44.8 134.4L352 320c20.8 27.7 32 61.4 32 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-48.5-15.7-95.6-44.8-134.4L384 256c-20.8-27.7-32-61.4-32-96V128z"]]
  },
  Tv = {
    prefix: "fad",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M224 288a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]]
  },
  Ov = {
    prefix: "fad",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", ["M505.7 412.3l-8.5 31.2c-71.8-8.7-138.9-32.9-197.8-69.1l20.5-25c55.4 33.4 118.4 55.4 185.8 62.9zM99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8l-25 20.5C101.4 153.7 77.2 86.6 68.4 14.8L99.7 6.3z", "M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"]]
  },
  Av = {
    prefix: "fad",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", ["M160.4 176C103.4 202.9 64 260.8 64 328v16c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8H418c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344V328c0-67.2-39.4-125.1-96.4-152H160.4zM448 328v16c0 27.4-16.8 53.7-33.5 72H161.5c-16.7-18.3-33.5-44.6-33.5-72V328c0-57.4 46.6-104 104-104H344c57.4 0 104 46.6 104 104z", "M96 96c-17.7 0-32 14.3-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128C0 75 43 32 96 32h25.3H192 454.7c14 0 25.3 11.3 25.3 25.3c0 4.4-1.1 8.7-3.3 12.5L416 176H160L114.3 96H96zM448 344c0 27.4-16.8 53.7-33.5 72H161.5c-16.7-18.3-33.5-44.6-33.5-72V328c0-2.7 .1-5.4 .3-8H447.7c.2 2.6 .3 5.3 .3 8v16z"]]
  },
  Dv = {
    prefix: "fad",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", ["M394.6 466.8L416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"]]
  },
  Iv = {
    prefix: "fad",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", ["M109.3 288L416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0-32 32 32 32z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z"]]
  },
  jv = {
    prefix: "fad",
    iconName: "align-left",
    icon: [448, 512, [], "f036", ["M256 352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256zm0-256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H256z", "M416 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416zm0-256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416z"]]
  },
  Fv = {
    prefix: "fad",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 288v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM300.9 397.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3V284.3c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304v64l44.9 29.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM64 288v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM300.9 397.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3V284.3c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304v64l44.9 29.9z"]]
  },
  Rv = {
    prefix: "fad",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", ["M0 112C0 67.8 35.8 32 80 32H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V320c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112z", "M322.4 19.8C327.4 7.8 339.1 0 352 0H480c17.7 0 32 14.3 32 32V160c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L416 141.3 246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 96 329.4 54.6c-9.2-9.2-11.9-22.9-6.9-34.9z"]]
  },
  Bv = {
    prefix: "fad",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM176 352c-8.8 0-16 7.2-16 16v80 48c0 8.8 7.2 16 16 16s16-7.2 16-16V464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H176zm32 80H192V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304zm32 128H320V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16zm80-112v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V384h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16z"]]
  },
  Gv = {
    prefix: "fad",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", ["M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384H424l3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2v-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M192 144c13.3 0 24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24z"]]
  },
  Yv = {
    prefix: "fad",
    iconName: "rv",
    icon: [640, 512, [], "f7be", ["M176 512a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm320 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M224 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16V32H512c53 0 96 43 96 96c0 17.7-14.3 32-32 32H384V416H266.5c-13.2-37.3-48.7-64-90.5-64c-38.9 0-72.5 23.2-87.5 56.5L18.7 338.7C6.7 326.7 0 310.5 0 293.5V96C0 60.7 28.7 32 64 32H224V16zM96 144v64c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM416 320V288 216 192h24 76.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V320v64c0 17.7-14.3 32-32 32H586.5c-13.2-37.3-48.7-64-90.5-64c-33.4 0-62.8 17-80 42.9V320zm162.1-32l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48H578.1z"]]
  },
  Wv = {
    prefix: "fad",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", ["M184 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 336c77.6 0 140.9-61.4 143.9-138.2C350 315.4 328.1 320 304 320c-32 0-56-16-80-32s-48-32-80-32c-19.7 0-40.6 4.7-59 10.4c-3.2 12-5 24.6-5 37.6c0 79.5 64.5 144 144 144z", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
  },
  qv = {
    prefix: "fad",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", ["M0 112V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V112c0 15.1-7.1 29.3-19.2 38.4L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112z", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48z"]]
  },
  Uv = {
    prefix: "fad",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", ["M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z", ""]]
  },
  $v = {
    prefix: "fad",
    iconName: "h6",
    icon: [640, 512, [], "e413", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M537 116c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L389 198.5c-24 29.9-37 67.1-37 105.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-77.6-61.4-140.9-138.3-143.9L537 116zm39 188a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z"]]
  },
  Xv = {
    prefix: "fad",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V272H216c-13.3 0-24-10.7-24-24z"]]
  },
  Zv = {
    prefix: "fad",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z"]]
  },
  Kv = {
    prefix: "fad",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", ["M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z", ""]]
  },
  Qv = {
    prefix: "fad",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", ["M192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M489.6 191.2c6.9-6.2 9.6-15.9 6.4-24.6c-4.4-11.9-9.7-23.3-15.8-34.3l-4.7-8.1c-6.6-11-14-21.4-22.1-31.2c-5.9-7.2-15.7-9.6-24.5-6.8L389.1 98.8c-10 3.2-20.8 1.1-29.7-4.6c-4.9-3.1-9.9-6.1-15.1-8.7c-9.3-4.8-16.5-13.2-18.8-23.4l-8.9-40.7c-2-9.1-9-16.3-18.2-17.8C284.7 1.2 270.5 0 256 0s-28.7 1.2-42.5 3.5c-9.2 1.5-16.2 8.7-18.2 17.8l-8.9 40.7c-2.2 10.2-9.5 18.6-18.8 23.4c-5.2 2.7-10.2 5.6-15.1 8.7c-8.8 5.7-19.7 7.7-29.7 4.6L83.1 86.1c-8.8-2.8-18.6-.3-24.5 6.8c-8.1 9.8-15.5 20.2-22.1 31.2l-4.7 8.1c-6.1 11-11.4 22.4-15.8 34.3c-3.2 8.7-.5 18.4 6.4 24.6l30.9 28.1c7.7 7.1 11.4 17.5 10.9 27.9c-.1 2.9-.2 5.8-.2 8.8s.1 5.9 .2 8.8c.5 10.5-3.1 20.9-10.9 27.9L22.4 320.8c-6.9 6.2-9.6 15.9-6.4 24.6c4.4 11.9 9.7 23.3 15.8 34.3l4.7 8.1c6.6 11 14 21.4 22.1 31.2c5.9 7.2 15.7 9.6 24.5 6.8l39.7-12.6c10-3.2 20.8-1.1 29.7 4.6c4.9 3.1 9.9 6.1 15.1 8.7c9.3 4.8 16.5 13.2 18.8 23.4l8.9 40.7c2 9.1 9 16.3 18.2 17.8c13.8 2.3 28 3.5 42.5 3.5s28.7-1.2 42.5-3.5c9.2-1.5 16.2-8.7 18.2-17.8l8.9-40.7c2.2-10.2 9.4-18.6 18.8-23.4c5.2-2.7 10.2-5.6 15.1-8.7c8.8-5.7 19.7-7.7 29.7-4.6l39.7 12.6c8.8 2.8 18.6 .3 24.5-6.8c8.1-9.8 15.5-20.2 22.1-31.2l4.7-8.1c6.1-11 11.3-22.4 15.8-34.3c3.2-8.7 .5-18.4-6.4-24.6l-30.9-28.1c-7.7-7.1-11.4-17.5-10.9-27.9c.1-2.9 .2-5.8 .2-8.8s-.1-5.9-.2-8.8c-.5-10.5 3.1-20.9 10.9-27.9l30.9-28.1zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
  },
  Jv = {
    prefix: "fad",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", ["M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 448c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM384 64H64V384H384V64z", "M64 64H384V384H64V64z"]]
  },
  eg = {
    prefix: "fad",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", ["M160 109.3L160 416c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96-43 96-96l0-306.7-32-32-32 32z", "M41.4 182.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 77.3 86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0z"]]
  },
  tg = {
    prefix: "fad",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M256 96c-13.3 0-24 10.7-24 24V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24z"]]
  },
  ng = {
    prefix: "fad",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", ["M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z", "M80 64H304V384H80V64z"]]
  },
  cg = {
    prefix: "fad",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", ["M0 416c0-17.7 14.3-32 32-32l54.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 448c-17.7 0-32-14.3-32-32zm233.3 32c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32L480 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-246.7 0zM0 256c0-17.7 14.3-32 32-32l246.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 288c-17.7 0-32-14.3-32-32zm425.3 32c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32l54.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-54.7 0zM32 64l86.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 128C14.3 128 0 113.7 0 96S14.3 64 32 64zm233.3 64c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32L480 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-214.7 0z", "M128 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 80 416a80 80 0 1 0 160 0zm80-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-112a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]]
  },
  ig = {
    prefix: "fad",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", ["M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256z", "M120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0zm0 320A56 56 0 1 0 8 416a56 56 0 1 0 112 0z"]]
  },
  rg = {
    prefix: "fad",
    iconName: "download",
    icon: [512, 512, [], "f019", ["M178.7 352H64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H333.3l-54.6 54.6c-12.5 12.5-32.8 12.5-45.3 0L178.7 352zM408 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M256 0c17.7 0 32 14.3 32 32V306.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 306.7V32c0-17.7 14.3-32 32-32z"]]
  },
  ag = {
    prefix: "fad",
    iconName: "oven",
    icon: [448, 512, [], "e01d", ["M448 160v32H0V160H448zM64 256H384V448H64V256zm32 48c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z", "M96 0H352c53 0 96 43 96 96v64H0V96C0 43 43 0 96 0zM80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM200 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM64 256l0 192H384V256H64zM0 192H64 384h64v64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256 192z"]]
  },
  og = {
    prefix: "fad",
    iconName: "align-center",
    icon: [448, 512, [], "f037", ["M128 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
  },
  sg = {
    prefix: "fad",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", ["M64 270.5L64.1 472c0 22.1 17.9 40 40 40H184c22.1 0 40-17.9 40-40V383.7c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V472c0 22.1 17.9 40 40 40h80.5c22.1 0 40-18 40-40.1l-.4-201.3L288 74.5 64 270.5z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
  },
  lg = {
    prefix: "fad",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", ["M413.4 96.6l-45.3 45.3c-62.6-61.5-163.1-61.2-225.3 1c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-229.3 87.5-316.8 0s-87.5-229.3 0-316.8c87.2-87.2 228.3-87.5 315.8-1z", "M344 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8z"]]
  },
  fg = {
    prefix: "fad",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", ["M288 176C288 32 400 0 416 0c17.7 0 32 14.3 32 32V352H352c-35.3 0-64-28.7-64-64V176zM49.7 .1C57.9 1 64 7.8 64 16V150.2c0 5.4 4.4 9.8 9.8 9.8c5.1 0 9.3-3.9 9.8-9L96.1 14.6C96.8 6.3 103.7 0 112 0s15.2 6.3 15.9 14.6L140.3 151c.5 5.1 4.7 9 9.8 9c5.4 0 9.8-4.4 9.8-9.8V16c0-8.2 6.1-15 14.3-15.9s15.6 4.5 17.4 12.4l30.3 136.3c1.4 6.3 2.1 12.7 2.1 19.1c0 48.6-39.4 88.1-88.1 88.1H88.1C39.4 256 0 216.6 0 167.9c0-6.4 .7-12.8 2.1-19.1L32.4 12.5C34.2 4.6 41.6-.8 49.7 .1zM112 167.4l-.3 .7 .3 0 .3 0-.3-.7z", "M144 480V256H80V480c0 17.7 14.3 32 32 32s32-14.3 32-32zm304 0V352H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"]]
  },
  ug = {
    prefix: "fad",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", ["M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM128 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm32 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M0 256c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256z"]]
  },
  dg = {
    prefix: "fad",
    iconName: "upload",
    icon: [512, 512, [], "f093", ["M288 352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H288zm120 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M256 416c17.7 0 32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3V384c0 17.7 14.3 32 32 32z"]]
  },
  pg = {
    prefix: "fad",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", ["M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z", ""]]
  },
  mg = {
    prefix: "fad",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm88 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M416 196.9c1.9 1.4 3.8 2.9 5.6 4.4C437.1 214.5 448 232.9 448 256c0 46.9-14.3 84.1-37 112.5c-14.2 17.7-31.1 31.3-48.5 41.8l19.8 59.5c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H96c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l19.8-59.5C68.1 399.8 51.2 386.2 37 368.5C14.3 340.1 0 302.9 0 256c0-23.1 10.9-41.5 26.4-54.6c1.8-1.5 3.7-3 5.6-4.4V48H416V196.9zM384 256l0-.1c0-1 0-2.5-3.8-5.8c-4.8-4.1-14-9-29.3-13.4C320.5 228 276.1 224 224 224s-96.5 4-126.9 12.8c-15.3 4.4-24.5 9.3-29.3 13.4C64 253.4 64 255 64 255.9l0 .1 0 .3c0 1 .3 2.6 3.8 5.6c4.8 4.1 14 9 29.3 13.4C127.5 284 171.9 288 224 288s96.5-4 126.9-12.8c15.3-4.4 24.5-9.3 29.3-13.4c3.5-3 3.8-4.6 3.8-5.6l0-.3zM112 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]]
  },
  hg = {
    prefix: "fad",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", ["M80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 96V416c0 53-43 96-96 96s-96-43-96-96c0-35.6 19.4-66.6 48-83.1c15.3-8.9 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-9.6 5.6-16 15.9-16 27.7c0 17.7 14.3 32 32 32s32-14.3 32-32V224h64zm64 0h64V384c0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7c-15.3-8.9-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c28.6 16.6 48 47.6 48 83.1c0 53-43 96-96 96s-96-43-96-96V224z", "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
  },
  vg = {
    prefix: "fad",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", ["M351.1 422.6c5.2 26-11.7 51.3-37.7 56.5s-51.3-11.7-56.5-37.7L254.6 430c-6.6-33.2-24.8-63-51.2-84.2l-7.4-5.9c-22.8-18.2-36-45.8-36-75V240 192 153.7c0-32.1 16-62.1 42.7-79.9l38.5-25.7C257.1 37.6 275.6 32 294.5 32H392c26.5 0 48 21.5 48 48c0 3.6-.4 7-1.1 10.4C458.1 96.6 472 114.7 472 136c0 9.1-2.5 17.6-6.9 24.9c22.2 4.2 38.9 23.7 38.9 47.1c0 15.1-7 28.6-17.9 37.4c15.4 8 25.9 24.1 25.9 42.6c0 26.5-21.5 48-48 48H320c13.7 23.1 23.5 48.5 28.8 75.2l2.3 11.4z", "M0 352c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352z"]]
  },
  gg = {
    prefix: "fad",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", ["M402.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0 32-32-32-32z", "M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 256 329.4 150.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]]
  },
  bg = {
    prefix: "fad",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", ["M168 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z", "M64 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm320 0a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]]
  },
  Hg = {
    prefix: "fad",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", ["M32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm0 256c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336zM336 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z", "M408 296c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H296c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V408h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H408V296z"]]
  },
  zg = {
    prefix: "fad",
    iconName: "bug",
    icon: [512, 512, [], "f188", ["M256 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H323.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zm0 480c5.4 0 10.7-.3 16-.8V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c5.3 .5 10.6 .8 16 .8z", "M86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c.7 .7 1.4 1.3 2.1 1.9c-6.2 12-10.1 25.3-11.1 39.5H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V240c0-8.8 7.2-16 16-16s16 7.2 16 16V479.2c34.5-3.4 65.8-17.8 90.3-39.6l63.1 63.1c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-1.9-1.9-3.9-3.4-6-4.8c9.9-20.8 15.4-44.1 15.4-68.6h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H415.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C345.2 164.1 329.1 160 312 160H200c-17.1 0-33.2 4.1-47.5 11.4c-.6-.7-1.2-1.4-1.9-2.1l-64-64z"]]
  },
  yg = {
    prefix: "fad",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", ["M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z", "M576 224H0V128H576v96z"]]
  },
  Vg = {
    prefix: "fad",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M96 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
  },
  xg = {
    prefix: "fad",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", ["M176 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm112 32c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96v64 32H608 320 288V288 160z", "M32 32c17.7 0 32 14.3 32 32V320H608h32v32 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32z"]]
  },
  Mg = {
    prefix: "fad",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", ["M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32z", "M288 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0h64z"]]
  },
  _g = {
    prefix: "fad",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]]
  },
  wg = {
    prefix: "fad",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64z", "M224 0L384 160H256c-17.7 0-32-14.3-32-32V0z"]]
  },
  Eg = {
    prefix: "fad",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", ["M269.5 325.9c11.1-7.9 25.9-7.9 37 0C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1z", "M447.9 297.1L309.5 178.4C331.7 166.6 357.1 160 384 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-121.8 0-220.9 97.2-223.9 218.2c10.8 4 21.8 6.2 31.9 6.2c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.6-1.1 3.1-2.1 4.8-3zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128z"]]
  },
  Cg = {
    prefix: "fad",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", ["M391 96H121L73 288h51.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H439L391 96z", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]]
  },
  Lg = {
    prefix: "fad",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", ["M96 32C78.3 32 64 46.3 64 64V249.7L236.7 377.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4L448 249.7V64c0-17.7-14.3-32-32-32H96zm80 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M511.8 202.5c-1.6-18.1-10.9-34.9-25.7-45.8L448 128.5v79.6 41.6l63.8-47.2zM512 448V242.1L294.4 403.3C283.3 411.6 269.8 416 256 416s-27.3-4.4-38.4-12.7L0 242.1V448v0c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64v0zM64 249.7V208.1l0-79.6L25.9 156.7C11.1 167.6 1.8 184.4 .2 202.5L64 249.7zM289.5 11.1C279.8 3.9 268.1 0 256 0s-23.8 3.9-33.5 11L194.2 32H317.8L289.5 11.1zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]]
  },
  Ng = {
    prefix: "fad",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", ["M320 448l0-352 64 0V448c0 17.7-14.3 32-32 32s-32-14.3-32-32z", "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]]
  },
  Sg = {
    prefix: "fad",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", ["M144 24c0-13.3-10.7-24-24-24S96 10.7 96 24v2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24z", "M0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424H306.5l-18.3-42.7C277.7 383.1 267 384 256 384H192c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
  },
  kg = {
    prefix: "fad",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", ["M579.8 63.2c56.5 56.5 56.5 148 0 204.5L467.5 380c-56.5 56.5-148 56.5-204.5 0c-50-50-56.5-128.8-15.4-186.3l1.1-1.6c10.3-14.4 30.3-17.7 44.6-7.4s17.7 30.3 7.4 44.6l-1.1 1.6c-22.9 32.1-19.3 76 8.6 103.8c31.5 31.5 82.5 31.5 114 0L534.5 222.5c31.5-31.5 31.5-82.5 0-114C506.7 80.6 462.7 77 430.7 99.9l-1.6 1.1c-14.4 10.3-34.4 6.9-44.6-7.4s-6.9-34.4 7.4-44.6l1.6-1.1C451 6.7 529.8 13.3 579.8 63.2z", "M60.2 448.8c-56.5-56.5-56.5-148 0-204.5L172.5 132c56.5-56.5 148-56.5 204.5 0c50 50 56.5 128.8 15.4 186.3l-1.1 1.6c-10.3 14.4-30.3 17.7-44.6 7.4s-17.7-30.3-7.4-44.6l1.1-1.6c22.9-32.1 19.3-76-8.6-103.9c-31.5-31.5-82.5-31.5-114 0L105.5 289.5C74 321 74 372 105.5 403.5c27.9 27.9 71.8 31.5 103.8 8.6l1.6-1.1c14.4-10.3 34.4-6.9 44.6 7.4s6.9 34.4-7.4 44.6l-1.6 1.1C189 505.3 110.2 498.7 60.2 448.8z"]]
  },
  Pg = {
    prefix: "fad",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", ["M208 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 352A208 208 0 1 0 208 0a208 208 0 1 0 0 416z", "M330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z"]]
  },
  Tg = {
    prefix: "fad",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", ["M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z", "M80 160c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm0 192c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM96 240H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
  },
  Og = {
    prefix: "fad",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", ["M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z", ""]]
  },
  Ag = {
    prefix: "fad",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", ["M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M64 64H576V352H64V64z"]]
  },
  Dg = {
    prefix: "fad",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", ["M160 416c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm64-160c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32zm32-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32s14.3 32 32 32z", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
  },
  Ig = {
    prefix: "fad",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", ["M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z", "M256 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 176c56.8 0 107.8-24.7 143-63.8C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8z"]]
  },
  jg = {
    prefix: "fad",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", ["M64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM288 416c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32z"]]
  },
  Fg = {
    prefix: "fad",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", ["M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z", ""]]
  },
  Rg = {
    prefix: "fad",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", ["M297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6z", ""]]
  },
  Bg = {
    prefix: "fad",
    iconName: "h2",
    icon: [640, 512, [], "f314", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M491.5 128c-15.3 0-30.1 5.5-41.7 15.4l-29 24.9c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l29-24.9C431.4 74.9 461 64 491.5 64H496c70.7 0 128 57.3 128 128v5.8c0 35.9-15.1 70.1-41.5 94.4L482.3 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H400c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L539.2 244.9c13.2-12.1 20.8-29.2 20.8-47.2V192c0-35.3-28.7-64-64-64h-4.5z"]]
  },
  Gg = {
    prefix: "fad",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", ["M192.1 416L384 480V96L192 32l.1 384z", "M0 114.5V464c0 11.3 11.5 19 22 14.8L192 416l-.1-384L10.1 99.6C4 102 0 107.9 0 114.5zM554 33.2L384 96V480l181.9-67.6c6.1-2.4 10.1-8.3 10.1-14.9V48c0-11.3-11.4-19.1-22-14.9z"]]
  },
  Yg = {
    prefix: "fad",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M384 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
  },
  Wg = {
    prefix: "fad",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", ["M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z", ""]]
  },
  qg = {
    prefix: "fad",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", ["M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z", ""]]
  },
  Ug = {
    prefix: "fad",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", ["M374.6 73.4c12.5 12.5 12.5 32.8 0 45.3l-320 320c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l320-320c12.5-12.5 32.8-12.5 45.3 0z", "M64 192A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
  },
  $g = {
    prefix: "fad",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", ["M16 319.6l0-7.6c0-13.3 10.7-24 24-24h7.6c.2 0 .5 0 .7 0H168c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6c0-.2 0-.5 0-.7z", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5z"]]
  },
  Xg = {
    prefix: "fad",
    iconName: "spinner",
    icon: [512, 512, [], "f110", ["M369.1 75A48 48 0 1 1 437 142.9 48 48 0 1 1 369.1 75zM416 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM75 369.1A48 48 0 1 1 142.9 437 48 48 0 1 1 75 369.1zm294.2 0A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256A48 48 0 1 0 0 256a48 48 0 1 0 96 0zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9z"]]
  },
  Zg = {
    prefix: "fad",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", ["M233.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]]
  },
  Kg = {
    prefix: "fad",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", ["M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z", "M32 96H608V480c0 17.7-14.3 32-32 32H480V352c0-88.4-71.6-160-160-160s-160 71.6-160 160V512H64c-17.7 0-32-14.3-32-32V96zM320.6 465.5c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8c-10.9 7.3-22.5 10.9-35.6 10.9z"]]
  },
  Qg = {
    prefix: "fad",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", ["M120.2 120.2C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8z", "M256 128c13.3 0 24 10.7 24 24v94.1l65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17V152c0-13.3 10.7-24 24-24z"]]
  },
  Jg = {
    prefix: "fad",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", ["M207.6 69.3c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L132.9 128h64.9l9.8-58.7zM187.1 192H122.2L80.4 442.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L187.1 192zM367.6 69.3c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L260.9 320h64.9L367.6 69.3zM315.1 384H250.2l-9.8 58.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L315.1 384z", "M292.9 128H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H282.2l10.7-64zm54.2 64H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.8l-10.7 64zm-192 192H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H165.8l-10.7 64zm-54.2-64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H90.2l10.7-64z"]]
  },
  eb = {
    prefix: "fad",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM288 160c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zm160-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32z"]]
  },
  tb = {
    prefix: "fad",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", ["M128 512c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V256H80v96H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z", "M128 0c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H176v96H80V160H24c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112C115 2.8 121.3 0 128 0z"]]
  },
  nb = {
    prefix: "fad",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
  },
  cb = {
    prefix: "fad",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", ["M384 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M99.9 96C80.1 96 64 112.1 64 131.9V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V131.9C0 76.7 44.7 32 99.9 32c26.5 0 51.9 10.5 70.6 29.3l16.2 16.2c38.9-21 87.5-17.4 123 10.9L311 87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L185 281c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l1.3-1.3c-28.3-35.5-31.9-84.2-10.9-123l-16.2-16.2C118.5 99.8 109.4 96 99.9 96z"]]
  },
  ib = {
    prefix: "fad",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z", "M512 64H64V288H512V64zM416 448H346.7L336 416H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32z"]]
  },
  rb = {
    prefix: "fad",
    iconName: "h5",
    icon: [640, 512, [], "e412", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M400.7 89.4C403.8 74.6 416.9 64 432 64H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H458l-18.5 88H524c64.1 0 116 51.9 116 116s-51.9 116-116 116H456.4c-37.9 0-71.5-24.2-83.5-60.2l-3.2-9.7c-5.6-16.8 3.5-34.9 20.2-40.5s34.9 3.5 40.5 20.2l3.2 9.7c3.3 9.8 12.4 16.4 22.8 16.4H524c28.7 0 52-23.3 52-52s-23.3-52-52-52H400c-9.6 0-18.8-4.3-24.8-11.8s-8.5-17.3-6.5-26.8l32-152z"]]
  },
  ab = {
    prefix: "fad",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", ["", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]]
  },
  ob = {
    prefix: "fad",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", ["M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  sb = {
    prefix: "fad",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", ["M288 288V128H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96z", "M288 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V64z"]]
  },
  lb = {
    prefix: "fad",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", ["M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 45 11.6 87.3 32 124V352c0-30.9 25.1-56 56-56s56 25.1 56 56v3l92.2-33.5-82.4-34.7c-8.1-3.4-12-12.8-8.5-21s12.8-12 21-8.5l122.5 51.6c22.7 9.6 37.9 31.2 39.2 55.6c1.5 24.2-12.9 47.4-36.8 56.1l-35.8 13-21 57.7c-2.5 6.8-5.8 13.1-9.8 18.8c10.3 1.3 20.8 1.9 31.4 1.9zM176.4 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-88-63.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3z", "M143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 352c0-13.3-10.7-24-24-24s-24 10.7-24 24V464c0 26.5 21.5 48 48 48h47.2c20.2 0 38.2-12.6 45.1-31.6l26.1-71.7 49.8-18.1c12.5-4.5 18.9-18.3 14.4-30.8s-18.3-18.9-30.8-14.4L112 400.6V352zM368.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
  },
  fb = {
    prefix: "fad",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", ["M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L224 402.7V389.4L380.7 185.8c5.2-6.7 4.2-16.4-2.3-21.9s-16.1-5.1-22 1.1L178.8 350.6l-14.1 14.1c-3 3-4.7 7.1-4.7 11.3l-28.3-11.8-112-46.7C8.4 312.8 .8 302.2 .1 290s5.5-23.7 16.1-29.8l448-256c10.7-6.1 23.9-5.5 34 1.4z", "M380.7 185.8c5.1-6.7 4.2-16.2-2.1-21.8s-15.9-5.3-21.9 .7l-179 179-13 13c-3 3-4.7 7.1-4.7 11.3v8 56 48c0 13.2 8.1 25 20.3 29.8s26.2 1.6 35.2-8.1L284 427.7l-60-25V389.4L380.7 185.8z"]]
  },
  ub = {
    prefix: "fad",
    iconName: "align-right",
    icon: [448, 512, [], "f038", ["M192 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H192zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H192z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
  },
  db = {
    prefix: "fad",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
  },
  pb = {
    prefix: "fad",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", ["M351.1 89.4c5.2-26-11.7-51.3-37.7-56.5s-51.3 11.7-56.5 37.7L254.6 82c-6.6 33.2-24.8 63-51.2 84.2l-7.4 5.9c-22.8 18.2-36 45.8-36 75V272v48 38.3c0 32.1 16 62.1 42.7 79.9l38.5 25.7c15.8 10.5 34.3 16.1 53.3 16.1H392c26.5 0 48-21.5 48-48c0-3.6-.4-7-1.1-10.4c19.2-6.3 33.1-24.3 33.1-45.6c0-9.1-2.5-17.6-6.9-24.9c22.2-4.2 38.9-23.7 38.9-47.1c0-15.1-7-28.6-17.9-37.4c15.4-8 25.9-24.1 25.9-42.6c0-26.5-21.5-48-48-48H320c13.7-23.1 23.5-48.5 28.8-75.2l2.3-11.4z", "M0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224z"]]
  },
  mb = {
    prefix: "fad",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm0 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 112c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zM224 432c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM96 224c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96zm0 32H288v64H96V256zM240 416c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]]
  },
  hb = {
    prefix: "fad",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", ["M128 0C92.7 0 64 28.7 64 64V192h64V64H354.7L384 93.3V192h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM64 384v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384H384v64H128V384H64z", "M0 256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H384V352H128v32H32c-17.7 0-32-14.3-32-32V256zm456 16a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
  },
  vb = {
    prefix: "fad",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", ["M128 192H64V420.3c-.6 .3-1.2 .7-1.7 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V192H384V416H344V192H280V416H232V192H168V416H128V192z", "M268.6 2.6c-8-3.4-17.2-3.4-25.2 0l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24l0-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
  },
  gb = {
    prefix: "fad",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", ["M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", ""]]
  },
  bb = {
    prefix: "fad",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", ["M144 192h96V400c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32V448c0-17.7 14.3-32 32-32h96c8.8 0 16-7.2 16-16V192z", "M345.4 151.5c6.6 7 8.4 17.2 4.6 26s-12.5 14.5-22 14.5L56 192c-9.6 0-18.2-5.7-22-14.5s-2-19 4.6-26l136-144C179.1 2.7 185.4 0 192 0s12.9 2.7 17.4 7.5l136 144z"]]
  },
  Hb = {
    prefix: "fab",
    iconName: "cc-visa",
    icon: [576, 512, [], "f1f0", "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"]
  },
  zb = {
    prefix: "fab",
    iconName: "cc-mastercard",
    icon: [576, 512, [], "f1f1", "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"]
  },
  yb = {
    prefix: "fab",
    iconName: "cc-discover",
    icon: [576, 512, [], "f1f2", "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"]
  },
  Vb = {
    prefix: "fab",
    iconName: "stripe",
    icon: [640, 512, [], "f429", "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"]
  },
  xb = {
    prefix: "fab",
    iconName: "instagram",
    icon: [448, 512, [], "f16d", "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"]
  },
  Mb = {
    prefix: "fab",
    iconName: "facebook",
    icon: [512, 512, [62e3], "f09a", "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"]
  },
  _b = {
    prefix: "fab",
    iconName: "snapchat",
    icon: [512, 512, [62124, "snapchat-ghost"], "f2ab", "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"]
  },
  wb = {
    prefix: "fab",
    iconName: "cc-amex",
    icon: [576, 512, [], "f1f3", "M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z"]
  },
  Eb = {
    prefix: "fab",
    iconName: "twitter",
    icon: [512, 512, [], "f099", "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"]
  },
  Cb = {
    prefix: "fab",
    iconName: "pinterest",
    icon: [496, 512, [], "f0d2", "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"]
  },
  Lb = ["solid", "regular", "light", "thin", "duotone"],
  Nb = {
    archive: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ll,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: na,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    arrowLeft: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Iv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ho,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: di,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    bars: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ch,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    bug: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: su,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ts,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $i,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    calendarAlt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: tl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $r,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    check: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ab,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: eh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $u,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chevronDown: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Og,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chevronLeft: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ws,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Hr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chevronRight: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Es,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chevronUp: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ha,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    clock: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: tg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ao,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Li,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    cog: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ff,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Po,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    commentLines: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ph,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ed,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: oc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    commentsDollar: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: tf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $a,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    conciergeBell: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _h,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Hd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: dl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ra,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    ellipsisH: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: dm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: au,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    ellipsisV: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ig,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ki,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    emptySet: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Eh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ml,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: oa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: tc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    envelope: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Eo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    envelopeOpenText: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    exclamationTriangle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ob,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: th,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Or,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    externalLinkAlt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Op,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    inbox: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ls,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    infoCircle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Df,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: No,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    longArrowRight: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: um,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ru,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    messageLines: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Kd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Da,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Sc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    minus: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Kv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ko,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _i,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    paperclip: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Uv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Of,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Co,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    pencilAlt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: md,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ol,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ea,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $n,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    plus: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ys,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    questionCircle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Nv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Mp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ii,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    search: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Em,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ms,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: or,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    slidersH: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Kp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Io,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Si,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    spinner: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Du,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ns,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    star: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $h,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ol,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ca,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    stars: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Dl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Na,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Mc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    times: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Om,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    trash: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Dv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Sp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _f,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ui,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    trashAlt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ph,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: od,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: el,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ur,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    userCircle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ig,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: km,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Hs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: dr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    turnUp: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: dh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ad,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Js,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    arrowTurnUp: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: eg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $p,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Oo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ci,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    house: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Go,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ai,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    moneyBill: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Od,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ya,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    moneyBillWave: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    receipt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    anglesLeft: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ym,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Iu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ss,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Mr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    phone: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ov,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: li,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    reply: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: aa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ec,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    thumbsUp: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: oh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: td,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $s,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    thumbsDown: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: iu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ko,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    lock: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Oh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ld,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ha,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    lockOpen: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ev,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: oo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ti,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    lockKeyhole: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ao,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ei,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    bell: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Mg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: du,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    circlePlus: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ds,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Nr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    rv: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ip,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _o,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    list: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Th,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ma,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    listCheck: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Dg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Sm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _u,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ur,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    download: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Uf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    circleCheck: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ov,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: tp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $l,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ra,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Oc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    image: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: iv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ia,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    clockRotateLeft: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ps,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    desktop: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ib,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: js,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    laptop: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    tablet: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Up,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: To,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ei,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    mobile: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ng,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Do,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ni,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    messageQuestion: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ca,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Kn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    users: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ih,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _l,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ba,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: dc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    peopleGroup: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: la,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    fileInvoice: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Br,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    fileInvoiceDollar: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Al,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: La,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    messageDots: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    floppyDisk: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ho,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: si,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    rotate: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $g,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Au,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ls,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chartBar: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Aa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Nc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chartGantt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: If,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: So,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Mi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chartSimple: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Dd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Nl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chartWaterfall: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: up,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ka,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chartScatter: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Im,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ku,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _s,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: br,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    chartColumn: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: eb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $m,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Os,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    barsFilter: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Eu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    starHalfStroke: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Hv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: of,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ja,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Uc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    percent: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ug,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ou,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    faceSurprise: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Mv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: df,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: io,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    faceThinking: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ch,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ku,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ys,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Dr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    circle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: so,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ni,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    upload: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: dg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: am,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: eu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Uo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    layerGroup: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: dv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ap,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    eye: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: po,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ai,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    sort: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    ban: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Uh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ea,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    bold: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: tv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Oa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    italic: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: op,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ef,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ua,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    strikethrough: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Hh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: al,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Un,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    paragraph: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ng,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Mm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: bu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: us,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ir,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    h1: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ld,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: nl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    h2: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Am,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Nu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    h3: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _a,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Hc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    h4: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Kh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Il,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Sa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: _c,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    h5: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Uu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    h6: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $v,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Af,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Vi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    listOl: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Za,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    blockquote: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ug,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ji,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    horizontalRule: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: uh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Wr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    rotateLeft: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ql,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ja,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    rotateRight: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Kf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Di,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    turnDownLeft: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Lv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: xp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ci,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    textSlash: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ip,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Kl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ya,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ic,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    alignSlash: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: av,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ep,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ul,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Tc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    underline: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ev,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $d,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Rl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ta,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Cc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    link: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: kg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: wm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ps,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ar,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    alignCenter: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: og,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: tm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Oi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    alignLeft: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Pp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ef,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: pi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    alignRight: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ub,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: rh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ju,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: qs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: jr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    alignJustify: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Bh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ad,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ll,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Va,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    hashtag: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Jg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Um,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ru,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ts,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Er,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    map: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Gg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Dm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Su,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ms,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    linkSimple: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Td,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: El,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: za,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    creditCard: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ns,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    clipboardList: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: yh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: hd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ta,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    code: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: zv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: mp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: eo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: $c,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    paperPlane: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ih,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Qu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ws,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ir,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    certificate: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: lv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: cp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Zl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ga,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Dc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    checkCircle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: sv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: np,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Xl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ba,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ac,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    exclamationCircle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Nh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Md,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: gl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ic,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    stripe: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color,
        s = e.iconProps;
      return /*#__PURE__*/t.createElement(jn, E({
        icon: Vb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      }, s));
    },
    timesCircle: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: db,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ah,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: ed,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Us,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Fr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    university: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: vb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: fh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: id,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Ks,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(jn, E({
              icon: Yr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s
            }, l));
        }
      }();
    },
    bed: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: xg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: gm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: uu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: is,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ki,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    shower: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: cb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Km,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Wu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Is,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Sr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    mapMarkerAlt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: _g,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Hm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: pu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: as,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ji,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    share: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: sb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: nh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Zu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Gs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ar,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    bath: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Jh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ud,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Fl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Pa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ec,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    toilet: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: mg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: sm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: nu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Xo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Bi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    grid: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: bh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: dd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: rl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Qr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: qn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    bolt: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: pg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: om,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: tu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: $o,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ri,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    boltLightning: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Vv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: vp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ff,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: no,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Zc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    airConditioner: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: hg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: lm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: cu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Zo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Gi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fireplace: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Kg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Wm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ju,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ks,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: _r,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    circleParking: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Yh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Id,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Sl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ma,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: bc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    wifi: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Qh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: qd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: jl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ka,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: wc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    heat: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Pv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ep,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: yf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: mo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: oi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    washingMachine: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Wv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: jp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Pf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: wo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Hi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    hotTubPerson: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ah,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Nd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: xl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: va,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: fc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    personSwimming: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Eg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ym,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: hu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ss,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: tr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    tv: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ag,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Nm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Mu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: gs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: fr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    blanket: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Dh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Sd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ml,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ga,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: uc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    gamepadModern: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Gv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Dp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Sf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Mo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: gi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    kitchenSet: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: _v,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Hp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: pf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ro,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Jc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    microwave: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Mh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: bd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ul,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ia,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Qn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    coffeePot: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Av,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Np,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Mf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: go,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: fi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    utensils: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: fg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: im,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Qf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Wo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ii,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    oven: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ag,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: em,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: $f,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ro,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ti,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fireBurner: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: kh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: wd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Hl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: da,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: ac,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    grillHot: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Sg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: _m,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Hu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ds,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: rr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    facebook: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: Mb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    twitter: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: Eb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    instagram: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: xb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    pinterest: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: Cb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    snapchat: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: _b,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    bedBunk: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: yv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: hp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: lf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: to,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Xc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    ccVisa: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: Hb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    ccMastercard: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: zb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    ccAmex: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: wb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    ccDiscover: function (e) {
      var n = e.spin,
        c = e.beat,
        i = e.fade,
        r = e.rotation,
        a = e.flip,
        o = e.color;
      return /*#__PURE__*/t.createElement(jn, {
        icon: yb,
        spin: n,
        beat: c,
        fade: i,
        rotation: r,
        flip: a,
        color: o
      });
    },
    sitemap: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Sh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: _d,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: bl,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ua,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: rc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    grid2Plus: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Hg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: pm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ou,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: es,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ui,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    upDownLeftRight: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: bv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: dp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: af,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Qa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: qc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    upDown: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: tb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Xm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Gu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: As,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Lr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    file: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: wg,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: zm,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: mu,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: os,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: er,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    filePdf: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Bv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ap,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Nf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: xo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: vi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileExcel: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: xv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: gp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: uf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: co,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Kc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileWord: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: uv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: rp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Ql,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Wa,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: jc,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileDoc: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Sv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: _p,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Hf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: uo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: ri,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileCsv: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: gh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: ud,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: il,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Kr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Wn,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileVideo: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Fv,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Tp,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Cf,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: yo,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: mi,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    print: function (e) {
      var n = e.style,
        c = e.spin,
        i = e.beat,
        r = e.fade,
        a = e.rotation,
        o = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(jn, {
              icon: hb,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(jn, {
              icon: lh,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(jn, {
              icon: cd,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(jn, {
              icon: Zs,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(jn, {
              icon: Gr,
              spin: c,
              beat: i,
              fade: r,
              rotation: a,
              flip: o,
              color: s,
              iconProps: l
            });
        }
      }();
    }
  },
  Sb = function (e) {
    var n = e.iconStyle,
      c = e.name,
      i = e.spin,
      r = e.beat,
      a = e.fade,
      o = e.rotation,
      s = e.flip,
      l = e.color,
      f = e.iconProps,
      u = Nb["".concat(c)];
    return /*#__PURE__*/t.createElement(u, {
      style: n,
      spin: i,
      beat: r,
      fade: a,
      rotation: o,
      flip: s,
      color: l,
      iconProps: f
    });
  };
Sb.propTypes = {
  name: p.oneOf(Object.keys(Nb)).isRequired,
  iconStyle: p.oneOf(Lb),
  spin: p.bool,
  beat: p.bool,
  fade: p.bool,
  rotation: p.number,
  flip: p.oneOf(["horizontal", "vertical", "both"]),
  iconProps: p.object,
  color: p.string
}, Sb.defaultProps = {
  iconStyle: Lb[0],
  name: Object.keys(Nb)[0],
  spin: !1,
  beat: !1,
  fade: !1,
  iconProps: {}
};
var kb,
  Pb = {
    exports: {}
  };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
kb = Pb, function () {
  var e = {}.hasOwnProperty;
  function t() {
    for (var n = [], c = 0; c < arguments.length; c++) {
      var i = arguments[c];
      if (i) {
        var r = typeof i;
        if ("string" === r || "number" === r) n.push(i);else if (Array.isArray(i)) {
          if (i.length) {
            var a = t.apply(null, i);
            a && n.push(a);
          }
        } else if ("object" === r) if (i.toString === Object.prototype.toString) for (var o in i) e.call(i, o) && i[o] && n.push(o);else n.push(i.toString());
      }
    }
    return n.join(" ");
  }
  kb.exports ? (t.default = t, kb.exports = t) : window.classNames = t;
}();
var Tb = Pb.exports,
  Ob = {
    "is-block": "baseElement-module_is-block__24Wgj",
    "is-flex": "baseElement-module_is-flex__27P-_",
    "is-inline": "baseElement-module_is-inline__38lhE",
    "is-inline-block": "baseElement-module_is-inline-block__1EOVI",
    "is-inline-flex": "baseElement-module_is-inline-flex__2jOiG",
    "is-flex-direction-row": "baseElement-module_is-flex-direction-row__2fezM",
    "is-flex-direction-row-reverse": "baseElement-module_is-flex-direction-row-reverse__VwsES",
    "is-flex-direction-column": "baseElement-module_is-flex-direction-column__1pnBV",
    "is-flex-direction-column-reverse": "baseElement-module_is-flex-direction-column-reverse__3zAYn",
    "is-flex-wrap-nowrap": "baseElement-module_is-flex-wrap-nowrap__1qsop",
    "is-flex-wrap-wrap": "baseElement-module_is-flex-wrap-wrap__1tCCu",
    "is-flex-wrap-wrap-reverse": "baseElement-module_is-flex-wrap-wrap-reverse__2C7XM",
    "is-justify-content-flex-start": "baseElement-module_is-justify-content-flex-start__2dszS",
    "is-justify-content-flex-end": "baseElement-module_is-justify-content-flex-end__lKIAa",
    "is-justify-content-center": "baseElement-module_is-justify-content-center__AMxz_",
    "is-justify-content-space-between": "baseElement-module_is-justify-content-space-between__1KY6r",
    "is-justify-content-space-around": "baseElement-module_is-justify-content-space-around__iIsbY",
    "is-justify-content-space-evenly": "baseElement-module_is-justify-content-space-evenly__3LRFd",
    "is-justify-content-start": "baseElement-module_is-justify-content-start__2VvsD",
    "is-justify-content-end": "baseElement-module_is-justify-content-end__3CH61",
    "is-justify-content-left": "baseElement-module_is-justify-content-left__1Zpay",
    "is-justify-content-right": "baseElement-module_is-justify-content-right__2KWWa",
    "is-align-content-flex-start": "baseElement-module_is-align-content-flex-start__gf-u4",
    "is-align-content-flex-end": "baseElement-module_is-align-content-flex-end__3W1JX",
    "is-align-content-center": "baseElement-module_is-align-content-center__3z9MS",
    "is-align-content-space-between": "baseElement-module_is-align-content-space-between__1VfdJ",
    "is-align-content-space-around": "baseElement-module_is-align-content-space-around__Opkbc",
    "is-align-content-space-evenly": "baseElement-module_is-align-content-space-evenly__1SIcp",
    "is-align-content-stretch": "baseElement-module_is-align-content-stretch__J0ZFA",
    "is-align-content-start": "baseElement-module_is-align-content-start__3YSV6",
    "is-align-content-end": "baseElement-module_is-align-content-end__3odqv",
    "is-align-content-baseline": "baseElement-module_is-align-content-baseline__383Ec",
    "is-align-items-stretch": "baseElement-module_is-align-items-stretch__2j-N3",
    "is-align-items-flex-start": "baseElement-module_is-align-items-flex-start__1c7_5",
    "is-align-items-flex-end": "baseElement-module_is-align-items-flex-end__1VAcG",
    "is-align-items-center": "baseElement-module_is-align-items-center__dp0Ke",
    "is-align-items-baseline": "baseElement-module_is-align-items-baseline__3A_mZ",
    "is-align-items-start": "baseElement-module_is-align-items-start__3Zsha",
    "is-align-items-end": "baseElement-module_is-align-items-end__TEayk",
    "is-align-items-self-start": "baseElement-module_is-align-items-self-start__2WYnZ",
    "is-align-items-self-end": "baseElement-module_is-align-items-self-end__egJ0A",
    "is-align-self-auto": "baseElement-module_is-align-self-auto__Rj55b",
    "is-align-self-flex-start": "baseElement-module_is-align-self-flex-start__3YVqx",
    "is-align-self-flex-end": "baseElement-module_is-align-self-flex-end__IEKld",
    "is-align-self-center": "baseElement-module_is-align-self-center__3sIv4",
    "is-align-self-baseline": "baseElement-module_is-align-self-baseline__1wmsb",
    "is-align-self-stretch": "baseElement-module_is-align-self-stretch__2haBd",
    "is-flex-grow-0": "baseElement-module_is-flex-grow-0__1OjTh",
    "is-flex-grow-1": "baseElement-module_is-flex-grow-1__4QoEZ",
    "is-flex-grow-2": "baseElement-module_is-flex-grow-2__3ZXmL",
    "is-flex-grow-3": "baseElement-module_is-flex-grow-3__3H1VO",
    "is-flex-grow-4": "baseElement-module_is-flex-grow-4__3Fmot",
    "is-flex-grow-5": "baseElement-module_is-flex-grow-5__N7Rl1",
    "is-flex-shrink-0": "baseElement-module_is-flex-shrink-0__3AG0j",
    "is-flex-shrink-1": "baseElement-module_is-flex-shrink-1__2V4UV",
    "is-flex-shrink-2": "baseElement-module_is-flex-shrink-2__33clr",
    "is-flex-shrink-3": "baseElement-module_is-flex-shrink-3__1Uhn7",
    "is-flex-shrink-4": "baseElement-module_is-flex-shrink-4__x0Xw6",
    "is-flex-shrink-5": "baseElement-module_is-flex-shrink-5__2HIX2",
    setRelative: "baseElement-module_setRelative__T8yZ2"
  },
  Ab = ["flexDirection", "flexWrap", "justifyContent", "alignItems", "flexGrow", "flexShrink", "display"],
  Db = ["renderAs", "children", "domRef", "className", "setPositionRelative"],
  Ib = function (e) {
    var n = e.renderAs,
      c = e.children,
      i = e.domRef,
      r = e.className,
      a = e.setPositionRelative,
      o = n,
      s = function (e) {
        var t,
          n = e.flexDirection,
          c = e.flexWrap,
          i = e.justifyContent,
          r = e.alignItems,
          a = e.flexGrow,
          o = e.flexShrink,
          s = e.display,
          l = C(e, Ab);
        return [Tb((t = {}, w(t, Ob["is-flex-direction-".concat(n)], n), w(t, Ob["is-flex-wrap-".concat(c)], c), w(t, Ob["is-justify-content-".concat(i)], i), w(t, Ob["is-align-items-".concat(r)], r), w(t, Ob["is-flex-grow-".concat(a)], a), w(t, Ob["is-flex-shrink-".concat(o)], o), w(t, Ob["is-".concat(s)], s), t)), l];
      }(C(e, Db)),
      l = L(s, 2),
      f = l[0],
      u = l[1];
    return /*#__PURE__*/t.createElement(o, E({
      ref: i,
      className: Tb(r, w({}, Ob.setRelative, a), f)
    }, u), c);
  };
Ib.propTypes = {
  children: p.any,
  domRef: p.object,
  className: p.string,
  renderAs: p.string,
  alignItems: p.oneOf(["auto", "flex-start", "flex-end", "center", "baseline", "stretch"]),
  display: p.oneOf(["block", "flex", "inline", "inline-block", "inline-flex"]),
  flexDirection: p.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  flexWrap: p.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  flexGrow: p.oneOf(["0", 1, 2, 3, 4, 5]),
  flexShrink: p.oneOf(["0", 1, 2, 3, 4, 5]),
  justifyContent: p.oneOf(["flex-start", "flex-end", "center", "space-around", "space-between", "space-evenly", "start", "end", "left", "right"]),
  style: p.object,
  setPositionRelative: p.bool
}, Ib.defaultProps = {
  renderAs: "div"
};
var jb = {
    "padding-xxs": "Box-module_padding-xxs__DGHEK",
    "padding-xs": "Box-module_padding-xs__1trre",
    "padding-s": "Box-module_padding-s__3zCtm",
    "padding-m": "Box-module_padding-m__3SkTd",
    "padding-l": "Box-module_padding-l__22LSy",
    "padding-xl": "Box-module_padding-xl__2QCUL",
    "padding-xxl": "Box-module_padding-xxl__3ONgU",
    "padding-top-xxs": "Box-module_padding-top-xxs__1vhtf",
    "padding-top-xs": "Box-module_padding-top-xs__2Q11i",
    "padding-top-s": "Box-module_padding-top-s__RSE3y",
    "padding-top-m": "Box-module_padding-top-m__3DBQt",
    "padding-top-l": "Box-module_padding-top-l__1ACd2",
    "padding-top-xl": "Box-module_padding-top-xl__1DFQ7",
    "padding-top-xxl": "Box-module_padding-top-xxl__1WG5Z",
    "padding-right-xxs": "Box-module_padding-right-xxs__1gO4b",
    "padding-right-xs": "Box-module_padding-right-xs__3hI75",
    "padding-right-s": "Box-module_padding-right-s__2bkMj",
    "padding-right-m": "Box-module_padding-right-m__3seaL",
    "padding-right-l": "Box-module_padding-right-l__28mEw",
    "padding-right-xl": "Box-module_padding-right-xl__3InK1",
    "padding-right-xxl": "Box-module_padding-right-xxl__oF6OY",
    "padding-bottom-xxs": "Box-module_padding-bottom-xxs__1KFWd",
    "padding-bottom-xs": "Box-module_padding-bottom-xs__eOnYU",
    "padding-bottom-s": "Box-module_padding-bottom-s__1JlIf",
    "padding-bottom-m": "Box-module_padding-bottom-m__2FS6P",
    "padding-bottom-l": "Box-module_padding-bottom-l__1EhuA",
    "padding-bottom-xl": "Box-module_padding-bottom-xl__2yxX9",
    "padding-bottom-xxl": "Box-module_padding-bottom-xxl__3VGSy",
    "padding-left-xxs": "Box-module_padding-left-xxs__yiX4Y",
    "padding-left-xs": "Box-module_padding-left-xs__R7mm0",
    "padding-left-s": "Box-module_padding-left-s__2xoI2",
    "padding-left-m": "Box-module_padding-left-m__2wHtt",
    "padding-left-l": "Box-module_padding-left-l__1MzCJ",
    "padding-left-xl": "Box-module_padding-left-xl__3pI6Q",
    "padding-left-xxl": "Box-module_padding-left-xxl__MXrqx",
    "padding-vertical-xxs": "Box-module_padding-vertical-xxs__1SNyY",
    "padding-vertical-xs": "Box-module_padding-vertical-xs__28e7k",
    "padding-vertical-s": "Box-module_padding-vertical-s__3NHTj",
    "padding-vertical-m": "Box-module_padding-vertical-m__MLAfX",
    "padding-vertical-l": "Box-module_padding-vertical-l__B_byz",
    "padding-vertical-xl": "Box-module_padding-vertical-xl__lIHIO",
    "padding-vertical-xxl": "Box-module_padding-vertical-xxl__3x4rf",
    "padding-horizontal-xxs": "Box-module_padding-horizontal-xxs__5Fz0F",
    "padding-horizontal-xs": "Box-module_padding-horizontal-xs__PMUiH",
    "padding-horizontal-s": "Box-module_padding-horizontal-s__hSEKP",
    "padding-horizontal-m": "Box-module_padding-horizontal-m__1BDD8",
    "padding-horizontal-l": "Box-module_padding-horizontal-l__2DdnJ",
    "padding-horizontal-xl": "Box-module_padding-horizontal-xl__2VwHr",
    "padding-horizontal-xxl": "Box-module_padding-horizontal-xxl__2gecm",
    truncateWrapper: "Box-module_truncateWrapper__2N9xC"
  },
  Fb = ["children", "display", "className", "renderAs", "padding", "flex", "flexBasis", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingVertical", "paddingHorizontal", "style", "setPositionRelative", "isTextTruncateWrapper"],
  Rb = function (e) {
    var n,
      c = e.children,
      i = e.display,
      r = e.className,
      a = e.renderAs,
      o = e.padding,
      s = e.flex,
      l = e.flexBasis,
      f = e.paddingTop,
      u = e.paddingRight,
      d = e.paddingBottom,
      p = e.paddingLeft,
      m = e.paddingVertical,
      h = e.paddingHorizontal,
      v = e.style,
      g = e.setPositionRelative,
      b = e.isTextTruncateWrapper,
      H = C(e, Fb),
      z = _({}, v);
    return l && (z = _(_({}, z), {}, {
      flexBasis: "".concat(l)
    })), s && (z = _(_({}, z), {}, {
      flex: "".concat(s)
    })), /*#__PURE__*/t.createElement(Ib, E({
      renderAs: a,
      display: i,
      className: Tb((n = {}, w(n, jb["padding-".concat(o)], o), w(n, jb["padding-top-".concat(f)], f), w(n, jb["padding-right-".concat(u)], u), w(n, jb["padding-bottom-".concat(d)], d), w(n, jb["padding-left-".concat(p)], p), w(n, jb["padding-vertical-".concat(m)], m), w(n, jb["padding-horizontal-".concat(h)], h), w(n, jb.truncateWrapper, b), n), r),
      setPositionRelative: g
    }, H, {
      style: z
    }), c);
  };
Rb.propTypes = {
  children: p.any,
  renderAs: p.string,
  display: p.oneOf(["block", "inline", "inline-block"]),
  padding: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingTop: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingRight: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingBottom: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingLeft: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingVertical: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingHorizontal: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  flex: p.string,
  flexBasis: p.string,
  className: p.string,
  setPositionRelative: p.bool,
  isTextTruncateWrapper: p.bool
}, Rb.defaultProps = {
  display: "block",
  renderAs: "div"
};
var Bb = function (e) {
  var n,
    c = e.children,
    i = e.variation,
    r = e.className,
    a = e.id;
  return /*#__PURE__*/t.createElement(Ib, {
    id: a,
    className: Tb("container-module_container__1qLQp", (n = {}, w(n, "container-module_isExtended__jyL90", "extended" === i), w(n, "container-module_isNarrow__2-Kc4", "narrow" === i), w(n, "container-module_isFluid__1SAZr", "fluid" === i), w(n, "container-module_isFullWidth__1mEWx", "full-width" === i), n), r)
  }, c);
};
Bb.propTypes = {
  variation: p.oneOf(["default", "narrow", "extended", "fluid", "full-width"]),
  children: p.any,
  id: p.string,
  className: p.string
}, Bb.defaultProps = {
  variation: "default"
};
var Gb = {
    spacer: "Spacer-module_spacer__157am",
    horizontal: "Spacer-module_horizontal__1Ss9P",
    xxs: "Spacer-module_xxs__1SWNu",
    xs: "Spacer-module_xs__3nq2h",
    s: "Spacer-module_s__ODsIN",
    m: "Spacer-module_m__17rQj",
    l: "Spacer-module_l__2VjR3",
    xl: "Spacer-module_xl__apdp7",
    xxl: "Spacer-module_xxl__23HAl",
    vertical: "Spacer-module_vertical__vI7JP"
  },
  Yb = function (e) {
    var n,
      c = e.size,
      i = e.direction;
    return /*#__PURE__*/t.createElement(Ib, {
      className: Tb(Gb.spacer, (n = {}, w(n, Gb["".concat(i)], i), w(n, Gb["".concat(c)], c), n))
    });
  };
Yb.propTypes = {
  direction: p.oneOf(["horizontal", "vertical"]),
  size: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"])
}, Yb.defaultProps = {
  size: "s",
  direction: "vertical"
}, p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]), p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]), p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]);
var Wb = {
    "padding-xxs": "FlexBox-module_padding-xxs__1tEjz",
    "padding-xs": "FlexBox-module_padding-xs__Tgh7q",
    "padding-s": "FlexBox-module_padding-s__1YK7j",
    "padding-m": "FlexBox-module_padding-m__3PQ3A",
    "padding-l": "FlexBox-module_padding-l__Ddn7p",
    "padding-xl": "FlexBox-module_padding-xl__tWTdC",
    "padding-xxl": "FlexBox-module_padding-xxl__wua71",
    "padding-top-xxs": "FlexBox-module_padding-top-xxs__2jv9X",
    "padding-top-xs": "FlexBox-module_padding-top-xs__3ykXC",
    "padding-top-s": "FlexBox-module_padding-top-s__TCXOM",
    "padding-top-m": "FlexBox-module_padding-top-m__2wUIW",
    "padding-top-l": "FlexBox-module_padding-top-l__3OXzw",
    "padding-top-xl": "FlexBox-module_padding-top-xl__zvcxy",
    "padding-top-xxl": "FlexBox-module_padding-top-xxl__1hG6Q",
    "padding-right-xxs": "FlexBox-module_padding-right-xxs__2nr6O",
    "padding-right-xs": "FlexBox-module_padding-right-xs__2qO2s",
    "padding-right-s": "FlexBox-module_padding-right-s__2eB-R",
    "padding-right-m": "FlexBox-module_padding-right-m__1_zg3",
    "padding-right-l": "FlexBox-module_padding-right-l__1IM-6",
    "padding-right-xl": "FlexBox-module_padding-right-xl__1YqAK",
    "padding-right-xxl": "FlexBox-module_padding-right-xxl__1sscX",
    "padding-bottom-xxs": "FlexBox-module_padding-bottom-xxs__21oct",
    "padding-bottom-xs": "FlexBox-module_padding-bottom-xs__28oDQ",
    "padding-bottom-s": "FlexBox-module_padding-bottom-s__TQ1L7",
    "padding-bottom-m": "FlexBox-module_padding-bottom-m__1hqL6",
    "padding-bottom-l": "FlexBox-module_padding-bottom-l__2e9Sj",
    "padding-bottom-xl": "FlexBox-module_padding-bottom-xl__3Iy7I",
    "padding-bottom-xxl": "FlexBox-module_padding-bottom-xxl__1c8e2",
    "padding-left-xxs": "FlexBox-module_padding-left-xxs__SLvDz",
    "padding-left-xs": "FlexBox-module_padding-left-xs__9C6VM",
    "padding-left-s": "FlexBox-module_padding-left-s__1cCq4",
    "padding-left-m": "FlexBox-module_padding-left-m__3kvmi",
    "padding-left-l": "FlexBox-module_padding-left-l__16VXB",
    "padding-left-xl": "FlexBox-module_padding-left-xl__1bP-k",
    "padding-left-xxl": "FlexBox-module_padding-left-xxl__eVSYY",
    "padding-vertical-xxs": "FlexBox-module_padding-vertical-xxs__1HRZH",
    "padding-vertical-xs": "FlexBox-module_padding-vertical-xs__3x7S6",
    "padding-vertical-s": "FlexBox-module_padding-vertical-s__2yMQm",
    "padding-vertical-m": "FlexBox-module_padding-vertical-m__1_eDF",
    "padding-vertical-l": "FlexBox-module_padding-vertical-l__3Be4E",
    "padding-vertical-xl": "FlexBox-module_padding-vertical-xl__VlH-s",
    "padding-vertical-xxl": "FlexBox-module_padding-vertical-xxl__1uxMI",
    "padding-horizontal-xxs": "FlexBox-module_padding-horizontal-xxs__2JWZZ",
    "padding-horizontal-xs": "FlexBox-module_padding-horizontal-xs__24qmh",
    "padding-horizontal-s": "FlexBox-module_padding-horizontal-s__36Fbo",
    "padding-horizontal-m": "FlexBox-module_padding-horizontal-m__1by1_",
    "padding-horizontal-l": "FlexBox-module_padding-horizontal-l__2U3sd",
    "padding-horizontal-xl": "FlexBox-module_padding-horizontal-xl__2bB1_",
    "padding-horizontal-xxl": "FlexBox-module_padding-horizontal-xxl__3qzh_",
    "gap-xxs": "FlexBox-module_gap-xxs__3sC05",
    "gap-xs": "FlexBox-module_gap-xs__1atrl",
    "gap-s": "FlexBox-module_gap-s__4QgHs",
    "gap-m": "FlexBox-module_gap-m__mgYgU",
    "gap-l": "FlexBox-module_gap-l__23o1w",
    "gap-xl": "FlexBox-module_gap-xl__2jL3K",
    "gap-xxl": "FlexBox-module_gap-xxl__314VO",
    minWidth: "FlexBox-module_minWidth__2SQ9E"
  },
  qb = ["children", "className", "renderAs", "isInlineFlex", "flexGrow", "flexShrink", "flexWrap", "flexBasis", "flex", "justifyContent", "alignItems", "flexDirection", "gap", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingVertical", "paddingHorizontal", "setPositionRelative", "isTextTruncateWrapper", "style"],
  Ub = function (e) {
    var n,
      c = e.children,
      i = e.className,
      r = e.renderAs,
      a = e.isInlineFlex,
      o = e.flexGrow,
      s = e.flexShrink,
      l = e.flexWrap,
      f = e.flexBasis,
      u = e.flex,
      d = e.justifyContent,
      p = e.alignItems,
      m = e.flexDirection,
      h = e.gap,
      v = e.padding,
      g = e.paddingTop,
      b = e.paddingRight,
      H = e.paddingBottom,
      z = e.paddingLeft,
      y = e.paddingVertical,
      V = e.paddingHorizontal,
      x = e.setPositionRelative,
      M = e.isTextTruncateWrapper,
      L = e.style,
      N = C(e, qb),
      S = _({}, L);
    return f && (S = _(_({}, S), {}, {
      flexBasis: "".concat(f)
    })), u && (S = _(_({}, S), {}, {
      flex: "".concat(u)
    })), /*#__PURE__*/t.createElement(Ib, E({
      renderAs: r,
      className: Tb((n = {}, w(n, Wb["gap-".concat(h)], h), w(n, Wb["padding-".concat(v)], v), w(n, Wb["padding-top-".concat(g)], g), w(n, Wb["padding-right-".concat(b)], b), w(n, Wb["padding-bottom-".concat(H)], H), w(n, Wb["padding-left-".concat(z)], z), w(n, Wb["padding-vertical-".concat(y)], y), w(n, Wb["padding-horizontal-".concat(V)], V), w(n, Wb.minWidth, M), n), i),
      display: a ? "inline-flex" : "flex",
      flexGrow: o,
      flexWrap: l,
      flexShrink: s,
      justifyContent: d,
      alignItems: p,
      flexDirection: m,
      setPositionRelative: x
    }, N, {
      style: S
    }), c);
  };
Ub.propTypes = {
  justifyContent: p.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"]),
  alignItems: p.oneOf(["flex-start", "flex-end", "center", "baseline", "stretch"]),
  flexDirection: p.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  flexWrap: p.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  flexGrow: p.oneOf(["0", 1, 2, 3, 4, 5]),
  flexShrink: p.oneOf(["0", 1, 2, 3, 4, 5]),
  flex: p.string,
  flexBasis: p.string,
  gap: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  isInlineFlex: p.bool,
  padding: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingTop: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingRight: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingBottom: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingLeft: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingVertical: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingHorizontal: p.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  renderAs: p.string,
  children: p.any,
  className: p.string,
  setPositionRelative: p.bool,
  isTextTruncateWrapper: p.bool
}, Ub.defaultProps = {
  isInlineFlex: !1,
  justifyContent: "flex-start",
  alignItems: "stretch",
  flexDirection: "row",
  flexWrap: "nowrap"
};
p.oneOf(["tablet", "large-tablet", "desktop", "large-desktop", "widescreen"]), p.oneOf(["mobile", "touch"]), p.oneOf(["tablet", "large-tablet", "desktop", "large-desktop", "widescreen"]), p.any;
var $b = {
    flexBoxGridWrapper: "FlexBoxGrid-module_flexBoxGridWrapper__3ccYL",
    "gap-size-s": "FlexBoxGrid-module_gap-size-s__3PUD6",
    "gap-size-m": "FlexBoxGrid-module_gap-size-m__2T5lt",
    "gap-size-l": "FlexBoxGrid-module_gap-size-l__1ADon",
    flexBoxGridCell: "FlexBoxGrid-module_flexBoxGridCell__1wB0Q",
    "columns-5": "FlexBoxGrid-module_columns-5__3eVc_",
    "columns-4": "FlexBoxGrid-module_columns-4__1ztDr",
    "columns-3": "FlexBoxGrid-module_columns-3__1UTZj",
    "columns-2": "FlexBoxGrid-module_columns-2__29goa",
    "columns-1": "FlexBoxGrid-module_columns-1__1fStw",
    keepColumnsOnTouch: "FlexBoxGrid-module_keepColumnsOnTouch__7HM7J",
    "margin-bottom-s": "FlexBoxGrid-module_margin-bottom-s__3mX8v",
    "margin-bottom-m": "FlexBoxGrid-module_margin-bottom-m__2pCdC",
    "margin-bottom-l": "FlexBoxGrid-module_margin-bottom-l__1-m7c",
    flexBoxGridContent: "FlexBoxGrid-module_flexBoxGridContent__2Matj",
    "padding-s": "FlexBoxGrid-module_padding-s__3cpWN",
    "padding-m": "FlexBoxGrid-module_padding-m__14h3w",
    "padding-l": "FlexBoxGrid-module_padding-l__DYAMm"
  },
  Xb = function (e) {
    var n,
      c = e.gap,
      i = e.children,
      r = e.columns,
      a = e.keepColumnsOnTouch;
    return /*#__PURE__*/t.createElement(Ub, {
      className: Tb($b.flexBoxGridCell, (n = {}, w(n, $b["columns-".concat(r)], r), w(n, $b["margin-bottom-".concat(c)], c), w(n, $b.keepColumnsOnTouch, a), n))
    }, /*#__PURE__*/t.createElement(Rb, {
      className: Tb($b.flexBoxGridContent, w({}, $b["padding-".concat(c)], c))
    }, i));
  };
Xb.propTypes = {
  gap: p.oneOf(["s", "m", "l"]),
  columns: p.oneOf([1, 2, 3, 4, 5]),
  keepColumnsOnTouch: p.bool
}, Xb.defaultProps = {
  gap: "s",
  columns: 4
}, Xb.displayName = "FlexBoxGrid.Cell";
var Zb = function (e) {
  var n = e.children,
    c = e.gap,
    i = e.columns,
    r = e.keepColumnsOnTouch;
  return /*#__PURE__*/t.createElement(Ub, {
    className: Tb($b.flexBoxGridWrapper, w({}, $b["gap-size-".concat(c)], c)),
    flexWrap: "wrap"
  }, t.Children.map(n, function (e) {
    return /*#__PURE__*/t.createElement(Xb, {
      gap: c,
      columns: i,
      keepColumnsOnTouch: r
    }, /*#__PURE__*/t.cloneElement(e));
  }));
};
Zb.propTypes = {
  gap: p.oneOf(["s", "m", "l"]),
  columns: p.oneOf([1, 2, 3, 4, 5]),
  keepColumnsOnTouch: p.bool
}, Zb.defaultProps = {
  gap: "s",
  columns: 4
};
var Kb = {
    "aspect-ratio-square": "AspectRatioBox-module_aspect-ratio-square__agKb2",
    "aspect-ratio-widescreen": "AspectRatioBox-module_aspect-ratio-widescreen__3DWuZ",
    "aspect-ratio-fullscreen": "AspectRatioBox-module_aspect-ratio-fullscreen__1Tvhl",
    "aspect-ratio-panorama": "AspectRatioBox-module_aspect-ratio-panorama__3i1Wz",
    "aspect-ratio-poster": "AspectRatioBox-module_aspect-ratio-poster__3EDz5"
  },
  Qb = ["baseComponent", "aspectRatio", "children", "width"],
  Jb = function (e) {
    var n = e.baseComponent,
      c = e.aspectRatio,
      i = e.children,
      r = e.width,
      a = C(e, Qb),
      o = {};
    return r && (o = _(_({}, o), {}, {
      width: r
    })), a.style && (o = _(_({}, o), a.style)), "flex-box" === n ? /*#__PURE__*/t.createElement(Ub, E({}, a, {
      className: Tb(Kb["aspect-ratio-".concat(c)], a.className),
      style: o
    }), i) : /*#__PURE__*/t.createElement(Rb, E({}, a, {
      className: Tb(Kb["aspect-ratio-".concat(c)], a.className),
      style: r ? _({
        width: r
      }, a.style) : null
    }), i);
  };
Jb.propTypes = {
  baseComponent: p.oneOf(["box", "flex-box"]),
  aspectRatio: p.oneOf(["square", "widescreen", "fullscreen", "panorama", "poster"]),
  children: p.any,
  width: p.oneOfType([p.string, p.number])
}, Jb.defaultProps = {
  aspectRatio: "square",
  baseComponent: "box"
};
var eH = "SlideoutPanel-module_content__1RCg3",
  tH = "SlideoutPanel-module_removeSidePadding__3RBpm",
  nH = "SlideoutPanel-module_removeTopPadding__5DAdj",
  cH = "SlideoutPanel-module_removePadding__P-akY",
  iH = "SlideoutPanel-module_scrollContent__2WQ_T",
  rH = function (e) {
    var t = L(c(null), 2),
      n = t[0],
      r = t[1];
    return i(function () {
      function t(t) {
        e.current && !e.current.contains(t.target) ? r(!0) : r(!1);
      }
      return document.addEventListener("mousedown", t), function () {
        document.removeEventListener("mousedown", t);
      };
    }, [e]), {
      isOutsideClick: n
    };
  },
  aH = {
    callToAction: "callToActionButton-module_callToAction__w-e8X",
    "textAlign-left": "callToActionButton-module_textAlign-left__35HGH",
    "textAlign-center": "callToActionButton-module_textAlign-center__2Qret",
    "textAlign-right": "callToActionButton-module_textAlign-right__2o_W_",
    primary: "callToActionButton-module_primary__2L2rn",
    outline: "callToActionButton-module_outline__kG-3S",
    "outline-white-bg": "callToActionButton-module_outline-white-bg__DgGO8",
    ghost: "callToActionButton-module_ghost__3-Iul",
    dense: "callToActionButton-module_dense__1wRpn",
    secondary: "callToActionButton-module_secondary__2g7bk",
    danger: "callToActionButton-module_danger__cvJS4",
    white: "callToActionButton-module_white__3GHQK",
    disabled: "callToActionButton-module_disabled__1Q4GD",
    fullWidth: "callToActionButton-module_fullWidth__2_WrM",
    large: "callToActionButton-module_large__x0KHj",
    dropdown: "callToActionButton-module_dropdown__1vsr7",
    callToAction_icon: "callToActionButton-module_callToAction_icon__FOfmN",
    after: "callToActionButton-module_after__2Vwxe",
    before: "callToActionButton-module_before__2aNLe",
    button: "callToActionButton-module_button__1qBSi"
  },
  oH = function (e) {
    var c,
      r,
      a = e.children,
      o = e.variation,
      s = e.onClick,
      l = e.onClickOutside,
      f = e.appearance,
      u = e.size,
      d = e.isDropdown,
      p = e.isDisabled,
      m = e.isFullWidth,
      h = e.prependIcon,
      v = e.appendIcon,
      g = e.id,
      b = e.className,
      H = e.textAlign,
      z = e.buttonType,
      y = e.title,
      V = e.role,
      x = n(null),
      M = rH(x).isOutsideClick;
    return i(function () {
      l && l(M);
    }, [M]), /*#__PURE__*/t.createElement(Ib, {
      id: g,
      domRef: x,
      title: y,
      role: V,
      renderAs: "button",
      onClick: s,
      disabled: p,
      type: z,
      className: Tb(aH.callToAction, aH.button, (c = {}, w(c, aH.primary, "primary" === o), w(c, aH.secondary, "secondary" === o), w(c, aH.danger, "danger" === o), w(c, aH.white, "white" === o), w(c, aH.disabled, p), w(c, aH.outline, "outline" === f), w(c, aH["outline-white-bg"], "outline-white-bg" === f), w(c, aH.ghost, "ghost" === f), w(c, aH.fullWidth, m), w(c, aH.dense, "dense" === u), w(c, aH.large, "large" === u), w(c, aH.dropdown, d), w(c, aH["textAlign-".concat(H)], H), c), b)
    }, h && /*#__PURE__*/t.createElement("span", {
      className: Tb(aH.callToAction_icon, aH.before)
    }, h), a, (v || d) && /*#__PURE__*/t.createElement("span", {
      className: Tb(aH.callToAction_icon, aH.after, (r = {}, w(r, aH.dense, "dense" === u), w(r, aH.large, "large" === u), w(r, aH.secondary, "secondary" === o), w(r, aH.danger, "danger" === o), w(r, aH.outline, "outline" === f), w(r, aH["outline-white-bg"], "outline-white-bg" === f), w(r, aH.ghost, "ghost" === f), w(r, aH.disabled, p), w(r, aH["textAlign-".concat(H)], H), r))
    }, v || (d ? /*#__PURE__*/t.createElement(Sb, {
      name: "chevronDown"
    }) : null)));
  };
oH.propTypes = {
  onClick: p.func.isRequired,
  children: p.oneOfType([p.string, p.node]).isRequired,
  variation: p.oneOf(["primary", "secondary", "danger", "white"]),
  appearance: p.oneOf(["filled", "outline", "outline-white-bg", "ghost"]),
  size: p.oneOf(["dense", "default", "large"]),
  prependIcon: p.node,
  appendIcon: p.node,
  isDisabled: p.bool,
  isFullWidth: p.bool,
  textAlign: p.oneOf(["left", "center", "right"]),
  id: p.string,
  buttonType: p.oneOf(["button", "submit"]),
  className: p.string,
  title: p.string,
  role: p.string,
  onClickOutside: p.func,
  isDropdown: p.bool
}, oH.defaultProps = {
  variation: "primary",
  appearance: "filled",
  textAlign: "center",
  buttonType: "button"
};
var sH = function (e) {
  return /*#__PURE__*/t.createElement(oH, E({}, e, {
    className: Tb("iconButton-module_iconButton__MZzv3", w({}, "iconButton-module_denseIcon__37ONs", "dense" === e.size), e.className),
    appendIcon: null,
    prependIcon: null,
    isDropdown: null,
    icon: null,
    size: e.size
  }), e.children);
};
sH.propTypes = {
  onClick: p.func.isRequired,
  children: p.node.isRequired,
  variation: p.oneOf(["primary", "secondary", "danger"]),
  appearance: p.oneOf(["filled", "outline", "outline-white-bg", "ghost"]),
  size: p.oneOf(["dense", "default"]),
  isDisabled: p.bool,
  isFullWidth: p.bool,
  id: p.string,
  className: p.string,
  onClickOutside: p.func
}, sH.defaultProps = {
  variation: "primary",
  appearance: "filled",
  size: "default"
};
var lH = {
    footer: "CallToActionBar-module_footer__1dm68",
    "height-m": "CallToActionBar-module_height-m__1_dTD",
    "height-s": "CallToActionBar-module_height-s__G1hhm",
    "height-xs": "CallToActionBar-module_height-xs__QJBRx",
    addBorder: "CallToActionBar-module_addBorder__29LjT",
    icon: "CallToActionBar-module_icon__2NpAZ"
  },
  fH = {
    callToAction: "callToActionLink-module_callToAction__28kpU",
    "textAlign-left": "callToActionLink-module_textAlign-left__14XMt",
    "textAlign-center": "callToActionLink-module_textAlign-center__1ydB_",
    "textAlign-right": "callToActionLink-module_textAlign-right__1EHao",
    primary: "callToActionLink-module_primary__BuGBa",
    outline: "callToActionLink-module_outline__1GCo5",
    "outline-white-bg": "callToActionLink-module_outline-white-bg__17RNz",
    ghost: "callToActionLink-module_ghost__1HM9I",
    dense: "callToActionLink-module_dense__1b-CD",
    secondary: "callToActionLink-module_secondary__3Pc3p",
    danger: "callToActionLink-module_danger__2jaWG",
    white: "callToActionLink-module_white__1HOLv",
    disabled: "callToActionLink-module_disabled__2_WZd",
    fullWidth: "callToActionLink-module_fullWidth__2wAfZ",
    large: "callToActionLink-module_large__1MpxH",
    dropdown: "callToActionLink-module_dropdown__3mUwq",
    callToAction_icon: "callToActionLink-module_callToAction_icon__1nBND",
    after: "callToActionLink-module_after__QvEQp",
    before: "callToActionLink-module_before__3vpp4",
    linkStyle: "callToActionLink-module_linkStyle__2qYXT",
    adjustText: "callToActionLink-module_adjustText__1Ydj8"
  },
  uH = function (e) {
    var n,
      c,
      i = e.type,
      r = e.children,
      a = e.onClick,
      o = e.size,
      s = e.href,
      l = e.appearance,
      f = e.prependIcon,
      u = e.appendIcon,
      d = e.openNewTab,
      p = e.id,
      h = e.reactRouterIsActive,
      v = e.variation,
      g = e.isFullWidth,
      b = e.textAlign,
      H = e.title,
      z = e.className,
      y = function () {
        return /*#__PURE__*/t.createElement(t.Fragment, null, f && /*#__PURE__*/t.createElement("span", {
          className: Tb(fH.callToAction_icon, fH.before)
        }, f), r, u && /*#__PURE__*/t.createElement("span", {
          className: Tb(fH.callToAction_icon, fH.after)
        }, u));
      };
    return "router-link" === i ? /*#__PURE__*/t.createElement(m, {
      id: p,
      to: s,
      className: Tb(fH.callToAction, fH.linkStyle, fH["".concat(v)], (c = {}, w(c, fH.dense, "dense" === o), w(c, fH.large, "large" === o), w(c, fH.adjustText, "large" === o), w(c, fH.ghost, "ghost" === l), w(c, fH.outline, "outline" === l), w(c, fH.fullWidth, g), w(c, fH["textAlign-".concat(b)], b), c), z),
      onClick: a || null,
      isActive: h || null,
      title: H
    }, y()) : /*#__PURE__*/t.createElement(Ib, {
      id: p,
      renderAs: "a",
      className: Tb(fH.callToAction, fH["".concat(v)], (n = {}, w(n, fH.dense, "dense" === o), w(n, fH.large, "large" === o), w(n, fH.adjustText, "large" === o), w(n, fH.ghost, "ghost" === l), w(n, fH.outline, "outline" === l), w(n, fH.fullWidth, g), w(n, fH["textAlign-".concat(b)], b), n), fH.linkStyle),
      href: s,
      target: d ? "_blank" : void 0,
      rel: d ? "noreferrer nofollow" : void 0,
      title: H
    }, y());
  };
uH.propTypes = {
  href: p.string.isRequired,
  reactRouterIsActive: p.func,
  children: p.string,
  variation: p.oneOf(["primary", "secondary"]),
  appearance: p.oneOf(["filled", "outline", "ghost"]),
  type: p.oneOf(["link", "router-link"]),
  size: p.oneOf(["dense", "default", "large"]),
  openNewTab: p.bool,
  isFullWidth: p.bool,
  textAlign: p.oneOf(["left", "center", "right"]),
  prependIcon: p.node,
  appendIcon: p.node,
  title: p.string,
  id: p.string,
  className: p.string
}, uH.defaultProps = {
  type: "router-link",
  variation: "primary",
  textAlign: "center",
  size: "default"
};
var dH = function (e) {
  var n,
    c = e.primaryProps,
    i = e.secondaryProps,
    r = e.alignButtons,
    a = e.addBorder,
    o = e.horizontalPadding,
    s = e.verticalHeight,
    l = e.showSpinner,
    f = function (e, n) {
      return "button" === e.actionType ? /*#__PURE__*/t.createElement(oH, {
        onClick: e.action,
        variation: n,
        appearance: "primary" === n ? "filled" : "ghost",
        isDisabled: e.isDisabled,
        isFullWidth: e.isFullWidth,
        className: e.className
      }, e.label) : /*#__PURE__*/t.createElement(uH, {
        href: e.action,
        variation: n,
        appearance: "primary" === n ? "filled" : "ghost",
        isDisabled: e.isDisabled,
        type: e.linkType ? e.linkType : "router-link",
        isFullWidth: e.isFullWidth,
        className: e.className
      }, e.label);
    };
  return /*#__PURE__*/t.createElement(Ub, {
    justifyContent: "flex-start",
    className: Tb(lH.footer, (n = {}, w(n, lH.addBorder, a), w(n, lH["height-".concat(s)], s), n)),
    alignItems: "center",
    paddingHorizontal: o,
    flexDirection: "right" === r ? "row-reverse" : "row",
    gap: "xs",
    flexShrink: "0"
  }, c && c.action && f(c, "primary"), l && /*#__PURE__*/t.createElement(Rb, {
    className: lH.icon
  }, /*#__PURE__*/t.createElement(Sb, {
    name: "spinner",
    spin: !0
  })), i && i.action && f(i, "secondary"));
};
dH.propTypes = {
  primaryProps: p.object,
  secondaryProps: p.object,
  alignButtons: p.oneOf(["left", "right"]),
  addBorder: p.bool,
  horizontalPadding: p.oneOf(["s", "m", "null"]),
  verticalHeight: p.oneOf(["xs", "s", "m", "null"]),
  showSpinner: p.bool
}, dH.defaultProps = {
  alignButtons: "left",
  addBorder: !0,
  horizontalPadding: "s",
  verticalHeight: "xs"
};
var pH = {
    wrapper: "textWrapper-module_wrapper__35qy4",
    "align-left": "textWrapper-module_align-left__2rC0r",
    "align-center": "textWrapper-module_align-center__2RtVp",
    "align-right": "textWrapper-module_align-right__2qtnp",
    "transform-capitalize": "textWrapper-module_transform-capitalize__3frFo",
    "transform-lowercase": "textWrapper-module_transform-lowercase__26l4H",
    "transform-uppercase": "textWrapper-module_transform-uppercase__21GXo",
    "transform-none": "textWrapper-module_transform-none__2Wizd",
    truncate: "textWrapper-module_truncate__1AuEs",
    whiteText: "textWrapper-module_whiteText__2dQrK",
    "color-white": "textWrapper-module_color-white__3gxuA",
    "color-gray": "textWrapper-module_color-gray__wnnpv",
    "color-dark-gray": "textWrapper-module_color-dark-gray__iCXdL",
    "color-light-gray": "textWrapper-module_color-light-gray__2W-rR",
    "color-disabled": "textWrapper-module_color-disabled__1vFBu",
    "weight-semibold": "textWrapper-module_weight-semibold__3oc4V",
    "weight-bold": "textWrapper-module_weight-bold__3Hovq",
    "weight-monospace": "textWrapper-module_weight-monospace__sO_7s",
    "vertical-align-baseline": "textWrapper-module_vertical-align-baseline__2_nq2",
    "vertical-align-sub": "textWrapper-module_vertical-align-sub__17cQC",
    "vertical-align-super": "textWrapper-module_vertical-align-super__3FJ8Y",
    "vertical-align-text-top": "textWrapper-module_vertical-align-text-top__2eY9D",
    "vertical-align-text-bottom": "textWrapper-module_vertical-align-text-bottom__2ht7o",
    "vertical-align-middle": "textWrapper-module_vertical-align-middle__PoIdv",
    "vertical-align-top": "textWrapper-module_vertical-align-top__3yKf5",
    "vertical-align-bottom": "textWrapper-module_vertical-align-bottom__1VmUB"
  },
  mH = ["children", "className", "isFullWidth", "textAlign", "textTransform", "truncate", "whiteText", "textColor", "weight", "verticalAlign"],
  hH = function (e) {
    var n,
      c = e.children,
      i = e.className,
      r = e.isFullWidth,
      a = e.textAlign,
      o = e.textTransform,
      s = e.truncate,
      l = e.whiteText,
      f = e.textColor,
      u = e.weight,
      d = e.verticalAlign,
      p = C(e, mH);
    return /*#__PURE__*/t.createElement(Rb, E({
      display: r ? "block" : "inline-block",
      className: Tb(pH.wrapper, (n = {}, w(n, pH["align-".concat(a)], a), w(n, pH["transform-".concat(o)], o), w(n, pH.truncate, s), w(n, pH.whiteText, l), w(n, pH["color-".concat(f)], f), w(n, pH["weight-".concat(u)], u), w(n, pH["vertical-align-".concat(d)], d), n), i)
    }, p), c);
  };
hH.propTypes = {
  children: p.any.isRequired,
  isFullWidth: p.bool,
  truncate: p.bool,
  textAlign: p.oneOf(["left", "center", "right"]),
  textTransform: p.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: p.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  verticalAlign: p.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"]),
  weight: p.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: p.string
}, hH.defaultProps = {
  textAlign: "left",
  textTransform: "none",
  weight: "regular"
};
var vH = ["children", "className"],
  gH = function (e) {
    var n = e.children,
      c = e.className,
      i = C(e, vH);
    return /*#__PURE__*/t.createElement(hH, E({
      className: Tb("textH2-module_subHeadline__2cfal", c),
      textColor: "dark-gray"
    }, i), n);
  };
gH.propTypes = {
  children: p.any.isRequired,
  isFullWidth: p.bool,
  truncate: p.bool,
  textAlign: p.oneOf(["left", "center", "right"]),
  textTransform: p.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: p.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: p.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: p.string,
  verticalAlign: p.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
}, gH.defaultProps = {
  weight: "semibold"
};
var bH = {
    overlay: "overlay-module_overlay__3gsL_",
    reveal: "overlay-module_reveal__36CW3",
    "position-fixed": "overlay-module_position-fixed__ibDqZ",
    "position-absolute": "overlay-module_position-absolute__3uHPM",
    "zIndex-navigation": "overlay-module_zIndex-navigation__1vT_K",
    "zIndex-modals": "overlay-module_zIndex-modals__2exb8",
    "zIndex-preloaders": "overlay-module_zIndex-preloaders__1dt2v",
    "zIndex-everything": "overlay-module_zIndex-everything__2l2cR",
    "color-transparent": "overlay-module_color-transparent__D5Oy_",
    "color-dark": "overlay-module_color-dark__2jZBX",
    "color-white": "overlay-module_color-white__1nlyN",
    "color-white-opaque": "overlay-module_color-white-opaque__3JkVK",
    activeCursor: "overlay-module_activeCursor__1GCsU"
  },
  HH = function (e) {
    var n,
      c = e.reveal,
      r = e.closeOnClick,
      a = e.color,
      o = e.position,
      s = e.top,
      l = e.right,
      f = e.bottom,
      u = e.left,
      d = e.zIndex,
      p = e.freezeBody,
      m = {};
    return s && (m = _(_({}, m), {}, {
      top: s
    })), l && (m = _(_({}, m), {}, {
      right: l
    })), f && (m = _(_({}, m), {}, {
      bottom: f
    })), u && (m = _(_({}, m), {}, {
      left: u
    })), i(function () {
      var e = document.querySelector("body"),
        t = document.body.style.top;
      e.style.top = c && p ? "-".concat(window.scrollY, "px") : "", e.style.overflow = c && p ? "hidden" : "", e.style.position = c && p ? "fixed" : "", e.style.width = c && p ? "100%" : "", !c && p && window.scrollTo(0, -1 * Number.parseInt(t || "0"));
    }, [c]), /*#__PURE__*/t.createElement("div", {
      role: "button",
      tabIndex: 0,
      onKeyDown: function (e) {
        "Escape" === e.code && r();
      },
      onClick: r,
      className: Tb(bH.overlay, (n = {}, w(n, bH.reveal, c), w(n, bH["color-".concat(a)], a), w(n, bH["position-".concat(o)], o), w(n, bH["zIndex-".concat(d)], d), w(n, bH.activeCursor, r), n)),
      style: m
    });
  };
HH.propTypes = {
  reveal: p.bool,
  color: p.oneOf(["transparent", "dark", "white", "white-opaque"]),
  position: p.oneOf(["absolute", "fixed"]),
  top: p.oneOfType([p.number, p.string]),
  right: p.oneOfType([p.number, p.string]),
  bottom: p.oneOfType([p.number, p.string]),
  left: p.oneOfType([p.number, p.string]),
  zIndex: p.oneOf(["navigation", "modals", "preloaders", "everything"]),
  closeOnClick: p.func,
  freezeBody: p.bool
}, HH.defaultProps = {
  color: "dark",
  position: "fixed",
  zIndex: "modals",
  freezeBody: !0
};
var zH = {
    modal: "Modal-module_modal__3Xz-_",
    reveal: "Modal-module_reveal__3xLOV",
    "size-auto": "Modal-module_size-auto__30vsP",
    "size-s": "Modal-module_size-s__JSbkQ",
    "size-m": "Modal-module_size-m__5fYKZ",
    "size-l": "Modal-module_size-l__1bFt8",
    "size-xl": "Modal-module_size-xl__2XPbd",
    "size-cover": "Modal-module_size-cover__3P8Oi",
    "size-form": "Modal-module_size-form__3RKiL",
    fullHeight: "Modal-module_fullHeight__3RTDG",
    header: "Modal-module_header__3I3C_",
    lightButton: "Modal-module_lightButton__2jgql",
    content: "Modal-module_content__1pGu_",
    contentBox: "Modal-module_contentBox__1I_uV",
    isScrollable: "Modal-module_isScrollable__2FSQ0",
    headlessCloseButton: "Modal-module_headlessCloseButton__1SO58"
  },
  yH = ["addShadow", "children", "className", "padding", "onClickOutside", "removeBorder"],
  VH = function (e) {
    var c,
      r = e.addShadow,
      a = e.children,
      o = e.className,
      s = e.padding,
      l = e.onClickOutside,
      f = e.removeBorder,
      u = C(e, yH),
      d = n(null),
      p = rH(d).isOutsideClick;
    return i(function () {
      p && l && l();
    }, [p]), /*#__PURE__*/t.createElement(Rb, E({
      domRef: d,
      className: Tb("panel-module_panel__3pPPg", (c = {}, w(c, "panel-module_shadow__h93rP", r), w(c, "panel-module_removeBorder__2j1TK", f), c), o),
      padding: s
    }, u), a);
  };
VH.propTypes = {
  addShadow: p.bool,
  children: p.any.isRequired,
  className: p.string,
  onClickOutside: p.func,
  removeBorder: p.bool
};
var xH = function (e) {
  var i = e.contentIsScrollable,
    r = e.headlessCloseOnClick,
    a = e.children,
    o = n(),
    s = L(c(0), 2),
    l = s[0],
    f = s[1];
  return /*#__PURE__*/t.createElement(Rb, {
    className: zH.content
  }, r && /*#__PURE__*/t.createElement(Rb, {
    className: zH.headlessCloseButton
  }, /*#__PURE__*/t.createElement(sH, {
    onClick: r,
    variation: "secondary",
    appearance: "ghost",
    size: "dense"
  }, /*#__PURE__*/t.createElement(Sb, {
    name: "times"
  }))), /*#__PURE__*/t.createElement(Rb, {
    className: Tb(zH.contentBox, w({}, zH.isScrollable, i)),
    domRef: o,
    onScroll: function () {
      var e = o.current.scrollTop;
      f(e);
    },
    style: i ? null : {
      marginTop: "-".concat(l, "px")
    }
  }, a));
};
xH.propTypes = {
  contentIsScrollable: p.bool,
  headlessCloseOnClick: p.func
}, xH.defaultProps = {
  contentIsScrollable: !1
};
var MH = function (e) {
  var n = e.primaryOnClick,
    c = e.primaryLabel,
    i = e.secondaryOnClick,
    r = e.secondaryLabel,
    a = e.alignButtons,
    o = e.primaryIsDisabled,
    s = e.secondaryIsDisabled;
  return /*#__PURE__*/t.createElement(dH, {
    alignButtons: a,
    primaryProps: {
      actionType: "button",
      action: n,
      label: c,
      isDisabled: o
    },
    secondaryProps: {
      actionType: "button",
      action: i,
      label: r,
      isDisabled: s
    }
  });
};
MH.propTypes = {
  primaryOnClick: p.func,
  primaryLabel: p.string,
  secondaryOnClick: p.func,
  secondaryLabel: p.string,
  alignButtons: p.oneOf(["left", "right"]),
  primaryIsDisabled: p.bool,
  secondaryIsDisabled: p.bool
}, MH.defaultProps = {
  alignButtons: "left",
  primaryLabel: "Primary",
  secondaryLabel: "Secondary",
  primaryIsDisabled: !1,
  secondaryIsDisabled: !1
};
var _H = ["children", "className"],
  wH = function (e) {
    var n = e.children,
      c = e.className,
      i = C(e, _H);
    return /*#__PURE__*/t.createElement(hH, E({
      className: Tb("TextBody-module_body__2Dz2Q", c)
    }, i), n);
  };
wH.propTypes = {
  children: p.any.isRequired,
  isFullWidth: p.bool,
  truncate: p.bool,
  textAlign: p.oneOf(["left", "center", "right"]),
  textTransform: p.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: p.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: p.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: p.string,
  verticalAlign: p.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
};
var EH = function (e) {
  var n,
    c = e.reveal,
    i = e.title,
    r = e.closeOnClick,
    a = e.size,
    o = e.fullHeight,
    s = e.noHeader,
    l = e.children;
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(HH, {
    reveal: c,
    closeOnClick: r
  }), /*#__PURE__*/t.createElement(VH, {
    className: Tb(zH.modal, (n = {}, w(n, zH.reveal, c), w(n, zH["size-".concat(a)], a), w(n, zH.fullHeight, o && "cover" !== a), n)),
    addShadow: !0
  }, !s && /*#__PURE__*/t.createElement(Ub, {
    className: Tb(zH.header),
    alignItems: "center",
    paddingLeft: "s",
    paddingRight: "xs"
  }, /*#__PURE__*/t.createElement(Ub, {
    flexGrow: 1
  }, /*#__PURE__*/t.createElement(wH, {
    weight: "semibold",
    textColor: "white",
    truncate: !0
  }, i || " ")), /*#__PURE__*/t.createElement(Yb, {
    size: "xs",
    direction: "horizontal"
  }), r && /*#__PURE__*/t.createElement(Ub, {
    alignItems: "center"
  }, /*#__PURE__*/t.createElement(sH, {
    onClick: r,
    variation: "secondary",
    appearance: "ghost",
    className: zH.lightButton
  }, /*#__PURE__*/t.createElement(Sb, {
    name: "times"
  })))), l));
};
EH.propTypes = {
  reveal: p.bool,
  title: p.string,
  closeOnClick: p.func,
  size: p.oneOf(["auto", "s", "m", "l", "xl", "cover", "form"]),
  fullHeight: p.bool,
  noHeader: p.bool,
  children: function (e, n) {
    var c = e[n],
      i = null;
    return t.Children.forEach(c, function (e) {
      e.type !== EH.Footer && e.type !== EH.Content && (i = new Error("'".concat(e.type, "' - Children of Modal should only be either <Modal.Content> or <Modal.Footer>")));
    }), i;
  }
}, EH.defaultProps = {
  size: "m",
  overlayClosesModal: !0
}, EH.Content = xH, EH.Footer = MH;
var CH = function (r) {
  var a,
    o,
    s,
    l,
    f = r.reveal,
    u = r.children,
    d = r.primaryActionProps,
    p = r.secondaryActionProps,
    m = r.closeButtonOnClick,
    h = r.removeContentSidePadding,
    v = r.removeContentTopPadding,
    g = r.removeContentPadding,
    b = r.contentIsScrollable,
    H = r.closeOnClickOutside,
    z = r.title,
    y = r.mobileModalSize,
    V = r.variation,
    x = r.headerIcon,
    M = r.modalOnMobile,
    _ = r.removeHeaderBorder,
    E = r.panelClassName,
    C = r.topShadowClassName,
    N = r.bottomShadowClassName,
    S = r.headerTextClassName,
    k = function () {
      var e = L(c({
          width: window.innerWidth,
          height: window.innerHeight,
          isMobile: window.innerWidth < 768,
          isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
          isTabletOrGreater: window.innerWidth >= 768,
          isTouch: window.innerWidth < 1024,
          isDesktop: window.innerWidth >= 1024,
          isLargeDesktop: window.innerWidth >= 1280,
          isWidescreen: window.innerWidth >= 1366,
          isHD: window.innerWidth >= 1440,
          isSuperHD: window.innerWidth >= 1680
        }), 2),
        t = e[0],
        n = e[1];
      return i(function () {
        function e() {
          n({
            width: window.innerWidth,
            height: window.innerHeight,
            isMobile: window.innerWidth < 768,
            isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
            isTabletOrGreater: window.innerWidth >= 768,
            isTouch: window.innerWidth < 1024,
            isDesktop: window.innerWidth >= 1024,
            isLargeDesktop: window.innerWidth >= 1280,
            isWidescreen: window.innerWidth >= 1366,
            isHD: window.innerWidth >= 1440,
            isSuperHD: window.innerWidth >= 1680
          });
        }
        return window.addEventListener("resize", e), e(), function () {
          return window.removeEventListener("resize", e);
        };
      }, []), t;
    }(),
    P = k.isMobile,
    T = k.height,
    O = n(),
    A = function (t, n) {
      var c = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        i = L(e.useState(), 2),
        r = i[0],
        a = i[1];
      return e.useLayoutEffect(function () {
        var e = t.current,
          i = function () {
            var t = c ? e.scrollWidth > e.clientWidth : e.scrollHeight > e.clientHeight;
            a(t), n && n(t);
          };
        e && ("ResizeObserver" in window && new ResizeObserver(i).observe(e), i());
      }, [n, t]), r;
    }(O),
    D = L(c(!1), 2),
    I = D[0],
    j = D[1],
    F = L(c(!1), 2),
    R = F[0],
    B = F[1],
    G = L(c(!0), 2),
    Y = G[0],
    W = G[1];
  return i(function () {
    Y && A && (B(!0), W(!1));
  }, [A]), P && M ? /*#__PURE__*/t.createElement(EH, {
    reveal: f,
    closeOnClick: m,
    title: z,
    size: y,
    variation: V
  }, /*#__PURE__*/t.createElement(EH.Content, {
    contentIsScrollable: b
  }, /*#__PURE__*/t.createElement(Rb, {
    className: Tb(eH, (l = {}, w(l, tH, h), w(l, nH, v), w(l, cH, g), w(l, iH, b), l))
  }, u)), (d || p) && /*#__PURE__*/t.createElement(EH.Footer, {
    primaryLabel: d.label,
    primaryOnClick: d.action,
    primaryIsDisabled: d.isDisabled,
    primaryCustomButtonColor: d.customButtonColor,
    primaryCustomTextColor: d.customTextColor,
    secondaryLabel: p.label,
    secondaryOnClick: p.action,
    secondaryIsDisabled: p.isDisabled
  })) : /*#__PURE__*/t.createElement(t.Fragment, null, H && /*#__PURE__*/t.createElement(HH, {
    reveal: f,
    color: "transparent",
    zIndex: "navigation",
    position: "fixed",
    closeOnClick: m
  }), /*#__PURE__*/t.createElement(Rb, {
    className: Tb("SlideoutPanel-module_panel__1QdFq", (a = {}, w(a, "SlideoutPanel-module_reveal__2kWOy", f), w(a, "SlideoutPanel-module_navWidth__3sC51", "side-navigation" === V), a), E),
    style: {
      height: T
    }
  }, /*#__PURE__*/t.createElement(Ub, {
    className: "SlideoutPanel-module_contentWrapper__CmsLs",
    flexDirection: "column"
  }, I && /*#__PURE__*/t.createElement(Rb, {
    className: Tb("SlideoutPanel-module_contentTopShadow__1NCjo", C)
  }), R && /*#__PURE__*/t.createElement(Rb, {
    className: Tb("SlideoutPanel-module_contentBottomShadow__2GWzR", w({}, "SlideoutPanel-module_adjustForFooter__12tcl", d || p), N)
  }), "side-navigation" !== V && /*#__PURE__*/t.createElement(Ub, {
    paddingVertical: "xxs",
    alignItems: "center",
    className: Tb("SlideoutPanel-module_header__2Hd7s", (o = {}, w(o, "SlideoutPanel-module_minimal__3F8sI", "minimal" === V || "side-navigation" === V), w(o, "SlideoutPanel-module_navPadding__1tyYu", "side-navigation" === V), w(o, "SlideoutPanel-module_removeHeader__RRRVR", _), o)),
    gap: "xs"
  }, x && /*#__PURE__*/t.createElement(Ub, {
    alignItems: "center",
    className: "SlideoutPanel-module_headerIcon__1_Au_"
  }, x), /*#__PURE__*/t.createElement(Ub, {
    flex: "1",
    alignItems: "center",
    style: {
      minWidth: 0
    }
  }, z ? /*#__PURE__*/t.createElement(gH, {
    textColor: "minimal" === V || "side-navigation" === V ? "dark-gray" : "white",
    truncate: !0,
    className: S
  }, z) : " "), /*#__PURE__*/t.createElement(sH, {
    onClick: m,
    variation: "secondary",
    appearance: "ghost",
    className: "default" === V ? "SlideoutPanel-module_closeButton__1_a0U" : null
  }, /*#__PURE__*/t.createElement(Sb, {
    name: "times"
  }))), /*#__PURE__*/t.createElement("div", {
    className: Tb(eH, (s = {}, w(s, tH, h), w(s, nH, v), w(s, cH, g), w(s, iH, b), s)),
    ref: O,
    onScroll: function () {
      var e = O.current,
        t = e.scrollHeight,
        n = e.scrollTop,
        c = e.clientHeight;
      A && n > 0 && !I ? j(!0) : A && 0 === n && I && j(!1), A && n + c === t ? R && B(!1) : R || B(!0);
    }
  }, u), (d || p) && /*#__PURE__*/t.createElement(dH, {
    primaryProps: d,
    secondaryProps: p,
    horizontalPadding: "m"
  }))));
};
CH.propTypes = {
  reveal: p.bool,
  children: p.any,
  closeButtonOnClick: p.func,
  primaryActionProps: p.object,
  secondaryActionProps: p.object,
  removeContentSidePadding: p.bool,
  removeContentTopPadding: p.bool,
  removeContentPadding: p.bool,
  contentIsScrollable: p.bool,
  closeOnClickOutside: p.bool,
  title: p.string,
  modalOnMobile: p.bool,
  mobileModalSize: p.oneOf(["auto", "s", "m", "l", "xl", "cover", "form"]),
  variation: p.oneOf(["default", "minimal", "side-navigation"]),
  headerIcon: p.node,
  removeHeaderBorder: p.bool,
  panelClassName: p.string,
  topShadowClassName: p.string,
  bottomShadowClassName: p.string,
  headerTextClassName: p.string
}, CH.defaultProps = {
  contentIsScrollable: !0,
  closeOnClickOutside: !0,
  mobileModalSize: "cover",
  variation: "default",
  modalOnMobile: !0
};
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
function LH(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var NH,
  SH = {
    exports: {}
  };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
NH = SH, function () {
  var e = {}.hasOwnProperty;
  function t() {
    for (var e = "", t = 0; t < arguments.length; t++) {
      var i = arguments[t];
      i && (e = c(e, n(i)));
    }
    return e;
  }
  function n(n) {
    if ("string" == typeof n || "number" == typeof n) return n;
    if ("object" != typeof n) return "";
    if (Array.isArray(n)) return t.apply(null, n);
    if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]")) return n.toString();
    var i = "";
    for (var r in n) e.call(n, r) && n[r] && (i = c(i, r));
    return i;
  }
  function c(e, t) {
    return t ? e ? e + " " + t : e + t : e;
  }
  NH.exports ? (t.default = t, NH.exports = t) : window.classNames = t;
}();
var kH = SH.exports,
  PH = {
    headline: "Headline-module_headline__L3SDb",
    "color-white": "Headline-module_color-white__9E1Ci",
    "color-black": "Headline-module_color-black__Z5VNI",
    "color-base": "Headline-module_color-base__04cke",
    "color-primary": "Headline-module_color-primary__WY-WV",
    "color-secondary": "Headline-module_color-secondary__34Fam",
    "color-primary-text": "Headline-module_color-primary-text__hV3s6",
    "color-secondary-text": "Headline-module_color-secondary-text__h8qnA",
    "size-s": "Headline-module_size-s__8KbkL",
    "size-m": "Headline-module_size-m__q77Z-",
    "size-l": "Headline-module_size-l__BtzvS",
    "text-align-left": "Headline-module_text-align-left__0-d-Y",
    "text-align-center": "Headline-module_text-align-center__MXTZs",
    "text-align-right": "Headline-module_text-align-right__4we-t",
    "font-family-figtree": "Headline-module_font-family-figtree__HLXLR",
    "font-family-poppins": "Headline-module_font-family-poppins__4fkjP",
    truncate: "Headline-module_truncate__QPd2Y"
  },
  TH = function (e) {
    var n = e.children,
      c = e.color,
      i = e.size,
      r = e.textAlign,
      a = e.fontFamily,
      o = e.truncate,
      s = e.className;
    return /*#__PURE__*/t.createElement(Rb, {
      className: kH(PH.headline, b(b(b(b(b({}, PH["color-".concat(c)], c), PH["size-".concat(i)], i), PH["text-align-".concat(r)], r), PH["font-family-".concat(a)], a), PH.truncate, o), s)
    }, n);
  };
TH.propTypes = {
  children: p.any,
  color: p.oneOf(["white", "black", "base", "primary", "secondary", "primary-text", "secondary-text"]),
  size: p.oneOf(["s", "m", "l"]),
  textAlign: p.oneOf(["left", "center", "right"]),
  fontFamily: p.oneOf(["figtree", "poppins"]),
  className: p.string
}, TH.defaultProps = {
  color: "black",
  size: "l",
  textAlign: "left",
  fontFamily: "poppins"
};
var OH = "CallToAction-module_callToAction__6k7F7",
  AH = "CallToAction-module_callToAction_text__KDLB8",
  DH = "CallToAction-module_isButton__wCtc-",
  IH = "CallToAction-module_isMobile__MrNHc",
  jH = "CallToAction-module_isMobileNav__nrPTY",
  FH = "CallToAction-module_isClear__FICCI",
  RH = "CallToAction-module_forceWhite__B4E-p",
  BH = function () {
    var e = y(c({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < 768,
        isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
        isTabletOrGreater: window.innerWidth >= 768,
        isTouch: window.innerWidth < 1024,
        isDesktop: window.innerWidth >= 1024,
        isLargeDesktop: window.innerWidth >= 1280,
        isWidescreen: window.innerWidth >= 1366,
        isHD: window.innerWidth >= 1440,
        isSuperHD: window.innerWidth >= 1680
      }), 2),
      t = e[0],
      n = e[1];
    return i(function () {
      function e() {
        n({
          width: window.innerWidth,
          height: window.innerHeight,
          isMobile: window.innerWidth < 768,
          isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
          isTabletOrGreater: window.innerWidth >= 768,
          isTouch: window.innerWidth < 1024,
          isDesktop: window.innerWidth >= 1024,
          isLargeDesktop: window.innerWidth >= 1280,
          isWidescreen: window.innerWidth >= 1366,
          isHD: window.innerWidth >= 1440,
          isSuperHD: window.innerWidth >= 1680
        });
      }
      return window.addEventListener("resize", e), e(), function () {
        return window.removeEventListener("resize", e);
      };
    }, []), t;
  },
  GH = function (e) {
    var n = e.type,
      c = e.href,
      i = e.onClick,
      r = e.children,
      a = e.icon,
      o = e.isInline,
      s = e.isMobileNav,
      l = e.isClear,
      f = e.forceWhite,
      u = BH(),
      d = u.isMobile;
    u.isTouch;
    var p = u.isLargeDesktop,
      h = function () {
        return /*#__PURE__*/t.createElement(Ub, {
          renderAs: "button" === n ? "button" : "span",
          className: kH(OH, DH, b(b(b(b({}, IH, d), jH, s), FH, l), RH, f)),
          alignItems: "center",
          justifyContent: "center",
          gap: "s",
          onClick: "button" === n ? i : null,
          isInlineFlex: o
        }, a && /*#__PURE__*/t.createElement(Rb, null, a), s ? /*#__PURE__*/t.createElement(t.Fragment, null, p && /*#__PURE__*/t.createElement(Rb, {
          className: AH
        }, r)) : /*#__PURE__*/t.createElement(Rb, {
          className: AH
        }, r));
      };
    return "link" === n ? /*#__PURE__*/t.createElement("a", {
      href: c,
      target: "_blank",
      rel: "noreferrer nofollow"
    }, h()) : "router-link" === n ? /*#__PURE__*/t.createElement(m, {
      to: c
    }, h()) : h();
  };
GH.propTypes = {
  type: p.oneOf(["router-link", "button", "link"]),
  href: p.string,
  onClick: p.func,
  children: p.any,
  icon: p.node,
  isInline: p.bool,
  isMobileNav: p.bool,
  isClear: p.bool
}, GH.defaultTypes = {};
var YH = "SliceHeader-module_SliceHeader__divider__R47KH",
  WH = function (e) {
    var n = e.headline,
      c = e.description,
      i = e.isOverlay,
      r = e.removeBottomSpacer,
      a = BH().isMobile;
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Bb, {
      variation: a ? "fluid" : "full-width"
    }, n && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(TH, {
      size: "m",
      textAlign: "center",
      color: i ? "white" : "black"
    }, n), c && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, null), /*#__PURE__*/t.createElement(Rb, {
      className: YH
    })), /*#__PURE__*/t.createElement(Yb, {
      size: c ? "s" : "l"
    })), c && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Rb, {
      className: "columns is-centered"
    }, /*#__PURE__*/t.createElement(Rb, {
      className: "column is-6-desktop is-8-tablet has-text-centered"
    }, c)))), !r && (n || c) && /*#__PURE__*/t.createElement(Yb, {
      size: "l"
    }));
  };
WH.propTypes = {
  headline: p.string,
  description: p.string,
  isOverlay: p.bool,
  removeBottomSpacer: p.bool
}, WH.defaultTypes = {};
var qH = "NavigationLink-module_NavigationLink__textLink__uDtGh",
  UH = "NavigationLink-module_NavigationLink__panelLink__5fl8j",
  $H = "NavigationLink-module_hasSubs__-sxvh",
  XH = "NavigationLink-module_NavigationLink__panelLink_dropdown__1bs8p",
  ZH = "NavigationLink-module_active__uKOHn",
  KH = "NavigationLink-module_NavigationLink__subLinkWrapper__RYUwL",
  QH = "NavigationLink-module_NavigationLink__subLinks__N6Y1T",
  JH = "NavigationLink-module_NavigationLink__subLinks_inner__Ht7-1",
  ez = "NavigationLink-module_NavigationLink__subLinksPanel__r4p7o",
  tz = "NavigationLink-module_NavigationLink__subLinksPanel_inner__GMGzB",
  nz = "NavigationSubLink-module_NavigationSubLink__textLink__z8I9e",
  cz = "NavigationSubLink-module_NavigationSubLink__panelLink__dlZ7I",
  iz = function (e) {
    var n = e.isMobilePanel,
      c = e.renderRouterLink,
      i = e.slug,
      r = e.label;
    return c ? /*#__PURE__*/t.createElement(m, {
      to: "/".concat(i),
      className: n ? cz : nz
    }, r) : /*#__PURE__*/t.createElement("a", {
      href: i,
      className: n ? cz : nz,
      rel: "noreferrer nofollow",
      target: "_blank"
    }, r);
  };
iz.propTypes = {
  isMobilePanel: p.bool,
  renderRouterLink: p.bool,
  slug: p.oneOfType([p.string, p.func]),
  label: p.string
};
var rz = function (e) {
  var n = e.isMobilePanel,
    c = e.renderRouterLink,
    i = e.hasSubLinks,
    r = e.subLinks,
    a = e.slug,
    o = e.label,
    s = e.showSubLinks,
    l = e.hasActiveSubLinkGroup,
    f = function () {
      return /*#__PURE__*/t.createElement(Ub, {
        renderAs: "span",
        gap: "xs",
        alignItems: "center"
      }, /*#__PURE__*/t.createElement(Rb, {
        renderAs: "span"
      }, o), /*#__PURE__*/t.createElement(Sb, {
        name: "chevronDown"
      }));
    },
    u = function () {
      return /*#__PURE__*/t.createElement(Ub, {
        renderAs: "button",
        onClick: s,
        justifyContent: "center",
        alignItems: "center",
        className: kH(XH, b({}, ZH, l))
      }, /*#__PURE__*/t.createElement(Sb, {
        name: l ? "chevronUp" : "chevronDown"
      }));
    },
    d = function () {
      return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(m, {
        to: "/".concat(a),
        className: n ? kH(UH, b({}, $H, i)) : qH
      }, i && !n ? f() : o), i && n && u());
    },
    p = function () {
      return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("a", {
        href: a,
        className: n ? kH(UH, b({}, $H, i)) : qH,
        rel: "noreferrer nofollow",
        target: "_blank"
      }, i && !n ? f() : o), i && n && u());
    },
    h = function () {
      return r.map(function (e, i) {
        return /*#__PURE__*/t.createElement(iz, {
          key: "nav-sub-link-".concat(i),
          slug: e.slug,
          renderRouterLink: c,
          label: e.title,
          isMobilePanel: n
        });
      });
    };
  return /*#__PURE__*/t.createElement(t.Fragment, null, n ? /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Ub, {
    alignItems: "center",
    renderAs: "li",
    flexDirection: "column"
  }, /*#__PURE__*/t.createElement(Ub, {
    justifyContent: "space-between",
    alignItems: "center",
    style: {
      width: "100%"
    }
  }, c ? d() : p())), i && l && /*#__PURE__*/t.createElement(Rb, {
    className: ez
  }, /*#__PURE__*/t.createElement(Rb, {
    renderAs: "ul",
    className: tz
  }, h()))) : /*#__PURE__*/t.createElement(Rb, {
    setPositionRelative: !0,
    className: i ? KH : null
  }, c ? d() : p(), i && /*#__PURE__*/t.createElement(Rb, {
    className: QH
  }, /*#__PURE__*/t.createElement(Rb, {
    renderAs: "ul",
    className: JH
  }, h()))));
};
rz.propTypes = {
  isMobilePanel: p.bool,
  renderRouterLink: p.bool,
  hasSubLinks: p.bool,
  subLinks: p.array,
  slug: p.oneOfType([p.string, p.func]),
  label: p.string,
  showSubLinks: p.func,
  hasActiveSubLinkGroup: p.bool
};
var az = {
    SlideoutPanel: "SlideoutPanel-module_SlideoutPanel__XKIsr"
  },
  oz = function (e) {
    var n = e.children,
      c = e.reveal,
      i = e.onClose,
      r = e.title;
    return /*#__PURE__*/t.createElement(CH, {
      reveal: c,
      closeButtonOnClick: i,
      variation: "side-navigation",
      panelClassName: az.SlideoutPanel,
      headerTextClassName: az.SlideoutPanel__headerText,
      modalOnMobile: !1,
      title: r
    }, n);
  };
oz.propTypes = {
  children: p.any,
  reveal: p.bool,
  onClose: p.func,
  title: p.string
}, oz.defaultProps = {
  title: "Menu"
};
var sz = "SearchBar-module_searchBar__Q-oDC",
  lz = "SearchBar-module_searchBar__caption__SfPIQ",
  fz = "SearchBar-module_searchBar__dateSpacer__-1fwf",
  uz = "SearchBar-module_searchBar__setLineHeight__Ft2bI",
  dz = "SearchBar-module_searchBar__incrementer__vu1Zb",
  pz = "SearchBar-module_searchBar__incrementer_label__qippl",
  mz = {
    exports: {}
  };
!function (e, t) {
  e.exports = function () {
    var t, n;
    function c() {
      return t.apply(null, arguments);
    }
    function i(e) {
      t = e;
    }
    function r(e) {
      return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
    }
    function a(e) {
      return null != e && "[object Object]" === Object.prototype.toString.call(e);
    }
    function o(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    function s(e) {
      if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
      var t;
      for (t in e) if (o(e, t)) return !1;
      return !0;
    }
    function l(e) {
      return void 0 === e;
    }
    function f(e) {
      return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
    }
    function u(e) {
      return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
    }
    function d(e, t) {
      var n,
        c = [],
        i = e.length;
      for (n = 0; n < i; ++n) c.push(t(e[n], n));
      return c;
    }
    function p(e, t) {
      for (var n in t) o(t, n) && (e[n] = t[n]);
      return o(t, "toString") && (e.toString = t.toString), o(t, "valueOf") && (e.valueOf = t.valueOf), e;
    }
    function m(e, t, n, c) {
      return $n(e, t, n, c, !0).utc();
    }
    function h() {
      return {
        empty: !1,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: !1,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: !1,
        userInvalidated: !1,
        iso: !1,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: !1,
        weekdayMismatch: !1
      };
    }
    function v(e) {
      return null == e._pf && (e._pf = h()), e._pf;
    }
    function g(e) {
      var t = null,
        c = !1,
        i = e._d && !isNaN(e._d.getTime());
      return i && (t = v(e), c = n.call(t.parsedDateParts, function (e) {
        return null != e;
      }), i = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && c), e._strict && (i = i && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour)), null != Object.isFrozen && Object.isFrozen(e) ? i : (e._isValid = i, e._isValid);
    }
    function b(e) {
      var t = m(NaN);
      return null != e ? p(v(t), e) : v(t).userInvalidated = !0, t;
    }
    n = Array.prototype.some ? Array.prototype.some : function (e) {
      var t,
        n = Object(this),
        c = n.length >>> 0;
      for (t = 0; t < c; t++) if (t in n && e.call(this, n[t], t, n)) return !0;
      return !1;
    };
    var H = c.momentProperties = [],
      z = !1;
    function y(e, t) {
      var n,
        c,
        i,
        r = H.length;
      if (l(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), l(t._i) || (e._i = t._i), l(t._f) || (e._f = t._f), l(t._l) || (e._l = t._l), l(t._strict) || (e._strict = t._strict), l(t._tzm) || (e._tzm = t._tzm), l(t._isUTC) || (e._isUTC = t._isUTC), l(t._offset) || (e._offset = t._offset), l(t._pf) || (e._pf = v(t)), l(t._locale) || (e._locale = t._locale), r > 0) for (n = 0; n < r; n++) l(i = t[c = H[n]]) || (e[c] = i);
      return e;
    }
    function V(e) {
      y(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === z && (z = !0, c.updateOffset(this), z = !1);
    }
    function x(e) {
      return e instanceof V || null != e && null != e._isAMomentObject;
    }
    function M(e) {
      !1 === c.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
    }
    function _(e, t) {
      var n = !0;
      return p(function () {
        if (null != c.deprecationHandler && c.deprecationHandler(null, e), n) {
          var i,
            r,
            a,
            s = [],
            l = arguments.length;
          for (r = 0; r < l; r++) {
            if (i = "", "object" == typeof arguments[r]) {
              for (a in i += "\n[" + r + "] ", arguments[0]) o(arguments[0], a) && (i += a + ": " + arguments[0][a] + ", ");
              i = i.slice(0, -2);
            } else i = arguments[r];
            s.push(i);
          }
          M(e + "\nArguments: " + Array.prototype.slice.call(s).join("") + "\n" + new Error().stack), n = !1;
        }
        return t.apply(this, arguments);
      }, t);
    }
    var w,
      E = {};
    function C(e, t) {
      null != c.deprecationHandler && c.deprecationHandler(e, t), E[e] || (M(t), E[e] = !0);
    }
    function L(e) {
      return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
    }
    function N(e) {
      var t, n;
      for (n in e) o(e, n) && (L(t = e[n]) ? this[n] = t : this["_" + n] = t);
      this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function S(e, t) {
      var n,
        c = p({}, e);
      for (n in t) o(t, n) && (a(e[n]) && a(t[n]) ? (c[n] = {}, p(c[n], e[n]), p(c[n], t[n])) : null != t[n] ? c[n] = t[n] : delete c[n]);
      for (n in e) o(e, n) && !o(t, n) && a(e[n]) && (c[n] = p({}, c[n]));
      return c;
    }
    function k(e) {
      null != e && this.set(e);
    }
    c.suppressDeprecationWarnings = !1, c.deprecationHandler = null, w = Object.keys ? Object.keys : function (e) {
      var t,
        n = [];
      for (t in e) o(e, t) && n.push(t);
      return n;
    };
    var P = {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    };
    function T(e, t, n) {
      var c = this._calendar[e] || this._calendar.sameElse;
      return L(c) ? c.call(t, n) : c;
    }
    function O(e, t, n) {
      var c = "" + Math.abs(e),
        i = t - c.length;
      return (e >= 0 ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + c;
    }
    var A = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      D = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      I = {},
      j = {};
    function F(e, t, n, c) {
      var i = c;
      "string" == typeof c && (i = function () {
        return this[c]();
      }), e && (j[e] = i), t && (j[t[0]] = function () {
        return O(i.apply(this, arguments), t[1], t[2]);
      }), n && (j[n] = function () {
        return this.localeData().ordinal(i.apply(this, arguments), e);
      });
    }
    function R(e) {
      return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
    }
    function B(e) {
      var t,
        n,
        c = e.match(A);
      for (t = 0, n = c.length; t < n; t++) j[c[t]] ? c[t] = j[c[t]] : c[t] = R(c[t]);
      return function (t) {
        var i,
          r = "";
        for (i = 0; i < n; i++) r += L(c[i]) ? c[i].call(t, e) : c[i];
        return r;
      };
    }
    function G(e, t) {
      return e.isValid() ? (t = Y(t, e.localeData()), I[t] = I[t] || B(t), I[t](e)) : e.localeData().invalidDate();
    }
    function Y(e, t) {
      var n = 5;
      function c(e) {
        return t.longDateFormat(e) || e;
      }
      for (D.lastIndex = 0; n >= 0 && D.test(e);) e = e.replace(D, c), D.lastIndex = 0, n -= 1;
      return e;
    }
    var W = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function q(e) {
      var t = this._longDateFormat[e],
        n = this._longDateFormat[e.toUpperCase()];
      return t || !n ? t : (this._longDateFormat[e] = n.match(A).map(function (e) {
        return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e;
      }).join(""), this._longDateFormat[e]);
    }
    var U = "Invalid date";
    function $() {
      return this._invalidDate;
    }
    var X = "%d",
      Z = /\d{1,2}/;
    function K(e) {
      return this._ordinal.replace("%d", e);
    }
    var Q = {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      w: "a week",
      ww: "%d weeks",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    };
    function J(e, t, n, c) {
      var i = this._relativeTime[n];
      return L(i) ? i(e, t, n, c) : i.replace(/%d/i, e);
    }
    function ee(e, t) {
      var n = this._relativeTime[e > 0 ? "future" : "past"];
      return L(n) ? n(t) : n.replace(/%s/i, t);
    }
    var te = {
      D: "date",
      dates: "date",
      date: "date",
      d: "day",
      days: "day",
      day: "day",
      e: "weekday",
      weekdays: "weekday",
      weekday: "weekday",
      E: "isoWeekday",
      isoweekdays: "isoWeekday",
      isoweekday: "isoWeekday",
      DDD: "dayOfYear",
      dayofyears: "dayOfYear",
      dayofyear: "dayOfYear",
      h: "hour",
      hours: "hour",
      hour: "hour",
      ms: "millisecond",
      milliseconds: "millisecond",
      millisecond: "millisecond",
      m: "minute",
      minutes: "minute",
      minute: "minute",
      M: "month",
      months: "month",
      month: "month",
      Q: "quarter",
      quarters: "quarter",
      quarter: "quarter",
      s: "second",
      seconds: "second",
      second: "second",
      gg: "weekYear",
      weekyears: "weekYear",
      weekyear: "weekYear",
      GG: "isoWeekYear",
      isoweekyears: "isoWeekYear",
      isoweekyear: "isoWeekYear",
      w: "week",
      weeks: "week",
      week: "week",
      W: "isoWeek",
      isoweeks: "isoWeek",
      isoweek: "isoWeek",
      y: "year",
      years: "year",
      year: "year"
    };
    function ne(e) {
      return "string" == typeof e ? te[e] || te[e.toLowerCase()] : void 0;
    }
    function ce(e) {
      var t,
        n,
        c = {};
      for (n in e) o(e, n) && (t = ne(n)) && (c[t] = e[n]);
      return c;
    }
    var ie = {
      date: 9,
      day: 11,
      weekday: 11,
      isoWeekday: 11,
      dayOfYear: 4,
      hour: 13,
      millisecond: 16,
      minute: 14,
      month: 8,
      quarter: 7,
      second: 15,
      weekYear: 1,
      isoWeekYear: 1,
      week: 5,
      isoWeek: 5,
      year: 1
    };
    function re(e) {
      var t,
        n = [];
      for (t in e) o(e, t) && n.push({
        unit: t,
        priority: ie[t]
      });
      return n.sort(function (e, t) {
        return e.priority - t.priority;
      }), n;
    }
    var ae,
      oe = /\d/,
      se = /\d\d/,
      le = /\d{3}/,
      fe = /\d{4}/,
      ue = /[+-]?\d{6}/,
      de = /\d\d?/,
      pe = /\d\d\d\d?/,
      me = /\d\d\d\d\d\d?/,
      he = /\d{1,3}/,
      ve = /\d{1,4}/,
      ge = /[+-]?\d{1,6}/,
      be = /\d+/,
      He = /[+-]?\d+/,
      ze = /Z|[+-]\d\d:?\d\d/gi,
      ye = /Z|[+-]\d\d(?::?\d\d)?/gi,
      Ve = /[+-]?\d+(\.\d{1,3})?/,
      xe = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      Me = /^[1-9]\d?/,
      _e = /^([1-9]\d|\d)/;
    function we(e, t, n) {
      ae[e] = L(t) ? t : function (e, c) {
        return e && n ? n : t;
      };
    }
    function Ee(e, t) {
      return o(ae, e) ? ae[e](t._strict, t._locale) : new RegExp(Ce(e));
    }
    function Ce(e) {
      return Le(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, c, i) {
        return t || n || c || i;
      }));
    }
    function Le(e) {
      return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function Ne(e) {
      return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
    }
    function Se(e) {
      var t = +e,
        n = 0;
      return 0 !== t && isFinite(t) && (n = Ne(t)), n;
    }
    ae = {};
    var ke = {};
    function Pe(e, t) {
      var n,
        c,
        i = t;
      for ("string" == typeof e && (e = [e]), f(t) && (i = function (e, n) {
        n[t] = Se(e);
      }), c = e.length, n = 0; n < c; n++) ke[e[n]] = i;
    }
    function Te(e, t) {
      Pe(e, function (e, n, c, i) {
        c._w = c._w || {}, t(e, c._w, c, i);
      });
    }
    function Oe(e, t, n) {
      null != t && o(ke, e) && ke[e](t, n._a, n, e);
    }
    function Ae(e) {
      return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
    }
    var De = 0,
      Ie = 1,
      je = 2,
      Fe = 3,
      Re = 4,
      Be = 5,
      Ge = 6,
      Ye = 7,
      We = 8;
    function qe(e) {
      return Ae(e) ? 366 : 365;
    }
    F("Y", 0, 0, function () {
      var e = this.year();
      return e <= 9999 ? O(e, 4) : "+" + e;
    }), F(0, ["YY", 2], 0, function () {
      return this.year() % 100;
    }), F(0, ["YYYY", 4], 0, "year"), F(0, ["YYYYY", 5], 0, "year"), F(0, ["YYYYYY", 6, !0], 0, "year"), we("Y", He), we("YY", de, se), we("YYYY", ve, fe), we("YYYYY", ge, ue), we("YYYYYY", ge, ue), Pe(["YYYYY", "YYYYYY"], De), Pe("YYYY", function (e, t) {
      t[De] = 2 === e.length ? c.parseTwoDigitYear(e) : Se(e);
    }), Pe("YY", function (e, t) {
      t[De] = c.parseTwoDigitYear(e);
    }), Pe("Y", function (e, t) {
      t[De] = parseInt(e, 10);
    }), c.parseTwoDigitYear = function (e) {
      return Se(e) + (Se(e) > 68 ? 1900 : 2e3);
    };
    var Ue,
      $e = Ze("FullYear", !0);
    function Xe() {
      return Ae(this.year());
    }
    function Ze(e, t) {
      return function (n) {
        return null != n ? (Qe(this, e, n), c.updateOffset(this, t), this) : Ke(this, e);
      };
    }
    function Ke(e, t) {
      if (!e.isValid()) return NaN;
      var n = e._d,
        c = e._isUTC;
      switch (t) {
        case "Milliseconds":
          return c ? n.getUTCMilliseconds() : n.getMilliseconds();
        case "Seconds":
          return c ? n.getUTCSeconds() : n.getSeconds();
        case "Minutes":
          return c ? n.getUTCMinutes() : n.getMinutes();
        case "Hours":
          return c ? n.getUTCHours() : n.getHours();
        case "Date":
          return c ? n.getUTCDate() : n.getDate();
        case "Day":
          return c ? n.getUTCDay() : n.getDay();
        case "Month":
          return c ? n.getUTCMonth() : n.getMonth();
        case "FullYear":
          return c ? n.getUTCFullYear() : n.getFullYear();
        default:
          return NaN;
      }
    }
    function Qe(e, t, n) {
      var c, i, r, a, o;
      if (e.isValid() && !isNaN(n)) {
        switch (c = e._d, i = e._isUTC, t) {
          case "Milliseconds":
            return void (i ? c.setUTCMilliseconds(n) : c.setMilliseconds(n));
          case "Seconds":
            return void (i ? c.setUTCSeconds(n) : c.setSeconds(n));
          case "Minutes":
            return void (i ? c.setUTCMinutes(n) : c.setMinutes(n));
          case "Hours":
            return void (i ? c.setUTCHours(n) : c.setHours(n));
          case "Date":
            return void (i ? c.setUTCDate(n) : c.setDate(n));
          case "FullYear":
            break;
          default:
            return;
        }
        r = n, a = e.month(), o = 29 !== (o = e.date()) || 1 !== a || Ae(r) ? o : 28, i ? c.setUTCFullYear(r, a, o) : c.setFullYear(r, a, o);
      }
    }
    function Je(e) {
      return L(this[e = ne(e)]) ? this[e]() : this;
    }
    function et(e, t) {
      if ("object" == typeof e) {
        var n,
          c = re(e = ce(e)),
          i = c.length;
        for (n = 0; n < i; n++) this[c[n].unit](e[c[n].unit]);
      } else if (L(this[e = ne(e)])) return this[e](t);
      return this;
    }
    function tt(e, t) {
      return (e % t + t) % t;
    }
    function nt(e, t) {
      if (isNaN(e) || isNaN(t)) return NaN;
      var n = tt(t, 12);
      return e += (t - n) / 12, 1 === n ? Ae(e) ? 29 : 28 : 31 - n % 7 % 2;
    }
    Ue = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
      var t;
      for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
      return -1;
    }, F("M", ["MM", 2], "Mo", function () {
      return this.month() + 1;
    }), F("MMM", 0, 0, function (e) {
      return this.localeData().monthsShort(this, e);
    }), F("MMMM", 0, 0, function (e) {
      return this.localeData().months(this, e);
    }), we("M", de, Me), we("MM", de, se), we("MMM", function (e, t) {
      return t.monthsShortRegex(e);
    }), we("MMMM", function (e, t) {
      return t.monthsRegex(e);
    }), Pe(["M", "MM"], function (e, t) {
      t[Ie] = Se(e) - 1;
    }), Pe(["MMM", "MMMM"], function (e, t, n, c) {
      var i = n._locale.monthsParse(e, c, n._strict);
      null != i ? t[Ie] = i : v(n).invalidMonth = e;
    });
    var ct = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      it = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      rt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      at = xe,
      ot = xe;
    function st(e, t) {
      return e ? r(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || rt).test(t) ? "format" : "standalone"][e.month()] : r(this._months) ? this._months : this._months.standalone;
    }
    function lt(e, t) {
      return e ? r(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[rt.test(t) ? "format" : "standalone"][e.month()] : r(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
    }
    function ft(e, t, n) {
      var c,
        i,
        r,
        a = e.toLocaleLowerCase();
      if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], c = 0; c < 12; ++c) r = m([2e3, c]), this._shortMonthsParse[c] = this.monthsShort(r, "").toLocaleLowerCase(), this._longMonthsParse[c] = this.months(r, "").toLocaleLowerCase();
      return n ? "MMM" === t ? -1 !== (i = Ue.call(this._shortMonthsParse, a)) ? i : null : -1 !== (i = Ue.call(this._longMonthsParse, a)) ? i : null : "MMM" === t ? -1 !== (i = Ue.call(this._shortMonthsParse, a)) || -1 !== (i = Ue.call(this._longMonthsParse, a)) ? i : null : -1 !== (i = Ue.call(this._longMonthsParse, a)) || -1 !== (i = Ue.call(this._shortMonthsParse, a)) ? i : null;
    }
    function ut(e, t, n) {
      var c, i, r;
      if (this._monthsParseExact) return ft.call(this, e, t, n);
      for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), c = 0; c < 12; c++) {
        if (i = m([2e3, c]), n && !this._longMonthsParse[c] && (this._longMonthsParse[c] = new RegExp("^" + this.months(i, "").replace(".", "") + "$", "i"), this._shortMonthsParse[c] = new RegExp("^" + this.monthsShort(i, "").replace(".", "") + "$", "i")), n || this._monthsParse[c] || (r = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[c] = new RegExp(r.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[c].test(e)) return c;
        if (n && "MMM" === t && this._shortMonthsParse[c].test(e)) return c;
        if (!n && this._monthsParse[c].test(e)) return c;
      }
    }
    function dt(e, t) {
      if (!e.isValid()) return e;
      if ("string" == typeof t) if (/^\d+$/.test(t)) t = Se(t);else if (!f(t = e.localeData().monthsParse(t))) return e;
      var n = t,
        c = e.date();
      return c = c < 29 ? c : Math.min(c, nt(e.year(), n)), e._isUTC ? e._d.setUTCMonth(n, c) : e._d.setMonth(n, c), e;
    }
    function pt(e) {
      return null != e ? (dt(this, e), c.updateOffset(this, !0), this) : Ke(this, "Month");
    }
    function mt() {
      return nt(this.year(), this.month());
    }
    function ht(e) {
      return this._monthsParseExact ? (o(this, "_monthsRegex") || gt.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (o(this, "_monthsShortRegex") || (this._monthsShortRegex = at), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
    }
    function vt(e) {
      return this._monthsParseExact ? (o(this, "_monthsRegex") || gt.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (o(this, "_monthsRegex") || (this._monthsRegex = ot), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
    }
    function gt() {
      function e(e, t) {
        return t.length - e.length;
      }
      var t,
        n,
        c,
        i,
        r = [],
        a = [],
        o = [];
      for (t = 0; t < 12; t++) n = m([2e3, t]), c = Le(this.monthsShort(n, "")), i = Le(this.months(n, "")), r.push(c), a.push(i), o.push(i), o.push(c);
      r.sort(e), a.sort(e), o.sort(e), this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i");
    }
    function bt(e, t, n, c, i, r, a) {
      var o;
      return e < 100 && e >= 0 ? (o = new Date(e + 400, t, n, c, i, r, a), isFinite(o.getFullYear()) && o.setFullYear(e)) : o = new Date(e, t, n, c, i, r, a), o;
    }
    function Ht(e) {
      var t, n;
      return e < 100 && e >= 0 ? ((n = Array.prototype.slice.call(arguments))[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
    }
    function zt(e, t, n) {
      var c = 7 + t - n;
      return -(7 + Ht(e, 0, c).getUTCDay() - t) % 7 + c - 1;
    }
    function yt(e, t, n, c, i) {
      var r,
        a,
        o = 1 + 7 * (t - 1) + (7 + n - c) % 7 + zt(e, c, i);
      return o <= 0 ? a = qe(r = e - 1) + o : o > qe(e) ? (r = e + 1, a = o - qe(e)) : (r = e, a = o), {
        year: r,
        dayOfYear: a
      };
    }
    function Vt(e, t, n) {
      var c,
        i,
        r = zt(e.year(), t, n),
        a = Math.floor((e.dayOfYear() - r - 1) / 7) + 1;
      return a < 1 ? c = a + xt(i = e.year() - 1, t, n) : a > xt(e.year(), t, n) ? (c = a - xt(e.year(), t, n), i = e.year() + 1) : (i = e.year(), c = a), {
        week: c,
        year: i
      };
    }
    function xt(e, t, n) {
      var c = zt(e, t, n),
        i = zt(e + 1, t, n);
      return (qe(e) - c + i) / 7;
    }
    function Mt(e) {
      return Vt(e, this._week.dow, this._week.doy).week;
    }
    F("w", ["ww", 2], "wo", "week"), F("W", ["WW", 2], "Wo", "isoWeek"), we("w", de, Me), we("ww", de, se), we("W", de, Me), we("WW", de, se), Te(["w", "ww", "W", "WW"], function (e, t, n, c) {
      t[c.substr(0, 1)] = Se(e);
    });
    var _t = {
      dow: 0,
      doy: 6
    };
    function wt() {
      return this._week.dow;
    }
    function Et() {
      return this._week.doy;
    }
    function Ct(e) {
      var t = this.localeData().week(this);
      return null == e ? t : this.add(7 * (e - t), "d");
    }
    function Lt(e) {
      var t = Vt(this, 1, 4).week;
      return null == e ? t : this.add(7 * (e - t), "d");
    }
    function Nt(e, t) {
      return "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10);
    }
    function St(e, t) {
      return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
    }
    function kt(e, t) {
      return e.slice(t, 7).concat(e.slice(0, t));
    }
    F("d", 0, "do", "day"), F("dd", 0, 0, function (e) {
      return this.localeData().weekdaysMin(this, e);
    }), F("ddd", 0, 0, function (e) {
      return this.localeData().weekdaysShort(this, e);
    }), F("dddd", 0, 0, function (e) {
      return this.localeData().weekdays(this, e);
    }), F("e", 0, 0, "weekday"), F("E", 0, 0, "isoWeekday"), we("d", de), we("e", de), we("E", de), we("dd", function (e, t) {
      return t.weekdaysMinRegex(e);
    }), we("ddd", function (e, t) {
      return t.weekdaysShortRegex(e);
    }), we("dddd", function (e, t) {
      return t.weekdaysRegex(e);
    }), Te(["dd", "ddd", "dddd"], function (e, t, n, c) {
      var i = n._locale.weekdaysParse(e, c, n._strict);
      null != i ? t.d = i : v(n).invalidWeekday = e;
    }), Te(["d", "e", "E"], function (e, t, n, c) {
      t[c] = Se(e);
    });
    var Pt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      Tt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      Ot = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      At = xe,
      Dt = xe,
      It = xe;
    function jt(e, t) {
      var n = r(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
      return !0 === e ? kt(n, this._week.dow) : e ? n[e.day()] : n;
    }
    function Ft(e) {
      return !0 === e ? kt(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
    }
    function Rt(e) {
      return !0 === e ? kt(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
    }
    function Bt(e, t, n) {
      var c,
        i,
        r,
        a = e.toLocaleLowerCase();
      if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], c = 0; c < 7; ++c) r = m([2e3, 1]).day(c), this._minWeekdaysParse[c] = this.weekdaysMin(r, "").toLocaleLowerCase(), this._shortWeekdaysParse[c] = this.weekdaysShort(r, "").toLocaleLowerCase(), this._weekdaysParse[c] = this.weekdays(r, "").toLocaleLowerCase();
      return n ? "dddd" === t ? -1 !== (i = Ue.call(this._weekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ue.call(this._shortWeekdaysParse, a)) ? i : null : -1 !== (i = Ue.call(this._minWeekdaysParse, a)) ? i : null : "dddd" === t ? -1 !== (i = Ue.call(this._weekdaysParse, a)) || -1 !== (i = Ue.call(this._shortWeekdaysParse, a)) || -1 !== (i = Ue.call(this._minWeekdaysParse, a)) ? i : null : "ddd" === t ? -1 !== (i = Ue.call(this._shortWeekdaysParse, a)) || -1 !== (i = Ue.call(this._weekdaysParse, a)) || -1 !== (i = Ue.call(this._minWeekdaysParse, a)) ? i : null : -1 !== (i = Ue.call(this._minWeekdaysParse, a)) || -1 !== (i = Ue.call(this._weekdaysParse, a)) || -1 !== (i = Ue.call(this._shortWeekdaysParse, a)) ? i : null;
    }
    function Gt(e, t, n) {
      var c, i, r;
      if (this._weekdaysParseExact) return Bt.call(this, e, t, n);
      for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), c = 0; c < 7; c++) {
        if (i = m([2e3, 1]).day(c), n && !this._fullWeekdaysParse[c] && (this._fullWeekdaysParse[c] = new RegExp("^" + this.weekdays(i, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[c] = new RegExp("^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[c] = new RegExp("^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[c] || (r = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[c] = new RegExp(r.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[c].test(e)) return c;
        if (n && "ddd" === t && this._shortWeekdaysParse[c].test(e)) return c;
        if (n && "dd" === t && this._minWeekdaysParse[c].test(e)) return c;
        if (!n && this._weekdaysParse[c].test(e)) return c;
      }
    }
    function Yt(e) {
      if (!this.isValid()) return null != e ? this : NaN;
      var t = Ke(this, "Day");
      return null != e ? (e = Nt(e, this.localeData()), this.add(e - t, "d")) : t;
    }
    function Wt(e) {
      if (!this.isValid()) return null != e ? this : NaN;
      var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return null == e ? t : this.add(e - t, "d");
    }
    function qt(e) {
      if (!this.isValid()) return null != e ? this : NaN;
      if (null != e) {
        var t = St(e, this.localeData());
        return this.day(this.day() % 7 ? t : t - 7);
      }
      return this.day() || 7;
    }
    function Ut(e) {
      return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Zt.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (o(this, "_weekdaysRegex") || (this._weekdaysRegex = At), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
    }
    function $t(e) {
      return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Zt.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (o(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Dt), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
    }
    function Xt(e) {
      return this._weekdaysParseExact ? (o(this, "_weekdaysRegex") || Zt.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (o(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = It), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
    }
    function Zt() {
      function e(e, t) {
        return t.length - e.length;
      }
      var t,
        n,
        c,
        i,
        r,
        a = [],
        o = [],
        s = [],
        l = [];
      for (t = 0; t < 7; t++) n = m([2e3, 1]).day(t), c = Le(this.weekdaysMin(n, "")), i = Le(this.weekdaysShort(n, "")), r = Le(this.weekdays(n, "")), a.push(c), o.push(i), s.push(r), l.push(c), l.push(i), l.push(r);
      a.sort(e), o.sort(e), s.sort(e), l.sort(e), this._weekdaysRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + a.join("|") + ")", "i");
    }
    function Kt() {
      return this.hours() % 12 || 12;
    }
    function Qt() {
      return this.hours() || 24;
    }
    function Jt(e, t) {
      F(e, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), t);
      });
    }
    function en(e, t) {
      return t._meridiemParse;
    }
    function tn(e) {
      return "p" === (e + "").toLowerCase().charAt(0);
    }
    F("H", ["HH", 2], 0, "hour"), F("h", ["hh", 2], 0, Kt), F("k", ["kk", 2], 0, Qt), F("hmm", 0, 0, function () {
      return "" + Kt.apply(this) + O(this.minutes(), 2);
    }), F("hmmss", 0, 0, function () {
      return "" + Kt.apply(this) + O(this.minutes(), 2) + O(this.seconds(), 2);
    }), F("Hmm", 0, 0, function () {
      return "" + this.hours() + O(this.minutes(), 2);
    }), F("Hmmss", 0, 0, function () {
      return "" + this.hours() + O(this.minutes(), 2) + O(this.seconds(), 2);
    }), Jt("a", !0), Jt("A", !1), we("a", en), we("A", en), we("H", de, _e), we("h", de, Me), we("k", de, Me), we("HH", de, se), we("hh", de, se), we("kk", de, se), we("hmm", pe), we("hmmss", me), we("Hmm", pe), we("Hmmss", me), Pe(["H", "HH"], Fe), Pe(["k", "kk"], function (e, t, n) {
      var c = Se(e);
      t[Fe] = 24 === c ? 0 : c;
    }), Pe(["a", "A"], function (e, t, n) {
      n._isPm = n._locale.isPM(e), n._meridiem = e;
    }), Pe(["h", "hh"], function (e, t, n) {
      t[Fe] = Se(e), v(n).bigHour = !0;
    }), Pe("hmm", function (e, t, n) {
      var c = e.length - 2;
      t[Fe] = Se(e.substr(0, c)), t[Re] = Se(e.substr(c)), v(n).bigHour = !0;
    }), Pe("hmmss", function (e, t, n) {
      var c = e.length - 4,
        i = e.length - 2;
      t[Fe] = Se(e.substr(0, c)), t[Re] = Se(e.substr(c, 2)), t[Be] = Se(e.substr(i)), v(n).bigHour = !0;
    }), Pe("Hmm", function (e, t, n) {
      var c = e.length - 2;
      t[Fe] = Se(e.substr(0, c)), t[Re] = Se(e.substr(c));
    }), Pe("Hmmss", function (e, t, n) {
      var c = e.length - 4,
        i = e.length - 2;
      t[Fe] = Se(e.substr(0, c)), t[Re] = Se(e.substr(c, 2)), t[Be] = Se(e.substr(i));
    });
    var nn = /[ap]\.?m?\.?/i,
      cn = Ze("Hours", !0);
    function rn(e, t, n) {
      return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
    }
    var an,
      on = {
        calendar: P,
        longDateFormat: W,
        invalidDate: U,
        ordinal: X,
        dayOfMonthOrdinalParse: Z,
        relativeTime: Q,
        months: ct,
        monthsShort: it,
        week: _t,
        weekdays: Pt,
        weekdaysMin: Ot,
        weekdaysShort: Tt,
        meridiemParse: nn
      },
      sn = {},
      ln = {};
    function fn(e, t) {
      var n,
        c = Math.min(e.length, t.length);
      for (n = 0; n < c; n += 1) if (e[n] !== t[n]) return n;
      return c;
    }
    function un(e) {
      return e ? e.toLowerCase().replace("_", "-") : e;
    }
    function dn(e) {
      for (var t, n, c, i, r = 0; r < e.length;) {
        for (t = (i = un(e[r]).split("-")).length, n = (n = un(e[r + 1])) ? n.split("-") : null; t > 0;) {
          if (c = mn(i.slice(0, t).join("-"))) return c;
          if (n && n.length >= t && fn(i, n) >= t - 1) break;
          t--;
        }
        r++;
      }
      return an;
    }
    function pn(e) {
      return !(!e || !e.match("^[^/\\\\]*$"));
    }
    function mn(t) {
      var n = null;
      if (void 0 === sn[t] && e && e.exports && pn(t)) try {
        n = an._abbr, LH("./locale/" + t), hn(n);
      } catch (e) {
        sn[t] = null;
      }
      return sn[t];
    }
    function hn(e, t) {
      var n;
      return e && ((n = l(t) ? bn(e) : vn(e, t)) ? an = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), an._abbr;
    }
    function vn(e, t) {
      if (null !== t) {
        var n,
          c = on;
        if (t.abbr = e, null != sn[e]) C("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), c = sn[e]._config;else if (null != t.parentLocale) if (null != sn[t.parentLocale]) c = sn[t.parentLocale]._config;else {
          if (null == (n = mn(t.parentLocale))) return ln[t.parentLocale] || (ln[t.parentLocale] = []), ln[t.parentLocale].push({
            name: e,
            config: t
          }), null;
          c = n._config;
        }
        return sn[e] = new k(S(c, t)), ln[e] && ln[e].forEach(function (e) {
          vn(e.name, e.config);
        }), hn(e), sn[e];
      }
      return delete sn[e], null;
    }
    function gn(e, t) {
      if (null != t) {
        var n,
          c,
          i = on;
        null != sn[e] && null != sn[e].parentLocale ? sn[e].set(S(sn[e]._config, t)) : (null != (c = mn(e)) && (i = c._config), t = S(i, t), null == c && (t.abbr = e), (n = new k(t)).parentLocale = sn[e], sn[e] = n), hn(e);
      } else null != sn[e] && (null != sn[e].parentLocale ? (sn[e] = sn[e].parentLocale, e === hn() && hn(e)) : null != sn[e] && delete sn[e]);
      return sn[e];
    }
    function bn(e) {
      var t;
      if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return an;
      if (!r(e)) {
        if (t = mn(e)) return t;
        e = [e];
      }
      return dn(e);
    }
    function Hn() {
      return w(sn);
    }
    function zn(e) {
      var t,
        n = e._a;
      return n && -2 === v(e).overflow && (t = n[Ie] < 0 || n[Ie] > 11 ? Ie : n[je] < 1 || n[je] > nt(n[De], n[Ie]) ? je : n[Fe] < 0 || n[Fe] > 24 || 24 === n[Fe] && (0 !== n[Re] || 0 !== n[Be] || 0 !== n[Ge]) ? Fe : n[Re] < 0 || n[Re] > 59 ? Re : n[Be] < 0 || n[Be] > 59 ? Be : n[Ge] < 0 || n[Ge] > 999 ? Ge : -1, v(e)._overflowDayOfYear && (t < De || t > je) && (t = je), v(e)._overflowWeeks && -1 === t && (t = Ye), v(e)._overflowWeekday && -1 === t && (t = We), v(e).overflow = t), e;
    }
    var yn = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      Vn = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      xn = /Z|[+-]\d\d(?::?\d\d)?/,
      Mn = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/], ["YYYYMM", /\d{6}/, !1], ["YYYY", /\d{4}/, !1]],
      _n = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
      wn = /^\/?Date\((-?\d+)/i,
      En = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      Cn = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
      };
    function Ln(e) {
      var t,
        n,
        c,
        i,
        r,
        a,
        o = e._i,
        s = yn.exec(o) || Vn.exec(o),
        l = Mn.length,
        f = _n.length;
      if (s) {
        for (v(e).iso = !0, t = 0, n = l; t < n; t++) if (Mn[t][1].exec(s[1])) {
          i = Mn[t][0], c = !1 !== Mn[t][2];
          break;
        }
        if (null == i) return void (e._isValid = !1);
        if (s[3]) {
          for (t = 0, n = f; t < n; t++) if (_n[t][1].exec(s[3])) {
            r = (s[2] || " ") + _n[t][0];
            break;
          }
          if (null == r) return void (e._isValid = !1);
        }
        if (!c && null != r) return void (e._isValid = !1);
        if (s[4]) {
          if (!xn.exec(s[4])) return void (e._isValid = !1);
          a = "Z";
        }
        e._f = i + (r || "") + (a || ""), Rn(e);
      } else e._isValid = !1;
    }
    function Nn(e, t, n, c, i, r) {
      var a = [Sn(e), it.indexOf(t), parseInt(n, 10), parseInt(c, 10), parseInt(i, 10)];
      return r && a.push(parseInt(r, 10)), a;
    }
    function Sn(e) {
      var t = parseInt(e, 10);
      return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
    }
    function kn(e) {
      return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function Pn(e, t, n) {
      return !e || Tt.indexOf(e) === new Date(t[0], t[1], t[2]).getDay() || (v(n).weekdayMismatch = !0, n._isValid = !1, !1);
    }
    function Tn(e, t, n) {
      if (e) return Cn[e];
      if (t) return 0;
      var c = parseInt(n, 10),
        i = c % 100;
      return (c - i) / 100 * 60 + i;
    }
    function On(e) {
      var t,
        n = En.exec(kn(e._i));
      if (n) {
        if (t = Nn(n[4], n[3], n[2], n[5], n[6], n[7]), !Pn(n[1], t, e)) return;
        e._a = t, e._tzm = Tn(n[8], n[9], n[10]), e._d = Ht.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), v(e).rfc2822 = !0;
      } else e._isValid = !1;
    }
    function An(e) {
      var t = wn.exec(e._i);
      null === t ? (Ln(e), !1 === e._isValid && (delete e._isValid, On(e), !1 === e._isValid && (delete e._isValid, e._strict ? e._isValid = !1 : c.createFromInputFallback(e)))) : e._d = new Date(+t[1]);
    }
    function Dn(e, t, n) {
      return null != e ? e : null != t ? t : n;
    }
    function In(e) {
      var t = new Date(c.now());
      return e._useUTC ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()] : [t.getFullYear(), t.getMonth(), t.getDate()];
    }
    function jn(e) {
      var t,
        n,
        c,
        i,
        r,
        a = [];
      if (!e._d) {
        for (c = In(e), e._w && null == e._a[je] && null == e._a[Ie] && Fn(e), null != e._dayOfYear && (r = Dn(e._a[De], c[De]), (e._dayOfYear > qe(r) || 0 === e._dayOfYear) && (v(e)._overflowDayOfYear = !0), n = Ht(r, 0, e._dayOfYear), e._a[Ie] = n.getUTCMonth(), e._a[je] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) e._a[t] = a[t] = c[t];
        for (; t < 7; t++) e._a[t] = a[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
        24 === e._a[Fe] && 0 === e._a[Re] && 0 === e._a[Be] && 0 === e._a[Ge] && (e._nextDay = !0, e._a[Fe] = 0), e._d = (e._useUTC ? Ht : bt).apply(null, a), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[Fe] = 24), e._w && void 0 !== e._w.d && e._w.d !== i && (v(e).weekdayMismatch = !0);
      }
    }
    function Fn(e) {
      var t, n, c, i, r, a, o, s, l;
      null != (t = e._w).GG || null != t.W || null != t.E ? (r = 1, a = 4, n = Dn(t.GG, e._a[De], Vt(Xn(), 1, 4).year), c = Dn(t.W, 1), ((i = Dn(t.E, 1)) < 1 || i > 7) && (s = !0)) : (r = e._locale._week.dow, a = e._locale._week.doy, l = Vt(Xn(), r, a), n = Dn(t.gg, e._a[De], l.year), c = Dn(t.w, l.week), null != t.d ? ((i = t.d) < 0 || i > 6) && (s = !0) : null != t.e ? (i = t.e + r, (t.e < 0 || t.e > 6) && (s = !0)) : i = r), c < 1 || c > xt(n, r, a) ? v(e)._overflowWeeks = !0 : null != s ? v(e)._overflowWeekday = !0 : (o = yt(n, c, i, r, a), e._a[De] = o.year, e._dayOfYear = o.dayOfYear);
    }
    function Rn(e) {
      if (e._f !== c.ISO_8601) {
        if (e._f !== c.RFC_2822) {
          e._a = [], v(e).empty = !0;
          var t,
            n,
            i,
            r,
            a,
            o,
            s,
            l = "" + e._i,
            f = l.length,
            u = 0;
          for (s = (i = Y(e._f, e._locale).match(A) || []).length, t = 0; t < s; t++) r = i[t], (n = (l.match(Ee(r, e)) || [])[0]) && ((a = l.substr(0, l.indexOf(n))).length > 0 && v(e).unusedInput.push(a), l = l.slice(l.indexOf(n) + n.length), u += n.length), j[r] ? (n ? v(e).empty = !1 : v(e).unusedTokens.push(r), Oe(r, n, e)) : e._strict && !n && v(e).unusedTokens.push(r);
          v(e).charsLeftOver = f - u, l.length > 0 && v(e).unusedInput.push(l), e._a[Fe] <= 12 && !0 === v(e).bigHour && e._a[Fe] > 0 && (v(e).bigHour = void 0), v(e).parsedDateParts = e._a.slice(0), v(e).meridiem = e._meridiem, e._a[Fe] = Bn(e._locale, e._a[Fe], e._meridiem), null !== (o = v(e).era) && (e._a[De] = e._locale.erasConvertYear(o, e._a[De])), jn(e), zn(e);
        } else On(e);
      } else Ln(e);
    }
    function Bn(e, t, n) {
      var c;
      return null == n ? t : null != e.meridiemHour ? e.meridiemHour(t, n) : null != e.isPM ? ((c = e.isPM(n)) && t < 12 && (t += 12), c || 12 !== t || (t = 0), t) : t;
    }
    function Gn(e) {
      var t,
        n,
        c,
        i,
        r,
        a,
        o = !1,
        s = e._f.length;
      if (0 === s) return v(e).invalidFormat = !0, void (e._d = new Date(NaN));
      for (i = 0; i < s; i++) r = 0, a = !1, t = y({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[i], Rn(t), g(t) && (a = !0), r += v(t).charsLeftOver, r += 10 * v(t).unusedTokens.length, v(t).score = r, o ? r < c && (c = r, n = t) : (null == c || r < c || a) && (c = r, n = t, a && (o = !0));
      p(e, n || t);
    }
    function Yn(e) {
      if (!e._d) {
        var t = ce(e._i),
          n = void 0 === t.day ? t.date : t.day;
        e._a = d([t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond], function (e) {
          return e && parseInt(e, 10);
        }), jn(e);
      }
    }
    function Wn(e) {
      var t = new V(zn(qn(e)));
      return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
    }
    function qn(e) {
      var t = e._i,
        n = e._f;
      return e._locale = e._locale || bn(e._l), null === t || void 0 === n && "" === t ? b({
        nullInput: !0
      }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), x(t) ? new V(zn(t)) : (u(t) ? e._d = t : r(n) ? Gn(e) : n ? Rn(e) : Un(e), g(e) || (e._d = null), e));
    }
    function Un(e) {
      var t = e._i;
      l(t) ? e._d = new Date(c.now()) : u(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? An(e) : r(t) ? (e._a = d(t.slice(0), function (e) {
        return parseInt(e, 10);
      }), jn(e)) : a(t) ? Yn(e) : f(t) ? e._d = new Date(t) : c.createFromInputFallback(e);
    }
    function $n(e, t, n, c, i) {
      var o = {};
      return !0 !== t && !1 !== t || (c = t, t = void 0), !0 !== n && !1 !== n || (c = n, n = void 0), (a(e) && s(e) || r(e) && 0 === e.length) && (e = void 0), o._isAMomentObject = !0, o._useUTC = o._isUTC = i, o._l = n, o._i = e, o._f = t, o._strict = c, Wn(o);
    }
    function Xn(e, t, n, c) {
      return $n(e, t, n, c, !1);
    }
    c.createFromInputFallback = _("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (e) {
      e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
    }), c.ISO_8601 = function () {}, c.RFC_2822 = function () {};
    var Zn = _("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
        var e = Xn.apply(null, arguments);
        return this.isValid() && e.isValid() ? e < this ? this : e : b();
      }),
      Kn = _("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
        var e = Xn.apply(null, arguments);
        return this.isValid() && e.isValid() ? e > this ? this : e : b();
      });
    function Qn(e, t) {
      var n, c;
      if (1 === t.length && r(t[0]) && (t = t[0]), !t.length) return Xn();
      for (n = t[0], c = 1; c < t.length; ++c) t[c].isValid() && !t[c][e](n) || (n = t[c]);
      return n;
    }
    function Jn() {
      return Qn("isBefore", [].slice.call(arguments, 0));
    }
    function ec() {
      return Qn("isAfter", [].slice.call(arguments, 0));
    }
    var tc = function () {
        return Date.now ? Date.now() : +new Date();
      },
      nc = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
    function cc(e) {
      var t,
        n,
        c = !1,
        i = nc.length;
      for (t in e) if (o(e, t) && (-1 === Ue.call(nc, t) || null != e[t] && isNaN(e[t]))) return !1;
      for (n = 0; n < i; ++n) if (e[nc[n]]) {
        if (c) return !1;
        parseFloat(e[nc[n]]) !== Se(e[nc[n]]) && (c = !0);
      }
      return !0;
    }
    function ic() {
      return this._isValid;
    }
    function rc() {
      return Cc(NaN);
    }
    function ac(e) {
      var t = ce(e),
        n = t.year || 0,
        c = t.quarter || 0,
        i = t.month || 0,
        r = t.week || t.isoWeek || 0,
        a = t.day || 0,
        o = t.hour || 0,
        s = t.minute || 0,
        l = t.second || 0,
        f = t.millisecond || 0;
      this._isValid = cc(t), this._milliseconds = +f + 1e3 * l + 6e4 * s + 1e3 * o * 60 * 60, this._days = +a + 7 * r, this._months = +i + 3 * c + 12 * n, this._data = {}, this._locale = bn(), this._bubble();
    }
    function oc(e) {
      return e instanceof ac;
    }
    function sc(e) {
      return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
    }
    function lc(e, t, n) {
      var c,
        i = Math.min(e.length, t.length),
        r = Math.abs(e.length - t.length),
        a = 0;
      for (c = 0; c < i; c++) (n && e[c] !== t[c] || !n && Se(e[c]) !== Se(t[c])) && a++;
      return a + r;
    }
    function fc(e, t) {
      F(e, 0, 0, function () {
        var e = this.utcOffset(),
          n = "+";
        return e < 0 && (e = -e, n = "-"), n + O(~~(e / 60), 2) + t + O(~~e % 60, 2);
      });
    }
    fc("Z", ":"), fc("ZZ", ""), we("Z", ye), we("ZZ", ye), Pe(["Z", "ZZ"], function (e, t, n) {
      n._useUTC = !0, n._tzm = dc(ye, e);
    });
    var uc = /([\+\-]|\d\d)/gi;
    function dc(e, t) {
      var n,
        c,
        i = (t || "").match(e);
      return null === i ? null : 0 === (c = 60 * (n = ((i[i.length - 1] || []) + "").match(uc) || ["-", 0, 0])[1] + Se(n[2])) ? 0 : "+" === n[0] ? c : -c;
    }
    function pc(e, t) {
      var n, i;
      return t._isUTC ? (n = t.clone(), i = (x(e) || u(e) ? e.valueOf() : Xn(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + i), c.updateOffset(n, !1), n) : Xn(e).local();
    }
    function mc(e) {
      return -Math.round(e._d.getTimezoneOffset());
    }
    function hc(e, t, n) {
      var i,
        r = this._offset || 0;
      if (!this.isValid()) return null != e ? this : NaN;
      if (null != e) {
        if ("string" == typeof e) {
          if (null === (e = dc(ye, e))) return this;
        } else Math.abs(e) < 16 && !n && (e *= 60);
        return !this._isUTC && t && (i = mc(this)), this._offset = e, this._isUTC = !0, null != i && this.add(i, "m"), r !== e && (!t || this._changeInProgress ? Pc(this, Cc(e - r, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, c.updateOffset(this, !0), this._changeInProgress = null)), this;
      }
      return this._isUTC ? r : mc(this);
    }
    function vc(e, t) {
      return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
    }
    function gc(e) {
      return this.utcOffset(0, e);
    }
    function bc(e) {
      return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(mc(this), "m")), this;
    }
    function Hc() {
      if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
        var e = dc(ze, this._i);
        null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
      }
      return this;
    }
    function zc(e) {
      return !!this.isValid() && (e = e ? Xn(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
    }
    function yc() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function Vc() {
      if (!l(this._isDSTShifted)) return this._isDSTShifted;
      var e,
        t = {};
      return y(t, this), (t = qn(t))._a ? (e = t._isUTC ? m(t._a) : Xn(t._a), this._isDSTShifted = this.isValid() && lc(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
    }
    function xc() {
      return !!this.isValid() && !this._isUTC;
    }
    function Mc() {
      return !!this.isValid() && this._isUTC;
    }
    function _c() {
      return !!this.isValid() && this._isUTC && 0 === this._offset;
    }
    c.updateOffset = function () {};
    var wc = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      Ec = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function Cc(e, t) {
      var n,
        c,
        i,
        r = e,
        a = null;
      return oc(e) ? r = {
        ms: e._milliseconds,
        d: e._days,
        M: e._months
      } : f(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (a = wc.exec(e)) ? (n = "-" === a[1] ? -1 : 1, r = {
        y: 0,
        d: Se(a[je]) * n,
        h: Se(a[Fe]) * n,
        m: Se(a[Re]) * n,
        s: Se(a[Be]) * n,
        ms: Se(sc(1e3 * a[Ge])) * n
      }) : (a = Ec.exec(e)) ? (n = "-" === a[1] ? -1 : 1, r = {
        y: Lc(a[2], n),
        M: Lc(a[3], n),
        w: Lc(a[4], n),
        d: Lc(a[5], n),
        h: Lc(a[6], n),
        m: Lc(a[7], n),
        s: Lc(a[8], n)
      }) : null == r ? r = {} : "object" == typeof r && ("from" in r || "to" in r) && (i = Sc(Xn(r.from), Xn(r.to)), (r = {}).ms = i.milliseconds, r.M = i.months), c = new ac(r), oc(e) && o(e, "_locale") && (c._locale = e._locale), oc(e) && o(e, "_isValid") && (c._isValid = e._isValid), c;
    }
    function Lc(e, t) {
      var n = e && parseFloat(e.replace(",", "."));
      return (isNaN(n) ? 0 : n) * t;
    }
    function Nc(e, t) {
      var n = {};
      return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
    }
    function Sc(e, t) {
      var n;
      return e.isValid() && t.isValid() ? (t = pc(t, e), e.isBefore(t) ? n = Nc(e, t) : ((n = Nc(t, e)).milliseconds = -n.milliseconds, n.months = -n.months), n) : {
        milliseconds: 0,
        months: 0
      };
    }
    function kc(e, t) {
      return function (n, c) {
        var i;
        return null === c || isNaN(+c) || (C(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), i = n, n = c, c = i), Pc(this, Cc(n, c), e), this;
      };
    }
    function Pc(e, t, n, i) {
      var r = t._milliseconds,
        a = sc(t._days),
        o = sc(t._months);
      e.isValid() && (i = null == i || i, o && dt(e, Ke(e, "Month") + o * n), a && Qe(e, "Date", Ke(e, "Date") + a * n), r && e._d.setTime(e._d.valueOf() + r * n), i && c.updateOffset(e, a || o));
    }
    Cc.fn = ac.prototype, Cc.invalid = rc;
    var Tc = kc(1, "add"),
      Oc = kc(-1, "subtract");
    function Ac(e) {
      return "string" == typeof e || e instanceof String;
    }
    function Dc(e) {
      return x(e) || u(e) || Ac(e) || f(e) || jc(e) || Ic(e) || null == e;
    }
    function Ic(e) {
      var t,
        n,
        c = a(e) && !s(e),
        i = !1,
        r = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"],
        l = r.length;
      for (t = 0; t < l; t += 1) n = r[t], i = i || o(e, n);
      return c && i;
    }
    function jc(e) {
      var t = r(e),
        n = !1;
      return t && (n = 0 === e.filter(function (t) {
        return !f(t) && Ac(e);
      }).length), t && n;
    }
    function Fc(e) {
      var t,
        n,
        c = a(e) && !s(e),
        i = !1,
        r = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
      for (t = 0; t < r.length; t += 1) n = r[t], i = i || o(e, n);
      return c && i;
    }
    function Rc(e, t) {
      var n = e.diff(t, "days", !0);
      return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
    }
    function Bc(e, t) {
      1 === arguments.length && (arguments[0] ? Dc(arguments[0]) ? (e = arguments[0], t = void 0) : Fc(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
      var n = e || Xn(),
        i = pc(n, this).startOf("day"),
        r = c.calendarFormat(this, i) || "sameElse",
        a = t && (L(t[r]) ? t[r].call(this, n) : t[r]);
      return this.format(a || this.localeData().calendar(r, this, Xn(n)));
    }
    function Gc() {
      return new V(this);
    }
    function Yc(e, t) {
      var n = x(e) ? e : Xn(e);
      return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = ne(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
    }
    function Wc(e, t) {
      var n = x(e) ? e : Xn(e);
      return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = ne(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
    }
    function qc(e, t, n, c) {
      var i = x(e) ? e : Xn(e),
        r = x(t) ? t : Xn(t);
      return !!(this.isValid() && i.isValid() && r.isValid()) && ("(" === (c = c || "()")[0] ? this.isAfter(i, n) : !this.isBefore(i, n)) && (")" === c[1] ? this.isBefore(r, n) : !this.isAfter(r, n));
    }
    function Uc(e, t) {
      var n,
        c = x(e) ? e : Xn(e);
      return !(!this.isValid() || !c.isValid()) && ("millisecond" === (t = ne(t) || "millisecond") ? this.valueOf() === c.valueOf() : (n = c.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
    }
    function $c(e, t) {
      return this.isSame(e, t) || this.isAfter(e, t);
    }
    function Xc(e, t) {
      return this.isSame(e, t) || this.isBefore(e, t);
    }
    function Zc(e, t, n) {
      var c, i, r;
      if (!this.isValid()) return NaN;
      if (!(c = pc(e, this)).isValid()) return NaN;
      switch (i = 6e4 * (c.utcOffset() - this.utcOffset()), t = ne(t)) {
        case "year":
          r = Kc(this, c) / 12;
          break;
        case "month":
          r = Kc(this, c);
          break;
        case "quarter":
          r = Kc(this, c) / 3;
          break;
        case "second":
          r = (this - c) / 1e3;
          break;
        case "minute":
          r = (this - c) / 6e4;
          break;
        case "hour":
          r = (this - c) / 36e5;
          break;
        case "day":
          r = (this - c - i) / 864e5;
          break;
        case "week":
          r = (this - c - i) / 6048e5;
          break;
        default:
          r = this - c;
      }
      return n ? r : Ne(r);
    }
    function Kc(e, t) {
      if (e.date() < t.date()) return -Kc(t, e);
      var n = 12 * (t.year() - e.year()) + (t.month() - e.month()),
        c = e.clone().add(n, "months");
      return -(n + (t - c < 0 ? (t - c) / (c - e.clone().add(n - 1, "months")) : (t - c) / (e.clone().add(n + 1, "months") - c))) || 0;
    }
    function Qc() {
      return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function Jc(e) {
      if (!this.isValid()) return null;
      var t = !0 !== e,
        n = t ? this.clone().utc() : this;
      return n.year() < 0 || n.year() > 9999 ? G(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : L(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", G(n, "Z")) : G(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    function ei() {
      if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
      var e,
        t,
        n,
        c,
        i = "moment",
        r = "";
      return this.isLocal() || (i = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", r = "Z"), e = "[" + i + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", c = r + '[")]', this.format(e + t + n + c);
    }
    function ti(e) {
      e || (e = this.isUtc() ? c.defaultFormatUtc : c.defaultFormat);
      var t = G(this, e);
      return this.localeData().postformat(t);
    }
    function ni(e, t) {
      return this.isValid() && (x(e) && e.isValid() || Xn(e).isValid()) ? Cc({
        to: this,
        from: e
      }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
    }
    function ci(e) {
      return this.from(Xn(), e);
    }
    function ii(e, t) {
      return this.isValid() && (x(e) && e.isValid() || Xn(e).isValid()) ? Cc({
        from: this,
        to: e
      }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
    }
    function ri(e) {
      return this.to(Xn(), e);
    }
    function ai(e) {
      var t;
      return void 0 === e ? this._locale._abbr : (null != (t = bn(e)) && (this._locale = t), this);
    }
    c.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", c.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    var oi = _("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
      return void 0 === e ? this.localeData() : this.locale(e);
    });
    function si() {
      return this._locale;
    }
    var li = 1e3,
      fi = 60 * li,
      ui = 60 * fi,
      di = 3506328 * ui;
    function pi(e, t) {
      return (e % t + t) % t;
    }
    function mi(e, t, n) {
      return e < 100 && e >= 0 ? new Date(e + 400, t, n) - di : new Date(e, t, n).valueOf();
    }
    function hi(e, t, n) {
      return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - di : Date.UTC(e, t, n);
    }
    function vi(e) {
      var t, n;
      if (void 0 === (e = ne(e)) || "millisecond" === e || !this.isValid()) return this;
      switch (n = this._isUTC ? hi : mi, e) {
        case "year":
          t = n(this.year(), 0, 1);
          break;
        case "quarter":
          t = n(this.year(), this.month() - this.month() % 3, 1);
          break;
        case "month":
          t = n(this.year(), this.month(), 1);
          break;
        case "week":
          t = n(this.year(), this.month(), this.date() - this.weekday());
          break;
        case "isoWeek":
          t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case "day":
        case "date":
          t = n(this.year(), this.month(), this.date());
          break;
        case "hour":
          t = this._d.valueOf(), t -= pi(t + (this._isUTC ? 0 : this.utcOffset() * fi), ui);
          break;
        case "minute":
          t = this._d.valueOf(), t -= pi(t, fi);
          break;
        case "second":
          t = this._d.valueOf(), t -= pi(t, li);
      }
      return this._d.setTime(t), c.updateOffset(this, !0), this;
    }
    function gi(e) {
      var t, n;
      if (void 0 === (e = ne(e)) || "millisecond" === e || !this.isValid()) return this;
      switch (n = this._isUTC ? hi : mi, e) {
        case "year":
          t = n(this.year() + 1, 0, 1) - 1;
          break;
        case "quarter":
          t = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case "month":
          t = n(this.year(), this.month() + 1, 1) - 1;
          break;
        case "week":
          t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case "isoWeek":
          t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case "day":
        case "date":
          t = n(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case "hour":
          t = this._d.valueOf(), t += ui - pi(t + (this._isUTC ? 0 : this.utcOffset() * fi), ui) - 1;
          break;
        case "minute":
          t = this._d.valueOf(), t += fi - pi(t, fi) - 1;
          break;
        case "second":
          t = this._d.valueOf(), t += li - pi(t, li) - 1;
      }
      return this._d.setTime(t), c.updateOffset(this, !0), this;
    }
    function bi() {
      return this._d.valueOf() - 6e4 * (this._offset || 0);
    }
    function Hi() {
      return Math.floor(this.valueOf() / 1e3);
    }
    function zi() {
      return new Date(this.valueOf());
    }
    function yi() {
      var e = this;
      return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
    }
    function Vi() {
      var e = this;
      return {
        years: e.year(),
        months: e.month(),
        date: e.date(),
        hours: e.hours(),
        minutes: e.minutes(),
        seconds: e.seconds(),
        milliseconds: e.milliseconds()
      };
    }
    function xi() {
      return this.isValid() ? this.toISOString() : null;
    }
    function Mi() {
      return g(this);
    }
    function _i() {
      return p({}, v(this));
    }
    function wi() {
      return v(this).overflow;
    }
    function Ei() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    function Ci(e, t) {
      var n,
        i,
        r,
        a = this._eras || bn("en")._eras;
      for (n = 0, i = a.length; n < i; ++n) switch ("string" == typeof a[n].since && (r = c(a[n].since).startOf("day"), a[n].since = r.valueOf()), typeof a[n].until) {
        case "undefined":
          a[n].until = 1 / 0;
          break;
        case "string":
          r = c(a[n].until).startOf("day").valueOf(), a[n].until = r.valueOf();
      }
      return a;
    }
    function Li(e, t, n) {
      var c,
        i,
        r,
        a,
        o,
        s = this.eras();
      for (e = e.toUpperCase(), c = 0, i = s.length; c < i; ++c) if (r = s[c].name.toUpperCase(), a = s[c].abbr.toUpperCase(), o = s[c].narrow.toUpperCase(), n) switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (a === e) return s[c];
          break;
        case "NNNN":
          if (r === e) return s[c];
          break;
        case "NNNNN":
          if (o === e) return s[c];
      } else if ([r, a, o].indexOf(e) >= 0) return s[c];
    }
    function Ni(e, t) {
      var n = e.since <= e.until ? 1 : -1;
      return void 0 === t ? c(e.since).year() : c(e.since).year() + (t - e.offset) * n;
    }
    function Si() {
      var e,
        t,
        n,
        c = this.localeData().eras();
      for (e = 0, t = c.length; e < t; ++e) {
        if (n = this.clone().startOf("day").valueOf(), c[e].since <= n && n <= c[e].until) return c[e].name;
        if (c[e].until <= n && n <= c[e].since) return c[e].name;
      }
      return "";
    }
    function ki() {
      var e,
        t,
        n,
        c = this.localeData().eras();
      for (e = 0, t = c.length; e < t; ++e) {
        if (n = this.clone().startOf("day").valueOf(), c[e].since <= n && n <= c[e].until) return c[e].narrow;
        if (c[e].until <= n && n <= c[e].since) return c[e].narrow;
      }
      return "";
    }
    function Pi() {
      var e,
        t,
        n,
        c = this.localeData().eras();
      for (e = 0, t = c.length; e < t; ++e) {
        if (n = this.clone().startOf("day").valueOf(), c[e].since <= n && n <= c[e].until) return c[e].abbr;
        if (c[e].until <= n && n <= c[e].since) return c[e].abbr;
      }
      return "";
    }
    function Ti() {
      var e,
        t,
        n,
        i,
        r = this.localeData().eras();
      for (e = 0, t = r.length; e < t; ++e) if (n = r[e].since <= r[e].until ? 1 : -1, i = this.clone().startOf("day").valueOf(), r[e].since <= i && i <= r[e].until || r[e].until <= i && i <= r[e].since) return (this.year() - c(r[e].since).year()) * n + r[e].offset;
      return this.year();
    }
    function Oi(e) {
      return o(this, "_erasNameRegex") || Bi.call(this), e ? this._erasNameRegex : this._erasRegex;
    }
    function Ai(e) {
      return o(this, "_erasAbbrRegex") || Bi.call(this), e ? this._erasAbbrRegex : this._erasRegex;
    }
    function Di(e) {
      return o(this, "_erasNarrowRegex") || Bi.call(this), e ? this._erasNarrowRegex : this._erasRegex;
    }
    function Ii(e, t) {
      return t.erasAbbrRegex(e);
    }
    function ji(e, t) {
      return t.erasNameRegex(e);
    }
    function Fi(e, t) {
      return t.erasNarrowRegex(e);
    }
    function Ri(e, t) {
      return t._eraYearOrdinalRegex || be;
    }
    function Bi() {
      var e,
        t,
        n,
        c,
        i,
        r = [],
        a = [],
        o = [],
        s = [],
        l = this.eras();
      for (e = 0, t = l.length; e < t; ++e) n = Le(l[e].name), c = Le(l[e].abbr), i = Le(l[e].narrow), a.push(n), r.push(c), o.push(i), s.push(n), s.push(c), s.push(i);
      this._erasRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + o.join("|") + ")", "i");
    }
    function Gi(e, t) {
      F(0, [e, e.length], 0, t);
    }
    function Yi(e) {
      return Zi.call(this, e, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function Wi(e) {
      return Zi.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function qi() {
      return xt(this.year(), 1, 4);
    }
    function Ui() {
      return xt(this.isoWeekYear(), 1, 4);
    }
    function $i() {
      var e = this.localeData()._week;
      return xt(this.year(), e.dow, e.doy);
    }
    function Xi() {
      var e = this.localeData()._week;
      return xt(this.weekYear(), e.dow, e.doy);
    }
    function Zi(e, t, n, c, i) {
      var r;
      return null == e ? Vt(this, c, i).year : (t > (r = xt(e, c, i)) && (t = r), Ki.call(this, e, t, n, c, i));
    }
    function Ki(e, t, n, c, i) {
      var r = yt(e, t, n, c, i),
        a = Ht(r.year, 0, r.dayOfYear);
      return this.year(a.getUTCFullYear()), this.month(a.getUTCMonth()), this.date(a.getUTCDate()), this;
    }
    function Qi(e) {
      return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
    }
    F("N", 0, 0, "eraAbbr"), F("NN", 0, 0, "eraAbbr"), F("NNN", 0, 0, "eraAbbr"), F("NNNN", 0, 0, "eraName"), F("NNNNN", 0, 0, "eraNarrow"), F("y", ["y", 1], "yo", "eraYear"), F("y", ["yy", 2], 0, "eraYear"), F("y", ["yyy", 3], 0, "eraYear"), F("y", ["yyyy", 4], 0, "eraYear"), we("N", Ii), we("NN", Ii), we("NNN", Ii), we("NNNN", ji), we("NNNNN", Fi), Pe(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, t, n, c) {
      var i = n._locale.erasParse(e, c, n._strict);
      i ? v(n).era = i : v(n).invalidEra = e;
    }), we("y", be), we("yy", be), we("yyy", be), we("yyyy", be), we("yo", Ri), Pe(["y", "yy", "yyy", "yyyy"], De), Pe(["yo"], function (e, t, n, c) {
      var i;
      n._locale._eraYearOrdinalRegex && (i = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[De] = n._locale.eraYearOrdinalParse(e, i) : t[De] = parseInt(e, 10);
    }), F(0, ["gg", 2], 0, function () {
      return this.weekYear() % 100;
    }), F(0, ["GG", 2], 0, function () {
      return this.isoWeekYear() % 100;
    }), Gi("gggg", "weekYear"), Gi("ggggg", "weekYear"), Gi("GGGG", "isoWeekYear"), Gi("GGGGG", "isoWeekYear"), we("G", He), we("g", He), we("GG", de, se), we("gg", de, se), we("GGGG", ve, fe), we("gggg", ve, fe), we("GGGGG", ge, ue), we("ggggg", ge, ue), Te(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, c) {
      t[c.substr(0, 2)] = Se(e);
    }), Te(["gg", "GG"], function (e, t, n, i) {
      t[i] = c.parseTwoDigitYear(e);
    }), F("Q", 0, "Qo", "quarter"), we("Q", oe), Pe("Q", function (e, t) {
      t[Ie] = 3 * (Se(e) - 1);
    }), F("D", ["DD", 2], "Do", "date"), we("D", de, Me), we("DD", de, se), we("Do", function (e, t) {
      return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
    }), Pe(["D", "DD"], je), Pe("Do", function (e, t) {
      t[je] = Se(e.match(de)[0]);
    });
    var Ji = Ze("Date", !0);
    function er(e) {
      var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
      return null == e ? t : this.add(e - t, "d");
    }
    F("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), we("DDD", he), we("DDDD", le), Pe(["DDD", "DDDD"], function (e, t, n) {
      n._dayOfYear = Se(e);
    }), F("m", ["mm", 2], 0, "minute"), we("m", de, _e), we("mm", de, se), Pe(["m", "mm"], Re);
    var tr = Ze("Minutes", !1);
    F("s", ["ss", 2], 0, "second"), we("s", de, _e), we("ss", de, se), Pe(["s", "ss"], Be);
    var nr,
      cr,
      ir = Ze("Seconds", !1);
    for (F("S", 0, 0, function () {
      return ~~(this.millisecond() / 100);
    }), F(0, ["SS", 2], 0, function () {
      return ~~(this.millisecond() / 10);
    }), F(0, ["SSS", 3], 0, "millisecond"), F(0, ["SSSS", 4], 0, function () {
      return 10 * this.millisecond();
    }), F(0, ["SSSSS", 5], 0, function () {
      return 100 * this.millisecond();
    }), F(0, ["SSSSSS", 6], 0, function () {
      return 1e3 * this.millisecond();
    }), F(0, ["SSSSSSS", 7], 0, function () {
      return 1e4 * this.millisecond();
    }), F(0, ["SSSSSSSS", 8], 0, function () {
      return 1e5 * this.millisecond();
    }), F(0, ["SSSSSSSSS", 9], 0, function () {
      return 1e6 * this.millisecond();
    }), we("S", he, oe), we("SS", he, se), we("SSS", he, le), nr = "SSSS"; nr.length <= 9; nr += "S") we(nr, be);
    function rr(e, t) {
      t[Ge] = Se(1e3 * ("0." + e));
    }
    for (nr = "S"; nr.length <= 9; nr += "S") Pe(nr, rr);
    function ar() {
      return this._isUTC ? "UTC" : "";
    }
    function or() {
      return this._isUTC ? "Coordinated Universal Time" : "";
    }
    cr = Ze("Milliseconds", !1), F("z", 0, 0, "zoneAbbr"), F("zz", 0, 0, "zoneName");
    var sr = V.prototype;
    function lr(e) {
      return Xn(1e3 * e);
    }
    function fr() {
      return Xn.apply(null, arguments).parseZone();
    }
    function ur(e) {
      return e;
    }
    sr.add = Tc, sr.calendar = Bc, sr.clone = Gc, sr.diff = Zc, sr.endOf = gi, sr.format = ti, sr.from = ni, sr.fromNow = ci, sr.to = ii, sr.toNow = ri, sr.get = Je, sr.invalidAt = wi, sr.isAfter = Yc, sr.isBefore = Wc, sr.isBetween = qc, sr.isSame = Uc, sr.isSameOrAfter = $c, sr.isSameOrBefore = Xc, sr.isValid = Mi, sr.lang = oi, sr.locale = ai, sr.localeData = si, sr.max = Kn, sr.min = Zn, sr.parsingFlags = _i, sr.set = et, sr.startOf = vi, sr.subtract = Oc, sr.toArray = yi, sr.toObject = Vi, sr.toDate = zi, sr.toISOString = Jc, sr.inspect = ei, "undefined" != typeof Symbol && null != Symbol.for && (sr[Symbol.for("nodejs.util.inspect.custom")] = function () {
      return "Moment<" + this.format() + ">";
    }), sr.toJSON = xi, sr.toString = Qc, sr.unix = Hi, sr.valueOf = bi, sr.creationData = Ei, sr.eraName = Si, sr.eraNarrow = ki, sr.eraAbbr = Pi, sr.eraYear = Ti, sr.year = $e, sr.isLeapYear = Xe, sr.weekYear = Yi, sr.isoWeekYear = Wi, sr.quarter = sr.quarters = Qi, sr.month = pt, sr.daysInMonth = mt, sr.week = sr.weeks = Ct, sr.isoWeek = sr.isoWeeks = Lt, sr.weeksInYear = $i, sr.weeksInWeekYear = Xi, sr.isoWeeksInYear = qi, sr.isoWeeksInISOWeekYear = Ui, sr.date = Ji, sr.day = sr.days = Yt, sr.weekday = Wt, sr.isoWeekday = qt, sr.dayOfYear = er, sr.hour = sr.hours = cn, sr.minute = sr.minutes = tr, sr.second = sr.seconds = ir, sr.millisecond = sr.milliseconds = cr, sr.utcOffset = hc, sr.utc = gc, sr.local = bc, sr.parseZone = Hc, sr.hasAlignedHourOffset = zc, sr.isDST = yc, sr.isLocal = xc, sr.isUtcOffset = Mc, sr.isUtc = _c, sr.isUTC = _c, sr.zoneAbbr = ar, sr.zoneName = or, sr.dates = _("dates accessor is deprecated. Use date instead.", Ji), sr.months = _("months accessor is deprecated. Use month instead", pt), sr.years = _("years accessor is deprecated. Use year instead", $e), sr.zone = _("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", vc), sr.isDSTShifted = _("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", Vc);
    var dr = k.prototype;
    function pr(e, t, n, c) {
      var i = bn(),
        r = m().set(c, t);
      return i[n](r, e);
    }
    function mr(e, t, n) {
      if (f(e) && (t = e, e = void 0), e = e || "", null != t) return pr(e, t, n, "month");
      var c,
        i = [];
      for (c = 0; c < 12; c++) i[c] = pr(e, c, n, "month");
      return i;
    }
    function hr(e, t, n, c) {
      "boolean" == typeof e ? (f(t) && (n = t, t = void 0), t = t || "") : (n = t = e, e = !1, f(t) && (n = t, t = void 0), t = t || "");
      var i,
        r = bn(),
        a = e ? r._week.dow : 0,
        o = [];
      if (null != n) return pr(t, (n + a) % 7, c, "day");
      for (i = 0; i < 7; i++) o[i] = pr(t, (i + a) % 7, c, "day");
      return o;
    }
    function vr(e, t) {
      return mr(e, t, "months");
    }
    function gr(e, t) {
      return mr(e, t, "monthsShort");
    }
    function br(e, t, n) {
      return hr(e, t, n, "weekdays");
    }
    function Hr(e, t, n) {
      return hr(e, t, n, "weekdaysShort");
    }
    function zr(e, t, n) {
      return hr(e, t, n, "weekdaysMin");
    }
    dr.calendar = T, dr.longDateFormat = q, dr.invalidDate = $, dr.ordinal = K, dr.preparse = ur, dr.postformat = ur, dr.relativeTime = J, dr.pastFuture = ee, dr.set = N, dr.eras = Ci, dr.erasParse = Li, dr.erasConvertYear = Ni, dr.erasAbbrRegex = Ai, dr.erasNameRegex = Oi, dr.erasNarrowRegex = Di, dr.months = st, dr.monthsShort = lt, dr.monthsParse = ut, dr.monthsRegex = vt, dr.monthsShortRegex = ht, dr.week = Mt, dr.firstDayOfYear = Et, dr.firstDayOfWeek = wt, dr.weekdays = jt, dr.weekdaysMin = Rt, dr.weekdaysShort = Ft, dr.weekdaysParse = Gt, dr.weekdaysRegex = Ut, dr.weekdaysShortRegex = $t, dr.weekdaysMinRegex = Xt, dr.isPM = tn, dr.meridiem = rn, hn("en", {
      eras: [{
        since: "0001-01-01",
        until: 1 / 0,
        offset: 1,
        name: "Anno Domini",
        narrow: "AD",
        abbr: "AD"
      }, {
        since: "0000-12-31",
        until: -1 / 0,
        offset: 1,
        name: "Before Christ",
        narrow: "BC",
        abbr: "BC"
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 === Se(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      }
    }), c.lang = _("moment.lang is deprecated. Use moment.locale instead.", hn), c.langData = _("moment.langData is deprecated. Use moment.localeData instead.", bn);
    var yr = Math.abs;
    function Vr() {
      var e = this._data;
      return this._milliseconds = yr(this._milliseconds), this._days = yr(this._days), this._months = yr(this._months), e.milliseconds = yr(e.milliseconds), e.seconds = yr(e.seconds), e.minutes = yr(e.minutes), e.hours = yr(e.hours), e.months = yr(e.months), e.years = yr(e.years), this;
    }
    function xr(e, t, n, c) {
      var i = Cc(t, n);
      return e._milliseconds += c * i._milliseconds, e._days += c * i._days, e._months += c * i._months, e._bubble();
    }
    function Mr(e, t) {
      return xr(this, e, t, 1);
    }
    function _r(e, t) {
      return xr(this, e, t, -1);
    }
    function wr(e) {
      return e < 0 ? Math.floor(e) : Math.ceil(e);
    }
    function Er() {
      var e,
        t,
        n,
        c,
        i,
        r = this._milliseconds,
        a = this._days,
        o = this._months,
        s = this._data;
      return r >= 0 && a >= 0 && o >= 0 || r <= 0 && a <= 0 && o <= 0 || (r += 864e5 * wr(Lr(o) + a), a = 0, o = 0), s.milliseconds = r % 1e3, e = Ne(r / 1e3), s.seconds = e % 60, t = Ne(e / 60), s.minutes = t % 60, n = Ne(t / 60), s.hours = n % 24, a += Ne(n / 24), o += i = Ne(Cr(a)), a -= wr(Lr(i)), c = Ne(o / 12), o %= 12, s.days = a, s.months = o, s.years = c, this;
    }
    function Cr(e) {
      return 4800 * e / 146097;
    }
    function Lr(e) {
      return 146097 * e / 4800;
    }
    function Nr(e) {
      if (!this.isValid()) return NaN;
      var t,
        n,
        c = this._milliseconds;
      if ("month" === (e = ne(e)) || "quarter" === e || "year" === e) switch (t = this._days + c / 864e5, n = this._months + Cr(t), e) {
        case "month":
          return n;
        case "quarter":
          return n / 3;
        case "year":
          return n / 12;
      } else switch (t = this._days + Math.round(Lr(this._months)), e) {
        case "week":
          return t / 7 + c / 6048e5;
        case "day":
          return t + c / 864e5;
        case "hour":
          return 24 * t + c / 36e5;
        case "minute":
          return 1440 * t + c / 6e4;
        case "second":
          return 86400 * t + c / 1e3;
        case "millisecond":
          return Math.floor(864e5 * t) + c;
        default:
          throw new Error("Unknown unit " + e);
      }
    }
    function Sr(e) {
      return function () {
        return this.as(e);
      };
    }
    var kr = Sr("ms"),
      Pr = Sr("s"),
      Tr = Sr("m"),
      Or = Sr("h"),
      Ar = Sr("d"),
      Dr = Sr("w"),
      Ir = Sr("M"),
      jr = Sr("Q"),
      Fr = Sr("y"),
      Rr = kr;
    function Br() {
      return Cc(this);
    }
    function Gr(e) {
      return e = ne(e), this.isValid() ? this[e + "s"]() : NaN;
    }
    function Yr(e) {
      return function () {
        return this.isValid() ? this._data[e] : NaN;
      };
    }
    var Wr = Yr("milliseconds"),
      qr = Yr("seconds"),
      Ur = Yr("minutes"),
      $r = Yr("hours"),
      Xr = Yr("days"),
      Zr = Yr("months"),
      Kr = Yr("years");
    function Qr() {
      return Ne(this.days() / 7);
    }
    var Jr = Math.round,
      ea = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };
    function ta(e, t, n, c, i) {
      return i.relativeTime(t || 1, !!n, e, c);
    }
    function na(e, t, n, c) {
      var i = Cc(e).abs(),
        r = Jr(i.as("s")),
        a = Jr(i.as("m")),
        o = Jr(i.as("h")),
        s = Jr(i.as("d")),
        l = Jr(i.as("M")),
        f = Jr(i.as("w")),
        u = Jr(i.as("y")),
        d = r <= n.ss && ["s", r] || r < n.s && ["ss", r] || a <= 1 && ["m"] || a < n.m && ["mm", a] || o <= 1 && ["h"] || o < n.h && ["hh", o] || s <= 1 && ["d"] || s < n.d && ["dd", s];
      return null != n.w && (d = d || f <= 1 && ["w"] || f < n.w && ["ww", f]), (d = d || l <= 1 && ["M"] || l < n.M && ["MM", l] || u <= 1 && ["y"] || ["yy", u])[2] = t, d[3] = +e > 0, d[4] = c, ta.apply(null, d);
    }
    function ca(e) {
      return void 0 === e ? Jr : "function" == typeof e && (Jr = e, !0);
    }
    function ia(e, t) {
      return void 0 !== ea[e] && (void 0 === t ? ea[e] : (ea[e] = t, "s" === e && (ea.ss = t - 1), !0));
    }
    function ra(e, t) {
      if (!this.isValid()) return this.localeData().invalidDate();
      var n,
        c,
        i = !1,
        r = ea;
      return "object" == typeof e && (t = e, e = !1), "boolean" == typeof e && (i = e), "object" == typeof t && (r = Object.assign({}, ea, t), null != t.s && null == t.ss && (r.ss = t.s - 1)), c = na(this, !i, r, n = this.localeData()), i && (c = n.pastFuture(+this, c)), n.postformat(c);
    }
    var aa = Math.abs;
    function oa(e) {
      return (e > 0) - (e < 0) || +e;
    }
    function sa() {
      if (!this.isValid()) return this.localeData().invalidDate();
      var e,
        t,
        n,
        c,
        i,
        r,
        a,
        o,
        s = aa(this._milliseconds) / 1e3,
        l = aa(this._days),
        f = aa(this._months),
        u = this.asSeconds();
      return u ? (e = Ne(s / 60), t = Ne(e / 60), s %= 60, e %= 60, n = Ne(f / 12), f %= 12, c = s ? s.toFixed(3).replace(/\.?0+$/, "") : "", i = u < 0 ? "-" : "", r = oa(this._months) !== oa(u) ? "-" : "", a = oa(this._days) !== oa(u) ? "-" : "", o = oa(this._milliseconds) !== oa(u) ? "-" : "", i + "P" + (n ? r + n + "Y" : "") + (f ? r + f + "M" : "") + (l ? a + l + "D" : "") + (t || e || s ? "T" : "") + (t ? o + t + "H" : "") + (e ? o + e + "M" : "") + (s ? o + c + "S" : "")) : "P0D";
    }
    var la = ac.prototype;
    return la.isValid = ic, la.abs = Vr, la.add = Mr, la.subtract = _r, la.as = Nr, la.asMilliseconds = kr, la.asSeconds = Pr, la.asMinutes = Tr, la.asHours = Or, la.asDays = Ar, la.asWeeks = Dr, la.asMonths = Ir, la.asQuarters = jr, la.asYears = Fr, la.valueOf = Rr, la._bubble = Er, la.clone = Br, la.get = Gr, la.milliseconds = Wr, la.seconds = qr, la.minutes = Ur, la.hours = $r, la.days = Xr, la.weeks = Qr, la.months = Zr, la.years = Kr, la.humanize = ra, la.toISOString = sa, la.toString = sa, la.toJSON = sa, la.locale = ai, la.localeData = si, la.toIsoString = _("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", sa), la.lang = oi, F("X", 0, 0, "unix"), F("x", 0, 0, "valueOf"), we("x", He), we("X", Ve), Pe("X", function (e, t, n) {
      n._d = new Date(1e3 * parseFloat(e));
    }), Pe("x", function (e, t, n) {
      n._d = new Date(Se(e));
    }),
    //! moment.js
    c.version = "2.30.1", i(Xn), c.fn = sr, c.min = Jn, c.max = ec, c.now = tc, c.utc = m, c.unix = lr, c.months = vr, c.isDate = u, c.locale = hn, c.invalid = b, c.duration = Cc, c.isMoment = x, c.weekdays = br, c.parseZone = fr, c.localeData = bn, c.isDuration = oc, c.monthsShort = gr, c.weekdaysMin = zr, c.defineLocale = vn, c.updateLocale = gn, c.locales = Hn, c.weekdaysShort = Hr, c.normalizeUnits = ne, c.relativeTimeRounding = ca, c.relativeTimeThreshold = ia, c.calendarFormat = Rc, c.prototype = sr, c.HTML5_FMT = {
      DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
      DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
      DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
      DATE: "YYYY-MM-DD",
      TIME: "HH:mm",
      TIME_SECONDS: "HH:mm:ss",
      TIME_MS: "HH:mm:ss.SSS",
      WEEK: "GGGG-[W]WW",
      MONTH: "YYYY-MM"
    }, c;
  }();
}(mz);
var hz = mz.exports;
process.env.NODE_ENV;
var vz = gz() ? r : i;
"production" !== process.env.NODE_ENV && ("undefined" != typeof process ? process : {
  env: {
    NODE_ENV: "development"
  }
}).env;
function gz() {
  return !("undefined" == typeof window || !window.document || !window.document.createElement);
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
var bz = function (e) {
  var t,
    i = e.children,
    r = e.type,
    s = void 0 === r ? "reach-portal" : r,
    l = n(null),
    f = n(null),
    u = (t = c(Object.create(null))[1], a(function () {
      t(Object.create(null));
    }, []));
  return vz(function () {
    if (l.current) {
      var e = l.current.ownerDocument;
      return f.current = null == e ? void 0 : e.createElement(s), e.body.appendChild(f.current), u(), function () {
        f.current && f.current.ownerDocument && f.current.ownerDocument.body.removeChild(f.current);
      };
    }
  }, [s, u]), f.current ? /*#__PURE__*/h(i, f.current) : /*#__PURE__*/o("span", {
    ref: l
  });
};
"production" !== process.env.NODE_ENV && (bz.displayName = "Portal");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Hz,
  zz,
  yz = function () {
    return yz = Object.assign || function (e) {
      for (var t, n = 1, c = arguments.length; n < c; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      return e;
    }, yz.apply(this, arguments);
  };
function Vz(e, t) {
  var n = {};
  for (var c in e) Object.prototype.hasOwnProperty.call(e, c) && t.indexOf(c) < 0 && (n[c] = e[c]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;
    for (c = Object.getOwnPropertySymbols(e); i < c.length; i++) t.indexOf(c[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[i]) && (n[c[i]] = e[c[i]]);
  }
  return n;
}
function xz(e) {
  var t = "function" == typeof Symbol && Symbol.iterator,
    n = t && e[t],
    c = 0;
  if (n) return n.call(e);
  if (e && "number" == typeof e.length) return {
    next: function () {
      return e && c >= e.length && (e = void 0), {
        value: e && e[c++],
        done: !e
      };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Mz(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var c,
    i,
    r = n.call(e),
    a = [];
  try {
    for (; (void 0 === t || t-- > 0) && !(c = r.next()).done;) a.push(c.value);
  } catch (e) {
    i = {
      error: e
    };
  } finally {
    try {
      c && !c.done && (n = r.return) && n.call(r);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}
function _z(e, t, n) {
  if (n || 2 === arguments.length) for (var c, i = 0, r = t.length; i < r; i++) !c && i in t || (c || (c = Array.prototype.slice.call(t, 0, i)), c[i] = t[i]);
  return e.concat(c || Array.prototype.slice.call(t));
}
!function (e) {
  e.Start = "xstate.start", e.Stop = "xstate.stop", e.Raise = "xstate.raise", e.Send = "xstate.send", e.Cancel = "xstate.cancel", e.NullEvent = "", e.Assign = "xstate.assign", e.After = "xstate.after", e.DoneState = "done.state", e.DoneInvoke = "done.invoke", e.Log = "xstate.log", e.Init = "xstate.init", e.Invoke = "xstate.invoke", e.ErrorExecution = "error.execution", e.ErrorCommunication = "error.communication", e.ErrorPlatform = "error.platform", e.ErrorCustom = "xstate.error", e.Update = "xstate.update", e.Pure = "xstate.pure", e.Choose = "xstate.choose";
}(Hz || (Hz = {})), function (e) {
  e.Parent = "#_parent", e.Internal = "#_internal";
}(zz || (zz = {}));
var wz = Hz.Start,
  Ez = Hz.Stop,
  Cz = Hz.Raise,
  Lz = Hz.Send,
  Nz = Hz.Cancel,
  Sz = Hz.NullEvent,
  kz = Hz.Assign;
Hz.After, Hz.DoneState;
var Pz = Hz.Log,
  Tz = Hz.Init,
  Oz = Hz.Invoke;
Hz.ErrorExecution;
var Az,
  Dz = Hz.ErrorPlatform,
  Iz = Hz.ErrorCustom,
  jz = Hz.Update,
  Fz = Hz.Choose,
  Rz = Hz.Pure,
  Bz = {},
  Gz = "xstate.guard",
  Yz = "production" === process.env.NODE_ENV;
function Wz(e, t, n) {
  void 0 === n && (n = ".");
  var c = $z(e, n),
    i = $z(t, n);
  return fy(i) ? !!fy(c) && i === c : fy(c) ? c in i : Object.keys(c).every(function (e) {
    return e in i && Wz(c[e], i[e]);
  });
}
function qz(e) {
  try {
    return fy(e) || "number" == typeof e ? "".concat(e) : e.type;
  } catch (e) {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function Uz(e, t) {
  try {
    return sy(e) ? e : e.toString().split(t);
  } catch (t) {
    throw new Error("'".concat(e, "' is not a valid state path."));
  }
}
function $z(e, t) {
  return "object" == typeof (n = e) && "value" in n && "context" in n && "event" in n && "_event" in n ? e.value : sy(e) ? Xz(e) : "string" != typeof e ? e : Xz(Uz(e, t));
  var n;
}
function Xz(e) {
  if (1 === e.length) return e[0];
  for (var t = {}, n = t, c = 0; c < e.length - 1; c++) c === e.length - 2 ? n[e[c]] = e[c + 1] : (n[e[c]] = {}, n = n[e[c]]);
  return t;
}
function Zz(e, t) {
  for (var n = {}, c = Object.keys(e), i = 0; i < c.length; i++) {
    var r = c[i];
    n[r] = t(e[r], r, e, i);
  }
  return n;
}
function Kz(e, t, n) {
  var c,
    i,
    r = {};
  try {
    for (var a = xz(Object.keys(e)), o = a.next(); !o.done; o = a.next()) {
      var s = o.value,
        l = e[s];
      n(l) && (r[s] = t(l, s, e));
    }
  } catch (e) {
    c = {
      error: e
    };
  } finally {
    try {
      o && !o.done && (i = a.return) && i.call(a);
    } finally {
      if (c) throw c.error;
    }
  }
  return r;
}
var Qz = function (e) {
  return function (t) {
    var n,
      c,
      i = t;
    try {
      for (var r = xz(e), a = r.next(); !a.done; a = r.next()) {
        i = i[a.value];
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        a && !a.done && (c = r.return) && c.call(r);
      } finally {
        if (n) throw n.error;
      }
    }
    return i;
  };
};
function Jz(e) {
  return e ? fy(e) ? [[e]] : ey(Object.keys(e).map(function (t) {
    var n = e[t];
    return "string" == typeof n || n && Object.keys(n).length ? Jz(e[t]).map(function (e) {
      return [t].concat(e);
    }) : [[t]];
  })) : [[]];
}
function ey(e) {
  var t;
  return (t = []).concat.apply(t, _z([], Mz(e), !1));
}
function ty(e) {
  return sy(e) ? e : [e];
}
function ny(e) {
  return void 0 === e ? [] : ty(e);
}
function cy(e, t, n) {
  var c, i;
  if (ly(e)) return e(t, n.data);
  var r = {};
  try {
    for (var a = xz(Object.keys(e)), o = a.next(); !o.done; o = a.next()) {
      var s = o.value,
        l = e[s];
      ly(l) ? r[s] = l(t, n.data) : r[s] = l;
    }
  } catch (e) {
    c = {
      error: e
    };
  } finally {
    try {
      o && !o.done && (i = a.return) && i.call(a);
    } finally {
      if (c) throw c.error;
    }
  }
  return r;
}
function iy(e) {
  return e instanceof Promise || !(null === e || !ly(e) && "object" != typeof e || !ly(e.then));
}
function ry(e, t) {
  return Zz(e.states, function (e, n) {
    if (e) {
      var c = (fy(t) ? void 0 : t[n]) || (e ? e.current : void 0);
      if (c) return {
        current: c,
        states: ry(e, c)
      };
    }
  });
}
function ay(e, t, n, c) {
  Yz || oy(!!e, "Attempting to update undefined context");
  var i = e ? n.reduce(function (e, n) {
    var i,
      r,
      a = n.assignment,
      o = {
        state: c,
        action: n,
        _event: t
      },
      s = {};
    if (ly(a)) s = a(e, t.data, o);else try {
      for (var l = xz(Object.keys(a)), f = l.next(); !f.done; f = l.next()) {
        var u = f.value,
          d = a[u];
        s[u] = ly(d) ? d(e, t.data, o) : d;
      }
    } catch (e) {
      i = {
        error: e
      };
    } finally {
      try {
        f && !f.done && (r = l.return) && r.call(l);
      } finally {
        if (i) throw i.error;
      }
    }
    return Object.assign({}, e, s);
  }, e) : e;
  return i;
}
var oy = function () {};
function sy(e) {
  return Array.isArray(e);
}
function ly(e) {
  return "function" == typeof e;
}
function fy(e) {
  return "string" == typeof e;
}
function uy(e, t) {
  if (e) return fy(e) ? {
    type: Gz,
    name: e,
    predicate: t ? t[e] : void 0
  } : ly(e) ? {
    type: Gz,
    name: e.name,
    predicate: e
  } : e;
}
Yz || (oy = function (e, t) {
  var n = e instanceof Error ? e : void 0;
  if ((n || !e) && void 0 !== console) {
    var c = ["Warning: ".concat(t)];
    n && c.push(n), console.warn.apply(console, c);
  }
});
var dy = function () {
  return "function" == typeof Symbol && Symbol.observable || "@@observable";
}();
function py(e) {
  return !!e && "__xstatenode" in e;
}
function my(e, t) {
  return fy(e) || "number" == typeof e ? yz({
    type: e
  }, t) : e;
}
function hy(e, t) {
  if (!fy(e) && "$$type" in e && "scxml" === e.$$type) return e;
  var n = my(e);
  return yz({
    name: n.type,
    data: n,
    $$type: "scxml",
    type: "external"
  }, t);
}
function vy(e, t) {
  return ty(t).map(function (t) {
    return void 0 === t || "string" == typeof t || py(t) ? {
      target: t,
      event: e
    } : yz(yz({}, t), {
      event: e
    });
  });
}
function gy(e, t, n, c, i) {
  var r = e.options.guards,
    a = {
      state: i,
      cond: t,
      _event: c
    };
  if (t.type === Gz) return ((null == r ? void 0 : r[t.name]) || t.predicate)(n, c.data, a);
  var o = null == r ? void 0 : r[t.type];
  if (!o) throw new Error("Guard '".concat(t.type, "' is not implemented on machine '").concat(e.id, "'."));
  return o(n, c.data, a);
}
function by(e) {
  return "string" == typeof e ? {
    type: e
  } : e;
}
function Hy(e, t, n) {
  var c = function () {},
    i = "object" == typeof e,
    r = i ? e : null;
  return {
    next: ((i ? e.next : e) || c).bind(r),
    error: ((i ? e.error : t) || c).bind(r),
    complete: ((i ? e.complete : n) || c).bind(r)
  };
}
function zy(e, t) {
  return "".concat(e, ":invocation[").concat(t, "]");
}
function yy(e) {
  return (e.type === Cz || e.type === Lz && e.to === zz.Internal) && "number" != typeof e.delay;
}
(Az = {})[dy] = function () {
  return this;
}, Az[Symbol.observable] = function () {
  return this;
};
var Vy = hy({
  type: Tz
});
function xy(e, t) {
  return t && t[e] || void 0;
}
function My(e, t) {
  var n;
  if (fy(e) || "number" == typeof e) n = ly(c = xy(e, t)) ? {
    type: e,
    exec: c
  } : c || {
    type: e,
    exec: void 0
  };else if (ly(e)) n = {
    type: e.name || e.toString(),
    exec: e
  };else {
    var c;
    if (ly(c = xy(e.type, t))) n = yz(yz({}, e), {
      exec: c
    });else if (c) {
      var i = c.type || e.type;
      n = yz(yz(yz({}, c), e), {
        type: i
      });
    } else n = e;
  }
  return n;
}
var _y = function (e, t) {
  return e ? (sy(e) ? e : [e]).map(function (e) {
    return My(e, t);
  }) : [];
};
function wy(e) {
  var t = My(e);
  return yz(yz({
    id: fy(e) ? e : t.id
  }, t), {
    type: t.type
  });
}
function Ey(e, t) {
  var n = "".concat(Hz.DoneState, ".").concat(e),
    c = {
      type: n,
      data: t,
      toString: function () {
        return n;
      }
    };
  return c;
}
function Cy(e, t) {
  var n = "".concat(Hz.DoneInvoke, ".").concat(e),
    c = {
      type: n,
      data: t,
      toString: function () {
        return n;
      }
    };
  return c;
}
function Ly(e, t) {
  var n = "".concat(Hz.ErrorPlatform, ".").concat(e),
    c = {
      type: n,
      data: t,
      toString: function () {
        return n;
      }
    };
  return c;
}
function Ny(e, t, n, c, i, r, a) {
  void 0 === a && (a = !1);
  var o = a ? [] : function (e) {
      var t,
        n,
        c = [];
      try {
        for (var i = xz(e), r = i.next(); !r.done; r = i.next()) for (var a = r.value, o = 0; o < a.actions.length;) a.actions[o].type !== kz ? o++ : (c.push(a.actions[o]), a.actions.splice(o, 1));
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (n = i.return) && n.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return c;
    }(i),
    s = o.length ? ay(n, c, o, t) : n,
    l = a ? [n] : void 0,
    f = [];
  function u(i, o) {
    var u;
    switch (o.type) {
      case Cz:
        var d = function (e, t, n, c) {
          var i,
            r = {
              _event: n
            },
            a = hy(ly(e.event) ? e.event(t, n.data, r) : e.event);
          if (fy(e.delay)) {
            var o = c && c[e.delay];
            i = ly(o) ? o(t, n.data, r) : o;
          } else i = ly(e.delay) ? e.delay(t, n.data, r) : e.delay;
          return yz(yz({}, e), {
            type: Cz,
            _event: a,
            delay: i
          });
        }(o, s, c, e.options.delays);
        return r && "number" == typeof d.delay && r(d, s, c), d;
      case Lz:
        var p = function (e, t, n, c) {
          var i,
            r = {
              _event: n
            },
            a = hy(ly(e.event) ? e.event(t, n.data, r) : e.event);
          if (fy(e.delay)) {
            var o = c && c[e.delay];
            i = ly(o) ? o(t, n.data, r) : o;
          } else i = ly(e.delay) ? e.delay(t, n.data, r) : e.delay;
          var s = ly(e.to) ? e.to(t, n.data, r) : e.to;
          return yz(yz({}, e), {
            to: s,
            _event: a,
            event: a.data,
            delay: i
          });
        }(o, s, c, e.options.delays);
        if (!Yz) {
          var m = o.delay;
          oy(!fy(m) || "number" == typeof p.delay, "No delay reference for delay expression '".concat(m, "' was found on machine '").concat(e.id, "'"));
        }
        return r && p.to !== zz.Internal && ("entry" === i ? f.push(p) : r(p, s, c)), p;
      case Pz:
        var h = function (e, t, n) {
          return yz(yz({}, e), {
            value: fy(e.expr) ? e.expr : e.expr(t, n.data, {
              _event: n
            })
          });
        }(o, s, c);
        return null == r || r(h, s, c), h;
      case Fz:
        if (!(H = null === (u = o.conds.find(function (n) {
          var i = uy(n.cond, e.options.guards);
          return !i || gy(e, i, s, c, r ? void 0 : t);
        })) || void 0 === u ? void 0 : u.actions)) return [];
        var v = Mz(Ny(e, t, s, c, [{
            type: i,
            actions: _y(ny(H), e.options.actions)
          }], r, a), 2),
          g = v[0],
          b = v[1];
        return s = b, null == l || l.push(s), g;
      case Rz:
        var H;
        if (!(H = o.get(s, c.data))) return [];
        var z = Mz(Ny(e, t, s, c, [{
            type: i,
            actions: _y(ny(H), e.options.actions)
          }], r, a), 2),
          y = z[0],
          V = z[1];
        return s = V, null == l || l.push(s), y;
      case Ez:
        h = function (e, t, n) {
          var c = ly(e.activity) ? e.activity(t, n.data) : e.activity,
            i = "string" == typeof c ? {
              id: c
            } : c;
          return {
            type: Hz.Stop,
            activity: i
          };
        }(o, s, c);
        return null == r || r(h, n, c), h;
      case kz:
        s = ay(s, c, [o], r ? void 0 : t), null == l || l.push(s);
        break;
      default:
        var x = My(o, e.options.actions),
          M = x.exec;
        if (r) r(x, s, c);else if (M && l) {
          var _ = l.length - 1,
            w = yz(yz({}, x), {
              exec: function (e) {
                for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
                M.apply(void 0, _z([l[_]], Mz(t), !1));
              }
            });
          x = w;
        }
        return x;
    }
  }
  var d = ey(i.map(function (e) {
    var t,
      n,
      i = [];
    try {
      for (var a = xz(e.actions), o = a.next(); !o.done; o = a.next()) {
        var l = o.value,
          d = u(e.type, l);
        d && (i = i.concat(d));
      }
    } catch (e) {
      t = {
        error: e
      };
    } finally {
      try {
        o && !o.done && (n = a.return) && n.call(a);
      } finally {
        if (t) throw t.error;
      }
    }
    return f.forEach(function (e) {
      r(e, s, c);
    }), f.length = 0, i;
  }));
  return [d, s];
}
var Sy = function (e, t) {
  return t(e);
};
function ky(e) {
  var t;
  return (t = {
    id: e,
    send: function () {},
    subscribe: function () {
      return {
        unsubscribe: function () {}
      };
    },
    getSnapshot: function () {},
    toJSON: function () {
      return {
        id: e
      };
    }
  })[dy] = function () {
    return this;
  }, t;
}
function Py(e, t, n) {
  var c = ky(t);
  if (c.deferred = !0, py(e)) {
    var i = c.state = Sy(void 0, function () {
      return (n ? e.withContext(n) : e).initialState;
    });
    c.getSnapshot = function () {
      return i;
    };
  }
  return c;
}
var Ty = function (e) {
  return "atomic" === e.type || "final" === e.type;
};
function Oy(e) {
  return Object.keys(e.states).map(function (t) {
    return e.states[t];
  });
}
function Ay(e) {
  return Oy(e).filter(function (e) {
    return "history" !== e.type;
  });
}
function Dy(e) {
  var t = [e];
  return Ty(e) ? t : t.concat(ey(Ay(e).map(Dy)));
}
function Iy(e, t) {
  var n,
    c,
    i,
    r,
    a,
    o,
    s,
    l,
    f = Fy(new Set(e)),
    u = new Set(t);
  try {
    for (var d = xz(u), p = d.next(); !p.done; p = d.next()) for (var m = (x = p.value).parent; m && !u.has(m);) u.add(m), m = m.parent;
  } catch (e) {
    n = {
      error: e
    };
  } finally {
    try {
      p && !p.done && (c = d.return) && c.call(d);
    } finally {
      if (n) throw n.error;
    }
  }
  var h = Fy(u);
  try {
    for (var v = xz(u), g = v.next(); !g.done; g = v.next()) {
      if ("compound" !== (x = g.value).type || h.get(x) && h.get(x).length) {
        if ("parallel" === x.type) try {
          for (var b = (a = void 0, xz(Ay(x))), H = b.next(); !H.done; H = b.next()) {
            var z = H.value;
            u.has(z) || (u.add(z), f.get(z) ? f.get(z).forEach(function (e) {
              return u.add(e);
            }) : z.initialStateNodes.forEach(function (e) {
              return u.add(e);
            }));
          }
        } catch (e) {
          a = {
            error: e
          };
        } finally {
          try {
            H && !H.done && (o = b.return) && o.call(b);
          } finally {
            if (a) throw a.error;
          }
        }
      } else f.get(x) ? f.get(x).forEach(function (e) {
        return u.add(e);
      }) : x.initialStateNodes.forEach(function (e) {
        return u.add(e);
      });
    }
  } catch (e) {
    i = {
      error: e
    };
  } finally {
    try {
      g && !g.done && (r = v.return) && r.call(v);
    } finally {
      if (i) throw i.error;
    }
  }
  try {
    for (var y = xz(u), V = y.next(); !V.done; V = y.next()) {
      var x;
      for (m = (x = V.value).parent; m && !u.has(m);) u.add(m), m = m.parent;
    }
  } catch (e) {
    s = {
      error: e
    };
  } finally {
    try {
      V && !V.done && (l = y.return) && l.call(y);
    } finally {
      if (s) throw s.error;
    }
  }
  return u;
}
function jy(e, t) {
  var n = t.get(e);
  if (!n) return {};
  if ("compound" === e.type) {
    var c = n[0];
    if (!c) return {};
    if (Ty(c)) return c.key;
  }
  var i = {};
  return n.forEach(function (e) {
    i[e.key] = jy(e, t);
  }), i;
}
function Fy(e) {
  var t,
    n,
    c = new Map();
  try {
    for (var i = xz(e), r = i.next(); !r.done; r = i.next()) {
      var a = r.value;
      c.has(a) || c.set(a, []), a.parent && (c.has(a.parent) || c.set(a.parent, []), c.get(a.parent).push(a));
    }
  } catch (e) {
    t = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return c;
}
function Ry(e, t) {
  return jy(e, Fy(Iy([e], t)));
}
function By(e, t) {
  return Array.isArray(e) ? e.some(function (e) {
    return e === t;
  }) : e instanceof Set && e.has(t);
}
function Gy(e, t) {
  return "compound" === t.type ? Ay(t).some(function (t) {
    return "final" === t.type && By(e, t);
  }) : "parallel" === t.type && Ay(t).every(function (t) {
    return Gy(e, t);
  });
}
function Yy(e) {
  return new Set(ey(e.map(function (e) {
    return e.tags;
  })));
}
function Wy(e, t) {
  if (e === t) return !0;
  if (void 0 === e || void 0 === t) return !1;
  if (fy(e) || fy(t)) return e === t;
  var n = Object.keys(e),
    c = Object.keys(t);
  return n.length === c.length && n.every(function (n) {
    return Wy(e[n], t[n]);
  });
}
var qy = function () {
    function e(e) {
      var t,
        n,
        c = this;
      this.actions = [], this.activities = Bz, this.meta = {}, this.events = [], this.value = e.value, this.context = e.context, this._event = e._event, this._sessionid = e._sessionid, this.event = this._event.data, this.historyValue = e.historyValue, this.history = e.history, this.actions = e.actions || [], this.activities = e.activities || Bz, this.meta = (void 0 === (n = e.configuration) && (n = []), n.reduce(function (e, t) {
        return void 0 !== t.meta && (e[t.id] = t.meta), e;
      }, {})), this.events = e.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = e.configuration, this.transitions = e.transitions, this.children = e.children, this.done = !!e.done, this.tags = null !== (t = Array.isArray(e.tags) ? new Set(e.tags) : e.tags) && void 0 !== t ? t : new Set(), this.machine = e.machine, Object.defineProperty(this, "nextEvents", {
        get: function () {
          return function (e) {
            return _z([], Mz(new Set(ey(_z([], Mz(e.map(function (e) {
              return e.ownEvents;
            })), !1)))), !1);
          }(c.configuration);
        }
      });
    }
    return e.from = function (t, n) {
      return t instanceof e ? t.context !== n ? new e({
        value: t.value,
        context: n,
        _event: t._event,
        _sessionid: null,
        historyValue: t.historyValue,
        history: t.history,
        actions: [],
        activities: t.activities,
        meta: {},
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      }) : t : new e({
        value: t,
        context: n,
        _event: Vy,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        meta: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, e.create = function (t) {
      return new e(t);
    }, e.inert = function (t, n) {
      if (t instanceof e) {
        if (!t.actions.length) return t;
        var c = Vy;
        return new e({
          value: t.value,
          context: n,
          _event: c,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          activities: t.activities,
          configuration: t.configuration,
          transitions: [],
          children: {}
        });
      }
      return e.from(t, n);
    }, e.prototype.toStrings = function (e, t) {
      var n = this;
      if (void 0 === e && (e = this.value), void 0 === t && (t = "."), fy(e)) return [e];
      var c = Object.keys(e);
      return c.concat.apply(c, _z([], Mz(c.map(function (c) {
        return n.toStrings(e[c], t).map(function (e) {
          return c + t + e;
        });
      })), !1));
    }, e.prototype.toJSON = function () {
      var e = this;
      e.configuration, e.transitions;
      var t = e.tags;
      e.machine;
      var n = Vz(e, ["configuration", "transitions", "tags", "machine"]);
      return yz(yz({}, n), {
        tags: Array.from(t)
      });
    }, e.prototype.matches = function (e) {
      return Wz(e, this.value);
    }, e.prototype.hasTag = function (e) {
      return this.tags.has(e);
    }, e.prototype.can = function (e) {
      var t;
      Yz && oy(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
      var n = null === (t = this.machine) || void 0 === t ? void 0 : t.getTransitionData(this, e);
      return !!(null == n ? void 0 : n.transitions.length) && n.transitions.some(function (e) {
        return void 0 !== e.target || e.actions.length;
      });
    }, e;
  }(),
  Uy = {
    deferEvents: !1
  },
  $y = function () {
    function e(e) {
      this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = yz(yz({}, Uy), e);
    }
    return e.prototype.initialize = function (e) {
      if (this.initialized = !0, e) {
        if (!this.options.deferEvents) return void this.schedule(e);
        this.process(e);
      }
      this.flushEvents();
    }, e.prototype.schedule = function (e) {
      if (this.initialized && !this.processingEvent) {
        if (0 !== this.queue.length) throw new Error("Event queue should be empty when it is not processing events");
        this.process(e), this.flushEvents();
      } else this.queue.push(e);
    }, e.prototype.clear = function () {
      this.queue = [];
    }, e.prototype.flushEvents = function () {
      for (var e = this.queue.shift(); e;) this.process(e), e = this.queue.shift();
    }, e.prototype.process = function (e) {
      this.processingEvent = !0;
      try {
        e();
      } catch (e) {
        throw this.clear(), e;
      } finally {
        this.processingEvent = !1;
      }
    }, e;
  }(),
  Xy = new Map(),
  Zy = 0,
  Ky = function () {
    return "x:".concat(Zy++);
  },
  Qy = function (e, t) {
    return Xy.set(e, t), e;
  },
  Jy = function (e) {
    return Xy.get(e);
  },
  eV = function (e) {
    Xy.delete(e);
  };
function tV() {
  return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : void (Yz || console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues"));
}
function nV(e) {
  if (tV()) {
    var t = function () {
      var e = tV();
      if (e && "__xstate__" in e) return e.__xstate__;
    }();
    t && t.register(e);
  }
}
function cV(e, t) {
  void 0 === t && (t = {});
  var n = e.initialState,
    c = new Set(),
    i = [],
    r = !1,
    a = function (e) {
      var t;
      return yz(((t = {
        subscribe: function () {
          return {
            unsubscribe: function () {}
          };
        },
        id: "anonymous",
        getSnapshot: function () {}
      })[dy] = function () {
        return this;
      }, t), e);
    }({
      id: t.id,
      send: function (t) {
        i.push(t), function () {
          if (!r) {
            for (r = !0; i.length > 0;) {
              var t = i.shift();
              n = e.transition(n, t, o), c.forEach(function (e) {
                return e.next(n);
              });
            }
            r = !1;
          }
        }();
      },
      getSnapshot: function () {
        return n;
      },
      subscribe: function (e, t, i) {
        var r = Hy(e, t, i);
        return c.add(r), r.next(n), {
          unsubscribe: function () {
            c.delete(r);
          }
        };
      }
    }),
    o = {
      parent: t.parent,
      self: a,
      id: t.id || "anonymous",
      observers: c
    };
  return n = e.start ? e.start(o) : n, a;
}
var iV,
  rV = {
    sync: !1,
    autoForward: !1
  };
!function (e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
}(iV || (iV = {}));
var aV = function () {
  function e(t, n) {
    void 0 === n && (n = e.defaultOptions);
    var c = this;
    this.machine = t, this.delayedEventsMap = {}, this.listeners = new Set(), this.contextListeners = new Set(), this.stopListeners = new Set(), this.doneListeners = new Set(), this.eventListeners = new Set(), this.sendListeners = new Set(), this.initialized = !1, this.status = iV.NotStarted, this.children = new Map(), this.forwardTo = new Set(), this._outgoingQueue = [], this.init = this.start, this.send = function (e, t) {
      if (sy(e)) return c.batch(e), c.state;
      var n = hy(my(e, t));
      if (c.status === iV.Stopped) return Yz || oy(!1, 'Event "'.concat(n.name, '" was sent to stopped service "').concat(c.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(n.data))), c.state;
      if (c.status !== iV.Running && !c.options.deferEvents) throw new Error('Event "'.concat(n.name, '" was sent to uninitialized service "').concat(c.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(n.data)));
      return c.scheduler.schedule(function () {
        c.forward(n);
        var e = c._nextState(n);
        c.update(e, n);
      }), c._state;
    }, this.sendTo = function (e, t, n) {
      var i,
        r = c.parent && (t === zz.Parent || c.parent.id === t),
        a = r ? c.parent : fy(t) ? t === zz.Internal ? c : c.children.get(t) || Jy(t) : (i = t) && "function" == typeof i.send ? t : void 0;
      if (a) {
        if ("machine" in a) {
          if (c.status !== iV.Stopped || c.parent !== a || c.state.done) {
            var o = yz(yz({}, e), {
              name: e.name === Iz ? "".concat(Ly(c.id)) : e.name,
              origin: c.sessionId
            });
            !n && c.machine.config.predictableActionArguments ? c._outgoingQueue.push([a, o]) : a.send(o);
          }
        } else !n && c.machine.config.predictableActionArguments ? c._outgoingQueue.push([a, e.data]) : a.send(e.data);
      } else {
        if (!r) throw new Error("Unable to send event to child '".concat(t, "' from service '").concat(c.id, "'."));
        Yz || oy(!1, "Service '".concat(c.id, "' has no parent: unable to send event ").concat(e.type));
      }
    }, this._exec = function (e, t, n, i) {
      void 0 === i && (i = c.machine.options.actions);
      var r = e.exec || xy(e.type, i),
        a = ly(r) ? r : r ? r.exec : e.exec;
      if (a) try {
        return a(t, n.data, c.machine.config.predictableActionArguments ? {
          action: e,
          _event: n
        } : {
          action: e,
          state: c.state,
          _event: n
        });
      } catch (e) {
        throw c.parent && c.parent.send({
          type: "xstate.error",
          data: e
        }), e;
      }
      switch (e.type) {
        case Cz:
          var o = e;
          c.defer(o);
          break;
        case Lz:
          var s = e;
          if ("number" == typeof s.delay) return void c.defer(s);
          s.to ? c.sendTo(s._event, s.to, n === Vy) : c.send(s._event);
          break;
        case Nz:
          c.cancel(e.sendId);
          break;
        case wz:
          if (c.status !== iV.Running) return;
          var l = e.activity;
          if (!c.machine.config.predictableActionArguments && !c.state.activities[l.id || l.type]) break;
          if (l.type === Hz.Invoke) {
            var f = by(l.src),
              u = c.machine.options.services ? c.machine.options.services[f.type] : void 0,
              d = l.id,
              p = l.data;
            Yz || oy(!("forward" in l), "`forward` property is deprecated (found in invocation of '".concat(l.src, "' in in machine '").concat(c.machine.id, "'). ") + "Please use `autoForward` instead.");
            var m = "autoForward" in l ? l.autoForward : !!l.forward;
            if (!u) return void (Yz || oy(!1, "No service found for invocation '".concat(l.src, "' in machine '").concat(c.machine.id, "'.")));
            var h = p ? cy(p, t, n) : void 0;
            if ("string" == typeof u) return;
            var v = ly(u) ? u(t, n.data, {
              data: h,
              src: f,
              meta: l.meta
            }) : u;
            if (!v) return;
            var g = void 0;
            py(v) && (v = h ? v.withContext(h) : v, g = {
              autoForward: m
            }), c.spawn(v, d, g);
          } else c.spawnActivity(l);
          break;
        case Ez:
          c.stopChild(e.activity.id);
          break;
        case Pz:
          var b = e,
            H = b.label,
            z = b.value;
          H ? c.logger(H, z) : c.logger(z);
          break;
        default:
          Yz || oy(!1, "No implementation found for action type '".concat(e.type, "'"));
      }
    };
    var i = yz(yz({}, e.defaultOptions), n),
      r = i.clock,
      a = i.logger,
      o = i.parent,
      s = i.id,
      l = void 0 !== s ? s : t.id;
    this.id = l, this.logger = a, this.clock = r, this.parent = o, this.options = i, this.scheduler = new $y({
      deferEvents: this.options.deferEvents
    }), this.sessionId = Ky();
  }
  return Object.defineProperty(e.prototype, "initialState", {
    get: function () {
      var e = this;
      return this._initialState ? this._initialState : Sy(this, function () {
        return e._initialState = e.machine.initialState, e._initialState;
      });
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "state", {
    get: function () {
      return Yz || oy(this.status !== iV.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first.")), this._state;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.execute = function (e, t) {
    var n, c;
    try {
      for (var i = xz(e.actions), r = i.next(); !r.done; r = i.next()) {
        var a = r.value;
        this.exec(a, e, t);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (c = i.return) && c.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
  }, e.prototype.update = function (e, t) {
    var n,
      c,
      i,
      r,
      a,
      o,
      s,
      l,
      f = this;
    if (e._sessionid = this.sessionId, this._state = e, this.machine.config.predictableActionArguments && t !== Vy || !this.options.execute) for (var u = void 0; u = this._outgoingQueue.shift();) u[0].send(u[1]);else this.execute(this.state);
    if (this.children.forEach(function (e) {
      f.state.children[e.id] = e;
    }), this.devTools && this.devTools.send(t.data, e), e.event) try {
      for (var d = xz(this.eventListeners), p = d.next(); !p.done; p = d.next()) {
        (0, p.value)(e.event);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        p && !p.done && (c = d.return) && c.call(d);
      } finally {
        if (n) throw n.error;
      }
    }
    try {
      for (var m = xz(this.listeners), h = m.next(); !h.done; h = m.next()) {
        (0, h.value)(e, e.event);
      }
    } catch (e) {
      i = {
        error: e
      };
    } finally {
      try {
        h && !h.done && (r = m.return) && r.call(m);
      } finally {
        if (i) throw i.error;
      }
    }
    try {
      for (var v = xz(this.contextListeners), g = v.next(); !g.done; g = v.next()) {
        (0, g.value)(this.state.context, this.state.history ? this.state.history.context : void 0);
      }
    } catch (e) {
      a = {
        error: e
      };
    } finally {
      try {
        g && !g.done && (o = v.return) && o.call(v);
      } finally {
        if (a) throw a.error;
      }
    }
    if (this.state.done) {
      var b = e.configuration.find(function (e) {
          return "final" === e.type && e.parent === f.machine;
        }),
        H = b && b.doneData ? cy(b.doneData, e.context, t) : void 0;
      this._doneEvent = Cy(this.id, H);
      try {
        for (var z = xz(this.doneListeners), y = z.next(); !y.done; y = z.next()) {
          (0, y.value)(this._doneEvent);
        }
      } catch (e) {
        s = {
          error: e
        };
      } finally {
        try {
          y && !y.done && (l = z.return) && l.call(z);
        } finally {
          if (s) throw s.error;
        }
      }
      this._stop(), this._stopChildren(), eV(this.sessionId);
    }
  }, e.prototype.onTransition = function (e) {
    return this.listeners.add(e), this.status === iV.Running && e(this.state, this.state.event), this;
  }, e.prototype.subscribe = function (e, t, n) {
    var c = this,
      i = Hy(e, t, n);
    this.listeners.add(i.next), this.status !== iV.NotStarted && i.next(this.state);
    var r = function () {
      c.doneListeners.delete(r), c.stopListeners.delete(r), i.complete();
    };
    return this.status === iV.Stopped ? i.complete() : (this.onDone(r), this.onStop(r)), {
      unsubscribe: function () {
        c.listeners.delete(i.next), c.doneListeners.delete(r), c.stopListeners.delete(r);
      }
    };
  }, e.prototype.onEvent = function (e) {
    return this.eventListeners.add(e), this;
  }, e.prototype.onSend = function (e) {
    return this.sendListeners.add(e), this;
  }, e.prototype.onChange = function (e) {
    return this.contextListeners.add(e), this;
  }, e.prototype.onStop = function (e) {
    return this.stopListeners.add(e), this;
  }, e.prototype.onDone = function (e) {
    return this.status === iV.Stopped && this._doneEvent ? e(this._doneEvent) : this.doneListeners.add(e), this;
  }, e.prototype.off = function (e) {
    return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
  }, e.prototype.start = function (e) {
    var t = this;
    if (this.status === iV.Running) return this;
    this.machine._init(), Qy(this.sessionId, this), this.initialized = !0, this.status = iV.Running;
    var n = void 0 === e ? this.initialState : Sy(this, function () {
      return "object" == typeof (n = e) && null !== n && "value" in n && "_event" in n ? t.machine.resolveState(e) : t.machine.resolveState(qy.from(e, t.machine.context));
      var n;
    });
    return this.options.devTools && this.attachDev(), this.scheduler.initialize(function () {
      t.update(n, Vy);
    }), this;
  }, e.prototype._stopChildren = function () {
    this.children.forEach(function (e) {
      ly(e.stop) && e.stop();
    }), this.children.clear();
  }, e.prototype._stop = function () {
    var e, t, n, c, i, r, a, o, s, l;
    try {
      for (var f = xz(this.listeners), u = f.next(); !u.done; u = f.next()) {
        var d = u.value;
        this.listeners.delete(d);
      }
    } catch (t) {
      e = {
        error: t
      };
    } finally {
      try {
        u && !u.done && (t = f.return) && t.call(f);
      } finally {
        if (e) throw e.error;
      }
    }
    try {
      for (var p = xz(this.stopListeners), m = p.next(); !m.done; m = p.next()) {
        (d = m.value)(), this.stopListeners.delete(d);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        m && !m.done && (c = p.return) && c.call(p);
      } finally {
        if (n) throw n.error;
      }
    }
    try {
      for (var h = xz(this.contextListeners), v = h.next(); !v.done; v = h.next()) {
        d = v.value;
        this.contextListeners.delete(d);
      }
    } catch (e) {
      i = {
        error: e
      };
    } finally {
      try {
        v && !v.done && (r = h.return) && r.call(h);
      } finally {
        if (i) throw i.error;
      }
    }
    try {
      for (var g = xz(this.doneListeners), b = g.next(); !b.done; b = g.next()) {
        d = b.value;
        this.doneListeners.delete(d);
      }
    } catch (e) {
      a = {
        error: e
      };
    } finally {
      try {
        b && !b.done && (o = g.return) && o.call(g);
      } finally {
        if (a) throw a.error;
      }
    }
    if (!this.initialized) return this;
    this.initialized = !1, this.status = iV.Stopped, this._initialState = void 0;
    try {
      for (var H = xz(Object.keys(this.delayedEventsMap)), z = H.next(); !z.done; z = H.next()) {
        var y = z.value;
        this.clock.clearTimeout(this.delayedEventsMap[y]);
      }
    } catch (e) {
      s = {
        error: e
      };
    } finally {
      try {
        z && !z.done && (l = H.return) && l.call(H);
      } finally {
        if (s) throw s.error;
      }
    }
    this.scheduler.clear(), this.scheduler = new $y({
      deferEvents: this.options.deferEvents
    });
  }, e.prototype.stop = function () {
    var e = this,
      t = this.scheduler;
    return this._stop(), t.schedule(function () {
      var t;
      if (!(null === (t = e._state) || void 0 === t ? void 0 : t.done)) {
        var n = hy({
            type: "xstate.stop"
          }),
          c = Sy(e, function () {
            var t = ey(_z([], Mz(e.state.configuration), !1).sort(function (e, t) {
                return t.order - e.order;
              }).map(function (t) {
                return _y(t.onExit, e.machine.options.actions);
              })),
              c = Mz(Ny(e.machine, e.state, e.state.context, n, [{
                type: "exit",
                actions: t
              }], e.machine.config.predictableActionArguments ? e._exec : void 0, e.machine.config.predictableActionArguments || e.machine.config.preserveActionOrder), 2),
              i = c[0],
              r = c[1],
              a = new qy({
                value: e.state.value,
                context: r,
                _event: n,
                _sessionid: e.sessionId,
                historyValue: void 0,
                history: e.state,
                actions: i.filter(function (e) {
                  return !yy(e);
                }),
                activities: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {},
                done: e.state.done,
                tags: e.state.tags,
                machine: e.machine
              });
            return a.changed = !0, a;
          });
        e.update(c, n), e._stopChildren(), eV(e.sessionId);
      }
    }), this;
  }, e.prototype.batch = function (e) {
    var t = this;
    if (this.status === iV.NotStarted && this.options.deferEvents) Yz || oy(!1, "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));else if (this.status !== iV.Running) throw new Error("".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
    if (e.length) {
      var n = !!this.machine.config.predictableActionArguments && this._exec;
      this.scheduler.schedule(function () {
        var c,
          i,
          r = t.state,
          a = !1,
          o = [],
          s = function (e) {
            var c = hy(e);
            t.forward(c), r = Sy(t, function () {
              return t.machine.transition(r, c, void 0, n || void 0);
            }), o.push.apply(o, _z([], Mz(t.machine.config.predictableActionArguments ? r.actions : r.actions.map(function (e) {
              return function (e, t) {
                var n = e.exec;
                return yz(yz({}, e), {
                  exec: void 0 !== n ? function () {
                    return n(t.context, t.event, {
                      action: e,
                      state: t,
                      _event: t._event
                    });
                  } : void 0
                });
              }(e, r);
            })), !1)), a = a || !!r.changed;
          };
        try {
          for (var l = xz(e), f = l.next(); !f.done; f = l.next()) {
            s(f.value);
          }
        } catch (e) {
          c = {
            error: e
          };
        } finally {
          try {
            f && !f.done && (i = l.return) && i.call(l);
          } finally {
            if (c) throw c.error;
          }
        }
        r.changed = a, r.actions = o, t.update(r, hy(e[e.length - 1]));
      });
    }
  }, e.prototype.sender = function (e) {
    return this.send.bind(this, e);
  }, e.prototype._nextState = function (e, t) {
    var n = this;
    void 0 === t && (t = !!this.machine.config.predictableActionArguments && this._exec);
    var c = hy(e);
    if (0 === c.name.indexOf(Dz) && !this.state.nextEvents.some(function (e) {
      return 0 === e.indexOf(Dz);
    })) throw c.data.data;
    return Sy(this, function () {
      return n.machine.transition(n.state, c, void 0, t || void 0);
    });
  }, e.prototype.nextState = function (e) {
    return this._nextState(e, !1);
  }, e.prototype.forward = function (e) {
    var t, n;
    try {
      for (var c = xz(this.forwardTo), i = c.next(); !i.done; i = c.next()) {
        var r = i.value,
          a = this.children.get(r);
        if (!a) throw new Error("Unable to forward event '".concat(e, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(r, "'."));
        a.send(e);
      }
    } catch (e) {
      t = {
        error: e
      };
    } finally {
      try {
        i && !i.done && (n = c.return) && n.call(c);
      } finally {
        if (t) throw t.error;
      }
    }
  }, e.prototype.defer = function (e) {
    var t = this,
      n = this.clock.setTimeout(function () {
        "to" in e && e.to ? t.sendTo(e._event, e.to, !0) : t.send(e._event);
      }, e.delay);
    e.id && (this.delayedEventsMap[e.id] = n);
  }, e.prototype.cancel = function (e) {
    this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
  }, e.prototype.exec = function (e, t, n) {
    void 0 === n && (n = this.machine.options.actions), this._exec(e, t.context, t._event, n);
  }, e.prototype.removeChild = function (e) {
    var t;
    this.children.delete(e), this.forwardTo.delete(e), null === (t = this.state) || void 0 === t || delete t.children[e];
  }, e.prototype.stopChild = function (e) {
    var t = this.children.get(e);
    t && (this.removeChild(e), ly(t.stop) && t.stop());
  }, e.prototype.spawn = function (e, t, n) {
    if (this.status !== iV.Running) return Py(e, t);
    if (iy(e)) return this.spawnPromise(Promise.resolve(e), t);
    if (ly(e)) return this.spawnCallback(e, t);
    if (function (e) {
      try {
        return "function" == typeof e.send;
      } catch (e) {
        return !1;
      }
    }(i = e) && "id" in i) return this.spawnActor(e, t);
    if (function (e) {
      try {
        return "subscribe" in e && ly(e.subscribe);
      } catch (e) {
        return !1;
      }
    }(e)) return this.spawnObservable(e, t);
    if (py(e)) return this.spawnMachine(e, yz(yz({}, n), {
      id: t
    }));
    if (null !== (c = e) && "object" == typeof c && "transition" in c && "function" == typeof c.transition) return this.spawnBehavior(e, t);
    throw new Error('Unable to spawn entity "'.concat(t, '" of type "').concat(typeof e, '".'));
    var c, i;
  }, e.prototype.spawnMachine = function (t, n) {
    var c = this;
    void 0 === n && (n = {});
    var i = new e(t, yz(yz({}, this.options), {
        parent: this,
        id: n.id || t.id
      })),
      r = yz(yz({}, rV), n);
    r.sync && i.onTransition(function (e) {
      c.send(jz, {
        state: e,
        id: i.id
      });
    });
    var a = i;
    return this.children.set(i.id, a), r.autoForward && this.forwardTo.add(i.id), i.onDone(function (e) {
      c.removeChild(i.id), c.send(hy(e, {
        origin: i.id
      }));
    }).start(), a;
  }, e.prototype.spawnBehavior = function (e, t) {
    var n = cV(e, {
      id: t,
      parent: this
    });
    return this.children.set(t, n), n;
  }, e.prototype.spawnPromise = function (e, t) {
    var n,
      c,
      i = this,
      r = !1;
    e.then(function (e) {
      r || (c = e, i.removeChild(t), i.send(hy(Cy(t, e), {
        origin: t
      })));
    }, function (e) {
      if (!r) {
        i.removeChild(t);
        var n = Ly(t, e);
        try {
          i.send(hy(n, {
            origin: t
          }));
        } catch (c) {
          !function (e, t, n) {
            if (!Yz) {
              var c = e.stack ? " Stacktrace was '".concat(e.stack, "'") : "";
              if (e === t) console.error("Missing onError handler for invocation '".concat(n, "', error was '").concat(e, "'.").concat(c));else {
                var i = t.stack ? " Stacktrace was '".concat(t.stack, "'") : "";
                console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(n, "'. ") + "Original error: '".concat(e, "'. ").concat(c, " Current error is '").concat(t, "'.").concat(i));
              }
            }
          }(e, c, t), i.devTools && i.devTools.send(n, i.state), i.machine.strict && i.stop();
        }
      }
    });
    var a = ((n = {
      id: t,
      send: function () {},
      subscribe: function (t, n, c) {
        var i = Hy(t, n, c),
          r = !1;
        return e.then(function (e) {
          r || (i.next(e), r || i.complete());
        }, function (e) {
          r || i.error(e);
        }), {
          unsubscribe: function () {
            return r = !0;
          }
        };
      },
      stop: function () {
        r = !0;
      },
      toJSON: function () {
        return {
          id: t
        };
      },
      getSnapshot: function () {
        return c;
      }
    })[dy] = function () {
      return this;
    }, n);
    return this.children.set(t, a), a;
  }, e.prototype.spawnCallback = function (e, t) {
    var n,
      c,
      i,
      r = this,
      a = !1,
      o = new Set(),
      s = new Set();
    try {
      i = e(function (e) {
        c = e, s.forEach(function (t) {
          return t(e);
        }), a || r.send(hy(e, {
          origin: t
        }));
      }, function (e) {
        o.add(e);
      });
    } catch (e) {
      this.send(Ly(t, e));
    }
    if (iy(i)) return this.spawnPromise(i, t);
    var l = ((n = {
      id: t,
      send: function (e) {
        return o.forEach(function (t) {
          return t(e);
        });
      },
      subscribe: function (e) {
        var t = Hy(e);
        return s.add(t.next), {
          unsubscribe: function () {
            s.delete(t.next);
          }
        };
      },
      stop: function () {
        a = !0, ly(i) && i();
      },
      toJSON: function () {
        return {
          id: t
        };
      },
      getSnapshot: function () {
        return c;
      }
    })[dy] = function () {
      return this;
    }, n);
    return this.children.set(t, l), l;
  }, e.prototype.spawnObservable = function (e, t) {
    var n,
      c,
      i = this,
      r = e.subscribe(function (e) {
        c = e, i.send(hy(e, {
          origin: t
        }));
      }, function (e) {
        i.removeChild(t), i.send(hy(Ly(t, e), {
          origin: t
        }));
      }, function () {
        i.removeChild(t), i.send(hy(Cy(t), {
          origin: t
        }));
      }),
      a = ((n = {
        id: t,
        send: function () {},
        subscribe: function (t, n, c) {
          return e.subscribe(t, n, c);
        },
        stop: function () {
          return r.unsubscribe();
        },
        getSnapshot: function () {
          return c;
        },
        toJSON: function () {
          return {
            id: t
          };
        }
      })[dy] = function () {
        return this;
      }, n);
    return this.children.set(t, a), a;
  }, e.prototype.spawnActor = function (e, t) {
    return this.children.set(t, e), e;
  }, e.prototype.spawnActivity = function (e) {
    var t = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
    if (t) {
      var n = t(this.state.context, e);
      this.spawnEffect(e.id, n);
    } else Yz || oy(!1, "No implementation found for activity '".concat(e.type, "'"));
  }, e.prototype.spawnEffect = function (e, t) {
    var n;
    this.children.set(e, ((n = {
      id: e,
      send: function () {},
      subscribe: function () {
        return {
          unsubscribe: function () {}
        };
      },
      stop: t || void 0,
      getSnapshot: function () {},
      toJSON: function () {
        return {
          id: e
        };
      }
    })[dy] = function () {
      return this;
    }, n));
  }, e.prototype.attachDev = function () {
    var e = tV();
    if (this.options.devTools && e) {
      if (e.__REDUX_DEVTOOLS_EXTENSION__) {
        var t = "object" == typeof this.options.devTools ? this.options.devTools : void 0;
        this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(yz(yz({
          name: this.id,
          autoPause: !0,
          stateSanitizer: function (e) {
            return {
              value: e.value,
              context: e.context,
              actions: e.actions
            };
          }
        }, t), {
          features: yz({
            jump: !1,
            skip: !1
          }, t ? t.features : void 0)
        }), this.machine), this.devTools.init(this.state);
      }
      nV(this);
    }
  }, e.prototype.toJSON = function () {
    return {
      id: this.id
    };
  }, e.prototype[dy] = function () {
    return this;
  }, e.prototype.getSnapshot = function () {
    return this.status === iV.NotStarted ? this.initialState : this._state;
  }, e.defaultOptions = {
    execute: !0,
    deferEvents: !0,
    clock: {
      setTimeout: function (e, t) {
        return setTimeout(e, t);
      },
      clearTimeout: function (e) {
        return clearTimeout(e);
      }
    },
    logger: console.log.bind(console),
    devTools: !1
  }, e.interpret = oV, e;
}();
function oV(e, t) {
  return new aV(e, t);
}
function sV(e) {
  if ("string" == typeof e) {
    var t = {
      type: e,
      toString: function () {
        return e;
      }
    };
    return t;
  }
  return e;
}
function lV(e) {
  return yz(yz({
    type: Oz
  }, e), {
    toJSON: function () {
      e.onDone, e.onError;
      var t = Vz(e, ["onDone", "onError"]);
      return yz(yz({}, t), {
        type: Oz,
        src: sV(e.src)
      });
    }
  });
}
var fV = "",
  uV = "*",
  dV = {},
  pV = function (e) {
    return "#" === e[0];
  },
  mV = function () {
    function e(t, n, c, i) {
      void 0 === c && (c = "context" in t ? t.context : void 0);
      var r,
        a = this;
      this.config = t, this._context = c, this.order = -1, this.__xstatenode = !0, this.__cache = {
        events: void 0,
        relativeValue: new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign({
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
      }, n), this.parent = null == i ? void 0 : i.parent, this.key = this.config.key || (null == i ? void 0 : i.key) || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : "."), this.id = this.config.id || _z([this.machine.key], Mz(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : null !== (r = this.config.schema) && void 0 !== r ? r : {}, this.description = this.config.description, Yz || oy(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead.")), this.initial = this.config.initial, this.states = this.config.states ? Zz(this.config.states, function (t, n) {
        var c,
          i = new e(t, {}, void 0, {
            parent: a,
            key: n
          });
        return Object.assign(a.idMap, yz(((c = {})[i.id] = i, c), i.idMap)), i;
      }) : dV;
      var o = 0;
      !function e(t) {
        var n, c;
        t.order = o++;
        try {
          for (var i = xz(Oy(t)), r = i.next(); !r.done; r = i.next()) {
            e(r.value);
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            r && !r.done && (c = i.return) && c.call(i);
          } finally {
            if (n) throw n.error;
          }
        }
      }(this), this.history = !0 === this.config.history ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || !!this.config.on && (Array.isArray(this.config.on) ? this.config.on.some(function (e) {
        return e.event === fV;
      }) : fV in this.config.on), this.strict = !!this.config.strict, this.onEntry = ny(this.config.entry || this.config.onEntry).map(function (e) {
        return My(e);
      }), this.onExit = ny(this.config.exit || this.config.onExit).map(function (e) {
        return My(e);
      }), this.meta = this.config.meta, this.doneData = "final" === this.type ? this.config.data : void 0, this.invoke = ny(this.config.invoke).map(function (e, t) {
        var n, c;
        if (py(e)) {
          var i = zy(a.id, t);
          return a.machine.options.services = yz(((n = {})[i] = e, n), a.machine.options.services), lV({
            src: i,
            id: i
          });
        }
        if (fy(e.src)) {
          i = e.id || zy(a.id, t);
          return lV(yz(yz({}, e), {
            id: i,
            src: e.src
          }));
        }
        if (py(e.src) || ly(e.src)) {
          i = e.id || zy(a.id, t);
          return a.machine.options.services = yz(((c = {})[i] = e.src, c), a.machine.options.services), lV(yz(yz({
            id: i
          }, e), {
            src: i
          }));
        }
        var r = e.src;
        return lV(yz(yz({
          id: zy(a.id, t)
        }, e), {
          src: r
        }));
      }), this.activities = ny(this.config.activities).concat(this.invoke).map(function (e) {
        return wy(e);
      }), this.transition = this.transition.bind(this), this.tags = ny(this.config.tags);
    }
    return e.prototype._init = function () {
      this.__cache.transitions || Dy(this).forEach(function (e) {
        return e.on;
      });
    }, e.prototype.withConfig = function (t, n) {
      var c = this.options,
        i = c.actions,
        r = c.activities,
        a = c.guards,
        o = c.services,
        s = c.delays;
      return new e(this.config, {
        actions: yz(yz({}, i), t.actions),
        activities: yz(yz({}, r), t.activities),
        guards: yz(yz({}, a), t.guards),
        services: yz(yz({}, o), t.services),
        delays: yz(yz({}, s), t.delays)
      }, null != n ? n : this.context);
    }, e.prototype.withContext = function (t) {
      return new e(this.config, this.options, t);
    }, Object.defineProperty(e.prototype, "context", {
      get: function () {
        return ly(this._context) ? this._context() : this._context;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "definition", {
      get: function () {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: Zz(this.states, function (e) {
            return e.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toJSON = function () {
      return this.definition;
    }, Object.defineProperty(e.prototype, "on", {
      get: function () {
        if (this.__cache.on) return this.__cache.on;
        var e = this.transitions;
        return this.__cache.on = e.reduce(function (e, t) {
          return e[t.eventType] = e[t.eventType] || [], e[t.eventType].push(t), e;
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "after", {
      get: function () {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "transitions", {
      get: function () {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getCandidates = function (e) {
      if (this.__cache.candidates[e]) return this.__cache.candidates[e];
      var t = e === fV,
        n = this.transitions.filter(function (n) {
          var c = n.eventType === e;
          return t ? c : c || n.eventType === uV;
        });
      return this.__cache.candidates[e] = n, n;
    }, e.prototype.getDelayedTransitions = function () {
      var e = this,
        t = this.config.after;
      if (!t) return [];
      var n = function (t, n) {
          var c = function (e, t) {
            var n = t ? "#".concat(t) : "";
            return "".concat(Hz.After, "(").concat(e, ")").concat(n);
          }(ly(t) ? "".concat(e.id, ":delay[").concat(n, "]") : t, e.id);
          return e.onEntry.push(function (e, t) {
            return {
              to: t ? t.to : void 0,
              type: Lz,
              event: ly(e) ? e : my(e),
              delay: t ? t.delay : void 0,
              id: t && void 0 !== t.id ? t.id : ly(e) ? e.name : qz(e)
            };
          }(c, {
            delay: t
          })), e.onExit.push({
            type: Nz,
            sendId: c
          }), c;
        },
        c = sy(t) ? t.map(function (e, t) {
          var c = n(e.delay, t);
          return yz(yz({}, e), {
            event: c
          });
        }) : ey(Object.keys(t).map(function (e, c) {
          var i = t[e],
            r = fy(i) ? {
              target: i
            } : i,
            a = isNaN(+e) ? e : +e,
            o = n(a, c);
          return ny(r).map(function (e) {
            return yz(yz({}, e), {
              event: o,
              delay: a
            });
          });
        }));
      return c.map(function (t) {
        var n = t.delay;
        return yz(yz({}, e.formatTransition(t)), {
          delay: n
        });
      });
    }, e.prototype.getStateNodes = function (e) {
      var t,
        n = this;
      if (!e) return [];
      var c = e instanceof qy ? e.value : $z(e, this.delimiter);
      if (fy(c)) {
        var i = this.getStateNode(c).initial;
        return void 0 !== i ? this.getStateNodes(((t = {})[c] = i, t)) : [this, this.states[c]];
      }
      var r = Object.keys(c),
        a = [this];
      return a.push.apply(a, _z([], Mz(ey(r.map(function (e) {
        return n.getStateNode(e).getStateNodes(c[e]);
      }))), !1)), a;
    }, e.prototype.handles = function (e) {
      var t = qz(e);
      return this.events.includes(t);
    }, e.prototype.resolveState = function (e) {
      var t = e instanceof qy ? e : qy.create(e),
        n = Array.from(Iy([], this.getStateNodes(t.value)));
      return new qy(yz(yz({}, t), {
        value: this.resolve(t.value),
        configuration: n,
        done: Gy(n, this),
        tags: Yy(n),
        machine: this.machine
      }));
    }, e.prototype.transitionLeafNode = function (e, t, n) {
      var c = this.getStateNode(e).next(t, n);
      return c && c.transitions.length ? c : this.next(t, n);
    }, e.prototype.transitionCompoundNode = function (e, t, n) {
      var c = Object.keys(e),
        i = this.getStateNode(c[0])._transition(e[c[0]], t, n);
      return i && i.transitions.length ? i : this.next(t, n);
    }, e.prototype.transitionParallelNode = function (e, t, n) {
      var c,
        i,
        r = {};
      try {
        for (var a = xz(Object.keys(e)), o = a.next(); !o.done; o = a.next()) {
          var s = o.value,
            l = e[s];
          if (l) {
            var f = this.getStateNode(s)._transition(l, t, n);
            f && (r[s] = f);
          }
        }
      } catch (e) {
        c = {
          error: e
        };
      } finally {
        try {
          o && !o.done && (i = a.return) && i.call(a);
        } finally {
          if (c) throw c.error;
        }
      }
      var u = Object.keys(r).map(function (e) {
          return r[e];
        }),
        d = ey(u.map(function (e) {
          return e.transitions;
        })),
        p = u.some(function (e) {
          return e.transitions.length > 0;
        });
      if (!p) return this.next(t, n);
      var m = ey(Object.keys(r).map(function (e) {
        return r[e].configuration;
      }));
      return {
        transitions: d,
        exitSet: ey(u.map(function (e) {
          return e.exitSet;
        })),
        configuration: m,
        source: t,
        actions: ey(Object.keys(r).map(function (e) {
          return r[e].actions;
        }))
      };
    }, e.prototype._transition = function (e, t, n) {
      return fy(e) ? this.transitionLeafNode(e, t, n) : 1 === Object.keys(e).length ? this.transitionCompoundNode(e, t, n) : this.transitionParallelNode(e, t, n);
    }, e.prototype.getTransitionData = function (e, t) {
      return this._transition(e.value, e, hy(t));
    }, e.prototype.next = function (e, t) {
      var n,
        c,
        i,
        r = this,
        a = t.name,
        o = [],
        s = [];
      try {
        for (var l = xz(this.getCandidates(a)), f = l.next(); !f.done; f = l.next()) {
          var u = f.value,
            d = u.cond,
            p = u.in,
            m = e.context,
            h = !p || (fy(p) && pV(p) ? e.matches($z(this.getStateNodeById(p).path, this.delimiter)) : Wz($z(p, this.delimiter), Qz(this.path.slice(0, -2))(e.value))),
            v = !1;
          try {
            v = !d || gy(this.machine, d, m, t, e);
          } catch (e) {
            throw new Error("Unable to evaluate guard '".concat(d.name || d.type, "' in transition for event '").concat(a, "' in state node '").concat(this.id, "':\n").concat(e.message));
          }
          if (v && h) {
            void 0 !== u.target && (s = u.target), o.push.apply(o, _z([], Mz(u.actions), !1)), i = u;
            break;
          }
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          f && !f.done && (c = l.return) && c.call(l);
        } finally {
          if (n) throw n.error;
        }
      }
      if (i) {
        if (!s.length) return {
          transitions: [i],
          exitSet: [],
          configuration: e.value ? [this] : [],
          source: e,
          actions: o
        };
        var g = ey(s.map(function (t) {
          return r.getRelativeStateNodes(t, e.historyValue);
        }));
        return {
          transitions: [i],
          exitSet: !!i.internal ? [] : ey(s.map(function (e) {
            return r.getPotentiallyReenteringNodes(e);
          })),
          configuration: g,
          source: e,
          actions: o
        };
      }
    }, e.prototype.getPotentiallyReenteringNodes = function (e) {
      if (this.order < e.order) return [this];
      for (var t = [], n = this, c = e; n && n !== c;) t.push(n), n = n.parent;
      return n !== c ? [] : (t.push(c), t);
    }, e.prototype.getActions = function (e, t, n, c, i, r, a) {
      var o,
        s,
        l,
        f,
        u = this,
        d = r ? Iy([], this.getStateNodes(r.value)) : [],
        p = new Set();
      try {
        for (var m = xz(Array.from(e).sort(function (e, t) {
            return e.order - t.order;
          })), h = m.next(); !h.done; h = m.next()) {
          (!By(d, b = h.value) || By(n.exitSet, b) || b.parent && p.has(b.parent)) && p.add(b);
        }
      } catch (e) {
        o = {
          error: e
        };
      } finally {
        try {
          h && !h.done && (s = m.return) && s.call(m);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var v = xz(d), g = v.next(); !g.done; g = v.next()) {
          var b;
          By(e, b = g.value) && !By(n.exitSet, b.parent) || n.exitSet.push(b);
        }
      } catch (e) {
        l = {
          error: e
        };
      } finally {
        try {
          g && !g.done && (f = v.return) && f.call(v);
        } finally {
          if (l) throw l.error;
        }
      }
      n.exitSet.sort(function (e, t) {
        return t.order - e.order;
      });
      var H = Array.from(p).sort(function (e, t) {
          return e.order - t.order;
        }),
        z = new Set(n.exitSet),
        y = ey(H.map(function (e) {
          var t = [];
          if ("final" !== e.type) return t;
          var r = e.parent;
          if (!r.parent) return t;
          t.push(Ey(e.id, e.doneData), Ey(r.id, e.doneData ? cy(e.doneData, c, i) : void 0));
          var a = r.parent;
          return "parallel" === a.type && Ay(a).every(function (e) {
            return Gy(n.configuration, e);
          }) && t.push(Ey(a.id)), t;
        })),
        V = H.map(function (e) {
          var t = e.onEntry,
            n = e.activities.map(function (e) {
              return function (e) {
                var t = wy(e);
                return {
                  type: Hz.Start,
                  activity: t,
                  exec: void 0
                };
              }(e);
            });
          return {
            type: "entry",
            actions: _y(a ? _z(_z([], Mz(t), !1), Mz(n), !1) : _z(_z([], Mz(n), !1), Mz(t), !1), u.machine.options.actions)
          };
        }).concat({
          type: "state_done",
          actions: y.map(function (e) {
            return function (e, t) {
              return {
                type: Cz,
                event: "function" == typeof e ? e : my(e),
                delay: t ? t.delay : void 0,
                id: null == t ? void 0 : t.id
              };
            }(e);
          })
        }),
        x = Array.from(z).map(function (e) {
          return {
            type: "exit",
            actions: _y(_z(_z([], Mz(e.onExit), !1), Mz(e.activities.map(function (e) {
              return function (e) {
                var t = ly(e) ? e : wy(e);
                return {
                  type: Hz.Stop,
                  activity: t,
                  exec: void 0
                };
              }(e);
            })), !1), u.machine.options.actions)
          };
        }).concat({
          type: "transition",
          actions: _y(n.actions, this.machine.options.actions)
        }).concat(V);
      if (t) {
        var M = _y(ey(_z([], Mz(e), !1).sort(function (e, t) {
          return t.order - e.order;
        }).map(function (e) {
          return e.onExit;
        })), this.machine.options.actions).filter(function (e) {
          return !yy(e);
        });
        return x.concat({
          type: "stop",
          actions: M
        });
      }
      return x;
    }, e.prototype.transition = function (e, t, n, c) {
      void 0 === e && (e = this.initialState);
      var i,
        r,
        a = hy(t);
      if (e instanceof qy) i = void 0 === n ? e : this.resolveState(qy.from(e, n));else {
        var o = fy(e) ? this.resolve(Xz(this.getResolvedPath(e))) : this.resolve(e),
          s = null != n ? n : this.machine.context;
        i = this.resolveState(qy.from(o, s));
      }
      if (!Yz && a.name === uV) throw new Error("An event cannot have the wildcard type ('".concat(uV, "')"));
      if (this.strict && !this.events.includes(a.name) && (r = a.name, !/^(done|error)\./.test(r))) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(a.name, "'"));
      var l = this._transition(i.value, i, a) || {
          transitions: [],
          configuration: [],
          exitSet: [],
          source: i,
          actions: []
        },
        f = Iy([], this.getStateNodes(i.value)),
        u = l.configuration.length ? Iy(f, l.configuration) : f;
      return l.configuration = _z([], Mz(u), !1), this.resolveTransition(l, i, i.context, c, a);
    }, e.prototype.resolveRaisedTransition = function (e, t, n, c) {
      var i,
        r = e.actions;
      return (e = this.transition(e, t, void 0, c))._event = n, e.event = n.data, (i = e.actions).unshift.apply(i, _z([], Mz(r), !1)), e;
    }, e.prototype.resolveTransition = function (e, t, n, c, i) {
      var r,
        a,
        o,
        s,
        l = this;
      void 0 === i && (i = Vy);
      var f = e.configuration,
        u = !t || e.transitions.length > 0,
        d = u ? e.configuration : t ? t.configuration : [],
        p = Gy(d, this),
        m = u ? Ry(this.machine, f) : void 0,
        h = t ? t.historyValue ? t.historyValue : e.source ? this.machine.historyValue(t.value) : void 0 : void 0,
        v = this.getActions(new Set(d), p, e, n, i, t, c),
        g = t ? yz({}, t.activities) : {};
      try {
        for (var b = xz(v), H = b.next(); !H.done; H = b.next()) {
          var z = H.value;
          try {
            for (var y = (o = void 0, xz(z.actions)), V = y.next(); !V.done; V = y.next()) {
              var x = V.value;
              x.type === wz ? g[x.activity.id || x.activity.type] = x : x.type === Ez && (g[x.activity.id || x.activity.type] = !1);
            }
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              V && !V.done && (s = y.return) && s.call(y);
            } finally {
              if (o) throw o.error;
            }
          }
        }
      } catch (e) {
        r = {
          error: e
        };
      } finally {
        try {
          H && !H.done && (a = b.return) && a.call(b);
        } finally {
          if (r) throw r.error;
        }
      }
      var M,
        _,
        w = Mz(Ny(this, t, n, i, v, c, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2),
        E = w[0],
        C = w[1],
        L = Mz(function (e, t) {
          var n,
            c,
            i = Mz([[], []], 2),
            r = i[0],
            a = i[1];
          try {
            for (var o = xz(e), s = o.next(); !s.done; s = o.next()) {
              var l = s.value;
              t(l) ? r.push(l) : a.push(l);
            }
          } catch (e) {
            n = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (c = o.return) && c.call(o);
            } finally {
              if (n) throw n.error;
            }
          }
          return [r, a];
        }(E, yy), 2),
        N = L[0],
        S = L[1],
        k = E.filter(function (e) {
          var t;
          return e.type === wz && (null === (t = e.activity) || void 0 === t ? void 0 : t.type) === Oz;
        }),
        P = k.reduce(function (e, t) {
          return e[t.activity.id] = function (e, t, n, c) {
            var i,
              r = by(e.src),
              a = null === (i = null == t ? void 0 : t.options.services) || void 0 === i ? void 0 : i[r.type],
              o = e.data ? cy(e.data, n, c) : void 0,
              s = a ? Py(a, e.id, o) : ky(e.id);
            return s.meta = e, s;
          }(t.activity, l.machine, C, i), e;
        }, t ? yz({}, t.children) : {}),
        T = new qy({
          value: m || t.value,
          context: C,
          _event: i,
          _sessionid: t ? t._sessionid : null,
          historyValue: m ? h ? (M = h, _ = m, {
            current: _,
            states: ry(M, _)
          }) : void 0 : t ? t.historyValue : void 0,
          history: !m || e.source ? t : void 0,
          actions: m ? S : [],
          activities: m ? g : t ? t.activities : {},
          events: [],
          configuration: d,
          transitions: e.transitions,
          children: P,
          done: p,
          tags: Yy(d),
          machine: this
        }),
        O = n !== C;
      T.changed = i.name === jz || O;
      var A = T.history;
      A && delete A.history;
      var D = !p && (this._transient || f.some(function (e) {
        return e._transient;
      }));
      if (!(u || D && i.name !== fV)) return T;
      var I = T;
      if (!p) for (D && (I = this.resolveRaisedTransition(I, {
        type: Sz
      }, i, c)); N.length;) {
        var j = N.shift();
        I = this.resolveRaisedTransition(I, j._event, i, c);
      }
      var F = I.changed || (A ? !!I.actions.length || O || typeof A.value != typeof I.value || !Wy(I.value, A.value) : void 0);
      return I.changed = F, I.history = A, I;
    }, e.prototype.getStateNode = function (e) {
      if (pV(e)) return this.machine.getStateNodeById(e);
      if (!this.states) throw new Error("Unable to retrieve child state '".concat(e, "' from '").concat(this.id, "'; no child states exist."));
      var t = this.states[e];
      if (!t) throw new Error("Child state '".concat(e, "' does not exist on '").concat(this.id, "'"));
      return t;
    }, e.prototype.getStateNodeById = function (e) {
      var t = pV(e) ? e.slice(1) : e;
      if (t === this.id) return this;
      var n = this.machine.idMap[t];
      if (!n) throw new Error("Child state node '#".concat(t, "' does not exist on machine '").concat(this.id, "'"));
      return n;
    }, e.prototype.getStateNodeByPath = function (e) {
      if ("string" == typeof e && pV(e)) try {
        return this.getStateNodeById(e.slice(1));
      } catch (e) {}
      for (var t = Uz(e, this.delimiter).slice(), n = this; t.length;) {
        var c = t.shift();
        if (!c.length) break;
        n = n.getStateNode(c);
      }
      return n;
    }, e.prototype.resolve = function (e) {
      var t,
        n = this;
      if (!e) return this.initialStateValue || dV;
      switch (this.type) {
        case "parallel":
          return Zz(this.initialStateValue, function (t, c) {
            return t ? n.getStateNode(c).resolve(e[c] || t) : dV;
          });
        case "compound":
          if (fy(e)) {
            var c = this.getStateNode(e);
            return "parallel" === c.type || "compound" === c.type ? ((t = {})[e] = c.initialStateValue, t) : e;
          }
          return Object.keys(e).length ? Zz(e, function (e, t) {
            return e ? n.getStateNode(t).resolve(e) : dV;
          }) : this.initialStateValue || {};
        default:
          return e || dV;
      }
    }, e.prototype.getResolvedPath = function (e) {
      if (pV(e)) {
        var t = this.machine.idMap[e.slice(1)];
        if (!t) throw new Error("Unable to find state node '".concat(e, "'"));
        return t.path;
      }
      return Uz(e, this.delimiter);
    }, Object.defineProperty(e.prototype, "initialStateValue", {
      get: function () {
        var e, t;
        if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
        if ("parallel" === this.type) t = Kz(this.states, function (e) {
          return e.initialStateValue || dV;
        }, function (e) {
          return !("history" === e.type);
        });else if (void 0 !== this.initial) {
          if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          t = Ty(this.states[this.initial]) ? this.initial : ((e = {})[this.initial] = this.states[this.initial].initialStateValue, e);
        } else t = {};
        return this.__cache.initialStateValue = t, this.__cache.initialStateValue;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getInitialState = function (e, t) {
      this._init();
      var n = this.getStateNodes(e);
      return this.resolveTransition({
        configuration: n,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, null != t ? t : this.machine.context, void 0);
    }, Object.defineProperty(e.prototype, "initialState", {
      get: function () {
        var e = this.initialStateValue;
        if (!e) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "target", {
      get: function () {
        var e;
        if ("history" === this.type) {
          var t = this.config;
          e = fy(t.target) && pV(t.target) ? Xz(this.machine.getStateNodeById(t.target).path.slice(this.path.length - 1)) : t.target;
        }
        return e;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getRelativeStateNodes = function (e, t, n) {
      return void 0 === n && (n = !0), n ? "history" === e.type ? e.resolveHistory(t) : e.initialStateNodes : [e];
    }, Object.defineProperty(e.prototype, "initialStateNodes", {
      get: function () {
        var e = this;
        return Ty(this) ? [this] : "compound" !== this.type || this.initial ? ey(Jz(this.initialStateValue).map(function (t) {
          return e.getFromRelativePath(t);
        })) : (Yz || oy(!1, "Compound state node '".concat(this.id, "' has no initial state.")), [this]);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getFromRelativePath = function (e) {
      if (!e.length) return [this];
      var t = Mz(e),
        n = t[0],
        c = t.slice(1);
      if (!this.states) throw new Error("Cannot retrieve subPath '".concat(n, "' from node with no states"));
      var i = this.getStateNode(n);
      if ("history" === i.type) return i.resolveHistory();
      if (!this.states[n]) throw new Error("Child state '".concat(n, "' does not exist on '").concat(this.id, "'"));
      return this.states[n].getFromRelativePath(c);
    }, e.prototype.historyValue = function (e) {
      if (Object.keys(this.states).length) return {
        current: e || this.initialStateValue,
        states: Kz(this.states, function (t, n) {
          if (!e) return t.historyValue();
          var c = fy(e) ? void 0 : e[n];
          return t.historyValue(c || t.initialStateValue);
        }, function (e) {
          return !e.history;
        })
      };
    }, e.prototype.resolveHistory = function (e) {
      var t = this;
      if ("history" !== this.type) return [this];
      var n = this.parent;
      if (!e) {
        var c = this.target;
        return c ? ey(Jz(c).map(function (e) {
          return n.getFromRelativePath(e);
        })) : n.initialStateNodes;
      }
      var i,
        r,
        a = (i = n.path, r = "states", function (e) {
          var t,
            n,
            c = e;
          try {
            for (var a = xz(i), o = a.next(); !o.done; o = a.next()) {
              var s = o.value;
              c = c[r][s];
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              o && !o.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
          return c;
        })(e).current;
      return fy(a) ? [n.getStateNode(a)] : ey(Jz(a).map(function (e) {
        return "deep" === t.history ? n.getFromRelativePath(e) : [n.states[e[0]]];
      }));
    }, Object.defineProperty(e.prototype, "stateIds", {
      get: function () {
        var e = this,
          t = ey(Object.keys(this.states).map(function (t) {
            return e.states[t].stateIds;
          }));
        return [this.id].concat(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "events", {
      get: function () {
        var e, t, n, c;
        if (this.__cache.events) return this.__cache.events;
        var i = this.states,
          r = new Set(this.ownEvents);
        if (i) try {
          for (var a = xz(Object.keys(i)), o = a.next(); !o.done; o = a.next()) {
            var s = i[o.value];
            if (s.states) try {
              for (var l = (n = void 0, xz(s.events)), f = l.next(); !f.done; f = l.next()) {
                var u = f.value;
                r.add("".concat(u));
              }
            } catch (e) {
              n = {
                error: e
              };
            } finally {
              try {
                f && !f.done && (c = l.return) && c.call(l);
              } finally {
                if (n) throw n.error;
              }
            }
          }
        } catch (t) {
          e = {
            error: t
          };
        } finally {
          try {
            o && !o.done && (t = a.return) && t.call(a);
          } finally {
            if (e) throw e.error;
          }
        }
        return this.__cache.events = Array.from(r);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ownEvents", {
      get: function () {
        var e = new Set(this.transitions.filter(function (e) {
          return !(!e.target && !e.actions.length && e.internal);
        }).map(function (e) {
          return e.eventType;
        }));
        return Array.from(e);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolveTarget = function (e) {
      var t = this;
      if (void 0 !== e) return e.map(function (e) {
        if (!fy(e)) return e;
        var n = e[0] === t.delimiter;
        if (n && !t.parent) return t.getStateNodeByPath(e.slice(1));
        var c = n ? t.key + e : e;
        if (!t.parent) return t.getStateNodeByPath(c);
        try {
          return t.parent.getStateNodeByPath(c);
        } catch (e) {
          throw new Error("Invalid transition definition for state node '".concat(t.id, "':\n").concat(e.message));
        }
      });
    }, e.prototype.formatTransition = function (e) {
      var t = this,
        n = function (e) {
          if (void 0 !== e && "" !== e) return ny(e);
        }(e.target),
        c = "internal" in e ? e.internal : !n || n.some(function (e) {
          return fy(e) && e[0] === t.delimiter;
        }),
        i = this.machine.options.guards,
        r = this.resolveTarget(n),
        a = yz(yz({}, e), {
          actions: _y(ny(e.actions)),
          cond: uy(e.cond, i),
          target: r,
          source: this,
          internal: c,
          eventType: e.event,
          toJSON: function () {
            return yz(yz({}, a), {
              target: a.target ? a.target.map(function (e) {
                return "#".concat(e.id);
              }) : void 0,
              source: "#".concat(t.id)
            });
          }
        });
      return a;
    }, e.prototype.formatTransitions = function () {
      var e,
        t,
        n,
        c = this;
      if (this.config.on) {
        if (Array.isArray(this.config.on)) n = this.config.on;else {
          var i = this.config.on,
            r = uV,
            a = i[r],
            o = void 0 === a ? [] : a,
            s = Vz(i, ["*"]);
          n = ey(Object.keys(s).map(function (e) {
            Yz || e !== fV || oy(!1, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(c.id, '".'));
            var t = vy(e, s[e]);
            return Yz || function (e, t, n) {
              var c = n.slice(0, -1).some(function (e) {
                  return !("cond" in e) && !("in" in e) && (fy(e.target) || py(e.target));
                }),
                i = t === fV ? "the transient event" : "event '".concat(t, "'");
              oy(!c, "One or more transitions for ".concat(i, " on state '").concat(e.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
            }(c, e, t), t;
          }).concat(vy(uV, o)));
        }
      } else n = [];
      var l = this.config.always ? vy("", this.config.always) : [],
        f = this.config.onDone ? vy(String(Ey(this.id)), this.config.onDone) : [];
      Yz || oy(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
      var u = ey(this.invoke.map(function (e) {
          var t = [];
          return e.onDone && t.push.apply(t, _z([], Mz(vy(String(Cy(e.id)), e.onDone)), !1)), e.onError && t.push.apply(t, _z([], Mz(vy(String(Ly(e.id)), e.onError)), !1)), t;
        })),
        d = this.after,
        p = ey(_z(_z(_z(_z([], Mz(f), !1), Mz(u), !1), Mz(n), !1), Mz(l), !1).map(function (e) {
          return ny(e).map(function (e) {
            return c.formatTransition(e);
          });
        }));
      try {
        for (var m = xz(d), h = m.next(); !h.done; h = m.next()) {
          var v = h.value;
          p.push(v);
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          h && !h.done && (t = m.return) && t.call(m);
        } finally {
          if (e) throw e.error;
        }
      }
      return p;
    }, e;
  }();
var hV,
  vV = function (e) {
    return {
      type: kz,
      assignment: e
    };
  };
!function (e) {
  e[e.Effect = 1] = "Effect", e[e.LayoutEffect = 2] = "LayoutEffect";
}(hV || (hV = {}));
var gV = "undefined" != typeof document ? r : i;
function bV(t) {
  var n = e.useRef();
  return n.current || (n.current = {
    v: t()
  }), n.current.v;
}
var HV = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var c,
      i,
      r = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(c = r.next()).done;) a.push(c.value);
    } catch (e) {
      i = {
        error: e
      };
    } finally {
      try {
        c && !c.done && (n = r.return) && n.call(r);
      } finally {
        if (i) throw i.error;
      }
    }
    return a;
  },
  zV = function (e) {
    var t = "function" == typeof Symbol && Symbol.iterator,
      n = t && e[t],
      c = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
      next: function () {
        return e && c >= e.length && (e = void 0), {
          value: e && e[c++],
          done: !e
        };
      }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
var yV = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var c,
      i,
      r = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(c = r.next()).done;) a.push(c.value);
    } catch (e) {
      i = {
        error: e
      };
    } finally {
      try {
        c && !c.done && (n = r.return) && n.call(r);
      } finally {
        if (i) throw i.error;
      }
    }
    return a;
  },
  VV = function (e, t, n) {
    if (n || 2 === arguments.length) for (var c, i = 0, r = t.length; i < r; i++) !c && i in t || (c || (c = Array.prototype.slice.call(t, 0, i)), c[i] = t[i]);
    return e.concat(c || Array.prototype.slice.call(t));
  };
function xV(e, t) {
  (0, e.exec)(t.context, t._event.data, {
    action: e,
    state: t,
    _event: t._event
  })();
}
function MV(e) {
  var t = n([]),
    c = n([]);
  gV(function () {
    var n = e.subscribe(function (e) {
      var n, i;
      if (e.actions.length) {
        var r = e.actions.filter(function (e) {
            return "function" == typeof e.exec && "__effect" in e.exec;
          }),
          a = yV(function (e, t) {
            var n,
              c,
              i = HV([[], []], 2),
              r = i[0],
              a = i[1];
            try {
              for (var o = zV(e), s = o.next(); !s.done; s = o.next()) {
                var l = s.value;
                t(l) ? r.push(l) : a.push(l);
              }
            } catch (e) {
              n = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (c = o.return) && c.call(o);
              } finally {
                if (n) throw n.error;
              }
            }
            return [r, a];
          }(r, function (e) {
            return e.exec.__effect === hV.Effect;
          }), 2),
          o = a[0],
          s = a[1];
        (n = t.current).push.apply(n, VV([], yV(o.map(function (t) {
          return [t, e];
        })), !1)), (i = c.current).push.apply(i, VV([], yV(s.map(function (t) {
          return [t, e];
        })), !1));
      }
    });
    return function () {
      n.unsubscribe();
    };
  }, []), gV(function () {
    for (; c.current.length;) {
      var e = yV(c.current.shift(), 2);
      xV(e[0], e[1]);
    }
  }), i(function () {
    for (; t.current.length;) {
      var e = yV(t.current.shift(), 2);
      xV(e[0], e[1]);
    }
  });
}
var _V = function () {
    return _V = Object.assign || function (e) {
      for (var t, n = 1, c = arguments.length; n < c; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      return e;
    }, _V.apply(this, arguments);
  },
  wV = function (e, t) {
    var n = {};
    for (var c in e) Object.prototype.hasOwnProperty.call(e, c) && t.indexOf(c) < 0 && (n[c] = e[c]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var i = 0;
      for (c = Object.getOwnPropertySymbols(e); i < c.length; i++) t.indexOf(c[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, c[i]) && (n[c[i]] = e[c[i]]);
    }
    return n;
  },
  EV = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var c,
      i,
      r = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(c = r.next()).done;) a.push(c.value);
    } catch (e) {
      i = {
        error: e
      };
    } finally {
      try {
        c && !c.done && (n = r.return) && n.call(r);
      } finally {
        if (i) throw i.error;
      }
    }
    return a;
  };
var CV = function (e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var c,
    i,
    r = n.call(e),
    a = [];
  try {
    for (; (void 0 === t || t-- > 0) && !(c = r.next()).done;) a.push(c.value);
  } catch (e) {
    i = {
      error: e
    };
  } finally {
    try {
      c && !c.done && (n = r.return) && n.call(r);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
};
function LV(e, t) {
  void 0 === t && (t = {});
  var n = a(function (e) {
      var t = void 0 === e.changed && Object.keys(e.children).length;
      (e.changed || t) && s(e);
    }, []),
    i = function (e, t, n) {
      void 0 === t && (t = {});
      var i = bV(function () {
        return "function" == typeof e ? e() : e;
      });
      if ("production" !== process.env.NODE_ENV && "function" != typeof e) {
        var r = EV(c(i), 1)[0];
        e !== r && console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
      }
      var a = t.context,
        o = t.guards,
        s = t.actions,
        l = t.activities,
        f = t.services,
        u = t.delays,
        d = t.state,
        p = wV(t, ["context", "guards", "actions", "activities", "services", "delays", "state"]),
        m = bV(function () {
          var e = {
            context: a,
            guards: o,
            actions: s,
            activities: l,
            services: f,
            delays: u
          };
          return oV(i.withConfig(e, function () {
            return _V(_V({}, i.context), a);
          }), _V({
            deferEvents: !0
          }, p));
        });
      return gV(function () {
        var e;
        return n && (e = m.subscribe(function (e, t, n) {
          if ("object" == typeof e) return e;
          var c = function () {};
          return {
            next: e,
            error: void 0 || c,
            complete: void 0 || c
          };
        }(n))), function () {
          null == e || e.unsubscribe();
        };
      }, [n]), gV(function () {
        return m.start(d ? qy.create(d) : void 0), function () {
          m.stop();
        };
      }, []), gV(function () {
        Object.assign(m.machine.options.actions, s), Object.assign(m.machine.options.guards, o), Object.assign(m.machine.options.activities, l), Object.assign(m.machine.options.services, f), Object.assign(m.machine.options.delays, u);
      }, [s, o, l, f, u]), MV(m), m;
    }(e, t, n),
    r = CV(c(function () {
      var e = i.machine.initialState;
      return t.state ? qy.create(t.state) : e;
    }), 2),
    o = r[0],
    s = r[1];
  return [o, i.send, i];
}
function NV() {
  return NV = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, NV.apply(this, arguments);
}
function SV(e, t) {
  if (null == e) return {};
  var n,
    c,
    i = {},
    r = Object.keys(e);
  for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || (i[n] = e[n]);
  return i;
}
const kV = {
  arr: Array.isArray,
  obj: e => "[object Object]" === Object.prototype.toString.call(e),
  fun: e => "function" == typeof e,
  str: e => "string" == typeof e,
  num: e => "number" == typeof e,
  und: e => void 0 === e,
  nul: e => null === e,
  set: e => e instanceof Set,
  map: e => e instanceof Map,
  equ(e, t) {
    if (typeof e != typeof t) return !1;
    if (kV.str(e) || kV.num(e)) return e === t;
    if (kV.obj(e) && kV.obj(t) && Object.keys(e).length + Object.keys(t).length === 0) return !0;
    let n;
    for (n in e) if (!(n in t)) return !1;
    for (n in t) if (e[n] !== t[n]) return !1;
    return !kV.und(n) || e === t;
  }
};
function PV(e, t) {
  return kV.und(e) || kV.nul(e) ? t : e;
}
function TV(e) {
  return kV.und(e) ? [] : kV.arr(e) ? e : [e];
}
function OV(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++) n[c - 1] = arguments[c];
  return kV.fun(e) ? e(...n) : e;
}
function AV(e) {
  const t = function (e) {
    return e.to, e.from, e.config, e.onStart, e.onRest, e.onFrame, e.children, e.reset, e.reverse, e.force, e.immediate, e.delay, e.attach, e.destroyed, e.interpolateTo, e.ref, e.lazy, SV(e, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);
  }(e);
  if (kV.und(t)) return NV({
    to: t
  }, e);
  const n = Object.keys(e).reduce((n, c) => kV.und(t[c]) ? NV({}, n, {
    [c]: e[c]
  }) : n, {});
  return NV({
    to: t
  }, n);
}
class DV {
  constructor() {
    this.payload = void 0, this.children = [];
  }
  getAnimatedValue() {
    return this.getValue();
  }
  getPayload() {
    return this.payload || this;
  }
  attach() {}
  detach() {}
  getChildren() {
    return this.children;
  }
  addChild(e) {
    0 === this.children.length && this.attach(), this.children.push(e);
  }
  removeChild(e) {
    const t = this.children.indexOf(e);
    this.children.splice(t, 1), 0 === this.children.length && this.detach();
  }
}
class IV extends DV {
  constructor() {
    super(...arguments), this.payload = [], this.attach = () => this.payload.forEach(e => e instanceof DV && e.addChild(this)), this.detach = () => this.payload.forEach(e => e instanceof DV && e.removeChild(this));
  }
}
class jV extends DV {
  constructor() {
    super(...arguments), this.payload = {}, this.attach = () => Object.values(this.payload).forEach(e => e instanceof DV && e.addChild(this)), this.detach = () => Object.values(this.payload).forEach(e => e instanceof DV && e.removeChild(this));
  }
  getValue(e) {
    void 0 === e && (e = !1);
    const t = {};
    for (const n in this.payload) {
      const c = this.payload[n];
      (!e || c instanceof DV) && (t[n] = c instanceof DV ? c[e ? "getAnimatedValue" : "getValue"]() : c);
    }
    return t;
  }
  getAnimatedValue() {
    return this.getValue(!0);
  }
}
let FV, RV;
let BV,
  GV = e => "undefined" != typeof window ? window.requestAnimationFrame(e) : -1;
let YV,
  WV = () => Date.now();
class qV extends jV {
  constructor(e, t) {
    super(), this.update = void 0, this.payload = e.style ? NV({}, e, {
      style: YV(e.style)
    }) : e, this.update = t, this.attach();
  }
}
let UV = !1;
const $V = new Set(),
  XV = () => {
    if (!UV) return !1;
    let e = WV();
    for (let t of $V) {
      let n = !1;
      for (let c = 0; c < t.configs.length; c++) {
        let i,
          r,
          a = t.configs[c];
        for (let t = 0; t < a.animatedValues.length; t++) {
          let c = a.animatedValues[t];
          if (c.done) continue;
          let o = a.fromValues[t],
            s = a.toValues[t],
            l = c.lastPosition,
            f = s instanceof DV,
            u = Array.isArray(a.initialVelocity) ? a.initialVelocity[t] : a.initialVelocity;
          if (f && (s = s.getValue()), a.immediate) c.setValue(s), c.done = !0;else if ("string" != typeof o && "string" != typeof s) {
            if (void 0 !== a.duration) l = o + a.easing((e - c.startTime) / a.duration) * (s - o), i = e >= c.startTime + a.duration;else if (a.decay) l = o + u / (1 - .998) * (1 - Math.exp(-(1 - .998) * (e - c.startTime))), i = Math.abs(c.lastPosition - l) < .1, i && (s = l);else {
              r = void 0 !== c.lastTime ? c.lastTime : e, u = void 0 !== c.lastVelocity ? c.lastVelocity : a.initialVelocity, e > r + 64 && (r = e);
              let t = Math.floor(e - r);
              for (let e = 0; e < t; ++e) {
                u += 1 * ((-a.tension * (l - s) + -a.friction * u) / a.mass) / 1e3, l += 1 * u / 1e3;
              }
              let n = !(!a.clamp || 0 === a.tension) && (o < s ? l > s : l < s),
                f = Math.abs(u) <= a.precision,
                d = 0 === a.tension || Math.abs(s - l) <= a.precision;
              i = n || f && d, c.lastVelocity = u, c.lastTime = e;
            }
            f && !a.toValues[t].done && (i = !1), i ? (c.value !== s && (l = s), c.done = !0) : n = !0, c.setValue(l), c.lastPosition = l;
          } else c.setValue(s), c.done = !0;
        }
        t.props.onFrame && (t.values[a.name] = a.interpolation.getValue());
      }
      t.props.onFrame && t.props.onFrame(t.values), n || ($V.delete(t), t.stop(!0));
    }
    return $V.size ? GV(XV) : UV = !1, UV;
  };
function ZV(e, t, n) {
  if ("function" == typeof e) return e;
  if (Array.isArray(e)) return ZV({
    range: e,
    output: t,
    extrapolate: n
  });
  if (BV && "string" == typeof e.output[0]) return BV(e);
  const c = e,
    i = c.output,
    r = c.range || [0, 1],
    a = c.extrapolateLeft || c.extrapolate || "extend",
    o = c.extrapolateRight || c.extrapolate || "extend",
    s = c.easing || (e => e);
  return e => {
    const t = function (e, t) {
      for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n);
      return n - 1;
    }(e, r);
    return function (e, t, n, c, i, r, a, o, s) {
      let l = s ? s(e) : e;
      if (l < t) {
        if ("identity" === a) return l;
        "clamp" === a && (l = t);
      }
      if (l > n) {
        if ("identity" === o) return l;
        "clamp" === o && (l = n);
      }
      if (c === i) return c;
      if (t === n) return e <= t ? c : i;
      t === -1 / 0 ? l = -l : n === 1 / 0 ? l -= t : l = (l - t) / (n - t);
      l = r(l), c === -1 / 0 ? l = -l : i === 1 / 0 ? l += c : l = l * (i - c) + c;
      return l;
    }(e, r[t], r[t + 1], i[t], i[t + 1], s, a, o, c.map);
  };
}
class KV extends IV {
  constructor(e, t, n, c) {
    super(), this.calc = void 0, this.payload = e instanceof IV && !(e instanceof KV) ? e.getPayload() : Array.isArray(e) ? e : [e], this.calc = ZV(t, n, c);
  }
  getValue() {
    return this.calc(...this.payload.map(e => e.getValue()));
  }
  updateConfig(e, t, n) {
    this.calc = ZV(e, t, n);
  }
  interpolate(e, t, n) {
    return new KV(this, e, t, n);
  }
}
const QV = (e, t, n) => e && new KV(e, t, n);
function JV(e, t) {
  "update" in e ? t.add(e) : e.getChildren().forEach(e => JV(e, t));
}
class ex extends DV {
  constructor(e) {
    var t;
    super(), t = this, this.animatedStyles = new Set(), this.value = void 0, this.startPosition = void 0, this.lastPosition = void 0, this.lastVelocity = void 0, this.startTime = void 0, this.lastTime = void 0, this.done = !1, this.setValue = function (e, n) {
      void 0 === n && (n = !0), t.value = e, n && t.flush();
    }, this.value = e, this.startPosition = e, this.lastPosition = e;
  }
  flush() {
    0 === this.animatedStyles.size && JV(this, this.animatedStyles), this.animatedStyles.forEach(e => e.update());
  }
  clearStyles() {
    this.animatedStyles.clear();
  }
  getValue() {
    return this.value;
  }
  interpolate(e, t, n) {
    return new KV(this, e, t, n);
  }
}
class tx extends IV {
  constructor(e) {
    super(), this.payload = e.map(e => new ex(e));
  }
  setValue(e, t) {
    void 0 === t && (t = !0), Array.isArray(e) ? e.length === this.payload.length && e.forEach((e, n) => this.payload[n].setValue(e, t)) : this.payload.forEach(n => n.setValue(e, t));
  }
  getValue() {
    return this.payload.map(e => e.getValue());
  }
  interpolate(e, t) {
    return new KV(this, e, t);
  }
}
let nx = 0;
class cx {
  constructor() {
    this.id = void 0, this.idle = !0, this.hasChanged = !1, this.guid = 0, this.local = 0, this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.values = {}, this.configs = [], this.listeners = [], this.queue = [], this.localQueue = void 0, this.getValues = () => this.interpolations, this.id = nx++;
  }
  update(e) {
    if (!e) return this;
    const t = AV(e),
      n = t.delay,
      c = void 0 === n ? 0 : n,
      i = t.to,
      r = SV(t, ["delay", "to"]);
    if (kV.arr(i) || kV.fun(i)) this.queue.push(NV({}, r, {
      delay: c,
      to: i
    }));else if (i) {
      let e = {};
      Object.entries(i).forEach(t => {
        let n = t[0];
        const i = NV({
            to: {
              [n]: t[1]
            },
            delay: OV(c, n)
          }, r),
          a = e[i.delay] && e[i.delay].to;
        e[i.delay] = NV({}, e[i.delay], i, {
          to: NV({}, a, i.to)
        });
      }), this.queue = Object.values(e);
    }
    return this.queue = this.queue.sort((e, t) => e.delay - t.delay), this.diff(r), this;
  }
  start(e) {
    if (this.queue.length) {
      this.idle = !1, this.localQueue && this.localQueue.forEach(e => {
        let t = e.from,
          n = void 0 === t ? {} : t,
          c = e.to,
          i = void 0 === c ? {} : c;
        kV.obj(n) && (this.merged = NV({}, n, this.merged)), kV.obj(i) && (this.merged = NV({}, this.merged, i));
      });
      const t = this.local = ++this.guid,
        n = this.localQueue = this.queue;
      this.queue = [], n.forEach((c, i) => {
        let r = c.delay,
          a = SV(c, ["delay"]);
        const o = c => {
          i === n.length - 1 && t === this.guid && c && (this.idle = !0, this.props.onRest && this.props.onRest(this.merged)), e && e();
        };
        let s = kV.arr(a.to) || kV.fun(a.to);
        r ? setTimeout(() => {
          t === this.guid && (s ? this.runAsync(a, o) : this.diff(a).start(o));
        }, r) : s ? this.runAsync(a, o) : this.diff(a).start(o);
      });
    } else kV.fun(e) && this.listeners.push(e), this.props.onStart && this.props.onStart(), t = this, $V.has(t) || $V.add(t), UV || (UV = !0, GV(XV));
    var t;
    return this;
  }
  stop(e) {
    return this.listeners.forEach(t => t(e)), this.listeners = [], this;
  }
  pause(e) {
    var t;
    return this.stop(!0), e && (t = this, $V.has(t) && $V.delete(t)), this;
  }
  runAsync(e, t) {
    var n = this;
    e.delay;
    let c = SV(e, ["delay"]);
    const i = this.local;
    let r = Promise.resolve(void 0);
    if (kV.arr(c.to)) for (let e = 0; e < c.to.length; e++) {
      const t = e,
        n = NV({}, c, AV(c.to[t]));
      kV.arr(n.config) && (n.config = n.config[t]), r = r.then(() => {
        if (i === this.guid) return new Promise(e => this.diff(n).start(e));
      });
    } else if (kV.fun(c.to)) {
      let e,
        t = 0;
      r = r.then(() => c.to(n => {
        const r = NV({}, c, AV(n));
        if (kV.arr(r.config) && (r.config = r.config[t]), t++, i === this.guid) return e = new Promise(e => this.diff(r).start(e));
      }, function (e) {
        return void 0 === e && (e = !0), n.stop(e);
      }).then(() => e));
    }
    r.then(t);
  }
  diff(e) {
    this.props = NV({}, this.props, e);
    let t = this.props,
      n = t.from,
      c = void 0 === n ? {} : n,
      i = t.to,
      r = void 0 === i ? {} : i,
      a = t.config,
      o = void 0 === a ? {} : a,
      s = t.reverse,
      l = t.attach,
      f = t.reset,
      u = t.immediate;
    if (s) {
      var d = [r, c];
      c = d[0], r = d[1];
    }
    this.merged = NV({}, c, this.merged, r), this.hasChanged = !1;
    let p = l && l(this);
    if (this.animations = Object.entries(this.merged).reduce((e, t) => {
      let n = t[0],
        i = t[1],
        r = e[n] || {};
      const a = kV.num(i),
        s = kV.str(i) && !i.startsWith("#") && !/\d/.test(i) && !RV[i],
        l = kV.arr(i),
        d = !a && !l && !s;
      let m = kV.und(c[n]) ? i : c[n],
        h = a || l || s ? i : 1,
        v = OV(o, n);
      p && (h = p.animations[n].parent);
      let g,
        b = r.parent,
        H = r.interpolation,
        z = TV(p ? h.getPayload() : h),
        y = i;
      d && (y = BV({
        range: [0, 1],
        output: [i, i]
      })(1));
      let V = H && H.getValue();
      const x = !kV.und(b) && r.animatedValues.some(e => !e.done),
        M = !kV.equ(y, V),
        _ = !kV.equ(y, r.previous),
        w = !kV.equ(v, r.config);
      if (f || _ && M || w) {
        if (a || s) b = H = r.parent || new ex(m);else if (l) b = H = r.parent || new tx(m);else if (d) {
          let e = r.interpolation && r.interpolation.calc(r.parent.value);
          e = void 0 === e || f ? m : e, r.parent ? (b = r.parent, b.setValue(0, !1)) : b = new ex(0);
          const t = {
            output: [e, i]
          };
          r.interpolation ? (H = r.interpolation, r.interpolation.updateConfig(t)) : H = b.interpolate(t);
        }
        return z = TV(p ? h.getPayload() : h), g = TV(b.getPayload()), f && !d && b.setValue(m, !1), this.hasChanged = !0, g.forEach(e => {
          e.startPosition = e.value, e.lastPosition = e.value, e.lastVelocity = x ? e.lastVelocity : void 0, e.lastTime = x ? e.lastTime : void 0, e.startTime = WV(), e.done = !1, e.animatedStyles.clear();
        }), OV(u, n) && b.setValue(d ? h : i, !1), NV({}, e, {
          [n]: NV({}, r, {
            name: n,
            parent: b,
            interpolation: H,
            animatedValues: g,
            toValues: z,
            previous: y,
            config: v,
            fromValues: TV(b.getValue()),
            immediate: OV(u, n),
            initialVelocity: PV(v.velocity, 0),
            clamp: PV(v.clamp, !1),
            precision: PV(v.precision, .01),
            tension: PV(v.tension, 170),
            friction: PV(v.friction, 26),
            mass: PV(v.mass, 1),
            duration: v.duration,
            easing: PV(v.easing, e => e),
            decay: v.decay
          })
        });
      }
      return M ? e : (d && (b.setValue(1, !1), H.updateConfig({
        output: [y, y]
      })), b.done = !0, this.hasChanged = !0, NV({}, e, {
        [n]: NV({}, e[n], {
          previous: y
        })
      }));
    }, this.animations), this.hasChanged) {
      this.configs = Object.values(this.animations), this.values = {}, this.interpolations = {};
      for (let e in this.animations) this.interpolations[e] = this.animations[e].interpolation, this.values[e] = this.animations[e].interpolation.getValue();
    }
    return this;
  }
  destroy() {
    this.stop(), this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.values = {}, this.configs = [], this.local = 0;
  }
}
const ix = e => {
  const t = kV.fun(e),
    c = ((e, t) => {
      const c = n(!1),
        r = n(),
        a = kV.fun(t),
        o = s(() => {
          let n;
          return r.current && (r.current.map(e => e.destroy()), r.current = void 0), [new Array(e).fill().map((e, c) => {
            const i = new cx(),
              r = a ? OV(t, c, i) : t[c];
            return 0 === c && (n = r.ref), i.update(r), n || i.start(), i;
          }), n];
        }, [e]),
        f = o[0],
        u = o[1];
      r.current = f, l(u, () => ({
        start: () => Promise.all(r.current.map(e => new Promise(t => e.start(t)))),
        stop: e => r.current.forEach(t => t.stop(e)),
        get controllers() {
          return r.current;
        }
      }));
      const d = s(() => e => r.current.map((t, n) => {
        t.update(a ? OV(e, n, t) : e[n]), u || t.start();
      }), [e]);
      i(() => {
        c.current ? a || d(t) : u || r.current.forEach(e => e.start());
      }), i(() => (c.current = !0, () => r.current.forEach(e => e.destroy())), []);
      const p = r.current.map(e => e.getValues());
      return a ? [p, d, e => r.current.forEach(t => t.pause(e))] : p;
    })(1, t ? e : [e]),
    r = c[0],
    a = c[1],
    o = c[2];
  return t ? [r[0], a, o] : r;
};
class rx extends jV {
  constructor(e) {
    void 0 === e && (e = {}), super(), !e.transform || e.transform instanceof DV || (e = FV.transform(e)), this.payload = e;
  }
}
const ax = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
  },
  ox = "[-+]?\\d*\\.?\\d+",
  sx = ox + "%";
function lx() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return "\\(\\s*(" + t.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const fx = new RegExp("rgb" + lx(ox, ox, ox)),
  ux = new RegExp("rgba" + lx(ox, ox, ox, ox)),
  dx = new RegExp("hsl" + lx(ox, sx, sx)),
  px = new RegExp("hsla" + lx(ox, sx, sx, ox)),
  mx = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hx = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  vx = /^#([0-9a-fA-F]{6})$/,
  gx = /^#([0-9a-fA-F]{8})$/;
function bx(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Hx(e, t, n) {
  const c = n < .5 ? n * (1 + t) : n + t - n * t,
    i = 2 * n - c,
    r = bx(i, c, e + 1 / 3),
    a = bx(i, c, e),
    o = bx(i, c, e - 1 / 3);
  return Math.round(255 * r) << 24 | Math.round(255 * a) << 16 | Math.round(255 * o) << 8;
}
function zx(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function yx(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function Vx(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(255 * t);
}
function xx(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function Mx(e) {
  let t = function (e) {
    let t;
    return "number" == typeof e ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = vx.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : ax.hasOwnProperty(e) ? ax[e] : (t = fx.exec(e)) ? (zx(t[1]) << 24 | zx(t[2]) << 16 | zx(t[3]) << 8 | 255) >>> 0 : (t = ux.exec(e)) ? (zx(t[1]) << 24 | zx(t[2]) << 16 | zx(t[3]) << 8 | Vx(t[4])) >>> 0 : (t = mx.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + "ff", 16) >>> 0 : (t = gx.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = hx.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + t[4] + t[4], 16) >>> 0 : (t = dx.exec(e)) ? (255 | Hx(yx(t[1]), xx(t[2]), xx(t[3]))) >>> 0 : (t = px.exec(e)) ? (Hx(yx(t[1]), xx(t[2]), xx(t[3])) | Vx(t[4])) >>> 0 : null;
  }(e);
  return null === t ? e : (t = t || 0, `rgba(${(4278190080 & t) >>> 24}, ${(16711680 & t) >>> 16}, ${(65280 & t) >>> 8}, ${(255 & t) / 255})`);
}
const _x = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
  wx = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
  Ex = new RegExp(`(${Object.keys(ax).join("|")})`, "g");
let Cx = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
};
const Lx = ["Webkit", "Ms", "Moz", "O"];
function Nx(e, t, n) {
  return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || Cx.hasOwnProperty(e) && Cx[e] ? ("" + t).trim() : t + "px";
}
Cx = Object.keys(Cx).reduce((e, t) => (Lx.forEach(n => e[((e, t) => e + t.charAt(0).toUpperCase() + t.substring(1))(n, t)] = e[t]), e), Cx);
const Sx = {};
YV = e => new rx(e), function (e) {
  BV = e;
}(e => {
  const t = e.output.map(e => e.replace(wx, Mx)).map(e => e.replace(Ex, Mx)),
    n = t[0].match(_x).map(() => []);
  t.forEach(e => {
    e.match(_x).forEach((e, t) => n[t].push(+e));
  });
  const c = t[0].match(_x).map((t, c) => ZV(NV({}, e, {
    output: n[c]
  })));
  return e => {
    let n = 0;
    return t[0].replace(_x, () => c[n++](e)).replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, (e, t, n, c, i) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(c)}, ${i})`);
  };
}), RV = ax, function (e, t) {
  FV = {
    fn: e,
    transform: t
  };
}((e, t) => {
  if (!e.nodeType || void 0 === e.setAttribute) return !1;
  {
    const i = t.style,
      r = t.children,
      a = t.scrollTop,
      o = t.scrollLeft,
      s = SV(t, ["style", "children", "scrollTop", "scrollLeft"]),
      l = "filter" === e.nodeName || e.parentNode && "filter" === e.parentNode.nodeName;
    void 0 !== a && (e.scrollTop = a), void 0 !== o && (e.scrollLeft = o), void 0 !== r && (e.textContent = r);
    for (let t in i) if (i.hasOwnProperty(t)) {
      var n = 0 === t.indexOf("--"),
        c = Nx(t, i[t], n);
      "float" === t && (t = "cssFloat"), n ? e.style.setProperty(t, c) : e.style[t] = c;
    }
    for (let t in s) {
      const n = l ? t : Sx[t] || (Sx[t] = t.replace(/([A-Z])/g, e => "-" + e.toLowerCase()));
      void 0 !== e.getAttribute(n) && e.setAttribute(n, s[t]);
    }
  }
}, e => e);
const kx = (Px = e => {
  const r = /*#__PURE__*/f((r, o) => {
    const s = function () {
        const e = c(!1)[1],
          t = a(() => e(e => !e), []);
        return t;
      }(),
      f = n(!0),
      u = n(null),
      d = n(null),
      p = a(e => {
        const t = u.current;
        u.current = new qV(e, () => {
          let e = !1;
          d.current && (e = FV.fn(d.current, u.current.getAnimatedValue())), d.current && !1 !== e || s();
        }), t && t.detach();
      }, []);
    i(() => () => {
      f.current = !1, u.current && u.current.detach();
    }, []), l(o, () => (e => e.current)(d)), p(r);
    const m = u.current.getValue();
    m.scrollTop, m.scrollLeft;
    const h = SV(m, ["scrollTop", "scrollLeft"]),
      v = (g = e, !kV.fun(g) || g.prototype instanceof t.Component ? e => d.current = function (e, t) {
        return t && (kV.fun(t) ? t(e) : kV.obj(t) && (t.current = e)), e;
      }(e, o) : void 0);
    var g;
    return /*#__PURE__*/t.createElement(e, NV({}, h, {
      ref: v
    }));
  });
  return r;
}, void 0 === (Tx = !1) && (Tx = !0), e => (kV.arr(e) ? e : Object.keys(e)).reduce((e, t) => {
  const n = Tx ? t[0].toLowerCase() + t.substring(1) : t;
  return e[n] = Px(n), e;
}, Px));
var Px, Tx;
const Ox = kx(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]);
function Ax(e, t) {
  return e.map(function (e, n) {
    return e + t[n];
  });
}
function Dx(e, t) {
  return e.map(function (e, n) {
    return e - t[n];
  });
}
function Ix(e) {
  return Math.hypot.apply(Math, e);
}
function jx(e) {
  return Math.sign ? Math.sign(e) : Number(e > 0) - Number(e < 0) || +e;
}
function Fx(e, t, n) {
  return 0 === t || Math.abs(t) === 1 / 0 ? function (e, t) {
    return Math.pow(e, 5 * t);
  }(e, n) : e * t * n / (t + n * e);
}
function Rx(e, t, n, c) {
  return void 0 === c && (c = .15), 0 === c ? function (e, t, n) {
    return Math.max(t, Math.min(e, n));
  }(e, t, n) : e < t ? -Fx(t - e, n - t, c) + t : e > n ? +Fx(e - n, n - t, c) + n : e;
}
function Bx(e, t) {
  for (var n = 0; n < t.length; n++) {
    var c = t[n];
    c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(e, c.key, c);
  }
}
function Gx() {
  return Gx = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, Gx.apply(this, arguments);
}
function Yx(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function Wx(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qx(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, c = new Array(t); n < t; n++) c[n] = e[n];
  return c;
}
function Ux(e, t) {
  var n;
  if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
    if (Array.isArray(e) || (n = function (e, t) {
      if (e) {
        if ("string" == typeof e) return qx(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? qx(e, t) : void 0;
      }
    }(e)) || t && e && "number" == typeof e.length) {
      n && (e = n);
      var c = 0;
      return function () {
        return c >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[c++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  return (n = e[Symbol.iterator]()).next.bind(n);
}
function $x() {}
function Xx() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return 0 === t.length ? $x : 1 === t.length ? t[0] : function () {
    for (var e, n, c = Ux(t); !(n = c()).done;) {
      e = n.value.apply(this, arguments) || e;
    }
    return e;
  };
}
function Zx(e, t) {
  if (void 0 === e) {
    if (void 0 === t) throw new Error("Must define fallback value if undefined is expected");
    e = t;
  }
  return Array.isArray(e) ? e : [e, e];
}
function Kx(e) {
  if ("function" == typeof e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++) n[c - 1] = arguments[c];
    return e.apply(void 0, n);
  }
  return e;
}
function Qx(e, t) {
  void 0 === e && (e = {});
  for (var n = {}, c = 0, i = Object.entries(t); c < i.length; c++) {
    var r = i[c],
      a = r[0],
      o = r[1];
    switch (typeof o) {
      case "function":
        n[a] = o.call(n, e[a], a, e);
        break;
      case "object":
        n[a] = Qx(e[a], o);
        break;
      case "boolean":
        o && (n[a] = e[a]);
    }
  }
  return n;
}
var Jx = Gx({}, {
    threshold: function (e) {
      return void 0 === e && (e = 0), Zx(e);
    },
    rubberband: function (e) {
      switch (void 0 === e && (e = 0), e) {
        case !0:
          return Zx(.15);
        case !1:
          return Zx(0);
        default:
          return Zx(e);
      }
    },
    enabled: function (e) {
      return void 0 === e && (e = !0), e;
    },
    triggerAllEvents: function (e) {
      return void 0 === e && (e = !1), e;
    },
    initial: function (e) {
      return void 0 === e && (e = 0), "function" == typeof e ? e : Zx(e);
    }
  }, {
    axis: !0,
    lockDirection: function (e) {
      return void 0 === e && (e = !1), e;
    },
    bounds: function (e) {
      if (void 0 === e && (e = {}), "function" == typeof e) return function (t) {
        return Jx.bounds(e(t));
      };
      var t = e,
        n = t.left,
        c = void 0 === n ? -1 / 0 : n,
        i = t.right,
        r = void 0 === i ? 1 / 0 : i,
        a = t.top,
        o = void 0 === a ? -1 / 0 : a,
        s = t.bottom;
      return [[c, r], [o, void 0 === s ? 1 / 0 : s]];
    }
  }),
  eM = "undefined" != typeof window && window.document && window.document.createElement,
  tM = {
    enabled: function (e) {
      return void 0 === e && (e = !0), e;
    },
    domTarget: !0,
    window: function (e) {
      function t(t) {
        return e.apply(this, arguments);
      }
      return t.toString = function () {
        return e.toString();
      }, t;
    }(function (e) {
      return void 0 === e && (e = eM ? window : void 0), e;
    }),
    eventOptions: function (e) {
      var t = void 0 === e ? {} : e,
        n = t.passive,
        c = void 0 === n || n,
        i = t.capture;
      return {
        passive: c,
        capture: void 0 !== i && i
      };
    }
  },
  nM = Gx({}, Jx, {
    threshold: function (e, t, n) {
      var c = n.filterTaps,
        i = void 0 !== c && c,
        r = n.lockDirection,
        a = void 0 !== r && r,
        o = n.axis,
        s = Zx(e, i ? 3 : a || (void 0 === o ? void 0 : o) ? 1 : 0);
      return this.filterTaps = i || s[0] + s[1] > 0, s;
    },
    swipeVelocity: function (e) {
      return void 0 === e && (e = .5), Zx(e);
    },
    swipeDistance: function (e) {
      return void 0 === e && (e = 60), Zx(e);
    },
    delay: function (e) {
      switch (void 0 === e && (e = 0), e) {
        case !0:
          return 180;
        case !1:
          return 0;
        default:
          return e;
      }
    }
  });
function cM(e) {
  var t = e.domTarget,
    n = e.eventOptions,
    c = e.window,
    i = e.enabled,
    r = function (e, t) {
      if (null == e) return {};
      var n,
        c,
        i = {},
        r = Object.keys(e);
      for (c = 0; c < r.length; c++) n = r[c], t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }(e, ["domTarget", "eventOptions", "window", "enabled"]),
    a = function (e) {
      return void 0 === e && (e = {}), Qx(e, tM);
    }({
      domTarget: t,
      eventOptions: n,
      window: c,
      enabled: i
    });
  return a.drag = function (e) {
    return void 0 === e && (e = {}), Qx(e, nM);
  }(r), a;
}
function iM(e) {
  return Gx({
    _active: !1,
    _blocked: !1,
    _intentional: [!1, !1],
    _movement: [0, 0],
    _initial: [0, 0],
    _bounds: [[-1 / 0, 1 / 0], [-1 / 0, 1 / 0]],
    _lastEventType: void 0,
    event: void 0,
    intentional: !1,
    values: [0, 0],
    velocities: [0, 0],
    delta: [0, 0],
    movement: [0, 0],
    offset: [0, 0],
    lastOffset: [0, 0],
    direction: [0, 0],
    initial: [0, 0],
    previous: [0, 0],
    first: !1,
    last: !1,
    active: !1,
    timeStamp: 0,
    startTime: 0,
    elapsedTime: 0,
    cancel: $x,
    canceled: !1,
    memo: void 0,
    args: void 0
  }, e);
}
function rM() {
  return {
    shared: {
      hovering: !1,
      scrolling: !1,
      wheeling: !1,
      dragging: !1,
      moving: !1,
      pinching: !1,
      touches: 0,
      buttons: 0,
      down: !1,
      shiftKey: !1,
      altKey: !1,
      metaKey: !1,
      ctrlKey: !1
    },
    drag: iM({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0,
      _isTap: !0,
      _delayedEvent: !1,
      _pointerId: void 0,
      tap: !1,
      swipe: [0, 0]
    }),
    pinch: iM({
      da: [0, 0],
      vdva: [0, 0],
      origin: void 0,
      turns: 0
    }),
    wheel: iM({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0
    }),
    move: iM({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0
    }),
    scroll: iM({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0
    })
  };
}
var aM = new Map(),
  oM = function () {
    function e(e, t) {
      var n = this;
      void 0 === t && (t = []), this.controller = e, this.args = t, this.debounced = !0, this.setTimeout = function (e, t) {
        var c;
        void 0 === t && (t = 140), clearTimeout(n.controller.timeouts[n.stateKey]);
        for (var i = arguments.length, r = new Array(i > 2 ? i - 2 : 0), a = 2; a < i; a++) r[a - 2] = arguments[a];
        n.controller.timeouts[n.stateKey] = (c = window).setTimeout.apply(c, [e, t].concat(r));
      }, this.clearTimeout = function () {
        clearTimeout(n.controller.timeouts[n.stateKey]);
      }, this.fireGestureHandler = function (e) {
        if (void 0 === e && (e = !1), n.state._blocked) return n.debounced || (n.state._active = !1, n.clean()), null;
        if (!e && !n.state.intentional && !n.config.triggerAllEvents) return null;
        if (n.state.intentional) {
          var t = n.state.active,
            c = n.state._active;
          n.state.active = c, n.state.first = c && !t, n.state.last = t && !c, n.controller.state.shared[n.ingKey] = c;
        }
        var i = Gx({}, n.controller.state.shared, n.state, n.mapStateValues(n.state)),
          r = n.handler(i);
        return n.state.memo = void 0 !== r ? r : n.state.memo, n.state._active || n.clean(), i;
      };
    }
    var t,
      n,
      c,
      i = e.prototype;
    return i.updateSharedState = function (e) {
      Object.assign(this.controller.state.shared, e);
    }, i.updateGestureState = function (e) {
      Object.assign(this.state, e);
    }, i.checkIntentionality = function (e, t) {
      return {
        _intentional: e,
        _blocked: !1
      };
    }, i.getMovement = function (e) {
      var t = this.config,
        n = t.initial,
        c = t.bounds,
        i = t.rubberband,
        r = t.threshold,
        a = this.state,
        o = a._bounds,
        s = a._initial,
        l = a._active,
        f = a._intentional,
        u = a.lastOffset,
        d = a.movement,
        p = this.getInternalMovement(e, this.state),
        m = !1 === f[0] ? sM(p[0], r[0]) : f[0],
        h = !1 === f[1] ? sM(p[1], r[1]) : f[1],
        v = this.checkIntentionality([m, h], p);
      if (v._blocked) return Gx({}, v, {
        _movement: p,
        delta: [0, 0]
      });
      var g,
        b,
        H,
        z,
        y = v._intentional,
        V = p;
      (!1 !== y[0] && !1 === f[0] && (b = Kx(n, this.state), g = Kx(c, this.state), s[0] = b[0], o[0] = g[0]), !1 !== y[1] && !1 === f[1]) && (b = null != (H = b) ? H : Kx(n, this.state), g = null != (z = g) ? z : Kx(c, this.state), s[1] = b[1], o[1] = g[1]);
      var x = [!1 !== y[0] ? p[0] - y[0] : s[0], !1 !== y[1] ? p[1] - y[1] : s[1]],
        M = Ax(x, u),
        _ = l ? i : [0, 0];
      return x = lM(o, Ax(x, s), _), Gx({}, v, {
        intentional: !1 !== y[0] || !1 !== y[1],
        _initial: s,
        _movement: V,
        movement: x,
        values: e,
        offset: lM(o, M, _),
        delta: Dx(x, d)
      });
    }, i.clean = function () {
      this.clearTimeout();
    }, t = e, (n = [{
      key: "config",
      get: function () {
        return this.controller.config[this.stateKey];
      }
    }, {
      key: "enabled",
      get: function () {
        return this.controller.config.enabled && this.config.enabled;
      }
    }, {
      key: "state",
      get: function () {
        return this.controller.state[this.stateKey];
      }
    }, {
      key: "handler",
      get: function () {
        return this.controller.handlers[this.stateKey];
      }
    }]) && Bx(t.prototype, n), c && Bx(t, c), e;
  }();
function sM(e, t) {
  return Math.abs(e) >= t && jx(e) * t;
}
function lM(e, t, n) {
  var c = t[0],
    i = t[1],
    r = n[0],
    a = n[1],
    o = e[0],
    s = o[0],
    l = o[1],
    f = e[1],
    u = f[0],
    d = f[1];
  return [Rx(c, s, l, r), Rx(i, u, d, a)];
}
function fM(e, t, n) {
  var c = e.state,
    i = e.args,
    r = t.timeStamp,
    a = t.type,
    o = c.values;
  return {
    _lastEventType: a,
    event: t,
    timeStamp: r,
    elapsedTime: n ? 0 : r - c.startTime,
    args: i,
    previous: o
  };
}
function uM(e, t) {
  return function (n) {
    for (var c = arguments.length, i = new Array(c > 1 ? c - 1 : 0), r = 1; r < c; r++) i[r - 1] = arguments[r];
    return e.call.apply(e, [this, Gx({}, t, {
      event: n
    })].concat(i));
  };
}
var dM = function (e) {
  var t = this;
  this.classes = e, this.bind = function () {
    for (var e = {}, n = arguments.length, c = new Array(n), i = 0; i < n; i++) c[i] = arguments[i];
    for (var r, a = Ux(t.classes); !(r = a()).done;) {
      new (0, r.value)(t, c).addBindings(e);
    }
    for (var o = 0, s = Object.entries(t.nativeRefs); o < s.length; o++) {
      var l = s[o];
      hM(e, l[0], uM(l[1], Gx({}, t.state.shared, {
        args: c
      })));
    }
    return t.config.domTarget ? function (e, t) {
      var n = e.config,
        c = e.domListeners,
        i = mM(n);
      if (!i) throw new Error("domTarget must be defined");
      var r = n.eventOptions;
      gM(i, pM(c), r);
      for (var a = 0, o = Object.entries(t); a < o.length; a++) {
        var s = o[a],
          l = s[0],
          f = s[1],
          u = l.slice(2).toLowerCase();
        c.push([u, Xx.apply(void 0, f)]);
      }
      vM(i, c, r);
    }(t, e) : function (e, t) {
      for (var n = e.config, c = {}, i = n.eventOptions.capture ? "Capture" : "", r = 0, a = Object.entries(t); r < a.length; r++) {
        var o = a[r],
          s = o[0],
          l = o[1],
          f = Array.isArray(l) ? l : [l];
        c[s + i] = Xx.apply(void 0, f);
      }
      return c;
    }(t, e);
  }, this.effect = function () {
    return t.config.domTarget && t.bind(), t.clean;
  }, this.clean = function () {
    var e = mM(t.config),
      n = t.config.eventOptions;
    e && gM(e, pM(t.domListeners), n), Object.values(t.timeouts).forEach(clearTimeout), function (e) {
      var t = e.config,
        n = t.window,
        c = t.eventOptions,
        i = e.windowListeners;
      if (!n) return;
      for (var r in i) {
        gM(n, i[r], c);
      }
      e.windowListeners = {};
    }(t);
  }, this.state = rM(), this.timeouts = {}, this.domListeners = [], this.windowListeners = {};
};
function pM(e) {
  return void 0 === e && (e = []), e.splice(0, e.length);
}
function mM(e) {
  var t = e.domTarget;
  return t && "current" in t ? t.current : t;
}
function hM(e, t, n) {
  e[t] || (e[t] = []), e[t].push(n);
}
function vM(e, t, n) {
  void 0 === t && (t = []), void 0 === n && (n = {});
  for (var c, i = Ux(t); !(c = i()).done;) {
    var r = c.value,
      a = r[0],
      o = r[1];
    e.addEventListener(a, o, n);
  }
}
function gM(e, t, n) {
  void 0 === t && (t = []), void 0 === n && (n = {});
  for (var c, i = Ux(t); !(c = i()).done;) {
    var r = c.value,
      a = r[0],
      o = r[1];
    e.removeEventListener(a, o, n);
  }
}
function bM(e, n, c) {
  void 0 === c && (c = {});
  var i = function (e) {
      var t = new Set();
      e.drag && t.add(aM.get("drag"));
      e.wheel && t.add(aM.get("wheel"));
      e.scroll && t.add(aM.get("scroll"));
      e.move && t.add(aM.get("move"));
      e.pinch && t.add(aM.get("pinch"));
      e.hover && t.add(aM.get("hover"));
      return t;
    }(e),
    r = t.useMemo(function () {
      return new dM(i);
    }, []);
  return r.config = n, r.handlers = e, r.nativeRefs = c, t.useEffect(r.effect, []), r.config.domTarget ? HM : r.bind;
}
function HM() {
  "development" === process.env.NODE_ENV && console.warn("Deprecation notice: When the `domTarget` option is specified, you don't need to write `useEffect(bind, [bind])` anymore: event binding is now made handled internally to this lib.\n\nNext version won't return anything when `domTarget` is provided, therefore your code will break if you try to call `useEffect`.");
}
var zM = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  Yx(t, e);
  var n = t.prototype;
  return n.getInternalMovement = function (e, t) {
    return Dx(e, t.initial);
  }, n.checkIntentionality = function (e, t) {
    if (!1 === e[0] && !1 === e[1]) return {
      _intentional: e,
      axis: this.state.axis
    };
    var n = t.map(Math.abs),
      c = n[0],
      i = n[1],
      r = this.state.axis || (c > i ? "x" : c < i ? "y" : void 0);
    return this.config.axis || this.config.lockDirection ? r ? this.config.axis && r !== this.config.axis ? {
      _intentional: e,
      _blocked: !0,
      axis: r
    } : (e["x" === r ? 1 : 0] = !1, {
      _intentional: e,
      _blocked: !1,
      axis: r
    }) : {
      _intentional: [!1, !1],
      _blocked: !1,
      axis: r
    } : {
      _intentional: e,
      _blocked: !1,
      axis: r
    };
  }, n.getKinematics = function (e, t) {
    var n = this.getMovement(e);
    if (!n._blocked) {
      var c = t.timeStamp - this.state.timeStamp;
      Object.assign(n, function (e, t, n) {
        var c = Ix(t),
          i = 0 === c ? 0 : 1 / c,
          r = 0 === n ? 0 : 1 / n,
          a = r * c,
          o = t.map(function (e) {
            return r * e;
          }),
          s = t.map(function (e) {
            return i * e;
          });
        return {
          velocities: o,
          velocity: a,
          distance: Ix(e),
          direction: s
        };
      }(n.movement, n.delta, c));
    }
    return n;
  }, n.mapStateValues = function (e) {
    return {
      xy: e.values,
      vxvy: e.velocities
    };
  }, t;
}(oM);
function yM(e) {
  if ("touches" in e) {
    var t = e.targetTouches,
      n = e.changedTouches;
    return t.length > 0 ? t : n;
  }
  return null;
}
function VM(e) {
  var t = "buttons" in e ? e.buttons : 0,
    n = yM(e),
    c = n && n.length || 0;
  return {
    touches: c,
    down: c > 0 || t > 0,
    buttons: t,
    shiftKey: e.shiftKey,
    altKey: e.altKey,
    metaKey: e.metaKey,
    ctrlKey: e.ctrlKey
  };
}
function xM(e) {
  var t = yM(e),
    n = t ? t[0] : e;
  return [n.clientX, n.clientY];
}
var MM = function (e) {
  function t() {
    var t;
    return (t = e.apply(this, arguments) || this).ingKey = "dragging", t.stateKey = "drag", t.onDragStart = function (e) {
      t.enabled && !t.state._active && (!function (e, t, n) {
        var c = e.config,
          i = e.windowListeners;
        void 0 === n && (n = []), c.window && (gM(c.window, i[t], c.eventOptions), vM(c.window, i[t] = n, c.eventOptions));
      }(t.controller, t.stateKey, [["pointermove", t.onDragChange], ["pointerup", t.onDragEnd], ["pointercancel", t.onDragEnd]]), t.updateGestureState({
        _pointerId: e.pointerId
      }), t.config.delay > 0 ? (t.state._delayedEvent = !0, "persist" in e && "function" == typeof e.persist && e.persist(), t.setTimeout(t.startDrag.bind(Wx(t)), t.config.delay, e)) : t.startDrag(e));
    }, t.onDragChange = function (e) {
      if (!t.state.canceled && e.pointerId === t.state._pointerId) if (t.state._active) {
        var n = VM(e);
        if (n.down) {
          t.updateSharedState(n);
          var c = xM(e),
            i = t.getKinematics(c, e),
            r = fM(Wx(t), e),
            a = t.state._isTap,
            o = Ix(i._movement);
          a && o >= 3 && (a = !1), t.updateGestureState(Gx({}, r, i, {
            _isTap: a
          })), t.fireGestureHandler();
        } else t.onDragEnd(e);
      } else t.state._delayedEvent && (t.clearTimeout(), t.startDrag(e));
    }, t.onDragEnd = function (e) {
      if (e.pointerId === t.state._pointerId) {
        t.state._active = !1, t.updateSharedState({
          down: !1,
          buttons: 0,
          touches: 0
        });
        var n = t.state._isTap,
          c = t.state.velocities,
          i = c[0],
          r = c[1],
          a = t.state.movement,
          o = a[0],
          s = a[1],
          l = t.state._intentional,
          f = l[0],
          u = l[1],
          d = t.config.swipeVelocity,
          p = d[0],
          m = d[1],
          h = t.config.swipeDistance,
          v = h[0],
          g = h[1],
          b = Gx({}, fM(Wx(t), e), t.getMovement(t.state.values)),
          H = [0, 0];
        b.elapsedTime < 220 && (!1 !== f && Math.abs(i) > p && Math.abs(o) > v && (H[0] = jx(i)), !1 !== u && Math.abs(r) > m && Math.abs(s) > g && (H[1] = jx(r))), t.updateGestureState(Gx({}, b, {
          tap: n,
          swipe: H
        })), t.fireGestureHandler(!0 === n);
      }
    }, t.clean = function () {
      e.prototype.clean.call(Wx(t)), t.state._delayedEvent = !1, function (e, t) {
        var n = e.config,
          c = e.windowListeners;
        n.window && (gM(n.window, c[t], n.eventOptions), delete c[t]);
      }(t.controller, t.stateKey);
    }, t.onCancel = function () {
      t.state.canceled || (t.updateGestureState({
        canceled: !0
      }), t.state._active = !1, t.updateSharedState({
        down: !1,
        buttons: 0,
        touches: 0
      }), requestAnimationFrame(function () {
        return t.fireGestureHandler();
      }));
    }, t.onClick = function (e) {
      t.state._isTap || e.stopPropagation();
    }, t;
  }
  Yx(t, e);
  var n = t.prototype;
  return n.startDrag = function (e) {
    var t = xM(e);
    this.updateSharedState(VM(e)), this.updateGestureState(Gx({}, function (e, t, n) {
      var c = e.state.offset,
        i = n.timeStamp;
      return Gx({}, rM()[e.stateKey], {
        _active: !0,
        values: t,
        initial: t,
        offset: c,
        lastOffset: c,
        startTime: i
      });
    }(this, t, e), fM(this, e, !0), {
      _pointerId: e.pointerId,
      cancel: this.onCancel
    })), this.updateGestureState(this.getMovement(t)), this.fireGestureHandler();
  }, n.addBindings = function (e) {
    (hM(e, "onPointerDown", this.onDragStart), this.config.filterTaps) && hM(e, this.controller.config.eventOptions.capture ? "onClick" : "onClickCapture", this.onClick);
  }, t;
}(zM);
function _M(e, t) {
  if (e === t) return !0;
  if (e && t && "object" == typeof e && "object" == typeof t) {
    if (e.constructor !== t.constructor) return !1;
    var n, c, i, r;
    if (Array.isArray(e)) {
      if ((n = e.length) !== t.length) return !1;
      for (c = n; 0 != c--;) if (!_M(e[c], t[c])) return !1;
      return !0;
    }
    if ("function" == typeof Map && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (r = e.entries(); !(c = r.next()).done;) if (!t.has(c.value[0])) return !1;
      for (r = e.entries(); !(c = r.next()).done;) if (!_M(c.value[1], t.get(c.value[0]))) return !1;
      return !0;
    }
    if ("function" == typeof Set && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (r = e.entries(); !(c = r.next()).done;) if (!t.has(c.value[0])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if ((n = (i = Object.keys(e)).length) !== Object.keys(t).length) return !1;
    for (c = n; 0 != c--;) if (!Object.prototype.hasOwnProperty.call(t, i[c])) return !1;
    if ("undefined" != typeof Element && e instanceof Element) return !1;
    for (c = n; 0 != c--;) if (!("_owner" === i[c] && e.$$typeof || _M(e[i[c]], t[i[c]]))) return !1;
    return !0;
  }
  return e != e && t != t;
}
function wM(e, t) {
  try {
    return _M(e, t);
  } catch (e) {
    if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw e;
  }
}
function EM(e, t) {
  void 0 === t && (t = {}), aM.set("drag", MM);
  var c = n();
  return c.current || (c.current = function (e, t) {
    var n,
      c,
      i = [],
      r = !1;
    return function () {
      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) o[s] = arguments[s];
      return r && n === this && t(o, i) || (c = e.apply(this, o), r = !0, n = this, i = o), c;
    };
  }(cM, wM)), bM({
    drag: e
  }, c.current(t));
}
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var CM = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"],
  LM = CM.join(","),
  NM = "undefined" == typeof Element,
  SM = NM ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  kM = !NM && Element.prototype.getRootNode ? function (e) {
    return e.getRootNode();
  } : function (e) {
    return e.ownerDocument;
  },
  PM = function (e, t, n) {
    var c = Array.prototype.slice.apply(e.querySelectorAll(LM));
    return t && SM.call(e, LM) && c.unshift(e), c = c.filter(n);
  },
  TM = function e(t, n, c) {
    for (var i = [], r = Array.from(t); r.length;) {
      var a = r.shift();
      if ("SLOT" === a.tagName) {
        var o = a.assignedElements(),
          s = e(o.length ? o : a.children, !0, c);
        c.flatten ? i.push.apply(i, s) : i.push({
          scope: a,
          candidates: s
        });
      } else {
        SM.call(a, LM) && c.filter(a) && (n || !t.includes(a)) && i.push(a);
        var l = a.shadowRoot || "function" == typeof c.getShadowRoot && c.getShadowRoot(a),
          f = !c.shadowRootFilter || c.shadowRootFilter(a);
        if (l && f) {
          var u = e(!0 === l ? a.children : l.children, !0, c);
          c.flatten ? i.push.apply(i, u) : i.push({
            scope: a,
            candidates: u
          });
        } else r.unshift.apply(r, a.children);
      }
    }
    return i;
  },
  OM = function (e, t) {
    return e.tabIndex < 0 && (t || /^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || e.isContentEditable) && isNaN(parseInt(e.getAttribute("tabindex"), 10)) ? 0 : e.tabIndex;
  },
  AM = function (e, t) {
    return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
  },
  DM = function (e) {
    return "INPUT" === e.tagName;
  },
  IM = function (e) {
    return function (e) {
      return DM(e) && "radio" === e.type;
    }(e) && !function (e) {
      if (!e.name) return !0;
      var t,
        n = e.form || kM(e),
        c = function (e) {
          return n.querySelectorAll('input[type="radio"][name="' + e + '"]');
        };
      if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t = c(window.CSS.escape(e.name));else try {
        t = c(e.name);
      } catch (e) {
        return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
      }
      var i = function (e, t) {
        for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
      }(t, e.form);
      return !i || i === e;
    }(e);
  },
  jM = function (e) {
    var t = e.getBoundingClientRect(),
      n = t.width,
      c = t.height;
    return 0 === n && 0 === c;
  },
  FM = function (e, t) {
    return !(t.disabled || function (e) {
      return DM(e) && "hidden" === e.type;
    }(t) || function (e, t) {
      var n = t.displayCheck,
        c = t.getShadowRoot;
      if ("hidden" === getComputedStyle(e).visibility) return !0;
      var i = SM.call(e, "details>summary:first-of-type") ? e.parentElement : e;
      if (SM.call(i, "details:not([open]) *")) return !0;
      var r = kM(e).host,
        a = (null == r ? void 0 : r.ownerDocument.contains(r)) || e.ownerDocument.contains(e);
      if (n && "full" !== n) {
        if ("non-zero-area" === n) return jM(e);
      } else {
        if ("function" == typeof c) {
          for (var o = e; e;) {
            var s = e.parentElement,
              l = kM(e);
            if (s && !s.shadowRoot && !0 === c(s)) return jM(e);
            e = e.assignedSlot ? e.assignedSlot : s || l === e.ownerDocument ? s : l.host;
          }
          e = o;
        }
        if (a) return !e.getClientRects().length;
      }
      return !1;
    }(t, e) || function (e) {
      return "DETAILS" === e.tagName && Array.prototype.slice.apply(e.children).some(function (e) {
        return "SUMMARY" === e.tagName;
      });
    }(t) || function (e) {
      if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
        if ("FIELDSET" === t.tagName && t.disabled) {
          for (var n = 0; n < t.children.length; n++) {
            var c = t.children.item(n);
            if ("LEGEND" === c.tagName) return !!SM.call(t, "fieldset[disabled] *") || !c.contains(e);
          }
          return !0;
        }
        t = t.parentElement;
      }
      return !1;
    }(t));
  },
  RM = function (e, t) {
    return !(IM(t) || OM(t) < 0 || !FM(e, t));
  },
  BM = function (e) {
    var t = parseInt(e.getAttribute("tabindex"), 10);
    return !!(isNaN(t) || t >= 0);
  },
  GM = function e(t) {
    var n = [],
      c = [];
    return t.forEach(function (t, i) {
      var r = !!t.scope,
        a = r ? t.scope : t,
        o = OM(a, r),
        s = r ? e(t.candidates) : a;
      0 === o ? r ? n.push.apply(n, s) : n.push(a) : c.push({
        documentOrder: i,
        tabIndex: o,
        item: t,
        isScope: r,
        content: s
      });
    }), c.sort(AM).reduce(function (e, t) {
      return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
    }, []).concat(n);
  },
  YM = function (e, t) {
    var n;
    return n = (t = t || {}).getShadowRoot ? TM([e], t.includeContainer, {
      filter: RM.bind(null, t),
      flatten: !1,
      getShadowRoot: t.getShadowRoot,
      shadowRootFilter: BM
    }) : PM(e, t.includeContainer, RM.bind(null, t)), GM(n);
  },
  WM = function (e, t) {
    if (t = t || {}, !e) throw new Error("No node provided");
    return !1 !== SM.call(e, LM) && RM(t, e);
  },
  qM = CM.concat("iframe").join(","),
  UM = function (e, t) {
    if (t = t || {}, !e) throw new Error("No node provided");
    return !1 !== SM.call(e, qM) && FM(t, e);
  };
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function $M(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    t && (c = c.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, c);
  }
  return n;
}
function XM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? $M(Object(n), !0).forEach(function (t) {
      ZM(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $M(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function ZM(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var KM,
  QM = (KM = [], {
    activateTrap: function (e) {
      if (KM.length > 0) {
        var t = KM[KM.length - 1];
        t !== e && t.pause();
      }
      var n = KM.indexOf(e);
      -1 === n || KM.splice(n, 1), KM.push(e);
    },
    deactivateTrap: function (e) {
      var t = KM.indexOf(e);
      -1 !== t && KM.splice(t, 1), KM.length > 0 && KM[KM.length - 1].unpause();
    }
  }),
  JM = function (e) {
    return setTimeout(e, 0);
  },
  e_ = function (e, t) {
    var n = -1;
    return e.every(function (e, c) {
      return !t(e) || (n = c, !1);
    }), n;
  },
  t_ = function (e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), c = 1; c < t; c++) n[c - 1] = arguments[c];
    return "function" == typeof e ? e.apply(void 0, n) : e;
  },
  n_ = function (e) {
    return e.target.shadowRoot && "function" == typeof e.composedPath ? e.composedPath()[0] : e.target;
  },
  c_ = function (e, t) {
    var n,
      c = (null == t ? void 0 : t.document) || document,
      i = XM({
        returnFocusOnDeactivate: !0,
        escapeDeactivates: !0,
        delayInitialFocus: !0
      }, t),
      r = {
        containers: [],
        containerGroups: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        delayInitialFocusTimer: void 0
      },
      a = function (e, t, n) {
        return e && void 0 !== e[t] ? e[t] : i[n || t];
      },
      o = function (e) {
        return r.containerGroups.findIndex(function (t) {
          var n = t.container,
            c = t.tabbableNodes;
          return n.contains(e) || c.find(function (t) {
            return t === e;
          });
        });
      },
      s = function (e) {
        var t = i[e];
        if ("function" == typeof t) {
          for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) r[a - 1] = arguments[a];
          t = t.apply(void 0, r);
        }
        if (!0 === t && (t = void 0), !t) {
          if (void 0 === t || !1 === t) return t;
          throw new Error("`".concat(e, "` was specified but was not a node, or did not return a node"));
        }
        var o = t;
        if ("string" == typeof t && !(o = c.querySelector(t))) throw new Error("`".concat(e, "` as selector refers to no known node"));
        return o;
      },
      l = function () {
        var e = s("initialFocus");
        if (!1 === e) return !1;
        if (void 0 === e) if (o(c.activeElement) >= 0) e = c.activeElement;else {
          var t = r.tabbableGroups[0];
          e = t && t.firstTabbableNode || s("fallbackFocus");
        }
        if (!e) throw new Error("Your focus-trap needs to have at least one focusable element");
        return e;
      },
      f = function () {
        if (r.containerGroups = r.containers.map(function (e) {
          var t = YM(e, i.tabbableOptions),
            n = function (e, t) {
              return (t = t || {}).getShadowRoot ? TM([e], t.includeContainer, {
                filter: FM.bind(null, t),
                flatten: !0,
                getShadowRoot: t.getShadowRoot
              }) : PM(e, t.includeContainer, FM.bind(null, t));
            }(e, i.tabbableOptions);
          return {
            container: e,
            tabbableNodes: t,
            focusableNodes: n,
            firstTabbableNode: t.length > 0 ? t[0] : null,
            lastTabbableNode: t.length > 0 ? t[t.length - 1] : null,
            nextTabbableNode: function (e) {
              var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                c = n.findIndex(function (t) {
                  return t === e;
                });
              if (!(c < 0)) return t ? n.slice(c + 1).find(function (e) {
                return WM(e, i.tabbableOptions);
              }) : n.slice(0, c).reverse().find(function (e) {
                return WM(e, i.tabbableOptions);
              });
            }
          };
        }), r.tabbableGroups = r.containerGroups.filter(function (e) {
          return e.tabbableNodes.length > 0;
        }), r.tabbableGroups.length <= 0 && !s("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
      },
      u = function e(t) {
        !1 !== t && t !== c.activeElement && (t && t.focus ? (t.focus({
          preventScroll: !!i.preventScroll
        }), r.mostRecentlyFocusedNode = t, function (e) {
          return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select;
        }(t) && t.select()) : e(l()));
      },
      d = function (e) {
        var t = s("setReturnFocus", e);
        return t || !1 !== t && e;
      },
      p = function (e) {
        var t = n_(e);
        o(t) >= 0 || (t_(i.clickOutsideDeactivates, e) ? n.deactivate({
          returnFocus: i.returnFocusOnDeactivate && !UM(t, i.tabbableOptions)
        }) : t_(i.allowOutsideClick, e) || e.preventDefault());
      },
      m = function (e) {
        var t = n_(e),
          n = o(t) >= 0;
        n || t instanceof Document ? n && (r.mostRecentlyFocusedNode = t) : (e.stopImmediatePropagation(), u(r.mostRecentlyFocusedNode || l()));
      },
      h = function (e) {
        if (function (e) {
          return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode;
        }(e) && !1 !== t_(i.escapeDeactivates, e)) return e.preventDefault(), void n.deactivate();
        (function (e) {
          return "Tab" === e.key || 9 === e.keyCode;
        })(e) && function (e) {
          var t = n_(e);
          f();
          var n = null;
          if (r.tabbableGroups.length > 0) {
            var c = o(t),
              a = c >= 0 ? r.containerGroups[c] : void 0;
            if (c < 0) n = e.shiftKey ? r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode : r.tabbableGroups[0].firstTabbableNode;else if (e.shiftKey) {
              var l = e_(r.tabbableGroups, function (e) {
                var n = e.firstTabbableNode;
                return t === n;
              });
              if (l < 0 && (a.container === t || UM(t, i.tabbableOptions) && !WM(t, i.tabbableOptions) && !a.nextTabbableNode(t, !1)) && (l = c), l >= 0) {
                var d = 0 === l ? r.tabbableGroups.length - 1 : l - 1;
                n = r.tabbableGroups[d].lastTabbableNode;
              }
            } else {
              var p = e_(r.tabbableGroups, function (e) {
                var n = e.lastTabbableNode;
                return t === n;
              });
              if (p < 0 && (a.container === t || UM(t, i.tabbableOptions) && !WM(t, i.tabbableOptions) && !a.nextTabbableNode(t)) && (p = c), p >= 0) {
                var m = p === r.tabbableGroups.length - 1 ? 0 : p + 1;
                n = r.tabbableGroups[m].firstTabbableNode;
              }
            }
          } else n = s("fallbackFocus");
          n && (e.preventDefault(), u(n));
        }(e);
      },
      v = function (e) {
        var t = n_(e);
        o(t) >= 0 || t_(i.clickOutsideDeactivates, e) || t_(i.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation());
      },
      g = function () {
        if (r.active) return QM.activateTrap(n), r.delayInitialFocusTimer = i.delayInitialFocus ? JM(function () {
          u(l());
        }) : u(l()), c.addEventListener("focusin", m, !0), c.addEventListener("mousedown", p, {
          capture: !0,
          passive: !1
        }), c.addEventListener("touchstart", p, {
          capture: !0,
          passive: !1
        }), c.addEventListener("click", v, {
          capture: !0,
          passive: !1
        }), c.addEventListener("keydown", h, {
          capture: !0,
          passive: !1
        }), n;
      },
      b = function () {
        if (r.active) return c.removeEventListener("focusin", m, !0), c.removeEventListener("mousedown", p, !0), c.removeEventListener("touchstart", p, !0), c.removeEventListener("click", v, !0), c.removeEventListener("keydown", h, !0), n;
      };
    return (n = {
      get active() {
        return r.active;
      },
      get paused() {
        return r.paused;
      },
      activate: function (e) {
        if (r.active) return this;
        var t = a(e, "onActivate"),
          n = a(e, "onPostActivate"),
          i = a(e, "checkCanFocusTrap");
        i || f(), r.active = !0, r.paused = !1, r.nodeFocusedBeforeActivation = c.activeElement, t && t();
        var o = function () {
          i && f(), g(), n && n();
        };
        return i ? (i(r.containers.concat()).then(o, o), this) : (o(), this);
      },
      deactivate: function (e) {
        if (!r.active) return this;
        var t = XM({
          onDeactivate: i.onDeactivate,
          onPostDeactivate: i.onPostDeactivate,
          checkCanReturnFocus: i.checkCanReturnFocus
        }, e);
        clearTimeout(r.delayInitialFocusTimer), r.delayInitialFocusTimer = void 0, b(), r.active = !1, r.paused = !1, QM.deactivateTrap(n);
        var c = a(t, "onDeactivate"),
          o = a(t, "onPostDeactivate"),
          s = a(t, "checkCanReturnFocus"),
          l = a(t, "returnFocus", "returnFocusOnDeactivate");
        c && c();
        var f = function () {
          JM(function () {
            l && u(d(r.nodeFocusedBeforeActivation)), o && o();
          });
        };
        return l && s ? (s(d(r.nodeFocusedBeforeActivation)).then(f, f), this) : (f(), this);
      },
      pause: function () {
        return r.paused || !r.active || (r.paused = !0, b()), this;
      },
      unpause: function () {
        return r.paused && r.active ? (r.paused = !1, f(), g(), this) : this;
      },
      updateContainerElements: function (e) {
        var t = [].concat(e).filter(Boolean);
        return r.containers = t.map(function (e) {
          return "string" == typeof e ? c.querySelector(e) : e;
        }), r.active && f(), this;
      }
    }).updateContainerElements(e), n;
  };
var i_ = !1;
if ("undefined" != typeof window) {
  var r_ = {
    get passive() {
      i_ = !0;
    }
  };
  window.addEventListener("testPassive", null, r_), window.removeEventListener("testPassive", null, r_);
}
var a_,
  o_ = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1),
  s_ = [],
  l_ = !1,
  f_ = -1,
  u_ = void 0,
  d_ = void 0,
  p_ = function (e) {
    return s_.some(function (t) {
      return !(!t.options.allowTouchMove || !t.options.allowTouchMove(e));
    });
  },
  m_ = function (e) {
    var t = e || window.event;
    return !!p_(t.target) || t.touches.length > 1 || (t.preventDefault && t.preventDefault(), !1);
  },
  h_ = function (e, t) {
    if (e) {
      if (!s_.some(function (t) {
        return t.targetElement === e;
      })) {
        var n = {
          targetElement: e,
          options: t || {}
        };
        s_ = [].concat(function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
            return n;
          }
          return Array.from(e);
        }(s_), [n]), o_ ? (e.ontouchstart = function (e) {
          1 === e.targetTouches.length && (f_ = e.targetTouches[0].clientY);
        }, e.ontouchmove = function (t) {
          1 === t.targetTouches.length && function (e, t) {
            var n = e.targetTouches[0].clientY - f_;
            !p_(e.target) && (t && 0 === t.scrollTop && n > 0 || function (e) {
              return !!e && e.scrollHeight - e.scrollTop <= e.clientHeight;
            }(t) && n < 0 ? m_(e) : e.stopPropagation());
          }(t, e);
        }, l_ || (document.addEventListener("touchmove", m_, i_ ? {
          passive: !1
        } : void 0), l_ = !0)) : function (e) {
          if (void 0 === d_) {
            var t = !!e && !0 === e.reserveScrollBarGap,
              n = window.innerWidth - document.documentElement.clientWidth;
            t && n > 0 && (d_ = document.body.style.paddingRight, document.body.style.paddingRight = n + "px");
          }
          void 0 === u_ && (u_ = document.body.style.overflow, document.body.style.overflow = "hidden");
        }(t);
      }
    } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
  },
  v_ = function (e) {
    e ? (s_ = s_.filter(function (t) {
      return t.targetElement !== e;
    }), o_ ? (e.ontouchstart = null, e.ontouchmove = null, l_ && 0 === s_.length && (document.removeEventListener("touchmove", m_, i_ ? {
      passive: !1
    } : void 0), l_ = !1)) : s_.length || (void 0 !== d_ && (document.body.style.paddingRight = d_, d_ = void 0), void 0 !== u_ && (document.body.style.overflow = u_, u_ = void 0))) : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
  },
  g_ = [],
  b_ = "ResizeObserver loop completed with undelivered notifications.";
!function (e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
}(a_ || (a_ = {}));
var H_,
  z_ = function (e) {
    return Object.freeze(e);
  },
  y_ = function (e, t) {
    this.inlineSize = e, this.blockSize = t, z_(this);
  },
  V_ = function () {
    function e(e, t, n, c) {
      return this.x = e, this.y = t, this.width = n, this.height = c, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, z_(this);
    }
    return e.prototype.toJSON = function () {
      var e = this;
      return {
        x: e.x,
        y: e.y,
        top: e.top,
        right: e.right,
        bottom: e.bottom,
        left: e.left,
        width: e.width,
        height: e.height
      };
    }, e.fromRect = function (t) {
      return new e(t.x, t.y, t.width, t.height);
    }, e;
  }(),
  x_ = function (e) {
    return e instanceof SVGElement && "getBBox" in e;
  },
  M_ = function (e) {
    if (x_(e)) {
      var t = e.getBBox(),
        n = t.width,
        c = t.height;
      return !n && !c;
    }
    var i = e,
      r = i.offsetWidth,
      a = i.offsetHeight;
    return !(r || a || e.getClientRects().length);
  },
  __ = function (e) {
    var t;
    if (e instanceof Element) return !0;
    var n = null === (t = null == e ? void 0 : e.ownerDocument) || void 0 === t ? void 0 : t.defaultView;
    return !!(n && e instanceof n.Element);
  },
  w_ = "undefined" != typeof window ? window : {},
  E_ = new WeakMap(),
  C_ = /auto|scroll/,
  L_ = /^tb|vertical/,
  N_ = /msie|trident/i.test(w_.navigator && w_.navigator.userAgent),
  S_ = function (e) {
    return parseFloat(e || "0");
  },
  k_ = function (e, t, n) {
    return void 0 === e && (e = 0), void 0 === t && (t = 0), void 0 === n && (n = !1), new y_((n ? t : e) || 0, (n ? e : t) || 0);
  },
  P_ = z_({
    devicePixelContentBoxSize: k_(),
    borderBoxSize: k_(),
    contentBoxSize: k_(),
    contentRect: new V_(0, 0, 0, 0)
  }),
  T_ = function (e, t) {
    if (void 0 === t && (t = !1), E_.has(e) && !t) return E_.get(e);
    if (M_(e)) return E_.set(e, P_), P_;
    var n = getComputedStyle(e),
      c = x_(e) && e.ownerSVGElement && e.getBBox(),
      i = !N_ && "border-box" === n.boxSizing,
      r = L_.test(n.writingMode || ""),
      a = !c && C_.test(n.overflowY || ""),
      o = !c && C_.test(n.overflowX || ""),
      s = c ? 0 : S_(n.paddingTop),
      l = c ? 0 : S_(n.paddingRight),
      f = c ? 0 : S_(n.paddingBottom),
      u = c ? 0 : S_(n.paddingLeft),
      d = c ? 0 : S_(n.borderTopWidth),
      p = c ? 0 : S_(n.borderRightWidth),
      m = c ? 0 : S_(n.borderBottomWidth),
      h = u + l,
      v = s + f,
      g = (c ? 0 : S_(n.borderLeftWidth)) + p,
      b = d + m,
      H = o ? e.offsetHeight - b - e.clientHeight : 0,
      z = a ? e.offsetWidth - g - e.clientWidth : 0,
      y = i ? h + g : 0,
      V = i ? v + b : 0,
      x = c ? c.width : S_(n.width) - y - z,
      M = c ? c.height : S_(n.height) - V - H,
      _ = x + h + z + g,
      w = M + v + H + b,
      E = z_({
        devicePixelContentBoxSize: k_(Math.round(x * devicePixelRatio), Math.round(M * devicePixelRatio), r),
        borderBoxSize: k_(_, w, r),
        contentBoxSize: k_(x, M, r),
        contentRect: new V_(u, s, x, M)
      });
    return E_.set(e, E), E;
  },
  O_ = function (e, t, n) {
    var c = T_(e, n),
      i = c.borderBoxSize,
      r = c.contentBoxSize,
      a = c.devicePixelContentBoxSize;
    switch (t) {
      case a_.DEVICE_PIXEL_CONTENT_BOX:
        return a;
      case a_.BORDER_BOX:
        return i;
      default:
        return r;
    }
  },
  A_ = function (e) {
    var t = T_(e);
    this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = z_([t.borderBoxSize]), this.contentBoxSize = z_([t.contentBoxSize]), this.devicePixelContentBoxSize = z_([t.devicePixelContentBoxSize]);
  },
  D_ = function (e) {
    if (M_(e)) return 1 / 0;
    for (var t = 0, n = e.parentNode; n;) t += 1, n = n.parentNode;
    return t;
  },
  I_ = function () {
    var e = 1 / 0,
      t = [];
    g_.forEach(function (n) {
      if (0 !== n.activeTargets.length) {
        var c = [];
        n.activeTargets.forEach(function (t) {
          var n = new A_(t.target),
            i = D_(t.target);
          c.push(n), t.lastReportedSize = O_(t.target, t.observedBox), i < e && (e = i);
        }), t.push(function () {
          n.callback.call(n.observer, c, n.observer);
        }), n.activeTargets.splice(0, n.activeTargets.length);
      }
    });
    for (var n = 0, c = t; n < c.length; n++) {
      (0, c[n])();
    }
    return e;
  },
  j_ = function (e) {
    g_.forEach(function (t) {
      t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function (n) {
        n.isActive() && (D_(n.target) > e ? t.activeTargets.push(n) : t.skippedTargets.push(n));
      });
    });
  },
  F_ = function () {
    var e = 0;
    for (j_(e); g_.some(function (e) {
      return e.activeTargets.length > 0;
    });) e = I_(), j_(e);
    return g_.some(function (e) {
      return e.skippedTargets.length > 0;
    }) && function () {
      var e;
      "function" == typeof ErrorEvent ? e = new ErrorEvent("error", {
        message: b_
      }) : ((e = document.createEvent("Event")).initEvent("error", !1, !1), e.message = b_), window.dispatchEvent(e);
    }(), e > 0;
  },
  R_ = [],
  B_ = function (e) {
    if (!H_) {
      var t = 0,
        n = document.createTextNode("");
      new MutationObserver(function () {
        return R_.splice(0).forEach(function (e) {
          return e();
        });
      }).observe(n, {
        characterData: !0
      }), H_ = function () {
        n.textContent = "".concat(t ? t-- : t++);
      };
    }
    R_.push(e), H_();
  },
  G_ = 0,
  Y_ = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
  },
  W_ = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
  q_ = function (e) {
    return void 0 === e && (e = 0), Date.now() + e;
  },
  U_ = !1,
  $_ = new (function () {
    function e() {
      var e = this;
      this.stopped = !0, this.listener = function () {
        return e.schedule();
      };
    }
    return e.prototype.run = function (e) {
      var t = this;
      if (void 0 === e && (e = 250), !U_) {
        U_ = !0;
        var n,
          c = q_(e);
        n = function () {
          var n = !1;
          try {
            n = F_();
          } finally {
            if (U_ = !1, e = c - q_(), !G_) return;
            n ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
          }
        }, B_(function () {
          requestAnimationFrame(n);
        });
      }
    }, e.prototype.schedule = function () {
      this.stop(), this.run();
    }, e.prototype.observe = function () {
      var e = this,
        t = function () {
          return e.observer && e.observer.observe(document.body, Y_);
        };
      document.body ? t() : w_.addEventListener("DOMContentLoaded", t);
    }, e.prototype.start = function () {
      var e = this;
      this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), W_.forEach(function (t) {
        return w_.addEventListener(t, e.listener, !0);
      }));
    }, e.prototype.stop = function () {
      var e = this;
      this.stopped || (this.observer && this.observer.disconnect(), W_.forEach(function (t) {
        return w_.removeEventListener(t, e.listener, !0);
      }), this.stopped = !0);
    }, e;
  }())(),
  X_ = function (e) {
    !G_ && e > 0 && $_.start(), !(G_ += e) && $_.stop();
  },
  Z_ = function () {
    function e(e, t) {
      this.target = e, this.observedBox = t || a_.CONTENT_BOX, this.lastReportedSize = {
        inlineSize: 0,
        blockSize: 0
      };
    }
    return e.prototype.isActive = function () {
      var e = O_(this.target, this.observedBox, !0);
      return function (e) {
        return !x_(e) && !function (e) {
          switch (e.tagName) {
            case "INPUT":
              if ("image" !== e.type) break;
            case "VIDEO":
            case "AUDIO":
            case "EMBED":
            case "OBJECT":
            case "CANVAS":
            case "IFRAME":
            case "IMG":
              return !0;
          }
          return !1;
        }(e) && "inline" === getComputedStyle(e).display;
      }(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
    }, e;
  }(),
  K_ = function (e, t) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
  },
  Q_ = new WeakMap(),
  J_ = function (e, t) {
    for (var n = 0; n < e.length; n += 1) if (e[n].target === t) return n;
    return -1;
  },
  ew = function () {
    function e() {}
    return e.connect = function (e, t) {
      var n = new K_(e, t);
      Q_.set(e, n);
    }, e.observe = function (e, t, n) {
      var c = Q_.get(e),
        i = 0 === c.observationTargets.length;
      J_(c.observationTargets, t) < 0 && (i && g_.push(c), c.observationTargets.push(new Z_(t, n && n.box)), X_(1), $_.schedule());
    }, e.unobserve = function (e, t) {
      var n = Q_.get(e),
        c = J_(n.observationTargets, t),
        i = 1 === n.observationTargets.length;
      c >= 0 && (i && g_.splice(g_.indexOf(n), 1), n.observationTargets.splice(c, 1), X_(-1));
    }, e.disconnect = function (e) {
      var t = this,
        n = Q_.get(e);
      n.observationTargets.slice().forEach(function (n) {
        return t.unobserve(e, n.target);
      }), n.activeTargets.splice(0, n.activeTargets.length);
    }, e;
  }(),
  tw = function () {
    function e(e) {
      if (0 === arguments.length) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
      if ("function" != typeof e) throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
      ew.connect(this, e);
    }
    return e.prototype.observe = function (e, t) {
      if (0 === arguments.length) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
      if (!__(e)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
      ew.observe(this, e, t);
    }, e.prototype.unobserve = function (e) {
      if (0 === arguments.length) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
      if (!__(e)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
      ew.unobserve(this, e);
    }, e.prototype.disconnect = function () {
      ew.disconnect(this);
    }, e.toString = function () {
      return "function ResizeObserver () { [polyfill code] }";
    }, e;
  }();
function nw() {
  return nw = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, nw.apply(this, arguments);
}
function cw(e, t) {
  if (null == e) return {};
  var n,
    c,
    i = {},
    r = Object.keys(e);
  for (c = 0; c < r.length; c++) t.indexOf(n = r[c]) >= 0 || (i[n] = e[n]);
  return i;
}
var iw = "undefined" != typeof window ? r : i;
function rw(e, t, n) {
  return t = (t = +t) == t ? t : 0, n = (n = +n) == n ? n : 0, (e = +e) == e && (e = (e = e <= n ? e : n) >= t ? e : t), e;
}
function aw(e) {
  var t = Math.round(e);
  if (Number.isNaN(e)) throw new TypeError("Found a NaN! Check your snapPoints / defaultSnap / snapTo ");
  return t;
}
var ow = {
  box: "border-box"
};
function sw(e, t) {
  var n = t.label,
    i = t.enabled,
    r = t.resizeSourceRef,
    o = c(0),
    s = o[0],
    l = o[1];
  u(n + ": " + s);
  var f = a(function (e) {
    l(e[0].borderBoxSize[0].blockSize), r.current = "element";
  }, [r]);
  return iw(function () {
    if (e.current && i) {
      var t = new tw(f);
      return t.observe(e.current, ow), function () {
        t.disconnect();
      };
    }
  }, [e, f, i]), i ? s : 0;
}
function lw(e) {
  return void 0 === e && (e = 1e3), new Promise(function (t) {
    return setTimeout(t, e);
  });
}
var fw = {
    DRAG: {
      target: "#overlay.dragging",
      actions: "onOpenEnd"
    }
  },
  uw = {
    RESIZE: {
      target: "#overlay.resizing",
      actions: "onOpenEnd"
    }
  },
  dw = function (e, t, n) {
    return void 0 === n && (n = e.context), new mV(e, t, n);
  }({
    id: "overlay",
    initial: "closed",
    context: {
      initialState: "CLOSED"
    },
    states: {
      closed: {
        on: {
          OPEN: "opening",
          CLOSE: void 0
        }
      },
      opening: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onOpenStart",
              onDone: "transition"
            }
          },
          transition: {
            always: [{
              target: "immediately",
              cond: "initiallyOpen"
            }, {
              target: "smoothly",
              cond: "initiallyClosed"
            }]
          },
          immediately: {
            initial: "open",
            states: {
              open: {
                invoke: {
                  src: "openImmediately",
                  onDone: "activating"
                }
              },
              activating: {
                invoke: {
                  src: "activate",
                  onDone: "#overlay.opening.end"
                },
                on: nw({}, fw, uw)
              }
            }
          },
          smoothly: {
            initial: "visuallyHidden",
            states: {
              visuallyHidden: {
                invoke: {
                  src: "renderVisuallyHidden",
                  onDone: "activating"
                }
              },
              activating: {
                invoke: {
                  src: "activate",
                  onDone: "open"
                }
              },
              open: {
                invoke: {
                  src: "openSmoothly",
                  onDone: "#overlay.opening.end"
                },
                on: nw({}, fw, uw)
              }
            }
          },
          end: {
            invoke: {
              src: "onOpenEnd",
              onDone: "done"
            },
            on: {
              CLOSE: "#overlay.closing",
              DRAG: "#overlay.dragging"
            }
          },
          done: {
            type: "final"
          }
        },
        on: nw({}, {
          CLOSE: {
            target: "#overlay.closing",
            actions: "onOpenCancel"
          }
        }),
        onDone: "open"
      },
      open: {
        on: {
          DRAG: "#overlay.dragging",
          SNAP: "snapping",
          RESIZE: "resizing"
        }
      },
      dragging: {
        on: {
          SNAP: "snapping"
        }
      },
      snapping: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onSnapStart",
              onDone: "snappingSmoothly"
            },
            entry: [vV({
              y: function (e, t) {
                return t.payload.y;
              },
              velocity: function (e, t) {
                return t.payload.velocity;
              },
              snapSource: function (e, t) {
                var n = t.payload.source;
                return void 0 === n ? "custom" : n;
              }
            })]
          },
          snappingSmoothly: {
            invoke: {
              src: "snapSmoothly",
              onDone: "end"
            }
          },
          end: {
            invoke: {
              src: "onSnapEnd",
              onDone: "done"
            },
            on: {
              RESIZE: "#overlay.resizing",
              SNAP: "#overlay.snapping",
              CLOSE: "#overlay.closing",
              DRAG: "#overlay.dragging"
            }
          },
          done: {
            type: "final"
          }
        },
        on: {
          SNAP: {
            target: "snapping",
            actions: "onSnapEnd"
          },
          RESIZE: {
            target: "#overlay.resizing",
            actions: "onSnapCancel"
          },
          DRAG: {
            target: "#overlay.dragging",
            actions: "onSnapCancel"
          },
          CLOSE: {
            target: "#overlay.closing",
            actions: "onSnapCancel"
          }
        },
        onDone: "open"
      },
      resizing: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onResizeStart",
              onDone: "resizingSmoothly"
            }
          },
          resizingSmoothly: {
            invoke: {
              src: "resizeSmoothly",
              onDone: "end"
            }
          },
          end: {
            invoke: {
              src: "onResizeEnd",
              onDone: "done"
            },
            on: {
              SNAP: "#overlay.snapping",
              CLOSE: "#overlay.closing",
              DRAG: "#overlay.dragging"
            }
          },
          done: {
            type: "final"
          }
        },
        on: {
          RESIZE: {
            target: "resizing",
            actions: "onResizeEnd"
          },
          SNAP: {
            target: "snapping",
            actions: "onResizeCancel"
          },
          DRAG: {
            target: "#overlay.dragging",
            actions: "onResizeCancel"
          },
          CLOSE: {
            target: "#overlay.closing",
            actions: "onResizeCancel"
          }
        },
        onDone: "open"
      },
      closing: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onCloseStart",
              onDone: "deactivating"
            },
            on: {
              OPEN: {
                target: "#overlay.open",
                actions: "onCloseCancel"
              }
            }
          },
          deactivating: {
            invoke: {
              src: "deactivate",
              onDone: "closingSmoothly"
            }
          },
          closingSmoothly: {
            invoke: {
              src: "closeSmoothly",
              onDone: "end"
            }
          },
          end: {
            invoke: {
              src: "onCloseEnd",
              onDone: "done"
            },
            on: {
              OPEN: {
                target: "#overlay.opening",
                actions: "onCloseCancel"
              }
            }
          },
          done: {
            type: "final"
          }
        },
        on: {
          CLOSE: void 0,
          OPEN: {
            target: "#overlay.opening",
            actions: "onCloseCancel"
          }
        },
        onDone: "closed"
      }
    },
    on: {
      CLOSE: "closing"
    }
  }, {
    actions: {
      onOpenCancel: function (e, t) {},
      onSnapCancel: function (e, t) {},
      onResizeCancel: function (e, t) {},
      onCloseCancel: function (e, t) {},
      onOpenEnd: function (e, t) {},
      onSnapEnd: function (e, t) {},
      onRezizeEnd: function (e, t) {}
    },
    services: {
      onSnapStart: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onOpenStart: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onCloseStart: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onResizeStart: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onSnapEnd: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onOpenEnd: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onCloseEnd: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onResizeEnd: function () {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      renderVisuallyHidden: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      activate: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      deactivate: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      openSmoothly: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      openImmediately: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      snapSmoothly: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      resizeSmoothly: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      closeSmoothly: function (e, t) {
        try {
          return Promise.resolve(lw()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    guards: {
      initiallyClosed: function (e) {
        return "CLOSED" === e.initialState;
      },
      initiallyOpen: function (e) {
        return "OPEN" === e.initialState;
      }
    }
  }),
  pw = ["children", "sibling", "className", "footer", "header", "open", "initialState", "lastSnapRef", "initialFocusRef", "onDismiss", "maxHeight", "defaultSnap", "snapPoints", "blocking", "scrollLocking", "style", "onSpringStart", "onSpringCancel", "onSpringEnd", "reserveScrollBarGap", "expandOnContentDrag"],
  mw = ["velocity"],
  hw = ["onRest", "config"],
  vw = {
    tension: 170,
    friction: 26
  },
  gw = vw.tension,
  bw = vw.friction,
  Hw = /*#__PURE__*/t.forwardRef(function (e, r) {
    var o = e.children,
      f = e.sibling,
      d = e.className,
      p = e.footer,
      m = e.header,
      h = e.open,
      v = e.initialState,
      g = e.lastSnapRef,
      b = e.initialFocusRef,
      H = e.onDismiss,
      z = e.maxHeight,
      y = e.defaultSnap,
      V = void 0 === y ? yw : y,
      x = e.snapPoints,
      M = void 0 === x ? Vw : x,
      _ = e.blocking,
      w = void 0 === _ || _,
      E = e.scrollLocking,
      C = void 0 === E || E,
      L = e.style,
      N = e.onSpringStart,
      S = e.onSpringCancel,
      k = e.onSpringEnd,
      P = e.reserveScrollBarGap,
      T = void 0 === P ? w : P,
      O = e.expandOnContentDrag,
      A = void 0 !== O && O,
      D = cw(e, pw),
      I = function () {
        var e = c(!1),
          t = e[0],
          n = e[1],
          r = c({}),
          o = r[0],
          s = r[1],
          l = a(function (e) {
            return s(function (t) {
              var n;
              return nw({}, t, ((n = {})[e] = !1, n));
            }), function () {
              s(function (t) {
                var n;
                return nw({}, t, ((n = {})[e] = !0, n));
              });
            };
          }, []);
        return i(function () {
          var e = Object.values(o);
          0 !== e.length && e.every(Boolean) && n(!0);
        }, [o]), {
          ready: t,
          registerReady: l
        };
      }(),
      j = I.ready,
      F = I.registerReady,
      R = n(!1),
      B = n(N),
      G = n(S),
      Y = n(k);
    i(function () {
      B.current = N, G.current = S, Y.current = k;
    }, [S, N, k]);
    var W,
      q,
      U = ix(function () {
        return {
          y: 0,
          ready: 0,
          maxHeight: 0,
          minSnap: 0,
          maxSnap: 0
        };
      }),
      $ = U[0],
      X = U[1],
      Z = n(null),
      K = n(null),
      Q = n(null),
      J = n(null),
      ee = n(null),
      te = n(null),
      ne = n(0),
      ce = n(),
      ie = n(!1),
      re = (W = s(function () {
        return "undefined" != typeof window ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
      }, []), q = n(null == W ? void 0 : W.matches), u(q.current ? "reduce" : "no-preference"), i(function () {
        var e = function (e) {
          q.current = e.matches;
        };
        return null == W || W.addListener(e), function () {
          return null == W ? void 0 : W.removeListener(e);
        };
      }, [W]), q),
      ae = function (e) {
        var t = e.targetRef,
          c = e.enabled,
          r = e.reserveScrollBarGap,
          a = n({
            activate: function () {
              throw new TypeError("Tried to activate scroll lock too early");
            },
            deactivate: function () {}
          });
        return u(c ? "Enabled" : "Disabled"), i(function () {
          if (!c) return a.current.deactivate(), void (a.current = {
            activate: function () {},
            deactivate: function () {}
          });
          var e = t.current,
            n = !1;
          a.current = {
            activate: function () {
              n || (n = !0, h_(e, {
                allowTouchMove: function (e) {
                  return e.closest("[data-body-scroll-lock-ignore]");
                },
                reserveScrollBarGap: r
              }));
            },
            deactivate: function () {
              n && (n = !1, v_(e));
            }
          };
        }, [c, t, r]), a;
      }({
        targetRef: K,
        enabled: j && C,
        reserveScrollBarGap: T
      }),
      oe = function (e) {
        var t = e.targetRef,
          c = e.enabled,
          r = n({
            activate: function () {
              throw new TypeError("Tried to activate aria hider too early");
            },
            deactivate: function () {}
          });
        return u(c ? "Enabled" : "Disabled"), i(function () {
          if (!c) return r.current.deactivate(), void (r.current = {
            activate: function () {},
            deactivate: function () {}
          });
          var e = t.current,
            n = !1,
            i = [],
            a = [];
          r.current = {
            activate: function () {
              if (!n) {
                n = !0;
                var t = e.parentNode;
                document.querySelectorAll("body > *").forEach(function (e) {
                  if (e !== t) {
                    var n = e.getAttribute("aria-hidden");
                    null !== n && "false" !== n || (i.push(n), a.push(e), e.setAttribute("aria-hidden", "true"));
                  }
                });
              }
            },
            deactivate: function () {
              n && (n = !1, a.forEach(function (e, t) {
                var n = i[t];
                null === n ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n);
              }), i = [], a = []);
            }
          };
        }, [t, c]), r;
      }({
        targetRef: Z,
        enabled: j && w
      }),
      se = function (e) {
        var t = e.targetRef,
          c = e.fallbackRef,
          r = e.initialFocusRef,
          a = e.enabled,
          o = n({
            activate: function () {
              throw new TypeError("Tried to activate focus trap too early");
            },
            deactivate: function () {}
          });
        return u(a ? "Enabled" : "Disabled"), i(function () {
          if (!a) return o.current.deactivate(), void (o.current = {
            activate: function () {},
            deactivate: function () {}
          });
          var e = c.current,
            n = c_(t.current, {
              onActivate: void 0,
              initialFocus: r ? function () {
                return (null == r ? void 0 : r.current) || e;
              } : void 0,
              fallbackFocus: e,
              escapeDeactivates: !1,
              clickOutsideDeactivates: !1
            }),
            i = !1;
          o.current = {
            activate: function () {
              try {
                return i ? Promise.resolve() : (i = !0, Promise.resolve(n.activate()).then(function () {
                  return Promise.resolve(new Promise(function (e) {
                    return setTimeout(function () {
                      return e(void 0);
                    }, 0);
                  })).then(function () {});
                }));
              } catch (e) {
                return Promise.reject(e);
              }
            },
            deactivate: function () {
              i && (i = !1, n.deactivate());
            }
          };
        }, [a, c, r, t]), o;
      }({
        targetRef: Z,
        fallbackRef: te,
        initialFocusRef: b || void 0,
        enabled: j && w && !1 !== b
      }),
      le = function (e) {
        var t = e.getSnapPoints,
          r = e.heightRef,
          a = e.lastSnapRef,
          o = e.ready,
          l = function (e) {
            var t = e.contentRef,
              r = e.controlledMaxHeight,
              a = e.footerEnabled,
              o = e.footerRef,
              l = e.headerEnabled,
              f = e.headerRef,
              d = e.registerReady,
              p = e.resizeSourceRef,
              m = s(function () {
                return d("contentHeight");
              }, [d]),
              h = function (e, t, r) {
                var a = s(function () {
                    return t("maxHeight");
                  }, [t]),
                  o = c(function () {
                    return aw(e) || "undefined" != typeof window ? window.innerHeight : 0;
                  }),
                  l = o[0],
                  f = o[1],
                  d = l > 0,
                  p = n(0);
                return u(e ? "controlled" : "auto"), i(function () {
                  d && a();
                }, [d, a]), iw(function () {
                  if (e) return f(aw(e)), void (r.current = "maxheightprop");
                  var t = function () {
                    p.current || (p.current = requestAnimationFrame(function () {
                      f(window.innerHeight), r.current = "window", p.current = 0;
                    }));
                  };
                  return window.addEventListener("resize", t), f(window.innerHeight), r.current = "window", a(), function () {
                    window.removeEventListener("resize", t), cancelAnimationFrame(p.current);
                  };
                }, [e, a, r]), l;
              }(r, d, p),
              v = sw(f, {
                label: "headerHeight",
                enabled: l,
                resizeSourceRef: p
              }),
              g = sw(t, {
                label: "contentHeight",
                enabled: !0,
                resizeSourceRef: p
              }),
              b = sw(o, {
                label: "footerHeight",
                enabled: a,
                resizeSourceRef: p
              }),
              H = Math.min(h - v - b, g) + v + b;
            u("minHeight: " + H);
            var z = g > 0;
            return i(function () {
              z && m();
            }, [z, m]), {
              maxHeight: h,
              minHeight: H,
              headerHeight: v,
              footerHeight: b
            };
          }({
            contentRef: e.contentRef,
            controlledMaxHeight: e.controlledMaxHeight,
            footerEnabled: e.footerEnabled,
            footerRef: e.footerRef,
            headerEnabled: e.headerEnabled,
            headerRef: e.headerRef,
            registerReady: e.registerReady,
            resizeSourceRef: e.resizeSourceRef
          }),
          f = l.maxHeight,
          d = l.minHeight,
          p = l.headerHeight,
          m = l.footerHeight,
          h = function (e, t) {
            var n = [].concat(e).map(aw).reduce(function (e, n) {
                return e.add(rw(n, 0, t)), e;
              }, new Set()),
              c = Array.from(n),
              i = Math.min.apply(Math, c);
            if (Number.isNaN(i)) throw new TypeError("minSnap is NaN");
            var r = Math.max.apply(Math, c);
            if (Number.isNaN(r)) throw new TypeError("maxSnap is NaN");
            return {
              snapPoints: c,
              minSnap: i,
              maxSnap: r
            };
          }(o ? t({
            height: r.current,
            footerHeight: m,
            headerHeight: p,
            minHeight: d,
            maxHeight: f
          }) : [0], f),
          v = h.snapPoints,
          g = h.minSnap,
          b = h.maxSnap;
        return u("minSnap: " + g + ", maxSnap:" + b), {
          minSnap: g,
          maxSnap: b,
          findSnap: function (e) {
            var t = aw("function" == typeof e ? e({
              footerHeight: m,
              headerHeight: p,
              height: r.current,
              minHeight: d,
              maxHeight: f,
              snapPoints: v,
              lastSnap: a.current
            }) : e);
            return v.reduce(function (e, n) {
              return Math.abs(n - t) < Math.abs(e - t) ? n : e;
            }, g);
          },
          maxHeight: f
        };
      }({
        contentRef: Q,
        controlledMaxHeight: z,
        footerEnabled: !!p,
        footerRef: ee,
        getSnapPoints: M,
        headerEnabled: !1 !== m,
        headerRef: J,
        heightRef: ne,
        lastSnapRef: g,
        ready: j,
        registerReady: F,
        resizeSourceRef: ce
      }),
      fe = le.minSnap,
      ue = le.maxSnap,
      de = le.maxHeight,
      pe = le.findSnap,
      me = n(de),
      he = n(fe),
      ve = n(ue),
      ge = n(pe),
      be = n(0);
    iw(function () {
      me.current = de, ve.current = ue, he.current = fe, ge.current = pe, be.current = pe(V);
    }, [pe, V, de, ue, fe]);
    var He = a(function (e) {
        var t = e.onRest,
          n = e.config,
          c = (n = void 0 === n ? {} : n).velocity,
          i = void 0 === c ? 1 : c,
          r = cw(n, mw),
          a = cw(e, hw);
        return new Promise(function (e) {
          return X(nw({}, a, {
            config: nw({
              velocity: i
            }, r, {
              mass: 1,
              tension: gw,
              friction: Math.max(bw, bw + (bw - bw * i))
            }),
            onRest: function () {
              var n = [].slice.call(arguments);
              e.apply(void 0, n), null == t || t.apply(void 0, n);
            }
          }));
        });
      }, [X]),
      ze = LV(dw, {
        devTools: !1,
        actions: {
          onOpenCancel: a(function () {
            return null == G.current ? void 0 : G.current({
              type: "OPEN"
            });
          }, []),
          onSnapCancel: a(function (e) {
            return null == G.current ? void 0 : G.current({
              type: "SNAP",
              source: e.snapSource
            });
          }, []),
          onCloseCancel: a(function () {
            return null == G.current ? void 0 : G.current({
              type: "CLOSE"
            });
          }, []),
          onResizeCancel: a(function () {
            return null == G.current ? void 0 : G.current({
              type: "RESIZE",
              source: ce.current
            });
          }, []),
          onOpenEnd: a(function () {
            return null == Y.current ? void 0 : Y.current({
              type: "OPEN"
            });
          }, []),
          onSnapEnd: a(function (e, t) {
            return null == Y.current ? void 0 : Y.current({
              type: "SNAP",
              source: e.snapSource
            });
          }, []),
          onResizeEnd: a(function () {
            return null == Y.current ? void 0 : Y.current({
              type: "RESIZE",
              source: ce.current
            });
          }, [])
        },
        context: {
          initialState: v
        },
        services: {
          onSnapStart: a(function (e, t) {
            try {
              return Promise.resolve(null == B.current ? void 0 : B.current({
                type: "SNAP",
                source: t.payload.source || "custom"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onOpenStart: a(function () {
            try {
              return Promise.resolve(null == B.current ? void 0 : B.current({
                type: "OPEN"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onCloseStart: a(function () {
            try {
              return Promise.resolve(null == B.current ? void 0 : B.current({
                type: "CLOSE"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onResizeStart: a(function () {
            try {
              return Promise.resolve(null == B.current ? void 0 : B.current({
                type: "RESIZE",
                source: ce.current
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onSnapEnd: a(function (e, t) {
            try {
              return Promise.resolve(null == Y.current ? void 0 : Y.current({
                type: "SNAP",
                source: e.snapSource
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onOpenEnd: a(function () {
            try {
              return Promise.resolve(null == Y.current ? void 0 : Y.current({
                type: "OPEN"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onCloseEnd: a(function () {
            try {
              return Promise.resolve(null == Y.current ? void 0 : Y.current({
                type: "CLOSE"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onResizeEnd: a(function () {
            try {
              return Promise.resolve(null == Y.current ? void 0 : Y.current({
                type: "RESIZE",
                source: ce.current
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          renderVisuallyHidden: a(function (e, t) {
            try {
              return Promise.resolve(He({
                y: be.current,
                ready: 0,
                maxHeight: me.current,
                maxSnap: ve.current,
                minSnap: be.current,
                immediate: !0
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [He]),
          activate: a(function (e, t) {
            try {
              return R.current = !0, Promise.resolve(Promise.all([ae.current.activate(), se.current.activate(), oe.current.activate()])).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [oe, se, ae]),
          deactivate: a(function () {
            try {
              return ae.current.deactivate(), se.current.deactivate(), oe.current.deactivate(), R.current = !1, Promise.resolve();
            } catch (e) {
              return Promise.reject(e);
            }
          }, [oe, se, ae]),
          openImmediately: a(function () {
            try {
              return ne.current = be.current, Promise.resolve(He({
                y: be.current,
                ready: 1,
                maxHeight: me.current,
                maxSnap: ve.current,
                minSnap: be.current,
                immediate: !0
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [He]),
          openSmoothly: a(function () {
            try {
              return Promise.resolve(He({
                y: 0,
                ready: 1,
                maxHeight: me.current,
                maxSnap: ve.current,
                minSnap: be.current,
                immediate: !0
              })).then(function () {
                return ne.current = be.current, Promise.resolve(He({
                  y: be.current,
                  ready: 1,
                  maxHeight: me.current,
                  maxSnap: ve.current,
                  minSnap: be.current,
                  immediate: re.current
                })).then(function () {});
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }, [He, re]),
          snapSmoothly: a(function (e, t) {
            try {
              var n = ge.current(e.y);
              return ne.current = n, g.current = n, Promise.resolve(He({
                y: n,
                ready: 1,
                maxHeight: me.current,
                maxSnap: ve.current,
                minSnap: he.current,
                immediate: re.current,
                config: {
                  velocity: e.velocity
                }
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [He, g, re]),
          resizeSmoothly: a(function () {
            try {
              var e = ge.current(ne.current);
              return ne.current = e, g.current = e, Promise.resolve(He({
                y: e,
                ready: 1,
                maxHeight: me.current,
                maxSnap: ve.current,
                minSnap: he.current,
                immediate: "element" !== ce.current || re.current
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [He, g, re]),
          closeSmoothly: a(function (e, t) {
            try {
              return He({
                minSnap: ne.current,
                immediate: !0
              }), ne.current = 0, Promise.resolve(He({
                y: 0,
                maxHeight: me.current,
                maxSnap: ve.current,
                immediate: re.current
              })).then(function () {
                return Promise.resolve(He({
                  ready: 0,
                  immediate: !0
                })).then(function () {});
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }, [He, re])
        }
      }),
      ye = ze[0],
      Ve = ze[1];
    i(function () {
      j && Ve(h ? "OPEN" : "CLOSE");
    }, [h, Ve, j]), iw(function () {
      (de || ue || fe) && Ve("RESIZE");
    }, [de, ue, fe, Ve]), i(function () {
      return function () {
        ae.current.deactivate(), se.current.deactivate(), oe.current.deactivate();
      };
    }, [oe, se, ae]), l(r, function () {
      return {
        snapTo: function (e, t) {
          var n = void 0 === t ? {} : t,
            c = n.velocity,
            i = void 0 === c ? 1 : c,
            r = n.source,
            a = void 0 === r ? "custom" : r;
          Ve("SNAP", {
            payload: {
              y: ge.current(e),
              velocity: i,
              source: a
            }
          });
        },
        get height() {
          return ne.current;
        }
      };
    }, [Ve]), i(function () {
      var e = K.current,
        t = function (e) {
          ie.current && e.preventDefault();
        },
        n = function (t) {
          e.scrollTop < 0 && (requestAnimationFrame(function () {
            e.style.overflow = "hidden", e.scrollTop = 0, e.style.removeProperty("overflow");
          }), t.preventDefault());
        };
      return A && (e.addEventListener("scroll", t), e.addEventListener("touchmove", t), e.addEventListener("touchstart", n)), function () {
        e.removeEventListener("scroll", t), e.removeEventListener("touchmove", t), e.removeEventListener("touchstart", n);
      };
    }, [A, K]);
    var xe = EM(function (e) {
      var t = e.args,
        n = (t = void 0 === t ? [] : t)[0],
        c = (n = void 0 === n ? {} : n).closeOnTap,
        i = void 0 !== c && c,
        r = n.isContentDragging,
        a = void 0 !== r && r,
        o = e.cancel,
        s = e.direction[1],
        l = e.down,
        f = e.first,
        u = e.last,
        d = e.memo,
        p = void 0 === d ? $.y.getValue() : d,
        m = e.tap,
        h = e.velocity,
        v = -1 * e.movement[1];
      if (!R.current) return o(), p;
      if (H && i && m) return o(), setTimeout(function () {
        return H();
      }, 0), p;
      if (m) return p;
      var g = p + v,
        b = v * h,
        z = Math.max(he.current, Math.min(ve.current, g + 2 * b));
      if (!l && H && s > 0 && g + b < he.current / 2) return o(), H(), p;
      var y = l ? H || he.current !== ve.current ? Rx(g, H ? 0 : he.current, ve.current, .55) : g < he.current ? Rx(g, he.current, 2 * ve.current, .55) : Rx(g, he.current / 2, ve.current, .55) : z;
      return A && a ? (y >= ve.current && (y = ve.current), p === ve.current && K.current.scrollTop > 0 && (y = ve.current), ie.current = y < ve.current) : ie.current = !1, f && Ve("DRAG"), u ? (Ve("SNAP", {
        payload: {
          y: y,
          velocity: h > .05 ? h : 1,
          source: "dragging"
        }
      }), p) : (X({
        y: y,
        ready: 1,
        maxHeight: me.current,
        maxSnap: ve.current,
        minSnap: he.current,
        immediate: !0,
        config: {
          velocity: h
        }
      }), p);
    }, {
      filterTaps: !0
    });
    if (Number.isNaN(ve.current)) throw new TypeError("maxSnapRef is NaN!!");
    if (Number.isNaN(he.current)) throw new TypeError("minSnapRef is NaN!!");
    var Me = function (e) {
      var t,
        n = e.spring,
        c = QV([n.y, n.maxHeight], function (e, t) {
          return Math.round(rw(t - e, 0, 16)) + "px";
        }),
        i = QV([n.y, n.minSnap, n.maxSnap], function (e, t, n) {
          return rw(e, t, n) + "px";
        }),
        r = QV([n.y, n.minSnap, n.maxSnap], function (e, t, n) {
          return e < t ? t - e + "px" : e > n ? n - e + "px" : "0px";
        }),
        a = QV([n.y, n.maxSnap], function (e, t) {
          return e >= t ? Math.ceil(e - t) : 0;
        }),
        o = QV([n.y, n.minSnap], function (e, t) {
          if (!t) return 0;
          var n = Math.max(t / 2 - 45, 0);
          return rw((e - n) * (1 / (Math.min(t / 2 + 45, t) - n) + 0), 0, 1);
        }),
        s = QV([n.y, n.minSnap], function (e, t) {
          return t ? rw(e / t, 0, 1) : 0;
        });
      return (t = {})["--rsbs-content-opacity"] = o, t["--rsbs-backdrop-opacity"] = s, t["--rsbs-antigap-scale-y"] = a, t["--rsbs-overlay-translate-y"] = r, t["--rsbs-overlay-rounded"] = c, t["--rsbs-overlay-h"] = i, t;
    }({
      spring: $
    });
    return /*#__PURE__*/t.createElement(Ox.div, nw({}, D, {
      "data-rsbs-root": !0,
      "data-rsbs-state": zw.find(ye.matches),
      "data-rsbs-is-blocking": w,
      "data-rsbs-is-dismissable": !!H,
      "data-rsbs-has-header": !!m,
      "data-rsbs-has-footer": !!p,
      className: d,
      ref: Z,
      style: nw({}, Me, L, {
        opacity: $.ready
      })
    }), f, w && /*#__PURE__*/t.createElement("div", nw({
      key: "backdrop",
      "data-rsbs-backdrop": !0
    }, xe({
      closeOnTap: !0
    }))), /*#__PURE__*/t.createElement("div", {
      key: "overlay",
      "aria-modal": "true",
      role: "dialog",
      "data-rsbs-overlay": !0,
      tabIndex: -1,
      ref: te,
      onKeyDown: function (e) {
        "Escape" === e.key && (e.stopPropagation(), H && H());
      }
    }, !1 !== m && /*#__PURE__*/t.createElement("div", nw({
      key: "header",
      "data-rsbs-header": !0,
      ref: J
    }, xe()), m), /*#__PURE__*/t.createElement("div", nw({
      key: "scroll",
      "data-rsbs-scroll": !0,
      ref: K
    }, A ? xe({
      isContentDragging: !0
    }) : {}), /*#__PURE__*/t.createElement("div", {
      "data-rsbs-content": !0,
      ref: Q
    }, o)), p && /*#__PURE__*/t.createElement("div", nw({
      key: "footer",
      ref: ee,
      "data-rsbs-footer": !0
    }, xe()), p)));
  }),
  zw = ["closed", "opening", "open", "closing", "dragging", "snapping", "resizing"];
function yw(e) {
  var t = e.lastSnap;
  return null != t ? t : Math.min.apply(Math, e.snapPoints);
}
function Vw(e) {
  return e.minHeight;
}
var xw = ["onSpringStart", "onSpringEnd", "skipInitialTransition"],
  Mw = /*#__PURE__*/f(function (e, i) {
    var r = e.onSpringStart,
      o = e.onSpringEnd,
      s = e.skipInitialTransition,
      l = cw(e, xw),
      f = c(!1),
      u = f[0],
      d = f[1],
      p = n(),
      m = n(null),
      h = n(s && l.open ? "OPEN" : "CLOSED");
    iw(function () {
      if (l.open) return cancelAnimationFrame(p.current), d(!0), function () {
        h.current = "CLOSED";
      };
    }, [l.open]);
    var v = a(function (e) {
        return Promise.resolve(null == r ? void 0 : r(e)).then(function () {
          "OPEN" === e.type && cancelAnimationFrame(p.current);
        });
      }, [r]),
      g = a(function (e) {
        return Promise.resolve(null == o ? void 0 : o(e)).then(function () {
          "CLOSE" === e.type && (p.current = requestAnimationFrame(function () {
            return d(!1);
          }));
        });
      }, [o]);
    return u ? /*#__PURE__*/t.createElement(bz, {
      "data-rsbs-portal": !0
    }, /*#__PURE__*/t.createElement(Hw, nw({}, l, {
      lastSnapRef: m,
      ref: i,
      initialState: h.current,
      onSpringStart: v,
      onSpringEnd: g
    }))) : null;
  }),
  _w = function (e) {
    var n = BH().isMobile;
    return /*#__PURE__*/t.createElement(v, H({}, e, {
      startDateId: "search_start_date",
      endDateId: "search_end_date",
      customArrowIcon: /*#__PURE__*/t.createElement(Sb, {
        name: "longArrowRight",
        iconStyle: "regular"
      }),
      customCloseIcon: /*#__PURE__*/t.createElement(Sb, {
        name: "times"
      }),
      startDatePlaceholderText: "Add Dates",
      endDatePlaceholderText: "Add Dates",
      noBorder: !0,
      withFullScreenPortal: n,
      orientation: n ? "vertical" : "horizontal",
      readOnly: !0
    }));
  };
_w.propTypes = {}, _w.defaultTypes = {};
var ww = function (e) {
  var n = e.onGuestsDecrement,
    i = e.onGuestsIncrement,
    r = e.maxGuests,
    a = BH(),
    o = a.isWidescreen,
    s = a.isMobile,
    l = y(c(1), 2),
    f = l[0],
    u = l[1],
    d = function () {
      return /*#__PURE__*/t.createElement(Rb, {
        flex: s ? "1" : null,
        className: pz
      }, /*#__PURE__*/t.createElement(TH, {
        size: o ? "m" : "s",
        className: uz,
        textAlign: s ? "left" : "center"
      }, 1 === f ? "1 Guest" : "".concat(f, " Guests")));
    };
  return /*#__PURE__*/t.createElement(Rb, {
    flex: "1"
  }, /*#__PURE__*/t.createElement(Rb, {
    className: lz
  }, "Guests"), /*#__PURE__*/t.createElement(Ub, {
    gap: "xs",
    alignItems: "center"
  }, s && d(), /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement(Rb, {
    renderAs: "button",
    onClick: function () {
      var e = f - 1;
      1 === f && (e = 1), u(e), n && n(e);
    },
    className: dz
  }, /*#__PURE__*/t.createElement(Sb, {
    name: "minus"
  }))), !s && d(), /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement(Rb, {
    renderAs: "button",
    onClick: function () {
      var e = f + 1;
      e > r && (e = r), u(e), i && i(e);
    },
    className: dz
  }, /*#__PURE__*/t.createElement(Sb, {
    name: "plus"
  })))));
};
ww.propTypes = {
  onGuestsIncrement: p.func,
  onGuestsDecrement: p.func,
  maxGuests: p.number
};
var Ew = function (e) {
  var n = e.dateRangeProps,
    r = e.searchLink,
    a = e.guests,
    o = e.maxGuests,
    s = e.onGuestsDecrement,
    l = e.onGuestsIncrement,
    f = e.isPhotoGalleryLayout,
    u = e.isPartialLayout,
    d = e.isVehicle,
    p = e.customParams,
    m = BH(),
    h = m.isWidescreen,
    v = m.isMobile,
    g = y(c(1), 2),
    b = g[0],
    z = g[1],
    V = y(c(null), 2),
    x = V[0],
    M = V[1],
    _ = y(c(null), 2),
    w = _[0],
    E = _[1],
    C = y(c(null), 2),
    L = C[0],
    N = C[1],
    S = y(c(!1), 2),
    k = S[0],
    P = S[1],
    T = function () {
      var e = "";
      return x && w && (e += "&check-in=".concat(hz(x).format("DD-MM-YYYY"), "&check-out=").concat(hz(w).format("DD-MM-YYYY"))), p.length > 0 && (e += "&".concat(p.join("&"))), "".concat(r, "?guests=").concat(b).concat(e);
    },
    O = function () {
      return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Ub, {
        gap: h ? "s" : "xs"
      }, /*#__PURE__*/t.createElement(Rb, {
        flex: "1",
        className: lz
      }, d ? "Pick Up" : "Check-In"), /*#__PURE__*/t.createElement(Rb, {
        className: fz
      }), /*#__PURE__*/t.createElement(Rb, {
        flex: "1",
        className: lz
      }, d ? "Drop Off" : "Check-Out")), /*#__PURE__*/t.createElement(_w, H({}, n, {
        startDate: x,
        endDate: w,
        onDatesChange: function (e) {
          var t = e.startDate,
            c = e.endDate;
          M(t), E(c), N(function (e, t) {
            return e && !t ? "endDate" : !e && t ? "startDate" : null;
          }(t, c)), n.onDatesChange && n.onDatesChange(t, c);
        },
        focusedInput: L,
        onFocusChange: function (e) {
          N(e);
        },
        displayFormat: (null == n ? void 0 : n.displayFormat) || "MMM D, YYYY"
      })));
    };
  return i(function () {
    null != n && n.startDate && M(n.startDate), null != n && n.endDate && E(n.endDate);
  }, [n]), i(function () {
    z(a);
  }, [a]), v ? /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(GH, {
    type: "button",
    onClick: function () {
      P(!0);
    }
  }, "Book Now"), f ? /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
    size: "xl"
  }), u && /*#__PURE__*/t.createElement(Yb, {
    size: "xs"
  })) : /*#__PURE__*/t.createElement(Yb, {
    size: "m"
  }), /*#__PURE__*/t.createElement(Mw, {
    open: k,
    onDismiss: function () {
      P(!1);
    },
    initialFocusRef: !1
  }, /*#__PURE__*/t.createElement(Rb, {
    setPositionRelative: !0,
    padding: "s"
  }, O(), /*#__PURE__*/t.createElement(Yb, null), /*#__PURE__*/t.createElement(ww, {
    onGuestsDecrement: s,
    onGuestsIncrement: l,
    maxGuests: o
  }), /*#__PURE__*/t.createElement(Yb, {
    size: "l"
  }), /*#__PURE__*/t.createElement(GH, {
    type: "router-link",
    href: T(),
    icon: /*#__PURE__*/t.createElement(Sb, {
      name: "search"
    })
  }, "Search"), /*#__PURE__*/t.createElement(Yb, {
    size: "xs"
  })))) : /*#__PURE__*/t.createElement(Ub, {
    className: sz,
    padding: "s",
    alignItems: "center",
    gap: h ? "s" : "xs"
  }, /*#__PURE__*/t.createElement(Rb, {
    flex: h ? "3" : "2"
  }, O()), /*#__PURE__*/t.createElement(ww, {
    onGuestsDecrement: s,
    onGuestsIncrement: l,
    maxGuests: o
  }), /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement(GH, {
    type: "router-link",
    href: T(),
    icon: /*#__PURE__*/t.createElement(Sb, {
      name: "search"
    })
  }, "Search")));
};
function Cw(e) {
  return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
}
function Lw(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = {}), Object.keys(t).forEach(n => {
    void 0 === e[n] ? e[n] = t[n] : Cw(t[n]) && Cw(e[n]) && Object.keys(t[n]).length > 0 && Lw(e[n], t[n]);
  });
}
Ew.propTypes = {}, Ew.defaultTypes = {};
const Nw = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ""
  },
  querySelector: () => null,
  querySelectorAll: () => [],
  getElementById: () => null,
  createEvent: () => ({
    initEvent() {}
  }),
  createElement: () => ({
    children: [],
    childNodes: [],
    style: {},
    setAttribute() {},
    getElementsByTagName: () => []
  }),
  createElementNS: () => ({}),
  importNode: () => null,
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Sw() {
  const e = "undefined" != typeof document ? document : {};
  return Lw(e, Nw), e;
}
const kw = {
  document: Nw,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function () {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle: () => ({
    getPropertyValue: () => ""
  }),
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia: () => ({}),
  requestAnimationFrame: e => "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
  cancelAnimationFrame(e) {
    "undefined" != typeof setTimeout && clearTimeout(e);
  }
};
function Pw() {
  const e = "undefined" != typeof window ? window : {};
  return Lw(e, kw), e;
}
function Tw(e, t) {
  return void 0 === t && (t = 0), setTimeout(e, t);
}
function Ow() {
  return Date.now();
}
function Aw(e, t) {
  void 0 === t && (t = "x");
  const n = Pw();
  let c, i, r;
  const a = function (e) {
    const t = Pw();
    let n;
    return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
  }(e);
  return n.WebKitCSSMatrix ? (i = a.transform || a.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map(e => e.replace(",", ".")).join(", ")), r = new n.WebKitCSSMatrix("none" === i ? "" : i)) : (r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), c = r.toString().split(",")), "x" === t && (i = n.WebKitCSSMatrix ? r.m41 : 16 === c.length ? parseFloat(c[12]) : parseFloat(c[4])), "y" === t && (i = n.WebKitCSSMatrix ? r.m42 : 16 === c.length ? parseFloat(c[13]) : parseFloat(c[5])), i || 0;
}
function Dw(e) {
  return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
}
function Iw() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
    t = ["__proto__", "constructor", "prototype"];
  for (let c = 1; c < arguments.length; c += 1) {
    const i = c < 0 || arguments.length <= c ? void 0 : arguments[c];
    if (null != i && (n = i, !("undefined" != typeof window && void 0 !== window.HTMLElement ? n instanceof HTMLElement : n && (1 === n.nodeType || 11 === n.nodeType)))) {
      const n = Object.keys(Object(i)).filter(e => t.indexOf(e) < 0);
      for (let t = 0, c = n.length; t < c; t += 1) {
        const c = n[t],
          r = Object.getOwnPropertyDescriptor(i, c);
        void 0 !== r && r.enumerable && (Dw(e[c]) && Dw(i[c]) ? i[c].__swiper__ ? e[c] = i[c] : Iw(e[c], i[c]) : !Dw(e[c]) && Dw(i[c]) ? (e[c] = {}, i[c].__swiper__ ? e[c] = i[c] : Iw(e[c], i[c])) : e[c] = i[c]);
      }
    }
  }
  var n;
  return e;
}
function jw(e, t, n) {
  e.style.setProperty(t, n);
}
function Fw(e) {
  let t = e.swiper,
    n = e.targetPosition,
    c = e.side;
  const i = Pw(),
    r = -t.translate;
  let a,
    o = null;
  const s = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(t.cssModeFrameID);
  const l = n > r ? "next" : "prev",
    f = (e, t) => "next" === l && e >= t || "prev" === l && e <= t,
    u = () => {
      a = new Date().getTime(), null === o && (o = a);
      const e = Math.max(Math.min((a - o) / s, 1), 0),
        l = .5 - Math.cos(e * Math.PI) / 2;
      let d = r + l * (n - r);
      if (f(d, n) && (d = n), t.wrapperEl.scrollTo({
        [c]: d
      }), f(d, n)) return t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [c]: d
        });
      }), void i.cancelAnimationFrame(t.cssModeFrameID);
      t.cssModeFrameID = i.requestAnimationFrame(u);
    };
  u();
}
function Rw(e) {
  return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
}
function Bw(e, t) {
  return void 0 === t && (t = ""), [...e.children].filter(e => e.matches(t));
}
function Gw(e, t) {
  return Pw().getComputedStyle(e, null).getPropertyValue(t);
}
function Yw(e) {
  let t,
    n = e;
  if (n) {
    for (t = 0; null !== (n = n.previousSibling);) 1 === n.nodeType && (t += 1);
    return t;
  }
}
function Ww(e, t, n) {
  const c = Pw();
  return n ? e["width" === t ? "offsetWidth" : "offsetHeight"] + parseFloat(c.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-right" : "margin-top")) + parseFloat(c.getComputedStyle(e, null).getPropertyValue("width" === t ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
function qw(e) {
  let t,
    n,
    c = e.swiper,
    i = e.extendParams,
    r = e.on,
    a = e.emit,
    o = e.params;
  c.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, i({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !0,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let s,
    l,
    f,
    u,
    d,
    p,
    m,
    h = o && o.autoplay ? o.autoplay.delay : 3e3,
    v = o && o.autoplay ? o.autoplay.delay : 3e3,
    g = new Date().getTime;
  function b(e) {
    c && !c.destroyed && c.wrapperEl && e.target === c.wrapperEl && (c.wrapperEl.removeEventListener("transitionend", b), M());
  }
  const H = () => {
      if (c.destroyed || !c.autoplay.running) return;
      c.autoplay.paused ? l = !0 : l && (v = s, l = !1);
      const e = c.autoplay.paused ? s : g + v - new Date().getTime();
      c.autoplay.timeLeft = e, a("autoplayTimeLeft", e, e / h), n = requestAnimationFrame(() => {
        H();
      });
    },
    z = e => {
      if (c.destroyed || !c.autoplay.running) return;
      cancelAnimationFrame(n), H();
      let i = void 0 === e ? c.params.autoplay.delay : e;
      h = c.params.autoplay.delay, v = c.params.autoplay.delay;
      const r = (() => {
        let e;
        if (e = c.virtual && c.params.virtual.enabled ? c.slides.filter(e => e.classList.contains("swiper-slide-active"))[0] : c.slides[c.activeIndex], !e) return;
        return parseInt(e.getAttribute("data-swiper-autoplay"), 10);
      })();
      !Number.isNaN(r) && r > 0 && void 0 === e && (i = r, h = r, v = r), s = i;
      const o = c.params.speed,
        l = () => {
          c && !c.destroyed && (c.params.autoplay.reverseDirection ? !c.isBeginning || c.params.loop || c.params.rewind ? (c.slidePrev(o, !0, !0), a("autoplay")) : c.params.autoplay.stopOnLastSlide || (c.slideTo(c.slides.length - 1, o, !0, !0), a("autoplay")) : !c.isEnd || c.params.loop || c.params.rewind ? (c.slideNext(o, !0, !0), a("autoplay")) : c.params.autoplay.stopOnLastSlide || (c.slideTo(0, o, !0, !0), a("autoplay")), c.params.cssMode && (g = new Date().getTime(), requestAnimationFrame(() => {
            z();
          })));
        };
      return i > 0 ? (clearTimeout(t), t = setTimeout(() => {
        l();
      }, i)) : requestAnimationFrame(() => {
        l();
      }), i;
    },
    y = () => {
      c.autoplay.running = !0, z(), a("autoplayStart");
    },
    V = () => {
      c.autoplay.running = !1, clearTimeout(t), cancelAnimationFrame(n), a("autoplayStop");
    },
    x = (e, n) => {
      if (c.destroyed || !c.autoplay.running) return;
      clearTimeout(t), e || (m = !0);
      const i = () => {
        a("autoplayPause"), c.params.autoplay.waitForTransition ? c.wrapperEl.addEventListener("transitionend", b) : M();
      };
      if (c.autoplay.paused = !0, n) return p && (s = c.params.autoplay.delay), p = !1, void i();
      const r = s || c.params.autoplay.delay;
      s = r - (new Date().getTime() - g), c.isEnd && s < 0 && !c.params.loop || (s < 0 && (s = 0), i());
    },
    M = () => {
      c.isEnd && s < 0 && !c.params.loop || c.destroyed || !c.autoplay.running || (g = new Date().getTime(), m ? (m = !1, z(s)) : z(), c.autoplay.paused = !1, a("autoplayResume"));
    },
    _ = () => {
      if (c.destroyed || !c.autoplay.running) return;
      const e = Sw();
      "hidden" === e.visibilityState && (m = !0, x(!0)), "visible" === e.visibilityState && M();
    },
    w = e => {
      "mouse" === e.pointerType && (m = !0, c.animating || c.autoplay.paused || x(!0));
    },
    E = e => {
      "mouse" === e.pointerType && c.autoplay.paused && M();
    };
  r("init", () => {
    c.params.autoplay.enabled && (c.params.autoplay.pauseOnMouseEnter && (c.el.addEventListener("pointerenter", w), c.el.addEventListener("pointerleave", E)), Sw().addEventListener("visibilitychange", _), g = new Date().getTime(), y());
  }), r("destroy", () => {
    c.el.removeEventListener("pointerenter", w), c.el.removeEventListener("pointerleave", E), Sw().removeEventListener("visibilitychange", _), c.autoplay.running && V();
  }), r("beforeTransitionStart", (e, t, n) => {
    !c.destroyed && c.autoplay.running && (n || !c.params.autoplay.disableOnInteraction ? x(!0, !0) : V());
  }), r("sliderFirstMove", () => {
    !c.destroyed && c.autoplay.running && (c.params.autoplay.disableOnInteraction ? V() : (f = !0, u = !1, m = !1, d = setTimeout(() => {
      m = !0, u = !0, x(!0);
    }, 200)));
  }), r("touchEnd", () => {
    if (!c.destroyed && c.autoplay.running && f) {
      if (clearTimeout(d), clearTimeout(t), c.params.autoplay.disableOnInteraction) return u = !1, void (f = !1);
      u && c.params.cssMode && M(), u = !1, f = !1;
    }
  }), r("slideChange", () => {
    !c.destroyed && c.autoplay.running && (p = !0);
  }), Object.assign(c.autoplay, {
    start: y,
    stop: V,
    pause: x,
    resume: M
  });
}
function Uw(e, t) {
  const n = Rw(t);
  return n !== t && (n.style.backfaceVisibility = "hidden", n.style["-webkit-backface-visibility"] = "hidden"), n;
}
function $w(e) {
  let t = e.swiper,
    n = e.duration,
    c = e.transformElements,
    i = e.allSlides;
  const r = t.activeIndex;
  if (t.params.virtualTranslate && 0 !== n) {
    let e,
      n = !1;
    e = i ? c : c.filter(e => {
      const n = e.classList.contains("swiper-slide-transform") ? (e => {
        if (!e.parentElement) return t.slides.filter(t => t.shadowRoot && t.shadowRoot === e.parentNode)[0];
        return e.parentElement;
      })(e) : e;
      return t.getSlideIndex(n) === r;
    }), e.forEach(e => {
      !function (e, t) {
        t && e.addEventListener("transitionend", function n(c) {
          c.target === e && (t.call(e, c), e.removeEventListener("transitionend", n));
        });
      }(e, () => {
        if (n) return;
        if (!t || t.destroyed) return;
        n = !0, t.animating = !1;
        const e = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        t.wrapperEl.dispatchEvent(e);
      });
    });
  }
}
function Xw(e) {
  let t = e.swiper,
    n = e.extendParams,
    c = e.on;
  n({
    fadeEffect: {
      crossFade: !1
    }
  });
  !function (e) {
    const t = e.effect,
      n = e.swiper,
      c = e.on,
      i = e.setTranslate,
      r = e.setTransition,
      a = e.overwriteParams,
      o = e.perspective,
      s = e.recreateShadows,
      l = e.getEffectParams;
    let f;
    c("beforeInit", () => {
      if (n.params.effect !== t) return;
      n.classNames.push(`${n.params.containerModifierClass}${t}`), o && o() && n.classNames.push(`${n.params.containerModifierClass}3d`);
      const e = a ? a() : {};
      Object.assign(n.params, e), Object.assign(n.originalParams, e);
    }), c("setTranslate", () => {
      n.params.effect === t && i();
    }), c("setTransition", (e, c) => {
      n.params.effect === t && r(c);
    }), c("transitionEnd", () => {
      if (n.params.effect === t && s) {
        if (!l || !l().slideShadows) return;
        n.slides.forEach(e => {
          e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(e => e.remove());
        }), s();
      }
    }), c("virtualUpdate", () => {
      n.params.effect === t && (n.slides.length || (f = !0), requestAnimationFrame(() => {
        f && n.slides && n.slides.length && (i(), f = !1);
      }));
    });
  }({
    effect: "fade",
    swiper: t,
    on: c,
    setTranslate: () => {
      const e = t.slides;
      t.params.fadeEffect;
      for (let n = 0; n < e.length; n += 1) {
        const e = t.slides[n];
        let c = -e.swiperSlideOffset;
        t.params.virtualTranslate || (c -= t.translate);
        let i = 0;
        t.isHorizontal() || (i = c, c = 0);
        const r = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(e.progress), 0) : 1 + Math.min(Math.max(e.progress, -1), 0),
          a = Uw(0, e);
        a.style.opacity = r, a.style.transform = `translate3d(${c}px, ${i}px, 0px)`;
      }
    },
    setTransition: e => {
      const n = t.slides.map(e => Rw(e));
      n.forEach(t => {
        t.style.transitionDuration = `${e}ms`;
      }), $w({
        swiper: t,
        duration: e,
        transformElements: n,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !t.params.cssMode
    })
  });
}
let Zw, Kw, Qw;
function Jw() {
  return Zw || (Zw = function () {
    const e = Pw(),
      t = Sw();
    return {
      smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
      touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
    };
  }()), Zw;
}
function eE(e) {
  return void 0 === e && (e = {}), Kw || (Kw = function (e) {
    let _ref = void 0 === e ? {} : e,
      t = _ref.userAgent;
    const n = Jw(),
      c = Pw(),
      i = c.navigator.platform,
      r = t || c.navigator.userAgent,
      a = {
        ios: !1,
        android: !1
      },
      o = c.screen.width,
      s = c.screen.height,
      l = r.match(/(Android);?[\s\/]+([\d.]+)?/);
    let f = r.match(/(iPad).*OS\s([\d_]+)/);
    const u = r.match(/(iPod)(.*OS\s([\d_]+))?/),
      d = !f && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
      p = "Win32" === i;
    let m = "MacIntel" === i;
    return !f && m && n.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${o}x${s}`) >= 0 && (f = r.match(/(Version)\/([\d.]+)/), f || (f = [0, 1, "13_0_0"]), m = !1), l && !p && (a.os = "android", a.android = !0), (f || d || u) && (a.os = "ios", a.ios = !0), a;
  }(e)), Kw;
}
function tE() {
  return Qw || (Qw = function () {
    const e = Pw();
    let t = !1;
    function n() {
      const t = e.navigator.userAgent.toLowerCase();
      return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
    }
    if (n()) {
      const n = String(e.navigator.userAgent);
      if (n.includes("Version/")) {
        const _n$split$1$split$0$sp = n.split("Version/")[1].split(" ")[0].split(".").map(e => Number(e)),
          _n$split$1$split$0$sp2 = _slicedToArray(_n$split$1$split$0$sp, 2),
          e = _n$split$1$split$0$sp2[0],
          c = _n$split$1$split$0$sp2[1];
        t = e < 16 || 16 === e && c < 2;
      }
    }
    return {
      isSafari: t || n(),
      needPerspectiveFix: t,
      isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
    };
  }()), Qw;
}
var nE = {
  on(e, t, n) {
    const c = this;
    if (!c.eventsListeners || c.destroyed) return c;
    if ("function" != typeof t) return c;
    const i = n ? "unshift" : "push";
    return e.split(" ").forEach(e => {
      c.eventsListeners[e] || (c.eventsListeners[e] = []), c.eventsListeners[e][i](t);
    }), c;
  },
  once(e, t, n) {
    const c = this;
    if (!c.eventsListeners || c.destroyed) return c;
    if ("function" != typeof t) return c;
    function i() {
      c.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++) r[a] = arguments[a];
      t.apply(c, r);
    }
    return i.__emitterProxy = t, c.on(e, i, n);
  },
  onAny(e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed) return n;
    if ("function" != typeof e) return n;
    const c = t ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[c](e), n;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed) return t;
    if (!t.eventsAnyListeners) return t;
    const n = t.eventsAnyListeners.indexOf(e);
    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
  },
  off(e, t) {
    const n = this;
    return !n.eventsListeners || n.destroyed ? n : n.eventsListeners ? (e.split(" ").forEach(e => {
      void 0 === t ? n.eventsListeners[e] = [] : n.eventsListeners[e] && n.eventsListeners[e].forEach((c, i) => {
        (c === t || c.__emitterProxy && c.__emitterProxy === t) && n.eventsListeners[e].splice(i, 1);
      });
    }), n) : n;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed) return e;
    if (!e.eventsListeners) return e;
    let t, n, c;
    for (var i = arguments.length, r = new Array(i), a = 0; a < i; a++) r[a] = arguments[a];
    "string" == typeof r[0] || Array.isArray(r[0]) ? (t = r[0], n = r.slice(1, r.length), c = e) : (t = r[0].events, n = r[0].data, c = r[0].context || e), n.unshift(c);
    return (Array.isArray(t) ? t : t.split(" ")).forEach(t => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach(e => {
        e.apply(c, [t, ...n]);
      }), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach(e => {
        e.apply(c, n);
      });
    }), e;
  }
};
const cE = (e, t) => {
    if (!e || e.destroyed || !e.params) return;
    const n = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
    if (n) {
      let t = n.querySelector(`.${e.params.lazyPreloaderClass}`);
      !t && e.isElement && (n.shadowRoot ? t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        n.shadowRoot && (t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), t && t.remove());
      })), t && t.remove();
    }
  },
  iE = (e, t) => {
    if (!e.slides[t]) return;
    const n = e.slides[t].querySelector('[loading="lazy"]');
    n && n.removeAttribute("loading");
  },
  rE = e => {
    if (!e || e.destroyed || !e.params) return;
    let t = e.params.lazyPreloadPrevNext;
    const n = e.slides.length;
    if (!n || !t || t < 0) return;
    t = Math.min(t, n);
    const c = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
      i = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
      const n = i,
        r = [n - t];
      return r.push(...Array.from({
        length: t
      }).map((e, t) => n + c + t)), void e.slides.forEach((t, n) => {
        r.includes(t.column) && iE(e, n);
      });
    }
    const r = i + c - 1;
    if (e.params.rewind || e.params.loop) for (let c = i - t; c <= r + t; c += 1) {
      const t = (c % n + n) % n;
      (t < i || t > r) && iE(e, t);
    } else for (let c = Math.max(i - t, 0); c <= Math.min(r + t, n - 1); c += 1) c !== i && (c > r || c < i) && iE(e, c);
  };
var aE = {
  updateSize: function () {
    const e = this;
    let t, n;
    const c = e.el;
    t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : c.clientWidth, n = void 0 !== e.params.height && null !== e.params.height ? e.params.height : c.clientHeight, 0 === t && e.isHorizontal() || 0 === n && e.isVertical() || (t = t - parseInt(Gw(c, "padding-left") || 0, 10) - parseInt(Gw(c, "padding-right") || 0, 10), n = n - parseInt(Gw(c, "padding-top") || 0, 10) - parseInt(Gw(c, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
      width: t,
      height: n,
      size: e.isHorizontal() ? t : n
    }));
  },
  updateSlides: function () {
    const e = this;
    function t(t) {
      return e.isHorizontal() ? t : {
        width: "height",
        "margin-top": "margin-left",
        "margin-bottom ": "margin-right",
        "margin-left": "margin-top",
        "margin-right": "margin-bottom",
        "padding-left": "padding-top",
        "padding-right": "padding-bottom",
        marginRight: "marginBottom"
      }[t];
    }
    function n(e, n) {
      return parseFloat(e.getPropertyValue(t(n)) || 0);
    }
    const c = e.params,
      i = e.wrapperEl,
      r = e.slidesEl,
      a = e.size,
      o = e.rtlTranslate,
      s = e.wrongRTL,
      l = e.virtual && c.virtual.enabled,
      f = l ? e.virtual.slides.length : e.slides.length,
      u = Bw(r, `.${e.params.slideClass}, swiper-slide`),
      d = l ? e.virtual.slides.length : u.length;
    let p = [];
    const m = [],
      h = [];
    let v = c.slidesOffsetBefore;
    "function" == typeof v && (v = c.slidesOffsetBefore.call(e));
    let g = c.slidesOffsetAfter;
    "function" == typeof g && (g = c.slidesOffsetAfter.call(e));
    const b = e.snapGrid.length,
      H = e.slidesGrid.length;
    let z = c.spaceBetween,
      y = -v,
      V = 0,
      x = 0;
    if (void 0 === a) return;
    "string" == typeof z && z.indexOf("%") >= 0 ? z = parseFloat(z.replace("%", "")) / 100 * a : "string" == typeof z && (z = parseFloat(z)), e.virtualSize = -z, u.forEach(e => {
      o ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = "";
    }), c.centeredSlides && c.cssMode && (jw(i, "--swiper-centered-offset-before", ""), jw(i, "--swiper-centered-offset-after", ""));
    const M = c.grid && c.grid.rows > 1 && e.grid;
    let _;
    M && e.grid.initSlides(d);
    const w = "auto" === c.slidesPerView && c.breakpoints && Object.keys(c.breakpoints).filter(e => void 0 !== c.breakpoints[e].slidesPerView).length > 0;
    for (let i = 0; i < d; i += 1) {
      let r;
      if (_ = 0, u[i] && (r = u[i]), M && e.grid.updateSlide(i, r, d, t), !u[i] || "none" !== Gw(r, "display")) {
        if ("auto" === c.slidesPerView) {
          w && (u[i].style[t("width")] = "");
          const a = getComputedStyle(r),
            o = r.style.transform,
            s = r.style.webkitTransform;
          if (o && (r.style.transform = "none"), s && (r.style.webkitTransform = "none"), c.roundLengths) _ = e.isHorizontal() ? Ww(r, "width", !0) : Ww(r, "height", !0);else {
            const e = n(a, "width"),
              t = n(a, "padding-left"),
              c = n(a, "padding-right"),
              i = n(a, "margin-left"),
              o = n(a, "margin-right"),
              s = a.getPropertyValue("box-sizing");
            if (s && "border-box" === s) _ = e + i + o;else {
              const _r2 = r,
                n = _r2.clientWidth,
                a = _r2.offsetWidth;
              _ = e + t + c + i + o + (a - n);
            }
          }
          o && (r.style.transform = o), s && (r.style.webkitTransform = s), c.roundLengths && (_ = Math.floor(_));
        } else _ = (a - (c.slidesPerView - 1) * z) / c.slidesPerView, c.roundLengths && (_ = Math.floor(_)), u[i] && (u[i].style[t("width")] = `${_}px`);
        u[i] && (u[i].swiperSlideSize = _), h.push(_), c.centeredSlides ? (y = y + _ / 2 + V / 2 + z, 0 === V && 0 !== i && (y = y - a / 2 - z), 0 === i && (y = y - a / 2 - z), Math.abs(y) < .001 && (y = 0), c.roundLengths && (y = Math.floor(y)), x % c.slidesPerGroup == 0 && p.push(y), m.push(y)) : (c.roundLengths && (y = Math.floor(y)), (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 && p.push(y), m.push(y), y = y + _ + z), e.virtualSize += _ + z, V = _, x += 1;
      }
    }
    if (e.virtualSize = Math.max(e.virtualSize, a) + g, o && s && ("slide" === c.effect || "coverflow" === c.effect) && (i.style.width = `${e.virtualSize + z}px`), c.setWrapperSize && (i.style[t("width")] = `${e.virtualSize + z}px`), M && e.grid.updateWrapperSize(_, p, t), !c.centeredSlides) {
      const t = [];
      for (let n = 0; n < p.length; n += 1) {
        let i = p[n];
        c.roundLengths && (i = Math.floor(i)), p[n] <= e.virtualSize - a && t.push(i);
      }
      p = t, Math.floor(e.virtualSize - a) - Math.floor(p[p.length - 1]) > 1 && p.push(e.virtualSize - a);
    }
    if (l && c.loop) {
      const t = h[0] + z;
      if (c.slidesPerGroup > 1) {
        const n = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / c.slidesPerGroup),
          i = t * c.slidesPerGroup;
        for (let e = 0; e < n; e += 1) p.push(p[p.length - 1] + i);
      }
      for (let n = 0; n < e.virtual.slidesBefore + e.virtual.slidesAfter; n += 1) 1 === c.slidesPerGroup && p.push(p[p.length - 1] + t), m.push(m[m.length - 1] + t), e.virtualSize += t;
    }
    if (0 === p.length && (p = [0]), 0 !== z) {
      const n = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
      u.filter((e, t) => !(c.cssMode && !c.loop) || t !== u.length - 1).forEach(e => {
        e.style[n] = `${z}px`;
      });
    }
    if (c.centeredSlides && c.centeredSlidesBounds) {
      let e = 0;
      h.forEach(t => {
        e += t + (z || 0);
      }), e -= z;
      const t = e - a;
      p = p.map(e => e <= 0 ? -v : e > t ? t + g : e);
    }
    if (c.centerInsufficientSlides) {
      let e = 0;
      if (h.forEach(t => {
        e += t + (z || 0);
      }), e -= z, e < a) {
        const t = (a - e) / 2;
        p.forEach((e, n) => {
          p[n] = e - t;
        }), m.forEach((e, n) => {
          m[n] = e + t;
        });
      }
    }
    if (Object.assign(e, {
      slides: u,
      snapGrid: p,
      slidesGrid: m,
      slidesSizesGrid: h
    }), c.centeredSlides && c.cssMode && !c.centeredSlidesBounds) {
      jw(i, "--swiper-centered-offset-before", -p[0] + "px"), jw(i, "--swiper-centered-offset-after", e.size / 2 - h[h.length - 1] / 2 + "px");
      const t = -e.snapGrid[0],
        n = -e.slidesGrid[0];
      e.snapGrid = e.snapGrid.map(e => e + t), e.slidesGrid = e.slidesGrid.map(e => e + n);
    }
    if (d !== f && e.emit("slidesLengthChange"), p.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), m.length !== H && e.emit("slidesGridLengthChange"), c.watchSlidesProgress && e.updateSlidesOffset(), !(l || c.cssMode || "slide" !== c.effect && "fade" !== c.effect)) {
      const t = `${c.containerModifierClass}backface-hidden`,
        n = e.el.classList.contains(t);
      d <= c.maxBackfaceHiddenSlides ? n || e.el.classList.add(t) : n && e.el.classList.remove(t);
    }
  },
  updateAutoHeight: function (e) {
    const t = this,
      n = [],
      c = t.virtual && t.params.virtual.enabled;
    let i,
      r = 0;
    "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
    const a = e => c ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
    if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1) {
      if (t.params.centeredSlides) (t.visibleSlides || []).forEach(e => {
        n.push(e);
      });else for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
        const e = t.activeIndex + i;
        if (e > t.slides.length && !c) break;
        n.push(a(e));
      }
    } else n.push(a(t.activeIndex));
    for (i = 0; i < n.length; i += 1) if (void 0 !== n[i]) {
      const e = n[i].offsetHeight;
      r = e > r ? e : r;
    }
    (r || 0 === r) && (t.wrapperEl.style.height = `${r}px`);
  },
  updateSlidesOffset: function () {
    const e = this,
      t = e.slides,
      n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
    for (let c = 0; c < t.length; c += 1) t[c].swiperSlideOffset = (e.isHorizontal() ? t[c].offsetLeft : t[c].offsetTop) - n - e.cssOverflowAdjustment();
  },
  updateSlidesProgress: function (e) {
    void 0 === e && (e = this && this.translate || 0);
    const t = this,
      n = t.params,
      c = t.slides,
      i = t.rtlTranslate,
      r = t.snapGrid;
    if (0 === c.length) return;
    void 0 === c[0].swiperSlideOffset && t.updateSlidesOffset();
    let a = -e;
    i && (a = e), c.forEach(e => {
      e.classList.remove(n.slideVisibleClass);
    }), t.visibleSlidesIndexes = [], t.visibleSlides = [];
    let o = n.spaceBetween;
    "string" == typeof o && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : "string" == typeof o && (o = parseFloat(o));
    for (let e = 0; e < c.length; e += 1) {
      const s = c[e];
      let l = s.swiperSlideOffset;
      n.cssMode && n.centeredSlides && (l -= c[0].swiperSlideOffset);
      const f = (a + (n.centeredSlides ? t.minTranslate() : 0) - l) / (s.swiperSlideSize + o),
        u = (a - r[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) / (s.swiperSlideSize + o),
        d = -(a - l),
        p = d + t.slidesSizesGrid[e];
      (d >= 0 && d < t.size - 1 || p > 1 && p <= t.size || d <= 0 && p >= t.size) && (t.visibleSlides.push(s), t.visibleSlidesIndexes.push(e), c[e].classList.add(n.slideVisibleClass)), s.progress = i ? -f : f, s.originalProgress = i ? -u : u;
    }
  },
  updateProgress: function (e) {
    const t = this;
    if (void 0 === e) {
      const n = t.rtlTranslate ? -1 : 1;
      e = t && t.translate && t.translate * n || 0;
    }
    const n = t.params,
      c = t.maxTranslate() - t.minTranslate();
    let i = t.progress,
      r = t.isBeginning,
      a = t.isEnd,
      o = t.progressLoop;
    const s = r,
      l = a;
    if (0 === c) i = 0, r = !0, a = !0;else {
      i = (e - t.minTranslate()) / c;
      const n = Math.abs(e - t.minTranslate()) < 1,
        o = Math.abs(e - t.maxTranslate()) < 1;
      r = n || i <= 0, a = o || i >= 1, n && (i = 0), o && (i = 1);
    }
    if (n.loop) {
      const n = t.getSlideIndexByData(0),
        c = t.getSlideIndexByData(t.slides.length - 1),
        i = t.slidesGrid[n],
        r = t.slidesGrid[c],
        a = t.slidesGrid[t.slidesGrid.length - 1],
        s = Math.abs(e);
      o = s >= i ? (s - i) / a : (s + a - r) / a, o > 1 && (o -= 1);
    }
    Object.assign(t, {
      progress: i,
      progressLoop: o,
      isBeginning: r,
      isEnd: a
    }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), r && !s && t.emit("reachBeginning toEdge"), a && !l && t.emit("reachEnd toEdge"), (s && !r || l && !a) && t.emit("fromEdge"), t.emit("progress", i);
  },
  updateSlidesClasses: function () {
    const e = this,
      t = e.slides,
      n = e.params,
      c = e.slidesEl,
      i = e.activeIndex,
      r = e.virtual && n.virtual.enabled,
      a = e => Bw(c, `.${n.slideClass}${e}, swiper-slide${e}`)[0];
    let o;
    if (t.forEach(e => {
      e.classList.remove(n.slideActiveClass, n.slideNextClass, n.slidePrevClass);
    }), r) {
      if (n.loop) {
        let t = i - e.virtual.slidesBefore;
        t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), o = a(`[data-swiper-slide-index="${t}"]`);
      } else o = a(`[data-swiper-slide-index="${i}"]`);
    } else o = t[i];
    if (o) {
      o.classList.add(n.slideActiveClass);
      let e = function (e, t) {
        const n = [];
        for (; e.nextElementSibling;) {
          const c = e.nextElementSibling;
          t ? c.matches(t) && n.push(c) : n.push(c), e = c;
        }
        return n;
      }(o, `.${n.slideClass}, swiper-slide`)[0];
      n.loop && !e && (e = t[0]), e && e.classList.add(n.slideNextClass);
      let c = function (e, t) {
        const n = [];
        for (; e.previousElementSibling;) {
          const c = e.previousElementSibling;
          t ? c.matches(t) && n.push(c) : n.push(c), e = c;
        }
        return n;
      }(o, `.${n.slideClass}, swiper-slide`)[0];
      n.loop && 0 === !c && (c = t[t.length - 1]), c && c.classList.add(n.slidePrevClass);
    }
    e.emitSlidesClasses();
  },
  updateActiveIndex: function (e) {
    const t = this,
      n = t.rtlTranslate ? t.translate : -t.translate,
      c = t.snapGrid,
      i = t.params,
      r = t.activeIndex,
      a = t.realIndex,
      o = t.snapIndex;
    let s,
      l = e;
    const f = e => {
      let n = e - t.virtual.slidesBefore;
      return n < 0 && (n = t.virtual.slides.length + n), n >= t.virtual.slides.length && (n -= t.virtual.slides.length), n;
    };
    if (void 0 === l && (l = function (e) {
      const t = e.slidesGrid,
        n = e.params,
        c = e.rtlTranslate ? e.translate : -e.translate;
      let i;
      for (let e = 0; e < t.length; e += 1) void 0 !== t[e + 1] ? c >= t[e] && c < t[e + 1] - (t[e + 1] - t[e]) / 2 ? i = e : c >= t[e] && c < t[e + 1] && (i = e + 1) : c >= t[e] && (i = e);
      return n.normalizeSlideIndex && (i < 0 || void 0 === i) && (i = 0), i;
    }(t)), c.indexOf(n) >= 0) s = c.indexOf(n);else {
      const e = Math.min(i.slidesPerGroupSkip, l);
      s = e + Math.floor((l - e) / i.slidesPerGroup);
    }
    if (s >= c.length && (s = c.length - 1), l === r) return s !== o && (t.snapIndex = s, t.emit("snapIndexChange")), void (t.params.loop && t.virtual && t.params.virtual.enabled && (t.realIndex = f(l)));
    let u;
    u = t.virtual && i.virtual.enabled && i.loop ? f(l) : t.slides[l] ? parseInt(t.slides[l].getAttribute("data-swiper-slide-index") || l, 10) : l, Object.assign(t, {
      previousSnapIndex: o,
      snapIndex: s,
      previousRealIndex: a,
      realIndex: u,
      previousIndex: r,
      activeIndex: l
    }), t.initialized && rE(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (a !== u && t.emit("realIndexChange"), t.emit("slideChange"));
  },
  updateClickedSlide: function (e, t) {
    const n = this,
      c = n.params;
    let i = e.closest(`.${c.slideClass}, swiper-slide`);
    !i && n.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach(e => {
      !i && e.matches && e.matches(`.${c.slideClass}, swiper-slide`) && (i = e);
    });
    let r,
      a = !1;
    if (i) for (let e = 0; e < n.slides.length; e += 1) if (n.slides[e] === i) {
      a = !0, r = e;
      break;
    }
    if (!i || !a) return n.clickedSlide = void 0, void (n.clickedIndex = void 0);
    n.clickedSlide = i, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = r, c.slideToClickedSlide && void 0 !== n.clickedIndex && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
  }
};
var oE = {
  getTranslate: function (e) {
    void 0 === e && (e = this.isHorizontal() ? "x" : "y");
    const t = this.params,
      n = this.rtlTranslate,
      c = this.translate,
      i = this.wrapperEl;
    if (t.virtualTranslate) return n ? -c : c;
    if (t.cssMode) return c;
    let r = Aw(i, e);
    return r += this.cssOverflowAdjustment(), n && (r = -r), r || 0;
  },
  setTranslate: function (e, t) {
    const n = this,
      c = n.rtlTranslate,
      i = n.params,
      r = n.wrapperEl,
      a = n.progress;
    let o,
      s = 0,
      l = 0;
    n.isHorizontal() ? s = c ? -e : e : l = e, i.roundLengths && (s = Math.floor(s), l = Math.floor(l)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? s : l, i.cssMode ? r[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -s : -l : i.virtualTranslate || (n.isHorizontal() ? s -= n.cssOverflowAdjustment() : l -= n.cssOverflowAdjustment(), r.style.transform = `translate3d(${s}px, ${l}px, 0px)`);
    const f = n.maxTranslate() - n.minTranslate();
    o = 0 === f ? 0 : (e - n.minTranslate()) / f, o !== a && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
  },
  minTranslate: function () {
    return -this.snapGrid[0];
  },
  maxTranslate: function () {
    return -this.snapGrid[this.snapGrid.length - 1];
  },
  translateTo: function (e, t, n, c, i) {
    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), void 0 === c && (c = !0);
    const r = this,
      a = r.params,
      o = r.wrapperEl;
    if (r.animating && a.preventInteractionOnTransition) return !1;
    const s = r.minTranslate(),
      l = r.maxTranslate();
    let f;
    if (f = c && e > s ? s : c && e < l ? l : e, r.updateProgress(f), a.cssMode) {
      const e = r.isHorizontal();
      if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -f;else {
        if (!r.support.smoothScroll) return Fw({
          swiper: r,
          targetPosition: -f,
          side: e ? "left" : "top"
        }), !0;
        o.scrollTo({
          [e ? "left" : "top"]: -f,
          behavior: "smooth"
        });
      }
      return !0;
    }
    return 0 === t ? (r.setTransition(0), r.setTranslate(f), n && (r.emit("beforeTransitionStart", t, i), r.emit("transitionEnd"))) : (r.setTransition(t), r.setTranslate(f), n && (r.emit("beforeTransitionStart", t, i), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function (e) {
      r && !r.destroyed && e.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, n && r.emit("transitionEnd"));
    }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0;
  }
};
function sE(e) {
  let t = e.swiper,
    n = e.runCallbacks,
    c = e.direction,
    i = e.step;
  const r = t.activeIndex,
    a = t.previousIndex;
  let o = c;
  if (o || (o = r > a ? "next" : r < a ? "prev" : "reset"), t.emit(`transition${i}`), n && r !== a) {
    if ("reset" === o) return void t.emit(`slideResetTransition${i}`);
    t.emit(`slideChangeTransition${i}`), "next" === o ? t.emit(`slideNextTransition${i}`) : t.emit(`slidePrevTransition${i}`);
  }
}
var lE = {
  slideTo: function (e, t, n, c, i) {
    void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), "string" == typeof e && (e = parseInt(e, 10));
    const r = this;
    let a = e;
    a < 0 && (a = 0);
    const o = r.params,
      s = r.snapGrid,
      l = r.slidesGrid,
      f = r.previousIndex,
      u = r.activeIndex,
      d = r.rtlTranslate,
      p = r.wrapperEl,
      m = r.enabled;
    if (r.animating && o.preventInteractionOnTransition || !m && !c && !i) return !1;
    const h = Math.min(r.params.slidesPerGroupSkip, a);
    let v = h + Math.floor((a - h) / r.params.slidesPerGroup);
    v >= s.length && (v = s.length - 1);
    const g = -s[v];
    if (o.normalizeSlideIndex) for (let e = 0; e < l.length; e += 1) {
      const t = -Math.floor(100 * g),
        n = Math.floor(100 * l[e]),
        c = Math.floor(100 * l[e + 1]);
      void 0 !== l[e + 1] ? t >= n && t < c - (c - n) / 2 ? a = e : t >= n && t < c && (a = e + 1) : t >= n && (a = e);
    }
    if (r.initialized && a !== u) {
      if (!r.allowSlideNext && (d ? g > r.translate && g > r.minTranslate() : g < r.translate && g < r.minTranslate())) return !1;
      if (!r.allowSlidePrev && g > r.translate && g > r.maxTranslate() && (u || 0) !== a) return !1;
    }
    let b;
    if (a !== (f || 0) && n && r.emit("beforeSlideChangeStart"), r.updateProgress(g), b = a > u ? "next" : a < u ? "prev" : "reset", d && -g === r.translate || !d && g === r.translate) return r.updateActiveIndex(a), o.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), "slide" !== o.effect && r.setTranslate(g), "reset" !== b && (r.transitionStart(n, b), r.transitionEnd(n, b)), !1;
    if (o.cssMode) {
      const e = r.isHorizontal(),
        n = d ? g : -g;
      if (0 === t) {
        const t = r.virtual && r.params.virtual.enabled;
        t && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), t && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
          p[e ? "scrollLeft" : "scrollTop"] = n;
        })) : p[e ? "scrollLeft" : "scrollTop"] = n, t && requestAnimationFrame(() => {
          r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1;
        });
      } else {
        if (!r.support.smoothScroll) return Fw({
          swiper: r,
          targetPosition: n,
          side: e ? "left" : "top"
        }), !0;
        p.scrollTo({
          [e ? "left" : "top"]: n,
          behavior: "smooth"
        });
      }
      return !0;
    }
    return r.setTransition(t), r.setTranslate(g), r.updateActiveIndex(a), r.updateSlidesClasses(), r.emit("beforeTransitionStart", t, c), r.transitionStart(n, b), 0 === t ? r.transitionEnd(n, b) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function (e) {
      r && !r.destroyed && e.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(n, b));
    }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0;
  },
  slideToLoop: function (e, t, n, c) {
    if (void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), "string" == typeof e) {
      e = parseInt(e, 10);
    }
    const i = this;
    let r = e;
    return i.params.loop && (i.virtual && i.params.virtual.enabled ? r += i.virtual.slidesBefore : r = i.getSlideIndexByData(r)), i.slideTo(r, t, n, c);
  },
  slideNext: function (e, t, n) {
    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
    const c = this,
      i = c.enabled,
      r = c.params,
      a = c.animating;
    if (!i) return c;
    let o = r.slidesPerGroup;
    "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && (o = Math.max(c.slidesPerViewDynamic("current", !0), 1));
    const s = c.activeIndex < r.slidesPerGroupSkip ? 1 : o,
      l = c.virtual && r.virtual.enabled;
    if (r.loop) {
      if (a && !l && r.loopPreventsSliding) return !1;
      if (c.loopFix({
        direction: "next"
      }), c._clientLeft = c.wrapperEl.clientLeft, c.activeIndex === c.slides.length - 1 && r.cssMode) return requestAnimationFrame(() => {
        c.slideTo(c.activeIndex + s, e, t, n);
      }), !0;
    }
    return r.rewind && c.isEnd ? c.slideTo(0, e, t, n) : c.slideTo(c.activeIndex + s, e, t, n);
  },
  slidePrev: function (e, t, n) {
    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
    const c = this,
      i = c.params,
      r = c.snapGrid,
      a = c.slidesGrid,
      o = c.rtlTranslate,
      s = c.enabled,
      l = c.animating;
    if (!s) return c;
    const f = c.virtual && i.virtual.enabled;
    if (i.loop) {
      if (l && !f && i.loopPreventsSliding) return !1;
      c.loopFix({
        direction: "prev"
      }), c._clientLeft = c.wrapperEl.clientLeft;
    }
    function u(e) {
      return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
    }
    const d = u(o ? c.translate : -c.translate),
      p = r.map(e => u(e));
    let m = r[p.indexOf(d) - 1];
    if (void 0 === m && i.cssMode) {
      let e;
      r.forEach((t, n) => {
        d >= t && (e = n);
      }), void 0 !== e && (m = r[e > 0 ? e - 1 : e]);
    }
    let h = 0;
    if (void 0 !== m && (h = a.indexOf(m), h < 0 && (h = c.activeIndex - 1), "auto" === i.slidesPerView && 1 === i.slidesPerGroup && i.slidesPerGroupAuto && (h = h - c.slidesPerViewDynamic("previous", !0) + 1, h = Math.max(h, 0))), i.rewind && c.isBeginning) {
      const i = c.params.virtual && c.params.virtual.enabled && c.virtual ? c.virtual.slides.length - 1 : c.slides.length - 1;
      return c.slideTo(i, e, t, n);
    }
    return i.loop && 0 === c.activeIndex && i.cssMode ? (requestAnimationFrame(() => {
      c.slideTo(h, e, t, n);
    }), !0) : c.slideTo(h, e, t, n);
  },
  slideReset: function (e, t, n) {
    return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, n);
  },
  slideToClosest: function (e, t, n, c) {
    void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === c && (c = .5);
    const i = this;
    let r = i.activeIndex;
    const a = Math.min(i.params.slidesPerGroupSkip, r),
      o = a + Math.floor((r - a) / i.params.slidesPerGroup),
      s = i.rtlTranslate ? i.translate : -i.translate;
    if (s >= i.snapGrid[o]) {
      const e = i.snapGrid[o];
      s - e > (i.snapGrid[o + 1] - e) * c && (r += i.params.slidesPerGroup);
    } else {
      const e = i.snapGrid[o - 1];
      s - e <= (i.snapGrid[o] - e) * c && (r -= i.params.slidesPerGroup);
    }
    return r = Math.max(r, 0), r = Math.min(r, i.slidesGrid.length - 1), i.slideTo(r, e, t, n);
  },
  slideToClickedSlide: function () {
    const e = this,
      t = e.params,
      n = e.slidesEl,
      c = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
    let i,
      r = e.clickedIndex;
    const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
    if (t.loop) {
      if (e.animating) return;
      i = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? r < e.loopedSlides - c / 2 || r > e.slides.length - e.loopedSlides + c / 2 ? (e.loopFix(), r = e.getSlideIndex(Bw(n, `${a}[data-swiper-slide-index="${i}"]`)[0]), Tw(() => {
        e.slideTo(r);
      })) : e.slideTo(r) : r > e.slides.length - c ? (e.loopFix(), r = e.getSlideIndex(Bw(n, `${a}[data-swiper-slide-index="${i}"]`)[0]), Tw(() => {
        e.slideTo(r);
      })) : e.slideTo(r);
    } else e.slideTo(r);
  }
};
var fE = {
  loopCreate: function (e) {
    const t = this,
      n = t.params,
      c = t.slidesEl;
    if (!n.loop || t.virtual && t.params.virtual.enabled) return;
    Bw(c, `.${n.slideClass}, swiper-slide`).forEach((e, t) => {
      e.setAttribute("data-swiper-slide-index", t);
    }), t.loopFix({
      slideRealIndex: e,
      direction: n.centeredSlides ? void 0 : "next"
    });
  },
  loopFix: function (e) {
    let _ref2 = void 0 === e ? {} : e,
      t = _ref2.slideRealIndex,
      _ref2$slideTo = _ref2.slideTo,
      n = _ref2$slideTo === void 0 ? !0 : _ref2$slideTo,
      c = _ref2.direction,
      i = _ref2.setTranslate,
      r = _ref2.activeSlideIndex,
      a = _ref2.byController,
      o = _ref2.byMousewheel;
    const s = this;
    if (!s.params.loop) return;
    s.emit("beforeLoopFix");
    const l = s.slides,
      f = s.allowSlidePrev,
      u = s.allowSlideNext,
      d = s.slidesEl,
      p = s.params;
    if (s.allowSlidePrev = !0, s.allowSlideNext = !0, s.virtual && p.virtual.enabled) return n && (p.centeredSlides || 0 !== s.snapIndex ? p.centeredSlides && s.snapIndex < p.slidesPerView ? s.slideTo(s.virtual.slides.length + s.snapIndex, 0, !1, !0) : s.snapIndex === s.snapGrid.length - 1 && s.slideTo(s.virtual.slidesBefore, 0, !1, !0) : s.slideTo(s.virtual.slides.length, 0, !1, !0)), s.allowSlidePrev = f, s.allowSlideNext = u, void s.emit("loopFix");
    const m = "auto" === p.slidesPerView ? s.slidesPerViewDynamic() : Math.ceil(parseFloat(p.slidesPerView, 10));
    let h = p.loopedSlides || m;
    h % p.slidesPerGroup != 0 && (h += p.slidesPerGroup - h % p.slidesPerGroup), s.loopedSlides = h;
    const v = [],
      g = [];
    let b = s.activeIndex;
    void 0 === r ? r = s.getSlideIndex(s.slides.filter(e => e.classList.contains(p.slideActiveClass))[0]) : b = r;
    const H = "next" === c || !c,
      z = "prev" === c || !c;
    let y = 0,
      V = 0;
    if (r < h) {
      y = Math.max(h - r, p.slidesPerGroup);
      for (let e = 0; e < h - r; e += 1) {
        const t = e - Math.floor(e / l.length) * l.length;
        v.push(l.length - t - 1);
      }
    } else if (r > s.slides.length - 2 * h) {
      V = Math.max(r - (s.slides.length - 2 * h), p.slidesPerGroup);
      for (let e = 0; e < V; e += 1) {
        const t = e - Math.floor(e / l.length) * l.length;
        g.push(t);
      }
    }
    if (z && v.forEach(e => {
      s.slides[e].swiperLoopMoveDOM = !0, d.prepend(s.slides[e]), s.slides[e].swiperLoopMoveDOM = !1;
    }), H && g.forEach(e => {
      s.slides[e].swiperLoopMoveDOM = !0, d.append(s.slides[e]), s.slides[e].swiperLoopMoveDOM = !1;
    }), s.recalcSlides(), "auto" === p.slidesPerView && s.updateSlides(), p.watchSlidesProgress && s.updateSlidesOffset(), n) if (v.length > 0 && z) {
      if (void 0 === t) {
        const e = s.slidesGrid[b],
          t = s.slidesGrid[b + y] - e;
        o ? s.setTranslate(s.translate - t) : (s.slideTo(b + y, 0, !1, !0), i && (s.touches[s.isHorizontal() ? "startX" : "startY"] += t, s.touchEventsData.currentTranslate = s.translate));
      } else i && (s.slideToLoop(t, 0, !1, !0), s.touchEventsData.currentTranslate = s.translate);
    } else if (g.length > 0 && H) if (void 0 === t) {
      const e = s.slidesGrid[b],
        t = s.slidesGrid[b - V] - e;
      o ? s.setTranslate(s.translate - t) : (s.slideTo(b - V, 0, !1, !0), i && (s.touches[s.isHorizontal() ? "startX" : "startY"] += t, s.touchEventsData.currentTranslate = s.translate));
    } else s.slideToLoop(t, 0, !1, !0);
    if (s.allowSlidePrev = f, s.allowSlideNext = u, s.controller && s.controller.control && !a) {
      const e = {
        slideRealIndex: t,
        direction: c,
        setTranslate: i,
        activeSlideIndex: r,
        byController: !0
      };
      Array.isArray(s.controller.control) ? s.controller.control.forEach(t => {
        !t.destroyed && t.params.loop && t.loopFix(_objectSpread(_objectSpread({}, e), {}, {
          slideTo: t.params.slidesPerView === p.slidesPerView && n
        }));
      }) : s.controller.control instanceof s.constructor && s.controller.control.params.loop && s.controller.control.loopFix(_objectSpread(_objectSpread({}, e), {}, {
        slideTo: s.controller.control.params.slidesPerView === p.slidesPerView && n
      }));
    }
    s.emit("loopFix");
  },
  loopDestroy: function () {
    const e = this,
      t = e.params,
      n = e.slidesEl;
    if (!t.loop || e.virtual && e.params.virtual.enabled) return;
    e.recalcSlides();
    const c = [];
    e.slides.forEach(e => {
      const t = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
      c[t] = e;
    }), e.slides.forEach(e => {
      e.removeAttribute("data-swiper-slide-index");
    }), c.forEach(e => {
      n.append(e);
    }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
  }
};
var uE = {
  setGrabCursor: function (e) {
    const t = this;
    if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
    const n = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
    t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
      t.__preventObserver__ = !1;
    });
  },
  unsetGrabCursor: function () {
    const e = this;
    e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
      e.__preventObserver__ = !1;
    }));
  }
};
function dE(e) {
  const t = this,
    n = Sw(),
    c = Pw(),
    i = t.touchEventsData;
  i.evCache.push(e);
  const r = t.params,
    a = t.touches,
    o = t.enabled;
  if (!o) return;
  if (!r.simulateTouch && "mouse" === e.pointerType) return;
  if (t.animating && r.preventInteractionOnTransition) return;
  !t.animating && r.cssMode && r.loop && t.loopFix();
  let s = e;
  s.originalEvent && (s = s.originalEvent);
  let l = s.target;
  if ("wrapper" === r.touchEventsTarget && !t.wrapperEl.contains(l)) return;
  if ("which" in s && 3 === s.which) return;
  if ("button" in s && s.button > 0) return;
  if (i.isTouched && i.isMoved) return;
  const f = !!r.noSwipingClass && "" !== r.noSwipingClass,
    u = e.composedPath ? e.composedPath() : e.path;
  f && s.target && s.target.shadowRoot && u && (l = u[0]);
  const d = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`,
    p = !(!s.target || !s.target.shadowRoot);
  if (r.noSwiping && (p ? function (e, t) {
    return void 0 === t && (t = this), function t(n) {
      if (!n || n === Sw() || n === Pw()) return null;
      n.assignedSlot && (n = n.assignedSlot);
      const c = n.closest(e);
      return c || n.getRootNode ? c || t(n.getRootNode().host) : null;
    }(t);
  }(d, l) : l.closest(d))) return void (t.allowClick = !0);
  if (r.swipeHandler && !l.closest(r.swipeHandler)) return;
  a.currentX = s.pageX, a.currentY = s.pageY;
  const m = a.currentX,
    h = a.currentY,
    v = r.edgeSwipeDetection || r.iOSEdgeSwipeDetection,
    g = r.edgeSwipeThreshold || r.iOSEdgeSwipeThreshold;
  if (v && (m <= g || m >= c.innerWidth - g)) {
    if ("prevent" !== v) return;
    e.preventDefault();
  }
  Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = m, a.startY = h, i.touchStartTime = Ow(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, r.threshold > 0 && (i.allowThresholdMove = !1);
  let b = !0;
  l.matches(i.focusableElements) && (b = !1, "SELECT" === l.nodeName && (i.isTouched = !1)), n.activeElement && n.activeElement.matches(i.focusableElements) && n.activeElement !== l && n.activeElement.blur();
  const H = b && t.allowTouchMove && r.touchStartPreventDefault;
  !r.touchStartForcePreventDefault && !H || l.isContentEditable || s.preventDefault(), r.freeMode && r.freeMode.enabled && t.freeMode && t.animating && !r.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", s);
}
function pE(e) {
  const t = Sw(),
    n = this,
    c = n.touchEventsData,
    i = n.params,
    r = n.touches,
    a = n.rtlTranslate,
    o = n.enabled;
  if (!o) return;
  if (!i.simulateTouch && "mouse" === e.pointerType) return;
  let s = e;
  if (s.originalEvent && (s = s.originalEvent), !c.isTouched) return void (c.startMoving && c.isScrolling && n.emit("touchMoveOpposite", s));
  const l = c.evCache.findIndex(e => e.pointerId === s.pointerId);
  l >= 0 && (c.evCache[l] = s);
  const f = c.evCache.length > 1 ? c.evCache[0] : s,
    u = f.pageX,
    d = f.pageY;
  if (s.preventedByNestedSwiper) return r.startX = u, void (r.startY = d);
  if (!n.allowTouchMove) return s.target.matches(c.focusableElements) || (n.allowClick = !1), void (c.isTouched && (Object.assign(r, {
    startX: u,
    startY: d,
    prevX: n.touches.currentX,
    prevY: n.touches.currentY,
    currentX: u,
    currentY: d
  }), c.touchStartTime = Ow()));
  if (i.touchReleaseOnEdges && !i.loop) if (n.isVertical()) {
    if (d < r.startY && n.translate <= n.maxTranslate() || d > r.startY && n.translate >= n.minTranslate()) return c.isTouched = !1, void (c.isMoved = !1);
  } else if (u < r.startX && n.translate <= n.maxTranslate() || u > r.startX && n.translate >= n.minTranslate()) return;
  if (t.activeElement && s.target === t.activeElement && s.target.matches(c.focusableElements)) return c.isMoved = !0, void (n.allowClick = !1);
  if (c.allowTouchCallbacks && n.emit("touchMove", s), s.targetTouches && s.targetTouches.length > 1) return;
  r.currentX = u, r.currentY = d;
  const p = r.currentX - r.startX,
    m = r.currentY - r.startY;
  if (n.params.threshold && Math.sqrt(p ** 2 + m ** 2) < n.params.threshold) return;
  if (void 0 === c.isScrolling) {
    let e;
    n.isHorizontal() && r.currentY === r.startY || n.isVertical() && r.currentX === r.startX ? c.isScrolling = !1 : p * p + m * m >= 25 && (e = 180 * Math.atan2(Math.abs(m), Math.abs(p)) / Math.PI, c.isScrolling = n.isHorizontal() ? e > i.touchAngle : 90 - e > i.touchAngle);
  }
  if (c.isScrolling && n.emit("touchMoveOpposite", s), void 0 === c.startMoving && (r.currentX === r.startX && r.currentY === r.startY || (c.startMoving = !0)), c.isScrolling || n.zoom && n.params.zoom && n.params.zoom.enabled && c.evCache.length > 1) return void (c.isTouched = !1);
  if (!c.startMoving) return;
  n.allowClick = !1, !i.cssMode && s.cancelable && s.preventDefault(), i.touchMoveStopPropagation && !i.nested && s.stopPropagation();
  let h = n.isHorizontal() ? p : m,
    v = n.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  i.oneWayMovement && (h = Math.abs(h) * (a ? 1 : -1), v = Math.abs(v) * (a ? 1 : -1)), r.diff = h, h *= i.touchRatio, a && (h = -h, v = -v);
  const g = n.touchesDirection;
  n.swipeDirection = h > 0 ? "prev" : "next", n.touchesDirection = v > 0 ? "prev" : "next";
  const b = n.params.loop && !i.cssMode,
    H = "next" === n.swipeDirection && n.allowSlideNext || "prev" === n.swipeDirection && n.allowSlidePrev;
  if (!c.isMoved) {
    if (b && H && n.loopFix({
      direction: n.swipeDirection
    }), c.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const e = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      n.wrapperEl.dispatchEvent(e);
    }
    c.allowMomentumBounce = !1, !i.grabCursor || !0 !== n.allowSlideNext && !0 !== n.allowSlidePrev || n.setGrabCursor(!0), n.emit("sliderFirstMove", s);
  }
  let z;
  c.isMoved && g !== n.touchesDirection && b && H && Math.abs(h) >= 1 && (n.loopFix({
    direction: n.swipeDirection,
    setTranslate: !0
  }), z = !0), n.emit("sliderMove", s), c.isMoved = !0, c.currentTranslate = h + c.startTranslate;
  let y = !0,
    V = i.resistanceRatio;
  if (i.touchReleaseOnEdges && (V = 0), h > 0 ? (b && H && !z && c.currentTranslate > (i.centeredSlides ? n.minTranslate() - n.size / 2 : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), c.currentTranslate > n.minTranslate() && (y = !1, i.resistance && (c.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + c.startTranslate + h) ** V))) : h < 0 && (b && H && !z && c.currentTranslate < (i.centeredSlides ? n.maxTranslate() + n.size / 2 : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - ("auto" === i.slidesPerView ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
  }), c.currentTranslate < n.maxTranslate() && (y = !1, i.resistance && (c.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - c.startTranslate - h) ** V))), y && (s.preventedByNestedSwiper = !0), !n.allowSlideNext && "next" === n.swipeDirection && c.currentTranslate < c.startTranslate && (c.currentTranslate = c.startTranslate), !n.allowSlidePrev && "prev" === n.swipeDirection && c.currentTranslate > c.startTranslate && (c.currentTranslate = c.startTranslate), n.allowSlidePrev || n.allowSlideNext || (c.currentTranslate = c.startTranslate), i.threshold > 0) {
    if (!(Math.abs(h) > i.threshold || c.allowThresholdMove)) return void (c.currentTranslate = c.startTranslate);
    if (!c.allowThresholdMove) return c.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, c.currentTranslate = c.startTranslate, void (r.diff = n.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY);
  }
  i.followFinger && !i.cssMode && ((i.freeMode && i.freeMode.enabled && n.freeMode || i.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), i.freeMode && i.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(c.currentTranslate), n.setTranslate(c.currentTranslate));
}
function mE(e) {
  const t = this,
    n = t.touchEventsData,
    c = n.evCache.findIndex(t => t.pointerId === e.pointerId);
  if (c >= 0 && n.evCache.splice(c, 1), ["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e.type)) {
    if (!(["pointercancel", "contextmenu"].includes(e.type) && (t.browser.isSafari || t.browser.isWebView))) return;
  }
  const i = t.params,
    r = t.touches,
    a = t.rtlTranslate,
    o = t.slidesGrid,
    s = t.enabled;
  if (!s) return;
  if (!i.simulateTouch && "mouse" === e.pointerType) return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", l), n.allowTouchCallbacks = !1, !n.isTouched) return n.isMoved && i.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, void (n.startMoving = !1);
  i.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
  const f = Ow(),
    u = f - n.touchStartTime;
  if (t.allowClick) {
    const e = l.path || l.composedPath && l.composedPath();
    t.updateClickedSlide(e && e[0] || l.target, e), t.emit("tap click", l), u < 300 && f - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", l);
  }
  if (n.lastClickTime = Ow(), Tw(() => {
    t.destroyed || (t.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === r.diff || n.currentTranslate === n.startTranslate) return n.isTouched = !1, n.isMoved = !1, void (n.startMoving = !1);
  let d;
  if (n.isTouched = !1, n.isMoved = !1, n.startMoving = !1, d = i.followFinger ? a ? t.translate : -t.translate : -n.currentTranslate, i.cssMode) return;
  if (i.freeMode && i.freeMode.enabled) return void t.freeMode.onTouchEnd({
    currentPos: d
  });
  let p = 0,
    m = t.slidesSizesGrid[0];
  for (let e = 0; e < o.length; e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
    const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    void 0 !== o[e + t] ? d >= o[e] && d < o[e + t] && (p = e, m = o[e + t] - o[e]) : d >= o[e] && (p = e, m = o[o.length - 1] - o[o.length - 2]);
  }
  let h = null,
    v = null;
  i.rewind && (t.isBeginning ? v = i.virtual && i.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (h = 0));
  const g = (d - o[p]) / m,
    b = p < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
  if (u > i.longSwipesMs) {
    if (!i.longSwipes) return void t.slideTo(t.activeIndex);
    "next" === t.swipeDirection && (g >= i.longSwipesRatio ? t.slideTo(i.rewind && t.isEnd ? h : p + b) : t.slideTo(p)), "prev" === t.swipeDirection && (g > 1 - i.longSwipesRatio ? t.slideTo(p + b) : null !== v && g < 0 && Math.abs(g) > i.longSwipesRatio ? t.slideTo(v) : t.slideTo(p));
  } else {
    if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
    t.navigation && (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl) ? l.target === t.navigation.nextEl ? t.slideTo(p + b) : t.slideTo(p) : ("next" === t.swipeDirection && t.slideTo(null !== h ? h : p + b), "prev" === t.swipeDirection && t.slideTo(null !== v ? v : p));
  }
}
function hE() {
  const e = this,
    t = e.params,
    n = e.el;
  if (n && 0 === n.offsetWidth) return;
  t.breakpoints && e.setBreakpoint();
  const c = e.allowSlideNext,
    i = e.allowSlidePrev,
    r = e.snapGrid,
    a = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = a && t.loop;
  !("auto" === t.slidesPerView || t.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || o ? e.params.loop && !a ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = i, e.allowSlideNext = c, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
}
function vE(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function gE() {
  const e = this,
    t = e.wrapperEl,
    n = e.rtlTranslate,
    c = e.enabled;
  if (!c) return;
  let i;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  const r = e.maxTranslate() - e.minTranslate();
  i = 0 === r ? 0 : (e.translate - e.minTranslate()) / r, i !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function bE(e) {
  const t = this;
  cE(t, e.target), t.params.cssMode || "auto" !== t.params.slidesPerView && !t.params.autoHeight || t.update();
}
let HE = !1;
function zE() {}
const yE = (e, t) => {
  const n = Sw(),
    c = e.params,
    i = e.el,
    r = e.wrapperEl,
    a = e.device,
    o = !!c.nested,
    s = "on" === t ? "addEventListener" : "removeEventListener",
    l = t;
  i[s]("pointerdown", e.onTouchStart, {
    passive: !1
  }), n[s]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), n[s]("pointerup", e.onTouchEnd, {
    passive: !0
  }), n[s]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), n[s]("pointerout", e.onTouchEnd, {
    passive: !0
  }), n[s]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), n[s]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (c.preventClicks || c.preventClicksPropagation) && i[s]("click", e.onClick, !0), c.cssMode && r[s]("scroll", e.onScroll), c.updateOnWindowResize ? e[l](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", hE, !0) : e[l]("observerUpdate", hE, !0), i[s]("load", e.onLoad, {
    capture: !0
  });
};
const VE = (e, t) => e.grid && t.grid && t.grid.rows > 1;
var xE = {
  setBreakpoint: function () {
    const e = this,
      t = e.realIndex,
      n = e.initialized,
      c = e.params,
      i = e.el,
      r = c.breakpoints;
    if (!r || r && 0 === Object.keys(r).length) return;
    const a = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
    if (!a || e.currentBreakpoint === a) return;
    const o = (a in r ? r[a] : void 0) || e.originalParams,
      s = VE(e, c),
      l = VE(e, o),
      f = c.enabled;
    s && !l ? (i.classList.remove(`${c.containerModifierClass}grid`, `${c.containerModifierClass}grid-column`), e.emitContainerClasses()) : !s && l && (i.classList.add(`${c.containerModifierClass}grid`), (o.grid.fill && "column" === o.grid.fill || !o.grid.fill && "column" === c.grid.fill) && i.classList.add(`${c.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach(t => {
      if (void 0 === o[t]) return;
      const n = c[t] && c[t].enabled,
        i = o[t] && o[t].enabled;
      n && !i && e[t].disable(), !n && i && e[t].enable();
    });
    const u = o.direction && o.direction !== c.direction,
      d = c.loop && (o.slidesPerView !== c.slidesPerView || u),
      p = c.loop;
    u && n && e.changeDirection(), Iw(e.params, o);
    const m = e.params.enabled,
      h = e.params.loop;
    Object.assign(e, {
      allowTouchMove: e.params.allowTouchMove,
      allowSlideNext: e.params.allowSlideNext,
      allowSlidePrev: e.params.allowSlidePrev
    }), f && !m ? e.disable() : !f && m && e.enable(), e.currentBreakpoint = a, e.emit("_beforeBreakpoint", o), n && (d ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !p && h ? (e.loopCreate(t), e.updateSlides()) : p && !h && e.loopDestroy()), e.emit("breakpoint", o);
  },
  getBreakpoint: function (e, t, n) {
    if (void 0 === t && (t = "window"), !e || "container" === t && !n) return;
    let c = !1;
    const i = Pw(),
      r = "window" === t ? i.innerHeight : n.clientHeight,
      a = Object.keys(e).map(e => {
        if ("string" == typeof e && 0 === e.indexOf("@")) {
          const t = parseFloat(e.substr(1));
          return {
            value: r * t,
            point: e
          };
        }
        return {
          value: e,
          point: e
        };
      });
    a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
    for (let e = 0; e < a.length; e += 1) {
      const _a$e = a[e],
        r = _a$e.point,
        o = _a$e.value;
      "window" === t ? i.matchMedia(`(min-width: ${o}px)`).matches && (c = r) : o <= n.clientWidth && (c = r);
    }
    return c || "max";
  }
};
var ME = {
  addClasses: function () {
    const e = this,
      t = e.classNames,
      n = e.params,
      c = e.rtl,
      i = e.el,
      r = e.device,
      a = function (e, t) {
        const n = [];
        return e.forEach(e => {
          "object" == typeof e ? Object.keys(e).forEach(c => {
            e[c] && n.push(t + c);
          }) : "string" == typeof e && n.push(t + e);
        }), n;
      }(["initialized", n.direction, {
        "free-mode": e.params.freeMode && n.freeMode.enabled
      }, {
        autoheight: n.autoHeight
      }, {
        rtl: c
      }, {
        grid: n.grid && n.grid.rows > 1
      }, {
        "grid-column": n.grid && n.grid.rows > 1 && "column" === n.grid.fill
      }, {
        android: r.android
      }, {
        ios: r.ios
      }, {
        "css-mode": n.cssMode
      }, {
        centered: n.cssMode && n.centeredSlides
      }, {
        "watch-progress": n.watchSlidesProgress
      }], n.containerModifierClass);
    t.push(...a), i.classList.add(...t), e.emitContainerClasses();
  },
  removeClasses: function () {
    const e = this.el,
      t = this.classNames;
    e.classList.remove(...t), this.emitContainerClasses();
  }
};
var _E = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  width: null,
  height: null,
  preventInteractionOnTransition: !1,
  userAgent: null,
  url: null,
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  autoHeight: !1,
  setWrapperSize: !1,
  virtualTranslate: !1,
  effect: "slide",
  breakpoints: void 0,
  breakpointsBase: "window",
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  watchOverflow: !0,
  roundLengths: !1,
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: .5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  uniqueNavElements: !0,
  resistance: !0,
  resistanceRatio: .85,
  watchSlidesProgress: !1,
  grabCursor: !1,
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  loop: !1,
  loopedSlides: null,
  loopPreventsSliding: !0,
  rewind: !1,
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  containerModifierClass: "swiper-",
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  runCallbacksOnInit: !0,
  _emitClasses: !1
};
function wE(e, t) {
  return function (n) {
    void 0 === n && (n = {});
    const c = Object.keys(n)[0],
      i = n[c];
    "object" == typeof i && null !== i ? (!0 === e[c] && (e[c] = {
      enabled: !0
    }), "navigation" === c && e[c] && e[c].enabled && !e[c].prevEl && !e[c].nextEl && (e[c].auto = !0), ["pagination", "scrollbar"].indexOf(c) >= 0 && e[c] && e[c].enabled && !e[c].el && (e[c].auto = !0), c in e && "enabled" in i ? ("object" != typeof e[c] || "enabled" in e[c] || (e[c].enabled = !0), e[c] || (e[c] = {
      enabled: !1
    }), Iw(t, n)) : Iw(t, n)) : Iw(t, n);
  };
}
const EE = {
    eventsEmitter: nE,
    update: aE,
    translate: oE,
    transition: {
      setTransition: function (e, t) {
        const n = this;
        n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`, n.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : ""), n.emit("setTransition", e, t);
      },
      transitionStart: function (e, t) {
        void 0 === e && (e = !0);
        const n = this,
          c = n.params;
        c.cssMode || (c.autoHeight && n.updateAutoHeight(), sE({
          swiper: n,
          runCallbacks: e,
          direction: t,
          step: "Start"
        }));
      },
      transitionEnd: function (e, t) {
        void 0 === e && (e = !0);
        const n = this,
          c = n.params;
        n.animating = !1, c.cssMode || (n.setTransition(0), sE({
          swiper: n,
          runCallbacks: e,
          direction: t,
          step: "End"
        }));
      }
    },
    slide: lE,
    loop: fE,
    grabCursor: uE,
    events: {
      attachEvents: function () {
        const e = this,
          t = Sw(),
          n = e.params;
        e.onTouchStart = dE.bind(e), e.onTouchMove = pE.bind(e), e.onTouchEnd = mE.bind(e), n.cssMode && (e.onScroll = gE.bind(e)), e.onClick = vE.bind(e), e.onLoad = bE.bind(e), HE || (t.addEventListener("touchstart", zE), HE = !0), yE(e, "on");
      },
      detachEvents: function () {
        yE(this, "off");
      }
    },
    breakpoints: xE,
    checkOverflow: {
      checkOverflow: function () {
        const e = this,
          t = e.isLocked,
          n = e.params,
          c = n.slidesOffsetBefore;
        if (c) {
          const t = e.slides.length - 1,
            n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * c;
          e.isLocked = e.size > n;
        } else e.isLocked = 1 === e.snapGrid.length;
        !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
      }
    },
    classes: ME
  },
  CE = {};
class LE {
  constructor() {
    var _c2, _c3;
    let e, t;
    for (var n = arguments.length, c = new Array(n), i = 0; i < n; i++) c[i] = arguments[i];
    1 === c.length && c[0].constructor && "Object" === Object.prototype.toString.call(c[0]).slice(8, -1) ? t = c[0] : (_c2 = c, _c3 = _slicedToArray(_c2, 2), e = _c3[0], t = _c3[1], _c2), t || (t = {}), t = Iw({}, t), e && !t.el && (t.el = e);
    const r = Sw();
    if (t.el && "string" == typeof t.el && r.querySelectorAll(t.el).length > 1) {
      const e = [];
      return r.querySelectorAll(t.el).forEach(n => {
        const c = Iw({}, t, {
          el: n
        });
        e.push(new LE(c));
      }), e;
    }
    const a = this;
    a.__swiper__ = !0, a.support = Jw(), a.device = eE({
      userAgent: t.userAgent
    }), a.browser = tE(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], t.modules && Array.isArray(t.modules) && a.modules.push(...t.modules);
    const o = {};
    a.modules.forEach(e => {
      e({
        params: t,
        swiper: a,
        extendParams: wE(t, o),
        on: a.on.bind(a),
        once: a.once.bind(a),
        off: a.off.bind(a),
        emit: a.emit.bind(a)
      });
    });
    const s = Iw({}, _E, o);
    return a.params = Iw({}, s, CE, t), a.originalParams = Iw({}, a.params), a.passedParams = Iw({}, t), a.params && a.params.on && Object.keys(a.params.on).forEach(e => {
      a.on(e, a.params.on[e]);
    }), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
      enabled: a.params.enabled,
      el: e,
      classNames: [],
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      isHorizontal: () => "horizontal" === a.params.direction,
      isVertical: () => "vertical" === a.params.direction,
      activeIndex: 0,
      realIndex: 0,
      isBeginning: !0,
      isEnd: !1,
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      allowSlideNext: a.params.allowSlideNext,
      allowSlidePrev: a.params.allowSlidePrev,
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        focusableElements: a.params.focusableElements,
        lastClickTime: 0,
        clickTimeout: void 0,
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      allowClick: !0,
      allowTouchMove: a.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      imagesToLoad: [],
      imagesLoaded: 0
    }), a.emit("_swiper"), a.params.init && a.init(), a;
  }
  getSlideIndex(e) {
    const t = this.slidesEl,
      n = this.params,
      c = Yw(Bw(t, `.${n.slideClass}, swiper-slide`)[0]);
    return Yw(e) - c;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter(t => 1 * t.getAttribute("data-swiper-slide-index") === e)[0]);
  }
  recalcSlides() {
    const e = this.slidesEl,
      t = this.params;
    this.slides = Bw(e, `.${t.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, t) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const c = n.minTranslate(),
      i = (n.maxTranslate() - c) * e + c;
    n.translateTo(i, void 0 === t ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = e.el.className.split(" ").filter(t => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
    e.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed ? "" : e.className.split(" ").filter(e => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass)).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = [];
    e.slides.forEach(n => {
      const c = e.getSlideClasses(n);
      t.push({
        slideEl: n,
        classNames: c
      }), e.emit("_slideClass", n, c);
    }), e.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(e, t) {
    void 0 === e && (e = "current"), void 0 === t && (t = !1);
    const n = this.params,
      c = this.slides,
      i = this.slidesGrid,
      r = this.slidesSizesGrid,
      a = this.size,
      o = this.activeIndex;
    let s = 1;
    if ("number" == typeof n.slidesPerView) return n.slidesPerView;
    if (n.centeredSlides) {
      let e,
        t = c[o] ? c[o].swiperSlideSize : 0;
      for (let n = o + 1; n < c.length; n += 1) c[n] && !e && (t += c[n].swiperSlideSize, s += 1, t > a && (e = !0));
      for (let n = o - 1; n >= 0; n -= 1) c[n] && !e && (t += c[n].swiperSlideSize, s += 1, t > a && (e = !0));
    } else if ("current" === e) for (let e = o + 1; e < c.length; e += 1) {
      (t ? i[e] + r[e] - i[o] < a : i[e] - i[o] < a) && (s += 1);
    } else for (let e = o - 1; e >= 0; e -= 1) {
      i[o] - i[e] < a && (s += 1);
    }
    return s;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const t = e.snapGrid,
      n = e.params;
    function c() {
      const t = e.rtlTranslate ? -1 * e.translate : e.translate,
        n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
      e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let i;
    if (n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach(t => {
      t.complete && cE(e, t);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), n.freeMode && n.freeMode.enabled && !n.cssMode) c(), n.autoHeight && e.updateAutoHeight();else {
      if (("auto" === n.slidesPerView || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
        const t = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
        i = e.slideTo(t.length - 1, 0, !1, !0);
      } else i = e.slideTo(e.activeIndex, 0, !1, !0);
      i || c();
    }
    n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, t) {
    void 0 === t && (t = !0);
    const n = this,
      c = n.params.direction;
    return e || (e = "horizontal" === c ? "vertical" : "horizontal"), e === c || "horizontal" !== e && "vertical" !== e || (n.el.classList.remove(`${n.params.containerModifierClass}${c}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach(t => {
      "vertical" === e ? t.style.width = "" : t.style.height = "";
    }), n.emit("changeDirection"), t && n.update()), n;
  }
  changeLanguageDirection(e) {
    const t = this;
    t.rtl && "rtl" === e || !t.rtl && "ltr" === e || (t.rtl = "rtl" === e, t.rtlTranslate = "horizontal" === t.params.direction && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted) return !0;
    let n = e || t.params.el;
    if ("string" == typeof n && (n = document.querySelector(n)), !n) return !1;
    n.swiper = t, n.parentNode && n.parentNode.host && "SWIPER-CONTAINER" === n.parentNode.host.nodeName && (t.isElement = !0);
    const c = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let i = (() => {
      if (n && n.shadowRoot && n.shadowRoot.querySelector) {
        return n.shadowRoot.querySelector(c());
      }
      return Bw(n, c())[0];
    })();
    return !i && t.params.createElements && (i = function (e, t) {
      void 0 === t && (t = []);
      const n = document.createElement(e);
      return n.classList.add(...(Array.isArray(t) ? t : [t])), n;
    }("div", t.params.wrapperClass), n.append(i), Bw(n, `.${t.params.slideClass}`).forEach(e => {
      i.append(e);
    })), Object.assign(t, {
      el: n,
      wrapperEl: i,
      slidesEl: t.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : i,
      hostEl: t.isElement ? n.parentNode.host : n,
      mounted: !0,
      rtl: "rtl" === n.dir.toLowerCase() || "rtl" === Gw(n, "direction"),
      rtlTranslate: "horizontal" === t.params.direction && ("rtl" === n.dir.toLowerCase() || "rtl" === Gw(n, "direction")),
      wrongRTL: "-webkit-box" === Gw(i, "display")
    }), !0;
  }
  init(e) {
    const t = this;
    if (t.initialized) return t;
    if (!1 === t.mount(e)) return t;
    t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
    const n = [...t.el.querySelectorAll('[loading="lazy"]')];
    return t.isElement && n.push(...t.hostEl.querySelectorAll('[loading="lazy"]')), n.forEach(e => {
      e.complete ? cE(t, e) : e.addEventListener("load", e => {
        cE(t, e.target);
      });
    }), rE(t), t.initialized = !0, rE(t), t.emit("init"), t.emit("afterInit"), t;
  }
  destroy(e, t) {
    void 0 === e && (e = !0), void 0 === t && (t = !0);
    const n = this,
      c = n.params,
      i = n.el,
      r = n.wrapperEl,
      a = n.slides;
    return void 0 === n.params || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), c.loop && n.loopDestroy(), t && (n.removeClasses(), i.removeAttribute("style"), r.removeAttribute("style"), a && a.length && a.forEach(e => {
      e.classList.remove(c.slideVisibleClass, c.slideActiveClass, c.slideNextClass, c.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach(e => {
      n.off(e);
    }), !1 !== e && (n.el.swiper = null, function (e) {
      const t = e;
      Object.keys(t).forEach(e => {
        try {
          t[e] = null;
        } catch (e) {}
        try {
          delete t[e];
        } catch (e) {}
      });
    }(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Iw(CE, e);
  }
  static get extendedDefaults() {
    return CE;
  }
  static get defaults() {
    return _E;
  }
  static installModule(e) {
    LE.prototype.__modules__ || (LE.prototype.__modules__ = []);
    const t = LE.prototype.__modules__;
    "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach(e => LE.installModule(e)), LE) : (LE.installModule(e), LE);
  }
}
Object.keys(EE).forEach(e => {
  Object.keys(EE[e]).forEach(t => {
    LE.prototype[t] = EE[e][t];
  });
}), LE.use([function (e) {
  let t = e.swiper,
    n = e.on,
    c = e.emit;
  const i = Pw();
  let r = null,
    a = null;
  const o = () => {
      t && !t.destroyed && t.initialized && (c("beforeResize"), c("resize"));
    },
    s = () => {
      t && !t.destroyed && t.initialized && c("orientationchange");
    };
  n("init", () => {
    t.params.resizeObserver && void 0 !== i.ResizeObserver ? t && !t.destroyed && t.initialized && (r = new ResizeObserver(e => {
      a = i.requestAnimationFrame(() => {
        const n = t.width,
          c = t.height;
        let i = n,
          r = c;
        e.forEach(e => {
          let n = e.contentBoxSize,
            c = e.contentRect,
            a = e.target;
          a && a !== t.el || (i = c ? c.width : (n[0] || n).inlineSize, r = c ? c.height : (n[0] || n).blockSize);
        }), i === n && r === c || o();
      });
    }), r.observe(t.el)) : (i.addEventListener("resize", o), i.addEventListener("orientationchange", s));
  }), n("destroy", () => {
    a && i.cancelAnimationFrame(a), r && r.unobserve && t.el && (r.unobserve(t.el), r = null), i.removeEventListener("resize", o), i.removeEventListener("orientationchange", s);
  });
}, function (e) {
  let t = e.swiper,
    n = e.extendParams,
    c = e.on,
    i = e.emit;
  const r = [],
    a = Pw(),
    o = function (e, n) {
      void 0 === n && (n = {});
      const c = new (a.MutationObserver || a.WebkitMutationObserver)(e => {
        if (t.__preventObserver__) return;
        if (1 === e.length) return void i("observerUpdate", e[0]);
        const n = function () {
          i("observerUpdate", e[0]);
        };
        a.requestAnimationFrame ? a.requestAnimationFrame(n) : a.setTimeout(n, 0);
      });
      c.observe(e, {
        attributes: void 0 === n.attributes || n.attributes,
        childList: void 0 === n.childList || n.childList,
        characterData: void 0 === n.characterData || n.characterData
      }), r.push(c);
    };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), c("init", () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const e = function (e, t) {
          const n = [];
          let c = e.parentElement;
          for (; c;) t ? c.matches(t) && n.push(c) : n.push(c), c = c.parentElement;
          return n;
        }(t.hostEl);
        for (let t = 0; t < e.length; t += 1) o(e[t]);
      }
      o(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }), c("destroy", () => {
    r.forEach(e => {
      e.disconnect();
    }), r.splice(0, r.length);
  });
}]);
const NE = ["eventsPrefix", "injectStyles", "injectStylesUrls", "modules", "init", "_direction", "oneWayMovement", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "breakpointsBase", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_loop", "loopedSlides", "loopPreventsSliding", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideActiveClass", "slideVisibleClass", "slideNextClass", "slidePrevClass", "wrapperClass", "lazyPreloaderClass", "lazyPreloadPrevNext", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren", "a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom", "control"];
function SE(e) {
  return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1) && !e.__swiper__;
}
function kE(e, t) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter(e => n.indexOf(e) < 0).forEach(n => {
    void 0 === e[n] ? e[n] = t[n] : SE(t[n]) && SE(e[n]) && Object.keys(t[n]).length > 0 ? t[n].__swiper__ ? e[n] = t[n] : kE(e[n], t[n]) : e[n] = t[n];
  });
}
function PE(e) {
  return void 0 === e && (e = {}), e.navigation && void 0 === e.navigation.nextEl && void 0 === e.navigation.prevEl;
}
function TE(e) {
  return void 0 === e && (e = {}), e.pagination && void 0 === e.pagination.el;
}
function OE(e) {
  return void 0 === e && (e = {}), e.scrollbar && void 0 === e.scrollbar.el;
}
function AE(e) {
  void 0 === e && (e = "");
  const t = e.split(" ").map(e => e.trim()).filter(e => !!e),
    n = [];
  return t.forEach(e => {
    n.indexOf(e) < 0 && n.push(e);
  }), n.join(" ");
}
function DE(e) {
  return void 0 === e && (e = ""), e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function IE() {
  return IE = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, IE.apply(this, arguments);
}
function jE(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function FE(e) {
  const n = [];
  return t.Children.toArray(e).forEach(e => {
    jE(e) ? n.push(e) : e.props && e.props.children && FE(e.props.children).forEach(e => n.push(e));
  }), n;
}
function RE(e) {
  const n = [],
    c = {
      "container-start": [],
      "container-end": [],
      "wrapper-start": [],
      "wrapper-end": []
    };
  return t.Children.toArray(e).forEach(e => {
    if (jE(e)) n.push(e);else if (e.props && e.props.slot && c[e.props.slot]) c[e.props.slot].push(e);else if (e.props && e.props.children) {
      const t = FE(e.props.children);
      t.length > 0 ? t.forEach(e => n.push(e)) : c["container-end"].push(e);
    } else c["container-end"].push(e);
  }), {
    slides: n,
    slots: c
  };
}
function BE(e, t) {
  return "undefined" == typeof window ? i(e, t) : r(e, t);
}
const GE = /*#__PURE__*/d(null),
  YE = /*#__PURE__*/d(null),
  WE = /*#__PURE__*/f(function (e, r) {
    let _ref3 = void 0 === e ? {} : e,
      a = _ref3.className,
      _ref3$tag = _ref3.tag,
      o = _ref3$tag === void 0 ? "div" : _ref3$tag,
      _ref3$wrapperTag = _ref3.wrapperTag,
      s = _ref3$wrapperTag === void 0 ? "div" : _ref3$wrapperTag,
      l = _ref3.children,
      f = _ref3.onSwiper,
      u = _objectWithoutProperties(_ref3, _excluded),
      d = !1;
    const _c4 = c("swiper"),
      _c5 = _slicedToArray(_c4, 2),
      p = _c5[0],
      m = _c5[1],
      _c6 = c(null),
      _c7 = _slicedToArray(_c6, 2),
      h = _c7[0],
      v = _c7[1],
      _c8 = c(!1),
      _c9 = _slicedToArray(_c8, 2),
      g = _c9[0],
      b = _c9[1],
      H = n(!1),
      z = n(null),
      y = n(null),
      V = n(null),
      x = n(null),
      M = n(null),
      _ = n(null),
      w = n(null),
      E = n(null),
      _ref4 = function (e, t) {
        void 0 === e && (e = {}), void 0 === t && (t = !0);
        const n = {
            on: {}
          },
          c = {},
          i = {};
        kE(n, _E), n._emitClasses = !0, n.init = !1;
        const r = {},
          a = NE.map(e => e.replace(/_/, "")),
          o = Object.assign({}, e);
        return Object.keys(o).forEach(o => {
          void 0 !== e[o] && (a.indexOf(o) >= 0 ? SE(e[o]) ? (n[o] = {}, i[o] = {}, kE(n[o], e[o]), kE(i[o], e[o])) : (n[o] = e[o], i[o] = e[o]) : 0 === o.search(/on[A-Z]/) && "function" == typeof e[o] ? t ? c[`${o[2].toLowerCase()}${o.substr(3)}`] = e[o] : n.on[`${o[2].toLowerCase()}${o.substr(3)}`] = e[o] : r[o] = e[o]);
        }), ["navigation", "pagination", "scrollbar"].forEach(e => {
          !0 === n[e] && (n[e] = {}), !1 === n[e] && delete n[e];
        }), {
          params: n,
          passedParams: i,
          rest: r,
          events: c
        };
      }(u),
      C = _ref4.params,
      L = _ref4.passedParams,
      N = _ref4.rest,
      S = _ref4.events,
      _RE = RE(l),
      k = _RE.slides,
      P = _RE.slots,
      T = () => {
        b(!g);
      };
    Object.assign(C.on, {
      _containerClasses(e, t) {
        m(t);
      }
    });
    const O = () => {
      Object.assign(C.on, S), d = !0;
      const e = _objectSpread({}, C);
      if (delete e.wrapperClass, y.current = new LE(e), y.current.virtual && y.current.params.virtual.enabled) {
        y.current.virtual.slides = k;
        const e = {
          cache: !1,
          slides: k,
          renderExternal: v,
          renderExternalUpdate: !1
        };
        kE(y.current.params.virtual, e), kE(y.current.originalParams.virtual, e);
      }
    };
    z.current || O(), y.current && y.current.on("_beforeBreakpoint", T);
    return i(() => () => {
      y.current && y.current.off("_beforeBreakpoint", T);
    }), i(() => {
      !H.current && y.current && (y.current.emitSlidesClasses(), H.current = !0);
    }), BE(() => {
      if (r && (r.current = z.current), z.current) return y.current.destroyed && O(), function (e, t) {
        let n = e.el,
          c = e.nextEl,
          i = e.prevEl,
          r = e.paginationEl,
          a = e.scrollbarEl,
          o = e.swiper;
        PE(t) && c && i && (o.params.navigation.nextEl = c, o.originalParams.navigation.nextEl = c, o.params.navigation.prevEl = i, o.originalParams.navigation.prevEl = i), TE(t) && r && (o.params.pagination.el = r, o.originalParams.pagination.el = r), OE(t) && a && (o.params.scrollbar.el = a, o.originalParams.scrollbar.el = a), o.init(n);
      }({
        el: z.current,
        nextEl: M.current,
        prevEl: _.current,
        paginationEl: w.current,
        scrollbarEl: E.current,
        swiper: y.current
      }, C), f && f(y.current), () => {
        y.current && !y.current.destroyed && y.current.destroy(!0, !1);
      };
    }, []), BE(() => {
      !d && S && y.current && Object.keys(S).forEach(e => {
        y.current.on(e, S[e]);
      });
      const e = function (e, t, n, c, i) {
        const r = [];
        if (!t) return r;
        const a = e => {
          r.indexOf(e) < 0 && r.push(e);
        };
        if (n && c) {
          const e = c.map(i),
            t = n.map(i);
          e.join("") !== t.join("") && a("children"), c.length !== n.length && a("children");
        }
        return NE.filter(e => "_" === e[0]).map(e => e.replace(/_/, "")).forEach(n => {
          if (n in e && n in t) if (SE(e[n]) && SE(t[n])) {
            const c = Object.keys(e[n]),
              i = Object.keys(t[n]);
            c.length !== i.length ? a(n) : (c.forEach(c => {
              e[n][c] !== t[n][c] && a(n);
            }), i.forEach(c => {
              e[n][c] !== t[n][c] && a(n);
            }));
          } else e[n] !== t[n] && a(n);
        }), r;
      }(L, V.current, k, x.current, e => e.key);
      return V.current = L, x.current = k, e.length && y.current && !y.current.destroyed && function (e) {
        let t = e.swiper,
          n = e.slides,
          c = e.passedParams,
          i = e.changedParams,
          r = e.nextEl,
          a = e.prevEl,
          o = e.scrollbarEl,
          s = e.paginationEl;
        const l = i.filter(e => "children" !== e && "direction" !== e && "wrapperClass" !== e),
          f = t.params,
          u = t.pagination,
          d = t.navigation,
          p = t.scrollbar,
          m = t.virtual,
          h = t.thumbs;
        let v, g, b, H, z, y, V, x;
        i.includes("thumbs") && c.thumbs && c.thumbs.swiper && f.thumbs && !f.thumbs.swiper && (v = !0), i.includes("controller") && c.controller && c.controller.control && f.controller && !f.controller.control && (g = !0), i.includes("pagination") && c.pagination && (c.pagination.el || s) && (f.pagination || !1 === f.pagination) && u && !u.el && (b = !0), i.includes("scrollbar") && c.scrollbar && (c.scrollbar.el || o) && (f.scrollbar || !1 === f.scrollbar) && p && !p.el && (H = !0), i.includes("navigation") && c.navigation && (c.navigation.prevEl || a) && (c.navigation.nextEl || r) && (f.navigation || !1 === f.navigation) && d && !d.prevEl && !d.nextEl && (z = !0);
        const M = e => {
          t[e] && (t[e].destroy(), "navigation" === e ? (t.isElement && (t[e].prevEl.remove(), t[e].nextEl.remove()), f[e].prevEl = void 0, f[e].nextEl = void 0, t[e].prevEl = void 0, t[e].nextEl = void 0) : (t.isElement && t[e].el.remove(), f[e].el = void 0, t[e].el = void 0));
        };
        i.includes("loop") && t.isElement && (f.loop && !c.loop ? y = !0 : !f.loop && c.loop ? V = !0 : x = !0), l.forEach(e => {
          if (SE(f[e]) && SE(c[e])) kE(f[e], c[e]), "navigation" !== e && "pagination" !== e && "scrollbar" !== e || !("enabled" in c[e]) || c[e].enabled || M(e);else {
            const t = c[e];
            !0 !== t && !1 !== t || "navigation" !== e && "pagination" !== e && "scrollbar" !== e ? f[e] = c[e] : !1 === t && M(e);
          }
        }), l.includes("controller") && !g && t.controller && t.controller.control && f.controller && f.controller.control && (t.controller.control = f.controller.control), i.includes("children") && n && m && f.virtual.enabled && (m.slides = n, m.update(!0)), i.includes("children") && n && f.loop && (x = !0), v && h.init() && h.update(!0);
        g && (t.controller.control = f.controller.control), b && (!t.isElement || s && "string" != typeof s || (s = document.createElement("div"), s.classList.add("swiper-pagination"), s.part.add("pagination"), t.el.appendChild(s)), s && (f.pagination.el = s), u.init(), u.render(), u.update()), H && (!t.isElement || o && "string" != typeof o || (o = document.createElement("div"), o.classList.add("swiper-scrollbar"), o.part.add("scrollbar"), t.el.appendChild(o)), o && (f.scrollbar.el = o), p.init(), p.updateSize(), p.setTranslate()), z && (t.isElement && (r && "string" != typeof r || (r = document.createElement("div"), r.classList.add("swiper-button-next"), r.innerHTML = t.hostEl.constructor.nextButtonSvg, r.part.add("button-next"), t.el.appendChild(r)), a && "string" != typeof a || (a = document.createElement("div"), a.classList.add("swiper-button-prev"), a.innerHTML = t.hostEl.constructor.prevButtonSvg, a.part.add("button-prev"), t.el.appendChild(a))), r && (f.navigation.nextEl = r), a && (f.navigation.prevEl = a), d.init(), d.update()), i.includes("allowSlideNext") && (t.allowSlideNext = c.allowSlideNext), i.includes("allowSlidePrev") && (t.allowSlidePrev = c.allowSlidePrev), i.includes("direction") && t.changeDirection(c.direction, !1), (y || x) && t.loopDestroy(), (V || x) && t.loopCreate(), t.update();
      }({
        swiper: y.current,
        slides: k,
        passedParams: L,
        changedParams: e,
        nextEl: M.current,
        prevEl: _.current,
        scrollbarEl: E.current,
        paginationEl: w.current
      }), () => {
        S && y.current && Object.keys(S).forEach(e => {
          y.current.off(e, S[e]);
        });
      };
    }), BE(() => {
      var e;
      !(e = y.current) || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
    }, [h]), /*#__PURE__*/t.createElement(o, IE({
      ref: z,
      className: AE(`${p}${a ? ` ${a}` : ""}`)
    }, N), /*#__PURE__*/t.createElement(YE.Provider, {
      value: y.current
    }, P["container-start"], /*#__PURE__*/t.createElement(s, {
      className: DE(C.wrapperClass)
    }, P["wrapper-start"], C.virtual ? function (e, n, c) {
      if (!c) return null;
      const i = e => {
          let t = e;
          return e < 0 ? t = n.length + e : t >= n.length && (t -= n.length), t;
        },
        r = e.isHorizontal() ? {
          [e.rtlTranslate ? "right" : "left"]: `${c.offset}px`
        } : {
          top: `${c.offset}px`
        },
        a = c.from,
        o = c.to,
        s = e.params.loop ? -n.length : 0,
        l = e.params.loop ? 2 * n.length : n.length,
        f = [];
      for (let e = s; e < l; e += 1) e >= a && e <= o && f.push(n[i(e)]);
      return f.map((n, c) => /*#__PURE__*/t.cloneElement(n, {
        swiper: e,
        style: r,
        key: `slide-${c}`
      }));
    }(y.current, k, h) : k.map((e, n) => /*#__PURE__*/t.cloneElement(e, {
      swiper: y.current,
      swiperSlideIndex: n
    })), P["wrapper-end"]), PE(C) && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("div", {
      ref: _,
      className: "swiper-button-prev"
    }), /*#__PURE__*/t.createElement("div", {
      ref: M,
      className: "swiper-button-next"
    })), OE(C) && /*#__PURE__*/t.createElement("div", {
      ref: E,
      className: "swiper-scrollbar"
    }), TE(C) && /*#__PURE__*/t.createElement("div", {
      ref: w,
      className: "swiper-pagination"
    }), P["container-end"]));
  });
WE.displayName = "Swiper";
const qE = /*#__PURE__*/f(function (e, i) {
  let _ref5 = void 0 === e ? {} : e,
    _ref5$tag = _ref5.tag,
    r = _ref5$tag === void 0 ? "div" : _ref5$tag,
    a = _ref5.children,
    _ref5$className = _ref5.className,
    o = _ref5$className === void 0 ? "" : _ref5$className,
    s = _ref5.swiper,
    l = _ref5.zoom,
    f = _ref5.lazy,
    u = _ref5.virtualIndex,
    d = _ref5.swiperSlideIndex,
    p = _objectWithoutProperties(_ref5, _excluded2);
  const m = n(null),
    _c10 = c("swiper-slide"),
    _c11 = _slicedToArray(_c10, 2),
    h = _c11[0],
    v = _c11[1],
    _c12 = c(!1),
    _c13 = _slicedToArray(_c12, 2),
    g = _c13[0],
    b = _c13[1];
  function H(e, t, n) {
    t === m.current && v(n);
  }
  BE(() => {
    if (void 0 !== d && (m.current.swiperSlideIndex = d), i && (i.current = m.current), m.current && s) {
      if (!s.destroyed) return s.on("_slideClass", H), () => {
        s && s.off("_slideClass", H);
      };
      "swiper-slide" !== h && v("swiper-slide");
    }
  }), BE(() => {
    s && m.current && !s.destroyed && v(s.getSlideClasses(m.current));
  }, [s]);
  const z = {
      isActive: h.indexOf("swiper-slide-active") >= 0,
      isVisible: h.indexOf("swiper-slide-visible") >= 0,
      isPrev: h.indexOf("swiper-slide-prev") >= 0,
      isNext: h.indexOf("swiper-slide-next") >= 0
    },
    y = () => "function" == typeof a ? a(z) : a;
  return /*#__PURE__*/t.createElement(r, IE({
    ref: m,
    className: AE(`${h}${o ? ` ${o}` : ""}`),
    "data-swiper-slide-index": u,
    onLoad: () => {
      b(!0);
    }
  }, p), l && /*#__PURE__*/t.createElement(GE.Provider, {
    value: z
  }, /*#__PURE__*/t.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": "number" == typeof l ? l : void 0
  }, y(), f && !g && /*#__PURE__*/t.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !l && /*#__PURE__*/t.createElement(GE.Provider, {
    value: z
  }, y(), f && !g && /*#__PURE__*/t.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
qE.displayName = "SwiperSlide";
var UE = ["modern"],
  $E = ["none", "s", "m", "l", "xl", "xxl"],
  XE = {
    theme: p.oneOf(UE),
    headline: p.string,
    description: p.string,
    layoutType: p.oneOf(["fullscreen_all_centered", "fullscreen_text_top_search_bottom", "fullscreen_all_bottom", "partial_screen_all_bottom"]),
    bgType: p.oneOf(["single_photo", "photo_gallery", "video"]),
    bgImage: p.string,
    bgImageAltText: p.string,
    bgVideo: p.string,
    bgImageGallery: p.array,
    bgImageGalleryAutoPlay: p.bool,
    bgImageGalleryAutoPlayDelay: p.number,
    searchLink: p.string,
    customParams: p.array,
    dateRangeProps: p.object,
    onGuestsIncrement: p.func,
    onGuestsDecrement: p.func,
    guests: p.number,
    maxGuests: p.number,
    primaryColor: p.string,
    primaryTextColor: p.string,
    isHome: p.bool,
    isVehicle: p.bool,
    hasNarrowContainer: p.bool
  },
  ZE = {
    theme: "modern",
    layoutType: "fullscreen_all_centered",
    bgType: "single_photo",
    bgImageGallery: [],
    bgImage: "",
    bgImageAltText: "",
    bgVideo: "",
    headline: "Hero Slice Headline",
    description: "This is a description for the Hero Slice.",
    maxGuests: 24,
    guests: 1,
    searchLink: "/",
    isHome: !0,
    bgImageGalleryAutoPlay: !1,
    bgImageGalleryAutoPlayDelay: 3e3,
    customParams: []
  },
  KE = function (e) {
    var r = BH(),
      o = r.height,
      s = r.isWidescreen,
      l = r.isTouch,
      f = r.isTablet,
      u = r.isMobile,
      d = n(null),
      p = y(c(0), 2),
      m = p[0],
      h = p[1],
      v = y(c(0), 2),
      g = v[0],
      H = v[1],
      z = function () {
        return /*#__PURE__*/t.createElement(TH, {
          color: "white",
          textAlign: "center",
          className: x.hero__headlineShadow
        }, e.headline);
      },
      V = function () {
        return /*#__PURE__*/t.createElement(Rb, {
          className: x.hero__description
        }, e.description);
      },
      M = a(function () {
        d.current && d.current.swiper.slidePrev();
      }, []),
      _ = a(function () {
        d.current && d.current.swiper.slideNext();
      }, []),
      w = a(function (e) {
        d.current && d.current.swiper.slideTo(e);
      }, []);
    return i(function () {
      l && 0 === m && h("partial_screen_all_bottom" === e.layoutType && f ? o - 120 : o);
    }, [l, o, m]), /*#__PURE__*/t.createElement(Rb, {
      className: kH(x.hero, b({}, x.partialHeight, "partial_screen_all_bottom" === e.layoutType)),
      setPositionRelative: !0,
      style: l ? {
        height: m
      } : null
    }, "single_photo" === e.bgType && "" !== e.bgImage && /*#__PURE__*/t.createElement(Rb, {
      className: x.hero__singleImageBg
    }, /*#__PURE__*/t.createElement("img", {
      src: e.bgImage,
      alt: e.bgImageAltText
    })), "video" === e.bgType && "" !== e.bgVideo && /*#__PURE__*/t.createElement(Rb, {
      className: x.hero__singleImageBg
    }, /*#__PURE__*/t.createElement("video", {
      playsInline: !0,
      controls: !1,
      autoPlay: !0,
      muted: !0,
      loop: !0
    }, /*#__PURE__*/t.createElement("source", {
      src: e.bgVideo
    }))), "photo_gallery" === e.bgType && e.bgImageGallery.length > 0 && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Rb, {
      className: x.hero__singleImageBg
    }, /*#__PURE__*/t.createElement(WE, {
      ref: d,
      slidesPerView: 1,
      style: {
        height: "100%",
        zIndex: 0
      },
      loop: !0,
      onSlideChange: function (e) {
        H(e.realIndex);
      },
      modules: [Xw, qw],
      effect: "fade",
      fadeEffect: {
        crossFade: !0
      },
      autoplay: e.bgImageGalleryAutoPlay
    }, e.bgImageGallery.map(function (e, n) {
      return /*#__PURE__*/t.createElement(qE, {
        key: "slide-".concat(n)
      }, /*#__PURE__*/t.createElement("img", {
        src: e.url,
        alt: e.alt_text,
        className: x.hero__swiperSlide
      }));
    }))), /*#__PURE__*/t.createElement(Ub, {
      className: kH(x.swiperControl, x.prev, b(b({}, x.adjustForPartialHeight, "partial_screen_all_bottom" === e.layoutType), x.isNotHome, !e.isHome)),
      renderAs: "button",
      onClick: function () {
        return M();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronLeft"
    })), /*#__PURE__*/t.createElement(Ub, {
      className: kH(x.swiperControl, x.next, b(b({}, x.adjustForPartialHeight, "partial_screen_all_bottom" === e.layoutType), x.isNotHome, !e.isHome)),
      renderAs: "button",
      onClick: function () {
        return _();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronRight"
    })), /*#__PURE__*/t.createElement(Ub, {
      gap: "xs",
      alignItems: "center",
      className: kH(x.swiperNav, b(b({}, x.adjustForPartialHeight, "partial_screen_all_bottom" === e.layoutType), x.isNotHome, !e.isHome))
    }, e.bgImageGallery.map(function (e, n) {
      return /*#__PURE__*/t.createElement(Rb, {
        key: "indicator-".concat(n),
        renderAs: "button",
        className: kH(x.swiperNav__dot, b({}, x.active, n === g)),
        onClick: function () {
          return w(n);
        }
      });
    })), /*#__PURE__*/t.createElement(Rb, {
      className: x.swiperNav__scrim
    })), /*#__PURE__*/t.createElement(Ub, {
      className: kH(x.hero__content, b(b({}, x["layout-".concat(e.layoutType)], e.layoutType), x.isNotHome, !e.isHome)),
      justifyContent: u ? "flex-end" : "center",
      alignItems: "center",
      flexDirection: "column"
    }, "fullscreen_text_top_search_bottom" === e.layoutType ? /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Bb, {
      variation: s ? e.hasNarrowContainer ? "narrow" : "default" : "fluid"
    }, /*#__PURE__*/t.createElement(Rb, {
      flex: "1"
    }, e.headline && z(), e.description && V())), e.isHome && /*#__PURE__*/t.createElement(Rb, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/t.createElement(Bb, {
      variation: s ? e.hasNarrowContainer ? "narrow" : "default" : "fluid",
      className: "photo_gallery" === e.bgType ? x.adjustPhotoGallery : null
    }, /*#__PURE__*/t.createElement(Ew, {
      isVehicle: e.isVehicle,
      dateRangeProps: e.dateRangeProps,
      searchLink: e.searchLink,
      guests: e.guests,
      maxGuests: e.maxGuests,
      onGuestsIncrement: e.onGuestsIncrement,
      onGuestsDecrement: e.onGuestsDecrement,
      customParams: e.customParams
    })))) : /*#__PURE__*/t.createElement(Bb, {
      variation: s ? e.hasNarrowContainer ? "narrow" : "default" : "fluid",
      className: kH(x.hero__container, b({}, x.adjustPhotoGallery, "photo_gallery" === e.bgType && "partial_screen_all_bottom" !== e.layoutType && "fullscreen_all_centered" !== e.layoutType))
    }, e.headline && z(), e.description && V(), e.isHome && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
      size: u ? "m" : "l"
    }), /*#__PURE__*/t.createElement(Ew, {
      isVehicle: e.isVehicle,
      dateRangeProps: e.dateRangeProps,
      searchLink: e.searchLink,
      guests: e.guests,
      maxGuests: e.maxGuests,
      onGuestsIncrement: e.onGuestsIncrement,
      onGuestsDecrement: e.onGuestsDecrement,
      isPhotoGalleryLayout: "photo_gallery" === e.bgType,
      isPartialLayout: "partial_screen_all_bottom" === e.layoutType,
      customParams: e.customParams
    }), "fullscreen_all_centered" === e.layoutType && /*#__PURE__*/t.createElement(Yb, {
      size: "xs"
    })))));
  };
function QE(e) {
  var t = e.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
  return "".concat(Number.parseInt(t[1], 16), ", ").concat(Number.parseInt(t[2], 16), ", ").concat(Number.parseInt(t[3], 16));
}
KE.propTypes = XE, KE.defaultProps = ZE;
var JE = function (e, t, n, c) {
    return {
      setCustomColors: function () {
        e && (document.documentElement.style.setProperty("--primary-color", e), document.documentElement.style.setProperty("--primary-color-rgb", QE(e))), e && t && document.documentElement.style.setProperty("--primary-text-color", t), n && (document.documentElement.style.setProperty("--secondary-color", n), document.documentElement.style.setProperty("--secondary-color-rgb", QE(n))), c && document.documentElement.style.setProperty("--secondary-text-color", c);
      }
    };
  },
  eC = ["theme", "primaryColor", "primaryTextColor"],
  tC = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = z(e, eC),
      a = JE(n, c).setCustomColors;
    return i(function () {
      a();
    }, [n, c]), /*#__PURE__*/t.createElement(KE, r);
  };
tC.propTypes = XE, tC.defaultProps = ZE;
var nC = "DecorativeHeadline-module_DecorativeHeadline__XYK-i",
  cC = "DecorativeHeadline-module_DecorativeHeadline__text__09uws",
  iC = {
    theme: p.oneOf(UE),
    marginTop: p.oneOf($E),
    marginBottom: p.oneOf($E),
    hasNarrowContainer: p.bool,
    headlineText: p.string,
    secondaryColor: p.string
  },
  rC = {
    theme: "modern",
    marginTop: "xl",
    marginBottom: "xl",
    headlineText: "Decorative Headline"
  },
  aC = function (e) {
    switch (e) {
      case "xxl":
        return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
          size: "xxl"
        }), /*#__PURE__*/t.createElement(Yb, {
          size: "xxl"
        }));
      case "xl":
        return /*#__PURE__*/t.createElement(Yb, {
          size: "xxl"
        });
      case "l":
        return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
          size: "l"
        }), /*#__PURE__*/t.createElement(Yb, {
          size: "l"
        }));
      case "m":
        return /*#__PURE__*/t.createElement(Yb, {
          size: "l"
        });
      case "s":
        return /*#__PURE__*/t.createElement(Yb, {
          size: "m"
        });
      default:
        return null;
    }
  },
  oC = function (e, n, c) {
    var i = e.siteName,
      r = null;
    return c && (e.logoWhiteMobile ? r = e.logoWhiteMobile.url : e.logoMobile && (r = e.logoMobile.url)), r || (e.logoWhite ? r = e.logoWhite.url : e.logo && (r = e.logo.url)), r ? /*#__PURE__*/t.createElement("img", {
      src: r,
      alt: i,
      className: kH("nav-logo-image", b({}, "isNavPanel", n))
    }) : /*#__PURE__*/t.createElement(TH, {
      size: "s",
      color: "white",
      truncate: !0
    }, i);
  },
  sC = function (e) {
    return y(c(null), 0), i(function () {}, []), /*#__PURE__*/t.createElement(t.Fragment, null, aC(e.marginTop), /*#__PURE__*/t.createElement(Rb, {
      className: nC
    }, /*#__PURE__*/t.createElement(Bb, {
      variation: e.hasNarrowContainer ? "narrow" : "default"
    }, /*#__PURE__*/t.createElement(Rb, {
      className: "columns"
    }, /*#__PURE__*/t.createElement(Rb, {
      className: kH("column is-10 is-offset-1", cC)
    }, e.headlineText)))), aC(e.marginBottom));
  };
sC.propTypes = iC, sC.defaultProps = rC;
var lC = ["theme", "secondaryColor"],
  fC = function (e) {
    e.theme;
    var n = e.secondaryColor,
      c = z(e, lC),
      r = JE(null, null, n).setCustomColors;
    return i(function () {
      r();
    }, [n]), /*#__PURE__*/t.createElement(sC, c);
  };
fC.propTypes = iC, fC.defaultProps = rC;
var uC = {
    GridContentBlock__item_headline: "GridContentBlock-module_GridContentBlock__item_headline__nHm0D",
    GridContentBlock__item_image: "GridContentBlock-module_GridContentBlock__item_image__m-J7D",
    isIcon: "GridContentBlock-module_isIcon__HObau",
    GridContentBlock__item_url: "GridContentBlock-module_GridContentBlock__item_url__Puq1A",
    addHover: "GridContentBlock-module_addHover__gcWia",
    swiperControl: "GridContentBlock-module_swiperControl__qYPfj",
    prev: "GridContentBlock-module_prev__U3asd",
    next: "GridContentBlock-module_next__e7hjJ",
    swiperNav: "GridContentBlock-module_swiperNav__c3ga1",
    swiperNav__dot: "GridContentBlock-module_swiperNav__dot__I5Idn",
    active: "GridContentBlock-module_active__FtN1T"
  },
  dC = {
    theme: p.oneOf(UE),
    marginTop: p.oneOf($E),
    marginBottom: p.oneOf($E),
    hasNarrowContainer: p.bool,
    secondaryColor: p.string,
    secondaryTextColor: p.string,
    headline: p.string,
    description: p.string,
    useImagesAsIcons: p.bool,
    columns: p.arrayOf(p.shape({
      image_url: p.string,
      image_alt_text: p.string,
      headline: p.string,
      description: p.string,
      grid_item_url: p.string
    })),
    numberOfColumns: p.oneOf(["1", "2", "3", "4"]),
    useCarouselOnMobile: p.bool,
    columnGap: p.oneOf(["s", "m", "l"]),
    imageAspectRatio: p.oneOf(["square", "widescreen", "fullscreen", "panorama", "poster"])
  },
  pC = {
    theme: "modern",
    marginTop: "xl",
    marginBottom: "xl",
    columns: [],
    numberOfColumns: "4",
    columnGap: "m",
    imageAspectRatio: "widescreen",
    useImageAsIcons: !1
  },
  mC = function (e) {
    var i = BH(),
      r = i.isMobile,
      o = i.isTouch,
      s = n(null),
      l = y(c(0), 2),
      f = l[0],
      u = l[1],
      d = a(function () {
        s.current && s.current.swiper.slidePrev();
      }, []),
      p = a(function () {
        s.current && s.current.swiper.slideNext();
      }, []),
      m = a(function (e) {
        s.current && s.current.swiper.slideTo(e);
      }, []),
      h = function (n) {
        return /*#__PURE__*/t.createElement(t.Fragment, null, n.image_url && /*#__PURE__*/t.createElement(t.Fragment, null, e.useImagesAsIcons ? /*#__PURE__*/t.createElement(Rb, {
          setPositionRelative: !0,
          className: kH(uC.GridContentBlock__item_image, uC.isIcon)
        }, n.grid_item_url && /*#__PURE__*/t.createElement(Rb, {
          renderAs: "a",
          target: "_blank",
          href: n.grid_item_url,
          className: uC.GridContentBlock__item_url
        }), /*#__PURE__*/t.createElement("img", {
          src: n.image_url,
          alt: n.image_alt_text
        })) : /*#__PURE__*/t.createElement(Jb, {
          aspectRatio: e.imageAspectRatio,
          className: uC.GridContentBlock__item_image,
          setPositionRelative: !0
        }, n.grid_item_url && /*#__PURE__*/t.createElement(Rb, {
          renderAs: "a",
          target: "_blank",
          href: n.grid_item_url,
          className: kH(uC.GridContentBlock__item_url, uC.addHover)
        }), /*#__PURE__*/t.createElement("img", {
          src: n.image_url,
          alt: n.image_alt_text
        })), /*#__PURE__*/t.createElement(Yb, {
          size: "m"
        })), n.headline && /*#__PURE__*/t.createElement(Rb, {
          setPositionRelative: !0,
          className: uC.GridContentBlock__item_headline
        }, /*#__PURE__*/t.createElement(TH, {
          size: "s",
          fontFamily: "figtree",
          color: "base"
        }, n.headline), /*#__PURE__*/t.createElement(Yb, null)), n.description && /*#__PURE__*/t.createElement(Rb, null, n.description));
      };
    return /*#__PURE__*/t.createElement(t.Fragment, null, aC(e.marginTop), /*#__PURE__*/t.createElement(WH, {
      headline: e.headline,
      description: e.description
    }), e.columns.length > 0 && /*#__PURE__*/t.createElement(t.Fragment, null, r && e.useCarouselOnMobile ? /*#__PURE__*/t.createElement(Bb, {
      variation: "fluid"
    }, /*#__PURE__*/t.createElement(Rb, {
      setPositionRelative: !0
    }, /*#__PURE__*/t.createElement(WE, {
      ref: s,
      slidesPerView: 1,
      spaceBetween: 24,
      loop: !0,
      onSlideChange: function (e) {
        u(e.realIndex);
      }
    }, e.columns.map(function (e, n) {
      return /*#__PURE__*/t.createElement(qE, {
        key: "grid-item-".concat(n)
      }, /*#__PURE__*/t.createElement(Ub, {
        flexDirection: "column"
      }, h(e), /*#__PURE__*/t.createElement(Yb, null)));
    })), /*#__PURE__*/t.createElement(Ub, {
      className: kH(uC.swiperControl, uC.prev),
      renderAs: "button",
      onClick: function () {
        return d();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronLeft"
    })), /*#__PURE__*/t.createElement(Ub, {
      className: kH(uC.swiperControl, uC.next),
      renderAs: "button",
      onClick: function () {
        return p();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronRight"
    })), /*#__PURE__*/t.createElement(Ub, {
      gap: "xs",
      alignItems: "center",
      className: uC.swiperNav
    }, e.columns.map(function (e, n) {
      return /*#__PURE__*/t.createElement(Rb, {
        key: "indicator-".concat(n),
        renderAs: "button",
        className: kH(uC.swiperNav__dot, b({}, uC.active, n === f)),
        onClick: function () {
          return m(n);
        }
      });
    })))) : /*#__PURE__*/t.createElement(Bb, {
      variation: o ? "fluid" : e.hasNarrowContainer ? "narrow" : "default",
      className: kH(uC.GridContentBlock__container, b({}, uC.hasIcons, e.useImagesAsIcons))
    }, e.useImagesAsIcons && /*#__PURE__*/t.createElement(Yb, {
      size: "m"
    }), /*#__PURE__*/t.createElement(Zb, {
      columns: e.numberOfColumns,
      gap: e.columnGap
    }, e.columns.map(function (e, n) {
      return /*#__PURE__*/t.createElement(Ub, {
        key: "grid-item-".concat(n),
        flexDirection: "column"
      }, h(e), /*#__PURE__*/t.createElement(Yb, null));
    })))), r && e.useCarouselOnMobile && /*#__PURE__*/t.createElement(Yb, {
      size: "xl"
    }), aC(e.marginBottom));
  };
mC.propTypes = dC, mC.defaultProps = pC;
var hC = ["theme", "primaryColor", "primaryTextColor", "secondaryColor", "secondaryTextColor"],
  vC = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = e.secondaryColor,
      a = e.secondaryTextColor,
      o = z(e, hC),
      s = JE(n, c, r, a).setCustomColors;
    return i(function () {
      s();
    }, [n, c, r, a]), /*#__PURE__*/t.createElement(mC, o);
  };
vC.propTypes = dC, vC.defaultProps = pC;
var gC = "MediaContentBlock-module_MediaContentBlock__wrapper__mGc3p",
  bC = "MediaContentBlock-module_MediaContentBlock__wrapper_inside__mq1Lb",
  HC = "MediaContentBlock-module_adjustOffsets__FKKKV",
  zC = "MediaContentBlock-module_MediaContentBlock__frame__ua7Z5",
  yC = "MediaContentBlock-module_MediaContentBlock__overlay__j2oDV",
  VC = "MediaContentBlock-module_MediaContentBlock__overlay_content__vGHke",
  xC = "MediaContentBlock-module_MediaContentBlock__image__zHNVV",
  MC = "MediaContentBlock-module_MediaContentBlock__content__PK5Y3",
  _C = "MediaContentBlock-module_left__XPxwa",
  wC = "MediaContentBlock-module_right__WWt4-",
  EC = "MediaContentBlock-module_bottom__WdH3z",
  CC = {
    theme: p.oneOf(UE),
    marginTop: p.oneOf($E),
    marginBottom: p.oneOf($E),
    hasNarrowContainer: p.bool,
    primaryColor: p.string,
    primaryTextColor: p.string,
    secondaryColor: p.string,
    secondaryTextColor: p.string,
    headline: p.string,
    description: p.string,
    image: p.object,
    callToActionLabel: p.string,
    callToActionUrl: p.string,
    layoutType: p.oneOf(["media_top_text_bottom", "media_left_text_right", "media_right_text_left", "text_overlay"])
  },
  LC = {
    theme: "modern",
    marginTop: "xl",
    marginBottom: "xl",
    layoutType: "media_top_text_bottom",
    callToActionLabel: "Learn More"
  },
  NC = function (e) {
    var n,
      c = BH().isMobile;
    return i(function () {}, []), /*#__PURE__*/t.createElement(t.Fragment, null, aC(e.marginTop), /*#__PURE__*/t.createElement(Bb, {
      variation: "text_overlay" === e.layoutType ? "full-width" : e.hasNarrowContainer ? "narrow" : "default"
    }, "text_overlay" === e.layoutType ? /*#__PURE__*/t.createElement(Rb, {
      paddingVertical: "xxl",
      setPositionRelative: !0,
      className: zC
    }, /*#__PURE__*/t.createElement(Yb, {
      size: "xl"
    }), e.image && e.image.url && /*#__PURE__*/t.createElement(t.Fragment, null, e.image.alt_text && /*#__PURE__*/t.createElement("span", {
      role: "img",
      "aria-label": null !== (n = e.image) && void 0 !== n && n.alt_text ? e.image.alt_text : ""
    }), /*#__PURE__*/t.createElement(Rb, {
      className: yC,
      style: {
        backgroundImage: "url(".concat(e.image.url, ")")
      }
    })), /*#__PURE__*/t.createElement(Rb, {
      className: VC
    }, /*#__PURE__*/t.createElement(WH, {
      headline: e.headline,
      description: e.description,
      isOverlay: !0,
      removeBottomSpacer: !0
    }), /*#__PURE__*/t.createElement(Bb, {
      variation: c ? "fluid" : e.hasNarrowContainer ? "narrow" : "default"
    }, /*#__PURE__*/t.createElement(Rb, {
      className: "columns is-centered"
    }, /*#__PURE__*/t.createElement(Rb, {
      className: "column is-6 has-text-centered"
    }, e.callToActionUrl && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
      size: "m"
    }), /*#__PURE__*/t.createElement(GH, {
      type: "link",
      href: e.callToActionUrl,
      isInline: !0
    }, e.callToActionLabel)))))), /*#__PURE__*/t.createElement(Yb, {
      size: "xl"
    })) : /*#__PURE__*/t.createElement(Rb, {
      className: kH("columns", gC, b({
        "is-centered": "media_top_text_bottom" === e.layoutType
      }, HC, "media_left_text_right" === e.layoutType || "media_right_text_left" === e.layoutType)),
      setPositionRelative: !0
    }, e.image && e.image.url && /*#__PURE__*/t.createElement(Rb, {
      className: kH("column is-10", bC, {
        "is-offset-2": "media_right_text_left" === e.layoutType
      })
    }, /*#__PURE__*/t.createElement(Jb, {
      setPositionRelative: !0,
      aspectRatio: "widescreen",
      className: xC
    }, /*#__PURE__*/t.createElement("img", {
      src: e.image.url,
      alt: e.image.alt_text
    }))), /*#__PURE__*/t.createElement(Rb, {
      padding: c ? "m" : "l",
      className: kH("column is-5-widescreen is-7-tablet", MC, b(b(b({}, _C, "media_right_text_left" === e.layoutType), wC, "media_left_text_right" === e.layoutType), EC, "media_top_text_bottom" === e.layoutType))
    }, e.headline && /*#__PURE__*/t.createElement(TH, {
      size: "m",
      color: "secondary-text"
    }, e.headline), e.description && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, null), /*#__PURE__*/t.createElement(Rb, null, e.description)), e.callToActionUrl && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
      size: "m"
    }), /*#__PURE__*/t.createElement(Yb, {
      size: "xs"
    }), /*#__PURE__*/t.createElement(GH, {
      type: "link",
      href: e.callToActionUrl,
      isInline: !0
    }, e.callToActionLabel))))), !c && "text_overlay" !== e.layoutType && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
      size: "l"
    }), /*#__PURE__*/t.createElement(Yb, {
      size: "m"
    })), aC(e.marginBottom));
  };
NC.propTypes = CC, NC.defaultProps = LC;
var SC = ["theme", "primaryColor", "primaryTextColor", "secondaryColor", "secondaryTextColor"],
  kC = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = e.secondaryColor,
      a = e.secondaryTextColor,
      o = z(e, SC),
      s = JE(n, c, r, a).setCustomColors;
    return i(function () {
      s();
    }, [n, c, r, a]), /*#__PURE__*/t.createElement(NC, o);
  };
kC.propTypes = CC, kC.defaultProps = LC;
var PC = {
    AmenitiesGrid__grid_item: "AmenitiesGrid-module_AmenitiesGrid__grid_item__1Wd1i",
    isSwiper: "AmenitiesGrid-module_isSwiper__0tHi4",
    addBg: "AmenitiesGrid-module_addBg__0mKww",
    AmenitiesGrid__grid_icon: "AmenitiesGrid-module_AmenitiesGrid__grid_icon__-kTLq",
    AmenitiesGrid__grid_itemLink: "AmenitiesGrid-module_AmenitiesGrid__grid_itemLink__gi5rX",
    whiteText: "AmenitiesGrid-module_whiteText__3ji5w",
    swiperControl: "AmenitiesGrid-module_swiperControl__IKJUE",
    prev: "AmenitiesGrid-module_prev__xvNCH",
    next: "AmenitiesGrid-module_next__TiS9t",
    swiperNav: "AmenitiesGrid-module_swiperNav__XgomL",
    swiperNav__dot: "AmenitiesGrid-module_swiperNav__dot__SAA41",
    active: "AmenitiesGrid-module_active__CkTe-"
  },
  TC = {
    theme: p.oneOf(UE),
    marginTop: p.oneOf($E),
    marginBottom: p.oneOf($E),
    hasNarrowContainer: p.bool,
    secondaryColor: p.string,
    secondaryTextColor: p.string,
    headline: p.string,
    description: p.string,
    amenities: p.arrayOf(p.shape({
      headline: p.string,
      description: p.string,
      icon_image: p.object,
      bg_image: p.object,
      grid_item_url: p.string
    })),
    useCarouselOnMobile: p.bool
  },
  OC = {
    theme: "modern",
    marginTop: "xl",
    marginBottom: "xl",
    amenities: []
  },
  AC = function (e) {
    return e.bg_image && e.bg_image.url;
  },
  DC = function (e) {
    var i = BH(),
      r = i.isTouch,
      o = i.isMobile,
      s = n(null),
      l = y(c(0), 2),
      f = l[0],
      u = l[1],
      d = a(function () {
        s.current && s.current.swiper.slidePrev();
      }, []),
      p = a(function () {
        s.current && s.current.swiper.slideNext();
      }, []),
      m = a(function (e) {
        s.current && s.current.swiper.slideTo(e);
      }, []),
      h = function (n) {
        var c, i;
        return /*#__PURE__*/t.createElement(Ub, {
          justifyContent: "center",
          alignItems: "center",
          className: kH(PC.AmenitiesGrid__grid_item, b(b({}, PC.addBg, AC(n)), PC.isSwiper, e.useCarouselOnMobile)),
          style: AC(n) ? {
            backgroundImage: "url(".concat(n.bg_image.url, ")")
          } : null
        }, n.grid_item_url && /*#__PURE__*/t.createElement(Rb, {
          renderAs: "a",
          href: n.grid_item_url,
          target: "_blank",
          className: PC.AmenitiesGrid__grid_itemLink,
          rel: "noopener noreferrer"
        }), AC(n) && /*#__PURE__*/t.createElement("span", {
          role: "img",
          "aria-label": null !== (c = n.bg_image) && void 0 !== c && c.alt_text ? n.bg_image.alt_text : ""
        }), /*#__PURE__*/t.createElement(Rb, {
          setPositionRelative: !0
        }, n.icon_image && n.icon_image.url && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Rb, {
          className: PC.AmenitiesGrid__grid_icon
        }, /*#__PURE__*/t.createElement("img", {
          src: n.icon_image.url,
          alt: null !== (i = n.icon_image) && void 0 !== i && i.alt_text ? n.icon_image.alt_text : ""
        })), /*#__PURE__*/t.createElement(Yb, {
          size: "m"
        })), n.headline && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(TH, {
          size: "s",
          fontFamily: "figtree",
          textAlign: "center",
          color: AC(n) ? "white" : "black"
        }, n.headline), /*#__PURE__*/t.createElement(Yb, {
          size: "xs"
        })), n.description && /*#__PURE__*/t.createElement(Rb, {
          className: AC(n) ? PC.whiteText : null
        }, n.description)));
      };
    return /*#__PURE__*/t.createElement(t.Fragment, null, aC(e.marginTop), /*#__PURE__*/t.createElement(WH, {
      headline: e.headline,
      description: e.description
    }), e.amenities.length > 0 && /*#__PURE__*/t.createElement(t.Fragment, null, o && e.useCarouselOnMobile ? /*#__PURE__*/t.createElement(Bb, {
      variation: "fluid"
    }, /*#__PURE__*/t.createElement(Rb, {
      setPositionRelative: !0
    }, /*#__PURE__*/t.createElement(WE, {
      ref: s,
      slidesPerView: 1,
      spaceBetween: 24,
      loop: !0,
      onSlideChange: function (e) {
        u(e.realIndex);
      }
    }, e.amenities.map(function (e, n) {
      return /*#__PURE__*/t.createElement(qE, {
        key: "grid-item-".concat(n)
      }, h(e));
    })), /*#__PURE__*/t.createElement(Ub, {
      className: kH(PC.swiperControl, PC.prev),
      renderAs: "button",
      onClick: function () {
        return d();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronLeft"
    })), /*#__PURE__*/t.createElement(Ub, {
      className: kH(PC.swiperControl, PC.next),
      renderAs: "button",
      onClick: function () {
        return p();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronRight"
    })), /*#__PURE__*/t.createElement(Ub, {
      gap: "xs",
      alignItems: "center",
      className: PC.swiperNav
    }, e.amenities.map(function (e, n) {
      return /*#__PURE__*/t.createElement(Rb, {
        key: "indicator-".concat(n),
        renderAs: "button",
        className: kH(PC.swiperNav__dot, b({}, PC.active, n === f)),
        onClick: function () {
          return m(n);
        }
      });
    })))) : /*#__PURE__*/t.createElement(Bb, {
      variation: r ? "fluid" : e.hasNarrowContainer ? "narrow" : "default"
    }, /*#__PURE__*/t.createElement(Ub, {
      flexWrap: "wrap",
      className: PC.AmenitiesGrid__grid,
      justifyContent: "center"
    }, e.amenities.map(function (e) {
      return h(e);
    })))), aC(e.marginBottom));
  };
DC.propTypes = TC, DC.defaultProps = OC;
var IC = ["theme", "primaryColor", "primaryTextColor", "secondaryColor", "secondaryTextColor"],
  jC = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = e.secondaryColor,
      a = e.secondaryTextColor,
      o = z(e, IC),
      s = JE(n, c, r, a).setCustomColors;
    return i(function () {
      s();
    }, [n, c, r, a]), /*#__PURE__*/t.createElement(DC, o);
  };
jC.propTypes = TC, jC.defaultProps = OC;
var FC = {
    FeaturedListings__extendColumn: "FeaturedListings-module_FeaturedListings__extendColumn__-e5k7",
    FeaturedListings__slide: "FeaturedListings-module_FeaturedListings__slide__sq9h4",
    FeaturedListings__listing: "FeaturedListings-module_FeaturedListings__listing__kbPgd",
    FeaturedListings__listing_image: "FeaturedListings-module_FeaturedListings__listing_image__AejVH",
    FeaturedListings__listing_nameWrapper: "FeaturedListings-module_FeaturedListings__listing_nameWrapper__CqrGR",
    FeaturedListings__listing_name: "FeaturedListings-module_FeaturedListings__listing_name__k4M0w",
    FeaturedListings__listing_amenities: "FeaturedListings-module_FeaturedListings__listing_amenities__FXXep",
    FeaturedListings__listing_amenityIcon: "FeaturedListings-module_FeaturedListings__listing_amenityIcon__a1xm9",
    FeaturedListings__listing_amenityText: "FeaturedListings-module_FeaturedListings__listing_amenityText__Bc60S",
    FeaturedListings__listing_link: "FeaturedListings-module_FeaturedListings__listing_link__UUwLl",
    FeaturedListings__controls_wrapper: "FeaturedListings-module_FeaturedListings__controls_wrapper__P6ew8",
    FeaturedListings__controls_control: "FeaturedListings-module_FeaturedListings__controls_control__OizM6",
    swiperNav__dot: "FeaturedListings-module_swiperNav__dot__KmNDl",
    active: "FeaturedListings-module_active__KpLZ8"
  },
  RC = {
    theme: p.oneOf(UE),
    marginTop: p.oneOf($E),
    marginBottom: p.oneOf($E),
    hasNarrowContainer: p.bool,
    secondaryColor: p.string,
    secondaryTextColor: p.string,
    headline: p.string,
    description: p.string,
    listings: p.arrayOf(p.shape({
      id: p.number,
      featured_image: p.object,
      guests: p.number,
      beds: p.number,
      baths: p.number,
      slug: p.string,
      is_room_type: p.bool,
      listing_url: p.string,
      multi_unit: p.bool,
      property_type: p.string,
      location: p.object,
      review_count: p.number,
      unit_count: p.number
    }))
  },
  BC = {
    theme: "modern",
    marginTop: "xl",
    marginBottom: "xl",
    listings: []
  },
  GC = function (e) {
    var i = BH(),
      r = i.isTouch,
      o = i.isMobile,
      s = n(null),
      l = y(c(0), 2),
      f = l[0],
      u = l[1],
      d = a(function () {
        s.current && s.current.swiper.slidePrev();
      }, []),
      p = a(function () {
        s.current && s.current.swiper.slideNext();
      }, []),
      m = a(function (e) {
        s.current && s.current.swiper.slideTo(e);
      }, []);
    return /*#__PURE__*/t.createElement(t.Fragment, null, aC(e.marginTop), /*#__PURE__*/t.createElement(WH, {
      headline: e.headline,
      description: e.description
    }), /*#__PURE__*/t.createElement(Bb, {
      variation: r ? "fluid" : e.hasNarrowContainer ? "narrow" : "default"
    }, /*#__PURE__*/t.createElement(Rb, {
      setPositionRelative: !0,
      paddingLeft: o ? null : "xl"
    }, /*#__PURE__*/t.createElement(Rb, {
      className: kH(FC.FeaturedListings__extendColumn)
    }, /*#__PURE__*/t.createElement(WE, {
      ref: s,
      slidesPerView: o ? 1 : "auto",
      spaceBetween: 24,
      onSlideChange: function (e) {
        u(e.realIndex);
      }
    }, e.listings.map(function (e, n) {
      return /*#__PURE__*/t.createElement(qE, {
        key: "listing-".concat(n),
        className: FC.FeaturedListings__slide
      }, /*#__PURE__*/t.createElement(Jb, {
        aspectRatio: "square",
        setPositionRelative: !0,
        className: FC.FeaturedListings__listing
      }, e.listing_url && /*#__PURE__*/t.createElement(Rb, {
        renderAs: "a",
        href: e.listing_url,
        className: FC.FeaturedListings__listing_link
      }), /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_image
      }, /*#__PURE__*/t.createElement("img", {
        src: null == e ? void 0 : e.featured_image.url,
        alt: e.name
      })), /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_nameWrapper
      }, /*#__PURE__*/t.createElement(TH, {
        color: "secondary-text",
        size: "s",
        className: FC.FeaturedListings__listing_name
      }, e.name)), /*#__PURE__*/t.createElement(Ub, {
        className: FC.FeaturedListings__listing_amenities,
        alignItems: "center",
        gap: "s"
      }, e.units && /*#__PURE__*/t.createElement(Ub, {
        gap: "xs",
        alignItems: "center"
      }, /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityIcon
      }, /*#__PURE__*/t.createElement(Sb, {
        name: "house"
      })), /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityText
      }, "".concat(e.units, " Units"))), e.guests && /*#__PURE__*/t.createElement(Ub, {
        gap: "xs",
        alignItems: "center"
      }, /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityIcon
      }, /*#__PURE__*/t.createElement(Sb, {
        name: "users"
      })), /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityText
      }, "".concat(e.guests, " Guests"))), e.beds && /*#__PURE__*/t.createElement(Ub, {
        gap: "xs",
        alignItems: "center"
      }, /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityIcon
      }, /*#__PURE__*/t.createElement(Sb, {
        name: "bed"
      })), /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityText
      }, "".concat(e.beds, " Beds"))), e.baths && /*#__PURE__*/t.createElement(Ub, {
        gap: "xs",
        alignItems: "center"
      }, /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityIcon
      }, /*#__PURE__*/t.createElement(Sb, {
        name: "bath"
      })), /*#__PURE__*/t.createElement(Rb, {
        className: FC.FeaturedListings__listing_amenityText
      }, "".concat(e.baths, " Baths"))))));
    }))), /*#__PURE__*/t.createElement(Rb, {
      className: FC.FeaturedListings__controls_wrapper
    }, /*#__PURE__*/t.createElement(Ub, {
      className: kH(FC.FeaturedListings__controls_control),
      renderAs: "button",
      onClick: function () {
        return d();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronLeft"
    })), o && /*#__PURE__*/t.createElement(Ub, {
      gap: "xs",
      alignItems: "center",
      className: FC.swiperNav
    }, e.listings.map(function (e, n) {
      return /*#__PURE__*/t.createElement(Rb, {
        key: "indicator-".concat(n),
        renderAs: "button",
        className: kH(FC.swiperNav__dot, b({}, FC.active, n === f)),
        onClick: function () {
          return m(n);
        }
      });
    })), /*#__PURE__*/t.createElement(Ub, {
      className: kH(FC.FeaturedListings__controls_control),
      renderAs: "button",
      onClick: function () {
        return p();
      },
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "chevronRight"
    }))))), aC(e.marginBottom));
  };
GC.propTypes = RC, GC.defaultProps = BC;
var YC = ["theme", "primaryColor", "primaryTextColor", "secondaryColor", "secondaryTextColor"],
  WC = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = e.secondaryColor,
      a = e.secondaryTextColor,
      o = z(e, YC),
      s = JE(n, c, r, a).setCustomColors;
    return i(function () {
      s();
    }, [n, c, r, a]), /*#__PURE__*/t.createElement(GC, o);
  };
WC.propTypes = RC, WC.defaultProps = BC;
var qC = "Navigation-module_Navigation__rtNyH",
  UC = "Navigation-module_Navigation__closeButton__BJOnJ",
  $C = "Navigation-module_Navigation__panelLinkList__5-WdZ",
  XC = {
    theme: p.oneOf(UE),
    primaryColor: p.string,
    primaryTextColor: p.string,
    siteName: p.string,
    logo: p.object,
    logoMobile: p.object,
    logoWhite: p.object,
    logoWhiteMobile: p.object,
    links: p.arrayOf(p.shape({
      title: p.string,
      position: p.number,
      visible: p.bool,
      slug: p.string,
      subLinks: p.arrayOf(p.shape({
        title: p.string,
        position: p.number,
        visible: p.bool,
        slug: p.string
      }))
    })),
    searchUrl: p.string
  },
  ZC = {
    theme: "modern",
    siteName: "My Website Name",
    links: [],
    searchUrl: "/listings/search"
  },
  KC = function (e) {
    var n = BH(),
      i = n.isMobile,
      r = n.isLargeDesktop,
      a = y(c(!1), 2),
      o = a[0],
      s = a[1],
      l = y(c(null), 2),
      f = l[0],
      u = l[1],
      d = function (e) {
        var t = !0;
        return e.slug.startsWith("http") && (t = !1), e.slug.startsWith("https") && (t = !1), t;
      },
      p = function (e) {
        return e.subLinks && e.subLinks.length > 0;
      },
      h = function (e) {
        return f === "sublink-group-".concat(e);
      };
    return /*#__PURE__*/t.createElement(Ub, {
      justifyContent: "space-between",
      alignItems: "center",
      className: qC,
      paddingHorizontal: i ? "s" : "m",
      gap: i ? "s" : null
    }, /*#__PURE__*/t.createElement(Rb, {
      style: {
        minWidth: 0
      }
    }, /*#__PURE__*/t.createElement(m, {
      to: "/"
    }, oC(e, !1, i))), /*#__PURE__*/t.createElement(Ub, {
      alignItems: "center",
      gap: r ? "s" : null
    }, r && e.links.map(function (e, n) {
      return /*#__PURE__*/t.createElement(rz, {
        key: "nav-link=".concat(n),
        label: e.title,
        subLinks: e.subLinks,
        hasSubLinks: p(e),
        renderRouterLink: d(e),
        slug: e.slug
      });
    }), /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement(GH, {
      type: "router-link",
      href: e.searchUrl,
      icon: /*#__PURE__*/t.createElement(Sb, {
        name: "search"
      }),
      isMobileNav: !0
    }, "Search")), !r && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement(GH, {
      type: "button",
      onClick: function () {
        return s(!0);
      },
      icon: /*#__PURE__*/t.createElement(Sb, {
        name: "bars"
      }),
      isClear: !0,
      isMobileNav: !0,
      forceWhite: !0
    }, "Navigation")), /*#__PURE__*/t.createElement(oz, {
      reveal: o,
      onClose: function () {
        return s(!1);
      },
      title: "Menu"
    }, /*#__PURE__*/t.createElement(Ub, {
      flexDirection: "column"
    }, /*#__PURE__*/t.createElement(Ub, {
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement(m, {
      to: "/"
    }, oC(e, !0))), /*#__PURE__*/t.createElement(Ub, {
      justifyContent: "center",
      alignItems: "center",
      renderAs: "button",
      onClick: function () {
        return s(!1);
      },
      className: UC
    }, /*#__PURE__*/t.createElement(Sb, {
      name: "times"
    }))), /*#__PURE__*/t.createElement(Yb, null), /*#__PURE__*/t.createElement(Ub, {
      flex: "1",
      renderAs: "ul",
      flexDirection: "column",
      className: $C
    }, e.links.map(function (e, n) {
      return /*#__PURE__*/t.createElement(rz, {
        key: "nav-link-".concat(n),
        label: e.title,
        subLinks: e.subLinks,
        hasSubLinks: p(e),
        renderRouterLink: d(e),
        slug: e.slug,
        isMobilePanel: !0,
        showSubLinks: function () {
          return u(h(n) ? null : "sublink-group-".concat(n));
        },
        hasActiveSubLinkGroup: h(n)
      });
    })))))));
  };
KC.propTypes = XC, KC.defaultProps = ZC;
var QC = ["theme", "primaryColor", "primaryTextColor", "secondaryColor", "secondaryTextColor"],
  JC = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = e.secondaryColor,
      a = e.secondaryTextColor,
      o = z(e, QC),
      s = JE(n, c, r, a).setCustomColors;
    return i(function () {
      s();
    }, [n, c, r, a]), /*#__PURE__*/t.createElement(KC, o);
  };
JC.propTypes = XC, JC.defaultProps = ZC;
var eL = "Footer-module_Footer__dTFI6",
  tL = "Footer-module_Footer__socialLinks__g7q9Z",
  nL = "Footer-module_Footer__sectionHeader__s1uWM",
  cL = "Footer-module_Footer__description__CvtvH",
  iL = "Footer-module_Footer__contactInfo__BNPFn",
  rL = "Footer-module_Footer__contactInfo_icon__UCSYS",
  aL = "Footer-module_FooterBottom__jXqIg",
  oL = {
    theme: p.oneOf(UE),
    primaryColor: p.string,
    primaryTextColor: p.string,
    secondaryColor: p.string,
    secondaryTextColor: p.string,
    siteName: p.string,
    logo: p.object,
    logoWhite: p.object,
    socialLinks: p.arrayOf(p.shape({
      url: p.string,
      destination: p.oneOf(["facebook", "twitter", "snapchat", "instagram", "pinterest"])
    })),
    contactInfo: p.shape({
      emailAddress: p.string,
      phone: p.string
    }),
    sendMessage: p.shape({
      headline: p.string,
      description: p.string,
      ctaLabel: p.string,
      onSendMessage: p.func
    }),
    bookNow: p.shape({
      headline: p.string,
      description: p.string,
      ctaLabel: p.string
    }),
    copyrightText: p.string,
    siteMapLink: p.string
  },
  sL = {
    theme: "modern",
    siteName: "My Website Name",
    socialLinks: []
  },
  lL = function (e) {
    var n = BH(),
      c = n.isMobile,
      i = n.isTouch,
      r = function (e) {
        return /*#__PURE__*/t.createElement(Rb, {
          className: "column"
        }, (null == e ? void 0 : e.headline) && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Rb, {
          className: nL,
          setPositionRelative: !0
        }, /*#__PURE__*/t.createElement(TH, {
          size: "s",
          fontFamily: "figtree",
          color: "white"
        }, e.headline)), /*#__PURE__*/t.createElement(Yb, {
          size: "m"
        })), (null == e ? void 0 : e.description) && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Rb, {
          className: cL
        }, e.description), /*#__PURE__*/t.createElement(Yb, {
          size: "m"
        })), ((null == e ? void 0 : e.headline) || (null == e ? void 0 : e.description)) && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
          size: "xs"
        }), /*#__PURE__*/t.createElement(GH, {
          type: e.onSendMessage ? "button" : "router-link",
          href: e.onSendMessage ? null : "/listings/search",
          onClick: e.onSendMessage,
          isInline: !0
        }, function (e) {
          return null != e && e.ctaLabel ? e.ctaLabel : e.onSendMessage ? "Send Message" : "Book Now";
        }(e))));
      },
      a = function (e, n) {
        return /*#__PURE__*/t.createElement(Ub, {
          renderAs: "li"
        }, /*#__PURE__*/t.createElement(Rb, {
          className: rL
        }, /*#__PURE__*/t.createElement(Sb, {
          name: e,
          iconStyle: "regular"
        })), /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement(Yb, {
          size: "xxs"
        }), /*#__PURE__*/t.createElement("a", {
          href: "envelope" === e ? "mailto:".concat(n) : "tel:+".concat(n),
          rel: "noreferrer nofollow"
        }, "envelope" === e ? "Email Us" : "Call Us")));
      };
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("footer", {
      className: eL
    }, aC("l"), /*#__PURE__*/t.createElement(Bb, {
      variation: i ? "fluid" : "default"
    }, /*#__PURE__*/t.createElement(Ub, {
      flexDirection: c ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: c ? "s" : null
    }, oC(e), e.socialLinks.length > 0 && /*#__PURE__*/t.createElement(Ub, {
      alignItems: "center",
      gap: "m",
      renderAs: "ul",
      className: tL
    }, e.socialLinks.map(function (e, n) {
      return /*#__PURE__*/t.createElement(Rb, {
        renderAs: "li",
        key: "social-link-".concat(n)
      }, /*#__PURE__*/t.createElement(Rb, {
        renderAs: "a",
        href: e.url,
        target: "_blank",
        nofollow: !0,
        noreferrer: !0
      }, /*#__PURE__*/t.createElement(Sb, {
        name: e.destination
      })));
    })))), /*#__PURE__*/t.createElement(Bb, {
      variation: "default"
    }, (e.bookNow || e.sendMessage || e.contactInfo) && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Yb, {
      size: "l"
    }), /*#__PURE__*/t.createElement(Rb, {
      className: "columns"
    }, e.bookNow && r(e.bookNow), e.sendMessage && r(e.sendMessage), e.contactInfo && /*#__PURE__*/t.createElement(Rb, {
      className: "column"
    }, /*#__PURE__*/t.createElement(Rb, {
      className: nL,
      setPositionRelative: !0
    }, /*#__PURE__*/t.createElement(TH, {
      size: "s",
      fontFamily: "figtree",
      color: "white"
    }, "Contact Info")), /*#__PURE__*/t.createElement(Yb, {
      size: "m"
    }), /*#__PURE__*/t.createElement(Yb, {
      size: "xs"
    }), /*#__PURE__*/t.createElement(Rb, {
      renderAs: "ul",
      className: iL
    }, e.contactInfo.emailAddress && a("envelope", e.contactInfo.emailAddress), e.contactInfo.phone && a("phone", e.contactInfo.phone)))))), aC("l")), /*#__PURE__*/t.createElement("footer", {
      className: aL
    }, /*#__PURE__*/t.createElement(Rb, {
      paddingVertical: "l"
    }, /*#__PURE__*/t.createElement(Bb, {
      variation: "fluid"
    }, /*#__PURE__*/t.createElement(Ub, {
      justifyContent: "space-between",
      alignItems: "center",
      flexDirection: c ? "column" : "row",
      gap: c ? "s" : null
    }, /*#__PURE__*/t.createElement(Rb, null, e.copyrightText ? e.copyrightText : "@2024 ".concat(e.siteName)), /*#__PURE__*/t.createElement(Ub, {
      gap: "m",
      alignItems: "center"
    }, e.siteMapLink && /*#__PURE__*/t.createElement(Rb, null, /*#__PURE__*/t.createElement("a", {
      href: e.siteMapLink,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Sitemap")), /*#__PURE__*/t.createElement(Rb, null, "Powered by", " ", /*#__PURE__*/t.createElement("a", {
      href: "https://www.directsoftware.com",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Direct"))))))));
  };
lL.propTypes = oL, lL.defaultProps = sL;
var fL = ["theme", "primaryColor", "primaryTextColor", "secondaryColor", "secondaryTextColor"],
  uL = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = e.secondaryColor,
      a = e.secondaryTextColor,
      o = z(e, fL),
      s = JE(n, c, r, a).setCustomColors;
    return i(function () {
      s();
    }, [n, c, r, a]), /*#__PURE__*/t.createElement(lL, o);
  };
uL.propTypes = oL, uL.defaultProps = sL;
var dL = "LongText-module_LongText__EnGYY",
  pL = {
    theme: p.oneOf(UE),
    marginTop: p.oneOf($E),
    marginBottom: p.oneOf($E),
    hasNarrowContainer: p.bool,
    primaryColor: p.string,
    secondaryColor: p.string,
    html: p.string
  },
  mL = {
    theme: "modern",
    marginTop: "xl",
    marginBottom: "xl"
  },
  hL = function (e) {
    var n = BH().isTouch;
    return i(function () {}, []), /*#__PURE__*/t.createElement(t.Fragment, null, aC(e.marginTop), /*#__PURE__*/t.createElement(Bb, {
      variation: n ? "fluid" : e.hasNarrowContainer ? "narrow" : "default"
    }, /*#__PURE__*/t.createElement("div", {
      className: dL,
      dangerouslySetInnerHTML: {
        __html: e.html
      }
    })), aC(e.marginBottom));
  };
hL.propTypes = pL, hL.defaultProps = mL;
var vL = ["theme", "primaryColor", "primaryTextColor", "secondaryColor", "secondaryTextColor"],
  gL = function (e) {
    e.theme;
    var n = e.primaryColor,
      c = e.primaryTextColor,
      r = e.secondaryColor,
      a = e.secondaryTextColor,
      o = z(e, vL),
      s = JE(n, c, r, a).setCustomColors;
    return i(function () {
      s();
    }, [n, c, r, a]), /*#__PURE__*/t.createElement(hL, o);
  };
gL.propTypes = pL, gL.defaultProps = mL;
export { jC as AmenitiesGrid, fC as DecorativeHeadline, WC as FeaturedListings, uL as Footer, vC as GridContentBlock, tC as Hero, gL as LongText, kC as MediaContentBlock, JC as Navigation };